import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review.projects.item');
import { workspaceDateTime } from "src/libs/portal/review/workspace-ui";
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";
import * as cytoscapeModule from 'cytoscape';
import * as hypuaUnicoderModule from 'hypua-unicoder';

const cytoscapeFactory = (cytoscapeModule as unknown as { default?: typeof cytoscapeModule }).default || cytoscapeModule;
const hypuaToUnicode = (hypuaUnicoderModule as unknown as { default: (text: string) => string }).default;
const HANYANG_PUA_RE = /[\ue0bc-\uf8f7]/;
const OLD_HANGUL_RE = /[\u1100-\u11ff\ua960-\ua97f\ud7b0-\ud7ff\ue0bc-\uf8f7]/;
const HISTORICAL_HANGUL_MODERN: Readonly<Record<string, string>> = {
    '\uf537': '하', '\ue285': '는', '\ue470': '를', '\uf53a': '한', '\uee95': '옵',
    '\uf53c': '할', '\ue669': '백', '\ue97d': '사', '\ue3a8': '대', '\ue668': '배',
    '\uf545': '함', '\ue98e': '삽', '\uf550': '해', '\ue38f': '달', '\ue299': '내',
    '\ue390': '닭', '\ueb68': '뿐', '\ue477': '람', '\ue650': '밝', '\ue57b': '매',
    '\ue288': '늘', '\ueaab': '또', '\uee8c': '알', '\ue999': '새', '\ue1d3': '갯',
    '\uf212': '재', '\ue1cd': '개', '\ue487': '래', '\ue560': '마', '\uee93': '암',
    '\uf325': '취', '\ue98b': '삼', '\ue283': '나', '\uf448': '태', '\ue64a': '바',
    '\uee88': '아', '\ue46c': '라', '\ue3e5': '따'
};

function normalizeHistoricalHangul(value: any): string {
    const text = String(value ?? '');
    if (!HANYANG_PUA_RE.test(text)) return text;
    return hypuaToUnicode(text).normalize('NFC');
}

function modernizeHistoricalProse(value: any): string {
    const text = String(value ?? '');
    if (!HANYANG_PUA_RE.test(text)) return text;
    const modernized = Array.from(text)
        .map((character) => HISTORICAL_HANGUL_MODERN[character] || character)
        .join('');
    return normalizeHistoricalHangul(modernized);
}

@Component({
    selector: 'wiz-page-review-projects-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review.projects.item/view.scss */
@charset "UTF-8";
.ops-page {
  --ops-ink: #25221f;
  --ops-muted: #77736c;
  --ops-line: #ddd9d1;
  --ops-line-soft: #ece9e3;
  --ops-soft: #f6f7f3;
  --ops-olive: #30491f;
  --ops-green: #52732e;
  --ops-orange: #b8521b;
  --ops-canvas: var(--ro-canvas, #fafbf8);
  min-height: 100%;
  color: var(--ops-ink);
  background: var(--ops-canvas);
}

.ops-page *,
.ops-page *::before,
.ops-page *::after,
.ops-modal-backdrop *,
.ops-modal-backdrop *::before,
.ops-modal-backdrop *::after {
  box-sizing: border-box;
}

.ops-page button,
.ops-page input,
.ops-page select,
.ops-page textarea,
.ops-modal-backdrop button,
.ops-modal-backdrop input,
.ops-modal-backdrop select,
.ops-modal-backdrop textarea {
  font: inherit;
}

.ops-shell {
  width: min(100%, 1500px);
  margin: 0 auto;
  padding-right: 32px;
  padding-left: 32px;
}

.ops-header {
  position: relative;
  z-index: 2;
  border-bottom: 1px solid #d8d5ce;
  background: #fff;
  box-shadow: 0 1px 0 rgba(42, 40, 35, 0.025);
}

.ops-header__inner {
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 26px;
}

.ops-heading {
  min-width: 0;
  animation: ops-fade-up 500ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #817d75;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.ops-eyebrow i,
.ops-result-meta > div i {
  width: 3px;
  height: 3px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #c5c0b8;
}

.ops-eyebrow strong {
  color: var(--ops-orange);
  font-weight: 900;
}

.ops-heading h1 {
  margin: 7px 0 0;
  color: #1f1d1a;
  font-size: 24px;
  font-weight: 900;
  line-height: 1.1;
  letter-spacing: -0.035em;
}

.ops-heading > p {
  margin: 7px 0 0;
  color: #706c65;
  font-size: 13px;
  line-height: 1.45;
}

.ops-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  animation: ops-fade-up 500ms 70ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-header-status {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 13px;
  border: 1px solid #d9d7d0;
  border-radius: 10px;
  background: #fafaf8;
  color: #5f6f50;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.ops-header-status i {
  position: relative;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #587b34;
}

.ops-header-status i::after {
  position: absolute;
  inset: -4px;
  border: 1px solid rgba(88, 123, 52, 0.26);
  border-radius: inherit;
  content: "";
  animation: ops-live 2.4s ease-out infinite;
}

.ops-primary-button {
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 17px;
  border: 0;
  border-radius: 10px;
  background: var(--ops-olive);
  color: #fff;
  box-shadow: 0 8px 20px rgba(48, 73, 31, 0.17);
  cursor: pointer;
  font-size: 13px;
  font-weight: 850;
  transition: transform 180ms ease, background 180ms ease, box-shadow 180ms ease;
}

.ops-primary-button svg {
  width: 16px;
  height: 16px;
  transition: transform 260ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-primary-button:hover {
  background: #3d592a;
  box-shadow: 0 11px 24px rgba(48, 73, 31, 0.22);
  transform: translateY(-1px);
}

.ops-primary-button:hover svg {
  transform: rotate(90deg);
}

.ops-primary-button:active {
  transform: translateY(0) scale(0.98);
}

.ops-content {
  display: grid;
  gap: 22px;
  padding-top: 24px;
  padding-bottom: 32px;
}

.ops-summary,
.ops-panel {
  overflow: hidden;
  border: 1px solid #d9d6cf;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 13px 32px rgba(42, 40, 35, 0.06), 0 2px 5px rgba(42, 40, 35, 0.03);
}

.ops-summary {
  min-height: 82px;
  display: grid;
  grid-template-columns: 245px minmax(0, 1fr);
  background: linear-gradient(105deg, #fff 0%, #fbfbf8 100%);
  animation: ops-panel-in 540ms 100ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-summary__intro {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  border-right: 1px solid var(--ops-line-soft);
}

.ops-summary__icon {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 11px;
  background: #edf2e8;
  color: #47672d;
}

.ops-summary__icon svg {
  width: 20px;
  height: 20px;
}

.ops-summary__intro strong {
  display: block;
  color: #34312d;
  font-size: 13px;
  font-weight: 900;
}

.ops-summary__intro p {
  margin: 5px 0 0;
  color: #8b877f;
  font-size: 10px;
  white-space: nowrap;
}

.ops-summary__grid {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.ops-stat {
  --stat-color: #8a9ab0;
  position: relative;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 7px;
  padding: 0 20px;
  border-right: 1px solid var(--ops-line-soft);
  animation: ops-stat-in 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-stat:nth-child(1) {
  animation-delay: 170ms;
}

.ops-stat:nth-child(2) {
  animation-delay: 220ms;
}

.ops-stat:nth-child(3) {
  animation-delay: 270ms;
}

.ops-stat:nth-child(4) {
  animation-delay: 320ms;
}

.ops-stat:last-child {
  border-right: 0;
}

.ops-stat::before {
  position: absolute;
  top: 20px;
  right: 18px;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--stat-color);
  content: "";
}

.ops-stat > span {
  color: #77736c;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.ops-stat > div {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.ops-stat strong {
  color: #292622;
  font-size: 25px;
  font-weight: 900;
  line-height: 0.9;
  letter-spacing: -0.04em;
}

.ops-stat small {
  color: #aaa69f;
  font-size: 10px;
}

.ops-stat--neutral {
  --stat-color: #8a9ab0;
}

.ops-stat--green {
  --stat-color: #52732e;
}

.ops-stat--violet {
  --stat-color: #70578e;
}

.ops-stat--amber {
  --stat-color: #c77813;
}

.ops-panel {
  animation: ops-panel-in 540ms 170ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-toolbar {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ops-line-soft);
}

.ops-tabs {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px;
  border-radius: 10px;
  background: #eff1ed;
}

.ops-tab {
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #716e67;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
  transition: color 170ms ease, background 170ms ease, box-shadow 170ms ease, transform 170ms ease;
}

.ops-tab em {
  min-width: 19px;
  height: 19px;
  display: inline-grid;
  place-items: center;
  padding: 0 5px;
  border-radius: 999px;
  background: rgba(87, 83, 75, 0.08);
  color: #8a867f;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}

.ops-tab:hover {
  color: #34312d;
}

.ops-tab.is-active {
  background: #fff;
  color: #2f4024;
  box-shadow: 0 2px 8px rgba(45, 51, 40, 0.1), inset 0 0 0 1px rgba(62, 82, 45, 0.08);
  transform: translateY(-1px);
}

.ops-tab.is-active em {
  background: #e7eee0;
  color: #47632f;
}

.ops-filter-group {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-search,
.ops-select {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid #d6d3cc;
  border-radius: 9px;
  background: #fff;
  color: #858078;
  transition: border-color 170ms ease, box-shadow 170ms ease;
}

.ops-search {
  width: 265px;
  padding-left: 12px;
}

.ops-select {
  width: 145px;
  padding-left: 11px;
}

.ops-search:focus-within,
.ops-select:focus-within {
  border-color: #879d71;
  box-shadow: 0 0 0 3px rgba(83, 116, 47, 0.11);
}

.ops-search > svg,
.ops-select > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.ops-search input,
.ops-select select {
  width: 100%;
  height: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #403d38;
  font-size: 12px;
}

.ops-search input {
  padding: 0 34px 0 10px;
}

.ops-select select {
  padding: 0 9px;
}

.ops-search input::placeholder {
  color: #a39f97;
}

.ops-search > button {
  position: absolute;
  right: 7px;
  width: 23px;
  height: 23px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: #f0f1ed;
  color: #77736c;
  cursor: pointer;
  font-size: 14px;
}

.ops-check {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #625f59;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
}

.ops-check input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.ops-check > span {
  width: 34px;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 3px;
  border-radius: 999px;
  background: #d8d9d4;
  transition: background 180ms ease;
}

.ops-check > span i {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(25, 27, 23, 0.18);
  transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-check input:checked + span {
  background: #547535;
}

.ops-check input:checked + span i {
  transform: translateX(14px);
}

.ops-check strong {
  font-weight: 750;
}

.ops-result-meta {
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-bottom: 1px solid var(--ops-line-soft);
  background: #fcfcfa;
}

.ops-result-meta > div {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #7f7b74;
  font-size: 11px;
}

.ops-result-meta > div strong {
  color: var(--ops-orange);
  font-size: 14px;
  font-weight: 900;
}

.ops-reset-button {
  padding: 6px 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #6e6a63;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  transition: color 160ms ease, background 160ms ease;
}

.ops-reset-button:hover {
  background: #eef0ea;
  color: #40572f;
}

.ops-table-wrap {
  width: 100%;
  overflow: hidden;
}

.ops-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: left;
}

.ops-table thead {
  background: #f5f6f2;
}

.ops-table th {
  height: 40px;
  padding: 0 12px;
  border-bottom: 1px solid #ddd9d2;
  color: #6f6b64;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.025em;
  white-space: nowrap;
}

.ops-table th:first-child,
.ops-table td:first-child {
  padding-left: 18px;
}

.ops-table th:last-child,
.ops-table td:last-child {
  padding-right: 18px;
}

.ops-table th.is-number,
.ops-table td.is-number {
  text-align: right;
}

.ops-table td {
  height: 66px;
  padding: 0 12px;
  border-bottom: 1px solid #ece9e3;
  color: #4f4b45;
  font-size: 13px;
  vertical-align: middle;
}

.ops-table tbody:last-child tr:last-child td,
.ops-table tbody > tr:last-child td {
  border-bottom: 0;
}

.ops-row {
  animation: ops-row-in 450ms cubic-bezier(0.22, 1, 0.36, 1) both;
  transition: background 170ms ease, box-shadow 170ms ease;
}

.ops-row:hover {
  background: #fafbf8;
  box-shadow: inset 3px 0 0 #688649;
}

.ops-identity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}

.ops-identity > div {
  min-width: 0;
}

.ops-identity > div > strong {
  display: block;
  overflow: hidden;
  color: #302d29;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-identity > div > p {
  margin: 5px 0 0;
  overflow: hidden;
  color: #8f8b84;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-mark,
.ops-avatar {
  width: 38px;
  height: 38px;
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 900;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.ops-mark--survey {
  border: 1px solid #d7e4cd;
  background: #eef4e9;
  color: #527136;
}

.ops-mark--harness {
  border: 1px solid #ded7e7;
  background: #f2eff6;
  color: #67547e;
}

.ops-avatar {
  border-radius: 12px;
  background: linear-gradient(145deg, #3d552a, #2d411f);
  color: #fff;
  box-shadow: 0 5px 12px rgba(48, 73, 31, 0.16);
  font-size: 12px;
}

.ops-row:hover .ops-mark,
.ops-row:hover .ops-avatar {
  box-shadow: 0 6px 13px rgba(49, 57, 43, 0.11);
  transform: translateY(-1px);
}

.ops-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border: 1px solid var(--status-line);
  border-radius: 999px;
  background: var(--status-bg);
  color: var(--status-color);
  font-size: 11px;
  font-weight: 850;
  white-space: nowrap;
}

.ops-status i {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
}

.status-live {
  --status-bg: #eef5e8;
  --status-color: #4c6e2f;
  --status-line: #d2e1c5;
}

.status-draft {
  --status-bg: #f1f1ee;
  --status-color: #69655e;
  --status-line: #ddd9d2;
}

.status-experiment {
  --status-bg: #f3eef8;
  --status-color: #6c5189;
  --status-line: #ded1e9;
}

.ops-version {
  display: inline-flex;
  padding: 5px 8px;
  border: 1px solid #edd7c6;
  border-radius: 7px;
  background: #fff5ed;
  color: #a4501d;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 900;
}

.ops-number {
  color: #5f5b54;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.ops-number--strong {
  color: #383530;
  font-weight: 900;
}

.ops-owner {
  color: #58544e;
  font-size: 12px;
  font-weight: 800;
}

.ops-date {
  color: #7f7b74;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
}

.ops-row-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 8px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #625e58;
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
  white-space: nowrap;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.ops-row-action svg {
  width: 14px;
  height: 14px;
  transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-row-action.is-open svg {
  transform: rotate(180deg);
}

.ops-row-action:hover {
  background: #eef1e9;
  color: #40582f;
}

.ops-row-action--button {
  border: 1px solid #d7d4cd;
  background: #fff;
}

.ops-history-row td {
  height: auto;
  padding: 14px 18px 18px !important;
  background: #f7f8f4;
}

.ops-inline-history {
  overflow: hidden;
  border: 1px solid #dcd9d2;
  border-radius: 10px;
  background: #fff;
  animation: ops-history-in 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.survey-history-grid {
  display: grid;
  grid-template-columns: 90px 120px 110px minmax(220px, 1fr) 70px;
  align-items: center;
  gap: 10px;
}

.ops-inline-history__head {
  min-height: 35px;
  padding: 0 14px;
  border-bottom: 1px solid #e5e2dc;
  background: #f6f6f3;
  color: #817d76;
  font-size: 10px;
  font-weight: 850;
}

.ops-inline-history__item {
  min-height: 42px;
  padding: 0 14px;
  border-bottom: 1px solid #eeece7;
  color: #615d56;
  font-size: 12px;
  animation: ops-row-in 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-inline-history__item:last-child {
  border-bottom: 0;
}

.ops-inline-history__item strong {
  color: #5c5851;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.ops-inline-history__item strong.is-active {
  color: var(--ops-orange);
}

.ops-inline-history__item p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-inline-history__item .is-number {
  text-align: right;
}

.ops-progress {
  display: flex;
  align-items: center;
  gap: 9px;
}

.ops-progress > div,
.ops-progress-track {
  height: 7px;
  flex: 1;
  overflow: hidden;
  border-radius: 999px;
  background: #e9ebe6;
}

.ops-progress i,
.ops-progress-track i {
  display: block;
  width: 0;
  height: 100%;
  border-radius: inherit;
  background: #658747;
  transform-origin: left center;
  animation: ops-progress-in 760ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-progress i.is-warning,
.ops-progress-track i.is-warning {
  background: #bf781a;
}

.ops-progress i.is-complete,
.ops-progress-track i.is-complete {
  background: #4e7950;
}

.ops-progress strong {
  width: 43px;
  flex: 0 0 auto;
  color: #4f4b45;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 850;
  text-align: right;
}

.ops-delta {
  color: #477442;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 900;
}

.ops-delta.is-negative {
  color: #b24b38;
}

.ops-field {
  display: grid;
  gap: 4px;
}

.ops-field strong {
  color: #4b4741;
  font-size: 12px;
  font-weight: 900;
}

.ops-field span {
  color: #918d85;
  font-size: 11px;
}

.ops-rating {
  color: #4b6537;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 900;
}

.ops-due {
  color: #5f5b54;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 850;
}

.ops-due.is-warning {
  color: #b06410;
}

.ops-toggle {
  position: relative;
  width: 40px;
  height: 23px;
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border: 0;
  border-radius: 999px;
  background: #d4d6d0;
  cursor: pointer;
  transition: background 180ms ease, box-shadow 180ms ease;
}

.ops-toggle > span {
  width: 17px;
  height: 17px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(28, 31, 25, 0.22);
  transition: transform 230ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-toggle.is-active {
  background: #547536;
  box-shadow: 0 0 0 3px rgba(84, 117, 54, 0.1);
}

.ops-toggle.is-active > span {
  transform: translateX(17px);
}

.ops-mobile-list {
  display: none;
}

.ops-empty {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  text-align: center;
  animation: ops-fade-up 380ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-empty strong {
  font-size: 14px;
}

.ops-empty p {
  margin: 7px 0 0;
  color: #827e77;
  font-size: 12px;
}

.ops-empty button {
  margin-top: 14px;
  padding: 8px 12px;
  border: 1px solid #d6d3cc;
  border-radius: 8px;
  background: #fff;
  color: #425a31;
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
}

.ops-footer {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-top: 1px solid var(--ops-line);
  background: #fbfbf9;
  color: #807c75;
  font-size: 11px;
}

.ops-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(27, 28, 24, 0.52);
  backdrop-filter: blur(5px);
  animation: ops-backdrop-in 220ms ease-out both;
}

.ops-modal {
  width: min(100%, 530px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 17px;
  background: #fff;
  box-shadow: 0 30px 80px rgba(22, 24, 20, 0.28);
  animation: ops-modal-in 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-modal--wide {
  width: min(100%, 760px);
}

.ops-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px 19px;
  border-bottom: 1px solid var(--ops-line);
  background: linear-gradient(120deg, #fff 0%, #f7f9f4 100%);
}

.ops-modal__header p {
  margin: 0;
  color: var(--ops-orange);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.ops-modal__header h2 {
  margin: 6px 0 0;
  color: #282521;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: -0.03em;
}

.ops-modal__header span {
  display: block;
  margin-top: 6px;
  color: #7f7b74;
  font-size: 12px;
}

.ops-modal__header > button {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-radius: 9px;
  background: #eef1ea;
  color: #66625b;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  transition: background 160ms ease, color 160ms ease, transform 160ms ease;
}

.ops-modal__header > button:hover {
  background: #e3e8dc;
  color: #354828;
  transform: rotate(5deg);
}

.ops-modal__body {
  display: grid;
  gap: 17px;
  padding: 22px 24px;
}

.ops-modal__body--scroll {
  max-height: 62vh;
  overflow-y: auto;
}

.ops-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px;
}

.ops-form-field {
  min-width: 0;
  display: grid;
  gap: 8px;
}

.ops-form-field > span {
  color: #4e4a44;
  font-size: 12px;
  font-weight: 850;
}

.ops-form-field input,
.ops-form-field select,
.ops-form-field textarea {
  width: 100%;
  padding: 0 13px;
  border: 1px solid #d5d2cb;
  border-radius: 9px;
  outline: 0;
  background: #fff;
  color: #37342f;
  font-size: 13px;
  transition: border-color 170ms ease, box-shadow 170ms ease;
}

.ops-form-field input,
.ops-form-field select {
  height: 43px;
}

.ops-form-field textarea {
  min-height: 90px;
  padding-top: 11px;
  padding-bottom: 11px;
  resize: vertical;
}

.ops-form-field input:focus,
.ops-form-field select:focus,
.ops-form-field textarea:focus {
  border-color: #879d71;
  box-shadow: 0 0 0 3px rgba(83, 116, 47, 0.11);
}

.ops-form-field input::placeholder,
.ops-form-field textarea::placeholder {
  color: #aaa69e;
}

.ops-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 24px;
  border-top: 1px solid var(--ops-line);
  background: #f8f8f5;
}

.ops-modal__footer button {
  height: 40px;
  padding: 0 15px;
  border-radius: 9px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.ops-modal-cancel {
  border: 1px solid #d5d2cb;
  background: #fff;
  color: #625e58;
}

.ops-modal-submit {
  border: 1px solid var(--ops-olive);
  background: var(--ops-olive);
  color: #fff;
}

.ops-modal-submit:hover {
  background: #3d592a;
  box-shadow: 0 7px 15px rgba(48, 73, 31, 0.17);
  transform: translateY(-1px);
}

.ops-timeline {
  position: relative;
  display: grid;
  gap: 0;
  padding-left: 25px;
}

.ops-timeline::before {
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 5px;
  width: 1px;
  background: #d9d6cf;
  content: "";
}

.ops-timeline__item {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 18px;
  padding: 0 0 22px;
  animation: ops-row-in 400ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-timeline__item:last-child {
  padding-bottom: 0;
}

.ops-timeline__item > i {
  position: absolute;
  top: 5px;
  left: -24px;
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: #b9b6af;
  box-shadow: 0 0 0 4px #fff;
}

.ops-timeline__item > i.is-active {
  background: var(--ops-orange);
}

.ops-timeline__content > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-timeline__content > div strong {
  color: #3d3934;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  font-weight: 900;
}

.ops-timeline__content > div span {
  padding: 3px 7px;
  border-radius: 999px;
  background: #fff0e5;
  color: var(--ops-orange);
  font-size: 10px;
  font-weight: 850;
}

.ops-timeline__content h3 {
  margin: 7px 0 0;
  color: #45413b;
  font-size: 13px;
  font-weight: 800;
}

.ops-timeline__content p {
  margin: 6px 0 0;
  color: #8b877f;
  font-size: 11px;
}

.ops-timeline__metrics {
  display: flex;
  gap: 8px;
}

.ops-timeline__metrics > span {
  min-width: 74px;
  display: grid;
  gap: 4px;
  padding: 9px 11px;
  border-radius: 9px;
  background: #f4f6f1;
  text-align: center;
}

.ops-timeline__metrics small {
  color: #818079;
  font-size: 10px;
}

.ops-timeline__metrics strong {
  color: #456332;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
}

@media (max-width: 1279px) {
  .ops-table-wrap {
    display: none;
  }
  .ops-mobile-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    padding: 14px;
    background: #f7f7f4;
  }
  .ops-mobile-card {
    min-width: 0;
    padding: 15px;
    border: 1px solid #ddd9d2;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(42, 40, 35, 0.035);
    animation: ops-row-in 450ms cubic-bezier(0.22, 1, 0.36, 1) both;
    transition: border-color 170ms ease, box-shadow 170ms ease, transform 170ms ease;
  }
  .ops-mobile-card:hover {
    border-color: #b8c3ad;
    box-shadow: 0 8px 19px rgba(45, 57, 36, 0.08);
    transform: translateY(-1px);
  }
  .ops-mobile-card__top,
  .expert-mobile-head,
  .expert-mobile-field,
  .ops-mobile-progress > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .ops-mobile-card__top {
    align-items: flex-start;
  }
  .ops-mobile-card__title {
    margin-top: 13px;
  }
  .ops-mobile-card__title > strong {
    display: block;
    overflow: hidden;
    color: #302d29;
    font-size: 15px;
    font-weight: 900;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ops-mobile-card__title > p {
    margin: 5px 0 0;
    color: #8f8b84;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
  }
  .ops-mobile-metrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 14px;
    border-top: 1px solid #ebe8e2;
    border-left: 1px solid #ebe8e2;
  }
  .ops-mobile-metrics > div {
    min-width: 0;
    display: grid;
    gap: 5px;
    padding: 10px;
    border-right: 1px solid #ebe8e2;
    border-bottom: 1px solid #ebe8e2;
  }
  .ops-mobile-metrics span,
  .expert-mobile-field span,
  .ops-mobile-progress span {
    color: #858179;
    font-size: 11px;
  }
  .ops-mobile-metrics strong,
  .expert-mobile-field strong {
    overflow: hidden;
    color: #44403a;
    font-size: 12px;
    font-weight: 850;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ops-mobile-progress {
    display: grid;
    gap: 8px;
    margin-top: 14px;
  }
  .ops-mobile-progress strong {
    color: #4e4a44;
    font-size: 12px;
  }
  .ops-mobile-history-button {
    width: 100%;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 13px;
    padding: 0 11px;
    border: 1px solid #d8d5ce;
    border-radius: 8px;
    background: #fafaf8;
    color: #535e49;
    cursor: pointer;
    font-size: 11px;
    font-weight: 850;
  }
  .ops-mobile-history-button svg {
    width: 15px;
    height: 15px;
    transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
  }
  .ops-mobile-history-button svg.is-open {
    transform: rotate(180deg);
  }
  .ops-mobile-history {
    display: grid;
    gap: 0;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid #dfdcd5;
    border-radius: 9px;
    animation: ops-history-in 340ms cubic-bezier(0.22, 1, 0.36, 1) both;
  }
  .ops-mobile-history__item {
    padding: 10px 11px;
    border-bottom: 1px solid #ebe8e2;
  }
  .ops-mobile-history__item:last-child {
    border-bottom: 0;
  }
  .ops-mobile-history__item > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .ops-mobile-history__item strong {
    color: #55514b;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
  }
  .ops-mobile-history__item strong.is-active {
    color: var(--ops-orange);
  }
  .ops-mobile-history__item span,
  .ops-mobile-history__item p {
    color: #89857d;
    font-size: 10px;
  }
  .ops-mobile-history__item p {
    margin: 6px 0 0;
  }
  .expert-mobile-head .ops-identity {
    min-width: 0;
  }
  .expert-mobile-field {
    margin-top: 14px;
    padding: 10px 11px;
    border-radius: 8px;
    background: #f4f6f1;
  }
}
@media (max-width: 960px) {
  .ops-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
  .ops-tabs {
    overflow-x: auto;
    scrollbar-width: none;
  }
  .ops-tabs::-webkit-scrollbar {
    display: none;
  }
  .ops-search {
    width: 100%;
  }
  .ops-filter-group {
    width: 100%;
  }
  .ops-filter-group .ops-search {
    flex: 1;
  }
}
@media (max-width: 767px) {
  .ops-shell {
    padding-right: 16px;
    padding-left: 16px;
  }
  .ops-header__inner {
    height: auto;
    min-height: 132px;
    align-items: flex-end;
    padding-top: 18px;
    padding-bottom: 17px;
  }
  .ops-heading {
    flex: 1;
  }
  .ops-eyebrow {
    font-size: 9px;
  }
  .ops-heading h1 {
    font-size: 21px;
  }
  .ops-heading > p {
    max-width: 245px;
    font-size: 11px;
  }
  .ops-header-status {
    display: none;
  }
  .ops-primary-button {
    width: 41px;
    padding: 0;
  }
  .ops-primary-button > span {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .ops-content {
    gap: 14px;
    padding-top: 14px;
    padding-bottom: 18px;
  }
  .ops-summary,
  .ops-panel {
    border-radius: 13px;
  }
  .ops-summary {
    display: block;
  }
  .ops-summary__intro {
    min-height: 68px;
    padding: 0 14px;
    border-right: 0;
    border-bottom: 1px solid var(--ops-line-soft);
  }
  .ops-summary__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ops-stat {
    min-height: 68px;
    padding: 0 14px;
    border-bottom: 1px solid var(--ops-line-soft);
  }
  .ops-stat:nth-child(even) {
    border-right: 0;
  }
  .ops-stat:nth-child(3),
  .ops-stat:nth-child(4) {
    border-bottom: 0;
  }
  .ops-stat strong {
    font-size: 21px;
  }
  .ops-stat > span {
    font-size: 10px;
  }
  .ops-toolbar {
    padding: 12px;
  }
  .ops-tabs {
    width: 100%;
  }
  .ops-tab {
    flex: 1;
    min-width: 0;
    padding: 0 8px;
    font-size: 10px;
  }
  .ops-tabs--wide .ops-tab em {
    display: none;
  }
  .ops-toolbar--experts .ops-filter-group {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 128px;
  }
  .ops-select {
    width: 100%;
  }
  .ops-check {
    align-self: flex-start;
  }
  .ops-result-meta {
    min-height: 48px;
    padding: 6px 12px;
  }
  .ops-mobile-list {
    grid-template-columns: 1fr;
    padding: 10px;
  }
  .ops-mobile-card {
    padding: 14px;
  }
  .ops-footer {
    padding: 0 12px;
  }
  .ops-footer span:last-child {
    display: none;
  }
  .ops-modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .ops-modal,
  .ops-modal--wide {
    width: 100%;
    max-height: 92vh;
    overflow-y: auto;
    border-radius: 19px 19px 0 0;
    animation-name: ops-sheet-in;
  }
  .ops-modal__header,
  .ops-modal__body,
  .ops-modal__footer {
    padding-right: 18px;
    padding-left: 18px;
  }
  .ops-form-grid {
    grid-template-columns: 1fr;
  }
  .ops-timeline__item {
    grid-template-columns: 1fr;
  }
  .ops-timeline__metrics {
    justify-content: flex-start;
  }
}
@media (max-width: 420px) {
  .ops-header__inner {
    gap: 12px;
  }
  .ops-heading > p {
    max-width: 255px;
  }
  .ops-toolbar--experts .ops-filter-group {
    grid-template-columns: 1fr;
  }
}
@keyframes ops-fade-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-panel-in {
  from {
    opacity: 0;
    transform: translateY(12px);
    box-shadow: 0 2px 5px rgba(42, 40, 35, 0);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-stat-in {
  from {
    opacity: 0;
    transform: translateX(-8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes ops-row-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-progress-in {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes ops-history-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-live {
  0% {
    opacity: 0.9;
    transform: scale(0.7);
  }
  65%, 100% {
    opacity: 0;
    transform: scale(1.55);
  }
}
@keyframes ops-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes ops-modal-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes ops-sheet-in {
  from {
    opacity: 0;
    transform: translateY(35px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .ops-heading,
  .ops-header__actions,
  .ops-summary,
  .ops-panel,
  .ops-stat,
  .ops-row,
  .ops-mobile-card,
  .ops-empty,
  .ops-inline-history,
  .ops-inline-history__item,
  .ops-mobile-history,
  .ops-progress i,
  .ops-progress-track i,
  .ops-header-status i::after,
  .ops-modal-backdrop,
  .ops-modal,
  .ops-timeline__item {
    animation: none !important;
  }
  .ops-primary-button,
  .ops-primary-button svg,
  .ops-row,
  .ops-mobile-card,
  .ops-mark,
  .ops-avatar,
  .ops-toggle,
  .ops-toggle > span,
  .ops-row-action svg,
  .ops-mobile-history-button svg {
    transition: none !important;
  }
}
:host {
  display: block;
  height: 100%;
}

/* Project-scoped QA resources and continuous quality loop */
.project-resource-studio,
.project-quality-loop {
  border: 1px solid #dfe5dc;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(40, 48, 39, 0.06);
}

.project-resource-studio {
  margin-bottom: 18px;
  padding: 22px;
}

.project-resource-studio__header,
.project-quality-loop > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.project-resource-studio__header p,
.project-quality-loop > header p {
  margin: 0 0 5px;
  color: #7d8b6b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.project-resource-studio__header h2,
.project-quality-loop > header h2 {
  margin: 0;
  color: #222920;
  font-size: 18px;
  font-weight: 700;
}

.project-resource-studio__header div > span,
.project-quality-loop > header div > em {
  display: block;
  margin-top: 6px;
  color: #758071;
  font-size: 12px;
  font-style: normal;
  line-height: 1.55;
}

.project-resource-studio__header > em {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 320px;
  padding: 8px 11px;
  border-radius: 10px;
  background: #f3f6ef;
  color: #667454;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-resource-studio__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 18px;
}

.project-resource-card {
  display: flex;
  min-height: 230px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e3e8df;
  border-radius: 15px;
  background: #fbfcfa;
}

.project-resource-card > header {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 16px 17px 13px;
  border-bottom: 1px solid #e7ebe4;
}

.project-resource-card > header > div {
  flex: 1;
}

.project-resource-card > header small {
  color: #879181;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-card > header h3 {
  margin: 2px 0 0;
  color: #283025;
  font-size: 15px;
  font-weight: 700;
}

.project-resource-card > header > em {
  padding: 4px 8px;
  border-radius: 999px;
  background: #edf2e7;
  color: #677655;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-resource-card__icon {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border-radius: 11px;
  background: #eef1eb;
  color: #5f6e51;
}

.project-resource-card__icon.is-survey {
  background: #fff1eb;
  color: #c66d4b;
}

.project-resource-card__list {
  display: grid;
  gap: 7px;
  padding: 13px 16px;
}

.project-resource-card__list > button {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 11px;
  border: 1px solid #e7ebe4;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;
}

.project-resource-card__list > button:hover,
.project-resource-card__list > button:focus-visible {
  border-color: #bccbb5;
  background: #f8faf6;
  box-shadow: 0 0 0 3px rgba(118, 137, 94, 0.1);
  outline: 0;
}

.project-resource-card__list > button > span:first-child {
  min-width: 0;
}

.project-resource-card__list strong,
.project-resource-card__list small {
  display: block;
}

.project-resource-card__list strong {
  overflow: hidden;
  color: #30372d;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-resource-card__list small {
  margin-top: 3px;
  color: #8a9386;
  font-size: 12px;
}

.project-resource-card__list b {
  color: #667653;
  font-size: 12px;
}

.project-resource-card__list-action {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 8px;
}

.project-resource-card__list-action i {
  color: #a5afa0;
  font-size: 12px;
  transition: transform 0.16s ease, color 0.16s ease;
}

.project-resource-card__list > button:hover .project-resource-card__list-action i,
.project-resource-card__list > button:focus-visible .project-resource-card__list-action i {
  color: #667653;
  transform: translateX(2px);
}

.project-resource-card__empty {
  flex: 1;
  padding: 22px 18px;
  color: #7a8475;
  text-align: center;
}

.project-resource-card__empty strong {
  color: #4d5848;
  font-size: 12px;
}

.project-resource-card__empty p {
  max-width: 390px;
  margin: 7px auto 0;
  font-size: 12px;
  line-height: 1.55;
}

.project-resource-card > footer {
  display: flex;
  gap: 8px;
  margin-top: auto;
  padding: 12px 16px 15px;
  border-top: 1px solid #e7ebe4;
}

.project-resource-card > footer button,
.project-quality-loop > footer button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #d9dfd5;
  background: #fff;
  color: #4e5b48;
}

.project-resource-card > footer button {
  flex: 1;
}

.project-resource-card > footer button.is-ai,
.project-quality-loop > footer button.is-ai {
  border-color: #76895e;
  background: #76895e;
  color: #fff;
}

.project-quality-loop {
  margin-top: 18px;
  padding: 22px;
  border-left: 4px solid #839568;
}

.project-quality-loop.is-complete {
  border-left-color: #3b9873;
}

.project-quality-loop > header > span {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 12px;
  background: #edf3e7;
  color: #6e8058;
  font-size: 16px;
}

.project-quality-loop > header > div {
  flex: 1;
}

.project-quality-loop > header > b {
  padding: 8px 11px;
  border-radius: 10px;
  background: #fff2e9;
  color: #bb6744;
  font-size: 12px;
}

.project-quality-loop > header > b.is-complete {
  background: #e8f5ef;
  color: #277858;
}

.project-quality-loop > ol {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 9px;
  margin: 20px 0 0;
  padding: 0;
  list-style: none;
}

.project-quality-loop > ol li {
  display: flex;
  gap: 9px;
  padding: 12px;
  border: 1px solid #e5e9e1;
  border-radius: 11px;
  background: #fafbf9;
}

.project-quality-loop > ol li > span {
  display: grid;
  width: 23px;
  height: 23px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 50%;
  background: #e9ede6;
  color: #8a9484;
  font-size: 12px;
  font-weight: 700;
}

.project-quality-loop > ol li.is-done > span {
  background: #7b8d61;
  color: #fff;
}

.project-quality-loop > ol strong,
.project-quality-loop > ol small {
  display: block;
}

.project-quality-loop > ol strong {
  color: #3e483a;
  font-size: 12px;
  font-weight: 700;
}

.project-quality-loop > ol small {
  margin-top: 4px;
  color: #7f887b;
  font-size: 12px;
  line-height: 1.45;
}

.project-quality-loop__priorities {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 13px;
  padding: 11px 12px;
  border-radius: 10px;
  background: #f5f7f2;
}

.project-quality-loop__priorities > strong {
  width: 100%;
  color: #65715d;
  font-size: 12px;
}

.project-quality-loop__priorities > span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  padding: 6px 8px;
  border: 1px solid #dde4d7;
  border-radius: 8px;
  background: #fff;
  color: #586353;
  font-size: 12px;
}

.project-quality-loop__priorities b {
  color: #74855e;
}

.project-quality-loop__priorities em {
  color: #9b7768;
  font-style: normal;
}

.project-quality-loop > footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-top: 16px;
  padding-top: 15px;
  border-top: 1px solid #e6eae3;
}

.project-quality-loop > footer p {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #6d7768;
  font-size: 12px;
}

.project-quality-loop > footer > div {
  display: flex;
  gap: 8px;
}

.project-quality-loop > footer button {
  padding: 0 12px;
}

.project-quality-loop > footer button.is-primary {
  border-color: #303a2c;
  background: #303a2c;
  color: #fff;
}

@media (max-width: 900px) {
  .project-resource-studio__grid,
  .project-quality-loop > ol {
    grid-template-columns: 1fr;
  }
  .project-resource-studio__header,
  .project-quality-loop > header,
  .project-quality-loop > footer {
    align-items: stretch;
    flex-direction: column;
  }
  .project-quality-loop > footer > div {
    flex-direction: column;
  }
}
/* Selected split-control concept: QA / project summary / KG */
.project-settings-header-action {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  color: #4f565f;
  background-color: #ffffff;
  border: 0;
  border-radius: 4px !important;
  box-shadow: inset 0 0 0 1px #cfd4da;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.project-settings-header-action:hover,
.project-settings-header-action:focus-visible {
  color: #d94d1f;
  background-color: #fff8f4;
  box-shadow: inset 0 0 0 1px #d94d1f;
  outline: 0;
}

.project-output-settings:has(> .project-output-settings__grid--split) {
  min-height: calc(100vh - 168px);
  padding: 0;
}

.project-output-settings__grid--split {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 226px minmax(0, 1fr);
  gap: 0;
  min-height: calc(100vh - 168px);
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e2e5e9;
  border-radius: 0;
  box-shadow: 0 12px 34px rgba(24, 28, 35, 0.055);
}

.project-output-settings__grid--split .project-output-card {
  position: relative;
  display: flex;
  flex-direction: column;
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
  min-height: 100%;
  overflow: hidden;
  background: #ffffff;
  border: 0;
  border-radius: 0 !important;
  box-shadow: inset 0 3px 0 #d94d1f;
}

.project-output-settings__grid--split .project-output-card.is-kg {
  grid-column: 3;
  box-shadow: inset 0 3px 0 #1f6a62;
}

.project-output-settings__grid--split .project-output-card:hover,
.project-output-settings__grid--split .project-output-card:focus-visible {
  transform: none;
  border-color: transparent;
  box-shadow: inset 0 3px 0 #d94d1f, inset 0 0 0 2px rgba(217, 77, 31, 0.14);
}

.project-output-settings__grid--split .project-output-card.is-kg:hover,
.project-output-settings__grid--split .project-output-card.is-kg:focus-visible {
  box-shadow: inset 0 3px 0 #1f6a62, inset 0 0 0 2px rgba(31, 106, 98, 0.14);
}

.project-output-settings__grid--split .project-output-card__header {
  min-height: 110px;
  padding: 30px 24px 22px;
  background: #ffffff;
  border: 0;
  border-radius: 0 !important;
}

.project-output-settings__grid--split .project-output-card__identity {
  align-items: flex-start;
  gap: 16px;
}

.project-output-settings__grid--split .project-output-card__identity > div {
  min-width: 0;
  padding-top: 2px;
}

.project-output-settings__grid--split .project-output-card__code {
  width: 52px;
  height: 52px;
  flex: 0 0 52px;
  display: grid;
  place-items: center;
  color: #ffffff;
  background-color: #df5425;
  border: 0;
  border-radius: 5px;
  box-shadow: 0 8px 18px rgba(216, 75, 29, 0.18);
  font-size: 17px;
  font-weight: 700;
}

.project-output-settings__grid--split .project-output-card__code.is-kg {
  background-color: #21685f;
  box-shadow: 0 8px 18px rgba(31, 106, 98, 0.18);
}

.project-output-settings__grid--split .project-output-card__identity strong {
  display: block;
  color: #1f2329;
  font-size: 18px;
  line-height: 1.25;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.project-output-settings__grid--split .project-output-card__identity p {
  margin-top: 6px;
  color: #6f7680;
  font-size: 12px;
  line-height: 1.45;
}

.project-output-settings__grid--split .project-output-card__header-actions {
  gap: 8px;
  align-items: center;
}

.project-output-settings__grid--split .project-output-card__status,
.project-output-settings__grid--split .project-output-card__settings {
  min-height: 34px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
}

.project-output-settings__grid--split .project-output-card__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  padding: 0 24px 18px;
}

.project-output-settings__grid--split .project-output-card__section {
  padding: 22px 0 18px;
  border-top: 1px solid #e3e5e8;
}

.project-output-settings__grid--split .project-output-card__section--output {
  flex: 1;
}

.project-output-settings__grid--split .project-output-card__section-title {
  margin: 0 0 14px;
  color: #c7481f;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.015em;
}

.project-output-settings__grid--split .project-output-card.is-kg .project-output-card__section-title {
  color: #1c665e;
}

.project-output-settings__grid--split .project-output-card__checklist {
  display: grid;
  gap: 8px;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
}

.project-output-settings__grid--split .project-output-card__checklist li {
  display: grid;
  grid-template-columns: 28px minmax(92px, 0.7fr) minmax(0, 1.3fr);
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 4px 0;
  border: 0;
}

.project-output-settings__grid--split .project-output-card__item-icon {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  color: #262a30;
  background: transparent;
  border-radius: 0;
  font-size: 13px;
}

.project-output-settings__grid--split .project-output-card__item-label {
  color: #2d3238;
  font-size: 12px;
  font-weight: 700;
}

.project-output-settings__grid--split .project-output-card__item-value {
  min-width: 0;
  max-width: 100%;
  justify-self: end;
  padding: 9px 12px;
  overflow: hidden;
  color: #353a41;
  background: #f5f6f7;
  border: 0;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-output-settings__grid--split .project-output-card__actions {
  margin-top: auto;
  padding-top: 18px;
  border-top: 1px solid #e3e5e8;
}

.project-output-settings__grid--split .project-output-card__cta {
  width: 100%;
  min-height: 58px;
  justify-content: center;
  color: #ffffff;
  background: #282c31;
  border: 0;
  border-radius: 3px !important;
  box-shadow: none;
  font-size: 15px;
  font-weight: 700;
}

.project-output-settings__grid--split .project-output-card__cta:hover {
  background: #1f2227;
  transform: none;
}

.project-output-settings__grid--split .project-output-card__cta.is-kg {
  background-color: #236a61;
}

.project-output-settings__grid--split .project-output-card__cta.is-kg:hover {
  background-color: #19564f;
}

.project-output-settings__summary {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 36px 20px 24px;
  background-color: #fbfbfb;
  border-right: 1px solid #e2e5e9;
  border-left: 1px solid #e2e5e9;
  border-radius: 0 !important;
  box-shadow: inset 1px 0 0 #e2e5e9, inset -1px 0 0 #e2e5e9;
}

.project-output-settings__summary-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 34px;
  text-align: center;
}

.project-output-settings__summary-icon {
  display: grid;
  width: 58px;
  height: 58px;
  margin-bottom: 16px;
  place-items: center;
  color: #ffffff;
  background: #2a2e33;
  border-radius: 50%;
  box-shadow: 0 10px 24px rgba(24, 28, 35, 0.16);
  font-size: 25px;
}

.project-output-settings__summary-status strong {
  color: #22262b;
  font-size: 25px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.project-output-settings__summary-status b {
  margin-top: 8px;
  color: #22262b;
  font-size: 16px;
  font-weight: 700;
}

.project-output-settings__summary-status p {
  margin-top: 14px;
  color: #757c85;
  font-size: 12px;
  line-height: 1.6;
}

.project-output-settings__summary-details {
  padding-top: 28px;
  border-top: 1px solid #dfe2e6;
}

.project-output-settings__summary-details h3 {
  margin: 0 0 18px;
  color: #25292e;
  font-size: 12px;
  font-weight: 700;
}

.project-output-settings__summary-details dl {
  display: grid;
  gap: 16px;
  margin: 0;
}

.project-output-settings__summary-details dl > div {
  min-width: 0;
}

.project-output-settings__summary-details dt {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #777e87;
  font-size: 12px;
  font-weight: 700;
}

.project-output-settings__summary-details dt i {
  width: 14px;
  color: #30353b;
  text-align: center;
}

.project-output-settings__summary-details dd {
  margin: 5px 0 0 22px;
  overflow: hidden;
  color: #22272c;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-output-settings__grid--split.is-single {
  grid-template-columns: minmax(0, 1fr) 240px;
}

.project-output-settings__grid--split.is-single .project-output-card,
.project-output-settings__grid--split.is-single .project-output-card.is-kg {
  grid-column: 1;
}

.project-output-settings__grid--split.is-single .project-output-settings__summary {
  grid-column: 2;
  border-right: 0;
}

@media (max-width: 1180px) {
  .project-output-settings__grid--split {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .project-output-settings__grid--split .project-output-card,
  .project-output-settings__grid--split .project-output-card.is-kg {
    grid-column: auto;
    grid-row: 1;
  }
  .project-output-settings__summary {
    grid-column: 1/-1;
    grid-row: 2;
    display: grid;
    grid-template-columns: 200px minmax(0, 1fr);
    align-items: start;
    gap: 28px;
    padding: 24px;
    border-top: 1px solid #e2e5e9;
    border-right: 0;
    border-left: 0;
  }
  .project-output-settings__summary-status {
    padding: 0;
  }
  .project-output-settings__summary-details {
    padding: 0;
    border: 0;
  }
  .project-output-settings__summary-details dl {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .project-output-settings__grid--split,
  .project-output-settings__grid--split.is-single {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
  .project-output-settings__grid--split .project-output-card,
  .project-output-settings__grid--split .project-output-card.is-kg {
    min-height: 660px;
  }
  .project-output-settings__summary {
    order: -1;
    display: block;
    padding: 24px 20px;
    border: 0;
    border-bottom: 1px solid #e2e5e9;
  }
  .project-output-settings__summary-status {
    padding-bottom: 22px;
  }
  .project-output-settings__summary-details {
    padding-top: 22px;
  }
  .project-output-settings__summary-details dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .project-output-settings__grid--split .project-output-card__header {
    padding: 24px 18px 18px;
  }
  .project-output-settings__grid--split .project-output-card__body {
    padding: 0 18px 18px;
  }
  .project-output-settings__grid--split .project-output-card__checklist li {
    grid-template-columns: 26px minmax(80px, 0.65fr) minmax(0, 1.35fr);
  }
}
/* QA generation — selected high-density console concept */
.project-generation-page-title.is-qa {
  width: 100%;
  display: grid;
  grid-template-columns: auto auto auto auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  min-height: 34px;
  color: #68707d;
}

.project-generation-page-title.is-qa strong {
  color: #14181d;
  font-size: 17px;
  font-weight: 700;
}

.project-generation-page-title.is-qa span {
  min-height: 22px;
  padding: 0 9px;
  color: #4f5966;
  background: #f0f2f3;
  border: 0;
  border-radius: 3px;
  font-size: 12px;
}

.project-generation-page-title.is-qa b,
.project-generation-page-title.is-qa em,
.project-generation-page-title.is-qa code,
.project-generation-page-title.is-qa time {
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-generation-page-title.is-qa b,
.project-generation-page-title.is-qa code {
  color: #37404b;
}

main.is-generation-main .project-output-workspace__layout.is-qa {
  grid-template-areas: "materials generation";
  grid-template-columns: minmax(0, 1fr) 390px;
  grid-template-rows: minmax(0, 1fr);
  column-gap: 0;
  row-gap: 0;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials,
main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-card {
  min-height: calc(100vh - 118px);
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials {
  border-right: 1px solid #dde2e7;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-card {
  position: sticky;
  top: 0;
  align-self: start;
  background: #fff;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__section-header {
  min-height: 105px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #e1e5e9;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__section-header h3 {
  font-size: 16px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__section-header p {
  margin-top: 7px;
  color: #75808c;
  font-size: 12px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__section-header > strong {
  padding: 7px 10px;
  border-radius: 3px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__filters {
  grid-template-columns: minmax(240px, 1fr) auto;
  align-items: end;
  gap: 14px;
  padding: 15px 24px;
  border-bottom: 1px solid #e1e5e9;
}

.qa-generation-source-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-height: 38px;
}

.qa-generation-source-tools button {
  min-height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px;
  color: #505966;
  background: #fff;
  border: 1px solid #d6dce2;
}

.qa-generation-source-tools button.is-active {
  color: #176e6c;
  border-color: #6ca8a5;
}

.qa-generation-source-tools button.is-refresh {
  width: 35px;
  padding: 0;
  border: 0;
}

.qa-generation-source-tools > span {
  color: #69727e;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.qa-generation-filter-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-height: 38px;
  padding: 0 24px;
  color: #59636f;
  background: #f7f9f9;
  border-bottom: 1px solid #e1e5e9;
  font-size: 12px;
}

.qa-generation-filter-panel span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.qa-generation-filter-panel i {
  color: #0d7775;
}

.project-generation-source-table__head.is-qa,
main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
  grid-template-columns: 34px minmax(190px, 1.5fr) 100px 66px 112px 122px;
  gap: 10px;
  padding-right: 24px;
  padding-left: 24px;
}

.project-generation-source-table__head.is-qa {
  min-height: 39px;
  color: #616a77;
  background: #fafbfb;
}

main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
  min-height: 53px;
  padding-top: 8px;
  padding-bottom: 8px;
}

main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa .project-generation-source__main strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-generation-source__version,
.project-generation-source__period {
  color: #59636f;
}

main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa .project-generation-source__availability {
  padding: 0;
  color: #077270;
  background: transparent;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-generation-source-table__footer {
  min-height: 58px;
  padding: 0 24px;
  border-top: 0;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-header {
  min-height: 58px;
  padding: 0 22px;
  border-bottom: 1px solid #e1e5e9;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-header h2 {
  font-size: 14px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-body {
  padding: 0 22px 20px;
}

.project-output-workspace__selected-overview.is-qa {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 17px 0;
}

.project-output-workspace__selected-overview.is-qa > div {
  min-width: 0;
}

.project-output-workspace__selected-overview.is-qa > div + div {
  padding-left: 20px;
  border-left: 1px solid #dfe4e8;
}

.project-output-workspace__selected-overview.is-qa span {
  color: #47515d;
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__selected-overview.is-qa strong {
  margin-top: 8px;
}

.project-output-workspace__selected-overview.is-qa b {
  color: #176e6c;
  font-size: 28px;
}

.project-output-workspace__selected-overview.is-qa em {
  font-size: 12px;
}

.qa-generation-completion,
.qa-generation-checklist {
  padding: 17px 0;
  border-bottom: 1px solid #e1e5e9;
}

.qa-generation-completion > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.qa-generation-completion h3,
.qa-generation-checklist h3 {
  margin: 0;
  color: #272d34;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-completion strong {
  font-size: 12px;
}

.qa-generation-completion__track {
  height: 5px;
  display: block;
  margin-top: 12px;
  overflow: hidden;
  background: #e9edef;
  border-radius: 999px;
}

.qa-generation-completion__track i {
  height: 100%;
  display: block;
  background: #0d7775;
  transition: width 0.2s ease;
}

.qa-generation-checklist ul {
  display: grid;
  gap: 10px;
  margin: 13px 0 0;
  padding: 0;
  list-style: none;
}

.qa-generation-checklist li {
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  color: #737b85;
  font-size: 12px;
}

.qa-generation-checklist li i {
  color: #b8bec5;
}

.qa-generation-checklist li b {
  font-size: 12px;
}

.qa-generation-checklist li.is-complete i,
.qa-generation-checklist li.is-complete b {
  color: #0d7775;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__configuration-heading {
  padding-top: 17px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__configuration dl > div,
main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__configuration dl > div.is-wide {
  grid-template-columns: 96px minmax(0, 1fr);
  padding: 7px 0;
}

.qa-generation-guide {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  gap: 8px;
  margin-top: 6px;
  padding: 11px 12px;
  color: #666f7a;
  background: #f1f3f4;
  font-size: 12px;
}

.qa-generation-guide p {
  margin: 0;
}

main.is-generation-main .project-output-workspace__run.is-qa:not(:disabled) {
  color: #fff;
  background: #e94e12;
}

main.is-generation-main .project-output-workspace__run.is-qa:not(:disabled):hover {
  background: #d9420b;
}

@media (max-width: 1180px) {
  main.is-generation-main .project-output-workspace__layout.is-qa {
    grid-template-areas: "materials" "generation";
    grid-template-columns: minmax(0, 1fr);
  }
  main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials {
    border-right: 0;
  }
  main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-card {
    position: static;
    min-height: 0;
  }
}
@media (max-width: 760px) {
  .project-generation-page-title.is-qa {
    grid-template-columns: auto 1fr;
  }
  .project-generation-page-title.is-qa em,
  .project-generation-page-title.is-qa code,
  .project-generation-page-title.is-qa time {
    display: none;
  }
  main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__filters {
    grid-template-columns: minmax(0, 1fr);
  }
  .qa-generation-source-tools {
    justify-content: flex-start;
  }
  main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
    grid-template-columns: 28px minmax(0, 1fr) auto;
  }
  .project-generation-source.is-qa .project-generation-source__format,
  .project-generation-source.is-qa .project-generation-source__version,
  .project-generation-source.is-qa .project-generation-source__period {
    display: none;
  }
}
/* Selected generation-console concept */
.project-generation-page-title {
  display: flex;
  align-items: center;
  gap: 18px;
  min-height: 38px;
}

.project-generation-page-title h1 {
  margin: 0;
}

.project-generation-page-title span {
  display: inline-flex;
  align-items: center;
  min-height: 27px;
  padding: 0 11px;
  color: #28665f;
  background: #edf5f3;
  border: 1px solid #cfe0dd;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
}

main.is-generation-main .project-output-settings {
  min-height: calc(100vh - 112px);
  padding: 0;
}

main.is-generation-main .project-output-workspace {
  max-width: none;
}

main.is-generation-main .project-output-workspace__layout {
  grid-template-areas: "steps generation" "materials generation";
  grid-template-columns: minmax(0, 1fr) 360px;
  grid-template-rows: auto minmax(0, 1fr);
  align-items: stretch;
  column-gap: 16px;
  row-gap: 20px;
}

main.is-generation-main .project-output-workspace__steps {
  min-height: 98px;
  border-color: #d7dbdf;
  border-radius: 5px;
  box-shadow: none;
}

main.is-generation-main .project-output-workspace__steps li {
  min-height: 96px;
  padding: 18px 20px;
}

main.is-generation-main .project-output-workspace__steps li + li {
  border-left: 0;
}

main.is-generation-main .project-output-workspace__steps li.is-active {
  box-shadow: none;
}

main.is-generation-main .project-output-workspace__step-number {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}

main.is-generation-main .project-output-workspace__steps li.is-active .project-output-workspace__step-number {
  background: #2f766d;
  border-color: #2f766d;
}

main.is-generation-main .project-output-workspace__materials,
main.is-generation-main .project-output-workspace__generation-card {
  border-color: #dde0e3;
  border-radius: 4px;
  box-shadow: 0 8px 24px rgba(28, 32, 38, 0.045);
}

main.is-generation-main .project-output-workspace__materials {
  min-height: 690px;
}

main.is-generation-main .project-output-workspace__generation-card {
  top: 18px;
  min-height: 808px;
  align-self: start;
}

main.is-generation-main .project-output-workspace__section-header {
  min-height: 110px;
  align-items: center;
  padding: 24px 22px 20px;
}

main.is-generation-main .project-output-workspace__section-header span {
  display: none;
}

main.is-generation-main .project-output-workspace__section-header h3 {
  margin: 0;
  color: #171b20;
  font-size: 22px;
  letter-spacing: -0.035em;
}

main.is-generation-main .project-output-workspace__section-header p {
  margin-top: 10px;
  font-size: 12px;
}

main.is-generation-main .project-output-workspace__section-header > strong {
  padding: 9px 13px;
  color: #2c6e66;
  background: #edf5f3;
  border-radius: 999px;
  font-size: 12px;
}

main.is-generation-main .project-output-workspace__filters {
  gap: 22px;
  padding: 18px 22px 17px;
  background: #ffffff;
}

main.is-generation-main .project-generation-field > span {
  color: #262b31;
  font-size: 12px;
  font-weight: 700;
}

main.is-generation-main .project-generation-field input,
main.is-generation-main .project-generation-search {
  border-radius: 4px;
}

main.is-generation-main .project-output-workspace__source-panel {
  min-height: 0;
  padding: 0;
}

main.is-generation-main .project-output-workspace__source-list {
  max-height: none;
  overflow: visible;
}

.project-generation-source-table__head,
main.is-generation-main .project-output-workspace__source-list .project-generation-source {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) 118px 132px;
  align-items: center;
  gap: 12px;
}

.project-generation-source-table__head {
  min-height: 43px;
  padding: 0 16px;
  color: #4c535c;
  background: #fbfbfb;
  border-bottom: 1px solid #dfe2e5;
}

.project-generation-source-table__head button {
  color: inherit;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.project-generation-source-table__select-all {
  display: grid;
  justify-content: start;
  padding: 0;
}

.project-generation-source-table__sort {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
}

main.is-generation-main .project-output-workspace__source-list .project-generation-source {
  width: 100%;
  min-height: 64px;
  padding: 9px 16px;
  color: #252a30;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #e1e4e7;
  text-align: left;
}

main.is-generation-main .project-output-workspace__source-list .project-generation-source:hover:not(:disabled),
main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-selected,
main.is-generation-main .project-output-workspace.is-kg .project-output-workspace__source-list .project-generation-source:hover:not(:disabled),
main.is-generation-main .project-output-workspace.is-kg .project-output-workspace__source-list .project-generation-source.is-selected {
  background: #f4f8f7;
}

main.is-generation-main .project-generation-source__check {
  width: 18px;
  height: 18px;
  color: #ffffff;
  background: #ffffff;
  border: 1px solid #9da5ae;
}

main.is-generation-main .project-generation-source__check.is-selected,
main.is-generation-main .project-generation-source.is-selected .project-generation-source__check {
  color: #ffffff;
  background: #2f766d;
  border-color: #2f766d;
}

main.is-generation-main .project-generation-source__main small {
  margin-top: 5px;
}

.project-generation-source__format {
  color: #5d646d;
}

main.is-generation-main .project-generation-source__availability {
  justify-self: start;
  padding: 7px 10px;
  color: #2d6e66;
  background: #eaf4f2;
  white-space: nowrap;
}

.project-generation-source-table__footer {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 16px;
  min-height: 55px;
  padding: 0 18px;
  color: #6f7680;
  background: #ffffff;
}

.project-generation-source-table__footer nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.project-generation-source-table__footer nav button {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: #3e454d;
  background: #ffffff;
  border: 0;
  cursor: pointer;
}

.project-generation-source-table__footer nav button:disabled {
  color: #b8bdc3;
  cursor: default;
}

.project-generation-source-table__footer nav strong {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: #1f2429;
  border: 1px solid #d5d9dd;
}

.project-generation-source-table__footer label {
  justify-self: end;
}

.project-generation-source-table__footer select {
  min-height: 30px;
  padding: 0 6px;
  color: #505760;
  background: #ffffff;
  border: 0;
}

main.is-generation-main .project-output-workspace__generation-header {
  min-height: 58px;
  align-items: center;
  padding: 0 18px;
}

main.is-generation-main .project-output-workspace__generation-header h2 {
  margin: 0;
  font-size: 15px;
  letter-spacing: -0.02em;
}

.project-output-workspace__live-status {
  display: inline-flex;
  align-items: center;
  min-height: 25px;
  padding: 0 11px;
  color: #2a6b63;
  background: #edf5f3;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

main.is-generation-main .project-output-workspace__generation-body {
  padding: 0 18px 18px;
}

.project-output-workspace__selected-overview {
  padding: 22px 0 18px;
  border-bottom: 1px solid #e1e4e7;
}

.project-output-workspace__selected-overview > span {
  display: block;
  color: #414850;
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__selected-overview strong {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-top: 7px;
}

.project-output-workspace__selected-overview b {
  color: #2f766d;
  font-size: 38px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.05em;
}

.project-output-workspace__selected-overview em {
  color: #252a30;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
}

.project-output-workspace__estimate {
  position: relative;
  padding: 18px 0 20px;
  border-bottom: 1px solid #e1e4e7;
}

.project-output-workspace__estimate h3,
.project-output-workspace__configuration-heading h3 {
  margin: 0;
  color: #252a30;
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__estimate > p {
  position: absolute;
  top: 18px;
  left: 84px;
  margin: 0;
  color: #9da3aa;
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__estimate dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 18px 0 0;
}

.project-output-workspace__estimate dl > div {
  min-width: 0;
  padding-right: 10px;
}

.project-output-workspace__estimate dl > div + div {
  padding-left: 16px;
  border-left: 1px solid #e0e3e6;
}

.project-output-workspace__estimate dt {
  color: #333941;
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__estimate dd {
  display: flex;
  align-items: baseline;
  margin: 8px 0 0;
}

.project-output-workspace__estimate dd strong {
  color: #181c21;
  font-size: 19px;
  font-weight: 700;
}

.project-output-workspace__estimate dd span {
  color: #767d86;
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__configuration-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 0 10px;
}

main.is-generation-main .project-output-workspace__setting-button {
  min-height: 32px;
  padding: 0 11px;
  color: #4c535c;
  border-color: #d8dce0;
}

main.is-generation-main .project-output-workspace__configuration {
  padding-bottom: 8px;
}

main.is-generation-main .project-output-workspace__configuration dl {
  display: block;
}

main.is-generation-main .project-output-workspace__configuration dl > div,
main.is-generation-main .project-output-workspace__configuration dl > div.is-wide {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr);
  align-items: start;
  gap: 8px;
  padding: 8px 0;
  border: 0;
}

main.is-generation-main .project-output-workspace__configuration dt {
  font-size: 12px;
}

main.is-generation-main .project-output-workspace__configuration dd,
main.is-generation-main .project-output-workspace__configuration dl > div.is-wide dd,
main.is-generation-main .project-output-workspace__configuration dl > div.is-stat dd {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
}

main.is-generation-main .project-output-workspace__generation-action {
  padding-top: 14px;
}

main.is-generation-main .project-output-workspace__message {
  grid-template-columns: 28px minmax(0, 1fr);
  margin: 0 0 12px;
  padding: 13px;
  border-color: #e0e3e6;
  border-radius: 5px;
  background: #fafafa;
}

main.is-generation-main .project-output-workspace__message.is-success {
  color: #2e6d65;
  border-color: #dce3e1;
  background: #fafafa;
}

main.is-generation-main .project-output-workspace__message.is-partial {
  color: #a66a12;
  border-color: #ead6ad;
  background: #fffaf0;
}

main.is-generation-main .project-output-workspace__result-link {
  min-height: 34px;
  margin-top: 10px;
}

main.is-generation-main .project-output-workspace__selection {
  border-radius: 4px;
}

main.is-generation-main .project-output-workspace__run {
  min-height: 58px;
  border: 0;
}

main.is-generation-main .project-output-workspace__run:disabled {
  color: #878c92;
  background: #e5e5e2;
}

@media (max-width: 1120px) {
  main.is-generation-main .project-output-workspace__layout {
    grid-template-areas: "steps" "materials" "generation";
    grid-template-columns: minmax(0, 1fr);
  }
  main.is-generation-main .project-output-workspace__generation-card {
    position: static;
    min-height: 0;
  }
}
@media (max-width: 720px) {
  .project-generation-page-title {
    align-items: flex-start;
    flex-direction: column;
    gap: 9px;
  }
  main.is-generation-main .project-output-workspace__steps {
    grid-template-columns: minmax(0, 1fr);
  }
  main.is-generation-main .project-output-workspace__steps li + li {
    border-top: 1px solid #e1e4e7;
  }
  main.is-generation-main .project-output-workspace__filters {
    grid-template-columns: minmax(0, 1fr);
  }
  .project-generation-source-table__head {
    display: none;
  }
  main.is-generation-main .project-output-workspace__source-list .project-generation-source {
    grid-template-columns: 28px minmax(0, 1fr) auto;
    gap: 9px;
  }
  .project-generation-source__format {
    display: none;
  }
  .project-generation-source-table__footer {
    grid-template-columns: minmax(0, 1fr);
    justify-items: center;
    padding: 14px;
  }
  .project-generation-source-table__footer label {
    justify-self: center;
  }
}
/* Project quality improvement center */
:host .project-admin-navigation {
  width: 100%;
  padding: 12px 24px;
  background: #f7f9f5;
}

:host .project-admin-navigation__inner {
  width: 100%;
}

:host .project-admin-tabs {
  width: fit-content;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 5px;
  overflow-x: auto;
  border: 1px solid #dde3dc;
  border-radius: 12px;
  background: #f2f4f0;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.82);
  scrollbar-width: none;
}

:host .project-admin-tabs::-webkit-scrollbar {
  display: none;
}

:host .project-admin-tabs a {
  position: relative;
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 15px;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #7c857d;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  text-decoration: none;
  transition: color 0.16s ease, background 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease;
}

:host .project-admin-tabs a i {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  color: #879188;
  background: rgba(255, 255, 255, 0.56);
  font-size: 12px;
  transition: color 0.16s ease, background 0.16s ease;
}

:host .project-admin-tabs a:hover {
  color: #4e6250;
  background: rgba(255, 255, 255, 0.64);
}

:host .project-admin-tabs a:focus-visible {
  outline: 0;
  border-color: #8ca08b;
  box-shadow: 0 0 0 3px rgba(99, 123, 99, 0.14);
}

:host .project-admin-tabs a.is-active {
  border-color: #d2dbd0;
  color: #465d49;
  background: #fff;
  box-shadow: 0 3px 10px rgba(55, 72, 59, 0.09);
}

:host .project-admin-tabs a.is-active i {
  color: #526b54;
  background: #edf3ea;
}

:host .is-quality-main {
  color: #202720;
}

:host .quality-state-card,
:host .quality-empty-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 180px;
  padding: 28px;
  border: 1px dashed #cfd7ce;
  background: #fbfcfa;
  color: #697369;
  text-align: center;
}

:host .quality-state-card.is-error {
  border-color: #e5c9c2;
  background: #fff9f7;
  color: #8f4438;
}

:host .quality-state-card button,
:host .quality-empty-panel button {
  min-height: 34px;
  padding: 0 14px;
  border: 1px solid #697f68;
  background: #697f68;
  color: #fff;
}

:host .quality-empty-panel {
  flex-direction: column;
}

:host .quality-empty-panel i {
  font-size: 24px;
  color: #8f9d8e;
}

:host .quality-empty-panel strong {
  color: #394539;
  font-size: 14px;
}

:host .quality-empty-panel p {
  max-width: 600px;
  margin: 0;
  font-size: 12px;
  line-height: 1.7;
}

:host .quality-empty-panel.is-compact {
  min-height: 142px;
}

:host .quality-flow,
:host .quality-review-inbox,
:host .quality-feedback-panel,
:host .quality-version-panel,
:host .quality-agent-panel,
:host .quality-regression-panel {
  border: 1px solid #dce2da;
  background: #fff;
}

:host .quality-workspace-tabs {
  display: flex;
  align-items: stretch;
  gap: 8px;
  padding: 8px;
  overflow-x: auto;
  border: 1px solid #dce2da;
  border-radius: 15px;
  background: #eef2ec;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.82), 0 2px 8px rgba(50, 67, 53, 0.04);
  scrollbar-width: none;
}

:host .quality-workspace-tabs::-webkit-scrollbar {
  display: none;
}

:host .quality-workspace-tabs button {
  position: relative;
  min-width: 180px;
  min-height: 72px;
  flex: 1 0 0;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) 18px;
  align-items: center;
  gap: 12px;
  padding: 12px 15px;
  border: 1px solid #dce3da;
  color: #5e6c60;
  text-align: left;
  background: #fff;
  box-shadow: 0 2px 7px rgba(46, 64, 49, 0.055);
  cursor: pointer;
  transition: color 0.16s ease, border-color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

:host .quality-workspace-tabs button:hover {
  z-index: 1;
  border-color: #9eb09d;
  color: #405a44;
  background: #fbfdfb;
  box-shadow: 0 7px 16px rgba(47, 68, 51, 0.11);
  transform: translateY(-2px);
}

:host .quality-workspace-tabs button:focus-visible {
  z-index: 2;
  outline: 3px solid rgba(98, 125, 101, 0.22);
  outline-offset: 2px;
}

:host .quality-workspace-tabs button.is-active {
  z-index: 1;
  border-color: #718a73;
  color: #334c38;
  background: linear-gradient(135deg, #edf4e9 0%, #e4eee1 100%);
  box-shadow: inset 0 -3px 0 #647d66, 0 7px 16px rgba(53, 78, 57, 0.13);
  transform: translateY(-1px);
}

:host .quality-workspace-tabs button > b {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border: 1px solid #d5ddd4;
  color: #647266;
  background: #f4f7f2;
}

:host .quality-workspace-tabs button.is-active > b {
  border-color: #58735d;
  color: #fff;
  background: #607a63;
}

:host .quality-workspace-tabs button > i {
  color: #a0aaa0;
  font-size: 12px;
  text-align: center;
  transition: color 0.16s ease, transform 0.16s ease;
}

:host .quality-workspace-tabs button:hover > i {
  color: #5d785f;
  transform: translateX(3px);
}

:host .quality-workspace-tabs button.is-active > i {
  color: #526d57;
}

:host .quality-workspace-tabs button span,
:host .quality-workspace-tabs button strong,
:host .quality-workspace-tabs button small {
  display: block;
}

:host .quality-workspace-tabs button small {
  margin-top: 5px;
  color: #8b958c;
}

:host .quality-workspace-tabs button.is-active strong {
  color: #304735;
}

:host .quality-workspace-tabs button.is-active small {
  color: #647567;
}

:host .quality-flow > header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 26px 20px;
  border-bottom: 1px solid #e7ebe5;
}

:host .quality-flow > header span,
:host .quality-section-header > div:first-child > span {
  display: block;
  margin-bottom: 6px;
  color: #728371;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

:host .quality-flow h2,
:host .quality-section-header h2 {
  margin: 0;
  color: #253025;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

:host .quality-flow > header p,
:host .quality-section-header p {
  max-width: 720px;
  margin: 6px 0 0;
  color: #717b71;
  font-size: 12px;
  line-height: 1.65;
}

:host .quality-flow ol {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin: 0;
  padding: 0;
  list-style: none;
}

:host .quality-flow li {
  position: relative;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  min-height: 86px;
  padding: 16px 20px;
  border-right: 1px solid #e7ebe5;
}

:host .quality-flow li:last-child {
  border-right: 0;
}

:host .quality-flow li > span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #d8ded6;
  background: #f7f9f6;
  color: #8a9489;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-flow li.is-complete > span {
  border-color: #6b8269;
  background: #6b8269;
  color: #fff;
}

:host .quality-flow li strong,
:host .quality-flow li small {
  display: block;
}

:host .quality-flow li strong {
  color: #344035;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-flow li small {
  margin-top: 4px;
  color: #8a9389;
  font-size: 12px;
}

:host .quality-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border: 1px solid #dce2da;
  background: #fff;
}

:host .quality-metrics article {
  min-height: 106px;
  padding: 20px 22px;
  border-right: 1px solid #e7ebe5;
}

:host .quality-metrics article:last-child {
  border-right: 0;
}

:host .quality-metrics span,
:host .quality-metrics small,
:host .quality-metrics strong {
  display: block;
}

:host .quality-metrics span {
  color: #7b857a;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-metrics strong {
  margin-top: 9px;
  color: #273228;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

:host .quality-metrics small {
  margin-top: 5px;
  color: #879087;
  font-size: 12px;
}

:host .quality-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 24px;
  border-bottom: 1px solid #e5eae3;
}

:host .quality-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 15px;
  border: 1px solid #657c65;
  cursor: pointer;
}

:host .quality-button.is-primary {
  background: #657c65;
  color: #fff;
}

:host .quality-button.is-secondary {
  background: #fff;
  color: #536a54;
}

:host .quality-button:disabled {
  border-color: #d9ded7;
  background: #edf0ec;
  color: #9ca49b;
  cursor: not-allowed;
}

:host .quality-filter-tabs {
  display: flex;
  gap: 3px;
  padding: 4px;
  border: 0;
  border-radius: 10px;
  background: #f0f3ee;
  box-shadow: inset 0 0 0 1px #dce3da;
}

:host .quality-filter-tabs button {
  min-width: 52px;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid transparent;
  background: transparent;
  color: #7d867c;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

:host .quality-filter-tabs button:hover {
  border-color: #d3dcd0;
  color: #435a47;
  background: rgba(255, 255, 255, 0.72);
}

:host .quality-filter-tabs button:focus-visible {
  position: relative;
  z-index: 1;
  outline: 2px solid #718771;
  outline-offset: -2px;
}

:host .quality-filter-tabs button.is-active {
  border-color: #9caf9c;
  color: #36513c;
  background: #e5eee2;
  box-shadow: 0 2px 5px rgba(47, 67, 50, 0.08);
}

:host .quality-review-grid {
  display: grid;
  grid-template-columns: minmax(270px, 300px) minmax(0, 1fr);
  align-items: stretch;
  min-height: 520px;
}

:host .quality-review-list {
  min-width: 0;
  border-right: 1px solid #e2e7e0;
  background: #fafbf9;
}

:host .quality-review-list__panel {
  position: sticky;
  top: 16px;
  display: flex;
  max-height: calc(100vh - 32px);
  flex-direction: column;
}

:host .quality-review-list__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 17px 16px 15px;
  border-bottom: 1px solid #e2e7e0;
  background: #f3f6f1;
}

:host .quality-review-list__title span,
:host .quality-review-list__title small {
  display: block;
}

:host .quality-review-list__title span {
  color: #3f5041;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-review-list__title small {
  margin-top: 4px;
  color: #899289;
  font-size: 12px;
  line-height: 1.45;
}

:host .quality-review-list__title > strong {
  min-width: 36px;
  min-height: 28px;
  display: grid;
  place-items: center;
  border: 1px solid #cfdbcd;
  border-radius: 8px;
  color: #526b54;
  background: #fff;
  font-size: 12px;
}

:host .quality-review-list__items {
  display: grid;
  gap: 8px;
  min-height: 0;
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #c7d0c5 transparent;
}

:host .quality-review-list__items > button {
  position: relative;
  display: block;
  width: 100%;
  padding: 14px 15px;
  border: 1px solid #e0e5df;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

:host .quality-review-list__items > button:hover {
  border-color: #bdcabb;
  background: #f8faf7;
  transform: translateX(2px);
}

:host .quality-review-list__items > button:focus-visible {
  outline: 2px solid #718771;
  outline-offset: 2px;
}

:host .quality-review-list__items > button.is-selected {
  border-color: #789078;
  background: #eef3ec;
  box-shadow: 0 4px 12px rgba(55, 75, 55, 0.08);
}

:host .quality-review-list__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

:host .quality-review-list__items strong {
  color: #344034;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-review-list__summary {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 11px;
}

:host .quality-review-list__summary strong {
  color: #465f49;
  font-size: 17px;
  font-weight: 700;
}

:host .quality-review-list__summary span {
  padding-left: 8px;
  border-left: 1px solid #dce3da;
  color: #788378;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-review-list__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 9px;
}

:host .quality-review-list__meta small,
:host .quality-review-list__meta time {
  color: #919991;
  font-size: 12px;
}

:host .quality-review-list__meta time {
  flex: 0 0 auto;
}

:host .quality-empty-list {
  padding: 34px 20px;
  color: #8b948a;
  font-size: 12px;
  text-align: center;
}

:host .quality-decision {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 0 8px;
  border: 1px solid #d8dfd5;
  background: #f5f7f4;
  color: #687268;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-decision.is-approve {
  border-color: #c7d9c3;
  background: #edf6eb;
  color: #477047;
}

:host .quality-decision.is-revise {
  border-color: #e7d5a9;
  background: #fff8e7;
  color: #8b6a1d;
}

:host .quality-decision.is-verify {
  border-color: #c9d7e6;
  background: #eef5fb;
  color: #486a8e;
}

:host .quality-decision.is-exclude {
  border-color: #e5c7c1;
  background: #fff0ed;
  color: #9a4a3c;
}

:host .quality-review-detail {
  min-width: 0;
  padding: 24px 26px 28px;
}

:host .quality-review-detail > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e6ebe4;
}

:host .quality-review-detail > header span,
:host .quality-review-detail > header h3,
:host .quality-review-detail > header strong {
  display: block;
}

:host .quality-review-detail > header > div:first-child > span {
  color: #8b958b;
  font-family: monospace;
  font-size: 12px;
}

:host .quality-review-detail h3 {
  margin: 6px 0 0;
  color: #283329;
  font-size: 16px;
  font-weight: 700;
}

:host .quality-review-result {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
}

:host .quality-review-result > strong {
  color: #4e684f;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

:host .quality-review-result > div {
  display: grid;
  max-width: 230px;
  justify-items: start;
  gap: 6px;
}

:host .quality-review-result > div > span.quality-decision {
  display: inline-flex;
  width: auto;
  min-height: 25px;
  padding: 0 10px;
  border-radius: 999px !important;
  white-space: nowrap;
}

:host .quality-review-result > div > small {
  max-width: 230px;
  color: #818b81;
  font-size: 12px;
  line-height: 1.5;
}

:host .quality-review-detail dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 20px 0 0;
  border: 1px solid #e2e7e0;
}

:host .quality-review-detail dl > div {
  padding: 13px 15px;
  border-right: 1px solid #e2e7e0;
}

:host .quality-review-detail dl > div:last-child {
  border-right: 0;
}

:host .quality-review-detail dt,
:host .quality-review-detail dd {
  margin: 0;
}

:host .quality-review-detail dt {
  color: #8b948a;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-review-detail dd {
  margin-top: 5px;
  color: #495449;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-review-detail section {
  margin-top: 21px;
}

:host .quality-review-detail h4 {
  margin: 0 0 9px;
  color: #485448;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

:host .quality-tag-list span {
  padding: 5px 8px;
  background: #f1f4ef;
  color: #5d6b5d;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-muted {
  color: #969e96;
  font-size: 12px;
}

:host .quality-review-notes {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border: 1px solid #e2e7e0;
}

:host .quality-review-notes > div {
  min-height: 118px;
  padding: 15px;
  border-right: 1px solid #e2e7e0;
}

:host .quality-review-notes > div:last-child {
  border-right: 0;
}

:host .quality-review-notes span {
  color: #7d887d;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-review-notes p {
  margin: 8px 0 0;
  color: #4d584d;
  font-size: 12px;
  line-height: 1.7;
  white-space: pre-wrap;
}

:host .quality-submitted-survey {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  margin-top: 22px;
  overflow: hidden;
  border: 1px solid #dfe5dd;
  border-radius: 13px;
  background: #dfe5dd;
}

:host .quality-submitted-survey > header {
  grid-column: 1/-1;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  padding: 17px 19px;
  border-bottom: 0;
  background: #f5f8f3;
}

:host .quality-submitted-survey > header span {
  display: block;
  margin-bottom: 4px;
  color: #738174;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

:host .quality-submitted-survey > header h4 {
  margin: 0;
  color: #344035;
  font-size: 13px;
  font-weight: 700;
}

:host .quality-submitted-survey > header small {
  color: #879087;
  font-size: 12px;
}

:host .quality-review-detail section.quality-survey-block {
  margin: 0;
  min-width: 0;
  padding: 18px 19px;
  border-bottom: 0;
  background: #fff;
}

:host .quality-review-detail section.quality-survey-block:not(.quality-survey-question) {
  grid-column: 1/-1;
}

:host .quality-review-detail section.quality-survey-question {
  min-height: 156px;
}

:host .quality-survey-block__title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

:host .quality-survey-block__title > span {
  width: 25px;
  height: 25px;
  flex: 0 0 25px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  color: #fff;
  background: #657a66;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-survey-block__title h5 {
  margin: 0;
  color: #39463a;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-survey-block__title p {
  margin: 4px 0 0;
  color: #7f897f;
  font-size: 12px;
  line-height: 1.55;
}

:host .quality-survey-decision-grid,
:host .quality-survey-response-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
  margin-top: 13px;
}

:host .quality-survey-decision-grid article {
  min-height: 56px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border: 1px solid #e0e5df;
  border-radius: 8px;
  color: #858e85;
  background: #fafbfa;
}

:host .quality-survey-decision-grid article > i {
  text-align: center;
}

:host .quality-survey-decision-grid article strong,
:host .quality-survey-decision-grid article small {
  display: block;
}

:host .quality-survey-decision-grid article strong {
  color: #657065;
  font-size: 12px;
}

:host .quality-survey-decision-grid article small {
  margin-top: 3px;
  font-size: 12px;
  line-height: 1.35;
}

:host .quality-survey-decision-grid article.is-selected {
  border-color: #6d856e;
  color: #4f6b51;
  background: #eef5eb;
  box-shadow: inset 0 0 0 1px rgba(109, 133, 110, 0.16);
}

:host .quality-survey-decision-grid article.is-selected strong {
  color: #405a42;
}

:host .quality-survey-response-grid {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

:host .quality-survey-response-grid > span {
  min-height: 43px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 2px;
  padding: 6px;
  border: 1px solid #e0e5df;
  border-radius: 7px;
  color: #8b938b;
  text-align: center;
  background: #fafbfa;
}

:host .quality-survey-response-grid b {
  color: #687468;
  font-size: 12px;
}

:host .quality-survey-response-grid em {
  font-size: 12px;
  font-style: normal;
}

:host .quality-survey-response-grid > span.is-selected {
  border-color: #617a63;
  color: #466048;
  background: #eaf3e7;
  box-shadow: inset 0 0 0 1px rgba(97, 122, 99, 0.14);
}

:host .quality-survey-response-grid > span.is-selected b {
  color: #3d5940;
}

:host .quality-survey-answer {
  margin-top: 12px;
  padding: 11px 13px;
  border: 1px solid #dce4da;
  border-radius: 8px;
  color: #405541;
  background: #eef5eb;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-survey-issue-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
  margin-top: 13px;
}

:host .quality-survey-issue-grid > span {
  min-height: 34px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid #e1e5df;
  border-radius: 7px;
  color: #a1a7a0;
  background: #fafbfa;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-survey-issue-grid > span.is-selected {
  border-color: #dfb49f;
  color: #944d35;
  background: #fff3ed;
}

:host .quality-review-detail section.quality-survey-comments {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  margin: 0;
  background: #dfe5dd;
}

:host .quality-survey-comments article {
  min-height: 118px;
  padding: 18px 19px;
  border-right: 0;
  background: #fff;
}

:host .quality-survey-comments article:first-child {
  grid-column: 1/-1;
  min-height: auto;
}

:host .quality-survey-comments strong {
  color: #6f7b70;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-survey-comments p {
  margin: 8px 0 0;
  color: #465247;
  font-size: 12px;
  line-height: 1.7;
  white-space: pre-wrap;
}

:host .quality-analysis-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(320px, 0.75fr);
  gap: 18px;
}

:host .quality-analysis-grid.is-single {
  grid-template-columns: minmax(0, 1fr);
}

:host .quality-feedback-panel ol {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 0;
  padding: 18px;
  background: #f7f9f6;
  list-style: none;
}

:host .quality-feedback-panel li {
  min-width: 0;
  padding: 16px;
  border: 1px solid #e0e6df;
  border-radius: 10px;
  background: #fff;
}

:host .quality-feedback-panel li.is-priority {
  border-color: #cad8c7;
  box-shadow: inset 3px 0 #688069;
}

:host .quality-feedback-panel li > header {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto;
  gap: 11px;
  align-items: center;
}

:host .quality-feedback-panel li > header > span {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #5e735f;
  background: #edf3eb;
  font-size: 12px;
}

:host .quality-feedback-panel li strong {
  display: block;
  color: #39483b;
  font-size: 12px;
  line-height: 1.4;
}

:host .quality-feedback-panel li small {
  display: block;
  margin-bottom: 4px;
  color: #879287;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-feedback-panel li em {
  min-width: 31px;
  padding: 5px 7px;
  border-radius: 999px;
  color: #536b54;
  text-align: center;
  background: #eef3ec;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

:host .quality-feedback-panel li > p {
  margin: 13px 0 0 43px;
  color: #687369;
  font-size: 12px;
  line-height: 1.65;
}

:host .quality-version-cards {
  display: grid;
  gap: 0;
}

:host .quality-version-cards section {
  position: relative;
  padding: 18px 76px 18px 20px;
  border-bottom: 1px solid #e7ebe5;
}

:host .quality-version-cards span,
:host .quality-version-cards strong,
:host .quality-version-cards small {
  display: block;
}

:host .quality-version-cards span {
  color: #849084;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-version-cards strong {
  margin-top: 6px;
  overflow: hidden;
  color: #364236;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .quality-version-cards small {
  margin-top: 5px;
  color: #929b92;
  font-size: 12px;
}

:host .quality-version-cards em {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #536b54;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
}

:host .quality-version-note {
  margin: 0;
  padding: 14px 20px;
  background: #f6f8f5;
  color: #687468;
  font-size: 12px;
  line-height: 1.55;
}

:host .quality-version-note i {
  margin-right: 7px;
}

:host .quality-version-history {
  border-bottom: 1px solid #e7ebe5;
}

:host .quality-version-history > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 0 20px;
  color: #667466;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  list-style: none;
}

:host .quality-version-history > summary::-webkit-details-marker {
  display: none;
}

:host .quality-version-history[open] > summary i {
  transform: rotate(180deg);
}

:host .quality-version-history > summary i {
  transition: transform 0.18s ease;
}

:host .quality-version-history > div {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid #e7ebe5;
}

:host .quality-version-history > div > section {
  min-width: 0;
  padding: 14px;
  border-right: 1px solid #e7ebe5;
}

:host .quality-version-history > div > section:last-child {
  border-right: 0;
}

:host .quality-version-history h3 {
  margin: 0 0 8px;
  color: #536153;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-version-history ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

:host .quality-version-history li {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 10px;
  border-top: 1px solid #edf0ec;
}

:host .quality-version-history li:first-child {
  border-top: 0;
}

:host .quality-version-history li > div {
  min-width: 0;
}

:host .quality-version-history li strong {
  color: #3f4d40;
  font-size: 12px;
}

:host .quality-version-history li span {
  margin-left: 6px;
  color: #557055;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-version-history li small {
  display: block;
  margin-top: 3px;
  color: #969e95;
  font-size: 12px;
}

:host .quality-version-history li p {
  margin: 4px 0 0;
  overflow: hidden;
  color: #717c71;
  font-size: 12px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .quality-version-history li button {
  flex: 0 0 auto;
  min-height: 26px;
  padding: 0 8px;
  border: 1px solid #cfd7cd;
  background: #fff;
  color: #5e715e;
}

:host .quality-version-history li button:disabled {
  color: #a2aaa1;
  background: #f0f2ef;
  cursor: not-allowed;
}

:host .quality-plan-status {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 5px;
}

:host .quality-plan-status span {
  color: #506850;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-plan-status code {
  color: #929a91;
  font-size: 12px;
}

:host .quality-proposal-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #e3e8e1;
  background: #f7f9f6;
}

:host .quality-proposal-tabs button {
  width: 100%;
  min-width: 0;
  min-height: 58px;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 0 14px;
  border: 1px solid #d9e0d7;
  color: #677268;
  text-align: left;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

:host .quality-proposal-tabs button:hover {
  border-color: #aebbab;
  color: #455d49;
  background: #fbfdfb;
}

:host .quality-proposal-tabs button:focus-visible {
  outline: 3px solid rgba(99, 124, 100, 0.18);
  outline-offset: 2px;
}

:host .quality-proposal-tabs button i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #718071;
  background: #eef3ec;
  font-size: 12px;
}

:host .quality-proposal-tabs button span {
  min-width: 0;
}

:host .quality-proposal-tabs button b {
  width: max-content;
  min-width: 64px;
  min-height: 28px;
  display: grid;
  place-items: center;
  padding: 0 11px;
  color: #6b776b;
  background: #f0f3ef;
  white-space: nowrap;
}

:host .quality-proposal-tabs button.is-active {
  border-color: #718a73;
  color: #304a35;
  background: #eaf2e7;
  box-shadow: 0 3px 9px rgba(53, 78, 57, 0.08);
}

:host .quality-proposal-tabs button.is-active i {
  color: #fff;
  background: #637d66;
}

:host .quality-proposal-tabs button.is-active b {
  color: #fff;
  background: #637d66;
}

:host .quality-proposal-tabs button.is-complete:not(.is-active) b {
  color: #4f6c53;
  background: #e6efe3;
}

:host .quality-proposal-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

:host .quality-proposal-list > article {
  padding: 20px 22px;
  border-right: 1px solid #e7ebe5;
  border-bottom: 1px solid #e7ebe5;
  background: #fff;
}

:host .quality-proposal-list > article:nth-child(2n) {
  border-right: 0;
}

:host .quality-proposal-list > .quality-empty-panel {
  grid-column: 1/-1;
  border: 0;
}

:host .quality-proposal-list > article.is-approved {
  background: #f6faf4;
  box-shadow: inset 3px 0 #6d876b;
}

:host .quality-proposal-list > article.is-hold {
  background: #fffbf2;
}

:host .quality-proposal-list > article.is-rejected {
  background: #fafafa;
  opacity: 0.72;
}

:host .quality-proposal-list article > header > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

:host .quality-proposal-list article > header span {
  color: #5d725d;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

:host .quality-proposal-list article > header em {
  color: #909990;
  font-size: 12px;
  font-style: normal;
}

:host .quality-proposal-list article > header strong {
  display: block;
  margin-top: 8px;
  color: #303d31;
  font-size: 13px;
  font-weight: 700;
}

:host .quality-proposal-list article > p {
  margin: 8px 0 0;
  color: #788278;
  font-size: 12px;
  line-height: 1.6;
}

:host .quality-proposal-list blockquote {
  margin: 14px 0 0;
  padding: 12px 14px;
  border-left: 3px solid #829481;
  background: #f5f7f3;
  color: #4d594e;
  font-size: 12px;
  line-height: 1.65;
}

:host .quality-proposal-list label {
  display: block;
  margin-top: 14px;
}

:host .quality-proposal-list label > span {
  display: block;
  margin-bottom: 6px;
  color: #7c877c;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-proposal-list textarea {
  display: block;
  width: 100%;
  resize: vertical;
  border: 1px solid #d9e0d7;
  background: #fff;
  padding: 10px 11px;
  color: #3f4c40;
  font-size: 12px;
  line-height: 1.55;
}

:host .quality-proposal-list textarea:focus {
  border-color: #70866f;
  outline: 2px solid rgba(112, 134, 111, 0.14);
}

:host .quality-proposal-actions {
  display: flex;
  gap: 6px;
  margin-top: 12px;
}

:host .quality-proposal-actions button {
  min-height: 31px;
  padding: 0 10px;
  border: 1px solid #d7ddd5;
  background: #fff;
  color: #727c72;
}

:host .quality-proposal-actions button.is-active:first-child {
  border-color: #637d63;
  background: #637d63;
  color: #fff;
}

:host .quality-proposal-actions button.is-active:nth-child(2) {
  border-color: #c9a953;
  background: #fff4d5;
  color: #7a5f16;
}

:host .quality-proposal-actions button.is-active:nth-child(3) {
  border-color: #b9938b;
  background: #fff0ed;
  color: #8f493d;
}

:host .quality-proposal-actions button:disabled {
  cursor: not-allowed;
}

:host .quality-agent-panel > footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 22px;
  background: #f8faf7;
}

:host .quality-agent-panel > footer > div > strong,
:host .quality-agent-panel > footer > div > span {
  display: block;
}

:host .quality-agent-panel > footer > div > strong {
  color: #3e4e3f;
  font-size: 12px;
}

:host .quality-agent-panel > footer > div > span {
  margin-top: 4px;
  color: #879187;
  font-size: 12px;
}

:host .quality-regression-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(360px, 0.92fr);
  gap: 12px;
  padding: 18px;
  background: #f6f8f4;
}

:host .quality-regression-grid > article {
  min-width: 0;
  min-height: 250px;
  padding: 20px;
  border: 1px solid #dfe6dc;
  border-radius: 12px;
  background: #fff;
}

:host .quality-regression-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

:host .quality-regression-card-header span,
:host .quality-regression-card-header strong {
  display: block;
}

:host .quality-regression-card-header span {
  color: #788578;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-regression-card-header strong {
  margin-top: 6px;
  color: #303d32;
  font-size: 15px;
  font-weight: 700;
}

:host .quality-regression-card-header b {
  min-width: 48px;
  padding: 8px 11px;
  border-radius: 999px;
  color: #48604c;
  text-align: center;
  background: #eaf1e6;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-regression-cases > p {
  max-width: 650px;
  margin: 10px 0 0;
  color: #7a857a;
  font-size: 12px;
  line-height: 1.65;
}

:host .quality-regression-grid ul {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin: 16px 0 0;
  padding: 0;
  list-style: none;
}

:host .quality-regression-grid li {
  display: grid;
  min-height: 62px;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  gap: 11px;
  align-items: center;
  padding: 11px 13px;
  border: 1px solid #dce4da;
  border-radius: 10px;
  background: #f8faf7;
}

:host .quality-regression-candidate__icon {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #56705b;
  background: #e7efe4;
  font-size: 12px;
}

:host .quality-regression-candidate__body {
  min-width: 0;
}

:host .quality-regression-grid li span {
  display: block;
  color: #526855;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-regression-grid li strong {
  display: block;
  margin-top: 5px;
  overflow: hidden;
  color: #778177;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .quality-regression-grid li em {
  min-width: 50px;
  padding: 5px 8px;
  border-radius: 999px;
  color: #536b56;
  text-align: center;
  background: #e7eee4;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

:host .quality-regression-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 18px;
  border-radius: 10px;
  color: #758175;
  background: #f6f8f4;
  font-size: 12px;
}

:host .quality-regression-state {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  margin-top: 16px;
  padding: 14px;
  border: 1px solid #dbe4d7;
  border-radius: 11px;
  background: #f2f6ef;
}

:host .quality-regression-state > i {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: #56705b;
  background: #e0ebdc;
  font-size: 14px;
}

:host .quality-regression-state strong {
  display: block;
  color: #334436;
  font-size: 12px;
  font-weight: 700;
}

:host .quality-regression-state p {
  margin: 5px 0 0;
  color: #718073;
  font-size: 12px;
  line-height: 1.55;
}

:host .quality-regression-state.is-passed {
  border-color: #c8dbc2;
  background: #edf6e9;
}

:host .quality-regression-state.is-failed {
  border-color: #ead0c5;
  background: #fff4ef;
}

:host .quality-regression-state.is-failed > i {
  color: #a34f32;
  background: #f8dfd5;
}

:host .quality-regression-state.is-before {
  border-color: #e0e4de;
  background: #f6f7f5;
}

:host .quality-regression-state.is-before > i {
  color: #778177;
  background: #e9ece7;
}

:host .quality-regression-result dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 12px 0 0;
  overflow: hidden;
  border: 1px solid #e0e6de;
  border-radius: 10px;
}

:host .quality-regression-result dl > div {
  min-width: 0;
  padding: 12px;
  border-right: 1px solid #e0e6de;
}

:host .quality-regression-result dl > div:last-child {
  border-right: 0;
}

:host .quality-regression-result dt {
  color: #8d978c;
  font-size: 12px;
}

:host .quality-regression-result dd {
  margin: 5px 0 0;
  overflow: hidden;
  color: #4c5c4d;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .quality-regression-next {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 12px;
  padding: 11px 12px;
  border-radius: 9px;
  color: #697769;
  background: #f6f8f4;
}

:host .quality-regression-next > i {
  margin-top: 2px;
  color: #5f775f;
  font-size: 12px;
}

:host .quality-regression-next span,
:host .quality-regression-next strong {
  display: block;
}

:host .quality-regression-next span {
  font-size: 12px;
  font-weight: 700;
}

:host .quality-regression-next strong {
  margin-top: 4px;
  color: #485849;
  font-size: 12px;
  line-height: 1.5;
}

@media (max-width: 1100px) {
  :host .quality-flow ol {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host .quality-flow li:nth-child(3) {
    border-right: 0;
  }
  :host .quality-flow li:nth-child(n+4) {
    border-top: 1px solid #e7ebe5;
  }
  :host .quality-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host .quality-metrics article:nth-child(2) {
    border-right: 0;
  }
  :host .quality-metrics article:nth-child(n+3) {
    border-top: 1px solid #e7ebe5;
  }
  :host .quality-analysis-grid {
    grid-template-columns: 1fr;
  }
  :host .quality-review-grid {
    grid-template-columns: minmax(235px, 260px) minmax(0, 1fr);
  }
  :host .quality-review-detail {
    padding: 22px 20px 26px;
  }
  :host .quality-review-notes {
    grid-template-columns: 1fr;
  }
  :host .quality-review-notes > div {
    min-height: auto;
    border-right: 0;
    border-bottom: 1px solid #e2e7e0;
  }
  :host .quality-review-notes > div:last-child {
    border-bottom: 0;
  }
  :host .quality-submitted-survey {
    grid-template-columns: 1fr;
  }
  :host .quality-survey-decision-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  :host .project-admin-navigation {
    padding: 10px 12px;
  }
  :host .project-admin-tabs {
    width: 100%;
    gap: 3px;
    margin-bottom: 0;
    padding: 4px;
  }
  :host .project-admin-tabs a {
    min-width: max-content;
    flex: 1 0 auto;
    min-height: 38px;
    padding-inline: 11px;
  }
  :host .quality-flow > header,
  :host .quality-section-header,
  :host .quality-agent-panel > footer {
    align-items: stretch;
    flex-direction: column;
  }
  :host .quality-flow ol,
  :host .quality-metrics,
  :host .quality-proposal-list,
  :host .quality-regression-grid {
    grid-template-columns: 1fr;
  }
  :host .quality-flow li,
  :host .quality-metrics article,
  :host .quality-proposal-list > article,
  :host .quality-regression-grid > article {
    border-right: 0;
  }
  :host .quality-flow li {
    border-top: 1px solid #e7ebe5;
  }
  :host .quality-flow li:first-child {
    border-top: 0;
  }
  :host .quality-review-grid {
    grid-template-columns: 1fr;
  }
  :host .quality-review-list {
    max-height: none;
    border-right: 0;
    border-bottom: 1px solid #e5eae3;
  }
  :host .quality-review-list__panel {
    position: static;
    max-height: none;
  }
  :host .quality-review-list__items {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
  }
  :host .quality-review-list__items > button {
    width: 280px;
    min-width: 280px;
  }
  :host .quality-review-detail {
    padding: 20px 17px;
  }
  :host .quality-review-detail dl {
    grid-template-columns: 1fr;
  }
  :host .quality-review-detail dl > div {
    border-right: 0;
    border-bottom: 1px solid #e2e7e0;
  }
  :host .quality-review-detail dl > div:last-child {
    border-bottom: 0;
  }
  :host .quality-filter-tabs {
    overflow-x: auto;
  }
  :host .quality-proposal-tabs {
    grid-template-columns: repeat(2, minmax(210px, 1fr));
    overflow-x: auto;
    padding: 11px 12px;
  }
  :host .quality-proposal-tabs button {
    min-width: 210px;
  }
  :host .quality-feedback-panel ol {
    grid-template-columns: 1fr;
    padding: 12px;
  }
  :host .quality-submitted-survey {
    grid-template-columns: 1fr;
  }
  :host .quality-submitted-survey > header,
  :host .quality-review-detail > header {
    align-items: flex-start;
    flex-direction: column;
  }
  :host .quality-review-result {
    width: 100%;
    justify-content: flex-start;
  }
  :host .quality-survey-response-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host .quality-survey-issue-grid,
  :host .quality-review-detail section.quality-survey-comments {
    grid-template-columns: 1fr;
  }
  :host .quality-survey-comments article {
    min-height: auto;
    border-right: 0;
    border-bottom: 1px solid #e5e9e3;
  }
  :host .quality-survey-comments article:last-child {
    border-bottom: 0;
  }
  :host .quality-regression-grid ul {
    grid-template-columns: 1fr;
  }
  :host .quality-version-history > div {
    grid-template-columns: 1fr;
  }
  :host .quality-version-history > div > section {
    border-right: 0;
    border-bottom: 1px solid #e7ebe5;
  }
}
.review-workspace {
  --review-ink: #221815;
  --review-muted: #77716b;
  --review-subtle: #9a948c;
  --review-line: #d5d3cc;
  --review-line-soft: #e6e3dc;
  --review-canvas: var(--ro-canvas, #fafbf8);
  --review-primary: #4b672a;
  --review-primary-dark: #3d5028;
  --review-primary-soft: #f0f5e9;
  --review-orange: #a94f1d;
  --review-orange-soft: #fff3ea;
  --review-gold: #c47a12;
  --review-gold-soft: #fff7e3;
  --review-teal: #356b65;
  --review-teal-soft: #edf5f3;
  --review-violet: #665184;
  --review-violet-soft: #f3eff8;
  --review-danger: #a13f36;
  --review-danger-soft: #fff1ef;
  min-height: 100%;
  color: var(--review-ink);
  background: radial-gradient(circle at 15% 0%, rgba(75, 103, 42, 0.09), transparent 25rem), var(--review-canvas);
}

.section-kicker,
.metric-label {
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  line-height: 1.2;
  text-transform: uppercase;
}

.metric-value {
  margin-top: 7px;
  color: var(--review-ink);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.metric-meta {
  margin-top: 4px;
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 600;
}

.lineage-track {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr) 20px) minmax(0, 1fr);
  align-items: stretch;
}

.lineage-node {
  position: relative;
  min-height: 78px;
  padding: 12px;
  border: 1px solid var(--review-line-soft);
  border-radius: 12px;
  background: #fafaf7;
}

.lineage-node > span {
  display: block;
  color: var(--review-primary);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
}

.lineage-node strong,
.lineage-node small {
  display: block;
}

.lineage-node strong {
  margin-top: 6px;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.lineage-node small {
  margin-top: 4px;
  overflow: hidden;
  color: var(--review-muted);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lineage-arrow {
  display: grid;
  place-items: center;
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
}

.pipeline-track {
  display: grid;
  grid-template-columns: repeat(7, minmax(145px, 1fr));
  gap: 12px;
}

.pipeline-step {
  position: relative;
  display: flex;
  min-height: 132px;
  flex-direction: column;
  align-items: flex-start;
  padding: 15px;
  overflow: visible;
  border: 1px solid var(--review-line-soft);
  background: #fff;
  text-align: left;
  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.pipeline-step:not(:last-child)::after {
  position: absolute;
  z-index: 2;
  top: 50%;
  right: -13px;
  width: 13px;
  border-top: 1px solid var(--review-line);
  content: "";
}

.pipeline-step:hover,
.pipeline-step.is-selected {
  border-color: #d6a27e;
  box-shadow: 0 8px 22px rgba(169, 79, 29, 0.1);
  transform: translateY(-1px);
}

.pipeline-step.is-selected {
  outline: 2px solid rgba(169, 79, 29, 0.13);
}

.pipeline-step .step-index {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  background: #f0efeb;
  color: var(--review-muted);
}

.pipeline-step .step-code {
  margin-top: 12px;
  color: var(--review-subtle);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  letter-spacing: 0.1em;
}

.pipeline-step strong,
.pipeline-step small {
  display: block;
}

.pipeline-step strong {
  margin-top: 5px;
  color: var(--review-ink);
}

.pipeline-step small {
  margin-top: auto;
  color: var(--review-subtle);
}

.pipeline-step.is-complete .step-index {
  background: var(--review-primary-soft);
  color: var(--review-primary);
}

.pipeline-step.is-active {
  border-color: #d69468;
  background: linear-gradient(145deg, var(--review-orange-soft), #fff 70%);
}

.pipeline-step.is-active .step-index {
  background: var(--review-orange);
  color: #fff;
  box-shadow: 0 0 0 5px rgba(169, 79, 29, 0.11);
}

.pipeline-step.is-active small {
  color: var(--review-orange);
}

.pipeline-step.is-conditional .step-index {
  background: var(--review-gold-soft);
  color: var(--review-gold);
}

.pipeline-step.is-pending {
  background: #fafaf7;
}

.loop-map {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) 20px minmax(180px, 1fr) 20px minmax(180px, 1fr) 20px minmax(180px, 1fr);
  gap: 8px;
  align-items: stretch;
}

.loop-outcome,
.loop-action,
.loop-pass {
  min-height: 60px;
  padding: 11px 13px;
  border-radius: 11px;
}

.loop-outcome span,
.loop-action span,
.loop-pass span,
.loop-outcome strong,
.loop-action strong,
.loop-pass strong {
  display: block;
}

.loop-outcome span,
.loop-action span,
.loop-pass span {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.loop-outcome strong,
.loop-action strong,
.loop-pass strong {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 700;
}

.loop-outcome.is-fail {
  border: 1px solid #e3b7b1;
  background: var(--review-danger-soft);
  color: var(--review-danger);
}

.loop-outcome.is-next {
  border: 1px solid #e4c28e;
  background: var(--review-gold-soft);
  color: #98600e;
}

.loop-action {
  border: 1px solid var(--review-line-soft);
  background: #fff;
  color: var(--review-ink);
}

.feedback-mark {
  color: var(--review-orange);
}

.version-mark {
  color: var(--review-violet);
}

.loop-arrow {
  display: grid;
  place-items: center;
  color: var(--review-subtle);
  font-weight: 700;
}

.loop-pass {
  grid-column: 1/-1;
  display: flex;
  min-height: auto;
  align-items: center;
  gap: 12px;
  border: 1px solid #c8d6b5;
  background: var(--review-primary-soft);
  color: var(--review-primary);
}

.loop-pass strong {
  margin-top: 0;
}

.score-button {
  display: grid;
  min-height: 54px;
  place-items: center;
  padding: 7px 4px;
  border: 1px solid var(--review-line-soft);
  background: #fafaf7;
  color: var(--review-muted);
  transition: all 140ms ease;
}

.score-button strong,
.score-button small {
  display: block;
}

.score-button small {
  min-height: 12px;
  margin-top: 2px;
}

.score-button:focus-visible,
.choice-button:focus-visible {
  outline: 2px solid var(--review-primary);
  outline-offset: 2px;
}

.score-button:hover,
.score-button.is-picked,
.choice-button.is-picked {
  border-color: var(--review-violet);
  background: var(--review-violet-soft);
  color: var(--review-violet);
  box-shadow: inset 0 0 0 1px var(--review-violet);
}

.choice-button {
  min-height: 42px;
  border: 1px solid var(--review-line-soft);
  background: #fafaf7;
  color: var(--review-muted);
  transition: all 140ms ease;
}

.pipeline-scroll,
main,
nav {
  scrollbar-color: var(--review-line) transparent;
  scrollbar-width: thin;
}

/* Keep Tailwind utility colors inside this page aligned with the product palette. */
.review-workspace .bg-blue-700,
.review-workspace .bg-blue-600 {
  background-color: var(--review-primary) !important;
}
.review-workspace .bg-blue-500 {
  background-color: var(--review-orange) !important;
}
.review-workspace .bg-blue-50,
.review-workspace .bg-blue-50\/50,
.review-workspace .bg-blue-50\/40 {
  background-color: var(--review-primary-soft) !important;
}
.review-workspace .text-blue-600,
.review-workspace .text-blue-700,
.review-workspace .text-blue-800 {
  color: var(--review-primary) !important;
}
.review-workspace .text-blue-950 {
  color: #31441f !important;
}
.review-workspace .border-blue-200,
.review-workspace .border-blue-300,
.review-workspace .border-blue-700 {
  border-color: #bdccaa !important;
}
.review-workspace .ring-blue-200 {
  --tw-ring-color: #bdccaa !important;
}
.review-workspace .hover\:bg-blue-800:hover {
  background-color: var(--review-primary-dark) !important;
}
.review-workspace .hover\:text-blue-700:hover {
  color: var(--review-primary) !important;
}
.review-workspace .focus\:border-blue-400:focus {
  border-color: var(--review-violet) !important;
}
.review-workspace .focus\:ring-blue-100:focus {
  --tw-ring-color: rgba(102, 81, 132, 0.18) !important;
}
.review-workspace .bg-slate-950 {
  background-color: var(--review-primary-dark) !important;
}
.review-workspace .bg-slate-50,
.review-workspace .bg-slate-100 {
  background-color: #f4f3ef !important;
}
.review-workspace .bg-slate-200 {
  background-color: #e2e0da !important;
}
.review-workspace .border-slate-100,
.review-workspace .border-slate-200,
.review-workspace .border-slate-300 {
  border-color: var(--review-line-soft) !important;
}
.review-workspace .text-slate-950,
.review-workspace .text-slate-900,
.review-workspace .text-slate-800 {
  color: var(--review-ink) !important;
}
.review-workspace .text-slate-700,
.review-workspace .text-slate-600,
.review-workspace .text-slate-500 {
  color: var(--review-muted) !important;
}
.review-workspace .text-slate-400 {
  color: var(--review-subtle) !important;
}
.review-workspace .bg-emerald-50 {
  background-color: var(--review-primary-soft) !important;
}
.review-workspace .text-emerald-700 {
  color: var(--review-primary) !important;
}
.review-workspace .bg-amber-50,
.review-workspace .bg-amber-50\/70 {
  background-color: var(--review-gold-soft) !important;
}
.review-workspace .text-amber-700,
.review-workspace .text-amber-800,
.review-workspace .text-amber-900 {
  color: #8a590f !important;
}
.review-workspace .ring-amber-200 {
  --tw-ring-color: #e4c28e !important;
}
.review-workspace .bg-rose-50 {
  background-color: var(--review-danger-soft) !important;
}
.review-workspace .text-rose-600,
.review-workspace .text-rose-700 {
  color: var(--review-danger) !important;
}
.review-workspace .ring-emerald-200 {
  --tw-ring-color: #c8d6b5 !important;
}
.review-workspace .ring-rose-200 {
  --tw-ring-color: #e3b7b1 !important;
}
.review-workspace .ring-slate-200 {
  --tw-ring-color: var(--review-line) !important;
}
.review-workspace .bg-sky-400 {
  background-color: #c9dd7d !important;
  box-shadow: 0 0 0 4px rgba(201, 221, 125, 0.14) !important;
}
.review-workspace .divide-slate-100 > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--review-line-soft) !important;
}
.review-workspace .placeholder\:text-slate-400::placeholder {
  color: var(--review-subtle) !important;
}
.review-workspace .hover\:bg-slate-50:hover {
  background-color: #f4f3ef !important;
}
.review-workspace .hover\:bg-slate-800:hover {
  background-color: #2f3e20 !important;
}
.review-workspace .disabled\:bg-slate-100:disabled,
.review-workspace .disabled\:bg-slate-200:disabled {
  background-color: #e2e0da !important;
}
.review-workspace .disabled\:text-slate-400:disabled {
  color: var(--review-subtle) !important;
}
.review-workspace .bg-slate-950\/55 {
  background-color: rgba(34, 24, 21, 0.58) !important;
}

.review-status--success,
.review-check--success {
  color: var(--review-primary) !important;
  background: var(--review-primary-soft) !important;
  --tw-ring-color: #c8d6b5 !important;
}

.review-status--active {
  color: var(--review-orange) !important;
  background: var(--review-orange-soft) !important;
  --tw-ring-color: #e2b697 !important;
}

.review-status--ai {
  color: var(--review-teal) !important;
  background: var(--review-teal-soft) !important;
  --tw-ring-color: #b9d0cc !important;
}

.review-status--human {
  color: var(--review-violet) !important;
  background: var(--review-violet-soft) !important;
  --tw-ring-color: #cfc3dd !important;
}

.review-status--warning,
.review-check--warning {
  color: #8a590f !important;
  background: var(--review-gold-soft) !important;
  --tw-ring-color: #e4c28e !important;
}

.review-status--danger,
.review-check--danger {
  color: var(--review-danger) !important;
  background: var(--review-danger-soft) !important;
  --tw-ring-color: #e3b7b1 !important;
}

.review-status--neutral,
.review-check--neutral {
  color: var(--review-muted) !important;
  background: #f0efeb !important;
  --tw-ring-color: var(--review-line) !important;
}

.human-review-panel {
  border-color: #cfc3dd !important;
  background: var(--review-violet-soft) !important;
}
.human-review-panel .bg-blue-700,
.human-review-panel .bg-blue-600,
.human-review-panel .bg-blue-500 {
  background-color: var(--review-violet) !important;
}
.human-review-panel .bg-blue-50 {
  background-color: #faf8fc !important;
}
.human-review-panel .text-blue-600,
.human-review-panel .text-blue-700,
.human-review-panel .text-blue-800,
.human-review-panel .text-blue-950 {
  color: var(--review-violet) !important;
}
.human-review-panel .border-blue-200,
.human-review-panel .border-blue-300 {
  border-color: #cfc3dd !important;
}
.human-review-panel .ring-blue-200 {
  --tw-ring-color: #cfc3dd !important;
}

@media (max-width: 767px) {
  .loop-map {
    grid-template-columns: 1fr;
  }
  .loop-arrow {
    min-height: 14px;
    transform: rotate(90deg);
  }
  .loop-pass {
    grid-column: auto;
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
}
/* Process tab: keep the current action visible and move audit detail behind disclosure. */
.process-history-panel,
.process-progress-panel {
  overflow: hidden;
  border: 1px solid var(--review-line-soft);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(34, 24, 21, 0.045);
}

.process-history-panel > summary,
.process-progress-panel__details > summary {
  cursor: pointer;
  list-style: none;
}

.process-history-panel > summary::-webkit-details-marker,
.process-progress-panel__details > summary::-webkit-details-marker {
  display: none;
}

.process-history-panel > summary {
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 11px 16px;
}

.process-history-panel__title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}

.process-history-panel__icon {
  width: 34px;
  height: 34px;
  display: inline-grid;
  flex: 0 0 34px;
  place-items: center;
  color: var(--review-primary);
  border-radius: 9px;
  background: var(--review-primary-soft);
}

.process-history-panel__title strong,
.process-history-panel__title small {
  display: block;
}

.process-history-panel__title strong {
  color: var(--review-ink);
  font-size: 13px;
  font-weight: 700;
}

.process-history-panel__title small {
  margin-top: 3px;
  color: var(--review-muted);
  font-size: 12px;
}

.process-history-panel__chevron,
.process-progress-panel__details > summary i:last-child {
  color: var(--review-muted);
  font-size: 12px;
  transition: transform 140ms ease;
}

.process-history-panel[open] .process-history-panel__chevron,
.process-progress-panel__details[open] > summary i:last-child {
  transform: rotate(180deg);
}

.process-history-panel__body {
  padding: 14px 16px 16px;
  border-top: 1px solid var(--review-line-soft);
  background: #fafaf7;
}

.process-history-panel__body > p {
  margin: 0 0 12px;
  color: var(--review-muted);
  font-size: 12px;
}

.process-history-panel__scroll {
  overflow-x: auto;
  padding-bottom: 2px;
}

.process-progress-panel__summary {
  min-height: 92px;
  display: grid;
  grid-template-columns: 112px minmax(220px, 1fr) 180px;
  align-items: center;
  gap: 18px;
  padding: 16px 18px;
}

.process-progress-panel__current span,
.process-progress-panel__next span,
.process-progress-panel__main small {
  display: block;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.process-progress-panel__current strong {
  display: block;
  margin-top: 4px;
  color: var(--review-primary);
  font-size: 18px;
  font-weight: 700;
}

.process-progress-panel__main > div {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.process-progress-panel__main strong,
.process-progress-panel__next strong {
  color: var(--review-ink);
  font-size: 14px;
  font-weight: 700;
}

.process-progress-panel__main progress {
  display: block;
  width: 100%;
  height: 7px;
  margin-top: 10px;
  overflow: hidden;
  border: 0;
  border-radius: 999px;
  background: #e5e4df;
  accent-color: var(--review-primary);
}

.process-progress-panel__main progress::-webkit-progress-bar {
  background: #e5e4df;
}

.process-progress-panel__main progress::-webkit-progress-value,
.process-progress-panel__main progress::-moz-progress-bar {
  background: var(--review-primary);
}

.process-progress-panel__next {
  padding-left: 18px;
  border-left: 1px solid var(--review-line-soft);
}

.process-progress-panel__next strong {
  display: block;
  margin-top: 4px;
}

.process-progress-panel__details {
  border-top: 1px solid var(--review-line-soft);
}

.process-progress-panel__details > summary {
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  padding: 8px 18px;
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
  background: #fafaf7;
}

.process-progress-panel__details .pipeline-scroll {
  overflow-x: auto;
  padding: 18px;
  border-top: 1px solid var(--review-line-soft);
}

.process-failure-loop,
.process-pass-result {
  padding: 14px 18px;
  border-top: 1px solid var(--review-line-soft);
  background: #fafaf7;
}

.process-pass-result {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--review-primary);
  font-size: 12px;
}

@media (max-width: 760px) {
  .process-progress-panel__summary {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .process-progress-panel__next {
    padding: 12px 0 0;
    border-top: 1px solid var(--review-line-soft);
    border-left: 0;
  }
}
/* Dataset workbench ------------------------------------------------------- */
.dataset-builder {
  --dataset-qa: #356b65;
  --dataset-qa-soft: #edf5f3;
  --dataset-kg: #4b672a;
  --dataset-kg-soft: #f0f5e9;
  --dataset-current: #a94f1d;
  --dataset-current-soft: #fff3ea;
  display: grid;
  gap: 16px;
  min-height: auto;
  color: var(--review-ink);
  background: transparent;
}

.dataset-builder__heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 4px 2px 2px;
}

.dataset-builder__eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.dataset-builder__eyebrow i {
  width: 3px;
  height: 3px;
  border-radius: 999px;
  background: var(--review-line);
}

.dataset-builder__eyebrow strong {
  color: var(--review-orange);
}

.dataset-builder__heading h2 {
  margin: 7px 0 0;
  color: var(--review-ink);
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.dataset-builder__heading p {
  margin: 7px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.55;
}

.dataset-builder__mode {
  min-width: 210px;
  padding: 11px 14px;
  border: 1px solid #c7d3b8;
  border-radius: 11px;
  background: var(--review-primary-soft);
}

.dataset-builder__mode span,
.dataset-builder__mode strong {
  display: block;
}

.dataset-builder__mode span {
  color: var(--review-primary);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.dataset-builder__mode strong {
  margin-top: 4px;
  color: #40552a;
  font-size: 12px;
}

.dataset-builder__mode.is-draft {
  border-color: #e4c28e;
  background: var(--review-gold-soft);
}

.dataset-builder__mode.is-draft span,
.dataset-builder__mode.is-draft strong {
  color: #8a590f;
}

.dataset-stepper {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  padding: 0;
  margin: 0;
  overflow: hidden;
  border: 1px solid var(--review-line);
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(34, 24, 21, 0.045);
  list-style: none;
}

.dataset-stepper li {
  min-width: 0;
}

.dataset-step {
  position: relative;
  width: 100%;
  min-height: 78px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 24px 13px 15px;
  border: 0;
  border-right: 1px solid var(--review-line-soft);
  background: #fff;
  color: var(--review-muted);
  cursor: pointer;
  text-align: left;
  transition: background 160ms ease, box-shadow 160ms ease;
}

.dataset-stepper li:last-child .dataset-step {
  border-right: 0;
}

.dataset-step:hover {
  background: #fafaf7;
}

.dataset-step.is-current {
  z-index: 1;
  background: var(--dataset-current-soft);
  box-shadow: inset 0 -3px 0 var(--dataset-current);
}

.dataset-step__number {
  width: 29px;
  height: 29px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 9px;
  background: #efeee9;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.dataset-step.is-complete .dataset-step__number {
  background: var(--review-primary-soft);
  color: var(--review-primary);
}

.dataset-step.is-current .dataset-step__number {
  background: var(--dataset-current);
  color: #fff;
  box-shadow: 0 0 0 4px rgba(169, 79, 29, 0.11);
}

.dataset-step__copy {
  min-width: 0;
}

.dataset-step__copy em,
.dataset-step__copy strong,
.dataset-step__copy small {
  display: block;
}

.dataset-step__copy em {
  color: var(--review-subtle);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.dataset-step__copy strong {
  margin-top: 4px;
  overflow: hidden;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-step__copy small {
  margin-top: 3px;
  overflow: hidden;
  color: var(--review-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-step__arrow {
  position: absolute;
  right: 8px;
  color: var(--review-line);
  font-size: 12px;
}

.dataset-connection {
  display: grid;
  grid-template-columns: minmax(220px, auto) auto minmax(260px, 1fr);
  align-items: center;
  gap: 16px;
  padding: 11px 14px;
  border: 1px solid #d8d1ba;
  border-radius: 12px;
  background: linear-gradient(90deg, #fffaf0, #fff 65%);
}

.dataset-connection__state {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dataset-connection__dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: var(--review-primary);
  box-shadow: 0 0 0 4px rgba(75, 103, 42, 0.12);
}

.dataset-connection strong,
.dataset-connection small {
  display: block;
}

.dataset-connection__state strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-connection__state small {
  margin-top: 3px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-connection__contract {
  padding: 6px 10px;
  border-left: 1px solid #e4c28e;
}

.dataset-connection__contract span {
  display: block;
  color: var(--review-gold);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.dataset-connection__contract strong {
  margin-top: 3px;
  color: #8a590f;
  font-size: 12px;
}

.dataset-connection > p {
  margin: 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.5;
}

.dataset-summary {
  min-height: 78px;
}

.dataset-summary .ops-summary__icon {
  color: var(--review-primary);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
}

.dataset-stat--qa {
  --stat-color: var(--dataset-qa);
}

.dataset-stat--kg {
  --stat-color: var(--dataset-kg);
}

.dataset-stage {
  display: grid;
  gap: 14px;
}

.dataset-stage__header {
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 17px;
  border: 1px solid var(--review-line);
  border-radius: 14px;
  background: #fff;
}

.dataset-stage__title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dataset-stage__title > span {
  width: 34px;
  height: 34px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 10px;
  background: var(--dataset-current);
  color: #fff;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
}

.dataset-stage__title strong,
.dataset-stage__title p {
  display: block;
}

.dataset-stage__title strong {
  color: var(--review-ink);
  font-size: 13px;
  font-weight: 700;
}

.dataset-stage__title p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.45;
}

.dataset-stage__status {
  max-width: 380px;
  padding: 6px 9px;
  overflow: hidden;
  border-radius: 7px;
  background: #f0efeb;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-stage__status.is-complete {
  color: var(--review-primary);
  background: var(--review-primary-soft);
}

.dataset-stage__status.is-waiting {
  color: #8a590f;
  background: var(--review-gold-soft);
}

.dataset-source-layout,
.dataset-snapshot-layout,
.dataset-preflight-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  gap: 14px;
  align-items: start;
}

.dataset-material-panel,
.dataset-selection-panel,
.dataset-scope-panel,
.dataset-chunk-panel,
.dataset-checkpoint-panel,
.dataset-snapshot-card,
.dataset-output-card,
.dataset-common-config,
.dataset-preflight-panel,
.dataset-recipe-panel,
.dataset-artifact-card,
.dataset-graph-preview {
  border-color: var(--review-line);
  box-shadow: 0 8px 24px rgba(34, 24, 21, 0.045);
}

.dataset-material-panel {
  min-width: 0;
}

.dataset-toolbar-title strong,
.dataset-toolbar-title small {
  display: block;
}

.dataset-toolbar-title strong {
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.dataset-toolbar-title small {
  margin-top: 3px;
  color: var(--review-subtle);
  font-size: 12px;
}

.dataset-search__mark {
  width: 16px;
  height: 16px;
  display: inline-grid;
  flex: 0 0 16px;
  place-items: center;
  color: #858078;
  font-size: 12px;
  line-height: 1;
}

.dataset-search > button i {
  font-size: 12px;
  line-height: 1;
}

.dataset-lock-note {
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
}

.dataset-material-list {
  display: grid;
}

.dataset-material-row {
  display: grid;
  grid-template-columns: 28px minmax(220px, 1fr) 190px minmax(150px, 0.8fr) 58px;
  align-items: center;
  gap: 12px;
  min-height: 66px;
  padding: 10px 16px;
  border: 0;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fff;
  color: var(--review-ink);
  cursor: pointer;
  text-align: left;
  transition: background 150ms ease, box-shadow 150ms ease;
}

.dataset-material-row:last-child {
  border-bottom: 0;
}

.dataset-material-row:hover {
  background: #fafaf7;
}

.dataset-material-row.is-selected {
  background: var(--review-primary-soft);
  box-shadow: inset 3px 0 0 var(--review-primary);
}

.dataset-material-check {
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border: 1px solid var(--review-line);
  border-radius: 6px;
  background: #fff;
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
}

.dataset-material-row.is-selected .dataset-material-check {
  border-color: var(--review-primary);
}

.dataset-material-main {
  min-width: 0;
}

.dataset-material-main strong,
.dataset-material-main code,
.dataset-material-availability strong,
.dataset-material-availability small {
  display: block;
}

.dataset-material-main strong {
  overflow: hidden;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-material-main code {
  margin-top: 4px;
  overflow: hidden;
  color: var(--review-muted);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-material-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.dataset-material-meta span,
.dataset-material-action {
  padding: 4px 6px;
  border-radius: 6px;
  background: #f0efeb;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.dataset-material-availability strong {
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-material-availability small {
  margin-top: 3px;
  color: var(--review-subtle);
  font-size: 12px;
}

.dataset-material-row.is-selected .dataset-material-action {
  color: var(--review-primary);
  background: #e3ecd8;
}

.dataset-empty {
  padding: 36px 20px;
  text-align: center;
}

.dataset-empty strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-empty p {
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-empty--compact {
  padding: 22px 14px;
}

.dataset-panel-heading {
  min-height: 61px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 15px;
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-panel-heading span,
.dataset-panel-heading strong,
.dataset-panel-heading small {
  display: block;
}

.dataset-panel-heading span {
  color: var(--review-orange);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.dataset-panel-heading strong {
  margin-top: 4px;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.dataset-panel-heading small {
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-selection-count {
  width: 27px;
  height: 27px;
  display: grid !important;
  place-items: center;
  border-radius: 8px;
  background: var(--review-primary-soft);
  color: var(--review-primary) !important;
  font-size: 12px !important;
}

.dataset-selected-list {
  display: grid;
  gap: 7px;
  padding: 12px;
}

.dataset-selected-list article {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  border: 1px solid #d2ddc4;
  border-radius: 9px;
  background: var(--review-primary-soft);
}

.dataset-selected-list strong,
.dataset-selected-list code {
  display: block;
}

.dataset-selected-list strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-selected-list code {
  margin-top: 3px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-selected-list article > span {
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
}

.dataset-selection-meta,
.dataset-snapshot-card dl,
.dataset-recipe-panel dl {
  margin: 0;
  padding: 4px 14px;
}

.dataset-selection-meta > div,
.dataset-snapshot-card dl > div,
.dataset-recipe-panel dl > div {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 0;
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-selection-meta > div:last-child,
.dataset-snapshot-card dl > div:last-child,
.dataset-recipe-panel dl > div:last-child {
  border-bottom: 0;
}

.dataset-selection-meta dt,
.dataset-snapshot-card dt,
.dataset-recipe-panel dt {
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
}

.dataset-selection-meta dd,
.dataset-snapshot-card dd,
.dataset-recipe-panel dd {
  margin: 0;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.dataset-panel-note,
.dataset-backend-notice {
  margin: 10px 12px 12px;
  padding: 10px 11px;
  border: 1px solid #cbd8bc;
  border-radius: 9px;
  background: var(--review-primary-soft);
}

.dataset-panel-note strong,
.dataset-panel-note p,
.dataset-backend-notice strong,
.dataset-backend-notice p {
  display: block;
}

.dataset-panel-note strong {
  color: var(--review-primary);
  font-size: 12px;
}

.dataset-panel-note p,
.dataset-backend-notice p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.5;
}

.dataset-panel-note--warning,
.dataset-backend-notice {
  border-color: #e4c28e;
  background: var(--review-gold-soft);
}

.dataset-panel-note--warning strong,
.dataset-backend-notice strong {
  color: #8a590f;
  font-size: 12px;
}

.dataset-stage__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 2px 0;
}

.dataset-button {
  min-height: 39px;
  padding: 0 14px;
  cursor: pointer;
  transition: background 150ms ease, transform 150ms ease, box-shadow 150ms ease;
}

.dataset-button--secondary {
  border: 1px solid var(--review-line);
  background: #fff;
  color: var(--review-muted);
}

.dataset-button--primary {
  border: 1px solid var(--review-primary);
  background: var(--review-primary);
  color: #fff;
  box-shadow: 0 7px 18px rgba(75, 103, 42, 0.16);
}

.dataset-button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.dataset-button--primary:hover:not(:disabled) {
  background: var(--review-primary-dark);
}

.dataset-button:disabled {
  cursor: not-allowed;
  opacity: 0.46;
}

.dataset-snapshot-main {
  display: grid;
  gap: 14px;
}

.dataset-scope-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
  padding: 13px;
}

.dataset-scope-options button {
  min-height: 91px;
  padding: 12px;
  border: 1px solid var(--review-line-soft);
  background: #fafaf7;
  cursor: pointer;
  text-align: left;
}

.dataset-scope-options button.is-selected {
  border-color: var(--review-orange);
  background: var(--review-orange-soft);
  box-shadow: inset 0 0 0 1px var(--review-orange);
}

.dataset-scope-options button:disabled {
  cursor: default;
}

.dataset-scope-options span,
.dataset-scope-options strong,
.dataset-scope-options small {
  display: block;
}

.dataset-scope-options span {
  color: var(--review-orange);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
}

.dataset-scope-options strong {
  margin-top: 8px;
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-scope-options small {
  margin-top: 4px;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.4;
}

.dataset-chunk-list {
  display: grid;
  gap: 8px;
  padding: 12px;
}

.dataset-chunk-list label {
  display: grid;
  grid-template-columns: 23px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 11px;
  border: 1px solid var(--review-line-soft);
  border-radius: 10px;
  background: #fafaf7;
}

.dataset-chunk-list label.is-selected {
  border-color: #c6d5b4;
  background: var(--review-primary-soft);
}

.dataset-chunk-list input {
  position: absolute;
  opacity: 0;
}

.dataset-chunk-check {
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border: 1px solid var(--review-line);
  border-radius: 6px;
  background: #fff;
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
}

.dataset-chunk-list strong,
.dataset-chunk-list p,
.dataset-chunk-list code {
  display: block;
}

.dataset-chunk-list strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-chunk-list p {
  margin: 3px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-chunk-list code {
  max-width: 560px;
  margin-top: 4px;
  overflow: hidden;
  color: var(--review-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-chunk-list em {
  padding: 5px 7px;
  border-radius: 6px;
  background: #fff;
  color: var(--review-primary);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.dataset-range-placeholder,
.dataset-result-empty {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px;
}

.dataset-range-placeholder > span,
.dataset-result-empty > span {
  width: 40px;
  height: 40px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 11px;
  background: #f0efeb;
  color: var(--review-muted);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
}

.dataset-range-placeholder strong,
.dataset-result-empty strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-range-placeholder p,
.dataset-result-empty p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.5;
}

.dataset-checklist,
.dataset-preflight-list {
  padding: 8px 13px 13px;
  margin: 0;
  list-style: none;
}

.dataset-checklist li,
.dataset-preflight-list li {
  display: grid;
  grid-template-columns: 27px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-checklist li:last-child,
.dataset-preflight-list li:last-child {
  border-bottom: 0;
}

.dataset-checklist li > span,
.dataset-preflight-list li > span {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.dataset-checklist strong,
.dataset-checklist small,
.dataset-preflight-list strong,
.dataset-preflight-list small {
  display: block;
}

.dataset-checklist strong,
.dataset-preflight-list strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-checklist small,
.dataset-preflight-list small {
  margin-top: 3px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-checklist .is-pass > span,
.dataset-preflight-list .is-ready > span {
  background: var(--review-primary-soft);
  color: var(--review-primary);
}

.dataset-checklist .is-wait > span,
.dataset-preflight-list .is-pending > span {
  background: var(--review-gold-soft);
  color: #8a590f;
}

.dataset-preflight-list .is-blocked > span {
  background: var(--review-danger-soft);
  color: var(--review-danger);
}

.dataset-preflight-list em {
  padding: 4px 6px;
  border-radius: 5px;
  background: #f0efeb;
  color: var(--review-muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.dataset-preflight-list .is-ready em {
  color: var(--review-primary);
  background: var(--review-primary-soft);
}

.dataset-preflight-list .is-pending em {
  color: #8a590f;
  background: var(--review-gold-soft);
}

.dataset-lock-icon,
.dataset-recipe-id {
  padding: 5px 7px;
  border-radius: 6px;
  background: #f0efeb;
  color: var(--review-muted) !important;
  font-size: 12px !important;
}

.dataset-config-grid,
.dataset-result-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.dataset-output-card {
  overflow: hidden;
}

.dataset-output-card > header,
.dataset-artifact-card > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 15px;
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-output-card > header > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dataset-output-card > header > div > span {
  width: 33px;
  height: 33px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
}

.dataset-output-card--qa > header > div > span {
  color: var(--dataset-qa);
  background: var(--dataset-qa-soft);
}

.dataset-output-card--kg > header > div > span {
  color: var(--dataset-kg);
  background: var(--dataset-kg-soft);
}

.dataset-output-card header strong,
.dataset-output-card header p {
  display: block;
}

.dataset-output-card header strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-output-card header p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-output-card--qa.is-enabled {
  border-top: 3px solid var(--dataset-qa);
}

.dataset-output-card--kg.is-enabled {
  border-top: 3px solid var(--dataset-kg);
}

.dataset-output-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 14px;
}

.dataset-output-fields.is-disabled {
  opacity: 0.48;
}

.dataset-output-fields label,
.dataset-common-grid > label {
  position: relative;
}

.dataset-output-fields label > span,
.dataset-common-grid > label > span {
  display: block;
  margin-bottom: 5px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.dataset-output-fields input,
.dataset-output-fields select,
.dataset-common-grid input,
.dataset-common-grid select {
  width: 100%;
  height: 37px;
  padding: 0 9px;
  border: 1px solid var(--review-line);
  border-radius: 8px;
  outline: 0;
  background: #fff;
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-output-fields input:focus,
.dataset-output-fields select:focus,
.dataset-common-grid input:focus,
.dataset-common-grid select:focus {
  border-color: var(--review-orange);
  box-shadow: 0 0 0 3px rgba(169, 79, 29, 0.11);
}

.dataset-output-fields label > small {
  position: absolute;
  right: 9px;
  bottom: 12px;
  color: var(--review-subtle);
  font-size: 12px;
}

.dataset-field--wide {
  grid-column: span 2;
}

.dataset-output-card > footer {
  min-height: 53px;
  padding: 11px 14px;
  border-top: 1px solid var(--review-line-soft);
  background: #fafaf7;
}

.dataset-output-card > footer > span,
.dataset-output-card > footer > strong {
  display: block;
}

.dataset-output-card > footer > span {
  color: var(--review-subtle);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.09em;
}

.dataset-output-card > footer > strong {
  margin-top: 4px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-relation-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 6px;
}

.dataset-relation-tags em {
  padding: 4px 6px;
  border-radius: 5px;
  background: var(--review-primary-soft);
  color: var(--review-primary);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.dataset-common-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
  padding: 14px;
}

.dataset-inline-check {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  min-height: 57px;
  padding: 8px 10px;
  border: 1px solid var(--review-line-soft);
  border-radius: 9px;
  background: #fafaf7;
}

.dataset-inline-check input {
  position: absolute;
  opacity: 0;
}

.dataset-inline-check > span {
  width: 18px;
  height: 18px;
  margin: 0 !important;
  border: 1px solid var(--review-line);
  border-radius: 5px;
  background: #fff;
}

.dataset-inline-check input:checked + span {
  border-color: var(--review-primary);
  background: var(--review-primary);
  box-shadow: inset 0 0 0 4px #fff;
}

.dataset-inline-check strong,
.dataset-inline-check small {
  display: block;
}

.dataset-inline-check strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-inline-check small {
  margin-top: 3px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-result-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
  padding: 18px;
  border: 1px solid #c7d3b8;
  border-radius: 14px;
  background: linear-gradient(105deg, var(--review-primary-soft), #fff 72%);
}

.dataset-result-hero.is-pending {
  border-color: #e4c28e;
  background: linear-gradient(105deg, var(--review-gold-soft), #fff 72%);
}

.dataset-result-hero span,
.dataset-result-hero strong,
.dataset-result-hero p {
  display: block;
}

.dataset-result-hero > div:first-child > span {
  color: var(--review-primary);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.11em;
}

.dataset-result-hero.is-pending > div:first-child > span {
  color: #8a590f;
}

.dataset-result-hero > div:first-child > strong {
  margin-top: 5px;
  color: var(--review-ink);
  font-size: 13px;
}

.dataset-result-hero p {
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-result-progress {
  min-width: 150px;
  text-align: right;
}

.dataset-result-progress strong {
  color: var(--review-primary);
  font-size: 22px;
  font-weight: 700;
}

.dataset-result-progress > span {
  width: 150px;
  height: 6px;
  margin-top: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #e3e1dc;
}

.dataset-result-progress i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--review-primary);
}

.dataset-artifact-card {
  overflow: hidden;
}

.dataset-artifact-card--qa {
  border-top: 3px solid var(--dataset-qa);
}

.dataset-artifact-card--kg {
  border-top: 3px solid var(--dataset-kg);
}

.dataset-artifact-card header span,
.dataset-artifact-card header strong {
  display: block;
}

.dataset-artifact-card header span {
  color: var(--review-subtle);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.dataset-artifact-card header strong {
  margin-top: 4px;
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-artifact-card header em {
  padding: 5px 7px;
  border-radius: 6px;
  background: #f0efeb;
  color: var(--review-muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.dataset-artifact-card header em.is-complete {
  color: var(--review-primary);
  background: var(--review-primary-soft);
}

.dataset-artifact-stats {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-artifact-stats > div {
  padding: 12px 10px;
  border-right: 1px solid var(--review-line-soft);
}

.dataset-artifact-stats > div:last-child {
  border-right: 0;
}

.dataset-artifact-stats span,
.dataset-artifact-stats strong {
  display: block;
  text-align: center;
}

.dataset-artifact-stats span {
  color: var(--review-subtle);
  font-size: 12px;
}

.dataset-artifact-stats strong {
  margin-top: 4px;
  color: var(--review-ink);
  font-size: 13px;
  font-weight: 700;
}

.dataset-artifact-body {
  min-height: 71px;
  padding: 13px 15px;
}

.dataset-artifact-body strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-artifact-body p {
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.5;
}

.dataset-preview-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  background: var(--review-line-soft);
}

.dataset-preview-columns > div {
  padding: 14px;
  background: #fff;
}

.dataset-preview-columns p {
  margin: 0 0 8px;
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
}

.dataset-preview-columns ul {
  display: grid;
  gap: 6px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.dataset-preview-columns li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 9px;
  border-radius: 8px;
  background: #f7f7f3;
}

.dataset-preview-columns li span {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  margin-top: 3px;
  border-radius: 999px;
  background: var(--review-orange);
}

.dataset-preview-columns li strong {
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.dataset-result-empty {
  border: 1px dashed #d7b778;
  border-radius: 12px;
  background: var(--review-gold-soft);
}

.dataset-result-empty > span {
  color: #8a590f;
  background: #fff;
}

@media (max-width: 1180px) {
  .dataset-step__copy small {
    display: none;
  }
  .dataset-source-layout,
  .dataset-snapshot-layout,
  .dataset-preflight-layout {
    grid-template-columns: 1fr;
  }
  .dataset-selection-panel,
  .dataset-snapshot-card,
  .dataset-recipe-panel {
    order: -1;
  }
  .dataset-common-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 900px) {
  .dataset-stepper {
    grid-template-columns: 1fr;
    overflow: visible;
  }
  .dataset-step {
    min-height: 60px;
    border-right: 0;
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-stepper li:last-child .dataset-step {
    border-bottom: 0;
  }
  .dataset-step__copy small {
    display: block;
  }
  .dataset-connection {
    grid-template-columns: 1fr auto;
  }
  .dataset-connection > p {
    grid-column: 1/-1;
  }
  .dataset-summary {
    grid-template-columns: 1fr;
  }
  .dataset-summary .ops-summary__intro {
    min-height: 70px;
    border-right: 0;
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-material-row {
    grid-template-columns: 28px minmax(0, 1fr) auto;
  }
  .dataset-material-meta,
  .dataset-material-availability {
    grid-column: 2/-1;
  }
  .dataset-material-action {
    grid-column: 3;
    grid-row: 1;
  }
  .dataset-config-grid,
  .dataset-result-grid {
    grid-template-columns: 1fr;
  }
  .dataset-common-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
/* Knowledge graph source snapshot modal */
.kg-result-source-row {
  width: 100%;
  min-height: 46px;
  display: grid;
  grid-template-columns: 110px minmax(180px, 1.4fr) minmax(120px, 1fr) 110px 130px 44px;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  color: #4d5652;
  background: #fff;
  border-top: 1px solid #edf0f1;
  text-align: left;
  transition: background 140ms ease;
}

.kg-result-source-row:hover {
  background: #f7faf8;
}

.kg-result-source-row > span,
.kg-result-source-row > strong {
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-result-source-row > button {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  justify-self: center;
  padding: 0;
  color: #1f654e;
  background: transparent;
  border: 0;
  cursor: pointer;
  transition: color 140ms ease, background 140ms ease;
}

.kg-result-source-row > button:hover,
.kg-result-source-row > button:focus-visible {
  color: #fff;
  background: #286650;
  outline: 0;
}

.kg-source-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 240;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(24, 31, 28, 0.56);
  backdrop-filter: blur(5px);
}

.kg-source-modal {
  width: min(980px, 100vw - 48px);
  max-height: min(820px, 100vh - 48px);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  color: #26302c;
  background: #fff;
  border: 1px solid #d8dfdb;
  border-radius: 12px;
  box-shadow: 0 28px 80px rgba(14, 24, 20, 0.26);
}

.kg-source-modal__header {
  min-height: 86px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 22px;
  border-bottom: 1px solid #e2e6e3;
}

.kg-source-modal__header > div {
  min-width: 0;
}

.kg-source-modal__header span,
.kg-source-modal__evidence > header span {
  color: #2f7259;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.kg-source-modal__header h2 {
  margin: 5px 0 0;
  color: #222925;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.kg-source-modal__header p {
  margin: 5px 0 0;
  color: #7c8580;
  font-size: 12px;
  font-weight: 700;
}

.kg-source-modal__header > button {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  color: #5f6964;
  background: #f3f5f4;
  border: 0;
  cursor: pointer;
}

.kg-source-modal__header > button:hover {
  color: #fff;
  background: #315f4d;
}

.kg-source-modal__body {
  overflow-y: auto;
  padding: 20px 22px 24px;
  background: #f7f8f5;
}

.kg-source-modal__overview {
  display: grid;
  grid-template-columns: minmax(240px, 0.8fr) minmax(0, 1.2fr);
  gap: 24px;
  padding: 18px;
  background: #fff;
  border: 1px solid #e0e5e1;
  border-radius: 9px;
}

.kg-source-modal__identity {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding-right: 20px;
  border-right: 1px solid #e5e9e6;
}

.kg-source-modal__identity > span {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  flex: 0 0 42px;
  color: #477252;
  background: #edf4e9;
  border-radius: 9px;
}

.kg-source-modal__identity small,
.kg-source-modal__identity strong,
.kg-source-modal__identity p {
  display: block;
}

.kg-source-modal__identity small {
  color: #7b857f;
  font-size: 12px;
  font-weight: 700;
}

.kg-source-modal__identity strong {
  margin-top: 5px;
  color: #2a332e;
  font-size: 14px;
  font-weight: 700;
}

.kg-source-modal__identity p {
  margin: 6px 0 0;
  color: #7c8580;
  font-size: 12px;
  line-height: 1.5;
}

.kg-source-modal__overview dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 22px;
  margin: 0;
}

.kg-source-modal__overview dl > div {
  min-height: 45px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #edf0ee;
}

.kg-source-modal__overview dt,
.kg-source-modal__overview dd {
  margin: 0;
  font-size: 12px;
}

.kg-source-modal__overview dt {
  color: #838b87;
  font-weight: 700;
}

.kg-source-modal__overview dd {
  overflow: hidden;
  color: #39443e;
  font-weight: 700;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-source-modal__metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 12px;
}

.kg-source-modal__metrics article {
  min-width: 0;
  padding: 14px 15px;
  background: #fff;
  border: 1px solid #e0e5e1;
  border-radius: 8px;
}

.kg-source-modal__metrics small,
.kg-source-modal__metrics strong,
.kg-source-modal__metrics span {
  display: block;
}

.kg-source-modal__metrics small {
  color: #7f8983;
  font-size: 12px;
  font-weight: 700;
}

.kg-source-modal__metrics strong {
  margin-top: 6px;
  overflow: hidden;
  color: #26322c;
  font-size: 14px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-source-modal__metrics span {
  margin-top: 4px;
  color: #959c98;
  font-size: 12px;
}

.kg-source-modal__evidence {
  margin-top: 12px;
  padding: 18px;
  background: #fff;
  border: 1px solid #e0e5e1;
  border-radius: 9px;
}

.kg-source-modal__evidence > header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.kg-source-modal__evidence h3 {
  margin: 4px 0 0;
  color: #27312c;
  font-size: 14px;
  font-weight: 700;
}

.kg-source-modal__evidence > header em {
  min-width: 28px;
  height: 24px;
  display: grid;
  place-items: center;
  color: #356a55;
  background: #edf5f1;
  border-radius: 999px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.kg-source-modal__evidence article {
  margin-top: 14px;
  padding: 14px 16px;
  background: #fafbf9;
  border-left: 3px solid #659176;
}

.kg-source-modal__evidence article > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.kg-source-modal__evidence article strong {
  color: #344139;
  font-size: 12px;
  font-weight: 700;
}

.kg-source-modal__evidence article span {
  color: #89928d;
  font-size: 12px;
  font-weight: 700;
}

.kg-source-modal__evidence blockquote,
.kg-source-modal__evidence article p {
  margin: 10px 0 0;
  color: #4e5953;
  font-size: 12px;
  line-height: 1.7;
}

.kg-source-modal__empty {
  min-height: 118px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 14px;
  color: #87908b;
  background: #fafbf9;
  text-align: center;
}

.kg-source-modal__empty i {
  margin-bottom: 3px;
  color: #91a199;
  font-size: 18px;
}

.kg-source-modal__empty strong {
  color: #59645f;
  font-size: 12px;
}

.kg-source-modal__empty p {
  margin: 0;
  font-size: 12px;
}

.kg-source-modal__footer {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e2e6e3;
  background: #fff;
}

.kg-source-modal__footer button {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 16px;
  color: #55605a;
  background: #fff;
  border: 1px solid #d7ddd9;
  cursor: pointer;
}

.kg-source-modal__footer button.is-primary {
  color: #fff;
  background: #286650;
  border-color: #286650;
}

.qa-result-source-link {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
  color: inherit;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
}

.qa-result-source-link > strong {
  text-decoration: underline;
  text-decoration-color: transparent;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  transition: color 140ms ease, text-decoration-color 140ms ease;
}

.qa-result-source-link > i {
  color: #658277;
  font-size: 12px;
  transition: color 140ms ease, transform 140ms ease;
}

.qa-result-source-link:hover > strong,
.qa-result-source-link:focus-visible > strong {
  color: #1f654e;
  text-decoration-color: currentColor;
}

.qa-result-source-link:hover > i,
.qa-result-source-link:focus-visible > i {
  color: #1f654e;
  transform: translate(1px, -1px);
}

.qa-result-source-link:focus-visible {
  outline: 2px solid rgba(40, 102, 80, 0.28);
  outline-offset: 3px;
}

.qa-source-modal__evidence article h4 {
  margin: 10px 0 0;
  color: #28332e;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.55;
}

.qa-source-modal__evidence .qa-source-modal__answer {
  display: flex;
  gap: 8px;
  margin-top: 7px;
  color: #59645f;
}

.qa-source-modal__answer b {
  flex: 0 0 auto;
  color: #9a6239;
  font-size: 12px;
}

.qa-source-modal__original {
  margin-top: 10px;
}

.qa-source-modal__original > span {
  color: #42685e;
  font-size: 12px;
  font-weight: 700;
}

.qa-source-modal__original > small {
  margin-left: 8px;
  color: #73867e;
  font-size: 12px;
  font-weight: 700;
}

.qa-source-modal__original blockquote {
  margin-top: 6px;
}

.qa-source-modal__modern {
  margin-top: 8px;
  padding: 10px 12px;
  border-left: 3px solid #c4975f;
  border-radius: 0 7px 7px 0;
  background: #fffaf2;
}

.qa-source-modal__modern > span {
  color: #7a5a38;
  font-size: 12px;
  font-weight: 700;
}

.qa-source-modal__modern > small {
  margin-left: 8px;
  color: #9a8163;
  font-size: 12px;
  font-weight: 700;
}

.qa-source-modal__modern p {
  margin: 6px 0 0;
  color: #594a3d;
  line-height: 1.65;
}

.qa-result-overview {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  overflow: hidden;
  background: #fff;
  border: 1px solid #d9e2de;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(44, 67, 58, 0.045);
}

.qa-result-overview__metrics {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.qa-result-overview__metrics article {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 17px 15px;
  border-right: 1px solid #e7ebe8;
  border-bottom: 0;
}

.qa-result-overview__metrics article:last-child {
  border-right: 0;
}

.qa-result-overview__metrics article.is-gate {
  grid-column: auto;
}

.qa-result-overview__metrics article > span {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  flex: 0 0 36px;
  color: #356d5f;
  background: #edf4f1;
  border-radius: 9px;
}

.qa-result-overview__metrics article > span.is-edge {
  color: #9b5b37;
  background: #faf1ea;
}

.qa-result-overview__metrics article > span.is-validation {
  color: #806d3d;
  background: #f8f4e8;
}

.qa-result-overview__metrics small,
.qa-result-overview__metrics strong,
.qa-result-overview__metrics p {
  display: block;
}

.qa-result-overview__metrics small {
  color: #7c8781;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-overview__metrics strong {
  margin-top: 3px;
  color: #26312c;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.1;
}

.qa-result-overview__metrics strong.is-text {
  font-size: 12px;
}

.qa-result-overview__metrics p {
  margin: 4px 0 0;
  color: #929a96;
  font-size: 12px;
}

.qa-result-card__regenerate {
  min-width: 76px;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 10px;
  color: #315f58;
  background: #fff;
  border: 1px solid #bfcfc8;
  cursor: pointer;
}

.qa-result-card__regenerate:hover:not(:disabled) {
  color: #fff;
  background: #315f58;
  border-color: #315f58;
}

.qa-result-card__regenerate:disabled {
  color: #aeb5b1;
  background: #f6f7f6;
  border-color: #e1e5e2;
  cursor: wait;
}

@media (max-width: 700px) {
  .qa-result-overview__metrics {
    grid-template-columns: 1fr 1fr;
  }
  .qa-result-overview__metrics article,
  .qa-result-overview__metrics article:nth-child(3),
  .qa-result-overview__metrics article:nth-child(n+4) {
    border-right: 1px solid #e7ebe8;
    border-bottom: 1px solid #e7ebe8;
  }
  .qa-result-overview__metrics article:nth-child(2n),
  .qa-result-overview__metrics article:last-child {
    border-right: 0;
  }
  .qa-result-overview__metrics article.is-gate {
    grid-column: 1/-1;
    border-bottom: 0;
  }
}
@media (max-width: 760px) {
  .kg-result-source-ledger {
    overflow-x: auto;
  }
  .kg-result-source-ledger > header,
  .kg-result-source-row {
    min-width: 760px;
  }
  .kg-source-modal-backdrop {
    padding: 12px;
  }
  .kg-source-modal {
    width: calc(100vw - 24px);
    max-height: calc(100vh - 24px);
  }
  .kg-source-modal__body {
    padding: 14px;
  }
  .kg-source-modal__overview {
    grid-template-columns: 1fr;
  }
  .kg-source-modal__identity {
    padding: 0 0 16px;
    border-right: 0;
    border-bottom: 1px solid #e5e9e6;
  }
  .kg-source-modal__overview dl,
  .kg-source-modal__metrics {
    grid-template-columns: 1fr;
  }
}
/* Project settings — compact control surface */
:host .project-output-settings:has(> .project-output-settings__grid--split) {
  display: block;
  min-height: 0;
  padding: 16px 0 32px;
}

:host .project-output-settings__grid--split,
:host .project-output-settings__grid--split.is-single {
  width: min(100%, 1260px);
  min-height: 0;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-areas: "summary summary" "qa kg";
  gap: 16px;
  overflow: visible;
  background: transparent;
  border: 0;
  border-radius: 0 !important;
  box-shadow: none;
}

:host .project-output-settings__grid--split .project-output-settings__summary {
  grid-area: summary;
  min-height: 122px;
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  align-items: center;
  gap: 28px;
  padding: 20px 24px;
  background: #ffffff;
  border: 0;
  border-radius: 6px !important;
  box-shadow: inset 0 0 0 1px #e1e4e8, 0 8px 24px rgba(24, 28, 35, 0.045);
}

:host .project-output-settings__grid--split .project-output-settings__summary-status {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr);
  grid-template-rows: auto auto auto;
  align-items: center;
  gap: 2px 14px;
  padding: 0;
  text-align: left;
}

:host .project-output-settings__grid--split .project-output-settings__summary-icon {
  grid-column: 1;
  grid-row: 1/4;
  width: 48px;
  height: 48px;
  margin: 0;
  color: #ffffff;
  background: #282c31;
  border-radius: 50%;
  box-shadow: none;
  font-size: 19px;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status strong {
  grid-column: 2;
  grid-row: 1;
  color: #20242a;
  font-size: 22px;
  line-height: 1;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status b {
  grid-column: 2;
  grid-row: 2;
  margin: 2px 0 0;
  color: #20242a;
  font-size: 13px;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status p {
  grid-column: 2;
  grid-row: 3;
  margin: 2px 0 0;
  color: #747b84;
  font-size: 12px;
  line-height: 1.45;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details {
  min-width: 0;
  padding: 0;
  border: 0;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details h3 {
  margin: 0 0 10px;
  color: #69717b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dl {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dl > div {
  min-width: 0;
  padding: 10px 12px;
  background: #f6f7f8;
  border-radius: 4px;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dt {
  gap: 6px;
  color: #7b828b;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dt i {
  width: 12px;
  color: #4b525a;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dd {
  margin: 5px 0 0;
  color: #24282e;
  font-size: 12px;
  line-height: 1.3;
}

:host .project-output-settings__grid--split .project-output-card,
:host .project-output-settings__grid--split.is-single .project-output-card,
:host .project-output-settings__grid--split.is-single .project-output-card.is-kg {
  grid-column: auto;
  grid-row: auto;
  grid-area: qa;
  min-width: 0;
  min-height: 0;
  height: auto;
  background: #ffffff;
  border: 0;
  border-radius: 6px !important;
  box-shadow: inset 0 3px 0 #d94d1f, inset 0 0 0 1px #e1e4e8, 0 10px 28px rgba(24, 28, 35, 0.05);
}

:host .project-output-settings__grid--split .project-output-card.is-kg {
  grid-area: kg;
  box-shadow: inset 0 3px 0 #1f6a62, inset 0 0 0 1px #e1e4e8, 0 10px 28px rgba(24, 28, 35, 0.05);
}

:host .project-output-settings__grid--split.is-single .project-output-card,
:host .project-output-settings__grid--split.is-single .project-output-card.is-kg {
  grid-column: 1/-1;
  grid-area: auto;
}

:host .project-output-settings__grid--split .project-output-card:hover,
:host .project-output-settings__grid--split .project-output-card:focus-visible {
  transform: none;
  box-shadow: inset 0 3px 0 #d94d1f, inset 0 0 0 2px rgba(217, 77, 31, 0.2), 0 12px 30px rgba(24, 28, 35, 0.07);
}

:host .project-output-settings__grid--split .project-output-card.is-kg:hover,
:host .project-output-settings__grid--split .project-output-card.is-kg:focus-visible {
  box-shadow: inset 0 3px 0 #1f6a62, inset 0 0 0 2px rgba(31, 106, 98, 0.2), 0 12px 30px rgba(24, 28, 35, 0.07);
}

:host .project-output-settings__grid--split .project-output-card__header {
  min-height: 86px;
  padding: 20px 22px 16px;
  background: transparent;
  border: 0;
  border-radius: 0 !important;
  box-shadow: inset 0 -1px 0 #e7e9ec;
}

:host .project-output-settings__grid--split .project-output-card__identity {
  gap: 13px;
}

:host .project-output-settings__grid--split .project-output-card__code {
  width: 44px;
  height: 44px;
  flex-basis: 44px;
  border-radius: 4px;
  box-shadow: none;
  font-size: 14px;
}

:host .project-output-settings__grid--split .project-output-card__identity strong {
  font-size: 16px;
}

:host .project-output-settings__grid--split .project-output-card__identity p {
  margin-top: 4px;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-card__status,
:host .project-output-settings__grid--split .project-output-card__settings {
  min-height: 32px;
  padding: 0 10px;
  border-radius: 4px;
}

:host .project-output-settings__grid--split .project-output-card__body {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 18px 20px 20px;
}

:host .project-output-settings__grid--split .project-output-card__section {
  min-width: 0;
  padding: 16px;
  background: #f8f9fa;
  border: 0;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px #eaeced;
}

:host .project-output-settings__grid--split .project-output-card__section--output,
:host .project-output-settings__grid--split .project-output-card__actions {
  grid-column: 1/-1;
}

:host .project-output-settings__grid--split .project-output-card__section--output {
  padding: 14px 16px;
}

:host .project-output-settings__grid--split .project-output-card__section-title {
  margin: 0 0 10px;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-card__checklist {
  gap: 4px;
}

:host .project-output-settings__grid--split .project-output-card__checklist li {
  grid-template-columns: 22px minmax(78px, 0.8fr) minmax(0, 1.2fr);
  gap: 7px;
  min-height: 36px;
  padding: 2px 0;
}

:host .project-output-settings__grid--split .project-output-card__item-icon {
  width: 22px;
  height: 22px;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-card__item-label {
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-card__item-value {
  padding: 6px 8px;
  background: #ffffff;
  border-radius: 3px;
  box-shadow: inset 0 0 0 1px #eceef0;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-card__actions {
  margin: 0;
  padding: 2px 0 0;
  border: 0;
}

:host .project-output-settings__grid--split .project-output-card__cta {
  min-height: 50px;
  border-radius: 4px !important;
  font-size: 13px;
}

@media (max-width: 1180px) {
  :host .project-output-settings__grid--split .project-output-settings__summary {
    grid-template-columns: 230px minmax(0, 1fr);
    gap: 20px;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host .project-output-settings__grid--split .project-output-card__body {
    grid-template-columns: 1fr;
  }
  :host .project-output-settings__grid--split .project-output-card__section--output,
  :host .project-output-settings__grid--split .project-output-card__actions {
    grid-column: auto;
  }
}
@media (max-width: 900px) {
  :host .project-output-settings__grid--split,
  :host .project-output-settings__grid--split.is-single {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: "summary" "qa" "kg";
  }
  :host .project-output-settings__grid--split .project-output-settings__summary {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 20px;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host .project-output-settings__grid--split .project-output-card,
  :host .project-output-settings__grid--split .project-output-card.is-kg {
    min-height: 0;
  }
}
@media (max-width: 600px) {
  :host .project-output-settings__grid--split .project-output-card__header {
    align-items: flex-start;
    gap: 14px;
    padding: 18px 16px 14px;
  }
  :host .project-output-settings__grid--split .project-output-card__header-actions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  :host .project-output-settings__grid--split .project-output-card__body {
    padding: 14px 16px 16px;
  }
}
@media (max-width: 640px) {
  .dataset-builder__heading,
  .dataset-stage__header,
  .dataset-result-hero {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-builder__mode,
  .dataset-stage__status {
    width: 100%;
    max-width: none;
  }
  .dataset-connection {
    grid-template-columns: 1fr;
  }
  .dataset-connection__contract,
  .dataset-connection > p {
    grid-column: auto;
  }
  .dataset-connection__contract {
    padding-left: 0;
    border-left: 0;
    border-top: 1px solid #e4c28e;
    padding-top: 9px;
  }
  .dataset-summary .ops-summary__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataset-summary .ops-stat {
    min-height: 72px;
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-stage__title {
    align-items: flex-start;
  }
  .dataset-stage__actions {
    display: grid;
    grid-template-columns: 1fr;
  }
  .dataset-button {
    width: 100%;
  }
  .dataset-scope-options,
  .dataset-output-fields,
  .dataset-common-grid,
  .dataset-preview-columns {
    grid-template-columns: 1fr;
  }
  .dataset-field--wide {
    grid-column: auto;
  }
  .dataset-artifact-stats {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .dataset-artifact-stats > div {
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-result-progress,
  .dataset-result-progress > span {
    width: 100%;
  }
}
@media (max-width: 900px) {
  :host .qa-generation-v2__toolbar-actions {
    width: 100%;
    justify-content: stretch;
  }
  :host .qa-generation-v2__toolbar-actions button {
    flex: 1 1 0;
  }
}
@media (max-width: 540px) {
  :host .qa-generation-v2__toolbar-actions {
    flex-direction: column;
  }
  :host .qa-generation-v2__toolbar-actions button {
    width: 100%;
  }
}
/* Focused QA generation progress dialog */
.qa-generation-v2__progress button {
  min-height: 32px;
  padding: 0 11px;
  color: #315f52;
  background: #ffffff;
  border: 1px solid #cad6ce;
  cursor: pointer;
}

.qa-generation-v2__progress button:hover,
.qa-generation-v2__progress button:focus-visible {
  color: #244e43;
  border-color: #708c7c;
  outline: 0;
}

.qa-generation-running-backdrop {
  position: fixed;
  inset: 0;
  z-index: 90;
  display: grid;
  width: 100vw;
  height: 100dvh;
  place-items: center;
  padding: 24px;
  overflow-y: auto;
  box-sizing: border-box;
  background: rgba(35, 39, 36, 0.52);
  backdrop-filter: blur(7px);
  animation: qa-generation-backdrop-in 180ms ease-out both;
}

.qa-generation-running-dialog {
  width: min(620px, 100vw - 32px);
  max-height: calc(100dvh - 48px);
  overflow: hidden;
  color: #29312c;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 16px;
  box-shadow: 0 28px 70px rgba(20, 26, 21, 0.28);
  animation: qa-generation-dialog-in 240ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.qa-generation-running-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 24px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e2e6df;
}

.qa-generation-running-dialog__heading {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  min-width: 0;
}

.qa-generation-running-dialog__icon {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: grid;
  place-items: center;
  margin: 0;
  color: #d9502c;
  background: #fff1eb;
  border: 1px solid #f3d8cc;
  border-radius: 11px;
  font-size: 16px;
}

.qa-generation-running-dialog__heading > div {
  min-width: 0;
}

.qa-generation-running-dialog__heading p {
  margin: 0 0 5px;
  color: #d9502c;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.qa-generation-running-dialog__heading h2 {
  margin: 0;
  color: #252b27;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.035em;
}

.qa-generation-running-dialog__heading > div > span {
  display: block;
  margin-top: 7px;
  color: #717a73;
  font-size: 12px;
  line-height: 1.55;
}

.qa-generation-running-dialog__minimize {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: grid;
  place-items: center;
  padding: 0;
  color: #667068;
  background: #f5f6f3;
  border: 1px solid #e1e6de;
  cursor: pointer;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.qa-generation-running-dialog__minimize:hover,
.qa-generation-running-dialog__minimize:focus-visible {
  color: #2f6254;
  background: #e5ece6;
  border-color: #c8d5cb;
  outline: 0;
}

.qa-generation-running-dialog__body {
  padding: 20px 24px 22px;
  background: #fafbf8;
}

.qa-generation-running-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  margin: 0 0 18px;
  padding: 0;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #dfe4dd;
  border-radius: 11px;
  list-style: none;
}

.qa-generation-running-steps li {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  min-height: 62px;
  padding: 10px 12px;
  color: #929a93;
  background: #ffffff;
  border: 0;
  border-right: 1px solid #e5e8e3;
  border-radius: 0;
}

.qa-generation-running-steps li:last-child {
  border-right: 0;
}

.qa-generation-running-steps__marker {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: #818982;
  background: #ffffff;
  border: 1px solid #d8ddd8;
  border-radius: 50%;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.qa-generation-running-steps li strong,
.qa-generation-running-steps li small {
  display: block;
  white-space: nowrap;
}

.qa-generation-running-steps li strong {
  color: currentColor;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-running-steps li small {
  margin-top: 3px;
  font-size: 12px;
}

.qa-generation-running-steps li.is-complete {
  color: #397060;
  background: #f3f7f2;
  border-color: #d4e1d6;
}

.qa-generation-running-steps li.is-complete .qa-generation-running-steps__marker {
  color: #ffffff;
  background: #397060;
  border-color: #397060;
}

.qa-generation-running-steps li.is-active {
  color: #a64126;
  background: #fff5f0;
  box-shadow: inset 0 -2px 0 #d9502c;
}

.qa-generation-running-steps li.is-active strong {
  color: #7d341f;
}

.qa-generation-running-steps li.is-active .qa-generation-running-steps__marker {
  color: #d9502c;
  background: #fffaf7;
  border-color: #e5a18c;
}

.qa-generation-running-dialog__status {
  padding: 17px 18px 16px;
  background: #ffffff;
  border: 1px solid #dfe4dd;
  border-radius: 12px !important;
}

:host-context(.reviewops-shell) .qa-generation-running-dialog .qa-generation-running-dialog__status {
  border-radius: 12px !important;
}

.qa-generation-running-dialog__progress {
  width: 100%;
  height: 7px;
  display: block;
  overflow: hidden;
  accent-color: #d9502c;
  border: 0;
  border-radius: 999px;
  background: #e1e6e0;
  appearance: none;
}

.qa-generation-running-dialog__progress::-webkit-progress-bar {
  background: #e1e6e0;
  border-radius: 999px;
}

.qa-generation-running-dialog__progress::-webkit-progress-value {
  background: #d9502c !important;
  border-radius: 999px;
}

.qa-generation-running-dialog__progress::-moz-progress-bar {
  background: #d9502c !important;
  border-radius: 999px;
}

.qa-generation-running-dialog__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 13px;
}

.qa-generation-running-dialog__summary > div {
  min-width: 0;
}

.qa-generation-running-dialog__summary span {
  display: block;
  margin-bottom: 3px;
  color: #818982;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-running-dialog__summary strong {
  display: block;
  color: #2d5146;
  font-size: 13px;
  font-weight: 700;
}

.qa-generation-running-dialog__summary em {
  flex: 0 0 auto;
  min-width: 62px;
  padding: 6px 9px;
  color: #356b5c;
  background: #e8f0e9;
  border-radius: 999px;
  font-style: normal;
  text-align: right;
}

.qa-generation-running-dialog__summary em b,
.qa-generation-running-dialog__summary em small {
  display: block;
}

.qa-generation-running-dialog__summary em b {
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-running-dialog__summary em small {
  margin-top: 1px;
  color: #6e8177;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-running-dialog__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 9px;
  color: #7c857e;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-running-dialog__meta span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #55675e;
}

.qa-generation-running-dialog__timing {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 13px;
}

.qa-generation-running-dialog__timing > span {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: 8px;
  padding: 10px 11px;
  color: #617068;
  background: #f8faf7;
  border: 1px solid #e0e5df;
  border-radius: 9px;
}

.qa-generation-running-dialog__timing i {
  grid-row: 1/3;
  align-self: center;
  color: #4f786a;
  font-size: 12px;
}

.qa-generation-running-dialog__timing small,
.qa-generation-running-dialog__timing strong {
  display: block;
}

.qa-generation-running-dialog__timing small {
  color: #8a928c;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-running-dialog__timing strong {
  margin-top: 2px;
  color: #30483f;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-running-dialog__notice {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 14px 0 0;
  padding: 11px 13px;
  color: #69736c;
  background: #f1f4ef;
  border: 0;
  border-radius: 10px;
  font-size: 12px;
  line-height: 1.55;
}

.qa-generation-running-dialog__notice i {
  color: #718b7b;
}

@keyframes qa-generation-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes qa-generation-dialog-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 560px) {
  .qa-generation-running-backdrop {
    place-items: center;
    padding: 12px;
  }
  .qa-generation-running-dialog {
    width: 100%;
    max-height: calc(100dvh - 24px);
    border-radius: 18px;
  }
  .qa-generation-running-dialog__header {
    padding: 20px;
  }
  .qa-generation-running-dialog__heading h2 {
    font-size: 18px;
  }
  .qa-generation-running-dialog__body {
    padding: 18px 20px 20px;
  }
  .qa-generation-running-steps {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .qa-generation-running-steps li {
    min-height: 54px;
    padding: 9px 11px;
    border-right: 0;
    border-bottom: 1px solid #e5e8e3;
  }
  .qa-generation-running-steps li:last-child {
    border-bottom: 0;
  }
  .qa-generation-running-dialog__meta {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }
  .qa-generation-running-dialog__timing {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (prefers-reduced-motion: reduce) {
  .qa-generation-running-backdrop,
  .qa-generation-running-dialog {
    animation: none;
  }
}
/* QA generation v2: configured-source review and direct generation */
:host .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

main.is-qa-generation-main {
  background: #f6f7f3;
}

main.is-qa-generation-main .project-output-settings,
main.is-qa-generation-main .project-output-workspace {
  min-height: 0;
}

.qa-generation-v2 {
  --qa-green: #2f6f61;
  --qa-green-dark: #24594f;
  --qa-orange: #e6532e;
  --qa-ink: #202622;
  --qa-muted: #687168;
  --qa-line: #dfe4dc;
  display: grid;
  gap: 16px;
  max-width: 1540px;
  margin: 0 auto;
  color: var(--qa-ink);
}

.qa-generation-v2 button,
.qa-generation-v2 a,
.qa-generation-v2 input,
.qa-generation-v2 select {
  font: inherit;
}

.qa-generation-v2 button,
.qa-generation-v2 a {
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.qa-generation-v2 button:focus-visible,
.qa-generation-v2 a:focus-visible,
.qa-generation-v2 input:focus-visible,
.qa-generation-v2 select:focus-visible {
  outline: 3px solid rgba(47, 111, 97, 0.18);
  outline-offset: 2px;
}

.qa-generation-v2__toolbar {
  min-height: 84px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 22px;
  background: #fff;
  border: 1px solid var(--qa-line);
  border-radius: 8px;
}

.qa-generation-v2__heading {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 14px;
}

.qa-generation-v2__back {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: grid;
  place-items: center;
  color: #4d574f;
  background: #f8f9f6;
  border: 1px solid #dce2da;
  border-radius: 7px;
  text-decoration: none;
}

.qa-generation-v2__back:hover {
  color: var(--qa-green-dark);
  background: #eef5f0;
  border-color: #aabfb5;
}

.qa-generation-v2__heading > div {
  min-width: 0;
}

.qa-generation-v2__heading span,
.qa-generation-v2__section-header span,
.qa-generation-v2__versioning-header > div > span,
.qa-generation-v2__review-panel header span {
  display: block;
  margin-bottom: 3px;
  color: #dc5a38;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.qa-generation-v2__heading h2 {
  margin: 0;
  color: #1d231f;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.qa-generation-v2__heading p {
  margin: 4px 0 0;
  color: #778078;
  font-size: 12px;
}

.qa-generation-v2__settings-button,
.qa-generation-v2__refresh {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 14px;
  color: #4a544c;
  background: #fff;
  border: 1px solid #d6ddd5;
  cursor: pointer;
}

.qa-generation-v2__settings-button:hover,
.qa-generation-v2__refresh:hover:not(:disabled) {
  color: var(--qa-green-dark);
  background: #f3f7f3;
  border-color: #b7c8bd;
}

.qa-generation-v2__setup {
  min-height: 360px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
  padding: 36px;
  background: #fff;
  border: 1px solid var(--qa-line);
  border-radius: 8px;
}

.qa-generation-v2__setup > span {
  width: 52px;
  height: 52px;
  display: grid;
  place-items: center;
  color: var(--qa-green);
  background: #edf4ef;
  border-radius: 8px;
}

.qa-generation-v2__setup h3,
.qa-generation-v2__setup p {
  margin: 0;
}

.qa-generation-v2__setup h3 {
  font-size: 17px;
  font-weight: 700;
}

.qa-generation-v2__setup p {
  margin-top: 6px;
  color: var(--qa-muted);
  font-size: 12px;
}

.qa-generation-v2__setup button {
  min-height: 42px;
  padding: 0 18px;
  color: #fff;
  background: var(--qa-green);
  border: 0;
  cursor: pointer;
}

.qa-generation-v2__overview {
  display: grid;
  grid-template-columns: minmax(300px, 1.8fr) repeat(3, minmax(150px, 1fr));
  background: #fff;
  border: 1px solid var(--qa-line);
  border-radius: 8px;
  overflow: hidden;
}

.qa-generation-v2__overview-card {
  min-width: 0;
  min-height: 118px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 22px;
  border-left: 1px solid #e7ebe5;
}

.qa-generation-v2__overview-card.is-source {
  position: relative;
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  align-content: center;
  gap: 12px;
  border-left: 0;
}

.qa-generation-v2__overview-icon {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  color: var(--qa-green);
  background: #edf4ef;
  border-radius: 7px;
}

.qa-generation-v2__overview-card small {
  display: block;
  color: #7a837b;
}

.qa-generation-v2__overview-card strong {
  display: block;
  margin-top: 6px;
  color: #263029;
}

.qa-generation-v2__overview-card strong b {
  color: var(--qa-green-dark);
}

.qa-generation-v2__overview-card strong span {
  margin-left: 4px;
  color: #59645c;
}

.qa-generation-v2__overview-card p {
  margin: 5px 0 0;
  overflow: hidden;
  color: #7c857d;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-generation-v2__overview-card.is-source em {
  position: absolute;
  top: 14px;
  right: 16px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #3c7566;
  font-style: normal;
}

.qa-generation-v2__catalog,
.qa-generation-v2__versioning,
.qa-generation-v2__review-panel,
.qa-generation-v2__message,
.qa-generation-v2__progress {
  background: #fff;
  border: 1px solid var(--qa-line);
  border-radius: 8px;
}

.qa-generation-v2__section-header {
  min-height: 86px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 17px 20px;
  border-bottom: 1px solid #e5e9e3;
}

.qa-generation-v2__section-header h3,
.qa-generation-v2__review-panel h3 {
  margin: 0;
  color: #252c27;
  font-size: 15px;
  font-weight: 700;
}

.qa-generation-v2__section-header p {
  margin: 4px 0 0;
  color: #737c74;
  font-size: 12px;
}

.qa-generation-v2__catalog-tools {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #e7ebe5;
}

.qa-generation-v2__search {
  min-width: 0;
  height: 42px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 44px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #cfd7cf;
  border-radius: 7px;
}

.qa-generation-v2__search:focus-within {
  border-color: #7ca193;
  box-shadow: 0 0 0 3px rgba(47, 111, 97, 0.1);
}

.qa-generation-v2__search input {
  min-width: 0;
  height: 40px;
  padding: 0 14px;
  color: #29312b;
  background: transparent;
  border: 0;
  outline: 0;
  font-size: 12px;
}

.qa-generation-v2__search input::placeholder {
  color: #98a099;
}

.qa-generation-v2__search button {
  width: 44px;
  height: 40px;
  display: grid;
  place-items: center;
  color: var(--qa-green);
  background: #edf4f0;
  border: 0;
  border-left: 1px solid #d5e0d9;
  cursor: pointer;
}

.qa-generation-v2__catalog-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.qa-generation-v2__catalog-actions button {
  min-width: 94px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  color: #586159;
  background: #fff;
  border: 1px solid #d5dcd4;
  cursor: pointer;
}

.qa-generation-v2__catalog-actions button.is-icon {
  min-width: 42px;
  width: 42px;
  padding: 0;
}

.qa-generation-v2__catalog-actions button:hover,
.qa-generation-v2__catalog-actions button.is-active {
  color: var(--qa-green-dark);
  background: #eef5f0;
  border-color: #aebfb4;
}

.qa-generation-v2__catalog-summary {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 0 20px;
  background: #fafbf8;
  border-bottom: 1px solid #e6eae4;
}

.qa-generation-v2__catalog-summary p,
.qa-generation-v2__catalog-summary small {
  margin: 0;
  font-size: 12px;
}

.qa-generation-v2__catalog-summary p {
  color: #6d766e;
}

.qa-generation-v2__catalog-summary strong {
  color: #354139;
  font-weight: 700;
}

.qa-generation-v2__catalog-summary small {
  color: #889087;
}

.qa-generation-v2__state {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 28px;
  color: #5f6c63;
  text-align: left;
}

.qa-generation-v2__state > i {
  color: var(--qa-green);
  font-size: 22px;
}

.qa-generation-v2__state strong,
.qa-generation-v2__state p {
  margin: 0;
}

.qa-generation-v2__state strong {
  color: #303a33;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__state p {
  margin-top: 5px;
  font-size: 12px;
}

.qa-generation-v2__state button {
  min-height: 36px;
  padding: 0 13px;
  color: #a7432c;
  background: #fff8f5;
  border: 1px solid #efb7a8;
  cursor: pointer;
}

.qa-generation-v2__state.is-error > i {
  color: #c85035;
}

.qa-generation-v2__state.is-warning > i {
  color: #a46a21;
}

.qa-generation-v2__table {
  min-width: 0;
}

.qa-generation-v2__table-head,
.qa-generation-v2__table-row {
  display: grid;
  grid-template-columns: 54px minmax(260px, 1.5fr) minmax(120px, 0.7fr) 120px 150px;
  align-items: center;
}

.qa-generation-v2__table-head {
  min-height: 42px;
  color: #687268;
  background: #f5f7f4;
  border-bottom: 1px solid #dfe4de;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__table-head span,
.qa-generation-v2__table-row > span {
  min-width: 0;
  padding: 0 14px;
}

.qa-generation-v2__table-row {
  min-height: 60px;
  color: #59635b;
  border-bottom: 1px solid #e8ebe7;
  font-size: 12px;
}

.qa-generation-v2__table-row:hover {
  background: #fafbf8;
}

.qa-generation-v2__table-row.is-unavailable {
  background: #fcfcfa;
  color: #9a9f9a;
}

.qa-generation-v2__row-number {
  color: #939a93;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.qa-generation-v2__row-title strong,
.qa-generation-v2__row-title small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-generation-v2__row-title strong {
  color: #303832;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__row-title small {
  margin-top: 4px;
  color: #919891;
  font-size: 12px;
}

.qa-generation-v2__chunk {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #9b6c2b;
  font-weight: 700;
}

.qa-generation-v2__chunk.is-ready {
  color: #2c7566;
}

.qa-generation-v2__catalog.is-compact .qa-generation-v2__table-row {
  min-height: 48px;
}

.qa-generation-v2__catalog.is-compact .qa-generation-v2__row-title small {
  display: none;
}

.qa-generation-v2__empty {
  min-height: 180px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 6px;
  color: #8b938b;
  text-align: center;
}

.qa-generation-v2__empty i {
  margin-bottom: 4px;
  font-size: 20px;
}

.qa-generation-v2__empty strong,
.qa-generation-v2__empty p {
  margin: 0;
  font-size: 12px;
}

.qa-generation-v2__pagination {
  min-height: 54px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 16px;
  padding: 0 20px;
  color: #747d75;
  background: #fafbf8;
  font-size: 12px;
}

.qa-generation-v2__pagination nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.qa-generation-v2__pagination nav button {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  color: #526056;
  background: #fff;
  border: 1px solid #d8ded7;
  cursor: pointer;
}

.qa-generation-v2__pagination nav button:disabled {
  color: #bcc2bc;
  background: #f6f7f5;
  cursor: default;
}

.qa-generation-v2__pagination nav strong {
  min-width: 30px;
  color: var(--qa-green-dark);
  text-align: center;
}

.qa-generation-v2__pagination > label {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.qa-generation-v2__pagination select {
  height: 32px;
  padding: 0 26px 0 10px;
  color: #4f5b52;
  background: #fff;
  border: 1px solid #d8ded7;
  border-radius: 6px;
  font-size: 12px;
}

.qa-generation-v2__versioning {
  overflow: hidden;
}

.qa-generation-v2__versioning-header {
  min-height: 92px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
  padding: 20px 22px;
  background: linear-gradient(115deg, #fbfcfa 0%, #f3f7f2 100%);
  border-bottom: 1px solid #dde4dd;
}

.qa-generation-v2__versioning-header h3,
.qa-generation-v2__versioning-header p {
  margin: 0;
}

.qa-generation-v2__versioning-header h3 {
  color: #243029;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.qa-generation-v2__versioning-header p {
  margin-top: 5px;
  color: #6f7971;
  font-size: 12px;
}

.qa-generation-v2__versioning-header > strong {
  min-width: 132px;
  padding: 11px 14px;
  color: var(--qa-green-dark);
  background: #fff;
  border: 1px solid #cfdcd2;
  border-radius: 8px;
  text-align: right;
}

.qa-generation-v2__versioning-header > strong small,
.qa-generation-v2__versioning-header > strong b {
  display: block;
}

.qa-generation-v2__versioning-header > strong small {
  color: #7b867d;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__versioning-header > strong b {
  margin-top: 3px;
  font-size: 13px;
  font-weight: 700;
}

.qa-generation-v2__versioning-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(330px, 0.8fr);
  min-height: 252px;
}

.qa-generation-v2__version-picker {
  padding: 20px 22px;
  border-right: 1px solid #e1e6e0;
}

.qa-generation-v2__version-picker-head {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  margin-bottom: 16px;
}

.qa-generation-v2__version-picker-head > span {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  color: #fff;
  background: var(--qa-green);
  border-radius: 8px;
}

.qa-generation-v2__version-picker-head strong,
.qa-generation-v2__version-picker-head small {
  display: block;
}

.qa-generation-v2__version-picker-head strong {
  color: #303b33;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__version-picker-head small {
  margin-top: 3px;
  color: #818982;
  font-size: 12px;
}

.qa-generation-v2__version-picker-head em {
  padding: 6px 9px;
  color: #2f6f61;
  background: #edf5ef;
  border-radius: 999px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.qa-generation-v2__version-picker-head em.is-neutral {
  color: #727b73;
  background: #f1f3ef;
}

.qa-generation-v2__version-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.qa-generation-v2__version-fields label {
  min-width: 0;
  display: grid;
  gap: 7px;
  padding: 14px;
  background: #fafbf8;
  border: 1px solid #dce3dc;
  border-radius: 8px;
}

.qa-generation-v2__version-fields label > span {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #5a6c5f;
  font-size: 12px;
}

.qa-generation-v2__version-fields label > strong {
  overflow: hidden;
  color: #2e3831;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-generation-v2__version-fields select {
  width: 100%;
  height: 40px;
  padding: 0 34px 0 12px;
  color: #244f45;
  background: #fff;
  border: 1px solid #aebfb4;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.qa-generation-v2__version-fields select:disabled {
  color: #929992;
  background: #f0f2ef;
  cursor: wait;
}

.qa-generation-v2__version-fields label > small {
  color: #858e86;
  font-size: 12px;
}

.qa-generation-v2__version-policy {
  min-height: 46px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  padding: 10px 12px;
  color: #446152;
  background: #eef5ef;
  border-radius: 7px;
}

.qa-generation-v2__version-policy > i {
  color: var(--qa-green);
}

.qa-generation-v2__version-policy strong,
.qa-generation-v2__version-policy small {
  display: block;
}

.qa-generation-v2__version-policy strong {
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__version-policy small {
  margin-top: 2px;
  color: #708078;
  font-size: 12px;
}

.qa-generation-v2__version-history {
  min-width: 0;
  padding: 20px;
  background: #fcfdfb;
}

.qa-generation-v2__version-history > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.qa-generation-v2__version-history > header strong,
.qa-generation-v2__version-history > header small {
  display: block;
}

.qa-generation-v2__version-history > header strong {
  color: #303a33;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__version-history > header small {
  margin-top: 3px;
  color: #858d86;
  font-size: 12px;
}

.qa-generation-v2__version-history > header em {
  color: #52655a;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.qa-generation-v2__version-history ul {
  max-height: 174px;
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
}

.qa-generation-v2__version-history li {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  min-height: 68px;
  padding: 10px 11px;
  border: 1px solid #e1e6e0;
  border-radius: 7px;
}

.qa-generation-v2__version-history li + li {
  margin-top: 8px;
}

.qa-generation-v2__version-history li.is-current {
  background: #f0f6f1;
  border-color: #abc0b2;
}

.qa-generation-v2__history-version {
  display: grid;
  justify-items: center;
  gap: 4px;
  color: #657168;
  font-size: 12px;
}

.qa-generation-v2__version-history li.is-current .qa-generation-v2__history-version {
  color: var(--qa-green);
}

.qa-generation-v2__history-detail {
  min-width: 0;
}

.qa-generation-v2__history-detail strong,
.qa-generation-v2__history-detail small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-generation-v2__history-detail strong {
  color: #364139;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__history-detail small {
  margin-top: 4px;
  color: #838b84;
  font-size: 12px;
}

.qa-generation-v2__version-history li > em {
  padding: 5px 7px;
  color: #747d75;
  background: #f0f2ef;
  border-radius: 999px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.qa-generation-v2__version-history li.is-current > em {
  color: #2f6f61;
  background: #dfece2;
}

.qa-generation-v2__version-empty {
  min-height: 146px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 5px;
  color: #7e8981;
  background: #f7f9f6;
  border: 1px dashed #d5ddd6;
  border-radius: 8px;
  text-align: center;
}

.qa-generation-v2__version-empty i {
  margin-bottom: 4px;
  color: #6c8a76;
}

.qa-generation-v2__version-empty strong {
  color: #4a554d;
  font-size: 12px;
}

.qa-generation-v2__version-empty small {
  font-size: 12px;
}

.qa-generation-v2__review {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
}

.qa-generation-v2__review-panel {
  padding: 20px;
}

.qa-generation-v2__review-panel header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.qa-generation-v2__review-panel header button {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  color: #526057;
  background: #fff;
  border: 1px solid #d7ded7;
  cursor: pointer;
}

.qa-generation-v2__review-panel header > strong {
  color: var(--qa-green-dark);
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__review-panel dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  margin: 0;
  border-top: 1px solid #e5e9e4;
  border-left: 1px solid #e5e9e4;
}

.qa-generation-v2__review-panel dl > div {
  min-width: 0;
  padding: 13px 14px;
  border-right: 1px solid #e5e9e4;
  border-bottom: 1px solid #e5e9e4;
}

.qa-generation-v2__review-panel dt {
  color: #858d85;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__review-panel dd {
  margin: 5px 0 0;
  overflow: hidden;
  color: #354038;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-generation-v2__review-panel ul {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 20px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.qa-generation-v2__review-panel li {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  color: #7d857e;
  font-size: 12px;
}

.qa-generation-v2__review-panel li i {
  color: #bcc3bc;
}

.qa-generation-v2__review-panel li strong {
  color: #979d97;
  font-size: 12px;
}

.qa-generation-v2__review-panel li.is-complete i,
.qa-generation-v2__review-panel li.is-complete strong {
  color: var(--qa-green);
}

.qa-generation-v2__message {
  min-height: 68px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 13px;
  padding: 14px 18px;
}

.qa-generation-v2__message > i {
  color: var(--qa-green);
  font-size: 18px;
}

.qa-generation-v2__message strong,
.qa-generation-v2__message p {
  margin: 0;
}

.qa-generation-v2__message strong {
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__message p {
  margin-top: 4px;
  color: #717a72;
  font-size: 12px;
}

.qa-generation-v2__message button {
  min-height: 34px;
  padding: 0 12px;
  color: var(--qa-green-dark);
  background: #edf4ef;
  border: 1px solid #c9d9cf;
  cursor: pointer;
}

.qa-generation-v2__message.is-error > i {
  color: #c64d32;
}

.qa-generation-v2__recovery {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-top: 11px;
  padding-top: 11px;
  border-top: 1px solid #eadeda;
}

.qa-generation-v2__recovery span {
  min-width: 0;
}

.qa-generation-v2__recovery span strong,
.qa-generation-v2__recovery span small {
  display: block;
}

.qa-generation-v2__recovery span strong {
  color: #68473e;
  font-size: 12px;
}

.qa-generation-v2__recovery span small {
  margin-top: 3px;
  color: #7d716c;
  font-size: 12px;
  line-height: 1.5;
}

.qa-generation-v2__recovery button {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.qa-generation-v2__message.is-partial {
  border-color: #ead6ad;
  background: #fffaf0;
}

.qa-generation-v2__message.is-partial > i {
  color: #b97816;
}

.qa-generation-v2__progress {
  padding: 18px 20px;
}

.qa-generation-v2__progress > div {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.qa-generation-v2__progress > div > i {
  color: var(--qa-green);
}

.qa-generation-v2__progress span strong,
.qa-generation-v2__progress span small {
  display: block;
}

.qa-generation-v2__progress span strong {
  font-size: 12px;
}

.qa-generation-v2__progress span small {
  margin-top: 4px;
  color: #7a837b;
  font-size: 12px;
}

.qa-generation-v2__progress em {
  color: var(--qa-green);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.qa-generation-v2__progress > progress {
  width: 100%;
  height: 4px;
  display: block;
  margin-top: 14px;
  overflow: hidden;
  accent-color: var(--qa-green);
  border: 0;
  background: #e5ebe6;
  border-radius: 2px;
  appearance: none;
}

.qa-generation-v2__progress > progress::-webkit-progress-bar {
  background: #e5ebe6;
  border-radius: 2px;
}

.qa-generation-v2__progress > progress::-webkit-progress-value {
  background: var(--qa-green);
  border-radius: 2px;
}

.qa-generation-v2__progress > progress::-moz-progress-bar {
  background: var(--qa-green);
  border-radius: 2px;
}

.qa-generation-v2__actions {
  position: sticky;
  bottom: 12px;
  z-index: 10;
  min-height: 78px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 16px 14px 20px;
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid #cfd8d0;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(30, 46, 36, 0.12);
  backdrop-filter: blur(8px);
}

.qa-generation-v2__readiness {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}

.qa-generation-v2__readiness > i {
  color: #a8752d;
  font-size: 17px;
}

.qa-generation-v2__readiness.is-ready > i {
  color: var(--qa-green);
}

.qa-generation-v2__readiness strong,
.qa-generation-v2__readiness p {
  display: block;
  margin: 0;
}

.qa-generation-v2__readiness strong {
  color: #313a33;
  font-size: 12px;
  font-weight: 700;
}

.qa-generation-v2__readiness p {
  margin-top: 4px;
  color: #717a72;
  font-size: 12px;
}

.qa-generation-v2__action-buttons {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.qa-generation-v2__estimate {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 4px;
  color: #66736b;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.qa-generation-v2__estimate i {
  color: var(--qa-green);
}

.qa-generation-v2__action-buttons button {
  min-height: 44px;
  padding: 0 17px;
  cursor: pointer;
}

.qa-generation-v2__action-buttons button.is-secondary {
  color: #4f5a52;
  background: #fff;
  border: 1px solid #d3dbd4;
}

.qa-generation-v2__action-buttons button.is-primary {
  min-width: 170px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;
  background: var(--qa-orange);
  border: 1px solid var(--qa-orange);
  box-shadow: 0 6px 14px rgba(230, 83, 46, 0.2);
}

.qa-generation-v2__action-buttons button.is-primary:hover:not(:disabled) {
  background: #d84b28;
  border-color: #d84b28;
}

.qa-generation-v2__action-buttons button:disabled,
.qa-generation-v2__settings-button:disabled,
.qa-generation-v2__refresh:disabled {
  color: #a7ada7;
  background: #e9ece8;
  border-color: #e1e4e0;
  box-shadow: none;
  cursor: not-allowed;
}

@media (max-width: 1180px) {
  .qa-generation-v2__overview {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .qa-generation-v2__overview-card.is-source {
    grid-column: 1/-1;
    border-bottom: 1px solid #e7ebe5;
  }
  .qa-generation-v2__overview-card:nth-child(2) {
    border-left: 0;
  }
  .qa-generation-v2__table-head,
  .qa-generation-v2__table-row {
    grid-template-columns: 48px minmax(220px, 1fr) 120px 140px;
  }
  .qa-generation-v2__table-head > :nth-child(3),
  .qa-generation-v2__table-row > :nth-child(3) {
    display: none;
  }
  .qa-generation-v2__review-panel ul {
    grid-template-columns: minmax(0, 1fr);
  }
  .qa-generation-v2__versioning-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .qa-generation-v2__version-picker {
    border-right: 0;
    border-bottom: 1px solid #e1e6e0;
  }
}
@media (max-width: 900px) {
  .qa-generation-v2__toolbar,
  .qa-generation-v2__section-header,
  .qa-generation-v2__catalog-summary,
  .qa-generation-v2__actions {
    align-items: flex-start;
    flex-direction: column;
  }
  .qa-generation-v2__settings-button,
  .qa-generation-v2__refresh {
    width: 100%;
  }
  .qa-generation-v2__catalog-tools,
  .qa-generation-v2__version-fields,
  .qa-generation-v2__review {
    grid-template-columns: minmax(0, 1fr);
  }
  .qa-generation-v2__versioning-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .qa-generation-v2__versioning-header > strong {
    width: 100%;
    text-align: left;
  }
  .qa-generation-v2__catalog-actions button:first-child {
    flex: 1;
  }
  .qa-generation-v2__catalog-summary {
    justify-content: center;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .qa-generation-v2__table-head,
  .qa-generation-v2__table-row {
    grid-template-columns: 46px minmax(180px, 1fr) 130px;
  }
  .qa-generation-v2__table-head > :nth-child(4),
  .qa-generation-v2__table-row > :nth-child(4) {
    display: none;
  }
  .qa-generation-v2__pagination {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .qa-generation-v2__pagination > label {
    display: none;
  }
  .qa-generation-v2__actions {
    position: static;
  }
  .qa-generation-v2__action-buttons {
    width: 100%;
  }
  .qa-generation-v2__action-buttons button {
    flex: 1;
  }
}
@media (max-width: 640px) {
  .qa-generation-v2__toolbar,
  .qa-generation-v2__catalog-tools,
  .qa-generation-v2__section-header,
  .qa-generation-v2__versioning-header,
  .qa-generation-v2__version-picker,
  .qa-generation-v2__version-history,
  .qa-generation-v2__review-panel,
  .qa-generation-v2__actions {
    padding-right: 14px;
    padding-left: 14px;
  }
  .qa-generation-v2__heading h2 {
    font-size: 18px;
  }
  .qa-generation-v2__overview {
    grid-template-columns: minmax(0, 1fr);
  }
  .qa-generation-v2__overview-card,
  .qa-generation-v2__overview-card:nth-child(2) {
    border-top: 1px solid #e7ebe5;
    border-left: 0;
  }
  .qa-generation-v2__overview-card.is-source {
    grid-column: auto;
    border-top: 0;
  }
  .qa-generation-v2__table-head,
  .qa-generation-v2__table-row {
    grid-template-columns: minmax(0, 1fr) 118px;
  }
  .qa-generation-v2__table-head > :first-child,
  .qa-generation-v2__table-row > :first-child {
    display: none;
  }
  .qa-generation-v2__review-panel dl {
    grid-template-columns: minmax(0, 1fr);
  }
  .qa-generation-v2__pagination {
    grid-template-columns: minmax(0, 1fr);
    justify-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
  }
  .qa-generation-v2__action-buttons {
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .qa-generation-v2__estimate {
    justify-content: center;
    margin: 0;
  }
  .qa-generation-v2__recovery {
    align-items: stretch;
    flex-direction: column;
  }
  .qa-generation-v2__action-buttons button.is-primary {
    min-width: 0;
  }
}
/* Focused dataset redesign: less chrome, larger type, one clear task. */
.dataset-builder {
  grid-template-columns: minmax(320px, 0.82fr) minmax(520px, 1.18fr);
  gap: 11px 12px;
}

.dataset-builder__heading,
.dataset-stepper,
.dataset-stage {
  grid-column: 1/-1;
}

.dataset-builder__heading {
  align-items: center;
  padding: 0 2px 2px;
}

.dataset-builder__heading h2 {
  margin-top: 5px;
  font-size: 20px;
}

.dataset-builder__heading p {
  max-width: 720px;
  margin-top: 5px;
  font-size: 12px;
}

.dataset-builder__mode {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 999px;
}

.dataset-builder__mode strong {
  margin-top: 0;
  font-size: 12px;
}

.dataset-stepper {
  position: relative;
  overflow: visible;
  padding: 7px 12px;
  border-radius: 12px;
  box-shadow: none;
}

.dataset-stepper li {
  position: relative;
}

.dataset-stepper li:not(:last-child)::after {
  position: absolute;
  z-index: 0;
  top: 50%;
  right: -10%;
  width: 20%;
  border-top: 1px solid var(--review-line);
  content: "";
}

.dataset-step {
  z-index: 1;
  min-height: 46px;
  justify-content: center;
  padding: 6px 8px;
  border-right: 0;
  border-radius: 8px;
  background: transparent;
}

.dataset-step:hover {
  background: #f6f5f1;
}

.dataset-step.is-current {
  background: var(--review-orange-soft);
  box-shadow: none;
}

.dataset-step__number {
  width: 25px;
  height: 25px;
  border-radius: 999px;
}

.dataset-step.is-current .dataset-step__number {
  box-shadow: none;
}

.dataset-step__copy em,
.dataset-step__copy small,
.dataset-step__arrow {
  display: none;
}

.dataset-step__copy strong {
  margin-top: 0;
  font-size: 12px;
}

.dataset-step.is-current .dataset-step__copy strong {
  color: var(--review-orange);
}

.dataset-connection {
  min-height: 58px;
  grid-template-columns: minmax(210px, 1fr) auto auto;
  gap: 12px;
  padding: 9px 12px;
  border-color: #cbd8bc;
  background: #f8faf5;
}

.dataset-connection__state strong {
  font-size: 12px;
}

.dataset-connection__state small {
  font-size: 12px;
}

.dataset-connection__contract {
  padding: 4px 10px;
}

.dataset-connection__contract span {
  font-size: 12px;
  letter-spacing: 0;
}

.dataset-connection__contract strong {
  font-size: 12px;
}

.dataset-connection__details {
  position: relative;
  justify-self: end;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-connection__details summary {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  border: 1px solid var(--review-line);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  font-weight: 700;
  list-style: none;
}

.dataset-connection__details summary::-webkit-details-marker,
.dataset-common-summary::-webkit-details-marker {
  display: none;
}

.dataset-connection__details p {
  position: absolute;
  z-index: 20;
  top: 42px;
  right: 0;
  width: min(360px, 80vw);
  margin: 0;
  padding: 11px 12px;
  border: 1px solid var(--review-line);
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(34, 24, 21, 0.14);
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.55;
}

.dataset-summary {
  min-height: 58px;
  display: block;
  border-radius: 12px;
  box-shadow: none;
}

.dataset-summary .ops-summary__grid {
  width: 100%;
  min-height: 58px;
}

.dataset-summary .ops-stat {
  min-height: 58px;
  gap: 4px;
  padding: 8px 14px;
}

.dataset-summary .ops-stat::before {
  top: 13px;
  right: 12px;
  width: 5px;
  height: 5px;
}

.dataset-summary .ops-stat > span {
  font-size: 12px;
}

.dataset-summary .ops-stat strong {
  font-size: 19px;
}

.dataset-stage {
  gap: 10px;
}

.dataset-stage__header {
  min-height: 52px;
  padding: 5px 2px 10px;
  border: 0;
  border-bottom: 1px solid var(--review-line);
  border-radius: 0;
  background: transparent;
}

.dataset-stage__title > span {
  width: 29px;
  height: 29px;
  border-radius: 8px;
  background: var(--review-orange-soft);
  color: var(--review-orange);
  font-size: 12px;
}

.dataset-stage__title strong {
  font-size: 14px;
}

.dataset-stage__title p {
  margin-top: 3px;
  font-size: 12px;
}

.dataset-stage__status {
  padding: 6px 9px;
  font-size: 12px;
}

.dataset-source-layout,
.dataset-snapshot-layout,
.dataset-preflight-layout {
  grid-template-columns: minmax(0, 1fr) 292px;
  gap: 12px;
}

.dataset-material-panel,
.dataset-selection-panel,
.dataset-scope-panel,
.dataset-chunk-panel,
.dataset-checkpoint-panel,
.dataset-snapshot-card,
.dataset-output-card,
.dataset-common-config,
.dataset-preflight-panel,
.dataset-recipe-panel,
.dataset-artifact-card,
.dataset-graph-preview {
  box-shadow: none;
}

.dataset-selection-panel,
.dataset-snapshot-card,
.dataset-recipe-panel {
  position: sticky;
  top: 12px;
}

.dataset-builder .ops-toolbar {
  min-height: 58px;
  padding: 9px 12px;
}

.dataset-toolbar-title strong {
  font-size: 13px;
}

.dataset-toolbar-title small,
.dataset-lock-note,
.dataset-builder .ops-result-meta,
.dataset-builder .ops-result-meta > div {
  font-size: 12px;
}

.dataset-builder .ops-search,
.dataset-builder .ops-select {
  height: 42px;
}

.dataset-builder .ops-search input,
.dataset-builder .ops-select select {
  font-size: 12px;
}

.dataset-builder .ops-search > button {
  width: 34px;
  height: 34px;
  right: 3px;
}

.dataset-material-row {
  grid-template-columns: 28px minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  gap: 4px 11px;
  min-height: 64px;
  padding: 9px 13px;
}

.dataset-material-check {
  grid-row: 1/3;
}

.dataset-material-main {
  grid-column: 2;
  grid-row: 1;
}

.dataset-material-main strong {
  font-size: 12px;
}

.dataset-material-main code {
  display: inline;
  margin-top: 0;
  margin-left: 7px;
  font-size: 12px;
}

.dataset-material-meta {
  grid-column: 2;
  grid-row: 2;
}

.dataset-material-meta span,
.dataset-material-action {
  padding: 3px 6px;
  font-size: 12px;
}

.dataset-material-availability {
  display: none;
}

.dataset-material-action {
  grid-column: 3;
  grid-row: 1/3;
  align-self: center;
}

.dataset-panel-heading {
  min-height: 54px;
  padding: 10px 13px;
}

.dataset-panel-heading span {
  font-size: 12px;
  letter-spacing: 0;
}

.dataset-panel-heading strong {
  margin-top: 3px;
  font-size: 12px;
}

.dataset-panel-heading small {
  font-size: 12px;
}

.dataset-selected-list strong {
  font-size: 12px;
}

.dataset-selected-list code,
.dataset-selected-list article > span {
  font-size: 12px;
}

.dataset-scope-options {
  gap: 0;
  padding: 11px 12px;
}

.dataset-scope-options button {
  min-height: 58px;
  background: #fff;
}

.dataset-scope-options button + button {
  margin-left: -1px;
}

.dataset-scope-options span {
  display: none;
}

.dataset-scope-options strong {
  margin-top: 0;
  font-size: 12px;
}

.dataset-scope-options small {
  margin-top: 3px;
  font-size: 12px;
}

.dataset-scope-options button:disabled:not(.is-selected) {
  opacity: 0.55;
  background: #f2f1ed;
}

.dataset-snapshot-main {
  gap: 0;
  overflow: hidden;
  border: 1px solid var(--review-line);
  border-radius: 12px;
  background: #fff;
}

.dataset-snapshot-main > .ops-panel {
  border: 0;
  border-bottom: 1px solid var(--review-line-soft);
  border-radius: 0;
}

.dataset-snapshot-main > .ops-panel:last-child {
  border-bottom: 0;
}

.dataset-chunk-list strong,
.dataset-checklist strong,
.dataset-preflight-list strong {
  font-size: 12px;
}

.dataset-chunk-list p,
.dataset-checklist small,
.dataset-preflight-list small,
.dataset-chunk-list code {
  font-size: 12px;
}

.dataset-output-card header strong {
  font-size: 13px;
}

.dataset-output-card header p,
.dataset-output-card > footer > strong {
  font-size: 12px;
}

.dataset-output-fields label > span,
.dataset-common-grid > label > span {
  font-size: 12px;
}

.dataset-output-fields input,
.dataset-output-fields select,
.dataset-common-grid input,
.dataset-common-grid select {
  height: 42px;
  font-size: 12px;
}

.dataset-output-fields.is-disabled {
  opacity: 1;
  background: #f6f5f1;
}

.dataset-output-fields.is-disabled input,
.dataset-output-fields.is-disabled select {
  color: var(--review-muted);
  background: #efeee9;
}

.dataset-output-card--qa .dataset-output-fields label:nth-child(n+3),
.dataset-output-card--kg .dataset-output-fields label:nth-child(n+3),
.dataset-output-card > footer {
  display: none;
}

.dataset-output-card .dataset-field--wide {
  grid-column: auto;
}

.dataset-common-config {
  overflow: hidden;
}

.dataset-common-summary {
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 14px;
  cursor: pointer;
  list-style: none;
}

.dataset-common-summary > div:last-child {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: right;
}

.dataset-common-summary span,
.dataset-common-summary strong,
.dataset-common-summary small {
  display: block;
}

.dataset-common-summary span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-common-summary strong {
  margin-top: 3px;
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-common-summary small {
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-common-summary em {
  padding: 5px 7px;
  border-radius: 6px;
  background: #f0efeb;
  color: var(--review-muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.dataset-common-config[open] .dataset-common-summary {
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-stage__actions {
  position: sticky;
  z-index: 15;
  bottom: 10px;
  min-height: 58px;
  align-items: center;
  padding: 9px 10px;
  border: 1px solid rgba(213, 211, 204, 0.92);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 10px 28px rgba(34, 24, 21, 0.12);
  backdrop-filter: blur(10px);
}

.dataset-button {
  min-height: 42px;
}

.dataset-artifact-card header span,
.dataset-artifact-stats span {
  font-size: 12px;
}

.dataset-artifact-card header strong,
.dataset-artifact-body strong {
  font-size: 12px;
}

.dataset-artifact-body p {
  font-size: 12px;
}

.dataset-builder button:focus-visible,
.dataset-builder input:focus-visible,
.dataset-builder select:focus-visible,
.dataset-builder summary:focus-visible,
.dataset-builder label:has(input:focus-visible) {
  outline: 3px solid rgba(169, 79, 29, 0.23);
  outline-offset: 2px;
}

.dataset-selection-meta dd,
.dataset-snapshot-card dd,
.dataset-recipe-panel dd,
.dataset-chunk-list code {
  min-width: 0;
  overflow-wrap: anywhere;
}

@media (max-width: 1100px) {
  .dataset-builder {
    grid-template-columns: 1fr;
  }
  .dataset-builder__heading,
  .dataset-stepper,
  .dataset-connection,
  .dataset-summary,
  .dataset-stage {
    grid-column: 1;
  }
  .dataset-source-layout,
  .dataset-snapshot-layout,
  .dataset-preflight-layout {
    grid-template-columns: 1fr;
  }
  .dataset-selection-panel,
  .dataset-snapshot-card,
  .dataset-recipe-panel {
    position: static;
    order: initial;
  }
}
@media (max-width: 900px) {
  .dataset-stepper {
    display: flex;
    grid-template-columns: none;
    gap: 4px;
    overflow-x: auto;
    padding: 6px;
    scrollbar-width: thin;
  }
  .dataset-stepper li {
    flex: 0 0 148px;
  }
  .dataset-stepper li::after {
    display: none;
  }
  .dataset-step {
    min-height: 46px;
    border: 0;
  }
  .dataset-stepper li:last-child .dataset-step {
    border: 0;
  }
  .dataset-connection {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .dataset-summary {
    grid-template-columns: 1fr;
  }
  .dataset-summary .ops-summary__grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .dataset-material-meta,
  .dataset-material-availability {
    grid-column: 2;
  }
}
@media (max-width: 640px) {
  .dataset-builder__heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 9px;
  }
  .dataset-builder__mode {
    width: auto;
  }
  .dataset-builder__heading p {
    font-size: 12px;
  }
  .dataset-connection {
    grid-template-columns: 1fr auto;
  }
  .dataset-connection__contract {
    display: none;
  }
  .dataset-connection__details {
    grid-column: 2;
    grid-row: 1;
  }
  .dataset-connection__details p {
    width: min(300px, 82vw);
  }
  .dataset-summary .ops-summary__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataset-summary .ops-stat {
    min-height: 56px;
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-stage__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .dataset-stage__status {
    width: auto;
  }
  .dataset-builder .ops-toolbar,
  .dataset-builder .ops-filter-group {
    align-items: stretch;
    flex-direction: column;
  }
  .dataset-builder .ops-search,
  .dataset-builder .ops-select {
    width: 100%;
  }
  .dataset-material-row {
    grid-template-columns: 28px minmax(0, 1fr);
  }
  .dataset-material-action {
    display: none;
  }
  .dataset-material-main code {
    display: block;
    margin: 3px 0 0;
  }
  .dataset-scope-options,
  .dataset-output-fields,
  .dataset-common-grid,
  .dataset-preview-columns {
    grid-template-columns: 1fr;
  }
  .dataset-scope-options {
    gap: 6px;
  }
  .dataset-scope-options button,
  .dataset-scope-options button:first-child,
  .dataset-scope-options button:last-child {
    margin-left: 0;
  }
  .dataset-common-summary {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-common-summary > div:last-child {
    width: 100%;
    justify-content: space-between;
    text-align: left;
  }
  .dataset-stage__actions {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
  }
  .dataset-button {
    width: auto;
    min-height: 44px;
  }
}
/* Review readability scale: labels start at 11px and working copy at 12–13px. */
.review-workspace [class~="text-[8px]"],
.review-workspace [class~="text-[9px]"] {
  font-size: 12px !important;
  line-height: 1.45 !important;
}

.review-workspace [class~="text-[10px]"] {
  font-size: 12px !important;
  line-height: 1.5 !important;
}

.review-workspace [class~="text-[11px]"],
.review-workspace .text-xs {
  font-size: 13px !important;
  line-height: 1.5 !important;
}

.dataset-builder__eyebrow,
.dataset-builder__mode span,
.dataset-step__number,
.dataset-connection__contract span,
.dataset-lock-note,
.dataset-material-meta span,
.dataset-material-action,
.dataset-panel-heading span,
.dataset-selection-count,
.dataset-lock-icon,
.dataset-recipe-id,
.dataset-common-summary span,
.dataset-common-summary em,
.dataset-preflight-list em,
.dataset-artifact-card header span,
.dataset-artifact-stats span {
  font-size: 12px !important;
  line-height: 1.4;
}

.dataset-builder__heading p,
.dataset-connection__state small,
.dataset-connection__details,
.dataset-summary .ops-stat > span,
.dataset-stage__title p,
.dataset-stage__status,
.dataset-toolbar-title small,
.dataset-builder .ops-result-meta,
.dataset-builder .ops-result-meta > div,
.dataset-material-main code,
.dataset-panel-heading small,
.dataset-selected-list code,
.dataset-selected-list article > span,
.dataset-scope-options small,
.dataset-chunk-list p,
.dataset-chunk-list code,
.dataset-checklist small,
.dataset-preflight-list small,
.dataset-output-card header p,
.dataset-output-card > footer > strong,
.dataset-output-fields label > span,
.dataset-common-grid > label > span,
.dataset-common-summary small,
.dataset-artifact-body p {
  font-size: 12px;
  line-height: 1.5;
}

.dataset-step__copy strong,
.dataset-connection__state strong,
.dataset-material-main strong,
.dataset-panel-heading strong,
.dataset-selected-list strong,
.dataset-scope-options strong,
.dataset-chunk-list strong,
.dataset-checklist strong,
.dataset-preflight-list strong,
.dataset-common-summary strong,
.dataset-artifact-card header strong,
.dataset-artifact-body strong {
  font-size: 13px;
  line-height: 1.45;
}

.dataset-toolbar-title strong,
.dataset-output-card header strong {
  font-size: 14px;
}

.dataset-builder .ops-search input,
.dataset-builder .ops-select select,
.dataset-output-fields input,
.dataset-output-fields select,
.dataset-common-grid input,
.dataset-common-grid select,
.dataset-button {
  font-size: 13px;
}

@media (max-width: 640px) {
  .dataset-builder__heading p {
    font-size: 12px;
  }
}
/* Dataset information architecture: list, read-only detail, and 3-step creation. */
.dataset-hub,
.dataset-detail-page,
.dataset-create-page {
  display: grid;
  gap: 16px;
}

.dataset-page-heading,
.dataset-detail-header,
.dataset-create-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 92px;
  padding: 20px 22px;
  border: 1px solid var(--review-line);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 26px rgba(34, 24, 21, 0.055);
}

.dataset-page-heading__copy,
.dataset-detail-header__copy {
  min-width: 0;
}

.dataset-page-kicker {
  display: block;
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.dataset-page-heading h2,
.dataset-detail-header h2,
.dataset-create-header h2 {
  margin: 5px 0 0;
  color: var(--review-ink);
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.dataset-page-heading p,
.dataset-detail-header p,
.dataset-create-header p {
  margin: 6px 0 0;
  color: var(--review-muted);
  font-size: 13px;
  line-height: 1.55;
}

.dataset-project-map {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--review-line);
  border-radius: 14px;
  background: #fff;
}

.dataset-project-map article {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  gap: 11px;
  min-height: 78px;
  padding: 16px 18px;
  border-right: 1px solid var(--review-line-soft);
}

.dataset-project-map article:last-child {
  border-right: 0;
}

.dataset-project-map article > span {
  width: 30px;
  height: 30px;
  display: grid;
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
  place-items: center;
  border-radius: 9px;
  background: var(--review-primary-soft);
}

.dataset-project-map strong,
.dataset-project-map p {
  display: block;
}

.dataset-project-map strong {
  color: var(--review-ink);
  font-size: 13px;
}

.dataset-project-map p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.45;
}

.dataset-overview-grid {
  display: grid;
  grid-template-columns: 0.7fr 1fr 1.25fr;
  gap: 12px;
}

.dataset-overview-grid article {
  min-width: 0;
  padding: 16px 18px;
  border: 1px solid var(--review-line);
  border-radius: 13px;
  background: #fff;
}

.dataset-overview-grid span,
.dataset-overview-grid strong,
.dataset-overview-grid small {
  display: block;
}

.dataset-overview-grid span {
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.dataset-overview-grid strong {
  overflow: hidden;
  margin-top: 7px;
  color: var(--review-ink);
  font-size: 17px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-overview-grid small {
  margin-top: 5px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-list-section {
  overflow: hidden;
  border: 1px solid var(--review-line);
  border-radius: 15px;
  background: #fff;
}

.dataset-section-heading,
.dataset-card-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.dataset-section-heading {
  min-height: 66px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fafaf7;
}

.dataset-section-heading span,
.dataset-card-heading span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-section-heading h3,
.dataset-card-heading h3 {
  margin: 3px 0 0;
  color: var(--review-ink);
  font-size: 14px;
}

.dataset-section-heading small,
.dataset-card-heading small {
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-record-card {
  margin: 14px;
  overflow: hidden;
  border: 1px solid #cbd8bc;
  border-radius: 13px;
  background: #fff;
}

.dataset-record-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 17px 18px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #f8faf5;
}

.dataset-record-card__header > div > span {
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
}

.dataset-record-card__header h3 {
  margin: 4px 0 0;
  color: var(--review-ink);
  font-size: 18px;
}

.dataset-record-card__header p {
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-status-badge,
.dataset-draft-badge {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 5px 9px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
}

.dataset-status-badge.is-complete {
  color: var(--review-primary);
  border: 1px solid #cbd8bc;
  background: var(--review-primary-soft);
}

.dataset-draft-badge {
  color: var(--review-orange);
  border: 1px solid #efc5ad;
  background: var(--review-orange-soft);
}

.dataset-record-card__metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.dataset-record-card__metrics > div {
  min-width: 0;
  padding: 16px 18px;
  border-right: 1px solid var(--review-line-soft);
}

.dataset-record-card__metrics > div:last-child {
  border-right: 0;
}

.dataset-record-card__metrics span,
.dataset-record-card__metrics strong,
.dataset-record-card__metrics small {
  display: block;
}

.dataset-record-card__metrics span {
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.dataset-record-card__metrics strong {
  margin-top: 5px;
  overflow: hidden;
  color: var(--review-ink);
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-record-card__metrics small {
  margin-top: 4px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-record-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  padding: 0 18px 16px;
}

.dataset-record-card__meta span {
  padding: 5px 8px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  border-radius: 6px;
  background: #f2f1ed;
}

.dataset-record-card__actions,
.dataset-detail-actions,
.dataset-create-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 14px;
  border-top: 1px solid var(--review-line-soft);
  background: #fafaf7;
}

.dataset-detail-header {
  justify-content: flex-start;
}

.dataset-detail-header__copy {
  flex: 1;
}

.dataset-detail-header__copy > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dataset-back-button {
  width: 42px;
  height: 42px;
  display: inline-grid;
  flex: 0 0 42px;
  place-items: center;
  padding: 0;
  color: var(--review-muted);
  cursor: pointer;
  border: 1px solid var(--review-line);
  background: #fff;
  box-shadow: 0 3px 10px rgba(34, 24, 21, 0.045);
  transition: color 160ms ease, border-color 160ms ease, background 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.dataset-back-button:hover {
  color: var(--review-primary-dark);
  border-color: #becbad;
  background: var(--review-primary-soft);
  box-shadow: 0 6px 16px rgba(61, 80, 40, 0.11);
  transform: translateX(-1px);
}

.dataset-back-button:active {
  transform: translateX(-1px) scale(0.96);
}

.dataset-back-button:focus-visible {
  outline: 3px solid rgba(75, 103, 42, 0.18);
  outline-offset: 2px;
}

.dataset-detail-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--review-line);
  border-radius: 13px;
  background: #fff;
}

.dataset-detail-summary > div {
  min-width: 0;
  padding: 14px 17px;
  border-right: 1px solid var(--review-line-soft);
}

.dataset-detail-summary > div:last-child {
  border-right: 0;
}

.dataset-detail-summary span,
.dataset-detail-summary strong {
  display: block;
}

.dataset-detail-summary span {
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-detail-summary strong {
  overflow: hidden;
  margin-top: 5px;
  color: var(--review-ink);
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-detail-tabs {
  display: flex;
  gap: 5px;
  padding: 5px;
  border: 1px solid var(--review-line);
  border-radius: 11px;
  background: #eeece7;
}

.dataset-detail-tabs button {
  min-height: 40px;
  padding: 0 14px;
  color: var(--review-muted);
  cursor: pointer;
  border: 0;
  background: transparent;
}

.dataset-detail-tabs button.is-active {
  color: var(--review-ink);
  background: #fff;
  box-shadow: 0 2px 7px rgba(34, 24, 21, 0.09);
}

.dataset-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.dataset-readonly-panel,
.dataset-review-card {
  overflow: hidden;
}

.dataset-readonly-panel > .dataset-card-heading,
.dataset-review-card > .dataset-card-heading,
.dataset-graph-preview > .dataset-card-heading {
  min-height: 66px;
  padding: 13px 16px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fafaf7;
}

.dataset-card-heading button {
  min-height: 34px;
  padding: 0 9px;
  color: var(--review-orange);
  cursor: pointer;
  border: 1px solid #efc5ad;
  background: #fff;
}

.dataset-card-heading code {
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-readonly-materials,
.dataset-create-selection__list,
.dataset-review-materials {
  display: grid;
  gap: 8px;
  padding: 14px 16px;
}

.dataset-readonly-materials article,
.dataset-create-selection__list article,
.dataset-review-materials article {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px;
  border: 1px solid var(--review-line-soft);
  border-radius: 9px;
  background: #fff;
}

.dataset-readonly-materials strong,
.dataset-create-selection__list strong,
.dataset-review-materials strong {
  color: var(--review-ink);
  font-size: 13px;
}

.dataset-readonly-materials code,
.dataset-create-selection__list code,
.dataset-review-materials span {
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-readonly-materials article > div:last-child {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
}

.dataset-readonly-materials article > div:last-child span {
  padding: 4px 6px;
  color: var(--review-muted);
  font-size: 12px;
  border-radius: 5px;
  background: #f0efeb;
}

.dataset-definition-list {
  display: grid;
  margin: 0;
  padding: 0 16px 14px;
}

.dataset-definition-list > div {
  display: grid;
  grid-template-columns: 128px minmax(0, 1fr);
  gap: 14px;
  padding: 11px 0;
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-definition-list > div:last-child {
  border-bottom: 0;
}

.dataset-definition-list dt {
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.dataset-definition-list dd {
  min-width: 0;
  margin: 0;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.dataset-readonly-note {
  margin: 0 16px 16px;
  padding: 11px 12px;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.5;
  border-radius: 8px;
  background: #f2f1ed;
}

.dataset-setting-summary,
.dataset-review-outputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px;
  padding: 14px 16px;
}

.dataset-setting-summary article,
.dataset-review-outputs article {
  padding: 12px;
  border: 1px solid var(--review-line-soft);
  border-radius: 9px;
  background: #fafaf7;
}

.dataset-setting-summary article.is-enabled,
.dataset-review-outputs article.is-enabled {
  border-color: #cbd8bc;
  background: #f8faf5;
}

.dataset-setting-summary span,
.dataset-setting-summary strong,
.dataset-setting-summary p,
.dataset-review-outputs span,
.dataset-review-outputs strong,
.dataset-review-outputs small {
  display: block;
}

.dataset-setting-summary span,
.dataset-review-outputs span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-setting-summary strong,
.dataset-review-outputs strong {
  margin-top: 5px;
  color: var(--review-ink);
  font-size: 14px;
}

.dataset-setting-summary p,
.dataset-review-outputs small {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.45;
}

.dataset-create-header {
  border-color: #efc5ad;
  background: linear-gradient(135deg, #fff, #fff9f5);
}

.dataset-create-stepper {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
  padding: 6px;
  list-style: none;
  border: 1px solid var(--review-line);
  border-radius: 13px;
  background: #eeece7;
}

.dataset-create-stepper button {
  width: 100%;
  min-height: 58px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  color: var(--review-muted);
  text-align: left;
  cursor: pointer;
  border: 0;
  background: transparent;
}

.dataset-create-stepper button.is-current {
  color: var(--review-ink);
  background: #fff;
  box-shadow: 0 3px 9px rgba(34, 24, 21, 0.09);
}

.dataset-create-stepper button.is-complete {
  color: var(--review-primary);
}

.dataset-create-stepper button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.dataset-create-stepper__number {
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  display: grid;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  place-items: center;
  border: 1px solid var(--review-line);
  border-radius: 9px;
  background: #fff;
}

.dataset-create-stepper button.is-current .dataset-create-stepper__number {
  color: #fff;
  border-color: var(--review-orange);
  background: var(--review-orange);
}

.dataset-create-stepper button.is-complete .dataset-create-stepper__number {
  color: var(--review-primary);
  border-color: #cbd8bc;
  background: var(--review-primary-soft);
}

.dataset-create-stepper button > span:last-child,
.dataset-create-stepper strong,
.dataset-create-stepper small {
  display: block;
}

.dataset-create-stepper strong {
  font-size: 13px;
}

.dataset-create-stepper small {
  margin-top: 3px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-create-stage {
  display: grid;
  gap: 13px;
}

.dataset-create-stage__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 8px 2px 12px;
  border-bottom: 1px solid var(--review-line);
}

.dataset-create-stage__header span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-create-stage__header h3 {
  margin: 4px 0 0;
  color: var(--review-ink);
  font-size: 18px;
}

.dataset-create-stage__header p {
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.5;
}

.dataset-create-stage__header > strong {
  flex: 0 0 auto;
  padding: 7px 9px;
  color: var(--review-primary);
  font-size: 12px;
  border-radius: 8px;
  background: var(--review-primary-soft);
}

.dataset-connection-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 52px;
  padding: 9px 13px;
  border: 1px solid #cbd8bc;
  border-radius: 11px;
  background: #f8faf5;
}

.dataset-connection-strip > div {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.dataset-connection-strip__dot {
  flex: 0 0 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--review-primary);
  box-shadow: 0 0 0 4px rgba(75, 103, 42, 0.12);
}

.dataset-connection-strip strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-connection-strip small {
  overflow: hidden;
  color: var(--review-muted);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-connection-strip details {
  position: relative;
  flex: 0 0 auto;
}

.dataset-connection-strip summary {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  padding: 0 9px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid var(--review-line);
  border-radius: 7px;
  background: #fff;
  list-style: none;
}

.dataset-connection-strip summary::-webkit-details-marker {
  display: none;
}

.dataset-connection-strip details p {
  position: absolute;
  z-index: 25;
  top: 40px;
  right: 0;
  width: min(360px, 78vw);
  margin: 0;
  padding: 11px 12px;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.5;
  border: 1px solid var(--review-line);
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(34, 24, 21, 0.14);
}

.dataset-create-source-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  align-items: start;
  gap: 13px;
}

.dataset-source-picker,
.dataset-create-selection,
.dataset-create-output,
.dataset-create-advanced {
  overflow: hidden;
}

.dataset-source-picker,
.dataset-create-selection {
  height: fit-content;
  align-self: start;
}

.dataset-create-selection {
  position: sticky;
  top: 12px;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.dataset-create-selection > .dataset-create-selection__header {
  min-height: 76px;
  align-items: flex-start;
  padding: 16px 18px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fafaf7;
}

.dataset-create-selection__header h3 {
  margin-top: 7px;
  font-size: 20px;
  line-height: 1;
}

.dataset-create-selection__header > small {
  padding-top: 2px;
  white-space: nowrap;
}

.dataset-source-picker__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-height: 42px;
  padding: 8px 13px;
  color: var(--review-muted);
  font-size: 12px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fafaf7;
}

.dataset-source-picker__meta-copy {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
}

.dataset-source-picker__meta-copy strong {
  color: var(--review-orange);
  font-size: 12px;
  white-space: nowrap;
}

.dataset-source-picker__meta-copy span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-select-all {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 0 0 auto;
  padding: 0 10px;
  color: var(--review-primary);
  cursor: pointer;
  border: 1px solid #b9c7aa;
  background: #fff;
  transition: border-color 120ms ease, background-color 120ms ease, color 120ms ease;
}

.dataset-select-all:hover:not(:disabled) {
  border-color: var(--review-primary);
  background: var(--review-primary-soft);
}

.dataset-select-all.is-selected {
  color: #fff;
  border-color: var(--review-primary);
  background: var(--review-primary);
}

.dataset-select-all:disabled {
  color: #aaa79f;
  cursor: not-allowed;
  border-color: var(--review-line-soft);
  background: #f2f1ed;
}

.dataset-select-all i {
  font-size: 12px;
}

.dataset-source-options {
  max-height: 478px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.dataset-source-option {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  min-height: 66px;
  padding: 10px 13px;
  cursor: pointer;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fff;
}

.dataset-source-option:last-child {
  border-bottom: 0;
}

.dataset-source-option:hover {
  background: #fafaf7;
}

.dataset-source-option.is-selected {
  background: var(--review-primary-soft);
  box-shadow: inset 3px 0 0 var(--review-primary);
}

.dataset-source-option__input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.dataset-source-option__check {
  display: grid;
  width: 18px;
  height: 18px;
  color: transparent;
  font-size: 12px;
  place-items: center;
  border: 1px solid #aaa79f;
  border-radius: 3px;
  background: #fff;
  transition: color 120ms ease, border-color 120ms ease, background-color 120ms ease, box-shadow 120ms ease;
}

.dataset-source-option.is-selected .dataset-source-option__check {
  color: #fff;
  border-color: var(--review-primary);
  background: var(--review-primary);
}

.dataset-source-option__input:focus-visible + .dataset-source-option__check {
  box-shadow: 0 0 0 3px rgba(79, 111, 48, 0.2);
}

.dataset-source-option__copy {
  min-width: 0;
}

.dataset-source-option__copy > strong,
.dataset-source-option__copy > code {
  display: block;
}

.dataset-source-option__copy > strong {
  overflow: hidden;
  color: var(--review-ink);
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-source-option__copy > code {
  margin-top: 3px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-source-option__copy > div {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
}

.dataset-source-option__copy > div span,
.dataset-source-option__state {
  padding: 3px 6px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  border-radius: 5px;
  background: #f0efeb;
}

.dataset-source-option.is-selected .dataset-source-option__state {
  color: var(--review-primary);
  background: #e4ecd9;
}

.dataset-create-selection__empty {
  min-height: 142px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 24px 18px;
  text-align: center;
}

.dataset-create-selection__empty strong {
  color: var(--review-ink);
  font-size: 13px;
}

.dataset-create-selection__empty p {
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-create-selection__list {
  max-height: 260px;
  gap: 6px;
  overflow-y: auto;
  padding: 10px 12px;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.dataset-create-selection__list article {
  min-width: 0;
  min-height: 44px;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 8px;
}

.dataset-create-selection__list article > strong {
  min-width: 0;
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-create-selection__list article > span {
  flex: 0 0 auto;
  padding: 3px 6px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  border-radius: 5px;
  background: #f0efeb;
}

.dataset-range-choice {
  display: grid;
  gap: 9px;
  margin: 0;
  padding: 16px 18px 18px;
  border: 0;
  border-top: 1px solid var(--review-line-soft);
  background: #fff;
}

.dataset-range-choice__heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 2px;
}

.dataset-range-choice__heading strong {
  color: var(--review-ink);
  font-size: 13px;
  font-weight: 700;
}

.dataset-range-choice__heading span {
  overflow: hidden;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-range-choice label {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  min-height: 68px;
  padding: 12px 13px;
  cursor: pointer;
  border: 1px solid var(--review-line);
  border-radius: 10px;
  background: #fafaf7;
  transition: border-color 120ms ease, background-color 120ms ease, box-shadow 120ms ease;
}

.dataset-range-choice label:hover {
  border-color: #b9c7aa;
  background: #f8faf5;
}

.dataset-range-choice label.is-selected {
  border-color: #9fb783;
  background: var(--review-primary-soft);
  box-shadow: inset 3px 0 0 var(--review-primary);
}

.dataset-range-choice label.is-selected .dataset-range-choice__copy strong {
  color: var(--review-primary);
}

.dataset-range-choice label:focus-within {
  outline: 3px solid rgba(79, 111, 48, 0.16);
  outline-offset: 1px;
}

.dataset-range-choice input,
.dataset-create-chunks input,
.dataset-output-toggle input,
.dataset-plain-check input {
  width: 18px;
  height: 18px;
  margin: 1px 0 0;
  accent-color: var(--review-primary);
}

.dataset-range-choice span,
.dataset-range-choice strong,
.dataset-range-choice small {
  display: block;
}

.dataset-range-choice label > span {
  min-width: 0;
}

.dataset-range-choice .dataset-range-choice__input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.dataset-range-choice .dataset-range-choice__radio {
  width: 24px;
  height: 24px;
  display: inline-grid;
  place-items: center;
  color: transparent;
  font-size: 12px;
  border: 2px solid #aaa79f;
  border-radius: 50%;
  background: #fff;
  transition: color 120ms ease, border-color 120ms ease, background-color 120ms ease, box-shadow 120ms ease;
}

.dataset-range-choice label.is-selected .dataset-range-choice__radio {
  color: #fff;
  border-color: var(--review-primary);
  background: var(--review-primary);
  box-shadow: 0 0 0 4px rgba(79, 111, 48, 0.14);
}

.dataset-range-choice__input:focus-visible + .dataset-range-choice__radio {
  outline: 3px solid rgba(79, 111, 48, 0.24);
  outline-offset: 2px;
}

.dataset-range-choice .dataset-range-choice__state {
  min-width: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 5px 7px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  border-radius: 6px;
  background: #ecebe7;
}

.dataset-range-choice label.is-selected .dataset-range-choice__state {
  color: #fff;
  background: var(--review-primary);
}

.dataset-range-choice__state i {
  font-size: 12px;
}

.dataset-range-choice strong,
.dataset-create-chunks strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-range-choice small,
.dataset-create-chunks small {
  margin-top: 3px;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.4;
}

.dataset-create-chunks {
  display: grid;
  gap: 7px;
  padding: 14px 16px;
  border-top: 1px solid var(--review-line-soft);
}

.dataset-create-chunks > strong {
  margin-bottom: 2px;
}

.dataset-create-chunks label {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 9px;
  border: 1px solid var(--review-line-soft);
  border-radius: 8px;
}

.dataset-create-output-grid,
.dataset-create-review-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  gap: 13px;
}

.dataset-create-output {
  border-color: var(--review-line);
}

.dataset-create-output.is-enabled {
  border-color: #cbd8bc;
}

.dataset-create-output > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  min-height: 84px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fafaf7;
}

.dataset-create-output.is-enabled > header {
  background: #f8faf5;
}

.dataset-create-output > header span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-create-output > header h3 {
  margin: 3px 0 0;
  color: var(--review-ink);
  font-size: 15px;
}

.dataset-create-output > header p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.45;
}

.dataset-output-toggle {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 126px;
  min-height: 46px;
  padding: 7px 10px;
  cursor: pointer;
  border: 1px solid var(--review-line);
  border-radius: 9px;
  background: #fff;
  transition: border-color 120ms ease, background-color 120ms ease, box-shadow 120ms ease;
}

.dataset-output-toggle:hover {
  border-color: #b9c7aa;
}

.dataset-output-toggle.is-checked {
  border-color: #9fb783;
  background: var(--review-primary-soft);
  box-shadow: inset 3px 0 0 var(--review-primary);
}

.dataset-output-toggle input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.dataset-output-toggle__check {
  width: 20px;
  height: 20px;
  display: inline-grid !important;
  flex: 0 0 20px;
  place-items: center;
  color: transparent !important;
  font-size: 12px !important;
  border: 1px solid #aaa79f;
  border-radius: 5px;
  background: #fff;
}

.dataset-output-toggle.is-checked .dataset-output-toggle__check {
  color: #fff !important;
  border-color: var(--review-primary);
  background: var(--review-primary);
}

.dataset-output-toggle input:focus-visible + .dataset-output-toggle__check {
  outline: 3px solid rgba(79, 111, 48, 0.18);
  outline-offset: 2px;
}

.dataset-output-toggle__text,
.dataset-output-toggle__text strong,
.dataset-output-toggle__text small {
  display: block;
}

.dataset-output-toggle__text strong {
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.dataset-output-toggle__text small {
  margin-top: 2px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.dataset-output-toggle.is-checked .dataset-output-toggle__text strong,
.dataset-output-toggle.is-checked .dataset-output-toggle__text small {
  color: var(--review-primary);
}

.dataset-create-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 11px;
  padding: 15px 16px 17px;
}

.dataset-create-fields.is-disabled {
  opacity: 0.62;
  background: #f5f4f0;
}

.dataset-create-fields label {
  min-width: 0;
}

.dataset-create-fields label > span {
  display: block;
  margin-bottom: 6px;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.dataset-create-fields input:not([type=checkbox]),
.dataset-create-fields select {
  width: 100%;
  height: 43px;
  padding: 0 10px;
  color: var(--review-ink);
  font-size: 13px;
  border: 1px solid var(--review-line);
  border-radius: 8px;
  outline: 0;
  background: #fff;
}

.dataset-create-fields label > small {
  display: block;
  margin-top: 5px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-create-fields .is-wide {
  grid-column: 1/-1;
}

.dataset-create-advanced summary {
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 15px;
  cursor: pointer;
  list-style: none;
}

.dataset-create-advanced summary::-webkit-details-marker {
  display: none;
}

.dataset-create-advanced summary span,
.dataset-create-advanced summary strong,
.dataset-create-advanced summary small {
  display: block;
}

.dataset-create-advanced summary span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-create-advanced summary strong {
  margin-top: 3px;
  color: var(--review-ink);
  font-size: 13px;
}

.dataset-create-advanced summary small {
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-create-advanced[open] summary {
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-create-fields--advanced {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.dataset-plain-check {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 10px;
  border: 1px solid var(--review-line-soft);
  border-radius: 8px;
  background: #fafaf7;
}

.dataset-plain-check > span {
  margin: 0 !important;
}

.dataset-plain-check strong,
.dataset-plain-check small {
  display: block;
}

.dataset-plain-check strong {
  color: var(--review-ink);
  font-size: 12px;
}

.dataset-plain-check small {
  margin-top: 3px;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.4;
}

.dataset-review-materials {
  padding-bottom: 6px;
}

.dataset-review-outputs {
  padding-bottom: 6px;
}

.dataset-api-notice {
  padding: 13px 15px;
  color: #785122;
  border: 1px solid #ead2a1;
  border-radius: 10px;
  background: var(--review-gold-soft);
}

.dataset-api-notice strong {
  font-size: 13px;
}

.dataset-api-notice p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.5;
}

.dataset-create-actions {
  position: sticky;
  z-index: 16;
  bottom: 10px;
  min-height: 64px;
  border: 1px solid rgba(213, 211, 204, 0.94);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 10px 30px rgba(34, 24, 21, 0.13);
  backdrop-filter: blur(10px);
}

@media (max-width: 1100px) {
  .dataset-project-map,
  .dataset-overview-grid,
  .dataset-detail-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataset-project-map article:nth-child(2),
  .dataset-detail-summary > div:nth-child(2) {
    border-right: 0;
  }
  .dataset-project-map article:last-child {
    grid-column: 1/-1;
    border-top: 1px solid var(--review-line-soft);
  }
  .dataset-overview-grid article:last-child {
    grid-column: 1/-1;
  }
  .dataset-detail-summary > div:nth-child(n+3) {
    border-top: 1px solid var(--review-line-soft);
  }
  .dataset-create-source-grid,
  .dataset-detail-grid {
    grid-template-columns: 1fr;
  }
  .dataset-create-selection {
    position: static;
  }
  .dataset-source-options {
    max-height: 420px;
  }
}
@media (max-width: 760px) {
  .dataset-page-heading,
  .dataset-detail-header,
  .dataset-create-header {
    align-items: stretch;
    flex-direction: column;
    gap: 14px;
    padding: 17px;
  }
  .dataset-detail-header__copy > div {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-page-heading .dataset-button,
  .dataset-detail-header .dataset-button {
    width: 100%;
  }
  .dataset-project-map,
  .dataset-overview-grid,
  .dataset-record-card__metrics,
  .dataset-detail-summary,
  .dataset-create-output-grid,
  .dataset-create-review-grid {
    grid-template-columns: 1fr;
  }
  .dataset-project-map article,
  .dataset-project-map article:nth-child(2),
  .dataset-project-map article:last-child,
  .dataset-record-card__metrics > div,
  .dataset-detail-summary > div,
  .dataset-detail-summary > div:nth-child(2),
  .dataset-detail-summary > div:nth-child(n+3) {
    grid-column: auto;
    border-top: 0;
    border-right: 0;
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-project-map article:last-child,
  .dataset-record-card__metrics > div:last-child,
  .dataset-detail-summary > div:last-child {
    border-bottom: 0;
  }
  .dataset-overview-grid article:last-child {
    grid-column: auto;
  }
  .dataset-record-card__header,
  .dataset-section-heading,
  .dataset-card-heading,
  .dataset-create-stage__header,
  .dataset-connection-strip {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-create-stepper {
    display: flex;
    overflow-x: auto;
  }
  .dataset-create-stepper li {
    flex: 0 0 210px;
  }
  .dataset-connection-strip > div {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .dataset-connection-strip small {
    width: 100%;
    padding-left: 16px;
    white-space: normal;
  }
  .dataset-create-fields,
  .dataset-create-fields--advanced {
    grid-template-columns: 1fr;
  }
  .dataset-create-fields .is-wide {
    grid-column: auto;
  }
}
@media (max-width: 520px) {
  .dataset-page-heading h2,
  .dataset-detail-header h2,
  .dataset-create-header h2 {
    font-size: 20px;
  }
  .dataset-detail-tabs,
  .dataset-record-card__actions,
  .dataset-detail-actions,
  .dataset-create-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .dataset-detail-tabs button,
  .dataset-record-card__actions .dataset-button,
  .dataset-detail-actions .dataset-button,
  .dataset-create-actions .dataset-button {
    width: 100%;
  }
  .dataset-source-option {
    grid-template-columns: 22px minmax(0, 1fr);
  }
  .dataset-source-option__state {
    grid-column: 2;
    width: fit-content;
  }
  .dataset-readonly-materials article,
  .dataset-create-selection__list article,
  .dataset-review-materials article {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-definition-list > div {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  .dataset-setting-summary,
  .dataset-review-outputs {
    grid-template-columns: 1fr;
  }
}
/* Dataset list: one clear flow and a scan-friendly row list without card chrome. */
.dataset-top-create-button {
  min-height: 42px;
  padding-inline: 18px;
}

.dataset-hub {
  gap: 0;
}

.dataset-hub.ops-page {
  background: transparent;
}

.dataset-hub .dataset-project-map {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 36px;
  overflow: visible;
  padding: 2px 0 26px;
  border: 0;
  border-bottom: 1px solid var(--review-line);
  border-radius: 0;
  background: transparent;
}

.dataset-hub .dataset-project-map article,
.dataset-hub .dataset-project-map article:nth-child(2),
.dataset-hub .dataset-project-map article:last-child {
  position: relative;
  grid-column: auto;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 12px;
  min-height: 64px;
  padding: 10px 0;
  border: 0;
}

.dataset-hub .dataset-project-map article:not(:last-child)::after {
  position: absolute;
  z-index: 0;
  top: 29px;
  right: -20px;
  left: 38px;
  height: 1px;
  content: "";
  background: #cfd4c8;
}

.dataset-hub .dataset-project-map article > span {
  position: relative;
  z-index: 1;
  width: 36px;
  height: 36px;
  border: 1px solid #cad5bd;
  border-radius: 50%;
  background: var(--review-canvas);
}

.dataset-hub .dataset-project-map article > div {
  position: relative;
  z-index: 1;
  padding-right: 12px;
  background: var(--review-canvas);
}

.dataset-hub .dataset-project-map strong {
  font-size: 14px;
}

.dataset-hub .dataset-project-map p {
  max-width: 280px;
  margin-top: 3px;
  font-size: 12px;
}

.dataset-hub .dataset-list-section {
  overflow: visible;
  padding-top: 26px;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.dataset-hub .dataset-section-heading {
  min-height: 0;
  align-items: flex-end;
  padding: 0 0 16px;
  border: 0;
  background: transparent;
}

.dataset-hub .dataset-section-heading h2 {
  margin: 4px 0 0;
  color: var(--review-ink);
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.dataset-hub .dataset-section-heading h2 strong {
  color: var(--review-primary);
}

.dataset-hub .dataset-section-heading div > p {
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-list-recent {
  margin: 0;
  color: var(--review-muted);
  font-size: 12px;
  white-space: nowrap;
}

.dataset-list-recent strong {
  color: var(--review-ink);
  font-weight: 700;
}

.dataset-list-table {
  border-top: 1px solid var(--review-line);
}

.dataset-list-table__head,
.dataset-list-row {
  display: grid;
  grid-template-columns: minmax(250px, 1.35fr) minmax(150px, 0.7fr) minmax(210px, 1fr) minmax(180px, 0.8fr) minmax(200px, auto);
  align-items: center;
}

.dataset-list-table__head {
  min-height: 40px;
  color: var(--review-muted);
  background: rgba(75, 103, 42, 0.055);
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-list-table__head span {
  padding: 0 16px;
  font-size: 12px;
  font-weight: 700;
}

.dataset-list-table__head span:last-child {
  text-align: right;
}

.dataset-list-row {
  min-height: 116px;
  border-bottom: 1px solid var(--review-line);
  transition: background 150ms ease;
}

.dataset-list-row:hover {
  background: rgba(255, 255, 255, 0.46);
}

.dataset-list-cell {
  min-width: 0;
  padding: 18px 16px;
}

.dataset-list-cell > strong,
.dataset-list-cell > small {
  display: block;
}

.dataset-list-cell > strong {
  overflow: hidden;
  color: var(--review-ink);
  font-size: 14px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-list-cell > small {
  overflow: hidden;
  margin-top: 5px;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-list-cell::before,
.dataset-list-actions::before {
  display: none;
  content: attr(data-label);
}

.dataset-list-cell--identity > span {
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
}

.dataset-list-cell--identity h3 {
  margin: 4px 0 0;
  color: var(--review-ink);
  font-size: 18px;
  font-weight: 700;
}

.dataset-list-cell--identity > p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-list-meta {
  display: flex;
  min-width: 0;
  gap: 8px;
  margin-top: 9px;
  color: var(--review-subtle);
  font-size: 12px;
  white-space: nowrap;
}

.dataset-list-meta span {
  overflow: hidden;
  padding-right: 8px;
  border-right: 1px solid var(--review-line);
  text-overflow: ellipsis;
}

.dataset-list-meta span:last-child {
  padding-right: 0;
  border-right: 0;
}

.dataset-list-cell--status {
  display: grid;
  justify-items: start;
  gap: 6px;
}

.dataset-list-cell--status small {
  margin-top: 0;
}

.dataset-list-actions {
  display: flex;
  justify-content: flex-end;
  gap: 7px;
  padding: 18px 0 18px 16px;
}

.dataset-list-actions .dataset-button {
  min-height: 36px;
  padding-inline: 11px;
  white-space: nowrap;
}

@media (max-width: 980px) {
  .dataset-list-table__head {
    display: none;
  }
  .dataset-list-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
    padding: 12px 0 14px;
  }
  .dataset-list-cell,
  .dataset-list-actions {
    padding: 10px 12px;
  }
  .dataset-list-cell--identity {
    grid-column: 1/-1;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-list-cell::before,
  .dataset-list-actions::before {
    display: block;
    margin-bottom: 6px;
    color: var(--review-subtle);
    font-size: 12px;
    font-weight: 700;
  }
  .dataset-list-cell--identity::before {
    display: none;
  }
  .dataset-list-actions {
    align-items: flex-end;
    flex-wrap: wrap;
  }
  .dataset-list-actions::before {
    width: 100%;
    text-align: right;
  }
}
@media (max-width: 760px) {
  .dataset-top-create-button {
    width: 100%;
  }
  .dataset-hub .dataset-project-map {
    grid-template-columns: 1fr;
    gap: 0;
    padding-bottom: 18px;
  }
  .dataset-hub .dataset-project-map article,
  .dataset-hub .dataset-project-map article:nth-child(2),
  .dataset-hub .dataset-project-map article:last-child {
    grid-template-columns: 38px minmax(0, 1fr);
    padding: 8px 0;
  }
  .dataset-hub .dataset-project-map article:not(:last-child)::after {
    top: 38px;
    right: auto;
    bottom: -8px;
    left: 17px;
    width: 1px;
    height: auto;
  }
  .dataset-hub .dataset-project-map article > div {
    padding-right: 0;
  }
  .dataset-hub .dataset-section-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
  .dataset-list-recent {
    white-space: normal;
  }
}
@media (max-width: 560px) {
  .dataset-list-row {
    grid-template-columns: 1fr;
  }
  .dataset-list-cell--identity {
    grid-column: auto;
  }
  .dataset-list-actions,
  .dataset-list-actions::before {
    justify-content: flex-start;
    text-align: left;
  }
  .dataset-list-actions .dataset-button {
    flex: 1;
  }
}
/* Selected master-detail direction for the dataset list. */
.dataset-hub {
  gap: 0;
}

.dataset-top-create-button {
  min-height: 44px;
  padding-inline: 20px;
  box-shadow: 0 9px 22px rgba(61, 80, 40, 0.15);
}

.dataset-flow-band {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr);
  align-items: center;
  gap: 24px;
  min-height: 112px;
  padding: 18px 8px;
  border-bottom: 1px solid var(--review-line);
}

.dataset-flow-band > h2 {
  margin: 0;
  color: var(--review-ink);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.dataset-flow-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 38px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataset-flow-steps li {
  position: relative;
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.dataset-flow-steps li:not(:last-child)::after {
  position: absolute;
  top: 23px;
  right: -24px;
  left: calc(100% - 4px);
  height: 1px;
  content: "";
  background: #c8ccbf;
}

.dataset-flow-steps li > span {
  display: grid;
  width: 46px;
  height: 46px;
  color: var(--review-primary);
  font-size: 13px;
  font-weight: 700;
  place-items: center;
  border: 1px solid #aebd9d;
  border-radius: 50%;
  background: #fbfcf8;
}

.dataset-flow-steps strong,
.dataset-flow-steps p {
  display: block;
}

.dataset-flow-steps strong {
  color: var(--review-ink);
  font-size: 14px;
  font-weight: 700;
}

.dataset-flow-steps p {
  overflow: hidden;
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-hub .dataset-list-section {
  overflow: visible;
  padding-top: 22px;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.dataset-hub .dataset-section-heading {
  min-height: 90px;
  align-items: center;
  padding: 0 8px 18px;
  border: 0;
  background: transparent;
}

.dataset-hub .dataset-section-heading h2 {
  margin: 0;
  color: var(--review-ink);
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.dataset-hub .dataset-section-heading h2 strong {
  color: var(--review-primary);
}

.dataset-hub .dataset-section-heading div > p {
  margin: 8px 0 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-list-recent {
  margin: 0;
  color: var(--review-muted);
  font-size: 12px;
  white-space: nowrap;
}

.dataset-list-recent strong {
  color: var(--review-ink);
  font-weight: 700;
}

.dataset-workspace {
  display: grid;
  grid-template-columns: minmax(390px, 0.92fr) minmax(560px, 1.08fr);
  min-height: 480px;
  border-top: 1px solid var(--review-line);
  border-bottom: 1px solid var(--review-line);
}

.dataset-master {
  min-width: 0;
  border-right: 1px solid var(--review-line);
}

.dataset-master__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 56px;
  padding: 0 16px;
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-master__header > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dataset-master__header h3 {
  margin: 0;
  color: var(--review-ink);
  font-size: 13px;
  font-weight: 700;
}

.dataset-master__header > div > span {
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
}

.dataset-sort-button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 4px;
  color: var(--review-muted);
  cursor: pointer;
  border: 0;
  background: transparent;
}

.dataset-sort-button:hover {
  color: var(--review-ink);
}

.dataset-sort-button i {
  font-size: 12px;
  transition: transform 160ms ease;
}

.dataset-sort-button i.is-reversed {
  transform: rotate(180deg);
}

.dataset-master-row {
  position: relative;
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  width: 100%;
  min-height: 102px;
  padding: 14px 18px;
  color: inherit;
  text-align: left;
  cursor: pointer;
  border: 0;
  border-bottom: 1px solid var(--review-line-soft);
  background: transparent;
  transition: background 150ms ease, box-shadow 150ms ease;
}

.dataset-master-row:hover {
  background: rgba(75, 103, 42, 0.045);
}

.dataset-master-row.is-selected {
  background: #f2f6ec;
  box-shadow: inset 6px 0 0 var(--review-primary);
}

.dataset-master-row__icon {
  display: grid;
  width: 44px;
  height: 44px;
  color: var(--review-primary);
  place-items: center;
  border: 1px solid #b9c7a9;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.7);
}

.dataset-master-row__icon i {
  font-size: 16px;
}

.dataset-master-row__main,
.dataset-master-row__title,
.dataset-master-row__state {
  display: flex;
  min-width: 0;
  align-items: center;
}

.dataset-master-row__main {
  align-items: flex-start;
  flex-direction: column;
  gap: 7px;
}

.dataset-master-row__title {
  gap: 14px;
}

.dataset-master-row__title strong {
  overflow: hidden;
  color: var(--review-ink);
  font-size: 15px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-master-row__title em {
  color: var(--review-muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.dataset-master-row__state {
  gap: 8px;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-master-row__state strong {
  color: var(--review-primary);
  font-weight: 700;
}

.dataset-master-row__summary {
  padding-left: 16px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  border-left: 1px solid var(--review-line);
}

.dataset-preview {
  min-width: 0;
  padding: 28px 32px 26px;
}

.dataset-preview__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 22px;
  min-height: 90px;
  padding: 0 0 22px;
  border-bottom: 1px solid var(--review-line);
}

.dataset-preview__header > div:first-child > span {
  display: block;
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.dataset-preview__title {
  display: flex;
  align-items: baseline;
  gap: 14px;
  margin-top: 10px;
}

.dataset-preview__title h3 {
  margin: 0;
  color: var(--review-ink);
  font-size: 29px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.dataset-preview__title strong {
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.dataset-preview__actions {
  display: flex;
  gap: 8px;
  padding-bottom: 1px;
}

.dataset-preview__actions .dataset-button {
  min-height: 40px;
  padding-inline: 15px;
  white-space: nowrap;
}

.dataset-preview__metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 32px 0 30px;
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-preview__metrics > div {
  min-width: 0;
  padding: 0 24px;
  border-right: 1px dashed var(--review-line);
}

.dataset-preview__metrics > div:first-child {
  padding-left: 8px;
}

.dataset-preview__metrics > div:last-child {
  padding-right: 8px;
  border-right: 0;
}

.dataset-preview__metrics span,
.dataset-preview__metrics strong,
.dataset-preview__metrics small {
  display: block;
}

.dataset-preview__metrics span {
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.dataset-preview__metrics strong {
  overflow: hidden;
  margin-top: 20px;
  color: var(--review-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-preview__metrics small {
  overflow: hidden;
  margin-top: 11px;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-preview__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  padding: 20px 8px 0;
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-preview__meta span {
  padding: 0 13px;
  border-right: 1px solid var(--review-line);
}

.dataset-preview__meta span:first-child {
  padding-left: 0;
}

.dataset-preview__meta span:last-child {
  padding-right: 0;
  border-right: 0;
}

@media (max-width: 1120px) {
  .dataset-flow-band {
    grid-template-columns: 1fr;
    gap: 14px;
    padding-block: 20px;
  }
  .dataset-workspace {
    grid-template-columns: minmax(330px, 0.8fr) minmax(470px, 1.2fr);
  }
  .dataset-master-row {
    grid-template-columns: 44px minmax(0, 1fr);
  }
  .dataset-master-row__summary {
    grid-column: 2;
    padding: 0;
    border-left: 0;
  }
  .dataset-preview {
    padding-inline: 24px;
  }
  .dataset-preview__header {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 900px) {
  .dataset-flow-steps {
    gap: 18px;
  }
  .dataset-flow-steps li {
    grid-template-columns: 40px minmax(0, 1fr);
    gap: 10px;
  }
  .dataset-flow-steps li > span {
    width: 40px;
    height: 40px;
  }
  .dataset-flow-steps li:not(:last-child)::after {
    display: none;
  }
  .dataset-flow-steps p {
    white-space: normal;
  }
  .dataset-workspace {
    grid-template-columns: 1fr;
  }
  .dataset-master {
    border-right: 0;
    border-bottom: 1px solid var(--review-line);
  }
  .dataset-preview {
    min-height: 390px;
  }
  .dataset-preview__header {
    align-items: flex-end;
    flex-direction: row;
  }
}
@media (max-width: 680px) {
  .dataset-top-create-button {
    width: 100%;
  }
  .dataset-flow-band {
    grid-template-columns: 1fr;
    padding-inline: 0;
  }
  .dataset-flow-steps {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .dataset-flow-steps li {
    min-height: 54px;
  }
  .dataset-flow-steps li:not(:last-child)::after {
    display: block;
    top: 40px;
    right: auto;
    bottom: -12px;
    left: 19px;
    width: 1px;
    height: auto;
  }
  .dataset-hub .dataset-section-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
    min-height: 0;
    padding: 22px 0 18px;
  }
  .dataset-list-recent {
    white-space: normal;
  }
  .dataset-master-row {
    grid-template-columns: 42px minmax(0, 1fr);
    padding-inline: 14px;
  }
  .dataset-preview {
    padding: 24px 16px;
  }
  .dataset-preview__header {
    align-items: stretch;
    flex-direction: column;
  }
  .dataset-preview__actions .dataset-button {
    flex: 1;
  }
  .dataset-preview__metrics {
    grid-template-columns: 1fr;
    gap: 0;
    padding-block: 18px;
  }
  .dataset-preview__metrics > div,
  .dataset-preview__metrics > div:first-child,
  .dataset-preview__metrics > div:last-child {
    padding: 16px 0;
    border-right: 0;
    border-bottom: 1px dashed var(--review-line);
  }
  .dataset-preview__metrics > div:last-child {
    border-bottom: 0;
  }
  .dataset-preview__metrics strong {
    margin-top: 7px;
  }
  .dataset-preview__metrics small {
    margin-top: 5px;
    white-space: normal;
  }
}
/* QA generation — readable split workspace */
.review-project-header.is-qa-generation-header .review-project-header__inner > div {
  padding: 0;
}

.project-generation-page-title.is-qa {
  grid-template-columns: auto auto auto auto minmax(110px, 1fr) auto;
  gap: 12px;
  min-height: 40px;
}

.project-generation-page-title.is-qa strong {
  font-size: 22px;
  letter-spacing: -0.035em;
}

.project-generation-page-title.is-qa span {
  min-height: 26px;
  padding: 0 10px;
  font-size: 12px;
}

.project-generation-page-title.is-qa b,
.project-generation-page-title.is-qa em,
.project-generation-page-title.is-qa code,
.project-generation-page-title.is-qa time {
  font-size: 12px;
}

main.is-generation-main.is-qa-generation-main .project-output-settings {
  width: 100%;
}

main.is-generation-main .project-output-workspace__layout.is-qa {
  grid-template-columns: minmax(0, 1fr) 404px;
  min-height: calc(100vh - 102px);
  background: #fff;
  box-shadow: 0 1px 0 #dfe4e8, 0 10px 28px rgba(20, 29, 38, 0.06);
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials,
main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-card {
  min-height: calc(100vh - 102px);
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials {
  box-shadow: inset -1px 0 #dfe4e8;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__section-header {
  min-height: 118px;
  padding: 26px 28px 22px;
  box-shadow: inset 0 -1px #e2e6ea;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__section-header h3 {
  margin-top: 5px;
  font-size: 20px;
  letter-spacing: -0.03em;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__section-header p {
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.55;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__section-header > strong {
  padding: 8px 11px;
  font-size: 12px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__filters {
  grid-template-columns: minmax(260px, 1fr) auto;
  gap: 18px;
  padding: 18px 28px;
  box-shadow: inset 0 -1px #e2e6ea;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-generation-field > span {
  margin-bottom: 8px;
  font-size: 12px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-generation-search input {
  min-height: 40px;
  font-size: 12px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-generation-search button {
  width: 40px;
  min-height: 40px;
}

.qa-generation-source-tools {
  gap: 12px;
  min-height: 40px;
}

.qa-generation-source-tools button {
  min-height: 40px;
  padding: 0 14px;
  box-shadow: inset 0 0 0 1px #d6dce2;
}

.qa-generation-source-tools button.is-active {
  box-shadow: inset 0 0 0 1px #6ca8a5;
}

.qa-generation-source-tools button.is-refresh {
  width: 40px;
  box-shadow: inset 0 0 0 1px #d6dce2;
}

.qa-generation-source-tools > span,
.qa-generation-filter-panel {
  font-size: 12px;
}

.qa-generation-filter-panel {
  min-height: 42px;
  padding: 0 28px;
  box-shadow: inset 0 -1px #e2e6ea;
}

.project-generation-source-table__head.is-qa,
main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
  grid-template-columns: 36px minmax(230px, 1.65fr) 108px 72px 118px 128px;
  gap: 12px;
  padding-right: 28px;
  padding-left: 28px;
}

.project-generation-source-table__head.is-qa {
  min-height: 46px;
  box-shadow: inset 0 -1px #e2e6ea;
}

main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
  min-height: 62px;
  padding-top: 10px;
  padding-bottom: 10px;
  box-shadow: inset 0 -1px #e4e7ea;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-generation-source-table__footer {
  min-height: 62px;
  padding: 0 28px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-header {
  min-height: 66px;
  padding: 0 24px;
  box-shadow: inset 0 -1px #e2e6ea;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-header h2 {
  font-size: 17px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__generation-body {
  padding: 0 24px 24px;
}

.project-output-workspace__selected-overview.is-qa {
  padding: 22px 0;
  box-shadow: inset 0 -1px #e2e6ea;
}

.project-output-workspace__selected-overview.is-qa > div + div {
  padding-left: 22px;
  box-shadow: inset 1px 0 #dfe4e8;
}

.project-output-workspace__selected-overview.is-qa span {
  font-size: 12px;
}

.project-output-workspace__selected-overview.is-qa b {
  font-size: 32px;
}

.project-output-workspace__selected-overview.is-qa em {
  font-size: 12px;
}

.qa-generation-completion,
.qa-generation-checklist {
  padding: 20px 0;
  box-shadow: inset 0 -1px #e2e6ea;
}

.qa-generation-completion h3,
.qa-generation-checklist h3,
.qa-generation-completion strong,
.project-output-workspace__estimate h3,
.project-output-workspace__configuration-heading h3 {
  font-size: 12px;
}

.qa-generation-checklist ul {
  gap: 12px;
  margin-top: 15px;
}

.qa-generation-checklist li {
  grid-template-columns: 18px minmax(0, 1fr) auto;
  font-size: 12px;
}

.qa-generation-checklist li b {
  font-size: 12px;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__configuration dl > div,
main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__configuration dl > div.is-wide {
  grid-template-columns: 104px minmax(0, 1fr);
  padding: 9px 0;
}

main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__configuration dt,
main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__configuration dd,
main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__configuration dl > div.is-wide dd,
main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__configuration dl > div.is-stat dd {
  font-size: 12px;
  line-height: 1.45;
}

.qa-generation-guide {
  margin-top: 10px;
  padding: 13px 14px;
  font-size: 12px;
  line-height: 1.5;
}

main.is-generation-main .project-output-workspace__run.is-qa {
  min-height: 52px;
}

@media (max-width: 1280px) {
  main.is-generation-main .project-output-workspace__layout.is-qa {
    grid-template-columns: minmax(0, 1fr) 360px;
  }
  .project-generation-source-table__head.is-qa,
  main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
    grid-template-columns: 32px minmax(180px, 1.5fr) 92px 62px 96px 104px;
    gap: 9px;
  }
}
@media (max-width: 1180px) {
  .review-project-header.is-qa-generation-header .review-project-header__inner,
  main.is-generation-main.is-qa-generation-main {
    max-width: none;
    padding-right: 20px;
    padding-left: 20px;
  }
  main.is-generation-main .project-output-workspace__layout.is-qa {
    grid-template-columns: minmax(0, 1fr);
  }
  main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials {
    box-shadow: none;
  }
}
/* Dataset lineage ledger: one connected operational story, without card stacks. */
.review-workspace {
  background: #f6f7f3;
}

.dataset-hub {
  gap: 0;
}

.dataset-top-create-button {
  min-height: 44px;
  padding-inline: 20px;
  box-shadow: 0 10px 24px rgba(61, 80, 40, 0.16);
}

.dataset-top-create-button:hover {
  box-shadow: 0 13px 30px rgba(61, 80, 40, 0.2);
  transform: translateY(-1px);
}

.dataset-flow-band {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  align-items: center;
  gap: 34px;
  min-height: 118px;
  padding: 22px 2px;
  border-top: 1px solid rgba(213, 211, 204, 0.72);
  border-bottom: 1px solid var(--review-line);
  background: transparent;
}

.dataset-flow-band__heading span,
.dataset-flow-band__heading h2 {
  display: block;
}

.dataset-flow-band__heading span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.dataset-flow-band__heading h2 {
  margin: 7px 0 0;
  color: var(--review-ink);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.dataset-flow-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 38px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.dataset-flow-steps li {
  position: relative;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: center;
  gap: 13px;
  min-width: 0;
}

.dataset-flow-steps li:not(:last-child)::after {
  position: absolute;
  z-index: 0;
  top: 21px;
  right: -27px;
  left: calc(100% - 2px);
  height: 1px;
  content: "";
  background: #c8ccbf;
}

.dataset-flow-steps__number {
  position: relative;
  z-index: 1;
  display: grid;
  width: 42px;
  height: 42px;
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
  place-items: center;
  border: 1px solid #aebd9d;
  border-radius: 50%;
  background: #f6f7f3;
}

.dataset-flow-steps strong,
.dataset-flow-steps p {
  display: block;
}

.dataset-flow-steps strong {
  color: var(--review-ink);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.dataset-flow-steps p {
  overflow: hidden;
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.5;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-hub .dataset-list-section {
  overflow: visible;
  padding-top: 30px;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.dataset-hub .dataset-section-heading {
  min-height: 88px;
  align-items: flex-end;
  padding: 0 2px 20px;
  border: 0;
  background: transparent;
}

.dataset-hub .dataset-section-heading h2 {
  margin: 0;
  color: var(--review-ink);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.dataset-hub .dataset-section-heading h2 strong {
  color: var(--review-primary);
}

.dataset-hub .dataset-section-heading div > p {
  margin: 8px 0 0;
  color: var(--review-muted);
  font-size: 13px;
  line-height: 1.5;
}

.dataset-list-recent {
  margin: 0 0 2px;
  color: var(--review-muted);
  font-size: 12px;
  white-space: nowrap;
}

.dataset-list-recent strong {
  color: var(--review-ink);
  font-weight: 700;
}

.dataset-ledger {
  border-top: 1px solid var(--review-line);
  border-bottom: 1px solid var(--review-line);
}

.dataset-ledger__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 52px;
  padding: 0 16px;
  color: var(--review-muted);
  border-bottom: 1px solid var(--review-line-soft);
}

.dataset-ledger__header > div {
  display: flex;
  align-items: center;
  gap: 9px;
}

.dataset-ledger__header h3 {
  margin: 0;
  color: var(--review-ink);
  font-size: 13px;
  font-weight: 700;
}

.dataset-ledger__header span {
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
}

.dataset-ledger__header p {
  margin: 0;
  font-size: 12px;
}

.dataset-ledger__list {
  min-width: 0;
}

.dataset-lineage-row {
  display: grid;
  grid-template-columns: minmax(230px, 1.24fr) 16px minmax(150px, 0.76fr) 16px minmax(180px, 0.92fr) 16px minmax(145px, 0.72fr) 16px minmax(170px, 0.86fr) auto;
  align-items: stretch;
  min-width: 0;
  min-height: 164px;
  padding: 0 16px;
  background: transparent;
  transition: background 160ms ease;
}

.dataset-lineage-row:hover {
  background: rgba(240, 245, 233, 0.72);
}

.dataset-lineage-node {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  align-content: center;
  align-items: start;
  gap: 12px;
  min-width: 0;
  padding: 26px 10px;
}

.dataset-lineage-node--identity {
  grid-template-columns: 44px minmax(0, 1fr);
  padding-left: 0;
}

.dataset-lineage-icon {
  display: grid;
  width: 38px;
  height: 38px;
  color: var(--review-primary);
  font-size: 14px;
  place-items: center;
  border: 1px solid #b9c7a9;
  border-radius: 50%;
  background: #f6f7f3;
}

.dataset-lineage-node--identity .dataset-lineage-icon {
  width: 42px;
  height: 42px;
}

.dataset-lineage-node--complete .dataset-lineage-icon {
  color: #3f6122;
  border-color: #aebf99;
  background: #eef4e7;
}

.dataset-lineage-node--next .dataset-lineage-icon {
  color: var(--review-orange);
  border-color: #ddbaa3;
  background: #fff7f1;
}

.dataset-lineage-label,
.dataset-lineage-node strong,
.dataset-lineage-node p,
.dataset-lineage-node small {
  display: block;
}

.dataset-lineage-label {
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.035em;
}

.dataset-lineage-title {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 9px;
  margin-top: 7px;
}

.dataset-lineage-title h4 {
  overflow: hidden;
  margin: 0;
  color: var(--review-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.025em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-lineage-title em {
  color: var(--review-primary);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.dataset-lineage-node strong {
  overflow: hidden;
  margin-top: 8px;
  color: var(--review-ink);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-lineage-node p {
  overflow: hidden;
  margin: 6px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-lineage-node small {
  overflow: hidden;
  margin-top: 7px;
  color: var(--review-subtle);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-lineage-node--identity > div > p {
  margin-top: 6px;
}

.dataset-lineage-meta {
  display: flex;
  min-width: 0;
  gap: 0;
  margin-top: 10px;
  color: var(--review-subtle);
  font-size: 12px;
}

.dataset-lineage-meta span {
  overflow: hidden;
  padding: 0 8px;
  border-right: 1px solid var(--review-line);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-lineage-meta span:first-child {
  padding-left: 0;
}

.dataset-lineage-meta span:last-child {
  padding-right: 0;
  border-right: 0;
}

.dataset-lineage-arrow {
  align-self: center;
  color: #9ca591;
  font-size: 12px;
  text-align: center;
}

.dataset-lineage-actions {
  display: flex;
  min-width: 172px;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  margin: 30px 0 30px 14px;
  padding-left: 16px;
  border-left: 1px solid var(--review-line);
}

.dataset-lineage-actions .dataset-button {
  min-height: 40px;
  padding-inline: 13px;
  white-space: nowrap;
}

.dataset-lineage-row button:focus-visible,
.dataset-top-create-button:focus-visible {
  outline: 3px solid rgba(75, 103, 42, 0.24);
  outline-offset: 3px;
}

@media (max-width: 1280px) {
  .dataset-lineage-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 0;
    padding-block: 6px;
  }
  .dataset-lineage-arrow {
    display: none;
  }
  .dataset-lineage-node {
    min-height: 128px;
    padding: 22px 18px;
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-lineage-node:nth-of-type(2),
  .dataset-lineage-node:nth-of-type(3),
  .dataset-lineage-node:nth-of-type(4),
  .dataset-lineage-node:nth-of-type(5) {
    border-left: 1px solid var(--review-line-soft);
  }
  .dataset-lineage-node--identity {
    padding-left: 0;
  }
  .dataset-lineage-actions {
    min-width: 0;
    justify-content: flex-start;
    margin: 0;
    padding: 22px 18px;
    border-left: 1px solid var(--review-line-soft);
  }
}
@media (max-width: 900px) {
  .dataset-flow-band {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .dataset-flow-steps {
    gap: 20px;
  }
  .dataset-flow-steps li:not(:last-child)::after {
    display: none;
  }
  .dataset-flow-steps p {
    white-space: normal;
  }
  .dataset-lineage-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataset-lineage-node--identity {
    padding-left: 18px;
  }
  .dataset-lineage-actions {
    border-top: 1px solid var(--review-line-soft);
  }
}
@media (max-width: 680px) {
  .dataset-top-create-button {
    width: 100%;
  }
  .dataset-flow-band {
    padding-block: 20px;
  }
  .dataset-flow-steps {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .dataset-flow-steps li {
    min-height: 48px;
  }
  .dataset-hub .dataset-section-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
    min-height: 0;
    padding-bottom: 18px;
  }
  .dataset-list-recent {
    white-space: normal;
  }
  .dataset-ledger__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
    padding-block: 14px;
  }
  .dataset-lineage-row {
    grid-template-columns: 1fr;
    padding: 0;
  }
  .dataset-lineage-node,
  .dataset-lineage-node--identity {
    min-height: 0;
    padding: 20px 16px;
    border-left: 0 !important;
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-lineage-actions {
    justify-content: stretch;
    padding: 18px 16px;
    border: 0;
  }
  .dataset-lineage-actions .dataset-button {
    flex: 1;
  }
}
/* Independent surfaces: white belongs to each meaningful component, never the whole page. */
.dataset-flow-band {
  padding: 24px 28px;
  border: 1px solid var(--review-line-soft);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(34, 24, 21, 0.045);
}

.dataset-flow-steps__number {
  background: #f6f7f3;
}

.dataset-hub .dataset-list-section {
  padding-top: 28px;
}

.dataset-hub .dataset-section-heading {
  padding-inline: 4px;
}

.dataset-ledger {
  border: 0;
}

.dataset-ledger__header {
  min-height: 46px;
  padding: 0 4px 12px;
  border: 0;
  background: transparent;
}

.dataset-lineage-row {
  overflow: hidden;
  padding-inline: 20px;
  border: 1px solid var(--review-line-soft);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(34, 24, 21, 0.05);
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.dataset-lineage-row:hover {
  border-color: #cbd3c1;
  background: #fff;
  box-shadow: 0 14px 34px rgba(34, 24, 21, 0.075);
  transform: translateY(-1px);
}

.dataset-lineage-icon {
  background: #f6f7f3;
}

@media (max-width: 900px) {
  .dataset-flow-band {
    padding: 24px;
  }
}
@media (max-width: 680px) {
  .dataset-flow-band {
    padding: 20px 18px;
    border-radius: 14px;
  }
  .dataset-ledger__header {
    padding-inline: 4px;
  }
  .dataset-lineage-row {
    border-radius: 14px;
  }
}
/* Dataset view modes and explicit progress states. */
.dataset-ledger__controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.dataset-view-toggle {
  display: inline-flex;
  padding: 3px;
  border: 1px solid var(--review-line);
  border-radius: 9px;
  background: #eeefea;
}

.dataset-view-toggle button {
  display: inline-flex;
  min-height: 31px;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  color: var(--review-muted);
  cursor: pointer;
  border: 0;
  background: transparent;
  transition: color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.dataset-view-toggle button:hover {
  color: var(--review-ink);
}

.dataset-view-toggle button.is-active {
  color: var(--review-primary-dark);
  background: #fff;
  box-shadow: 0 1px 4px rgba(34, 24, 21, 0.1);
}

.dataset-view-toggle button:focus-visible {
  outline: 2px solid rgba(75, 103, 42, 0.26);
  outline-offset: 1px;
}

.dataset-lineage-row {
  min-height: 190px;
}

.dataset-lineage-node {
  grid-template-columns: 46px minmax(0, 1fr);
  align-content: start;
  padding-top: 30px;
  padding-bottom: 26px;
}

.dataset-lineage-node--identity {
  grid-template-columns: 46px minmax(0, 1fr);
  padding-left: 16px;
}

.dataset-lineage-icon,
.dataset-lineage-node--identity .dataset-lineage-icon {
  width: 42px;
  height: 42px;
}

.dataset-lineage-node--identity .dataset-lineage-icon {
  color: #fff;
  border-color: var(--review-primary);
  background: var(--review-primary);
}

.dataset-lineage-title h4 {
  font-size: 23px;
  letter-spacing: -0.035em;
}

.dataset-lineage-title em {
  padding: 3px 7px;
  border-radius: 6px;
  background: var(--review-primary-soft);
}

.dataset-lineage-node--done .dataset-lineage-icon {
  color: var(--review-primary);
  border-color: #b4c49f;
  background: #f1f6eb;
}

.dataset-lineage-node--current .dataset-lineage-icon {
  color: #fff;
  border-color: var(--review-primary);
  background: var(--review-primary);
}

.dataset-lineage-node--current .dataset-lineage-label,
.dataset-lineage-node--current strong {
  color: var(--review-primary-dark);
}

.dataset-lineage-node--pending .dataset-lineage-icon {
  color: #aaa7a1;
  border-color: #d7d4ce;
  background: #f5f5f2;
}

.dataset-lineage-node--pending .dataset-lineage-label,
.dataset-lineage-node--pending strong,
.dataset-lineage-node--pending p {
  color: #a09c95;
}

.dataset-lineage-arrow {
  color: var(--review-primary);
  opacity: 0.58;
}

.dataset-lineage-arrow.is-pending {
  color: #b5b2ac;
  opacity: 1;
}

.dataset-progress-summary {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 2px 8px;
  margin-top: 13px;
}

.dataset-progress-summary > span {
  grid-row: 1/span 2;
  padding: 5px 7px;
  color: var(--review-primary-dark);
  font-size: 12px;
  font-weight: 700;
  border-radius: 7px;
  background: var(--review-primary-soft);
}

.dataset-progress-summary strong,
.dataset-progress-summary small {
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-progress-summary strong {
  color: var(--review-primary-dark);
  font-size: 12px;
  font-weight: 700;
}

.dataset-progress-summary small {
  color: var(--review-muted);
  font-size: 12px;
}

.dataset-compact-table {
  overflow: hidden;
  border: 1px solid var(--review-line-soft);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(34, 24, 21, 0.05);
}

.dataset-compact-head,
.dataset-compact-row {
  display: grid;
  grid-template-columns: minmax(260px, 1.25fr) minmax(150px, 0.7fr) minmax(180px, 0.85fr) minmax(210px, 0.95fr) minmax(180px, auto);
  align-items: center;
}

.dataset-compact-head {
  min-height: 42px;
  padding: 0 18px;
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fafbf8;
}

.dataset-compact-head span {
  padding-inline: 12px;
}

.dataset-compact-head span:last-child {
  text-align: right;
}

.dataset-compact-row {
  min-height: 126px;
  padding: 0 18px;
}

.dataset-compact-identity,
.dataset-compact-cell,
.dataset-compact-status,
.dataset-compact-actions {
  min-width: 0;
  padding: 22px 12px;
}

.dataset-compact-identity {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
}

.dataset-compact-identity .dataset-lineage-icon {
  display: grid;
  place-items: center;
  font-size: 15px;
  line-height: 1;
  color: #fff;
  border-color: var(--review-primary);
  background: var(--review-primary);
}

.dataset-compact-identity .dataset-lineage-icon i {
  display: block;
  line-height: 1;
}

.dataset-compact-identity span,
.dataset-compact-cell span,
.dataset-compact-status span {
  display: block;
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
}

.dataset-compact-identity strong,
.dataset-compact-cell strong,
.dataset-compact-status strong {
  display: block;
  overflow: hidden;
  margin-top: 7px;
  color: var(--review-ink);
  font-size: 15px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-compact-identity strong {
  color: var(--review-ink);
  font-size: 20px;
  letter-spacing: -0.025em;
}

.dataset-compact-identity p,
.dataset-compact-cell p,
.dataset-compact-status p {
  overflow: hidden;
  margin: 6px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-compact-status strong {
  color: var(--review-primary-dark);
}

.dataset-compact-status progress {
  display: block;
  width: min(150px, 100%);
  height: 6px;
  margin-top: 10px;
  overflow: hidden;
  border: 0;
  border-radius: 999px;
  background: #e5e4df;
  accent-color: var(--review-primary);
}

.dataset-compact-status progress::-webkit-progress-bar {
  background: #e5e4df;
}

.dataset-compact-status progress::-webkit-progress-value {
  background: var(--review-primary);
}

.dataset-compact-status progress::-moz-progress-bar {
  background: var(--review-primary);
}

.dataset-compact-actions {
  display: flex;
  justify-content: flex-end;
  gap: 7px;
  border-left: 1px solid var(--review-line-soft);
}

.dataset-compact-actions .dataset-button {
  min-height: 40px;
  padding-inline: 13px;
  white-space: nowrap;
}

@media (max-width: 1280px) {
  .dataset-lineage-node {
    padding-top: 24px;
    padding-bottom: 22px;
  }
  .dataset-lineage-node--identity {
    padding-left: 18px;
  }
  .dataset-compact-head,
  .dataset-compact-row {
    grid-template-columns: minmax(240px, 1.2fr) minmax(140px, 0.7fr) minmax(170px, 0.8fr) minmax(200px, 0.9fr) minmax(170px, auto);
  }
}
@media (max-width: 980px) {
  .dataset-ledger__controls > p {
    display: none;
  }
  .dataset-compact-head {
    display: none;
  }
  .dataset-compact-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding-block: 6px;
  }
  .dataset-compact-identity,
  .dataset-compact-cell,
  .dataset-compact-status,
  .dataset-compact-actions {
    padding: 18px;
    border-bottom: 1px solid var(--review-line-soft);
  }
  .dataset-compact-cell:nth-of-type(2),
  .dataset-compact-status,
  .dataset-compact-actions {
    border-left: 1px solid var(--review-line-soft);
  }
  .dataset-compact-actions {
    justify-content: flex-start;
    border-bottom: 0;
  }
}
@media (max-width: 680px) {
  .dataset-ledger__header {
    align-items: stretch;
  }
  .dataset-ledger__controls {
    width: 100%;
  }
  .dataset-view-toggle,
  .dataset-view-toggle button {
    flex: 1;
  }
  .dataset-view-toggle button {
    justify-content: center;
  }
  .dataset-lineage-node,
  .dataset-lineage-node--identity {
    padding: 20px 16px;
  }
  .dataset-compact-row {
    grid-template-columns: 1fr;
    padding: 0;
  }
  .dataset-compact-identity,
  .dataset-compact-cell,
  .dataset-compact-status,
  .dataset-compact-actions {
    border-left: 0 !important;
  }
  .dataset-compact-actions .dataset-button {
    flex: 1;
  }
}
/* Final polish: explicit progress hierarchy and a stronger dataset record. */
.dataset-flow-band {
  border-color: #dfddd7;
  box-shadow: 0 12px 34px rgba(34, 24, 21, 0.05);
}

.dataset-hub .dataset-section-heading h2 {
  font-size: 30px;
  letter-spacing: -0.045em;
}

.dataset-ledger__header {
  padding-bottom: 14px;
}

.dataset-view-toggle {
  border-color: #d7d6cf;
  background: #e9ebe5;
}

.dataset-view-toggle button {
  min-height: 34px;
  padding-inline: 12px;
}

.dataset-view-toggle button.is-active {
  box-shadow: 0 2px 7px rgba(34, 24, 21, 0.11);
}

.dataset-lineage-row {
  grid-template-rows: auto minmax(0, 1fr);
  min-height: 232px;
  border-radius: 15px;
  box-shadow: 0 13px 36px rgba(34, 24, 21, 0.06);
}

.dataset-lineage-row:hover {
  box-shadow: 0 17px 42px rgba(34, 24, 21, 0.085);
}

.dataset-lineage-statusbar {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: auto minmax(220px, 1fr) auto;
  align-items: center;
  gap: 20px;
  min-height: 52px;
  margin: 0 -20px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fafbf7;
}

.dataset-lineage-statusbar__current,
.dataset-lineage-statusbar__next {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.dataset-lineage-statusbar__current span,
.dataset-lineage-statusbar__next span {
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
}

.dataset-lineage-statusbar__current strong {
  color: var(--review-primary-dark);
  font-size: 12px;
  font-weight: 700;
}

.dataset-lineage-statusbar__next strong {
  color: #8e8a84;
  font-size: 12px;
  font-weight: 700;
}

.dataset-lineage-statusbar progress {
  display: block;
  width: 100%;
  height: 7px;
  overflow: hidden;
  border: 0;
  border-radius: 999px;
  background: #e4e4df;
  accent-color: var(--review-primary);
}

.dataset-lineage-statusbar progress::-webkit-progress-bar {
  background: #e4e4df;
}

.dataset-lineage-statusbar progress::-webkit-progress-value {
  background: var(--review-primary);
}

.dataset-lineage-statusbar progress::-moz-progress-bar {
  background: var(--review-primary);
}

.dataset-lineage-node {
  padding-top: 26px;
  padding-bottom: 24px;
}

.dataset-lineage-node--identity {
  padding-left: 14px;
  border-left: 0;
}

.dataset-lineage-title h4 {
  font-size: 24px;
  font-weight: 700;
}

.dataset-lineage-label {
  font-size: 12px;
  letter-spacing: 0.045em;
}

.dataset-lineage-node strong {
  font-size: 16px;
}

.dataset-lineage-node--pending strong {
  font-weight: 700;
}

.dataset-lineage-actions {
  margin-block: 22px;
}

.dataset-lineage-actions .dataset-button,
.dataset-compact-actions .dataset-button {
  min-height: 42px;
  padding-inline: 15px;
}

.dataset-compact-table {
  border-radius: 15px;
  box-shadow: 0 13px 36px rgba(34, 24, 21, 0.06);
}

.dataset-compact-row {
  min-height: 132px;
  border-left: 0 !important;
}

@media (max-width: 1280px) {
  .dataset-lineage-row {
    min-height: 0;
  }
  .dataset-lineage-statusbar {
    grid-template-columns: auto minmax(160px, 1fr) auto;
  }
}
@media (max-width: 760px) {
  .dataset-lineage-statusbar {
    grid-template-columns: 1fr;
    gap: 8px;
    padding-block: 14px;
  }
  .dataset-lineage-statusbar__next {
    justify-content: space-between;
  }
  .dataset-lineage-node--identity {
    padding-left: 16px;
  }
}
/* Shared-canvas separation: detail and creation views must not become one white sheet. */
.dataset-detail-page.ops-page,
.dataset-create-page.ops-page {
  background: transparent;
}

.dataset-detail-page,
.dataset-create-page {
  gap: 20px;
}

.dataset-detail-summary {
  box-shadow: 0 8px 24px rgba(34, 24, 21, 0.045);
}

.dataset-detail-tabs {
  width: fit-content;
  max-width: 100%;
  align-self: start;
  padding: 4px;
  box-shadow: 0 4px 14px rgba(34, 24, 21, 0.035);
}

.dataset-detail-tabs button {
  min-width: 132px;
}

.dataset-detail-grid,
.dataset-result-grid,
.dataset-create-source-grid,
.dataset-create-output-grid,
.dataset-create-review-grid {
  gap: 20px;
}

@media (max-width: 680px) {
  .dataset-detail-tabs {
    width: 100%;
  }
  .dataset-detail-tabs button {
    min-width: 0;
    flex: 1;
  }
}
/* Legacy graph presentations are retained for history but excluded from the compiled stylesheet. */
/* Premium dataset result workspace */
.dataset-detail-page.ops-page {
  width: 100%;
  max-width: 1480px;
  margin-inline: auto;
  gap: 20px;
  background: transparent;
}

.dataset-detail-page .dataset-detail-header {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto;
  grid-template-areas: "back copy actions" ". metrics metrics";
  align-items: center;
  gap: 18px 20px;
  min-height: 0;
  padding: 24px 26px 20px;
  border: 1px solid #dfe3d8;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(32, 43, 24, 0.055);
}

.dataset-detail-page .dataset-back-button {
  grid-area: back;
  width: 44px;
  height: 44px;
  flex-basis: 44px;
  border-color: #d9ddd3;
  box-shadow: none;
}

.dataset-detail-page .dataset-back-button:hover {
  border-color: #aebd9d;
  box-shadow: 0 5px 14px rgba(61, 80, 40, 0.1);
}

.dataset-detail-page .dataset-detail-header__copy {
  grid-area: copy;
  min-width: 0;
}

.dataset-detail-page .dataset-detail-header__copy > div:first-of-type {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.dataset-detail-page .dataset-page-kicker {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.dataset-detail-page .dataset-detail-header h2 {
  margin: 4px 0 0;
  color: var(--review-ink);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.dataset-detail-page .dataset-status-badge {
  min-height: 28px;
  margin-top: 4px;
  padding: 4px 9px;
  font-size: 12px;
}

.dataset-detail-page .dataset-detail-header__copy > p {
  margin: 6px 0 0;
  color: #817b73;
  font-size: 13px;
  font-weight: 600;
}

.dataset-detail-header__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 11px;
}

.dataset-detail-header__meta > span {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  color: #6f6a63;
  border-radius: 8px;
  background: #f5f5f1;
}

.dataset-detail-header__meta i {
  color: #718657;
  font-size: 12px;
}

.dataset-detail-header__meta strong {
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-detail-header__actions {
  grid-area: actions;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.dataset-detail-header__actions .dataset-button {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding-inline: 15px;
}

.dataset-detail-header__actions .dataset-button i {
  font-size: 12px;
}

.dataset-detail-header__metrics {
  grid-area: metrics;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
  padding-top: 17px;
  border-top: 1px solid #eceee8;
}

.dataset-detail-header__metrics > div {
  min-width: 0;
  padding: 0 20px;
  border-right: 1px solid #e6e8e1;
}

.dataset-detail-header__metrics > div:first-child {
  padding-left: 0;
}

.dataset-detail-header__metrics > div:last-child {
  padding-right: 0;
  border-right: 0;
}

.dataset-detail-header__metrics span,
.dataset-detail-header__metrics strong,
.dataset-detail-header__metrics small {
  display: block;
}

.dataset-detail-header__metrics span {
  color: #969189;
  font-size: 12px;
  font-weight: 700;
}

.dataset-detail-header__metrics strong {
  margin-top: 4px;
  overflow: hidden;
  color: #2d2924;
  font-size: 16px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-detail-header__metrics small {
  margin-top: 3px;
  overflow: hidden;
  color: #817c75;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-detail-header__metrics > div.is-muted strong,
.dataset-detail-header__metrics > div.is-muted small {
  color: #9a9690;
}

.dataset-detail-page .dataset-detail-tabs {
  width: 100%;
  max-width: none;
  display: flex;
  align-items: center;
  gap: 28px;
  align-self: stretch;
  padding: 0 2px;
  border: 0;
  border-bottom: 1px solid #dfe2da;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.dataset-detail-page .dataset-detail-tabs button {
  position: relative;
  min-width: 0;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 4px;
  color: #8a857e;
  background: transparent;
  box-shadow: none;
}

.dataset-detail-page .dataset-detail-tabs button::after {
  position: absolute;
  right: 0;
  bottom: -1px;
  left: 0;
  height: 3px;
  content: "";
  background: transparent;
}

.dataset-detail-page .dataset-detail-tabs button i {
  color: #a4a097;
  font-size: 12px;
}

.dataset-detail-page .dataset-detail-tabs button.is-active {
  color: #344d21;
  background: transparent;
  box-shadow: none;
}

.dataset-detail-page .dataset-detail-tabs button.is-active i {
  color: #58733d;
}

.dataset-detail-page .dataset-detail-tabs button.is-active::after {
  background: #58733d;
}

.dataset-result-hero {
  display: grid;
  grid-template-columns: minmax(280px, 1.05fr) minmax(360px, 1.4fr) auto;
  align-items: center;
  gap: 24px;
  min-height: 96px;
  padding: 18px 22px;
  border: 1px solid #d9e1cf;
  border-left: 4px solid #58733d;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(32, 43, 24, 0.04);
}

.dataset-result-hero.is-pending {
  border-color: #ead6bc;
  border-left-color: #b86a2e;
  background: #fffdf9;
}

.dataset-result-hero__status {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 13px;
}

.dataset-result-status-icon {
  width: 44px;
  height: 44px;
  display: inline-grid;
  flex: 0 0 44px;
  place-items: center;
  color: #fff;
  font-size: 15px;
  border-radius: 999px;
  background: #58733d;
  box-shadow: 0 0 0 6px #eef3e8;
}

.dataset-result-hero > .dataset-result-hero__status > .dataset-result-status-icon {
  display: inline-grid;
  color: #fff;
  font-family: inherit;
  font-size: 15px;
  letter-spacing: normal;
}

.dataset-result-hero.is-pending .dataset-result-status-icon {
  background: #b86a2e;
  box-shadow: 0 0 0 6px #fff1e7;
}

.dataset-result-hero.is-pending > .dataset-result-hero__status > .dataset-result-status-icon {
  color: #fff;
}

.dataset-result-hero__status > div {
  min-width: 0;
}

.dataset-result-hero__status span,
.dataset-result-hero__status strong,
.dataset-result-hero__status p {
  display: block;
}

.dataset-result-hero__status > div > span {
  color: #8b867e;
  font-size: 12px;
  font-weight: 700;
}

.dataset-result-hero__status strong {
  margin-top: 3px;
  overflow: hidden;
  color: #2e2a25;
  font-size: 16px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-result-hero__status p {
  margin: 4px 0 0;
  overflow: hidden;
  color: #7b766f;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-result-stages {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.dataset-result-stages li {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 10px;
  color: #526540;
  border-radius: 9px;
  background: #f3f6ef;
}

.dataset-result-stages i {
  flex: 0 0 auto;
  color: #6d8a4f;
  font-size: 12px;
}

.dataset-result-stages span {
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-result-counts {
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  gap: 0;
}

.dataset-result-counts > span {
  min-width: 88px;
  display: grid;
  gap: 3px;
  padding: 2px 14px;
  text-align: right;
  border-left: 1px solid #e4e7df;
}

.dataset-result-counts small {
  color: #99948d;
  font-size: 12px;
  font-weight: 700;
}

.dataset-result-counts strong {
  color: #344d21;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.dataset-result-progress {
  min-width: 150px;
}

.dataset-result-progress > strong {
  display: block;
  color: #9b531f;
  font-size: 22px;
  text-align: right;
}

.dataset-result-progress > span {
  height: 6px;
  display: block;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #eee8e1;
}

.dataset-result-progress i {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: #b86a2e;
}

.dataset-output-ledger {
  overflow: hidden;
  border: 1px solid #dfe2da;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(32, 43, 24, 0.035);
}

.dataset-output-ledger > header {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 22px;
  border-bottom: 1px solid #e8eae4;
  background: #fbfbf8;
}

.dataset-output-ledger > header h3 {
  margin: 4px 0 0;
  color: #2d2924;
  font-size: 17px;
  font-weight: 700;
}

.dataset-output-ledger > header > p {
  margin: 0;
  color: #8d8881;
  font-size: 12px;
}

.dataset-output-list {
  display: grid;
}

.dataset-output-row {
  position: relative;
  display: grid;
  grid-template-columns: 48px 180px minmax(220px, 1fr) minmax(230px, auto) auto;
  align-items: center;
  gap: 16px;
  min-height: 96px;
  padding: 16px 20px;
  border-bottom: 1px solid #eceee8;
}

.dataset-output-row:last-child {
  border-bottom: 0;
}

.dataset-output-row.is-primary {
  box-shadow: inset 4px 0 0 #58733d;
}

.dataset-output-row.is-muted {
  background: #fcfcfa;
}

.dataset-output-icon {
  width: 44px;
  height: 44px;
  display: inline-grid;
  place-items: center;
  font-size: 15px;
  border-radius: 12px;
}

.dataset-output-icon.is-qa {
  color: #8a857e;
  border: 1px solid #dedfd9;
  background: #f3f3f0;
}

.dataset-output-icon.is-kg {
  color: #fff;
  background: #58733d;
}

.dataset-output-identity,
.dataset-output-summary {
  min-width: 0;
}

.dataset-output-identity span,
.dataset-output-identity strong,
.dataset-output-identity small,
.dataset-output-summary strong,
.dataset-output-summary p {
  display: block;
}

.dataset-output-identity > span {
  color: #938f87;
  font-size: 12px;
  font-weight: 700;
}

.dataset-output-identity strong {
  margin-top: 4px;
  overflow: hidden;
  color: #2d2924;
  font-size: 14px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-output-identity small {
  margin-top: 4px;
  color: #99948d;
  font-size: 12px;
}

.dataset-output-summary strong {
  overflow: hidden;
  color: #3a352f;
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-output-summary p {
  margin: 5px 0 0;
  overflow: hidden;
  color: #7d7871;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-output-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(42px, 1fr));
  gap: 0;
  margin: 0;
}

.dataset-output-metrics > div {
  min-width: 48px;
  padding: 0 12px;
  text-align: center;
  border-left: 1px solid #e8eae4;
}

.dataset-output-metrics dt {
  color: #9a958e;
  font-size: 12px;
  font-weight: 700;
}

.dataset-output-metrics dd {
  margin: 4px 0 0;
  color: #37322d;
  font-size: 13px;
  font-weight: 700;
}

.dataset-output-note {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  color: #8e8982;
  font-size: 12px;
}

.dataset-output-note i {
  color: #a6a198;
}

.dataset-output-row > em {
  min-width: 64px;
  justify-self: end;
  padding: 6px 9px;
  color: #77726b;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
  border: 1px solid #dedfd9;
  border-radius: 999px;
  background: #f5f5f2;
}

.dataset-output-row > em.is-complete {
  color: #47612e;
  border-color: #cdd9c1;
  background: #f0f5e9;
}

.dataset-knowledge-graph.ops-panel {
  overflow: hidden;
  border: 1px solid #d8dcd2;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 16px 42px rgba(32, 43, 24, 0.065);
}

.dataset-knowledge-graph .dataset-kg-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 26px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #e5e8e0;
}

.dataset-kg-eyebrow {
  display: block;
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.07em;
}

.dataset-kg-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 5px;
}

.dataset-kg-title-row h3 {
  margin: 0;
  color: #28241f;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.dataset-kg-mode-badge {
  padding: 5px 8px;
  color: #47612e;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid #cdd9c1;
  border-radius: 999px;
  background: #f0f5e9;
}

.dataset-kg-header__copy > p {
  max-width: 760px;
  margin: 7px 0 0;
  color: #7b766f;
  font-size: 13px;
  line-height: 1.55;
}

.dataset-kg-head-tools {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 10px;
}

.dataset-kg-inline-facts {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.dataset-kg-inline-facts > span {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  padding: 0 10px;
  border-right: 1px solid #e2e5de;
}

.dataset-kg-inline-facts > span:first-child {
  padding-left: 0;
}

.dataset-kg-inline-facts strong {
  color: #312d28;
  font-size: 13px;
  font-weight: 700;
}

.dataset-kg-inline-facts small {
  color: #8e8982;
  font-size: 12px;
  font-weight: 700;
}

.dataset-kg-inline-facts code {
  margin-left: 10px;
  color: #77726b;
  font-size: 12px;
  font-weight: 700;
}

.dataset-kg-view-tabs {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 4px;
  border: 1px solid #dfe1da;
  border-radius: 11px;
  background: #f1f1ed;
}

.dataset-kg-view-tabs button {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  color: #817c75;
  cursor: pointer;
  border: 0;
  background: transparent;
}

.dataset-kg-view-tabs button.is-active {
  color: #344d21;
  background: #fff;
  box-shadow: 0 2px 7px rgba(34, 24, 21, 0.09);
}

.dataset-kg-view-tabs button:focus-visible,
.dataset-kg-canvas-controls button:focus-visible,
.dataset-kg-selection-panel button:focus-visible,
.dataset-kg-node-index button:focus-visible {
  outline: 3px solid rgba(75, 103, 42, 0.2);
  outline-offset: 2px;
}

.dataset-kg-network-toolbar {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 10px 16px 10px 20px;
  border-bottom: 1px solid #e3e6de;
  background: #f8f9f5;
}

.dataset-kg-stage-legend {
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 22px;
}

.dataset-kg-legend-group {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.dataset-kg-legend-group > span {
  flex: 0 0 auto;
  color: #9a958e;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
}

.dataset-kg-legend,
.dataset-kg-edge-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px 12px;
}

.dataset-kg-legend > span,
.dataset-kg-edge-legend > span {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #5f5a54;
}

.dataset-kg-legend i {
  width: 25px;
  height: 25px;
  display: inline-grid;
  flex: 0 0 25px;
  place-items: center;
  color: #496130;
  font-size: 12px;
  border-radius: 8px;
  background: #dce7d1;
}

.dataset-kg-legend i.is-concept {
  color: #fff;
  border-radius: 999px;
  background: #405d25;
}

.dataset-kg-legend i.is-evidence {
  color: #fff;
  background: #d57636;
}

.dataset-kg-legend i.is-page {
  color: #fff;
  background: #8d9089;
}

.dataset-kg-legend i.is-benefit {
  color: #fff;
  background: #3f7b6c;
}

.dataset-kg-legend strong,
.dataset-kg-edge-legend strong {
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.dataset-kg-edge-legend i,
.dataset-kg-selection-links i {
  color: #8c958c;
  font-size: 12px;
}

.dataset-kg-edge-legend i.is-olive,
.dataset-kg-selection-links i.is-olive {
  color: #5f793f;
}

.dataset-kg-edge-legend i.is-orange,
.dataset-kg-selection-links i.is-orange {
  color: #c56229;
}

.dataset-kg-edge-legend i.is-gold,
.dataset-kg-selection-links i.is-gold {
  color: #af7f18;
}

.dataset-kg-edge-legend i.is-teal,
.dataset-kg-selection-links i.is-teal {
  color: #3f7b6c;
}

.dataset-kg-canvas-controls {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid #d9ddd3;
  border-radius: 11px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(34, 24, 21, 0.045);
}

.dataset-kg-canvas-controls button {
  width: 44px;
  height: 44px;
  display: inline-grid;
  place-items: center;
  padding: 0;
  color: #736e67;
  cursor: pointer;
  border: 0;
  border-right: 1px solid #e4e6df;
  background: #fff;
}

.dataset-kg-canvas-controls button:last-child {
  border-right: 0;
}

.dataset-kg-canvas-controls button:hover {
  color: #344d21;
  background: #f0f5e9;
}

.dataset-kg-explorer-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  background: #fcfcfa;
}

.dataset-kg-explorer-shell.has-selection {
  grid-template-columns: minmax(0, 1fr) 320px;
}

.dataset-kg-network-stage {
  position: relative;
  min-width: 0;
  min-height: 500px;
  overflow: hidden;
  background: #fcfcfa;
}

.dataset-kg-canvas {
  position: relative;
  width: 100%;
  height: clamp(500px, 42vw, 560px);
  min-width: 0;
  overflow: hidden;
  outline: 0;
  touch-action: none;
}

.dataset-kg-selection-panel {
  min-width: 0;
  padding: 22px 20px;
  border-left: 1px solid #e1e4dc;
  background: #fff;
  box-shadow: -10px 0 24px rgba(32, 43, 24, 0.025);
}

.dataset-kg-selection-panel > ng-container > header,
.dataset-kg-selection-panel header {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) 32px;
  align-items: center;
  gap: 11px;
}

.dataset-kg-node-icon {
  width: 48px;
  height: 48px;
  display: inline-grid;
  place-items: center;
  color: #344922;
  font-size: 13px;
  border: 1px solid #809765;
  border-radius: 999px;
  background: #a9bf91;
}

.dataset-kg-node-icon.is-concept {
  color: #fff;
  border-color: #405d25;
  background: #405d25;
}

.dataset-kg-node-icon.is-evidence {
  color: #fff;
  border-color: #d57636;
  border-radius: 12px;
  background: #d57636;
}

.dataset-kg-node-icon.is-page {
  color: #fff;
  border-color: #8d9089;
  border-radius: 12px;
  background: #8d9089;
}

.dataset-kg-node-icon.is-benefit {
  color: #fff;
  border-color: #3f7b6c;
  border-radius: 12px;
  background: #3f7b6c;
}

.dataset-kg-selection-panel header > div {
  min-width: 0;
}

.dataset-kg-selection-panel header span,
.dataset-kg-selection-panel header h4,
.dataset-kg-selection-panel header code {
  display: block;
}

.dataset-kg-selection-panel header > div > span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-kg-selection-panel h4 {
  margin: 3px 0 0;
  overflow: hidden;
  color: #2b2722;
  font-size: 16px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-kg-selection-panel header code {
  margin-top: 3px;
  overflow: hidden;
  color: #918c85;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-kg-selection-panel header > button {
  width: 32px;
  height: 32px;
  display: inline-grid;
  place-items: center;
  padding: 0;
  color: #807b74;
  cursor: pointer;
  border: 1px solid #dde0d8;
  background: #fff;
}

.dataset-kg-node-summary {
  margin: 18px 0 0;
  color: #69645e;
  font-size: 12px;
  line-height: 1.65;
}

.dataset-kg-selection-meta {
  display: grid;
  gap: 0;
  margin: 17px 0 0;
  border-block: 1px solid #e7e9e3;
}

.dataset-kg-selection-meta > div {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #eef0ea;
}

.dataset-kg-selection-meta > div:last-child {
  border-bottom: 0;
}

.dataset-kg-selection-meta dt,
.dataset-kg-selection-meta dd {
  font-size: 12px;
}

.dataset-kg-selection-meta dt {
  color: #98938c;
  font-weight: 700;
}

.dataset-kg-selection-meta dd {
  margin: 0;
  overflow: hidden;
  color: #45403a;
  font-weight: 700;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-kg-selection-links {
  margin-top: 18px;
}

.dataset-kg-selection-links > p {
  margin: 0 0 8px;
  color: #8f8a83;
  font-size: 12px;
  font-weight: 700;
}

.dataset-kg-selection-links > div {
  display: grid;
  gap: 7px;
}

.dataset-kg-selection-links button {
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  color: inherit;
  text-align: left;
  cursor: pointer;
  border: 1px solid #e0e3db;
  background: #fafbf8;
}

.dataset-kg-selection-links button:hover {
  border-color: #c7d3bb;
  background: #f0f5e9;
}

.dataset-kg-selection-links small,
.dataset-kg-selection-links strong {
  display: block;
}

.dataset-kg-selection-links small {
  color: #938e87;
  font-size: 12px;
}

.dataset-kg-selection-links strong {
  margin-top: 2px;
  color: #413c36;
  font-size: 12px;
}

.dataset-kg-node-rail {
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 9px 16px 9px 20px;
  border-top: 1px solid #e5e7e0;
  background: #fff;
}

.dataset-kg-stage-guide {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #8b867f;
  font-size: 12px;
}

.dataset-kg-stage-guide i {
  color: #627b45;
}

.dataset-kg-node-index {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

.dataset-kg-node-index > span {
  margin-right: 2px;
  color: #97928b;
  font-size: 12px;
  font-weight: 700;
}

.dataset-kg-node-index button {
  max-width: 150px;
  overflow: hidden;
  padding: 6px 9px;
  color: #6f6a63;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #e0e2dc;
  background: #f7f7f4;
}

.dataset-kg-node-index button:hover,
.dataset-kg-node-index button.is-active {
  color: #fff;
  border-color: #58733d;
  background: #58733d;
}

.dataset-kg-triples {
  background: #fff;
}

.dataset-kg-triples > header {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 16px 22px;
  border-bottom: 1px solid #e5e7e0;
  background: #f8f9f5;
}

.dataset-kg-triples > header strong {
  display: block;
  color: #302c27;
  font-size: 14px;
  font-weight: 700;
}

.dataset-kg-triples > header p {
  margin: 4px 0 0;
  color: #817c75;
  font-size: 12px;
}

.dataset-kg-triples > header > span {
  padding: 6px 9px;
  color: #51683a;
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  background: #eef3e8;
}

.dataset-kg-triple-table {
  overflow-x: auto;
}

.dataset-kg-triple-head,
.dataset-kg-triple-table article {
  min-width: 820px;
  display: grid;
  grid-template-columns: minmax(180px, 1.2fr) minmax(160px, 1fr) minmax(180px, 1.2fr) minmax(180px, 1fr);
  align-items: center;
  gap: 18px;
  padding: 13px 22px;
}

.dataset-kg-triple-head {
  color: #938e87;
  font-size: 12px;
  font-weight: 700;
  border-bottom: 1px solid #e8eae4;
  background: #fcfcfa;
}

.dataset-kg-triple-table article {
  min-height: 68px;
  border-bottom: 1px solid #eceee8;
}

.dataset-kg-triple-table article:last-child {
  border-bottom: 0;
}

.dataset-kg-triple-table article > div {
  min-width: 0;
}

.dataset-kg-triple-table article strong,
.dataset-kg-triple-table article code {
  display: block;
}

.dataset-kg-triple-table article strong {
  margin-top: 4px;
  overflow: hidden;
  color: #3d3832;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-kg-triple-table article code {
  margin-top: 3px;
  color: #8f8a83;
  font-size: 12px;
}

.dataset-kg-triple-table article > div:last-child {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #6e6962;
  font-size: 12px;
}

.dataset-kg-type-mark {
  display: inline-flex;
  padding: 4px 7px;
  color: #48612f;
  font-size: 12px;
  font-weight: 700;
  border-radius: 6px;
  background: #e7efe0;
}

.dataset-kg-type-mark.is-concept {
  color: #fff;
  background: #405d25;
}

.dataset-kg-type-mark.is-evidence {
  color: #fff;
  background: #d57636;
}

.dataset-kg-type-mark.is-page {
  color: #fff;
  background: #8d9089;
}

.dataset-kg-type-mark.is-benefit {
  color: #fff;
  background: #3f7b6c;
}

@media (max-width: 1180px) {
  .dataset-detail-page .dataset-detail-header {
    grid-template-columns: 44px minmax(0, 1fr);
    grid-template-areas: "back copy" ". actions" ". metrics";
    align-items: start;
  }
  .dataset-detail-header__actions {
    justify-content: flex-start;
  }
  .dataset-result-hero {
    grid-template-columns: minmax(260px, 1fr) minmax(330px, 1.3fr);
  }
  .dataset-result-counts,
  .dataset-result-progress {
    grid-column: 1/-1;
    justify-content: flex-start;
  }
  .dataset-result-counts > span {
    padding-left: 0;
    padding-right: 24px;
    text-align: left;
    border-left: 0;
  }
  .dataset-output-row {
    grid-template-columns: 48px 165px minmax(220px, 1fr) auto;
  }
  .dataset-output-metrics,
  .dataset-output-note {
    grid-column: 3/5;
    justify-self: stretch;
  }
  .dataset-output-row > em {
    grid-column: 4;
    grid-row: 1;
  }
}
@media (max-width: 1024px) {
  .dataset-detail-header__metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 0;
  }
  .dataset-detail-header__metrics > div:nth-child(2) {
    border-right: 0;
  }
  .dataset-detail-header__metrics > div:nth-child(3) {
    padding-left: 0;
  }
  .dataset-knowledge-graph .dataset-kg-header {
    grid-template-columns: 1fr;
    align-items: start;
  }
  .dataset-kg-head-tools {
    width: 100%;
    align-items: flex-start;
  }
  .dataset-kg-inline-facts {
    justify-content: flex-start;
  }
  .dataset-kg-network-toolbar {
    align-items: flex-start;
  }
  .dataset-kg-stage-legend {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .dataset-kg-explorer-shell.has-selection {
    grid-template-columns: minmax(0, 1fr) 292px;
  }
}
@media (max-width: 860px) {
  .dataset-result-hero {
    grid-template-columns: 1fr;
  }
  .dataset-result-stages {
    grid-template-columns: 1fr;
  }
  .dataset-result-counts,
  .dataset-result-progress {
    grid-column: auto;
  }
  .dataset-output-row {
    grid-template-columns: 48px minmax(140px, 180px) minmax(0, 1fr) auto;
  }
  .dataset-output-metrics,
  .dataset-output-note {
    grid-column: 2/-1;
  }
  .dataset-kg-explorer-shell.has-selection {
    grid-template-columns: 1fr;
  }
  .dataset-kg-selection-panel {
    border-top: 1px solid #e1e4dc;
    border-left: 0;
    box-shadow: 0 -8px 24px rgba(32, 43, 24, 0.025);
  }
  .dataset-kg-selection-links > div {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 720px) {
  .dataset-detail-page.ops-page {
    gap: 16px;
  }
  .dataset-detail-page .dataset-detail-header {
    grid-template-columns: 44px minmax(0, 1fr);
    grid-template-areas: "back copy" "actions actions" "metrics metrics";
    gap: 15px 12px;
    padding: 18px 16px;
    border-radius: 15px;
  }
  .dataset-detail-page .dataset-detail-header h2 {
    font-size: 23px;
  }
  .dataset-detail-header__meta {
    align-items: stretch;
    flex-direction: column;
  }
  .dataset-detail-header__meta > span {
    width: 100%;
  }
  .dataset-detail-header__actions {
    display: grid;
    grid-template-columns: 1fr;
  }
  .dataset-detail-header__actions .dataset-button {
    width: 100%;
    justify-content: center;
  }
  .dataset-detail-header__metrics {
    padding-top: 15px;
  }
  .dataset-detail-header__metrics > div {
    padding-inline: 12px;
  }
  .dataset-detail-page .dataset-detail-tabs {
    gap: 22px;
    overflow-x: auto;
  }
  .dataset-detail-page .dataset-detail-tabs button {
    flex: 0 0 auto;
    min-height: 46px;
  }
  .dataset-result-hero {
    gap: 18px;
    padding: 17px 16px;
  }
  .dataset-result-stages li {
    min-height: 40px;
  }
  .dataset-output-ledger > header {
    align-items: flex-start;
    flex-direction: column;
    gap: 7px;
    padding: 15px 16px;
  }
  .dataset-output-row {
    grid-template-columns: 46px minmax(0, 1fr) auto;
    gap: 12px;
    padding: 16px;
  }
  .dataset-output-identity {
    grid-column: 2;
  }
  .dataset-output-summary,
  .dataset-output-metrics,
  .dataset-output-note {
    grid-column: 1/-1;
  }
  .dataset-output-row > em {
    grid-column: 3;
    grid-row: 1;
  }
  .dataset-output-summary p {
    white-space: normal;
  }
  .dataset-knowledge-graph .dataset-kg-header {
    padding: 18px 16px;
  }
  .dataset-kg-title-row {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-kg-title-row h3 {
    font-size: 19px;
  }
  .dataset-kg-inline-facts {
    width: 100%;
    flex-wrap: wrap;
    gap: 8px 0;
  }
  .dataset-kg-inline-facts code {
    width: 100%;
    margin-left: 0;
  }
  .dataset-kg-view-tabs {
    width: 100%;
    overflow-x: auto;
  }
  .dataset-kg-view-tabs button {
    min-width: 98px;
    flex: 1;
  }
  .dataset-kg-network-toolbar {
    align-items: stretch;
    flex-direction: column;
    padding: 12px;
  }
  .dataset-kg-stage-legend {
    overflow-x: auto;
    padding-bottom: 2px;
  }
  .dataset-kg-legend-group {
    min-width: max-content;
  }
  .dataset-kg-canvas-controls {
    align-self: flex-end;
  }
  .dataset-kg-network-stage {
    min-height: 420px;
  }
  .dataset-kg-canvas {
    height: 430px;
  }
  .dataset-kg-selection-panel {
    padding: 18px 16px;
  }
  .dataset-kg-selection-links > div {
    grid-template-columns: 1fr;
  }
  .dataset-kg-node-rail {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
  }
  .dataset-kg-node-index {
    justify-content: flex-start;
  }
  .dataset-kg-stage-guide {
    font-size: 12px;
  }
  .dataset-kg-triples > header {
    align-items: flex-start;
    padding-inline: 16px;
  }
}
@media (max-width: 480px) {
  .dataset-detail-header__metrics {
    grid-template-columns: 1fr;
  }
  .dataset-detail-header__metrics > div,
  .dataset-detail-header__metrics > div:nth-child(3) {
    padding: 0 0 12px;
    border-right: 0;
    border-bottom: 1px solid #eceee8;
  }
  .dataset-detail-header__metrics > div:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }
  .dataset-result-counts {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dataset-output-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 0;
  }
  .dataset-output-metrics > div:nth-child(odd) {
    border-left: 0;
  }
  .dataset-kg-inline-facts > span {
    padding-inline: 7px;
  }
  .dataset-kg-view-tabs button i {
    display: none;
  }
  .dataset-kg-canvas-controls button {
    width: 42px;
    height: 42px;
  }
  .dataset-kg-node-index > span {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .dataset-detail-page button,
  .dataset-kg-canvas-controls button,
  .dataset-kg-selection-links button,
  .dataset-kg-node-index button {
    transition: none;
  }
}
/* Three-column dataset result command center */
.dataset-detail-page.ops-page {
  container: dataset-result/inline-size;
}

.dataset-detail-page .dataset-detail-header.is-results-layout {
  grid-template-columns: 44px minmax(0, 1fr);
  grid-template-areas: "back copy";
  gap: 14px;
  padding: 18px 22px;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(32, 43, 24, 0.035);
}

.dataset-detail-header.is-results-layout .dataset-detail-header__copy > div:first-of-type {
  gap: 0;
}

.dataset-detail-header.is-results-layout .dataset-detail-header__copy > p {
  margin-top: 4px;
}

.dataset-result-workspace {
  display: grid;
  grid-template-columns: 260px minmax(560px, 1fr) 310px;
  grid-template-rows: repeat(4, auto);
  align-items: start;
  gap: 16px 18px;
}

.dataset-result-workspace__info {
  grid-column: 1;
  grid-row: 1/-1;
  min-width: 0;
  display: grid;
  gap: 12px;
  position: sticky;
  top: 18px;
}

.dataset-result-workspace__graph {
  grid-column: 2;
  grid-row: 1/-1;
  min-width: 0;
}

.dataset-result-workspace__summary,
.dataset-result-workspace__outputs,
.dataset-result-workspace__selection,
.dataset-result-workspace__review-action {
  grid-column: 3;
  min-width: 0;
}

.dataset-result-workspace__summary {
  grid-row: 1;
}

.dataset-result-workspace__outputs {
  grid-row: 2;
}

.dataset-result-workspace__selection {
  grid-row: 3;
}

.dataset-result-workspace__review-action {
  grid-row: 4;
}

.dataset-result-side-card {
  overflow: hidden;
  padding: 18px;
  border: 1px solid #dfe3d8;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(32, 43, 24, 0.045);
}

.dataset-result-identity-card > header {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  align-items: start;
  gap: 11px;
}

.dataset-result-identity-icon {
  grid-row: 1/span 2;
  width: 44px;
  height: 44px;
  display: inline-grid;
  place-items: center;
  color: #fff;
  font-size: 14px;
  border-radius: 13px;
  background: #4f6b32;
  box-shadow: 0 6px 14px rgba(61, 87, 36, 0.16);
}

.dataset-result-identity-card header > div {
  min-width: 0;
}

.dataset-result-identity-card header > div > span,
.dataset-result-identity-card header h3 {
  display: block;
}

.dataset-result-identity-icon > i {
  display: block;
  margin: 0;
  line-height: 1;
}

.dataset-result-identity-card header > div > span {
  color: #98938b;
  font-size: 12px;
  font-weight: 700;
}

.dataset-result-identity-card h3 {
  margin: 3px 0 0;
  color: #27231f;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.28;
  letter-spacing: -0.025em;
  white-space: normal;
}

.dataset-result-identity-card header > em {
  grid-column: 2;
  justify-self: start;
  padding: 5px 7px;
  margin-top: -3px;
  color: #49632f;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
  border: 1px solid #cad8bd;
  border-radius: 999px;
  background: #f0f5e9;
}

.dataset-result-identity-card > p {
  margin: 16px 0 0;
  color: #3e3933;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.5;
}

.dataset-result-info-list {
  display: grid;
  gap: 0;
  margin: 15px 0 0;
  border-block: 1px solid #e8eae4;
}

.dataset-result-info-list > div {
  display: grid;
  grid-template-columns: 74px minmax(0, 1fr);
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #eef0ea;
}

.dataset-result-info-list > div:last-child {
  border-bottom: 0;
}

.dataset-result-info-list dt,
.dataset-result-info-list dd {
  min-width: 0;
  font-size: 12px;
}

.dataset-result-info-list dt {
  color: #98938c;
  font-weight: 700;
}

.dataset-result-info-list dd {
  margin: 0;
  overflow: hidden;
  color: #46413a;
  font-weight: 700;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-result-text-action {
  width: 100%;
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 14px;
  color: #4f6539;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid #d9e1d1;
  border-radius: 10px;
  background: #f7f9f4;
}

.dataset-result-text-action:hover {
  border-color: #b6c6a5;
  background: #eef4e8;
}

.dataset-result-flow-card > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.dataset-result-flow-card > header span {
  color: #7e7972;
  font-size: 12px;
  font-weight: 700;
}

.dataset-result-flow-card > header strong {
  color: #4e6635;
  font-size: 12px;
  font-weight: 700;
}

.dataset-result-flow-card ol {
  display: grid;
  gap: 4px;
  padding: 0;
  margin: 14px 0 0;
  list-style: none;
}

.dataset-result-flow-card li {
  min-width: 0;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 8px 7px;
  border-radius: 10px;
}

.dataset-result-flow-card li > span {
  width: 28px;
  height: 28px;
  display: inline-grid;
  place-items: center;
  color: #fff;
  font-size: 12px;
  border-radius: 999px;
  background: #6c884e;
}

.dataset-result-flow-card li.is-next {
  margin-top: 3px;
  background: #f4f4f1;
}

.dataset-result-flow-card li.is-next > span {
  color: #8d8881;
  background: #e2e2dd;
}

.dataset-result-flow-card li strong,
.dataset-result-flow-card li small {
  display: block;
}

.dataset-result-flow-card li strong {
  overflow: hidden;
  color: #403b35;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-result-flow-card li small {
  margin-top: 2px;
  color: #9b968f;
  font-size: 12px;
}

.dataset-detail-page .dataset-result-workspace__summary {
  min-height: 0;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 14px;
  padding: 17px;
  border: 1px solid #d9e1cf;
  border-left-width: 1px;
  border-radius: 16px;
}

.dataset-result-workspace__summary .dataset-result-stages {
  display: none;
}

.dataset-result-workspace__summary .dataset-result-hero__status {
  align-items: flex-start;
}

.dataset-result-workspace__summary .dataset-result-status-icon {
  width: 40px;
  height: 40px;
  flex-basis: 40px;
  font-size: 13px;
  box-shadow: 0 0 0 5px #eef3e8;
}

.dataset-result-workspace__summary .dataset-result-hero__status strong {
  white-space: normal;
}

.dataset-result-workspace__summary .dataset-result-hero__status p {
  line-height: 1.45;
  white-space: normal;
}

.dataset-result-workspace__summary .dataset-result-counts {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.dataset-result-workspace__summary .dataset-result-counts > span {
  min-width: 0;
  padding: 10px;
  text-align: left;
  border: 0;
  border-radius: 10px;
  background: #f3f6ef;
}

.dataset-detail-page .dataset-result-workspace__graph.dataset-knowledge-graph.ops-panel {
  margin: 0;
  border-radius: 18px;
  box-shadow: 0 14px 38px rgba(32, 43, 24, 0.06);
}

.dataset-result-workspace__graph .dataset-kg-header {
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 15px;
  padding: 20px;
}

.dataset-result-workspace__graph .dataset-kg-head-tools {
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 14px;
}

.dataset-result-workspace__graph .dataset-kg-inline-facts > span:last-child {
  border-right: 0;
}

.dataset-result-workspace__graph .dataset-kg-network-toolbar {
  align-items: flex-start;
  padding: 11px 14px;
}

.dataset-result-workspace__graph .dataset-kg-stage-legend {
  gap: 8px 16px;
}

.dataset-result-workspace__graph .dataset-kg-explorer-shell,
.dataset-result-workspace__graph .dataset-kg-explorer-shell.has-selection {
  grid-template-columns: minmax(0, 1fr);
}

.dataset-result-workspace__graph .dataset-kg-network-stage {
  min-height: 540px;
}

.dataset-result-workspace__graph .dataset-kg-canvas {
  height: clamp(540px, 100dvh - 340px, 720px);
}

.dataset-result-workspace__graph .dataset-kg-node-rail {
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
  padding: 11px 14px;
}

.dataset-result-workspace__graph .dataset-kg-node-index {
  justify-content: flex-start;
}

.dataset-detail-page .dataset-result-workspace__outputs {
  overflow: visible;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.dataset-result-workspace__outputs > header {
  min-height: 0;
  display: block;
  padding: 2px 2px 8px;
  border: 0;
  background: transparent;
}

.dataset-result-workspace__outputs > header h3 {
  font-size: 15px;
}

.dataset-result-workspace__outputs > header > p {
  margin-top: 4px;
  font-size: 12px;
}

.dataset-result-workspace__outputs .dataset-output-list {
  gap: 9px;
}

.dataset-result-workspace__outputs .dataset-output-row {
  min-height: 0;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  gap: 10px 12px;
  padding: 14px;
  border: 1px solid #dfe3d8;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(32, 43, 24, 0.035);
}

.dataset-result-workspace__outputs .dataset-output-row.is-primary {
  box-shadow: inset 3px 0 0 #58733d, 0 6px 18px rgba(32, 43, 24, 0.035);
}

.dataset-result-workspace__outputs .dataset-output-row:last-child {
  border-bottom: 1px solid #dfe3d8;
}

.dataset-result-workspace__outputs .dataset-output-icon {
  width: 40px;
  height: 40px;
  grid-column: 1;
  grid-row: 1;
}

.dataset-result-workspace__outputs .dataset-output-identity {
  grid-column: 2;
  grid-row: 1;
}

.dataset-result-workspace__outputs .dataset-output-row > em {
  grid-column: 3;
  grid-row: 1;
  min-width: 0;
  align-self: start;
  padding: 5px 7px;
}

.dataset-result-workspace__outputs .dataset-output-summary,
.dataset-result-workspace__outputs .dataset-output-metrics,
.dataset-result-workspace__outputs .dataset-output-note {
  grid-column: 1/-1;
}

.dataset-result-workspace__outputs .dataset-output-summary {
  padding-top: 10px;
  border-top: 1px solid #eceee8;
}

.dataset-result-workspace__outputs .dataset-output-summary strong,
.dataset-result-workspace__outputs .dataset-output-summary p {
  white-space: normal;
}

.dataset-result-workspace__outputs .dataset-output-metrics {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 0;
  padding-top: 11px;
  border-top: 1px solid #eceee8;
}

.dataset-result-workspace__outputs .dataset-output-metrics > div {
  padding: 0 9px;
}

.dataset-detail-page .dataset-result-workspace__selection {
  position: static;
  padding: 17px;
  border: 1px solid #dfe3d8;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(32, 43, 24, 0.045);
}

.dataset-result-workspace__selection .dataset-kg-selection-links > div {
  grid-template-columns: 1fr;
}

.dataset-result-workspace__review-action {
  border-color: #cad7bd;
  background: #f7faf4;
}

.dataset-result-next-kicker {
  display: block;
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.dataset-result-review-action__title {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
  margin-top: 10px;
}

.dataset-result-review-action__title > span {
  width: 42px;
  height: 42px;
  display: inline-grid;
  place-items: center;
  color: #fff;
  font-size: 13px;
  border-radius: 12px;
  background: #4f6b32;
}

.dataset-result-review-action__title h3,
.dataset-result-review-action__title p {
  margin: 0;
}

.dataset-result-review-action__title h3 {
  color: #2d2924;
  font-size: 17px;
  font-weight: 700;
}

.dataset-result-review-action__title p {
  margin-top: 3px;
  color: #817c75;
  font-size: 12px;
  font-weight: 700;
}

.dataset-result-workspace__review-action > p {
  margin: 14px 0 0;
  color: #716c65;
  font-size: 12px;
  line-height: 1.6;
}

.dataset-result-workspace__review-action .dataset-button {
  width: 100%;
  min-height: 46px;
  justify-content: center;
  margin-top: 13px;
}

.dataset-result-workspace__review-action .dataset-button + .dataset-button {
  margin-top: 8px;
}

@container dataset-result (max-width: 1220px) {
  .dataset-result-workspace {
    grid-template-columns: 240px minmax(0, 1fr);
    grid-template-rows: repeat(5, auto);
  }
  .dataset-result-workspace__info {
    grid-column: 1;
    grid-row: 1;
    position: static;
  }
  .dataset-result-workspace__graph {
    grid-column: 2;
    grid-row: 1/-1;
  }
  .dataset-result-workspace__summary,
  .dataset-result-workspace__outputs,
  .dataset-result-workspace__selection,
  .dataset-result-workspace__review-action {
    grid-column: 1;
  }
  .dataset-result-workspace__summary {
    grid-row: 2;
  }
  .dataset-result-workspace__outputs {
    grid-row: 3;
  }
  .dataset-result-workspace__selection {
    grid-row: 4;
  }
  .dataset-result-workspace__review-action {
    grid-row: 5;
  }
}
@container dataset-result (max-width: 860px) {
  .dataset-detail-page .dataset-detail-header.is-results-layout {
    padding: 16px;
  }
  .dataset-result-workspace {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto;
  }
  .dataset-result-workspace__info,
  .dataset-result-workspace__graph,
  .dataset-result-workspace__summary,
  .dataset-result-workspace__outputs,
  .dataset-result-workspace__selection,
  .dataset-result-workspace__review-action {
    grid-column: 1;
    grid-row: auto;
  }
  .dataset-result-workspace__info {
    order: 1;
  }
  .dataset-result-workspace__graph {
    order: 2;
  }
  .dataset-result-workspace__summary {
    order: 3;
  }
  .dataset-result-workspace__outputs {
    order: 4;
  }
  .dataset-result-workspace__selection {
    order: 5;
  }
  .dataset-result-workspace__review-action {
    order: 6;
  }
  .dataset-result-workspace__info {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }
  .dataset-result-workspace__graph .dataset-kg-head-tools,
  .dataset-result-workspace__graph .dataset-kg-network-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .dataset-result-workspace__graph .dataset-kg-canvas {
    height: 500px;
  }
}
@container dataset-result (max-width: 560px) {
  .dataset-detail-header.is-results-layout .dataset-detail-header__copy > p {
    white-space: normal;
  }
  .dataset-result-workspace__info {
    grid-template-columns: 1fr;
  }
  .dataset-result-workspace__graph .dataset-kg-canvas,
  .dataset-result-workspace__graph .dataset-kg-network-stage {
    min-height: 430px;
    height: 430px;
  }
  .dataset-result-workspace__graph .dataset-kg-view-tabs {
    width: 100%;
    overflow-x: auto;
  }
  .dataset-result-workspace__graph .dataset-kg-view-tabs button {
    min-width: 96px;
    flex: 1 0 auto;
  }
}
.dataset-detail-page.is-graph-workspace {
  width: 100%;
  max-width: none;
  gap: 0;
}

.dataset-detail-page.is-graph-workspace > .dataset-detail-header,
.dataset-detail-page.is-graph-workspace > .dataset-detail-tabs {
  display: none;
}

.dataset-map-workspace {
  min-width: 0;
  min-height: 720px;
  height: max(720px, 100vh - 188px);
  max-height: none;
  display: grid;
  grid-template-columns: 250px minmax(520px, 1fr) 310px;
  grid-template-rows: auto minmax(0, 1fr);
  overflow: hidden;
  container-type: inline-size;
  border: 1px solid #dfe3d8;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(32, 43, 24, 0.07);
}

.dataset-map-toolbar {
  grid-column: 1/-1;
  position: relative;
  z-index: 5;
  border-bottom: 1px solid #e3e6df;
  background: #fff;
}

.dataset-map-toolbar__main {
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 10px 14px;
}

.dataset-map-context,
.dataset-map-toolbar__actions,
.dataset-map-view-switcher,
.dataset-map-filterbar,
.dataset-map-filterbar__filters,
.dataset-map-search {
  display: flex;
  align-items: center;
}

.dataset-map-context {
  min-width: 0;
  gap: 10px;
}

.dataset-map-icon-button,
.dataset-map-panel-toggle,
.dataset-map-canvas-controls button,
.dataset-map-node-header button {
  display: inline-grid;
  place-items: center;
  cursor: pointer;
  border: 1px solid #dde1d8;
  background: #fff;
}

.dataset-map-icon-button {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  color: #6f6a63;
}

.dataset-map-context__icon {
  width: 38px;
  height: 38px;
  display: inline-grid;
  flex: 0 0 38px;
  place-items: center;
  color: #fff;
  border-radius: 11px;
  background: #4f6b32;
}

.dataset-map-context > div {
  min-width: 0;
}

.dataset-map-context > div > span,
.dataset-map-context > div > strong,
.dataset-map-context > div > small {
  display: block;
}

.dataset-map-context > div > span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.07em;
}

.dataset-map-context > div > strong {
  overflow: hidden;
  margin-top: 2px;
  color: #2e2a25;
  font-size: 15px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-map-context > div > small {
  overflow: hidden;
  margin-top: 2px;
  color: #88837b;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-map-toolbar__actions {
  flex: 0 0 auto;
  gap: 8px;
}

.dataset-map-expand-button {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 0 0 auto;
  padding: 0 11px;
  color: #4c6533;
  cursor: pointer;
  border: 1px solid #cfdac5;
  background: #f6f9f3;
}

.dataset-map-expand-button:hover,
.dataset-map-expand-button[aria-pressed=true] {
  color: #fff;
  border-color: #4f6b32;
  background: #4f6b32;
}

.dataset-map-text-button,
.dataset-map-review-button,
.dataset-map-secondary-action,
.dataset-map-primary-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  cursor: pointer;
}

.dataset-map-text-button {
  min-height: 36px;
  padding: 0 11px;
  color: #6c675f;
  border: 1px solid #dde1d8;
  background: #fff;
}

.dataset-map-view-switcher {
  gap: 2px;
  padding: 3px;
  border: 1px solid #dde1d8;
  border-radius: 10px;
  background: #f3f4f0;
}

.dataset-map-view-switcher button {
  min-height: 30px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  color: #858078;
  cursor: pointer;
  border: 0;
  background: transparent;
}

.dataset-map-view-switcher button.is-active {
  color: #405b28;
  background: #fff;
  box-shadow: 0 2px 7px rgba(33, 42, 27, 0.09);
}

.dataset-map-review-button {
  min-height: 36px;
  padding: 0 13px;
  color: #fff;
  border: 0;
  background: #3f5d25;
  box-shadow: 0 5px 13px rgba(63, 93, 37, 0.16);
}

.dataset-map-review-button:disabled,
.dataset-map-primary-action:disabled {
  color: #7f7b74;
  cursor: not-allowed;
  background: #e8e9e5;
  box-shadow: none;
}

.dataset-map-filterbar {
  min-height: 46px;
  justify-content: space-between;
  gap: 14px;
  padding: 7px 14px;
  border-top: 1px solid #f0f1ed;
  background: #fafbf8;
}

.dataset-map-filterbar__filters {
  min-width: 0;
  gap: 5px;
  overflow-x: auto;
}

.dataset-map-filterbar__filters > span {
  flex: 0 0 auto;
  margin-right: 3px;
  color: #9b968e;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-filterbar__filters button {
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 5px;
  padding: 0 8px;
  color: #706b64;
  cursor: pointer;
  border: 1px solid #e3e5de;
  background: #fff;
}

.dataset-map-filterbar__filters button em {
  color: #aaa59d;
  font-style: normal;
}

.dataset-map-filterbar__filters button.is-active {
  color: #405b28;
  border-color: #c9d7bd;
  background: #edf3e7;
}

.dataset-map-filterbar__filters button.is-evidence i {
  color: #c5632c;
}

.dataset-map-filterbar__filters button.is-claim i {
  color: #405d25;
}

.dataset-map-filterbar__filters button.is-entity i {
  color: #526f8a;
}

.dataset-map-filterbar__filters button.is-concept i {
  color: #405d25;
}

.dataset-map-filterbar__filters button.is-page i {
  color: #858980;
}

.dataset-map-search {
  width: 230px;
  min-height: 32px;
  flex: 0 0 230px;
  gap: 7px;
  padding: 0 9px;
  border: 1px solid #dde1d8;
  border-radius: 9px;
  background: #fff;
}

.dataset-map-search > i {
  color: #aaa59d;
  font-size: 12px;
}

.dataset-map-search input {
  min-width: 0;
  flex: 1;
  color: #3c3833;
  font-size: 12px;
  border: 0;
  outline: 0;
  background: transparent;
}

.dataset-map-search button {
  padding: 0;
  color: #928d86;
  cursor: pointer;
  border: 0;
  background: transparent;
}

.dataset-map-search small {
  color: #526d35;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-left,
.dataset-map-right,
.dataset-map-canvas-panel {
  min-width: 0;
  min-height: 0;
}

.dataset-map-left,
.dataset-map-right {
  position: relative;
  overflow: auto;
  background: #fbfcfa;
}

.dataset-map-left {
  grid-column: 1;
  border-right: 1px solid #e3e6df;
}

.dataset-map-right {
  grid-column: 3;
  border-left: 1px solid #e3e6df;
  background: #fff;
}

.dataset-map-panel-toggle {
  width: 26px;
  height: 26px;
  position: sticky;
  z-index: 4;
  top: 10px;
  float: right;
  margin: 10px 10px 0 0;
  color: #89847c;
}

.dataset-map-side-section {
  padding: 16px;
  border-bottom: 1px solid #e5e8e1;
}

.dataset-map-side-section > header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dataset-map-dataset {
  padding-top: 44px;
}

.dataset-map-side-icon {
  width: 38px;
  height: 38px;
  display: inline-grid;
  flex: 0 0 38px;
  place-items: center;
  color: #fff;
  border-radius: 11px;
  background: #4f6b32;
}

.dataset-map-dataset header > div {
  min-width: 0;
  flex: 1;
}

.dataset-map-dataset header > div > span,
.dataset-map-dataset header h3 {
  display: block;
}

.dataset-map-dataset header > div > span {
  color: #969188;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-dataset header h3 {
  overflow: hidden;
  margin: 2px 0 0;
  color: #312d28;
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-map-dataset header > em {
  padding: 4px 6px;
  color: #4f6b32;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  border: 1px solid #d2dec7;
  border-radius: 999px;
  background: #eff5e9;
}

.dataset-map-dataset > p {
  overflow: hidden;
  margin: 16px 0 0;
  color: #3f3a35;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-map-dataset dl {
  margin: 11px 0 0;
}

.dataset-map-dataset dl > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 0;
  border-top: 1px solid #e9ebe5;
}

.dataset-map-dataset dt,
.dataset-map-dataset dd {
  margin: 0;
  font-size: 12px;
}

.dataset-map-dataset dt {
  color: #969188;
  font-weight: 700;
}

.dataset-map-dataset dd {
  color: #4b4640;
  font-weight: 700;
  text-align: right;
}

.dataset-map-secondary-action,
.dataset-map-primary-action {
  width: 100%;
  min-height: 38px;
  margin-top: 12px;
  padding: 0 12px;
}

.dataset-map-secondary-action {
  color: #4f6b32;
  border: 1px solid #cedac2;
  background: #f6f9f2;
}

.dataset-map-flow > header {
  justify-content: space-between;
}

.dataset-map-flow > header div > span,
.dataset-map-flow > header h3 {
  display: block;
}

.dataset-map-flow > header div > span {
  color: #969188;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-flow > header h3 {
  margin: 2px 0 0;
  color: #312d28;
  font-size: 13px;
  font-weight: 700;
}

.dataset-map-flow > header > strong {
  color: #4f6b32;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-progress {
  height: 5px;
  overflow: hidden;
  margin-top: 12px;
  border-radius: 999px;
  background: #e7e9e3;
}

.dataset-map-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #5f7c40;
}

.dataset-map-flow ol {
  display: grid;
  gap: 12px;
  margin: 16px 0 0;
  padding: 0;
  list-style: none;
}

.dataset-map-flow li {
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
}

.dataset-map-flow li > span {
  width: 26px;
  height: 26px;
  display: inline-grid;
  place-items: center;
  color: #fff;
  font-size: 12px;
  border-radius: 999px;
  background: #78975a;
}

.dataset-map-flow li.is-current {
  padding: 9px;
  border: 1px solid #dce4d3;
  border-radius: 10px;
  background: #f3f7ef;
}

.dataset-map-flow li.is-current > span {
  background: #4f6b32;
}

.dataset-map-flow li strong,
.dataset-map-flow li small {
  display: block;
}

.dataset-map-flow li strong {
  color: #4a453f;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-flow li small {
  margin-top: 1px;
  color: #969188;
  font-size: 12px;
}

.dataset-map-canvas-panel {
  grid-column: 2;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  background: #fff;
}

.dataset-map-canvas-header {
  min-height: 84px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
  padding: 13px 18px;
  border-bottom: 1px solid #e5e8e1;
}

.dataset-map-canvas-header > div:first-child {
  min-width: 0;
}

.dataset-map-canvas-header > div:first-child > span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.07em;
}

.dataset-map-canvas-header h2 {
  overflow: hidden;
  margin: 3px 0 0;
  color: #2e2a25;
  font-size: 17px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-map-canvas-header p {
  overflow: hidden;
  margin: 3px 0 0;
  color: #8a857d;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-map-canvas-facts {
  display: flex;
  flex: 0 0 auto;
}

.dataset-map-canvas-facts > span {
  min-width: 56px;
  padding: 0 10px;
  text-align: center;
  border-left: 1px solid #e3e6df;
}

.dataset-map-canvas-facts strong,
.dataset-map-canvas-facts small {
  display: block;
}

.dataset-map-canvas-facts strong {
  color: #36312c;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-canvas-facts small {
  margin-top: 2px;
  color: #969188;
  font-size: 12px;
}

.dataset-map-stage {
  min-height: 0;
  position: relative;
  overflow: hidden;
  background: #fbfcfa;
}

.dataset-map-canvas {
  width: 100%;
  height: 100%;
  min-height: 0;
  background: #fbfcfa;
}

.dataset-map-canvas-controls {
  position: absolute;
  z-index: 3;
  top: 14px;
  right: 14px;
  display: inline-flex;
  overflow: hidden;
  border: 1px solid #dfe2db;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 7px 18px rgba(38, 43, 33, 0.09);
}

.dataset-map-canvas-controls button {
  width: 36px;
  height: 36px;
  color: #77726a;
  border-width: 0 0 0 1px;
}

.dataset-map-canvas-controls button:first-child {
  border-left: 0;
}

.dataset-map-canvas-guide {
  position: absolute;
  left: 14px;
  bottom: 13px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  padding: 8px 10px;
  color: #79746c;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid #e1e4dd;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 5px 14px rgba(38, 43, 33, 0.06);
}

.dataset-map-no-result {
  min-width: 220px;
  position: absolute;
  z-index: 4;
  top: 50%;
  left: 50%;
  padding: 20px;
  color: #7d7871;
  text-align: center;
  transform: translate(-50%, -50%);
  border: 1px solid #dfe3db;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 10px 26px rgba(38, 43, 33, 0.08);
}

.dataset-map-no-result i,
.dataset-map-no-result strong,
.dataset-map-no-result p {
  display: block;
}

.dataset-map-no-result i {
  color: #9b968f;
  font-size: 18px;
}

.dataset-map-no-result strong {
  margin-top: 9px;
  color: #3f3a35;
  font-size: 12px;
}

.dataset-map-no-result p {
  margin: 4px 0 0;
  font-size: 12px;
}

.dataset-map-canvas-footer {
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  border-top: 1px solid #e5e8e1;
  background: #fff;
}

.dataset-map-legend,
.dataset-map-node-shortcuts {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 5px;
}

.dataset-map-legend {
  flex: 0 0 auto;
}

.dataset-map-legend > span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #716c65;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-legend i {
  width: 22px;
  height: 22px;
  display: inline-grid;
  place-items: center;
  color: #4f6b32;
  font-size: 12px;
  border-radius: 7px;
  background: #dfe9d4;
}

.dataset-map-legend i.is-concept {
  color: #fff;
  border-radius: 999px;
  background: #405d25;
}

.dataset-map-legend i.is-claim {
  color: #fff;
  background: #405d25;
}

.dataset-map-legend i.is-entity {
  color: #fff;
  border-radius: 999px;
  background: #526f8a;
}

.dataset-map-legend i.is-evidence {
  color: #fff;
  background: #d57636;
}

.dataset-map-legend i.is-page {
  color: #fff;
  background: #8d9089;
}

.dataset-map-node-shortcuts {
  flex: 1;
  justify-content: flex-end;
  overflow-x: auto;
}

.dataset-map-node-shortcuts > span {
  flex: 0 0 auto;
  color: #9a958e;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-node-shortcuts button {
  min-height: 26px;
  flex: 0 0 auto;
  padding: 0 8px;
  color: #77726a;
  cursor: pointer;
  border: 1px solid #e1e4dd;
  background: #fff;
}

.dataset-map-node-shortcuts button.is-active {
  color: #fff;
  border-color: #4f6b32;
  background: #4f6b32;
}

.dataset-map-relation-list {
  min-height: 0;
  overflow: auto;
  padding: 18px;
  background: #fbfcfa;
}

.dataset-map-relation-list > header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-bottom: 14px;
}

.dataset-map-relation-list > header span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-relation-list > header h3 {
  margin: 3px 0 0;
  color: #302c27;
  font-size: 17px;
  font-weight: 700;
}

.dataset-map-relation-list > header > strong {
  color: #4f6b32;
  font-size: 12px;
}

.dataset-map-relation-table {
  overflow: hidden;
  border: 1px solid #dfe3db;
  border-radius: 12px;
  background: #fff;
}

.dataset-map-relation-head,
.dataset-map-relation-table > button {
  display: grid;
  grid-template-columns: 1.1fr 1fr 1.1fr 0.8fr;
  align-items: center;
  gap: 12px;
}

.dataset-map-relation-head {
  min-height: 34px;
  padding: 0 12px;
  color: #918c85;
  font-size: 12px;
  font-weight: 700;
  background: #f4f5f1;
}

.dataset-map-relation-table > button {
  width: 100%;
  min-height: 58px;
  padding: 9px 12px;
  color: #47423c;
  text-align: left;
  cursor: pointer;
  border: 0;
  border-top: 1px solid #eceee8;
  background: #fff;
}

.dataset-map-relation-table > button:hover {
  background: #fafbf8;
}

.dataset-map-relation-table > button > span {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.dataset-map-relation-table > button > span strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-map-relation-table > button > span > span {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.dataset-map-relation-table > button > span > span small {
  color: #8d887f;
  letter-spacing: 0.04em;
}

.dataset-map-relation-table em {
  padding: 3px 5px;
  color: #5a743f;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  border-radius: 5px;
  background: #e9f0e3;
}

.dataset-map-right > .dataset-map-panel-toggle {
  float: left;
  margin: 10px 0 0 10px;
}

.dataset-map-inspector-tabs {
  min-height: 48px;
  display: flex;
  padding: 0 10px;
  border-bottom: 1px solid #e3e6df;
}

.dataset-map-inspector-tabs button {
  min-width: 0;
  flex: 1;
  color: #928d85;
  cursor: pointer;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
}

.dataset-map-inspector-tabs button.is-active {
  color: #3f5c27;
  border-bottom-color: #4f6b32;
}

.dataset-map-inspector {
  padding: 22px 16px;
}

.dataset-map-inspector > h3 {
  margin: 12px 0 0;
  color: #302c27;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
}

.dataset-map-inspector > p {
  margin: 7px 0 0;
  color: #88837c;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

.dataset-map-overview-icon {
  width: 48px;
  height: 48px;
  display: grid;
  margin: 20px auto 0;
  place-items: center;
  color: #5b773d;
  font-size: 17px;
  border-radius: 15px;
  background: #edf3e7;
}

.dataset-map-overview-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 20px 0 0;
  border-top: 1px solid #e5e8e1;
  border-left: 1px solid #e5e8e1;
}

.dataset-map-overview-metrics > div {
  padding: 12px;
  text-align: center;
  border-right: 1px solid #e5e8e1;
  border-bottom: 1px solid #e5e8e1;
}

.dataset-map-overview-metrics dt,
.dataset-map-overview-metrics dd {
  margin: 0;
}

.dataset-map-overview-metrics dt {
  color: #9a958e;
  font-size: 12px;
}

.dataset-map-overview-metrics dd {
  margin-top: 4px;
  color: #38342f;
  font-size: 13px;
  font-weight: 700;
}

.dataset-map-inspector-tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 16px;
  padding: 11px;
  color: #6f6a63;
  font-size: 12px;
  line-height: 1.55;
  border-radius: 9px;
  background: #f3f5f0;
}

.dataset-map-inspector-tip i {
  margin-top: 2px;
  color: #5f7a42;
}

.dataset-map-inspector-tip.is-validation {
  color: #6f5937;
  background: #fff7e8;
}

.dataset-map-inspector-tip.is-validation i {
  color: #c26a2c;
}

.dataset-map-inspector-tip.is-validation strong {
  color: #4e4436;
}

.dataset-map-node-header {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) 26px;
  align-items: center;
  gap: 10px;
}

.dataset-map-node-header > span {
  width: 42px;
  height: 42px;
  display: inline-grid;
  place-items: center;
  color: #fff;
  border-radius: 12px;
  background: #8d9089;
}

.dataset-map-node-header > span.is-source {
  color: #47612e;
  background: #dfe9d4;
}

.dataset-map-node-header > span.is-concept {
  background: #405d25;
}

.dataset-map-node-header > span.is-claim {
  background: #405d25;
}

.dataset-map-node-header > span.is-entity {
  background: #526f8a;
}

.dataset-map-node-header > span.is-evidence {
  background: #d57636;
}

.dataset-map-node-header > div em,
.dataset-map-node-header > div h3 {
  display: block;
}

.dataset-map-node-header > div em {
  color: var(--review-orange);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.dataset-map-node-header > div h3 {
  overflow: hidden;
  margin: 2px 0 0;
  color: #302c27;
  font-size: 15px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-map-node-header button {
  width: 26px;
  height: 26px;
  color: #8f8a83;
}

.dataset-map-node-summary {
  margin-top: 16px !important;
  padding: 12px;
  color: #625d56 !important;
  text-align: left !important;
  border: 1px solid #e5e8e1;
  border-radius: 10px;
  background: #fafbf8;
}

.dataset-map-node-meta {
  margin: 14px 0 0;
}

.dataset-map-node-meta > div {
  display: grid;
  grid-template-columns: 82px minmax(0, 1fr);
  gap: 10px;
  padding: 10px 0;
  border-top: 1px solid #e8eae5;
}

.dataset-map-node-meta dt,
.dataset-map-node-meta dd {
  margin: 0;
  font-size: 12px;
}

.dataset-map-node-meta dt {
  color: #97928a;
}

.dataset-map-node-meta dd {
  color: #48433d;
  font-weight: 700;
}

.dataset-map-primary-action {
  color: #fff;
  border: 0;
  background: #4f6b32;
}

.dataset-map-inspector-heading > span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-inspector-heading h3 {
  margin: 3px 0 0;
  color: #302c27;
  font-size: 15px;
  font-weight: 700;
}

.dataset-map-inspector-heading p {
  margin: 3px 0 0;
  color: #98938c;
  font-size: 12px;
}

.dataset-map-connections {
  display: grid;
  gap: 9px;
  margin-top: 16px;
}

.dataset-map-connections > button {
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 18px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  padding: 11px;
  color: #555049;
  text-align: left;
  cursor: pointer;
  border: 1px solid #e1e4dd;
  background: #fff;
}

.dataset-map-connections > button:hover {
  border-color: #cbd8c0;
  background: #f8faf5;
}

.dataset-map-connections > button > span {
  min-width: 0;
}

.dataset-map-connections em,
.dataset-map-connections strong {
  display: block;
}

.dataset-map-connections em {
  color: #9b968f;
  font-size: 12px;
  font-style: normal;
}

.dataset-map-connections strong {
  overflow: hidden;
  margin-top: 2px;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-map-connections > button > i {
  color: #78945c;
  font-size: 12px;
  text-align: center;
}

.dataset-map-connections > button > small {
  grid-column: 1/-1;
  padding-top: 8px;
  color: #817c74;
  border-top: 1px solid #eceee9;
}

.dataset-map-review-status {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 12px;
  border: 1px solid #d1dec5;
  border-radius: 11px;
  background: #f4f8ef;
}

.dataset-map-review-status > span {
  width: 40px;
  height: 40px;
  display: inline-grid;
  place-items: center;
  color: #fff;
  border-radius: 999px;
  background: #5d7c3e;
}

.dataset-map-review-status em,
.dataset-map-review-status h3,
.dataset-map-review-status p {
  display: block;
  margin: 0;
}

.dataset-map-review-status em {
  color: #79925f;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.dataset-map-review-status h3 {
  margin-top: 2px;
  color: #35452a;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-review-status p {
  margin-top: 3px;
  color: #7e8a73;
  font-size: 12px;
  text-align: left;
}

.dataset-map-output-card {
  margin-top: 10px;
  padding: 12px;
  border: 1px solid #e1e4dd;
  border-radius: 11px;
  background: #fff;
}

.dataset-map-output-card.is-primary {
  border-color: #cbd9c0;
  box-shadow: inset 3px 0 0 #4f6b32;
}

.dataset-map-output-card.is-muted {
  background: #fafaf8;
}

.dataset-map-output-card header {
  display: flex;
  align-items: center;
  gap: 9px;
}

.dataset-map-output-card header > span {
  width: 34px;
  height: 34px;
  display: inline-grid;
  place-items: center;
  color: #5a753e;
  border-radius: 9px;
  background: #e8efe2;
}

.dataset-map-output-card em,
.dataset-map-output-card h4 {
  display: block;
  margin: 0;
}

.dataset-map-output-card em {
  color: #969188;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.dataset-map-output-card h4 {
  margin-top: 2px;
  color: #3c3732;
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-output-card > p {
  margin: 9px 0 0;
  color: #858078;
  font-size: 12px;
  line-height: 1.5;
}

.dataset-map-next-action {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #e3e6df;
}

.dataset-map-next-action > span {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
}

.dataset-map-next-action h3 {
  margin: 4px 0 0;
  color: #302c27;
  font-size: 15px;
  font-weight: 700;
}

.dataset-map-next-action p {
  margin: 6px 0 0;
  color: #827d76;
  font-size: 12px;
  line-height: 1.55;
}

.dataset-map-workspace.is-left-collapsed {
  grid-template-columns: 54px minmax(520px, 1fr) 310px;
}

.dataset-map-workspace.is-right-collapsed {
  grid-template-columns: 250px minmax(520px, 1fr) 54px;
}

.dataset-map-workspace.is-left-collapsed.is-right-collapsed {
  grid-template-columns: 54px minmax(520px, 1fr) 54px;
}

.dataset-map-workspace.is-expanded,
.dataset-map-workspace.is-expanded.is-left-collapsed,
.dataset-map-workspace.is-expanded.is-right-collapsed,
.dataset-map-workspace.is-expanded.is-left-collapsed.is-right-collapsed {
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  position: fixed;
  z-index: 80;
  inset: 12px;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr);
  border-radius: 16px;
  box-shadow: 0 24px 80px rgba(25, 32, 20, 0.2);
}

.dataset-map-workspace.is-expanded .dataset-map-toolbar,
.dataset-map-workspace.is-expanded .dataset-map-canvas-panel {
  grid-column: 1;
}

.dataset-map-workspace.is-expanded .dataset-map-left,
.dataset-map-workspace.is-expanded .dataset-map-right {
  display: none;
}

.dataset-map-workspace.is-left-collapsed .dataset-map-left .dataset-map-panel-toggle,
.dataset-map-workspace.is-right-collapsed .dataset-map-right .dataset-map-panel-toggle {
  float: none;
  display: grid;
  margin: 12px auto;
}

.dataset-map-icon-button:hover,
.dataset-map-text-button:hover,
.dataset-map-panel-toggle:hover,
.dataset-map-canvas-controls button:hover,
.dataset-map-node-shortcuts button:hover {
  color: #3f5c27;
  border-color: #c9d6be;
  background: #f5f8f2;
}

.dataset-map-icon-button:focus-visible,
.dataset-map-text-button:focus-visible,
.dataset-map-expand-button:focus-visible,
.dataset-map-review-button:focus-visible,
.dataset-map-view-switcher button:focus-visible,
.dataset-map-filterbar__filters button:focus-visible,
.dataset-map-search input:focus-visible,
.dataset-map-panel-toggle:focus-visible,
.dataset-map-canvas-controls button:focus-visible,
.dataset-map-node-shortcuts button:focus-visible,
.dataset-map-inspector-tabs button:focus-visible,
.dataset-map-secondary-action:focus-visible,
.dataset-map-primary-action:focus-visible,
.dataset-map-connections button:focus-visible,
.dataset-map-relation-table button:focus-visible {
  outline: 3px solid rgba(75, 103, 42, 0.2);
  outline-offset: 2px;
}

@container (max-width: 1180px) {
  .dataset-map-workspace {
    grid-template-columns: 220px minmax(460px, 1fr) 280px;
  }
  .dataset-map-workspace.is-left-collapsed {
    grid-template-columns: 54px minmax(460px, 1fr) 280px;
  }
  .dataset-map-workspace.is-right-collapsed {
    grid-template-columns: 220px minmax(460px, 1fr) 54px;
  }
  .dataset-map-toolbar__main {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-map-toolbar__actions {
    width: 100%;
    justify-content: flex-end;
  }
}
@container (max-width: 900px) {
  .dataset-map-workspace,
  .dataset-map-workspace.is-left-collapsed,
  .dataset-map-workspace.is-right-collapsed,
  .dataset-map-workspace.is-left-collapsed.is-right-collapsed {
    grid-template-columns: minmax(0, 1fr) 280px;
  }
  .dataset-map-left {
    display: none;
  }
  .dataset-map-canvas-panel {
    grid-column: 1;
  }
  .dataset-map-right {
    grid-column: 2;
  }
  .dataset-map-filterbar {
    align-items: stretch;
    flex-direction: column;
  }
  .dataset-map-search {
    width: 100%;
    flex-basis: auto;
  }
}
@container (max-width: 680px) {
  .dataset-map-workspace,
  .dataset-map-workspace.is-left-collapsed,
  .dataset-map-workspace.is-right-collapsed,
  .dataset-map-workspace.is-left-collapsed.is-right-collapsed {
    height: auto;
    max-height: none;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto auto auto;
  }
  .dataset-map-toolbar,
  .dataset-map-canvas-panel,
  .dataset-map-right {
    grid-column: 1;
  }
  .dataset-map-toolbar__actions {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .dataset-map-view-switcher {
    order: 3;
    width: 100%;
  }
  .dataset-map-view-switcher button {
    flex: 1;
    justify-content: center;
  }
  .dataset-map-text-button,
  .dataset-map-review-button {
    flex: 1;
  }
  .dataset-map-right {
    min-height: 420px;
    border-top: 1px solid #e3e6df;
    border-left: 0;
  }
  .dataset-map-canvas,
  .dataset-map-stage {
    min-height: 520px;
    height: 520px;
  }
  .dataset-map-canvas-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-map-canvas-facts {
    width: 100%;
  }
  .dataset-map-canvas-facts > span {
    flex: 1;
  }
  .dataset-map-canvas-footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-map-node-shortcuts {
    width: 100%;
    justify-content: flex-start;
  }
  .dataset-map-panel-toggle {
    display: none;
  }
}
.dataset-detail-page.is-graph-workspace {
  width: min(100%, 2000px);
  margin-inline: auto;
}

.dataset-map-workspace {
  width: min(100%, 1920px);
  min-height: 700px;
  height: clamp(700px, 100vh - 188px, 860px);
  margin-inline: auto;
  grid-template-columns: 272px minmax(640px, 1fr) 320px;
  border-radius: 20px;
  box-shadow: 0 16px 42px rgba(32, 43, 24, 0.065);
}

.dataset-map-workspace.is-left-collapsed {
  grid-template-columns: 58px minmax(640px, 1fr) 320px;
}

.dataset-map-workspace.is-right-collapsed {
  grid-template-columns: 272px minmax(640px, 1fr) 58px;
}

.dataset-map-workspace.is-left-collapsed.is-right-collapsed {
  grid-template-columns: 58px minmax(640px, 1fr) 58px;
}

.dataset-map-workspace.is-expanded,
.dataset-map-workspace.is-expanded.is-left-collapsed,
.dataset-map-workspace.is-expanded.is-right-collapsed,
.dataset-map-workspace.is-expanded.is-left-collapsed.is-right-collapsed {
  width: auto;
  height: auto;
  margin: 0;
  grid-template-columns: minmax(0, 1fr);
}

.dataset-map-toolbar__main {
  min-height: 76px;
  padding: 12px 18px;
}

.dataset-map-context > div > strong {
  font-size: 17px;
}

.dataset-map-context > div > small {
  font-size: 12px;
}

.dataset-map-filterbar {
  min-height: 52px;
  padding: 8px 18px;
}

.dataset-map-filterbar__filters > span,
.dataset-map-filterbar__filters button,
.dataset-map-search input,
.dataset-map-search small {
  font-size: 12px;
}

.dataset-map-filterbar__filters button {
  min-height: 32px;
  padding-inline: 10px;
}

.dataset-map-search {
  flex-basis: 270px;
  min-height: 38px;
}

.dataset-map-text-button,
.dataset-map-view-switcher button,
.dataset-map-expand-button,
.dataset-map-review-button {
  min-height: 38px;
}

.dataset-map-canvas-header {
  min-height: 96px;
  padding: 16px 22px;
}

.dataset-map-canvas-header > div:first-child > span {
  font-size: 12px;
}

.dataset-map-canvas-header h2 {
  margin-top: 4px;
  font-size: 20px;
}

.dataset-map-canvas-header p {
  margin-top: 5px;
  font-size: 12px;
}

.dataset-map-canvas-facts > span {
  min-width: 66px;
  padding-inline: 12px;
}

.dataset-map-canvas-facts strong {
  font-size: 14px;
}

.dataset-map-canvas-facts small {
  font-size: 12px;
}

.dataset-map-stage,
.dataset-map-canvas {
  background: #f8faf7;
}

.dataset-map-canvas-controls {
  top: 18px;
  right: 18px;
}

.dataset-map-canvas-controls button {
  width: 40px;
  height: 40px;
}

.dataset-map-canvas-guide {
  left: 18px;
  bottom: 16px;
  padding: 9px 12px;
  font-size: 12px;
}

.dataset-map-canvas-footer {
  min-height: 52px;
  padding: 8px 16px;
}

.dataset-map-legend > span,
.dataset-map-node-shortcuts > span,
.dataset-map-node-shortcuts button {
  font-size: 12px;
}

.dataset-map-side-section {
  padding: 18px;
}

.dataset-map-dataset {
  padding-top: 48px;
}

.dataset-map-dataset header > div > span,
.dataset-map-flow header span,
.dataset-map-flow li small {
  font-size: 12px;
}

.dataset-map-dataset header h3 {
  font-size: 14px;
}

.dataset-map-dataset > p,
.dataset-map-dataset dt,
.dataset-map-dataset dd,
.dataset-map-flow li strong {
  font-size: 12px;
}

.dataset-map-panel-toggle {
  width: 30px;
  height: 30px;
}

@container (max-width: 1180px) {
  .dataset-map-workspace,
  .dataset-map-workspace.is-left-collapsed,
  .dataset-map-workspace.is-right-collapsed,
  .dataset-map-workspace.is-left-collapsed.is-right-collapsed {
    grid-template-columns: 58px minmax(520px, 1fr) 58px;
  }
  .dataset-map-left > :not(.dataset-map-panel-toggle),
  .dataset-map-right > :not(.dataset-map-panel-toggle) {
    display: none;
  }
}
@container (max-width: 680px) {
  .dataset-map-workspace,
  .dataset-map-workspace.is-left-collapsed,
  .dataset-map-workspace.is-right-collapsed,
  .dataset-map-workspace.is-left-collapsed.is-right-collapsed {
    min-height: 0;
    height: auto;
    grid-template-columns: minmax(0, 1fr);
  }
  .dataset-map-left {
    display: none;
  }
  .dataset-map-right {
    display: block;
  }
}
.project-output-settings {
  min-height: 620px;
  padding: 24px 0 8px;
}

.project-output-settings__intro {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 28px;
}

.project-output-settings__copy h2 {
  margin: 0;
  color: var(--review-ink);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.045em;
  line-height: 1.2;
}

.project-output-settings__copy p {
  margin: 10px 0 0;
  color: var(--review-muted);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.55;
}

.project-output-settings__copy p + p {
  margin-top: 3px;
}

.project-output-settings__progress {
  min-width: 282px;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 16px;
  padding: 17px 20px;
  color: var(--review-subtle);
  border: 1px solid #d8dccf;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.74);
}

.project-output-settings__progress > i {
  width: 52px;
  color: #deded8;
  font-size: 48px;
  text-align: center;
}

.project-output-settings__progress > div {
  min-width: 0;
}

.project-output-settings__progress strong {
  display: flex;
  align-items: baseline;
  gap: 12px;
  color: var(--review-primary-dark);
}

.project-output-settings__progress strong b {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.project-output-settings__progress strong span {
  font-size: 12px;
  font-weight: 700;
}

.project-output-settings__progress p {
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
}

.project-output-settings__progress.is-complete > i {
  color: var(--review-primary);
}

.project-output-settings__grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px;
}

.project-output-settings__grid.is-single {
  max-width: 680px;
  grid-template-columns: minmax(0, 1fr);
}

.project-output-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #ced9bf;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.86);
}

.project-output-card.is-kg {
  border-color: #c8dcda;
}

.project-output-card.is-complete {
  border-color: #a9bf91;
}

.project-output-card.is-kg.is-complete {
  border-color: #91b8b4;
}

.project-output-card.is-navigable {
  cursor: pointer;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.project-output-card.is-navigable:hover {
  box-shadow: 0 16px 36px rgba(55, 68, 42, 0.1);
  transform: translateY(-2px);
}

.project-output-card.is-navigable:focus-visible {
  outline: 3px solid rgba(75, 103, 42, 0.2);
  outline-offset: 4px;
}

.project-output-card__header {
  min-height: 106px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 28px;
  border-bottom: 2px solid var(--review-primary);
  background: #fff;
}

.project-output-card.is-kg .project-output-card__header {
  border-bottom-color: var(--review-teal);
}

.project-output-card__identity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 18px;
}

.project-output-card__identity > div {
  min-width: 0;
}

.project-output-card__code {
  width: 60px;
  height: 60px;
  display: inline-grid;
  flex: 0 0 60px;
  place-items: center;
  color: var(--review-primary);
  font-size: 16px;
  font-weight: 700;
  border: 1px solid #d8e3cb;
  border-radius: 15px;
  background: var(--review-primary-soft);
}

.project-output-card__code.is-kg {
  color: var(--review-teal);
  border-color: #d2e3e0;
  background: var(--review-teal-soft);
}

.project-output-card__identity strong {
  display: block;
  color: var(--review-ink);
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.project-output-card__identity p {
  margin: 7px 0 0;
  overflow: hidden;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-output-card__status {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  padding: 7px 11px;
  color: #996218;
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  background: var(--review-gold-soft);
}

.project-output-card__status i {
  color: #d6901e;
  font-size: 12px;
}

.project-output-card__status.is-complete {
  color: var(--review-primary);
  background: var(--review-primary-soft);
}

.project-output-card__status.is-complete i {
  color: var(--review-primary);
  font-size: 12px;
}

.project-output-card__header-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

.project-output-card__settings {
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 11px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  border: 1px solid var(--review-line);
  border-radius: 9px;
  background: #fff;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.project-output-card__settings:hover {
  color: var(--review-primary);
  border-color: #b9c9a6;
  background: var(--review-primary-soft);
}

.project-output-card__body {
  padding: 19px 28px 23px;
  background: rgba(252, 253, 250, 0.78);
}

.project-output-card__body h3 {
  margin: 0 0 14px;
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.project-output-card.is-kg .project-output-card__body h3 {
  color: var(--review-teal);
}

.project-output-card__checklist {
  margin: 0;
  padding: 0 14px;
  overflow: hidden;
  border: 1px solid var(--review-line-soft);
  border-radius: 12px;
  background: #fff;
  list-style: none;
}

.project-output-card__checklist li {
  min-height: 57px;
  display: grid;
  grid-template-columns: 28px minmax(110px, 1fr) minmax(88px, auto);
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid var(--review-line-soft);
}

.project-output-card__checklist li:last-child {
  border-bottom: 0;
}

.project-output-card__item-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--review-primary);
  font-size: 16px;
}

.project-output-card.is-kg .project-output-card__item-icon {
  color: var(--review-teal);
}

.project-output-card__item-label {
  min-width: 0;
  color: var(--review-ink);
  font-size: 13px;
  font-weight: 700;
}

.project-output-card__item-value {
  max-width: 190px;
  padding: 6px 9px;
  overflow: hidden;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  background: #f5f5ef;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-output-card__checklist li.is-complete .project-output-card__item-value {
  color: var(--review-primary);
  background: var(--review-primary-soft);
}

.project-output-card.is-kg .project-output-card__checklist li.is-complete .project-output-card__item-value {
  color: var(--review-teal);
  background: var(--review-teal-soft);
}

.project-output-card__actions {
  margin-top: 18px;
}

.project-output-card__actions > p {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0 0 9px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-output-card__actions > p i {
  color: var(--review-primary);
}

.project-output-card__cta {
  width: 100%;
  min-height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid var(--review-primary);
  border-radius: 9px;
  background: var(--review-primary);
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.project-output-card__cta.is-kg {
  border-color: var(--review-teal);
  background: var(--review-teal);
}

.project-output-card__cta:hover {
  background: var(--review-primary-dark);
  box-shadow: 0 8px 18px rgba(75, 103, 42, 0.16);
  transform: translateY(-1px);
}

.project-output-card__cta.is-kg:hover {
  background: #285b56;
  box-shadow: 0 8px 18px rgba(53, 107, 101, 0.16);
}

.project-output-card__cta:focus-visible {
  outline: 3px solid rgba(75, 103, 42, 0.2);
  outline-offset: 3px;
}

.project-output-card__cta:disabled {
  color: #a7a49c;
  border-color: #dfdfd8;
  background: #efefeb;
  box-shadow: none;
  cursor: not-allowed;
  transform: none;
}

.project-output-settings__notice {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 24px;
  padding: 15px 20px;
  color: var(--review-ink);
  border: 1px solid var(--review-line-soft);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.58);
}

.project-output-settings__notice-icon {
  display: inline-flex;
  flex: 0 0 auto;
  color: #c47a12;
  font-size: 22px;
}

.project-output-settings__notice strong {
  display: block;
  font-size: 12px;
  font-weight: 700;
}

.project-output-settings__notice p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
}

.project-output-detail {
  max-width: 1180px;
  margin: 0 auto;
}

.project-output-detail__back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.project-output-detail__back:hover {
  color: var(--review-primary-dark);
}

.project-output-detail.is-kg .project-output-detail__back:hover {
  color: var(--review-teal);
}

.project-output-detail__hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding: 26px 30px;
  border: 1px solid #ced9bf;
  border-bottom: 3px solid var(--review-primary);
  border-radius: 18px 18px 0 0;
  background: #fff;
}

.project-output-detail.is-kg .project-output-detail__hero {
  border-color: #c8dcda;
  border-bottom-color: var(--review-teal);
}

.project-output-detail__identity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 20px;
}

.project-output-detail__identity > div {
  min-width: 0;
}

.project-output-detail__eyebrow {
  display: block;
  margin-bottom: 5px;
  color: #aa4e16;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.project-output-detail.is-kg .project-output-detail__eyebrow {
  color: var(--review-teal);
}

.project-output-detail__identity h2 {
  margin: 0;
  color: var(--review-ink);
  font-size: 25px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.project-output-detail__identity p {
  margin: 7px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
}

.project-output-detail__grid {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
  gap: 20px;
  padding: 24px;
  border: 1px solid #dfe4d8;
  border-top: 0;
  border-radius: 0 0 18px 18px;
  background: rgba(252, 253, 250, 0.82);
}

.project-output-detail.is-kg .project-output-detail__grid {
  border-color: #d7e4e2;
}

.project-output-detail__panel {
  min-width: 0;
  padding: 22px;
  border: 1px solid var(--review-line-soft);
  border-radius: 14px;
  background: #fff;
}

.project-output-detail__panel-header {
  min-height: 36px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.project-output-detail__panel-header > div > span {
  display: block;
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

.project-output-detail.is-kg .project-output-detail__panel-header > div > span {
  color: var(--review-teal);
}

.project-output-detail__panel-header h3 {
  margin: 4px 0 0;
  color: var(--review-ink);
  font-size: 16px;
  font-weight: 700;
}

.project-output-detail__checklist {
  padding: 0 12px;
}

.project-output-detail__checklist li {
  min-height: 55px;
}

.project-output-detail__state {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 16px;
  color: var(--review-primary);
  border: 1px solid #dbe5d0;
  border-radius: 12px;
  background: var(--review-primary-soft);
}

.project-output-detail.is-kg .project-output-detail__state {
  color: var(--review-teal);
  border-color: #d4e4e1;
  background: var(--review-teal-soft);
}

.project-output-detail__state > i {
  margin-top: 2px;
  font-size: 18px;
}

.project-output-detail__state strong {
  display: block;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.project-output-detail__state p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
}

.project-output-detail__steps {
  display: grid;
  gap: 0;
  margin: 18px 0;
  padding: 0;
  list-style: none;
}

.project-output-detail__steps li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: flex-start;
  gap: 11px;
  padding: 11px 0;
  border-bottom: 1px solid var(--review-line-soft);
}

.project-output-detail__steps li:last-child {
  border-bottom: 0;
}

.project-output-detail__steps b {
  width: 25px;
  height: 25px;
  display: grid;
  place-items: center;
  color: var(--review-primary);
  font-size: 12px;
  border-radius: 999px;
  background: var(--review-primary-soft);
}

.project-output-detail.is-kg .project-output-detail__steps b {
  color: var(--review-teal);
  background: var(--review-teal-soft);
}

.project-output-detail__steps strong {
  display: block;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.project-output-detail__steps p {
  margin: 3px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
}

.project-output-detail__primary {
  width: 100%;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 16px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid var(--review-primary);
  border-radius: 10px;
  background: var(--review-primary);
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

.project-output-detail__primary:hover {
  background: var(--review-primary-dark);
  box-shadow: 0 9px 20px rgba(75, 103, 42, 0.17);
  transform: translateY(-1px);
}

.project-output-detail__primary.is-kg {
  border-color: var(--review-teal);
  background: var(--review-teal);
}

.project-output-detail__primary.is-kg:hover {
  background: #285b56;
  box-shadow: 0 9px 20px rgba(53, 107, 101, 0.17);
}

.project-output-detail__primary:focus-visible,
.project-output-detail__back:focus-visible {
  outline: 3px solid rgba(75, 103, 42, 0.2);
  outline-offset: 3px;
}

.project-output-workspace {
  width: 100%;
  max-width: 1360px;
  margin: 0 auto;
}

.project-output-workspace__topline {
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.project-output-workspace__topline .project-output-detail__back {
  margin: 0;
}

.project-output-workspace__generation-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 22px 20px 20px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fff;
}

.project-output-workspace__generation-header .project-output-detail__eyebrow {
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.project-output-workspace__generation-header h2 {
  margin: 7px 0 0;
  color: var(--review-ink);
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.project-output-workspace__setting-button {
  min-height: 38px;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 13px;
  color: var(--review-muted);
  border: 1px solid var(--review-line);
  background: #fff;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.project-output-workspace__setting-button:hover {
  color: var(--review-primary);
  border-color: #bacaa8;
  background: var(--review-primary-soft);
}

.project-output-workspace.is-kg .project-output-workspace__setting-button:hover {
  color: var(--review-teal);
  border-color: #b7d1cd;
  background: var(--review-teal-soft);
}

.project-output-workspace__layout {
  display: grid;
  grid-template-areas: "steps empty" "materials generation";
  grid-template-columns: minmax(0, 1fr) 280px;
  align-items: start;
  column-gap: 18px;
  row-gap: 18px;
}

.project-output-workspace__layout.is-unconfigured {
  grid-template-areas: "steps" "generation";
  grid-template-columns: minmax(0, 1fr);
}

.project-output-workspace__steps {
  grid-area: steps;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 1px solid #dfe4da;
  border-radius: 14px;
  background: #fff;
  list-style: none;
}

.project-output-workspace__steps li {
  min-width: 0;
  min-height: 94px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  padding: 17px 20px;
  color: var(--review-muted);
}

.project-output-workspace__steps li + li {
  border-left: 1px solid var(--review-line-soft);
}

.project-output-workspace__steps li.is-active {
  color: var(--review-teal);
  box-shadow: inset 0 0 0 2px var(--review-teal);
}

.project-output-workspace__steps li.is-active:first-child {
  border-radius: 13px 0 0 13px;
}

.project-output-workspace__step-number {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  color: var(--review-ink);
  font-size: 14px;
  font-weight: 700;
  border: 1px solid var(--review-line);
  border-radius: 50%;
  background: #fff;
}

.project-output-workspace__steps li.is-active .project-output-workspace__step-number {
  color: #fff;
  border-color: var(--review-teal);
  background: var(--review-teal);
}

.project-output-workspace__step-copy {
  min-width: 0;
}

.project-output-workspace__step-copy strong,
.project-output-workspace__step-copy small {
  display: block;
}

.project-output-workspace__step-copy strong {
  color: var(--review-ink);
  font-size: 13px;
  font-weight: 700;
}

.project-output-workspace__step-copy small {
  margin-top: 6px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}

.project-output-workspace__steps li > i {
  color: var(--review-subtle);
  font-size: 14px;
}

.project-output-workspace__steps li:last-child > i {
  display: none;
}

.project-output-workspace__materials,
.project-output-workspace__generation-card {
  min-width: 0;
  border: 1px solid #dfe4da;
  border-radius: 16px;
  background: #fff;
}

.project-output-workspace__materials {
  grid-area: materials;
  min-height: 660px;
  overflow: hidden;
  box-shadow: 0 7px 22px rgba(47, 58, 37, 0.04);
}

.project-output-workspace__generation-card {
  grid-area: generation;
  position: sticky;
  top: 18px;
  min-height: 0;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(47, 58, 37, 0.06);
}

.project-output-workspace.is-kg .project-output-workspace__generation-card {
  border-color: #d5e4e1;
}

.project-output-workspace__section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 22px 22px 20px;
  border-bottom: 1px solid var(--review-line-soft);
}

.project-output-workspace__section-header span {
  display: block;
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.project-output-workspace.is-kg .project-output-workspace__section-header span {
  color: var(--review-teal);
}

.project-output-workspace__section-header h3 {
  margin: 4px 0 0;
  color: var(--review-ink);
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.project-output-workspace__section-header p {
  margin: 5px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
}

.project-output-workspace__section-header > strong {
  flex: 0 0 auto;
  padding: 6px 9px;
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  background: var(--review-primary-soft);
}

.project-output-workspace.is-kg .project-output-workspace__section-header > strong {
  color: var(--review-teal);
  background: var(--review-teal-soft);
}

.project-output-workspace__filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 14px;
  padding: 18px 22px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fbfcf9;
}

.project-output-workspace__filters .project-generation-field input {
  min-height: 42px;
}

.project-output-workspace__message {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  margin: 16px 22px 0;
  padding: 11px 12px;
  color: #8f611b;
  border: 1px solid #ead6ad;
  border-radius: 10px;
  background: #fffaf0;
}

.project-output-workspace__message > i {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.72);
}

.project-output-workspace__message strong {
  display: block;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__message p {
  margin: 3px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
}

.project-output-workspace__retry {
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 0 10px;
  color: #9f3f32;
  border: 1px solid #e3aea5;
  background: #fff;
  cursor: pointer;
}

.project-output-workspace__retry:hover:not(:disabled) {
  border-color: #c96b5d;
  background: #fff9f8;
}

.project-output-workspace__retry:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.project-output-workspace__message.is-error {
  color: #b64b3b;
  border-color: #edc7c0;
  background: #fff5f3;
}

.project-output-workspace__message.is-success {
  color: var(--review-primary);
  border-color: #cbdcb9;
  background: var(--review-primary-soft);
}

.project-output-workspace__message.is-partial {
  color: #a66a12;
  border-color: #ead6ad;
  background: #fffaf0;
}

.project-output-workspace__source-panel {
  position: relative;
  min-height: 430px;
  padding: 10px 18px 18px;
}

.project-output-workspace__source-list {
  max-height: 520px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.project-output-workspace__source-list .project-generation-source {
  min-height: 62px;
  padding: 9px 8px;
}

.project-output-workspace__source-list .project-generation-source:hover:not(:disabled),
.project-output-workspace__source-list .project-generation-source.is-selected {
  background: #f5f8f1;
}

.project-output-workspace.is-kg .project-output-workspace__source-list .project-generation-source:hover:not(:disabled),
.project-output-workspace.is-kg .project-output-workspace__source-list .project-generation-source.is-selected {
  background: #f2f8f7;
}

.project-output-workspace__loading {
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__loading i {
  color: var(--review-teal);
  font-size: 22px;
}

.project-output-workspace__generation-body {
  padding: 0 16px 18px;
}

.project-output-workspace__configuration {
  padding: 0;
  border-bottom: 1px solid var(--review-line-soft);
}

.project-output-workspace__configuration dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0;
}

.project-output-workspace__configuration dl > div {
  min-width: 0;
  padding: 15px 8px;
  border-bottom: 1px solid var(--review-line-soft);
}

.project-output-workspace__configuration dl > div.is-wide {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 76px minmax(0, 1fr);
  align-items: start;
  gap: 8px;
}

.project-output-workspace__configuration dl > div.is-stat + div.is-stat {
  border-left: 1px solid var(--review-line-soft);
}

.project-output-workspace__configuration dt {
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__configuration dd {
  margin: 5px 0 0;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.project-output-workspace__configuration dl > div.is-wide dd {
  margin-top: 0;
}

.project-output-workspace__configuration dl > div.is-stat dd {
  font-size: 12px;
}

.project-output-workspace__generation-action {
  padding-top: 14px;
}

.project-output-workspace__generation-action .project-output-workspace__message {
  margin: 0 0 14px;
}

.project-output-workspace__selection {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 10px;
  padding: 10px 11px;
  color: var(--review-muted);
  border-radius: 9px;
  background: #f5f5f1;
}

.project-output-workspace__selection.is-ready {
  color: var(--review-primary);
  background: var(--review-primary-soft);
}

.project-output-workspace.is-kg .project-output-workspace__selection.is-ready {
  color: var(--review-teal);
  background: var(--review-teal-soft);
}

.project-output-workspace__selection i {
  margin-top: 1px;
}

.project-output-workspace__selection p {
  margin: 0;
  color: inherit;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.project-output-workspace__progress {
  margin: 16px 0 10px;
  padding: 13px;
  border: 1px solid #cfddbf;
  border-radius: 10px;
  background: var(--review-primary-soft);
}

.project-output-workspace.is-kg .project-output-workspace__progress {
  border-color: #c8ddda;
  background: var(--review-teal-soft);
}

.project-output-workspace__progress-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.project-output-workspace__progress-heading > span {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--review-primary);
}

.project-output-workspace.is-kg .project-output-workspace__progress-heading > span {
  color: var(--review-teal);
}

.project-output-workspace__progress-heading strong {
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.project-output-workspace__progress-heading em {
  flex: 0 0 auto;
  color: var(--review-primary);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-output-workspace.is-kg .project-output-workspace__progress-heading em {
  color: var(--review-teal);
}

.project-output-workspace__progress-track {
  position: relative;
  height: 7px;
  margin-top: 11px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(75, 103, 42, 0.16);
}

.project-output-workspace.is-kg .project-output-workspace__progress-track {
  background: rgba(53, 107, 101, 0.16);
}

.project-output-workspace__progress-track i {
  position: absolute;
  inset-block: 0;
  left: -42%;
  width: 42%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--review-primary), #88a866);
  animation: project-output-generation-progress 1.55s ease-in-out infinite;
}

.project-output-workspace.is-kg .project-output-workspace__progress-track i {
  background: linear-gradient(90deg, var(--review-teal), #6da49e);
}

.project-output-workspace__progress > p {
  margin: 9px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
}

.project-output-workspace__progress ol {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 10px 0 0;
  padding: 0;
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 700;
  list-style: none;
}

.project-output-workspace__progress ol li {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.project-output-workspace__progress ol li::before {
  width: 5px;
  height: 5px;
  display: block;
  border-radius: 999px;
  background: currentColor;
  content: "";
}

@keyframes project-output-generation-progress {
  from {
    left: -42%;
  }
  to {
    left: 100%;
  }
}
.project-output-workspace__run {
  width: 100%;
  min-height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;
  border: 1px solid var(--review-primary);
  background: var(--review-primary);
  cursor: pointer;
}

.project-output-workspace__run.is-kg {
  border-color: var(--review-teal);
  background: var(--review-teal);
}

.project-output-workspace__run:disabled {
  color: #92958e;
  border-color: #dedfd9;
  background: #ecece8;
  cursor: not-allowed;
}

.project-output-workspace__run:not(:disabled):hover {
  filter: brightness(0.93);
}

.project-output-workspace__generation-action > small {
  display: block;
  margin-top: 8px;
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

.project-output-workspace__setup {
  min-height: 430px;
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
  padding: 30px;
  background: #fff;
}

.project-output-workspace__setup > span {
  width: 56px;
  height: 56px;
  display: grid;
  place-items: center;
  color: var(--review-primary);
  font-size: 20px;
  border-radius: 16px;
  background: var(--review-primary-soft);
}

.project-output-workspace__setup h3 {
  margin: 0;
  color: var(--review-ink);
  font-size: 17px;
  font-weight: 700;
}

.project-output-workspace__setup p {
  margin: 7px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.55;
}

.project-output-workspace__setup button {
  min-height: 42px;
  padding: 0 15px;
  color: #fff;
  border: 0;
  background: var(--review-primary);
  cursor: pointer;
}

@media (max-width: 1080px) {
  .project-output-workspace__layout {
    grid-template-areas: "steps" "materials" "generation";
    grid-template-columns: minmax(0, 1fr);
  }
  .project-output-workspace__generation-card {
    position: static;
  }
}
@media (max-width: 680px) {
  .project-output-workspace__steps {
    grid-template-columns: minmax(0, 1fr);
  }
  .project-output-workspace__steps li {
    min-height: 78px;
    padding: 14px 16px;
  }
  .project-output-workspace__steps li + li {
    border-top: 1px solid var(--review-line-soft);
    border-left: 0;
  }
  .project-output-workspace__steps li.is-active:first-child {
    border-radius: 13px 13px 0 0;
  }
  .project-output-workspace__steps li > i {
    display: none;
  }
  .project-output-workspace__filters {
    grid-template-columns: minmax(0, 1fr);
    padding: 14px 16px;
  }
  .project-output-workspace__section-header {
    align-items: flex-start;
    flex-direction: column;
    padding: 17px;
  }
  .project-output-workspace__source-panel {
    padding-inline: 10px;
  }
  .project-output-workspace__source-list .project-generation-source {
    grid-template-columns: 30px minmax(0, 1fr);
  }
  .project-output-workspace__source-list .project-generation-source__availability {
    grid-column: 2;
    justify-self: start;
  }
  .project-output-workspace__generation-body {
    padding: 0 20px 20px;
  }
  .project-output-workspace__configuration {
    padding: 0;
  }
  .project-output-workspace__configuration dl {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .project-output-workspace__configuration dl > div.is-wide {
    grid-column: 1/-1;
  }
  .project-output-workspace__setup {
    grid-template-columns: minmax(0, 1fr);
    justify-items: start;
    padding: 22px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .project-output-workspace__progress-track i {
    left: 29%;
    animation: none;
  }
}
.project-setting-modal-backdrop {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100dvh;
  z-index: 120;
  display: grid;
  place-items: center;
  overflow: hidden;
  overscroll-behavior: contain;
  padding: 24px;
  background: rgba(31, 34, 29, 0.6);
  backdrop-filter: blur(7px);
  animation: project-setting-fade-in 0.16s ease-out;
}

.project-setting-modal {
  width: min(620px, 100%);
  max-height: calc(100dvh - 48px);
  overflow: auto;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 26px 70px rgba(30, 32, 28, 0.25);
  animation: project-setting-rise-in 0.2s ease-out;
}

.project-generation-modal {
  width: min(760px, 100%);
  max-height: calc(100vh - 48px);
  overflow: auto;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 26px 70px rgba(30, 32, 28, 0.25);
  animation: project-setting-rise-in 0.2s ease-out;
}

.project-generation-modal__header {
  position: sticky;
  top: 0;
  z-index: 3;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fff;
}

.project-generation-modal__body {
  padding: 22px 24px 24px;
}

.project-generation-modal__loading {
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-generation-modal__loading i {
  color: var(--review-teal);
  font-size: 18px;
}

.project-generation-controls {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  gap: 12px;
  margin-bottom: 16px;
}

.project-generation-field > span {
  display: block;
  margin-bottom: 7px;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.project-generation-field input {
  width: 100%;
  min-height: 44px;
  padding: 0 12px;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
  border: 1px solid var(--review-line);
  border-radius: 10px;
  background: #fff;
  outline: none;
}

.project-generation-field input:focus {
  border-color: var(--review-teal);
  box-shadow: 0 0 0 4px rgba(53, 107, 101, 0.09);
}

.project-generation-field small {
  display: block;
  margin-top: 6px;
  color: var(--review-subtle);
  font-size: 12px;
  font-weight: 600;
}

.project-generation-search {
  position: relative;
}

.project-generation-search input {
  padding-right: 42px;
}

.project-generation-search button {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 34px;
  height: 34px;
  display: inline-grid;
  place-items: center;
  color: var(--review-teal);
  border: 0;
  background: var(--review-teal-soft);
  cursor: pointer;
}

.project-generation-alert,
.project-generation-result {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin-bottom: 16px;
  padding: 13px 15px;
  border: 1px solid #ecd5ab;
  border-radius: 11px;
  background: #fff9ed;
}

.project-generation-alert > i {
  margin-top: 2px;
  color: #bd7918;
}

.project-generation-alert.is-error {
  border-color: #efc6bf;
  background: #fff3f1;
}

.project-generation-alert.is-error > i {
  color: #b64535;
}

.project-generation-alert strong,
.project-generation-result strong {
  display: block;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.project-generation-alert p,
.project-generation-result p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
}

.project-generation-result {
  margin-bottom: 0;
  border-color: #c8dcb3;
  background: var(--review-primary-soft);
}

.project-generation-result > i {
  margin-top: 2px;
  color: var(--review-primary);
}

.project-generation-result code {
  display: block;
  margin-top: 7px;
  color: var(--review-primary-dark);
  font-size: 12px;
  font-weight: 700;
}

.project-generation-sources {
  overflow: hidden;
  border: 1px solid var(--review-line-soft);
  background: #fff;
}

.project-generation-sources__heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 16px 12px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fafbf8;
}

.project-generation-sources__heading span {
  display: block;
  color: var(--review-orange);
  letter-spacing: 0.08em;
}

.project-generation-sources__heading h3 {
  margin: 3px 0 0;
  color: var(--review-ink);
}

.project-generation-sources__heading > strong {
  color: var(--review-teal);
}

.project-generation-sources__list {
  max-height: 300px;
  overflow-y: auto;
  padding: 6px 14px;
}

.project-generation-source {
  width: 100%;
  min-height: 62px;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  padding: 9px 4px;
  color: inherit;
  border: 0;
  border-bottom: 1px solid var(--review-line-soft);
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.project-generation-source:last-child {
  border-bottom: 0;
}

.project-generation-source:hover:not(:disabled),
.project-generation-source.is-selected {
  background: #f7faf3;
}

.project-generation-source__check {
  width: 25px;
  height: 25px;
  display: inline-grid;
  place-items: center;
  color: var(--review-teal);
  border: 1px solid #c9dcda;
  background: var(--review-teal-soft);
}

.project-generation-source.is-selected .project-generation-source__check {
  color: #fff;
  border-color: var(--review-teal);
  background: var(--review-teal);
}

.project-generation-source__main {
  min-width: 0;
}

.project-generation-source__main strong,
.project-generation-source__main small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-generation-source__main strong {
  color: var(--review-ink);
}

.project-generation-source__main small {
  margin-top: 5px;
  color: var(--review-subtle);
}

.project-generation-source__availability {
  padding: 6px 9px;
  color: var(--review-teal);
  background: var(--review-teal-soft);
}

.project-generation-source.is-unavailable {
  opacity: 0.62;
  cursor: not-allowed;
}

.project-generation-sources__empty {
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 24px;
  color: var(--review-subtle);
  text-align: center;
}

.project-generation-sources__empty > i {
  margin-bottom: 10px;
  color: #c3c2bb;
  font-size: 24px;
}

.project-generation-sources__empty strong {
  color: var(--review-muted);
}

.project-generation-sources__empty p {
  margin: 5px 0 0;
}

.project-generation-modal__footer {
  position: sticky;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 15px 24px 19px;
  border-top: 1px solid var(--review-line-soft);
  background: #fff;
}

.project-generation-modal__footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.project-generation-modal__footer > div:first-child {
  align-items: flex-start;
  flex-direction: column;
  gap: 3px;
}

.project-generation-modal__footer strong {
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.project-generation-modal__footer span {
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-generation-modal__run {
  min-height: 41px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 16px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid var(--review-primary);
  border-radius: 10px;
  background: var(--review-primary);
  cursor: pointer;
}

.project-generation-modal__run i,
.project-generation-modal__run span {
  color: #fff;
  -webkit-text-fill-color: #fff;
}

.project-generation-modal__run:not(:disabled) {
  opacity: 1;
  color: #fff;
  box-shadow: 0 8px 18px rgba(75, 103, 42, 0.22);
}

.project-generation-modal__run:not(:disabled) i,
.project-generation-modal__run:not(:disabled) span {
  color: #fff;
}

.project-generation-modal__run:not(:disabled):hover {
  filter: brightness(0.93);
}

.project-generation-modal__run.is-kg {
  border-color: var(--review-teal);
  background: var(--review-teal);
}

.project-generation-modal__run:disabled,
.project-generation-search button:disabled,
.project-setting-modal__close:disabled,
.project-setting-modal__cancel:disabled {
  opacity: 0.48;
  cursor: not-allowed;
}

.project-generation-modal__run:disabled {
  opacity: 1;
  border-color: #a8b99a;
  background: #a8b99a;
  color: #fff;
}

.project-setting-modal__header {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid var(--review-line-soft);
  background: #fff;
}

.project-setting-modal__title {
  display: flex;
  align-items: center;
  gap: 13px;
}

.project-setting-modal__title > div > span {
  display: block;
  color: var(--review-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.project-setting-modal__title h2 {
  margin: 3px 0 0;
  color: var(--review-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.project-setting-modal__title p {
  margin: 4px 0 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 600;
}

.project-setting-modal__close {
  width: 34px;
  height: 34px;
  display: inline-grid;
  flex: 0 0 34px;
  place-items: center;
  color: var(--review-muted);
  border: 0;
  background: #f6f6f2;
  cursor: pointer;
}

.project-setting-modal__close:hover {
  color: var(--review-ink);
  background: #eceee8;
}

.project-setting-modal__body {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 17px 14px;
  padding: 22px 24px 24px;
}

.project-setting-field {
  min-width: 0;
}

.project-setting-advisory {
  grid-column: 1/-1;
  padding: 13px 15px;
  border: 1px solid #dbe6df;
  border-radius: 11px;
  background: #f5f9f6;
}

.project-setting-advisory p {
  margin: 6px 0 0;
  color: #66736c;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
}

.project-setting-field--wide {
  grid-column: 1/-1;
}

.project-setting-field > span,
.project-setting-field__label > span {
  display: block;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
}

.project-setting-field__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.project-setting-field__label a {
  color: var(--review-primary);
  font-size: 12px;
  font-weight: 700;
}

.project-setting-field select,
.project-setting-field input {
  width: 100%;
  min-height: 46px;
  margin-top: 8px;
  padding: 0 13px;
  color: var(--review-ink);
  font-size: 12px;
  font-weight: 700;
  border: 1px solid var(--review-line);
  border-radius: 11px;
  background: #fff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.project-setting-field select:focus,
.project-setting-field input:focus {
  border-color: var(--review-primary);
  box-shadow: 0 0 0 4px rgba(75, 103, 42, 0.1);
}

.project-setting-field input::placeholder {
  color: #b7b3ac;
}

.project-setting-number {
  position: relative;
}

.project-setting-number input {
  padding-right: 50px;
}

.project-setting-number em {
  position: absolute;
  right: 13px;
  bottom: 14px;
  color: var(--review-subtle);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-setting-modal__footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 16px 24px 20px;
  border-top: 1px solid var(--review-line-soft);
  background: #fff;
}

.project-setting-modal__footer > p {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  color: var(--review-muted);
  font-size: 12px;
  font-weight: 700;
}

.project-setting-modal__footer > p i {
  color: var(--review-orange);
}

.project-setting-modal__footer > div {
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}

.project-setting-modal__cancel,
.project-setting-modal__save {
  min-height: 41px;
  padding: 0 14px;
  cursor: pointer;
}

.project-setting-modal__cancel {
  color: var(--review-muted);
  border: 1px solid var(--review-line);
  background: #fff;
}

.project-setting-modal__save {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #fff;
  border: 1px solid var(--review-primary);
  background: var(--review-primary);
}

.project-setting-modal__save:hover {
  background: var(--review-primary-dark);
}

@keyframes project-setting-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes project-setting-rise-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 1024px) {
  .project-output-settings__intro {
    align-items: stretch;
    flex-direction: column;
    gap: 20px;
  }
  .project-output-settings__progress {
    width: 100%;
    min-width: 0;
  }
  .project-output-settings__grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .project-output-detail__grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 680px) {
  .project-output-settings {
    padding-top: 10px;
  }
  .project-output-settings__copy h2 {
    font-size: 24px;
  }
  .project-output-detail__hero {
    align-items: flex-start;
    flex-direction: column;
    padding: 20px;
  }
  .project-output-detail__identity {
    align-items: flex-start;
  }
  .project-output-detail__identity h2 {
    font-size: 22px;
  }
  .project-output-detail__grid {
    padding: 14px;
  }
  .project-output-detail__panel {
    padding: 17px;
  }
  .project-output-card__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }
  .project-output-card__status {
    align-self: flex-start;
  }
  .project-output-card__header-actions {
    width: 100%;
    justify-content: space-between;
  }
  .project-output-card__body {
    padding: 18px 20px 20px;
  }
  .project-output-card__checklist {
    padding: 0 12px;
  }
  .project-output-card__checklist li {
    grid-template-columns: 24px minmax(92px, 1fr) minmax(72px, auto);
    gap: 9px;
  }
  .project-output-card__item-value {
    max-width: 120px;
  }
  .project-output-settings__notice {
    align-items: flex-start;
  }
  .project-output-settings__progress strong {
    width: 100%;
    justify-content: space-between;
  }
  .project-setting-modal-backdrop {
    align-items: end;
    padding: 12px;
  }
  .project-setting-modal {
    max-height: calc(100dvh - 24px);
    border-radius: 20px;
  }
  .project-generation-modal {
    max-height: calc(100vh - 24px);
    border-radius: 20px;
  }
  .project-setting-modal__body {
    grid-template-columns: 1fr;
    padding: 20px;
  }
  .project-setting-field--wide {
    grid-column: auto;
  }
  .project-setting-modal__footer {
    align-items: stretch;
    flex-direction: column;
    padding: 14px 20px 20px;
  }
  .project-setting-modal__footer > div,
  .project-setting-modal__save {
    width: 100%;
  }
  .project-setting-modal__footer button {
    flex: 1 1 0;
    justify-content: center;
  }
  .project-generation-controls {
    grid-template-columns: 1fr;
  }
  .project-generation-modal__body {
    padding: 20px;
  }
  .project-generation-modal__footer {
    align-items: stretch;
    flex-direction: column;
    padding: 14px 20px 20px;
  }
  .project-generation-modal__footer > div:last-child,
  .project-generation-modal__run {
    width: 100%;
  }
  .project-generation-modal__footer button {
    flex: 1 1 0;
    justify-content: center;
  }
  .project-generation-source {
    grid-template-columns: 30px minmax(0, 1fr);
  }
  .project-generation-source__availability {
    grid-column: 2;
    justify-self: start;
  }
}
@media (prefers-reduced-motion: reduce) {
  .project-setting-modal-backdrop,
  .project-setting-modal,
  .project-generation-modal {
    animation: none;
  }
}
.project-setting-field select:disabled {
  color: var(--review-subtle);
  background: #f5f5f1;
  cursor: not-allowed;
}

.project-setting-field__empty {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 7px;
  color: #9a651c;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.project-setting-field__empty i {
  color: var(--review-orange);
}

.project-setting-validation {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 11px;
  padding: 13px 14px;
  color: #753a2c;
  border: 1px solid #ebc5b9;
  border-radius: 12px;
  background: #fff5f1;
  animation: project-setting-validation-in 0.18s ease-out;
}

.project-setting-validation__icon {
  width: 38px;
  height: 38px;
  display: inline-grid;
  place-items: center;
  color: #b8521b;
  font-size: 14px;
  border-radius: 11px;
  background: #ffe8dc;
}

.project-setting-validation strong {
  display: block;
  font-size: 12px;
  font-weight: 700;
}

.project-setting-validation p {
  margin: 3px 0 0;
  color: #9a5d4e;
  font-size: 12px;
  font-weight: 700;
}

.project-setting-validation ul {
  display: grid;
  gap: 3px;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
}

.project-setting-validation li {
  position: relative;
  padding-left: 10px;
  color: #7f4537;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.project-setting-validation li::before {
  position: absolute;
  top: 0.55em;
  left: 0;
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: #b8521b;
  content: "";
}

.project-setting-field.has-error > span,
.project-setting-field.has-error .project-setting-field__label > span {
  color: #9d3f31;
}

.project-setting-field.has-error select,
.project-setting-field.has-error input {
  border-color: #c85c4c;
  background: #fffafa;
  box-shadow: 0 0 0 3px rgba(200, 92, 76, 0.1);
}

.project-setting-field.has-error select:focus,
.project-setting-field.has-error input:focus {
  border-color: #b84536;
  box-shadow: 0 0 0 4px rgba(200, 92, 76, 0.13);
}

.project-setting-field__error {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 7px;
  color: #a74335;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.project-setting-field__error i {
  margin-top: 2px;
  color: #b8521b;
}

@keyframes project-setting-validation-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.project-output-workspace__result-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  width: fit-content;
  margin-top: 11px;
  padding: 9px 13px;
  border: 0;
  background: #386f68;
  color: #fff;
  cursor: pointer;
  transition: transform 160ms ease, background 160ms ease;
}

.project-output-workspace__result-link:hover {
  background: #285b55;
  transform: translateY(-1px);
}

.kg-result-page {
  display: grid;
  gap: 18px;
  color: #272925;
}

.kg-result-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 26px 28px;
  border: 1px solid #d7e1dc;
  border-radius: 22px;
  background: radial-gradient(circle at 88% 14%, rgba(169, 191, 145, 0.24), transparent 29%), linear-gradient(145deg, #ffffff 0%, #f8fbf8 67%, #f1f6f2 100%);
  box-shadow: 0 12px 34px rgba(43, 69, 58, 0.07);
}

.kg-result-header__copy {
  min-width: 0;
}

.kg-result-back {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 0 0 18px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #66716c;
  cursor: pointer;
}

.kg-result-back:hover {
  color: #315f58;
}

.kg-result-kicker,
.kg-result-toolbar > div:first-child > span,
.kg-result-panel header span {
  color: #b25424;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.kg-result-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 6px;
}

.kg-result-title-row h2 {
  margin: 0;
  color: #231f1d;
  font-size: clamp(24px, 3vw, 34px);
  font-weight: 700;
  letter-spacing: -0.045em;
}

.kg-result-header__copy > p {
  margin: 9px 0 0;
  color: #6f746f;
  font-size: 12px;
  font-weight: 600;
}

.kg-result-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid #bad0b0;
  border-radius: 999px;
  background: #f0f7ed;
  color: #55753c;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-header__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  flex: 0 0 auto;
}

.result-kind-switch {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-right: 4px;
  padding: 3px;
  border: 1px solid #d5dfda;
  border-radius: 12px;
  background: #eef3f0;
}

.result-kind-switch a {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border-radius: 9px;
  color: #69766f;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  transition: color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.result-kind-switch a:hover:not(.is-active) {
  color: #315f55;
  background: rgba(255, 255, 255, 0.55);
}

.result-kind-switch a.is-active {
  color: #285f51;
  background: #fff;
  box-shadow: 0 3px 10px rgba(44, 79, 67, 0.1);
}

.result-kind-switch a:focus-visible {
  outline: 3px solid rgba(72, 126, 116, 0.2);
  outline-offset: 1px;
}

.kg-result-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 15px;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;
}

.kg-result-button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.kg-result-button.is-secondary {
  border: 1px solid #d3dbd7;
  background: rgba(255, 255, 255, 0.84);
  color: #59645f;
}

.kg-result-button.is-primary {
  border: 1px solid #315f58;
  background: #315f58;
  color: #fff;
}

.kg-result-button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.kg-result-button.is-secondary:hover:not(:disabled) {
  border-color: #9dadA5;
  background: #fff;
}

.kg-result-button.is-primary:hover:not(:disabled) {
  background: #254d47;
}

.kg-result-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 240px;
  border: 1px solid #d9e2de;
  border-radius: 18px;
  background: #fff;
  color: #53645d;
  font-size: 12px;
}

.kg-result-state > i {
  color: #3d776f;
  font-size: 20px;
}

.kg-result-state.is-error {
  justify-content: flex-start;
  min-height: auto;
  padding: 22px;
  border-color: #ecc8bd;
  background: #fff8f5;
  color: #8f4939;
}

.kg-result-state.is-error p {
  margin: 5px 0 12px;
  font-size: 12px;
}

.kg-result-state.is-error button {
  padding: 7px 11px;
  border: 1px solid #dca99b;
  background: #fff;
  color: #8f4939;
  cursor: pointer;
}

.kg-result-summary {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  border: 1px solid #d9e1dd;
  border-radius: 17px;
  background: #fff;
  box-shadow: 0 9px 28px rgba(46, 65, 57, 0.05);
  overflow: hidden;
}

.kg-result-summary article {
  display: flex;
  align-items: center;
  gap: 13px;
  min-width: 0;
  padding: 20px 18px;
  border-right: 1px solid #e4e9e6;
}

.kg-result-summary article:last-child {
  border-right: 0;
}

.kg-result-summary article > span {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  border-radius: 11px;
  font-size: 15px;
}

.kg-result-summary article > span.is-source {
  background: #edf4e9;
  color: #55733f;
}

.kg-result-summary article > span.is-claim {
  background: #e8f2f0;
  color: #315f58;
}

.kg-result-summary article > span.is-node {
  background: #eaf0f5;
  color: #496982;
}

.kg-result-summary article > span.is-edge {
  background: #f8eee6;
  color: #a35d34;
}

.kg-result-summary article > span.is-validation {
  background: #f3eee2;
  color: #89733d;
}

.kg-result-summary div {
  min-width: 0;
}

.kg-result-summary small {
  display: block;
  color: #8a918d;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-summary strong {
  display: block;
  margin-top: 2px;
  color: #26312c;
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.kg-result-summary strong.is-text {
  overflow: hidden;
  font-size: 12px;
  letter-spacing: -0.02em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-result-summary p {
  overflow: hidden;
  margin: 2px 0 0;
  color: #8a918d;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-result-workspace {
  border: 1px solid #d5dfda;
  border-radius: 20px;
  background: #f8fbfa;
  box-shadow: 0 14px 38px rgba(44, 65, 56, 0.07);
  overflow: hidden;
}

.kg-result-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px 17px;
  border-bottom: 1px solid #dce5e0;
  background: rgba(255, 255, 255, 0.9);
}

.kg-result-toolbar h3,
.kg-result-panel h3 {
  margin: 4px 0 0;
  color: #26302c;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.kg-result-toolbar p {
  margin: 5px 0 0;
  color: #808985;
  font-size: 12px;
  font-weight: 600;
}

.kg-result-toolbar__controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kg-result-search {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(300px, 30vw);
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d5ded9;
  border-radius: 10px;
  background: #f9fbfa;
  color: #89938e;
}

.kg-result-search:focus-within {
  border-color: #759b92;
  box-shadow: 0 0 0 3px rgba(49, 95, 88, 0.1);
}

.kg-result-search input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: #35423c;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-zoom {
  display: flex;
  height: 38px;
  border: 1px solid #d5ded9;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.kg-result-zoom button {
  display: grid;
  place-items: center;
  width: 36px;
  border: 0;
  border-right: 1px solid #e3e9e6;
  background: transparent;
  color: #66756e;
  cursor: pointer;
}

.kg-result-zoom button:last-child {
  border-right: 0;
}

.kg-result-zoom button:hover {
  background: #edf4f1;
  color: #315f58;
}

.kg-result-filters {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 22px;
  border-bottom: 1px solid #dde5e1;
  background: #f5f8f6;
  overflow-x: auto;
}

.kg-result-filters button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex: 0 0 auto;
  padding: 7px 10px;
  border: 1px solid #d8e1dd;
  background: #fff;
  color: #68736e;
  cursor: pointer;
}

.kg-result-filters button em {
  display: grid;
  place-items: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: #eff3f1;
  color: #7a857f;
  font-style: normal;
}

.kg-result-filters button.is-active {
  border-color: #315f58;
  background: #315f58;
  color: #fff;
}

.kg-result-filters button.is-active em {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.kg-result-filters button:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}

.kg-result-workspace__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 390px;
  min-height: 650px;
}

.kg-result-graph-panel {
  position: relative;
  min-width: 0;
  background: radial-gradient(circle at 1px 1px, rgba(91, 115, 105, 0.15) 1px, transparent 0) 0 0/24px 24px, linear-gradient(135deg, #fbfdfc, #f3f8f5);
}

.kg-result-canvas {
  position: absolute;
  inset: 0;
  cursor: grab;
}

.kg-result-canvas:active {
  cursor: grabbing;
}

.kg-result-graph-hint {
  position: absolute;
  bottom: 16px;
  left: 18px;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 11px;
  border: 1px solid rgba(201, 214, 208, 0.9);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 8px 20px rgba(45, 64, 56, 0.08);
  color: #68766f;
  font-size: 12px;
  font-weight: 700;
  pointer-events: none;
  backdrop-filter: blur(8px);
}

.kg-result-graph-hint i {
  color: #3d7169;
}

.kg-result-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 100%;
  color: #7d8882;
  text-align: center;
}

.kg-result-empty i {
  margin-bottom: 4px;
  color: #9ba9a3;
  font-size: 24px;
}

.kg-result-empty strong {
  font-size: 12px;
}

.kg-result-empty p {
  margin: 0;
  font-size: 12px;
}

.kg-result-inspector {
  min-width: 0;
  border-left: 1px solid #dbe4df;
  background: #fff;
  overflow: hidden;
}

.kg-result-inspector__header {
  padding: 20px 20px 17px;
  border-bottom: 1px solid #e1e7e4;
}

.kg-result-inspector__header > span {
  display: inline-flex;
  padding: 5px 8px;
  border-radius: 7px;
  background: #eef3f1;
  color: #56635d;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-inspector__header > span.is-source {
  background: #edf4e9;
  color: #55733f;
}

.kg-result-inspector__header > span.is-claim {
  background: #e6f0ed;
  color: #315f58;
}

.kg-result-inspector__header > span.is-entity {
  background: #e9f0f5;
  color: #496982;
}

.kg-result-inspector__header > span.is-event {
  background: #f8eee6;
  color: #a35d34;
}

.kg-result-inspector__header > span.is-time {
  background: #f3eee2;
  color: #89733d;
}

.kg-result-inspector__header > span.is-concept {
  background: #f0eaf4;
  color: #755989;
}

.kg-result-inspector__header > span.is-evidence {
  background: #f2ede5;
  color: #806b4c;
}

.kg-result-inspector__header h3 {
  margin: 10px 0 0;
  color: #26302c;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.45;
  word-break: keep-all;
}

.kg-result-inspector__header p {
  overflow: hidden;
  margin: 7px 0 0;
  color: #99a09c;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-result-source-preview {
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr);
  gap: 16px;
  padding: 17px 20px 19px;
  border-bottom: 1px solid #e1e7e4;
  background: radial-gradient(circle at 12% 18%, rgba(177, 197, 154, 0.2), transparent 38%), linear-gradient(145deg, #f8fbf7, #f1f6f2);
}

.kg-result-source-cover {
  position: relative;
  width: 108px;
  height: 148px;
  margin: 0;
  border-radius: 4px 10px 10px 4px;
  background: #e7eee6;
  box-shadow: 0 12px 24px rgba(48, 66, 57, 0.18), inset 4px 0 0 rgba(48, 83, 72, 0.16);
  overflow: hidden;
}

.kg-result-source-cover::after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 7px;
  width: 1px;
  background: rgba(255, 255, 255, 0.34);
  content: "";
  pointer-events: none;
}

.kg-result-source-cover > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.kg-result-source-cover__digital {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 14px 11px 12px 15px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.12), transparent 38%), linear-gradient(145deg, #406d61, #244b45);
  color: #fff;
}

.kg-result-source-cover__digital > img {
  width: 74px;
  height: 28px;
  padding: 4px 5px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.92);
  object-fit: contain;
}

.kg-result-source-cover__digital span {
  margin-top: auto;
  color: #d9e8d2;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.kg-result-source-cover__digital strong {
  display: -webkit-box;
  margin-top: 6px;
  overflow: hidden;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: -0.025em;
  word-break: keep-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.kg-result-source-cover__digital small {
  margin-top: 7px;
  color: rgba(255, 255, 255, 0.58);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.kg-result-source-preview__copy {
  align-self: center;
  min-width: 0;
}

.kg-result-source-preview__copy > span {
  color: #b25424;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.kg-result-source-preview__copy h4 {
  margin: 7px 0 0;
  color: #26322d;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.03em;
  word-break: keep-all;
}

.kg-result-source-preview__copy p {
  margin: 8px 0 0;
  color: #718078;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  word-break: keep-all;
}

.kg-result-source-preview__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 11px;
}

.kg-result-source-preview__badges em {
  padding: 4px 7px;
  border-radius: 999px;
  background: #e5eee1;
  color: #557348;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.kg-result-inspector__tabs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid #e1e7e4;
}

.kg-result-inspector__tabs button {
  padding: 12px 5px 10px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #929a96;
  cursor: pointer;
}

.kg-result-inspector__tabs button.is-active {
  border-bottom-color: #315f58;
  color: #315f58;
}

.kg-result-inspector__content {
  max-height: 485px;
  padding: 16px 18px;
  overflow: auto;
}

.kg-result-source-preview + .kg-result-inspector__tabs + .kg-result-inspector__content {
  max-height: 230px;
}

.kg-result-inspector__content dl {
  display: grid;
  gap: 0;
  margin: 0;
}

.kg-result-inspector__content dl > div {
  display: grid;
  grid-template-columns: 105px minmax(0, 1fr);
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #edf0ee;
}

.kg-result-inspector__content dt {
  color: #969e9a;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 700;
  word-break: break-all;
}

.kg-result-inspector__content dd {
  margin: 0;
  color: #46514c;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.55;
  word-break: break-word;
}

.kg-result-source-meta dl,
.kg-result-source-meta {
  margin: 0;
}

.kg-result-source-meta > div {
  grid-template-columns: 92px minmax(0, 1fr) !important;
}

.kg-result-source-meta dt {
  font-family: inherit;
  font-size: 12px;
  word-break: keep-all;
}

.kg-result-source-meta dd {
  color: #34443d;
  font-size: 12px;
}

.kg-result-inspector__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 650px;
  padding: 30px;
  color: #78847e;
  text-align: center;
}

.kg-result-inspector__placeholder > span {
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  margin-bottom: 14px;
  border-radius: 17px;
  background: #edf4f1;
  color: #3f7068;
  font-size: 19px;
}

.kg-result-inspector__placeholder strong {
  color: #3d4b45;
  font-size: 12px;
}

.kg-result-inspector__placeholder p {
  max-width: 230px;
  margin: 7px 0 0;
  color: #929c97;
  font-size: 12px;
  line-height: 1.55;
}

.kg-result-inspector__empty {
  padding: 35px 10px;
  color: #9aa29e;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.kg-result-connections,
.kg-result-sources,
.kg-result-warnings {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.kg-result-connections button {
  width: 100%;
  padding: 11px 12px;
  border: 1px solid #e0e6e3;
  background: #fafcfb;
  color: #37443e;
  text-align: left;
  cursor: pointer;
}

.kg-result-connections button:hover {
  border-color: #94aaa1;
  background: #f2f7f5;
}

.kg-result-connection__direction {
  display: block;
  color: #9aa29e;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-connections strong {
  display: block;
  margin-top: 3px;
  color: #315f58;
  font-size: 12px;
}

.kg-result-connections p {
  margin: 5px 0 0;
  color: #68736e;
  font-size: 12px;
  line-height: 1.45;
}

.kg-result-evidence > span {
  display: block;
  margin-bottom: 9px;
  color: #8c7756;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-evidence blockquote {
  margin: 0;
  padding: 13px 14px;
  border-left: 3px solid #c7ad82;
  border-radius: 0 10px 10px 0;
  background: #faf7f1;
  color: #51493e;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.75;
  white-space: pre-wrap;
}

.kg-result-lower-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
  gap: 16px;
}

.kg-result-panel {
  min-width: 0;
  padding: 20px;
  border: 1px solid #dae2de;
  border-radius: 17px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(49, 66, 59, 0.04);
}

.kg-result-panel > header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.kg-result-panel > header > strong {
  color: #6e7973;
  font-size: 12px;
}

.kg-result-sources {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.kg-result-sources li {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  padding: 10px;
  border: 1px solid #e3e9e6;
  border-radius: 10px;
  background: #fafcfb;
}

.kg-result-sources li > span {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #edf4e9;
  color: #5c7748;
}

.kg-result-sources strong {
  display: block;
  overflow: hidden;
  color: #3e4944;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-result-sources p {
  margin: 3px 0 0;
  color: #929a96;
  font-size: 12px;
}

.kg-result-sources em {
  color: #8a938e;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.kg-result-warnings li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 11px 12px;
  border: 1px solid #eadfca;
  border-radius: 10px;
  background: #fdfaf4;
}

.kg-result-warnings li > i {
  margin-top: 2px;
  color: #b27b2f;
}

.kg-result-warnings strong {
  color: #775926;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
}

.kg-result-warnings p {
  margin: 3px 0 0;
  color: #6e6554;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.kg-result-warnings small {
  display: block;
  margin-top: 4px;
  color: #978a75;
  font-size: 12px;
  line-height: 1.45;
}

.kg-result-panel__empty {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 18px;
  border-radius: 10px;
  background: #f1f7ee;
  color: #5b7847;
  font-size: 12px;
}

@media (max-width: 1180px) {
  .kg-result-summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .kg-result-summary article:nth-child(3) {
    border-right: 0;
  }
  .kg-result-summary article:nth-child(n+4) {
    border-top: 1px solid #e4e9e6;
  }
  .kg-result-workspace__body {
    grid-template-columns: minmax(0, 1fr) 350px;
  }
  .kg-result-sources {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 900px) {
  .kg-result-header,
  .kg-result-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .kg-result-header__actions,
  .kg-result-toolbar__controls {
    width: 100%;
  }
  .result-kind-switch {
    margin-right: auto;
  }
  .kg-result-button,
  .kg-result-search {
    flex: 1 1 auto;
    width: auto;
  }
  .kg-result-workspace__body {
    grid-template-columns: 1fr;
  }
  .kg-result-graph-panel {
    min-height: 560px;
  }
  .kg-result-inspector {
    border-top: 1px solid #dbe4df;
    border-left: 0;
  }
  .kg-result-inspector__content {
    max-height: 390px;
  }
  .kg-result-inspector__placeholder {
    min-height: 320px;
  }
  .kg-result-lower-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 640px) {
  .kg-result-header {
    padding: 21px 18px;
    border-radius: 16px;
  }
  .kg-result-header__actions,
  .kg-result-toolbar__controls {
    align-items: stretch;
    flex-direction: column;
  }
  .result-kind-switch {
    display: flex;
    width: 100%;
    margin-right: 0;
  }
  .result-kind-switch a {
    flex: 1 1 50%;
  }
  .kg-result-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .kg-result-summary article,
  .kg-result-summary article:nth-child(3) {
    border-top: 1px solid #e4e9e6;
    border-right: 1px solid #e4e9e6;
  }
  .kg-result-summary article:nth-child(1),
  .kg-result-summary article:nth-child(2) {
    border-top: 0;
  }
  .kg-result-summary article:nth-child(even) {
    border-right: 0;
  }
  .kg-result-toolbar {
    padding: 18px 16px 14px;
  }
  .kg-result-filters {
    padding-right: 16px;
    padding-left: 16px;
  }
  .kg-result-graph-panel {
    min-height: 480px;
  }
  .kg-result-source-preview {
    grid-template-columns: 94px minmax(0, 1fr);
    padding: 15px 16px 17px;
  }
  .kg-result-source-cover {
    width: 94px;
    height: 132px;
  }
  .kg-result-graph-hint {
    right: 14px;
    bottom: 12px;
    left: 14px;
    justify-content: center;
  }
  .kg-result-panel {
    padding: 16px;
  }
}
.project-setting-field__hint {
  display: block;
  margin-top: 7px;
  color: #7b817d;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.55;
}

.project-output-workspace__configuration dl.has-qa-target {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.project-output-workspace__configuration dl.has-qa-target > div.is-stat:nth-of-type(6) {
  border-left: 0;
}

.review-project-header.is-output-result-header {
  border: 0 !important;
  border-bottom: 1px solid #dfe5e1 !important;
  outline: 0 !important;
  background: #fff;
}

.project-result-page-title {
  display: grid;
  gap: 10px;
  min-width: 0;
}

.project-result-page-title__back {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 7px;
  color: #66726d;
  font-size: 12px;
  font-weight: 700;
  transition: color 150ms ease;
}

.project-result-page-title__back:hover {
  color: #285f51;
}

.project-result-page-title__heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.project-result-page-title__heading h1 {
  margin: 0 4px 0 0;
}

.project-result-page-title__status,
.project-result-page-title__type {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  padding: 0 9px;
  border: 1px solid #cbdac7;
  border-radius: 999px;
  background: #f3f8f1;
  color: #567348;
  font-size: 12px;
  font-weight: 700;
}

.project-result-page-title__type {
  border-color: #ead6b7;
  background: #fff8ed;
  color: #8b6a31;
}

.project-result-page-title__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px 0;
  margin: 0;
}

.project-result-page-title__meta > div {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #68736e;
  font-size: 12px;
  font-weight: 700;
}

.project-result-page-title__meta > div + div::before {
  width: 1px;
  height: 11px;
  margin: 0 10px;
  background: #dce2de;
  content: "";
}

.project-result-page-title__meta dt {
  color: #959d99;
  font-weight: 700;
}

.project-result-page-title__meta dd {
  margin: 0;
  color: #4b5651;
  font-weight: 700;
}

.qa-result-header {
  align-items: center;
  border-radius: 17px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(44, 67, 58, 0.06);
}

.qa-result-page .kg-result-back {
  min-height: 36px;
  margin-bottom: 15px;
  padding: 0 12px;
  border: 1px solid #ccd7d1;
  background: #fff;
  color: #4f6159;
  box-shadow: 0 2px 5px rgba(37, 65, 54, 0.06);
  transition: color 150ms ease, border-color 150ms ease, background 150ms ease, transform 150ms ease;
}

.qa-result-page .kg-result-back:hover {
  border-color: #93afa5;
  background: #f4f8f6;
  color: #285f51;
  transform: translateY(-1px);
}

.qa-result-header__kicker {
  display: block;
  margin-bottom: 7px;
}

.qa-result-page .kg-result-header__actions {
  max-width: 610px;
}

.qa-result-page .result-kind-switch {
  border-color: #c9d5cf;
  background: #edf3f0;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.7);
}

.qa-result-page .result-kind-switch a {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid transparent;
  font-size: 12px;
}

.qa-result-page .result-kind-switch a.is-active {
  border-color: #4d7b6d;
  background: #356d5f;
  color: #fff;
  box-shadow: 0 4px 10px rgba(44, 91, 76, 0.18);
}

.qa-result-page .kg-result-button {
  min-height: 42px;
  padding: 0 16px;
  border-width: 1px;
  border-style: solid;
  box-shadow: 0 3px 8px rgba(41, 63, 54, 0.08);
}

.qa-result-page .kg-result-button.is-secondary {
  border-color: #bdc9c3;
  background: #fff;
  color: #45544d;
}

.qa-result-page .kg-result-button.is-primary {
  border-color: #315f58;
  background: #315f58;
  box-shadow: 0 5px 12px rgba(49, 95, 88, 0.2);
}

.qa-result-page .kg-result-button:focus-visible,
.qa-result-page .kg-result-back:focus-visible {
  outline: 3px solid rgba(72, 126, 116, 0.2);
  outline-offset: 2px;
}

.qa-result-page .kg-result-title-row {
  position: relative;
  overflow: visible;
}

.qa-result-version-picker {
  position: relative;
}

.qa-result-version-picker__trigger {
  display: inline-flex;
  min-width: 156px;
  min-height: 43px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 7px 12px 7px 14px;
  border: 1px solid #b9cbc2;
  background: #f7faf8;
  color: #35594f;
  text-align: left;
  box-shadow: 0 2px 6px rgba(37, 65, 54, 0.07);
  cursor: pointer;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.qa-result-version-picker__trigger > span {
  display: grid;
  gap: 2px;
}

.qa-result-version-picker__trigger small {
  color: #77847e;
}

.qa-result-version-picker__trigger > i {
  color: #668077;
  font-size: 12px;
  transition: transform 160ms ease;
}

.qa-result-version-picker__trigger:hover:not(:disabled),
.qa-result-version-picker.is-open .qa-result-version-picker__trigger {
  border-color: #6f9488;
  background: #eef5f1;
  box-shadow: 0 5px 14px rgba(49, 95, 88, 0.12);
}

.qa-result-version-picker.is-open .qa-result-version-picker__trigger > i {
  transform: rotate(180deg);
}

.qa-result-version-picker__trigger:disabled {
  cursor: default;
}

.qa-result-version-picker__trigger:focus-visible,
.qa-result-version-picker__option:focus-visible {
  outline: 3px solid rgba(72, 126, 116, 0.2);
  outline-offset: 2px;
}

.qa-result-version-picker__dismiss {
  position: fixed;
  z-index: 70;
  inset: 0;
  border: 0;
  background: transparent;
  cursor: default;
}

.qa-result-version-picker.is-open .qa-result-version-picker__trigger {
  position: relative;
  z-index: 72;
}

.qa-result-version-picker__menu {
  position: absolute;
  z-index: 73;
  top: calc(100% + 9px);
  left: 0;
  width: min(440px, 100vw - 48px);
  overflow: hidden;
  border: 1px solid #c8d5cf;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 18px 44px rgba(29, 49, 41, 0.18);
}

.qa-result-version-picker__menu > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  border-bottom: 1px solid #e1e8e4;
  background: #f7f9f8;
  color: #34453e;
}

.qa-result-version-picker__menu > header strong {
  font-size: 12px;
  font-weight: 700;
}

.qa-result-version-picker__menu > header span {
  color: #84908a;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-version-picker__option {
  display: grid;
  width: 100%;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 14px 15px;
  border: 0;
  border-bottom: 1px solid #e8ecea;
  background: #fff;
  color: #33443d;
  text-align: left;
  cursor: pointer;
}

.qa-result-version-picker__option:last-child {
  border-bottom: 0;
}

.qa-result-version-picker__option:hover,
.qa-result-version-picker__option.is-selected {
  background: #f1f6f3;
}

.qa-result-version-picker__option.is-selected {
  box-shadow: inset 3px 0 #4f7f70;
}

.qa-result-version-picker__check {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #e7f0eb;
  color: #3f7364;
  font-size: 12px;
}

.qa-result-version-picker__option:not(.is-selected) .qa-result-version-picker__check {
  background: transparent;
}

.qa-result-version-picker__option-copy {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.qa-result-version-picker__option-copy > span {
  display: flex;
  align-items: center;
  gap: 7px;
}

.qa-result-version-picker__option-copy em {
  padding: 2px 6px;
  background: #dcebe3;
  color: #3f6e60;
  font-style: normal;
}

.qa-result-version-picker__option-copy small,
.qa-result-version-picker__option-copy time {
  overflow: hidden;
  color: #7c8882;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-result-version-picker__review {
  padding: 5px 8px;
  border-radius: 999px;
  background: #f1f2f1;
  color: #7a837f;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.qa-result-version-picker__review.is-complete {
  background: #e6f1e2;
  color: #55783d;
}

.qa-result-export-context {
  flex-basis: 100%;
  color: #929b96;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.qa-result-version-context {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: -8px;
  padding: 10px 16px;
  border: 1px solid #d7e2dc;
  border-radius: 11px;
  background: #f1f7f3;
  color: #46675c;
}

.qa-result-version-context > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.qa-result-version-context strong {
  font-size: 12px;
  font-weight: 700;
}

.qa-result-version-context span {
  overflow: hidden;
  color: #76857e;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-result-version-context em {
  padding: 4px 8px;
  border-radius: 999px;
  background: #fff;
  color: #78847f;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.qa-result-version-context.is-archive {
  border-color: #ddd8ca;
  background: #faf8f1;
  color: #74684b;
}

.qa-result-summary {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.qa-result-summary article {
  padding: 18px 14px;
}

.qa-result-summary article > span {
  width: 36px;
  height: 36px;
  flex-basis: 36px;
}

@media (max-width: 1280px) {
  .qa-result-summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .qa-result-summary article:nth-child(3) {
    border-right: 0;
  }
  .qa-result-summary article:nth-child(n+4) {
    border-top: 1px solid #e4e9e6;
  }
}
@media (max-width: 760px) {
  .review-project-header.is-output-result-header .review-project-header__inner > div {
    padding-bottom: 16px !important;
  }
  .project-result-page-title__meta {
    align-items: flex-start;
    flex-direction: column;
  }
  .project-result-page-title__meta > div + div::before {
    display: none;
  }
  .qa-result-header {
    align-items: stretch;
    flex-direction: column;
    padding: 21px 18px;
  }
  .qa-result-page .kg-result-header__actions {
    max-width: none;
    justify-content: flex-start;
  }
  .qa-result-export-context {
    text-align: left;
  }
  .qa-result-version-picker__menu {
    position: fixed;
    top: 50%;
    left: 50%;
    width: min(440px, 100vw - 28px);
    max-height: calc(100vh - 40px);
    overflow-y: auto;
    transform: translate(-50%, -50%);
  }
  .qa-result-version-context,
  .qa-result-version-context > div {
    align-items: flex-start;
    flex-direction: column;
  }
  .qa-result-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .qa-result-summary article:nth-child(3) {
    border-right: 1px solid #e4e9e6;
  }
  .qa-result-summary article:nth-child(2n) {
    border-right: 0;
  }
  .qa-result-summary article:nth-child(n+3) {
    border-top: 1px solid #e4e9e6;
  }
}
@media (max-width: 460px) {
  .qa-result-page .result-kind-switch,
  .qa-result-page .kg-result-button {
    width: 100%;
  }
  .qa-result-page .result-kind-switch a {
    flex: 1 1 0;
  }
  .qa-result-summary {
    grid-template-columns: 1fr;
  }
  .qa-result-summary article,
  .qa-result-summary article:nth-child(3),
  .qa-result-summary article:nth-child(2n) {
    border-right: 0;
  }
  .qa-result-summary article:nth-child(n+2) {
    border-top: 1px solid #e4e9e6;
  }
}
.qa-result-workspace {
  overflow: hidden;
  border: 1px solid #d9e2de;
  border-radius: 19px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(44, 67, 58, 0.055);
}

.qa-result-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #e4eae7;
  background: #fbfcfb;
}

.qa-result-toolbar__copy {
  min-width: 0;
}

.qa-result-toolbar__copy > span {
  color: #b25424;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.qa-result-toolbar__copy h3 {
  margin: 5px 0 0;
  color: #292723;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.qa-result-toolbar__copy p {
  margin: 6px 0 0;
  color: #7a817d;
  font-size: 12px;
  font-weight: 600;
}

.qa-result-toolbar__filters {
  display: grid;
  grid-template-columns: minmax(230px, 1.4fr) minmax(150px, 0.9fr) minmax(135px, 0.8fr);
  gap: 8px;
  width: min(680px, 62%);
}

.qa-result-search,
.qa-result-filter {
  position: relative;
  min-width: 0;
}

.qa-result-search > i {
  position: absolute;
  top: 50%;
  left: 12px;
  z-index: 1;
  color: #8b9690;
  font-size: 12px;
  transform: translateY(-50%);
  pointer-events: none;
}

.qa-result-search input,
.qa-result-filter select {
  width: 100%;
  height: 39px;
  border: 1px solid #d6ded9;
  border-radius: 10px;
  outline: 0;
  background: #fff;
  color: #3c4541;
  font-size: 12px;
  font-weight: 700;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.qa-result-search input {
  padding: 0 12px 0 33px;
}

.qa-result-filter select {
  padding: 14px 30px 0 11px;
}

.qa-result-search input:focus,
.qa-result-filter select:focus {
  border-color: #5c8c83;
  box-shadow: 0 0 0 3px rgba(72, 126, 116, 0.11);
}

.qa-result-filter > span {
  position: absolute;
  top: 5px;
  left: 11px;
  z-index: 1;
  color: #929a96;
  font-size: 12px;
  font-weight: 700;
  pointer-events: none;
}

.qa-result-selection-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 24px;
  border-bottom: 1px solid #e2e8e4;
  background: #f4f8f6;
}

.qa-result-selection-toolbar__summary {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.qa-result-selection-toolbar__summary > span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #355c52;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-selection-toolbar__summary > span i {
  color: #3d776b;
}

.qa-result-selection-toolbar__summary small {
  color: #76827c;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-selection-toolbar__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 7px;
}

.qa-result-selection-toolbar__actions button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid #cfdad5;
  background: #fff;
  color: #52625b;
  cursor: pointer;
  transition: border-color 150ms ease, color 150ms ease, background 150ms ease;
}

.qa-result-selection-toolbar__actions button:hover:not(:disabled) {
  border-color: #8fb3a8;
  color: #285f55;
  background: #fff;
}

.qa-result-selection-toolbar__actions .is-regenerate {
  border-color: #96b8b0;
  color: #306c61;
  background: #edf6f3;
}

.qa-result-selection-toolbar__actions .is-delete {
  border-color: #e2c2ba;
  color: #a04e3d;
  background: #fff8f6;
}

.qa-result-selection-toolbar__actions .is-clear {
  border-color: transparent;
  color: #748078;
  background: transparent;
}

.qa-result-selection-toolbar__actions button:disabled {
  border-color: #e1e5e2;
  color: #aeb5b1;
  background: #f6f7f6;
  cursor: wait;
}

.qa-result-card.is-selected {
  border-color: #77a69a;
  box-shadow: 0 0 0 2px rgba(75, 128, 117, 0.12), 0 7px 19px rgba(47, 66, 58, 0.06);
}

.qa-result-card.is-selected .qa-result-card__header {
  background: #f4faf7;
}

.qa-result-card__select {
  display: inline-grid;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  place-items: center;
  cursor: pointer;
}

.qa-result-card__select input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.qa-result-card__select span {
  display: grid;
  width: 17px;
  height: 17px;
  place-items: center;
  border: 1px solid #b7c8c1;
  border-radius: 5px;
  background: #fff;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.qa-result-card__select span::after {
  color: #fff;
  content: "✓";
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  opacity: 0;
  transform: scale(0.7);
  transition: opacity 150ms ease, transform 150ms ease;
}

.qa-result-card__select input:checked + span {
  border-color: #397a6c;
  background: #397a6c;
}

.qa-result-card__select input:checked + span::after {
  opacity: 1;
  transform: scale(1);
}

.qa-result-card__select input:focus-visible + span {
  box-shadow: 0 0 0 3px rgba(72, 126, 116, 0.2);
}

.qa-result-card__select input:disabled + span {
  border-color: #dfe4e1;
  background: #f3f5f4;
  cursor: wait;
}

.qa-result-generation-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 18px;
  padding: 12px 24px;
  border-bottom: 1px solid #edf0ee;
  background: #f7faf8;
}

.qa-result-generation-meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: #66726d;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-generation-meta i {
  color: #4d796f;
}

.qa-result-list {
  display: grid;
  gap: 13px;
  margin: 0;
  padding: 18px 20px 22px;
  list-style: none;
  background: #f4f7f5;
}

.qa-result-pagination {
  display: flex;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 20px;
  border-top: 1px solid #e1e7e3;
  background: #fff;
}

.qa-result-pagination p {
  margin: 0;
  color: #7b8580;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-pagination p strong {
  color: #365e52;
  font-weight: 700;
}

.qa-result-pagination nav {
  display: flex;
  align-items: center;
  gap: 6px;
}

.qa-result-pagination button {
  display: inline-grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 1px solid #dbe2de;
  color: #63706a;
  background: #fff;
  cursor: pointer;
  transition: border-color 150ms ease, color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.qa-result-pagination button:hover:not(:disabled):not(.is-active) {
  border-color: #9bb5ac;
  color: #2f675b;
  background: #f4f8f6;
}

.qa-result-pagination button.is-active {
  border-color: #356d65;
  color: #fff;
  background: #356d65;
  box-shadow: 0 5px 12px rgba(53, 109, 101, 0.18);
}

.qa-result-pagination button:disabled {
  color: #bdc5c0;
  background: #f7f8f7;
  cursor: not-allowed;
}

.qa-result-pagination button:focus-visible {
  outline: 3px solid rgba(72, 126, 116, 0.18);
  outline-offset: 2px;
}

.qa-result-card {
  overflow: hidden;
  border: 1px solid #dce4e0;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 5px 16px rgba(47, 66, 58, 0.035);
}

.qa-result-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 13px 16px;
  border-bottom: 1px solid #edf0ee;
  background: #fbfcfb;
}

.qa-result-card__identity,
.qa-result-card__badges {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.qa-result-card__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 11px;
  min-width: 0;
}

.qa-result-card__badges {
  justify-content: flex-end;
  flex-wrap: wrap;
}

.qa-result-meta-badge {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  color: #64716b;
  background: #f6f8f6;
  border: 1px solid #dfe5e1;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.qa-result-meta-badge b {
  color: #3e5149;
  font-size: inherit;
  font-weight: 700;
}

.qa-result-meta-badge.is-era {
  color: #557168;
  background: #f1f6f3;
  border-color: #d8e5de;
}

.qa-result-meta-badge.is-topic {
  color: #5f6c78;
  background: #f3f6f8;
  border-color: #dce3e8;
}

.qa-result-meta-badge.is-difficulty {
  color: #816f43;
  background: #faf7ed;
  border-color: #e7ddc2;
}

.qa-result-meta-badge.is-style {
  color: #6f6253;
  background: #f8f4ef;
  border-color: #e6ddd3;
  font-weight: 700;
}

.qa-result-card__delete {
  display: inline-flex;
  min-width: 66px;
  min-height: 32px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid #e2c4bc;
  background: #fff;
  color: #a14f3f;
  cursor: pointer;
  transition: border-color 150ms ease, color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.qa-result-card__delete:hover:not(:disabled) {
  border-color: #c87967;
  background: #fff3ef;
  color: #8a3c2e;
}

.qa-result-card__delete:focus-visible {
  outline: 3px solid rgba(184, 81, 62, 0.18);
  outline-offset: 2px;
}

.qa-result-card__delete:disabled {
  border-color: #e1e5e2;
  background: #f6f7f6;
  color: #aeb5b1;
  cursor: wait;
}

.qa-result-card__number {
  display: grid;
  place-items: center;
  width: 29px;
  height: 29px;
  flex: 0 0 29px;
  border-radius: 9px;
  background: #356d65;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-card__identity > div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  min-width: 0;
}

.qa-result-card__identity strong {
  color: #515b56;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-card__identity > div > span {
  padding: 4px 7px;
  border: 1px solid #dce6e1;
  border-radius: 999px;
  background: #f0f6f3;
  color: #4c7169;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-confidence,
.qa-result-review-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.qa-result-confidence {
  background: #edf5f2;
  color: #3d7067;
}

.qa-result-review-status {
  border: 1px solid #d9ddd8;
  background: #f7f7f5;
  color: #717772;
}

.qa-result-review-status.is-pending {
  border-color: #ded4b7;
  background: #faf7ea;
  color: #846f36;
}

.qa-result-review-status.is-approved {
  border-color: #bfd7b5;
  background: #eef7eb;
  color: #52733d;
}

.qa-result-review-status.is-rejected {
  border-color: #e4c1b8;
  background: #fff3ef;
  color: #984f3e;
}

.qa-result-card__content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0;
}

.qa-result-question,
.qa-result-answer {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 12px;
  min-width: 0;
  padding: 18px;
}

.qa-result-question {
  border-right: 1px solid #e7ece9;
}

.qa-result-question > span,
.qa-result-answer > span {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-question > span {
  background: #eaf3f0;
  color: #356d65;
}

.qa-result-answer > span {
  background: #f6eee6;
  color: #a45d33;
}

.qa-result-question small,
.qa-result-answer small {
  display: block;
  margin-bottom: 5px;
  color: #959b97;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-question h4,
.qa-result-answer p {
  margin: 0;
  color: #292d2a;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.65;
  word-break: keep-all;
}

.qa-result-answer p {
  color: #473d35;
}

.qa-result-card__review-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 2.3fr);
  gap: 1px;
  border-top: 1px solid #e7ece9;
  background: #e7ece9;
}

.qa-result-card__review-grid section {
  min-width: 0;
  padding: 13px 18px;
  background: #fffdf9;
}

.qa-result-card__review-grid small,
.qa-result-card__review-grid strong,
.qa-result-card__review-grid p {
  display: block;
}

.qa-result-card__review-grid small {
  margin-bottom: 5px;
  color: #8a918d;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-card__review-grid strong,
.qa-result-card__review-grid p {
  margin: 0;
  color: #4b514e;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.65;
}

.qa-result-card__review-grid .is-review-point {
  border-left: 3px solid #c79a63;
  background: #fffaf2;
}

.qa-result-card__review-grid .is-review-point p {
  color: #624d39;
}

.qa-result-citation {
  margin: 0;
  padding: 15px 18px 17px;
  border-top: 1px solid #e7ece9;
  background: #fafbf9;
}

.qa-result-entities {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
}

.qa-result-entities > span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border: 1px solid #dce5e0;
  border-radius: 7px;
  background: #fff;
  color: #52615a;
  font-size: 12px;
}

.qa-result-entities b,
.qa-result-entities em,
.qa-result-entities small {
  font-size: inherit;
  font-style: normal;
}

.qa-result-entities em {
  color: #735b45;
}

.qa-result-entities small {
  color: #728178;
}

.qa-result-citation figcaption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.qa-result-citation figcaption > span {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 7px;
  color: #4a625b;
  font-size: 12px;
}

.qa-result-citation figcaption strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qa-result-citation figcaption em {
  color: #7e8782;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.qa-result-citation__evidence {
  display: grid;
  margin: 10px 0 0;
  overflow: hidden;
  border: 1px solid #dce6e1;
  border-radius: 8px;
  background: #fff;
}

.qa-result-citation__evidence > section {
  min-width: 0;
  padding: 11px 13px;
}

.qa-result-citation__evidence > section + section {
  border-top: 1px solid #dce6e1;
}

.qa-result-citation__original {
  border-left: 3px solid #7fa49b;
  background: #f2f7f4;
}

.qa-result-citation__original > div strong,
.qa-result-citation__translation strong,
.qa-result-citation__commentary > div strong {
  display: block;
  margin-bottom: 6px;
  color: #42685e;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-citation__original > div,
.qa-result-citation__commentary > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.qa-result-citation__original small,
.qa-result-citation__commentary small {
  color: #73867e;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-citation__original blockquote,
.qa-result-citation__translation p,
.qa-result-citation__commentary p {
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #4e5a55;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.65;
  word-break: break-word;
}

.qa-result-citation__original blockquote,
.qa-source-modal__original blockquote {
  font-family: "ReviewOps YetHangul", Pretendard, "NanumBarunGothic YetHangul", sans-serif !important;
  font-weight: 400;
}

.qa-result-citation__translation {
  border-left: 3px solid #c4975f;
  background: #fffaf2;
}

.qa-result-citation__translation > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.qa-result-citation__translation small {
  color: #9a8163;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-citation__translation p {
  color: #594a3d;
}

.qa-result-citation__commentary {
  border-left: 3px solid #aeb7b2;
  background: #f7f8f7;
}

.qa-result-citation__commentary > div strong {
  margin-bottom: 6px;
}

.qa-result-citation footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 13px;
  margin-top: 9px;
  color: #929894;
  font-size: 12px;
  font-weight: 700;
}

.qa-result-citation footer span {
  overflow-wrap: anywhere;
}

.qa-result-empty {
  display: grid;
  justify-items: center;
  gap: 7px;
  min-height: 260px;
  place-content: center;
  background: #f5f7f6;
  color: #7d8883;
  text-align: center;
}

.qa-result-empty i {
  margin-bottom: 4px;
  color: #6f948b;
  font-size: 25px;
}

.qa-result-empty strong {
  color: #4b5752;
  font-size: 12px;
}

.qa-result-empty p {
  margin: 0;
  font-size: 12px;
}

@media (max-width: 1180px) {
  .qa-result-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .qa-result-toolbar__filters {
    width: 100%;
  }
}
@media (max-width: 800px) {
  .qa-result-toolbar__filters {
    grid-template-columns: 1fr 1fr;
  }
  .qa-result-search {
    grid-column: 1/-1;
  }
  .qa-result-selection-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .qa-result-selection-toolbar__actions {
    justify-content: flex-start;
  }
  .qa-result-card__header,
  .qa-result-citation figcaption {
    align-items: flex-start;
    flex-direction: column;
  }
  .qa-result-card__content {
    grid-template-columns: 1fr;
  }
  .qa-result-card__review-grid {
    grid-template-columns: 1fr 1fr;
  }
  .qa-result-card__review-grid .is-review-point {
    grid-column: 1/-1;
    border-left: 0;
    border-top: 3px solid #c79a63;
  }
  .qa-result-card__actions {
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
  }
  .qa-result-card__badges {
    justify-content: flex-start;
  }
  .qa-result-question {
    border-right: 0;
    border-bottom: 1px solid #e7ece9;
  }
}
@media (max-width: 640px) {
  .qa-result-toolbar {
    padding: 18px 16px 15px;
  }
  .qa-result-toolbar__filters {
    grid-template-columns: 1fr;
  }
  .qa-result-search {
    grid-column: auto;
  }
  .qa-result-generation-meta {
    align-items: flex-start;
    flex-direction: column;
    padding: 12px 16px;
  }
  .qa-result-selection-toolbar {
    padding: 12px 16px;
  }
  .qa-result-selection-toolbar__actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .qa-result-selection-toolbar__actions .is-clear {
    grid-column: 1/-1;
  }
  .qa-result-list {
    padding: 12px;
  }
  .qa-result-pagination {
    align-items: flex-start;
    flex-direction: column;
    padding: 14px 16px;
  }
  .qa-result-pagination nav {
    width: 100%;
    overflow-x: auto;
    padding-bottom: 2px;
  }
  .qa-result-card__header,
  .qa-result-question,
  .qa-result-answer,
  .qa-result-citation {
    padding-right: 14px;
    padding-left: 14px;
  }
  .qa-result-card__review-grid {
    grid-template-columns: 1fr;
  }
  .qa-result-card__review-grid .is-review-point {
    grid-column: auto;
  }
  .qa-result-card__badges {
    flex-wrap: wrap;
  }
  .qa-result-card__actions {
    align-items: stretch;
    flex-direction: column;
  }
  .qa-result-card__delete {
    width: 100%;
  }
}
/* Keep the selected split layout authoritative over legacy hub rules below. */
.project-output-settings__grid.project-output-settings__grid--split {
  max-width: none;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 226px minmax(0, 1fr);
  gap: 0;
}

.project-output-settings__grid.project-output-settings__grid--split.is-single {
  max-width: none;
  grid-template-columns: minmax(0, 1fr) 240px;
}

.project-output-settings__grid--split .project-output-card__checklist li.is-complete .project-output-card__item-value,
.project-output-settings__grid--split .project-output-card.is-kg .project-output-card__checklist li.is-complete .project-output-card__item-value {
  color: #353a41;
  background: #f5f6f7;
}

@media (max-width: 1180px) {
  .project-output-settings__grid.project-output-settings__grid--split,
  .project-output-settings__grid.project-output-settings__grid--split.is-single {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .project-output-settings__grid.project-output-settings__grid--split,
  .project-output-settings__grid.project-output-settings__grid--split.is-single {
    display: flex;
    flex-direction: column;
    max-width: none;
  }
}
/* Knowledge graph result — selected analytical canvas concept */
.kg-result-page:not(.qa-result-page) {
  display: grid;
  gap: 0;
  color: #22282d;
  background: #fff;
}

.kg-result-page:not(.qa-result-page) .kg-result-header {
  min-height: 82px;
  display: flex;
  align-items: center;
  padding: 16px 18px;
  background: #fff;
  border: 0;
  border-bottom: 1px solid #dfe4e7;
  border-radius: 0;
  box-shadow: none;
}

.kg-result-page:not(.qa-result-page) .kg-result-title-row {
  gap: 12px;
}

.kg-result-page:not(.qa-result-page) .kg-result-title-row h2 {
  font-size: 21px;
  letter-spacing: -0.035em;
}

.kg-result-page:not(.qa-result-page) .kg-result-status {
  min-height: 23px;
  padding: 0 8px;
  color: #397146;
  background: #edf5e9;
  border-radius: 3px;
  font-size: 12px;
}

.kg-result-page:not(.qa-result-page) .kg-result-header__copy > p {
  margin-top: 7px;
  font-size: 12px;
}

.kg-result-page:not(.qa-result-page) .kg-result-header__actions {
  gap: 9px;
}

.kg-result-page:not(.qa-result-page) .result-kind-switch {
  border-radius: 4px;
  background: #f1f4f2;
}

.kg-result-page:not(.qa-result-page) .result-kind-switch a {
  min-height: 29px;
  border-radius: 2px;
}

.kg-result-page:not(.qa-result-page) .kg-result-button {
  min-height: 35px;
  padding: 0 14px;
}

.kg-result-page:not(.qa-result-page) .kg-result-button.is-primary {
  background: #285f46;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary {
  min-height: 105px;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0;
  padding: 0 18px;
  background: #fff;
  border: 0;
  border-bottom: 1px solid #dfe4e7;
  border-radius: 0;
  box-shadow: none;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary article {
  min-height: 104px;
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  padding: 15px 18px;
  border: 0;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary article + article {
  border-left: 1px solid #e1e5e8;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary article > span {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  font-size: 16px;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary small {
  font-size: 12px;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary strong {
  margin-top: 3px;
  font-size: 19px;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary strong.is-text {
  font-size: 14px;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary p {
  margin-top: 4px;
  font-size: 12px;
}

.kg-result-page:not(.qa-result-page) .kg-result-workspace {
  overflow: visible;
  background: #fff;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.kg-result-page:not(.qa-result-page) .kg-result-toolbar {
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 14px;
  background: #fff;
  border-bottom: 1px solid #dfe4e7;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 0;
  overflow-x: auto;
  background: transparent;
  border: 0;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button {
  min-height: 29px;
  padding: 0 10px;
  color: #4c555d;
  background: #fff;
  border: 1px solid #d8dde1;
  white-space: nowrap;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button em {
  min-width: 16px;
  height: 16px;
  background: #f1f3f4;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-active {
  color: #fff;
  background: #1e6048;
  border-color: #1e6048;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-active em {
  color: #1e6048;
  background: #dce9e3;
}

.kg-result-page:not(.qa-result-page) .kg-result-toolbar__controls {
  flex: 0 0 auto;
  gap: 8px;
}

.kg-result-page:not(.qa-result-page) .kg-result-search {
  width: 205px;
  min-height: 33px;
  border-radius: 3px;
}

.kg-result-page:not(.qa-result-page) .kg-result-search input {
  font-size: 12px;
}

.kg-result-page:not(.qa-result-page) .kg-result-zoom {
  gap: 4px;
  border: 0;
}

.kg-result-page:not(.qa-result-page) .kg-result-zoom button,
.kg-result-page:not(.qa-result-page) .kg-result-zoom button:last-child {
  width: 31px;
  height: 31px;
  border: 1px solid #d8dde1;
}

.kg-result-page:not(.qa-result-page) .kg-result-workspace__body {
  min-height: 560px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  align-items: stretch;
}

.kg-result-page:not(.qa-result-page) .kg-result-graph-panel {
  min-height: 560px;
  background: #fff;
  border: 0;
  border-right: 1px solid #dfe4e7;
}

.kg-result-page:not(.qa-result-page) .kg-result-canvas {
  min-height: 560px;
  height: 560px;
  background: #fff;
}

.kg-result-page:not(.qa-result-page) .kg-result-graph-hint {
  right: auto;
  bottom: 12px;
  left: 12px;
  padding: 6px 9px;
  color: #52605b;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #dce2df;
  border-radius: 3px;
  box-shadow: none;
  font-size: 12px;
}

.kg-result-page:not(.qa-result-page) .kg-result-inspector {
  max-height: 718px;
  padding: 0;
  overflow-y: auto;
  background: #fff;
  border: 0;
}

.kg-result-inspector__title {
  margin: 0;
  padding: 15px 14px 9px;
  color: #22282d;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-selected-card {
  margin: 0 14px 10px;
  padding: 13px;
  background: #f3f7ef;
  border: 1px solid #d4dfcc;
  border-radius: 3px;
}

.kg-result-selected-card > span {
  display: inline-flex;
  min-height: 19px;
  align-items: center;
  padding: 0 7px;
  color: #356643;
  background: #e0ecda;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-selected-card h4 {
  margin: 8px 0 10px;
  color: #27492f;
  font-size: 12px;
  line-height: 1.55;
}

.kg-result-selected-card dl {
  display: grid;
  gap: 6px;
  margin: 0;
}

.kg-result-selected-card dl > div {
  display: grid;
  grid-template-columns: 64px minmax(0, 1fr);
  gap: 8px;
}

.kg-result-selected-card dt,
.kg-result-selected-card dd {
  margin: 0;
  font-size: 12px;
}

.kg-result-selected-card dt {
  color: #7b847e;
}

.kg-result-selected-card dd {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #3e4742;
  font-weight: 700;
}

.kg-result-selected-card dd strong {
  margin-right: 8px;
}

.kg-result-confidence {
  width: 100%;
  height: 4px;
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
  background: #d7dfd2;
  border-radius: 999px;
}

.kg-result-confidence i {
  height: 100%;
  display: block;
  background: #5a883e;
}

.kg-result-selected-card blockquote {
  margin: 10px 0 0;
  padding-top: 10px;
  color: #52605a;
  border-top: 1px solid #d4dfcc;
  font-size: 12px;
  line-height: 1.55;
}

.kg-result-inspector-section {
  padding: 12px 14px;
  border-top: 1px solid #e1e5e8;
}

.kg-result-inspector-section > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.kg-result-inspector-section h4,
.kg-result-inspector-section h5 {
  margin: 0;
  color: #29302f;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-inspector-section h5 {
  margin-top: 12px;
  font-size: 12px;
}

.kg-result-inspector-section header > span {
  min-width: 19px;
  height: 19px;
  display: grid;
  place-items: center;
  color: #5a6360;
  background: #eef0f0;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-compact-connections {
  display: grid;
  gap: 0;
  max-height: 165px;
  margin: 8px 0 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.kg-result-compact-connections button {
  width: 100%;
  display: grid;
  grid-template-columns: minmax(60px, 0.7fr) minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  padding: 7px 0;
  color: #4a5450;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #edf0f1;
  text-align: left;
}

.kg-result-compact-connections span,
.kg-result-compact-connections strong,
.kg-result-compact-connections em {
  overflow: hidden;
  font-size: 12px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-result-compact-connections strong {
  color: #2d3532;
}

.kg-result-compact-connections em {
  color: #8a918e;
}

.kg-result-distribution {
  display: grid;
  gap: 6px;
  margin-top: 8px;
}

.kg-result-distribution > div {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr) 66px;
  align-items: center;
  gap: 7px;
}

.kg-result-distribution span,
.kg-result-distribution strong {
  font-size: 12px;
}

.kg-result-distribution strong {
  text-align: right;
}

.kg-result-distribution i {
  height: 5px;
  display: block;
  overflow: hidden;
  background: #eceeed;
  border-radius: 999px;
}

.kg-result-distribution i b {
  height: 100%;
  display: block;
  background: #5b8a48;
  border-radius: inherit;
}

.kg-result-distribution.is-edges i b {
  background: #4a7a40;
}

.kg-result-inspector-section.is-completeness > div {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 12px;
}

.kg-result-completeness-track {
  height: 5px;
  display: block;
  margin-top: 8px;
  overflow: hidden;
  background: #e7ebe8;
  border-radius: 999px;
}

.kg-result-completeness-track b {
  height: 100%;
  display: block;
  background: #548244;
}

.kg-result-lower-ledger {
  width: calc(100% - 330px);
  background: #fff;
  border-top: 1px solid #dfe4e7;
  border-right: 1px solid #dfe4e7;
}

.kg-result-lower-ledger > nav {
  min-height: 43px;
  display: flex;
  border-bottom: 1px solid #dfe4e7;
}

.kg-result-lower-ledger > nav button {
  min-width: 180px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #68716e;
  background: #fff;
  border: 0;
  border-bottom: 3px solid transparent;
}

.kg-result-lower-ledger > nav button.is-active {
  color: #1f654e;
  border-bottom-color: #1f654e;
}

.kg-result-lower-ledger > nav em {
  min-width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  color: #56605c;
  background: #eef0ef;
  border-radius: 999px;
  font-size: 12px;
  font-style: normal;
}

.kg-result-source-ledger > header,
.kg-result-source-ledger > button {
  display: grid;
  grid-template-columns: 110px minmax(180px, 1.4fr) minmax(120px, 1fr) 110px 130px 44px;
  align-items: center;
  gap: 10px;
  min-height: 39px;
  padding: 0 14px;
}

.kg-result-source-ledger > header {
  color: #5f6865;
  background: #f8f9f9;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-source-ledger > button {
  width: 100%;
  color: #4d5652;
  background: #fff;
  border: 0;
  border-top: 1px solid #edf0f1;
  text-align: left;
}

.kg-result-source-ledger > button:hover {
  background: #f7faf8;
}

.kg-result-source-ledger > button span,
.kg-result-source-ledger > button strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kg-result-source-ledger > button i {
  justify-self: center;
  color: #1f654e;
}

.kg-result-warning-ledger {
  padding: 12px;
}

.kg-result-warning-ledger article {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  gap: 10px;
  padding: 10px;
  background: #fff8ed;
  border: 1px solid #f0d5aa;
}

.kg-result-warning-ledger article + article {
  margin-top: 8px;
}

.kg-result-warning-ledger p,
.kg-result-warning-ledger small {
  margin: 3px 0 0;
  font-size: 12px;
}

@media (max-width: 1180px) {
  .kg-result-page:not(.qa-result-page) .kg-result-summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .kg-result-page:not(.qa-result-page) .kg-result-workspace__body {
    grid-template-columns: minmax(0, 1fr) 290px;
  }
  .kg-result-lower-ledger {
    width: calc(100% - 290px);
  }
}
@media (max-width: 900px) {
  .kg-result-page:not(.qa-result-page) .kg-result-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-toolbar__controls,
  .kg-result-page:not(.qa-result-page) .kg-result-search {
    width: 100%;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-workspace__body {
    grid-template-columns: minmax(0, 1fr);
  }
  .kg-result-page:not(.qa-result-page) .kg-result-inspector {
    max-height: none;
    border-top: 1px solid #dfe4e7;
  }
  .kg-result-lower-ledger {
    width: 100%;
    border-right: 0;
  }
}
@media (max-width: 680px) {
  .kg-result-page:not(.qa-result-page) .kg-result-summary {
    grid-template-columns: 1fr 1fr;
    padding: 0;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-summary article {
    padding: 12px;
  }
  .kg-result-source-ledger {
    overflow-x: auto;
  }
  .kg-result-source-ledger > header,
  .kg-result-source-ledger > button {
    min-width: 760px;
  }
}
/* Knowledge graph result v3 — full clustered analysis workspace */
.kg-result-page:not(.qa-result-page) {
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  background: #f7f8f8;
}

.kg-result-page:not(.qa-result-page) .kg-result-header {
  min-height: 76px;
  padding: 14px 22px;
  border: 0;
  box-shadow: inset 0 -1px #dde3e0;
}

.kg-result-page:not(.qa-result-page) .kg-result-title-row h2 {
  font-size: 24px;
}

.kg-result-page:not(.qa-result-page) .kg-result-header__copy > p,
.kg-result-page:not(.qa-result-page) .kg-result-button {
  font-size: 12px;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary {
  min-height: 88px;
  padding: 0 20px;
  border: 0;
  box-shadow: inset 0 -1px #dfe4e1;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary article {
  min-height: 88px;
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 11px;
  padding: 12px 18px;
  border: 0;
  box-shadow: inset -1px 0 #e2e6e4;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary article:last-child {
  box-shadow: none;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary article > span {
  width: 40px;
  height: 40px;
  border-radius: 10px;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary small,
.kg-result-page:not(.qa-result-page) .kg-result-summary p {
  font-size: 12px;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary strong {
  font-size: 20px;
}

.kg-result-page:not(.qa-result-page) .kg-result-workspace {
  display: grid;
  grid-template-columns: 208px minmax(0, 1fr);
  align-items: stretch;
  overflow: hidden;
  background: #fff;
}

.kg-result-filter-rail {
  min-width: 0;
  padding: 20px 16px;
  background: #fbfcfc;
  box-shadow: inset -1px 0 #dfe4e1;
}

.kg-result-filter-rail > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 14px;
}

.kg-result-filter-rail h3,
.kg-result-filter-rail h4 {
  margin: 0;
  color: #242b29;
  font-size: 12px;
  font-weight: 700;
}

.kg-result-filter-rail > header button {
  padding: 4px 6px;
  color: #6c7772;
  background: transparent;
  border: 0;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters {
  display: grid;
  gap: 3px;
  overflow: visible;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button {
  position: relative;
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 0 28px;
  color: #4c5752;
  background: transparent;
  border: 0;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button::before,
.kg-result-filter-legend li::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: #a7b5ae;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button::before {
  position: absolute;
  left: 9px;
  top: 50%;
  transform: translateY(-50%);
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-source::before,
.kg-result-filter-legend li.is-source::before {
  background: #8fb4d3;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-claim::before {
  background: #ef7d32;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-entity::before,
.kg-result-filter-legend li.is-entity::before {
  background: #a996c7;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-event::before,
.kg-result-filter-legend li.is-event::before {
  background: #d3a36e;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-time::before,
.kg-result-filter-legend li.is-time::before {
  background: #7eaaa3;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-concept::before,
.kg-result-filter-legend li.is-concept::before {
  background: #8eaf78;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-evidence::before {
  background: #7c9c6d;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button em {
  min-width: 24px;
  height: 20px;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-active {
  color: #fff;
  background: #245e4c;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button.is-active::before {
  background: #fff;
}

.kg-result-filter-legend,
.kg-result-filter-tips {
  margin-top: 22px;
  padding-top: 18px;
  box-shadow: inset 0 1px #e3e7e5;
}

.kg-result-filter-legend ul {
  display: grid;
  gap: 9px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.kg-result-filter-legend li {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #68726d;
  font-size: 12px;
}

.kg-result-filter-tips p {
  margin: 10px 0 0;
  color: #727b77;
  font-size: 12px;
  line-height: 1.55;
}

.kg-result-analysis {
  min-width: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
}

.kg-result-page:not(.qa-result-page) .kg-result-toolbar {
  min-height: 54px;
  justify-content: flex-end;
  padding: 9px 14px;
  border: 0;
  box-shadow: inset 0 -1px #dfe4e1;
}

.kg-result-page:not(.qa-result-page) .kg-result-search {
  width: min(390px, 42vw);
  min-height: 36px;
  margin-right: auto;
  border: 0;
  box-shadow: inset 0 0 0 1px #d7dedb;
}

.kg-result-page:not(.qa-result-page) .kg-result-search input {
  font-size: 12px;
}

.kg-result-view-toggle {
  display: inline-flex;
  min-height: 34px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px #d7dedb;
}

.kg-result-view-toggle button {
  min-width: 96px;
  padding: 0 12px;
  color: #59635e;
  background: #fff;
  border: 0;
}

.kg-result-view-toggle button.is-active {
  color: #fff;
  background: #245e4c;
}

.kg-result-view-toggle button:disabled {
  opacity: 0.42;
}

.kg-result-page:not(.qa-result-page) .kg-result-workspace__body {
  min-height: 690px;
  height: calc(100vh - 300px);
  max-height: 820px;
  grid-template-columns: minmax(0, 1fr) 310px;
}

.kg-result-page:not(.qa-result-page) .kg-result-graph-panel,
.kg-result-page:not(.qa-result-page) .kg-result-canvas {
  min-height: 690px;
  height: 100%;
}

.kg-result-page:not(.qa-result-page) .kg-result-graph-panel {
  border: 0;
  box-shadow: inset -1px 0 #dfe4e1;
  background: radial-gradient(circle at 24% 24%, rgba(143, 180, 211, 0.08), transparent 22%), radial-gradient(circle at 78% 22%, rgba(142, 175, 120, 0.08), transparent 22%), radial-gradient(circle at 74% 70%, rgba(211, 163, 110, 0.07), transparent 24%), #fff;
}

.kg-result-page:not(.qa-result-page) .kg-result-inspector {
  max-height: none;
  height: 100%;
  background: #fff;
}

.kg-result-inspector__title {
  padding: 17px 16px 12px;
  font-size: 12px;
}

.kg-result-selected-card {
  margin: 0 14px 12px;
  padding: 15px;
}

.kg-result-selected-card h4 {
  font-size: 12px;
}

.kg-result-selected-card dt,
.kg-result-selected-card dd,
.kg-result-selected-card blockquote,
.kg-result-inspector-section h4,
.kg-result-inspector-section h5 {
  font-size: 12px;
}

.kg-result-lower-ledger {
  width: 100%;
  border: 0;
  box-shadow: inset 0 1px #dfe4e1;
}

@media (max-width: 1180px) {
  .kg-result-page:not(.qa-result-page) .kg-result-workspace {
    grid-template-columns: 176px minmax(0, 1fr);
  }
  .kg-result-page:not(.qa-result-page) .kg-result-workspace__body {
    grid-template-columns: minmax(0, 1fr) 280px;
  }
}
@media (max-width: 900px) {
  .kg-result-page:not(.qa-result-page) .kg-result-workspace {
    grid-template-columns: 1fr;
  }
  .kg-result-filter-rail {
    padding: 12px;
    box-shadow: inset 0 -1px #dfe4e1;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-filters {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .kg-result-filter-legend,
  .kg-result-filter-tips {
    display: none;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-toolbar {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-search {
    width: 100%;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-workspace__body {
    height: auto;
    grid-template-columns: minmax(0, 1fr);
  }
  .kg-result-page:not(.qa-result-page) .kg-result-inspector {
    height: auto;
    max-height: 520px;
    box-shadow: inset 0 1px #dfe4e1;
  }
}
/* QA generation: use the full desktop canvas instead of anchoring a 1380px workspace to the left. */
@media (min-width: 1441px) {
  .review-project-header.is-qa-generation-header .review-project-header__inner,
  main.is-generation-main.is-qa-generation-main {
    width: 100%;
    max-width: none;
    margin-right: auto;
    margin-left: auto;
  }
  main.is-generation-main .project-output-workspace__layout.is-qa {
    grid-template-columns: minmax(0, 1fr) 420px;
  }
}
/* Knowledge graph result v4 — calm, progressive graph workspace */
.kg-result-page:not(.qa-result-page) {
  padding: 18px;
  background: #f6f7f3;
}

.kg-result-page:not(.qa-result-page) .kg-result-header,
.kg-result-page:not(.qa-result-page) .kg-result-summary,
.kg-result-page:not(.qa-result-page) .kg-result-filter-rail,
.kg-result-page:not(.qa-result-page) .kg-result-analysis,
.kg-result-page:not(.qa-result-page) .kg-result-lower-ledger {
  border: 0 !important;
  box-shadow: 0 1px 2px rgba(30, 42, 37, 0.07), 0 8px 26px rgba(30, 42, 37, 0.035) !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-header {
  min-height: 82px;
  padding: 16px 20px;
  border-radius: 10px !important;
  background: #fff;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary {
  min-height: 92px;
  gap: 8px;
  margin-top: 12px;
  padding: 8px;
  border-radius: 10px !important;
  background: #fff;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary article {
  min-height: 76px;
  padding: 12px 14px;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary article + article {
  border: 0 !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-summary article:hover {
  background: #f8faf9;
}

.kg-result-page:not(.qa-result-page) .kg-result-workspace {
  grid-template-columns: 206px minmax(0, 1fr);
  gap: 12px;
  margin-top: 12px;
  overflow: visible;
  background: transparent;
}

.kg-result-page:not(.qa-result-page) .kg-result-filter-rail {
  align-self: start;
  position: sticky;
  top: 14px;
  padding: 16px 14px;
  border-radius: 10px !important;
  background: #fff;
}

.kg-result-page:not(.qa-result-page) .kg-result-filter-rail > header {
  margin-bottom: 10px;
}

.kg-result-page:not(.qa-result-page) .kg-result-filter-rail > header button {
  min-height: 28px;
  padding: 0 9px;
  color: #596761;
  background: #f2f4f3;
  box-shadow: none !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters {
  gap: 4px;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button {
  min-height: 36px;
  padding: 0 9px 0 30px;
  border: 0 !important;
  box-shadow: none !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-filters button:not(.is-active):hover {
  background: #f2f5f3;
}

.kg-result-page:not(.qa-result-page) .kg-result-filter-legend,
.kg-result-page:not(.qa-result-page) .kg-result-filter-tips {
  margin-top: 16px;
  padding-top: 16px;
  box-shadow: 0 -1px #edf0ee !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-analysis {
  min-width: 0;
  overflow: hidden;
  border-radius: 10px !important;
  background: #fff;
}

.kg-result-page:not(.qa-result-page) .kg-result-toolbar {
  min-height: 58px;
  gap: 10px;
  padding: 10px 12px;
  box-shadow: 0 1px #edf0ee !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-search {
  width: min(420px, 42vw);
  min-height: 38px;
  overflow: hidden;
  border: 0 !important;
  border-radius: 7px !important;
  box-shadow: inset 0 0 0 1px #d8dfdb !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-search:focus-within {
  box-shadow: inset 0 0 0 2px #397563 !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-search input {
  box-shadow: none !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-view-toggle {
  min-height: 36px;
  padding: 3px;
  gap: 2px;
  border-radius: 7px !important;
  background: #eef1ef;
  box-shadow: none !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-view-toggle button {
  min-width: 92px;
  min-height: 30px;
  padding: 0 11px;
  box-shadow: none !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-view-toggle button.is-active {
  background: #286650;
  box-shadow: 0 1px 3px rgba(24, 68, 52, 0.16) !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-zoom {
  gap: 5px;
}

.kg-result-page:not(.qa-result-page) .kg-result-zoom button,
.kg-result-page:not(.qa-result-page) .kg-result-zoom button:last-child {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  padding: 0;
  color: #52605a;
  background: #fff;
  border: 0 !important;
  box-shadow: inset 0 0 0 1px #d8dfdb !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-zoom button:hover {
  color: #225e4a;
  background: #eef5f2;
}

.kg-result-page:not(.qa-result-page) .kg-result-workspace__body {
  min-height: 720px;
  height: calc(100vh - 326px);
  max-height: 900px;
  grid-template-columns: minmax(0, 1fr) minmax(310px, 340px);
  gap: 12px;
  padding: 12px;
  background: #f6f7f3;
}

.kg-result-page:not(.qa-result-page) .kg-result-graph-panel,
.kg-result-page:not(.qa-result-page) .kg-result-canvas {
  min-height: 696px;
}

.kg-result-page:not(.qa-result-page) .kg-result-graph-panel {
  overflow: hidden;
  border: 0 !important;
  border-radius: 8px !important;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(30, 42, 37, 0.06) !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-graph-hint {
  max-width: calc(100% - 28px);
  padding: 8px 10px;
  border: 0 !important;
  border-radius: 6px !important;
  background: rgba(247, 250, 248, 0.95);
  box-shadow: 0 2px 8px rgba(32, 48, 41, 0.08) !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-inspector {
  min-width: 0;
  height: 100%;
  max-height: none;
  overflow-x: hidden;
  overflow-y: auto;
  border: 0 !important;
  border-radius: 8px !important;
  background: #fff;
  box-shadow: 0 1px 2px rgba(30, 42, 37, 0.06) !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-inspector__title {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 15px 16px 10px;
  background: #fff;
}

.kg-result-page:not(.qa-result-page) .kg-result-selected-card {
  margin: 0 12px 10px;
  padding: 14px;
  border: 0 !important;
  border-radius: 7px !important;
  background: #f3f8f4;
  box-shadow: inset 0 0 0 1px #dbe7dd !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-inspector-section {
  margin: 0 12px 10px;
  padding: 13px 2px 3px;
  border: 0 !important;
  box-shadow: 0 -1px #edf0ee !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-compact-connections {
  gap: 4px;
  max-height: 190px;
}

.kg-result-page:not(.qa-result-page) .kg-result-compact-connections button {
  grid-template-columns: minmax(62px, 0.7fr) minmax(0, 1.2fr);
  gap: 8px;
  min-height: 38px;
  padding: 7px 8px;
  overflow: hidden;
  border: 0 !important;
  background: #f7f9f8;
  box-shadow: none !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-compact-connections button:hover {
  background: #edf4f0;
}

.kg-result-page:not(.qa-result-page) .kg-result-compact-connections em {
  display: none;
}

.kg-result-page:not(.qa-result-page) .kg-result-lower-ledger {
  width: calc(100% - 218px);
  margin: 12px 0 0 218px;
  overflow: hidden;
  border-radius: 10px !important;
  background: #fff;
}

.kg-result-page:not(.qa-result-page) .kg-result-lower-ledger > nav {
  min-height: 48px;
  gap: 4px;
  padding: 6px;
  border: 0 !important;
  box-shadow: 0 1px #edf0ee !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-lower-ledger > nav button {
  min-width: 160px;
  min-height: 36px;
  padding: 0 14px;
  border: 0 !important;
  background: transparent;
  box-shadow: none !important;
}

.kg-result-page:not(.qa-result-page) .kg-result-lower-ledger > nav button.is-active {
  color: #205f4b;
  background: #edf5f1;
}

@media (max-width: 1180px) {
  .kg-result-page:not(.qa-result-page) {
    padding: 12px;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-workspace {
    grid-template-columns: 184px minmax(0, 1fr);
  }
  .kg-result-page:not(.qa-result-page) .kg-result-workspace__body {
    grid-template-columns: minmax(0, 1fr) 290px;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-lower-ledger {
    width: calc(100% - 196px);
    margin-left: 196px;
  }
}
@media (max-width: 900px) {
  .kg-result-page:not(.qa-result-page) .kg-result-workspace {
    grid-template-columns: 1fr;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-filter-rail {
    position: static;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-workspace__body {
    height: auto;
    max-height: none;
    grid-template-columns: 1fr;
  }
  .kg-result-page:not(.qa-result-page) .kg-result-lower-ledger {
    width: 100%;
    margin-left: 0;
  }
}
/* Project settings — option 1: summary first, two configuration cards */
.project-settings-page-title h1 {
  margin: 0;
}

.project-settings-page-title > i {
  color: #aab2b9;
  font-size: 12px;
}

.project-settings-page-title strong {
  color: #4c5661;
  font-size: 13px;
  font-weight: 700;
}

.project-settings-page-title code {
  padding: 6px 9px;
  color: #465260;
  background: #f4f6f7;
  border: 1px solid #d8dee2;
  border-radius: 6px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
}

.project-settings-completion {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  color: #425d3c;
  font-size: 12px;
  font-weight: 700;
}

.project-settings-completion i {
  font-size: 17px;
}

.project-settings-completion strong {
  color: #28312b;
  font-size: 13px;
  font-weight: 700;
}

.project-output-settings:has(> .project-output-settings__grid--split) {
  min-height: 0;
}

.project-output-settings__grid.project-output-settings__grid--split,
.project-output-settings__grid.project-output-settings__grid--split.is-single {
  --settings-qa: #334f72;
  --settings-qa-dark: #293f5b;
  --settings-qa-soft: #eef3f8;
  --settings-kg: #3f6f5f;
  --settings-kg-dark: #31584b;
  --settings-kg-soft: #edf4f1;
  --settings-line: #dce2df;
  max-width: none;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: auto minmax(0, 1fr);
  gap: 16px;
  overflow: visible;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.project-output-settings__grid--split > .project-output-settings__summary,
.project-output-settings__grid--split.is-single > .project-output-settings__summary {
  grid-column: 1/-1;
  grid-row: 1;
  display: block;
  min-width: 0;
  padding: 0;
  background: #fff;
  border: 1px solid var(--settings-line);
  border-radius: 10px !important;
  box-shadow: 0 5px 18px rgba(32, 45, 39, 0.035);
}

.project-output-settings__grid--split .project-output-settings__summary-status {
  display: none;
}

.project-output-settings__grid--split .project-output-settings__summary-details {
  padding: 0;
  border: 0;
}

.project-output-settings__grid--split .project-output-settings__summary-details h3 {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.project-output-settings__grid--split .project-output-settings__summary-details dl {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0;
  margin: 0;
}

.project-output-settings__grid--split .project-output-settings__summary-details dl > div {
  min-width: 0;
  min-height: 92px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 16px 20px;
}

.project-output-settings__grid--split .project-output-settings__summary-details dl > div + div {
  border-left: 1px solid var(--settings-line);
}

.project-output-settings__grid--split .project-output-settings__summary-details dt {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #69737b;
  font-size: 12px;
  font-weight: 700;
}

.project-output-settings__grid--split .project-output-settings__summary-details dt i {
  width: 16px;
  color: #44505a;
  font-size: 12px;
  text-align: center;
}

.project-output-settings__grid--split .project-output-settings__summary-details dd {
  margin: 9px 0 0 24px;
  overflow: hidden;
  color: #252c32;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-output-settings__grid--split > .project-output-card,
.project-output-settings__grid--split > .project-output-card.is-kg,
.project-output-settings__grid--split.is-single > .project-output-card,
.project-output-settings__grid--split.is-single > .project-output-card.is-kg {
  grid-row: 2;
  grid-column: auto;
  min-width: 0;
  min-height: 590px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--settings-line);
  border-top: 3px solid var(--settings-qa);
  border-radius: 10px !important;
  box-shadow: 0 7px 22px rgba(34, 49, 43, 0.045);
}

.project-output-settings__grid--split > .project-output-card.is-kg,
.project-output-settings__grid--split.is-single > .project-output-card.is-kg {
  border-top-color: var(--settings-kg);
}

.project-output-settings__grid--split.is-single > .project-output-card,
.project-output-settings__grid--split.is-single > .project-output-card.is-kg {
  grid-column: 1/-1;
}

.project-output-settings__grid--split > .project-output-card:hover,
.project-output-settings__grid--split > .project-output-card:focus-visible {
  transform: translateY(-1px);
  border-color: #b9c7d4;
  border-top-color: var(--settings-qa);
  box-shadow: 0 12px 30px rgba(43, 63, 82, 0.09);
}

.project-output-settings__grid--split > .project-output-card.is-kg:hover,
.project-output-settings__grid--split > .project-output-card.is-kg:focus-visible {
  border-color: #b9cbc4;
  border-top-color: var(--settings-kg);
  box-shadow: 0 12px 30px rgba(48, 86, 73, 0.09);
}

.project-output-settings__grid--split .project-output-card__header {
  min-height: 94px;
  padding: 20px 22px;
  background: #fff;
  border: 0;
  border-bottom: 1px solid var(--settings-line);
  border-radius: 0 !important;
}

.project-output-settings__grid--split .project-output-card__identity {
  align-items: center;
  gap: 14px;
}

.project-output-settings__grid--split .project-output-card__identity > div {
  padding-top: 0;
}

.project-output-settings__grid--split .project-output-card__code {
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  color: #fff;
  background: var(--settings-qa);
  border: 0;
  border-radius: 7px;
  box-shadow: 0 7px 16px rgba(51, 79, 114, 0.18);
  font-size: 16px;
}

.project-output-settings__grid--split .project-output-card__code.is-kg {
  background: var(--settings-kg);
  box-shadow: 0 7px 16px rgba(63, 111, 95, 0.18);
}

.project-output-settings__grid--split .project-output-card__identity strong {
  font-size: 18px;
}

.project-output-settings__grid--split .project-output-card__identity p {
  margin-top: 4px;
  color: #7a838a;
  font-size: 12px;
}

.project-output-settings__grid--split .project-output-card__header-actions {
  flex: 0 0 auto;
  gap: 9px;
}

.project-output-settings__grid--split .project-output-card__status {
  min-height: 30px;
  padding: 0 10px;
  color: #52634d;
  background: #f0f4ed;
  border: 0;
  border-radius: 999px;
  font-size: 12px;
}

.project-output-settings__grid--split .project-output-card__settings {
  min-height: 34px;
  padding: 0 12px;
  color: var(--settings-qa);
  background: #fff;
  border: 1px solid #9fb0c2;
  border-radius: 7px;
  box-shadow: none;
  font-size: 12px;
}

.project-output-settings__grid--split .project-output-card.is-kg .project-output-card__settings {
  color: var(--settings-kg);
  border-color: #a3bbb2;
}

.project-output-settings__grid--split .project-output-card__settings:hover {
  color: #fff;
  background: var(--settings-qa);
  border-color: var(--settings-qa);
}

.project-output-settings__grid--split .project-output-card.is-kg .project-output-card__settings:hover {
  background: var(--settings-kg);
  border-color: var(--settings-kg);
}

.project-output-settings__grid--split .project-output-card__body {
  flex: 1;
  padding: 0 16px 16px;
}

.project-output-settings__grid--split .project-output-card__section {
  padding: 16px 0 8px;
  border-top: 0;
}

.project-output-settings__grid--split .project-output-card__section + .project-output-card__section {
  padding-top: 18px;
}

.project-output-settings__grid--split .project-output-card__section--output {
  flex: 1;
}

.project-output-settings__grid--split .project-output-card__section-title,
.project-output-settings__grid--split .project-output-card.is-kg .project-output-card__section-title {
  margin: 0 0 7px 2px;
  color: var(--settings-qa);
  font-size: 12px;
}

.project-output-settings__grid--split .project-output-card.is-kg .project-output-card__section-title {
  color: var(--settings-kg);
}

.project-output-settings__grid--split .project-output-card__checklist {
  gap: 0;
}

.project-output-settings__grid--split .project-output-card__checklist li {
  grid-template-columns: 30px minmax(110px, 0.7fr) minmax(0, 1.3fr);
  min-height: 44px;
  padding: 3px 4px;
  border-bottom: 1px solid #e5e9e7;
}

.project-output-settings__grid--split .project-output-card__item-icon {
  width: 28px;
  height: 28px;
  color: #39434b;
  font-size: 12px;
}

.project-output-settings__grid--split .project-output-card.is-kg .project-output-card__item-icon {
  color: #394a44;
}

.project-output-settings__grid--split .project-output-card__item-label {
  color: #343d44;
  font-size: 12px;
}

.project-output-settings__grid--split .project-output-card__item-value,
.project-output-settings__grid--split .project-output-card__checklist li.is-complete .project-output-card__item-value,
.project-output-settings__grid--split .project-output-card.is-kg .project-output-card__checklist li.is-complete .project-output-card__item-value {
  padding: 0;
  color: #30383e;
  background: transparent;
  border: 0;
  font-size: 12px;
}

.project-output-settings__grid--split .project-output-card__actions {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid var(--settings-line);
}

.project-output-settings__grid--split .project-output-card__cta,
.project-output-settings__grid--split .project-output-card__cta.is-kg {
  min-height: 52px;
  color: #fff;
  background: var(--settings-qa);
  border-radius: 7px !important;
  box-shadow: none;
  font-size: 13px;
}

.project-output-settings__grid--split .project-output-card__cta.is-kg {
  background: var(--settings-kg);
}

.project-output-settings__grid--split .project-output-card__cta:hover {
  background: var(--settings-qa-dark);
}

.project-output-settings__grid--split .project-output-card__cta.is-kg:hover {
  background: var(--settings-kg-dark);
}

@media (max-width: 1180px) {
  .project-output-settings__grid--split .project-output-settings__summary-details dl {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .project-output-settings__grid--split .project-output-settings__summary-details dl > div:nth-child(4) {
    border-left: 0;
  }
  .project-output-settings__grid--split .project-output-settings__summary-details dl > div:nth-child(n+4) {
    border-top: 1px solid var(--settings-line);
  }
}
@media (max-width: 840px) {
  .project-output-settings__grid.project-output-settings__grid--split,
  .project-output-settings__grid.project-output-settings__grid--split.is-single {
    grid-template-columns: minmax(0, 1fr);
  }
  .project-output-settings__grid--split > .project-output-card,
  .project-output-settings__grid--split > .project-output-card.is-kg {
    grid-column: 1;
    grid-row: auto;
    min-height: 0;
  }
  .project-output-settings__grid--split > .project-output-settings__summary {
    grid-row: 1;
  }
}
@media (max-width: 620px) {
  .project-settings-page-title h1 {
    width: 100%;
  }
  .project-output-settings__grid--split .project-output-settings__summary-details dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .project-output-settings__grid--split .project-output-settings__summary-details dl > div,
  .project-output-settings__grid--split .project-output-settings__summary-details dl > div:nth-child(4) {
    border-top: 0;
    border-left: 0;
  }
  .project-output-settings__grid--split .project-output-settings__summary-details dl > div:nth-child(even) {
    border-left: 1px solid var(--settings-line);
  }
  .project-output-settings__grid--split .project-output-settings__summary-details dl > div:nth-child(n+3) {
    border-top: 1px solid var(--settings-line);
  }
  .project-output-settings__grid--split .project-output-card__header {
    align-items: flex-start;
    flex-direction: column;
  }
  .project-output-settings__grid--split .project-output-card__header-actions {
    width: 100%;
    justify-content: space-between;
  }
  .project-output-settings__grid--split .project-output-card__checklist li {
    grid-template-columns: 28px minmax(88px, 0.8fr) minmax(0, 1.2fr);
  }
}
/* Project settings — compact flat ledger, authoritative over legacy concepts. */
:host main:has(> .project-output-settings > .project-output-settings__grid--split),
:host .project-output-settings:has(> .project-output-settings__grid--split) {
  min-height: 0;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}

:host .project-output-settings:has(> .project-output-settings__grid--split) {
  padding: 8px 0 30px;
}

:host .project-output-settings__grid.project-output-settings__grid--split,
:host .project-output-settings__grid.project-output-settings__grid--split.is-single {
  --settings-qa: #3f5878;
  --settings-qa-dark: #31465f;
  --settings-qa-soft: #f3f6f9;
  --settings-kg: #477566;
  --settings-kg-dark: #365d50;
  --settings-kg-soft: #f2f7f4;
  --settings-line: #dfe4e2;
  width: min(100%, 1380px);
  max-width: 1380px;
  min-height: 0;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: auto auto;
  grid-template-areas: "summary summary" "qa kg";
  align-items: start;
  gap: 14px;
  overflow: visible;
  background: transparent;
  border: 0;
  border-radius: 0 !important;
  box-shadow: none;
}

:host .project-output-settings__grid--split > .project-output-settings__summary,
:host .project-output-settings__grid--split.is-single > .project-output-settings__summary {
  grid-area: summary;
  min-width: 0;
  min-height: 82px;
  display: grid;
  grid-template-columns: 210px minmax(0, 1fr);
  align-items: center;
  gap: 20px;
  padding: 14px 18px;
  background: #fff;
  border: 1px solid var(--settings-line);
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(37, 49, 43, 0.035);
}

:host .project-output-settings__grid--split .project-output-settings__summary-status {
  min-width: 0;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-items: center;
  gap: 3px 11px;
  padding: 0;
  text-align: left;
}

:host .project-output-settings__grid--split .project-output-settings__summary-icon {
  grid-column: 1;
  grid-row: 1/3;
  width: 38px;
  height: 38px;
  margin: 0;
  color: #fff;
  background: #30363b;
  border-radius: 50%;
  box-shadow: none;
  font-size: 14px;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status strong {
  grid-column: 2;
  grid-row: 1;
  color: #242a2f;
  font-size: 17px;
  line-height: 1;
  font-weight: 700;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status b {
  grid-column: 2;
  grid-row: 2;
  margin: 0;
  color: #59635f;
  font-size: 12px;
  font-weight: 700;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status p {
  display: none;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details {
  min-width: 0;
  padding: 0;
  border: 0;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details h3 {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dl {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0;
  margin: 0;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dl > div {
  min-width: 0;
  padding: 4px 14px;
  background: transparent;
  border: 0;
  border-radius: 0;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dl > div + div {
  border-left: 1px solid var(--settings-line);
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dt {
  gap: 6px;
  color: #858c91;
  font-size: 12px;
  font-weight: 700;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dt i {
  width: 12px;
  color: #60696f;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dd {
  margin: 5px 0 0 18px;
  overflow: hidden;
  color: #2c3338;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-output-settings__grid--split > .project-output-card,
:host .project-output-settings__grid--split > .project-output-card.is-kg,
:host .project-output-settings__grid--split.is-single > .project-output-card,
:host .project-output-settings__grid--split.is-single > .project-output-card.is-kg {
  grid-column: auto;
  grid-row: auto;
  grid-area: qa;
  min-width: 0;
  min-height: 0;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--settings-line);
  border-radius: 8px !important;
  box-shadow: 0 6px 20px rgba(37, 49, 43, 0.04);
}

:host .project-output-settings__grid--split > .project-output-card.is-kg {
  grid-area: kg;
}

:host .project-output-settings__grid--split.is-single > .project-output-card,
:host .project-output-settings__grid--split.is-single > .project-output-card.is-kg {
  grid-column: 1/-1;
  grid-area: auto;
}

:host .project-output-settings__grid--split > .project-output-card:hover,
:host .project-output-settings__grid--split > .project-output-card:focus-visible,
:host .project-output-settings__grid--split > .project-output-card.is-kg:hover,
:host .project-output-settings__grid--split > .project-output-card.is-kg:focus-visible {
  transform: none;
  border-color: #c8d0cc;
  box-shadow: 0 9px 24px rgba(37, 49, 43, 0.065);
}

:host .project-output-settings__grid--split .project-output-card__header {
  min-height: 76px;
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: var(--settings-qa-soft);
  border: 0;
  border-bottom: 1px solid var(--settings-line);
  border-radius: 0 !important;
  box-shadow: none;
}

:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__header {
  background: var(--settings-kg-soft);
}

:host .project-output-settings__grid--split .project-output-card__identity {
  min-width: 0;
  align-items: center;
  gap: 12px;
}

:host .project-output-settings__grid--split .project-output-card__identity > div {
  min-width: 0;
  padding: 0;
}

:host .project-output-settings__grid--split .project-output-card__code {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  color: #fff;
  background: var(--settings-qa);
  border: 0;
  border-radius: 6px;
  box-shadow: none;
  font-size: 13px;
}

:host .project-output-settings__grid--split .project-output-card__code.is-kg {
  background: var(--settings-kg);
  box-shadow: none;
}

:host .project-output-settings__grid--split .project-output-card__identity strong {
  color: #252c31;
  font-size: 15px;
  font-weight: 700;
}

:host .project-output-settings__grid--split .project-output-card__identity p {
  margin-top: 3px;
  color: #747d82;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-card__header-actions {
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
}

:host .project-output-settings__grid--split .project-output-card__status {
  min-height: 28px;
  padding: 0 9px;
  color: #566650;
  background: #fff;
  border: 1px solid #d9e3d5;
  border-radius: 999px;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-card__settings,
:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__settings {
  min-height: 30px;
  padding: 0 9px;
  color: #505a61;
  background: #fff;
  border: 1px solid #cfd6d3;
  border-radius: 5px;
  box-shadow: none;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-card__settings:hover {
  color: #fff;
  background: var(--settings-qa);
  border-color: var(--settings-qa);
}

:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__settings:hover {
  color: #fff;
  background: var(--settings-kg);
  border-color: var(--settings-kg);
}

:host .project-output-settings__grid--split .project-output-card__body {
  min-height: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0;
  padding: 0 16px 14px;
}

:host .project-output-settings__grid--split .project-output-card__section,
:host .project-output-settings__grid--split .project-output-card__section--output {
  min-width: 0;
  display: grid;
  grid-template-columns: 104px minmax(0, 1fr);
  align-items: start;
  gap: 14px;
  flex: none;
  padding: 13px 0;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #e7eae8;
  border-radius: 0;
  box-shadow: none;
}

:host .project-output-settings__grid--split .project-output-card__section-title,
:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__section-title {
  margin: 7px 0 0;
  color: var(--settings-qa);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__section-title {
  color: var(--settings-kg);
}

:host .project-output-settings__grid--split .project-output-card__checklist {
  min-width: 0;
  display: grid;
  gap: 0;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
}

:host .project-output-settings__grid--split .project-output-card__checklist li {
  min-width: 0;
  min-height: 34px;
  display: grid;
  grid-template-columns: 22px minmax(92px, 0.7fr) minmax(0, 1.3fr);
  align-items: center;
  gap: 7px;
  padding: 2px 0;
  border: 0;
}

:host .project-output-settings__grid--split .project-output-card__checklist li + li {
  border-top: 1px dashed #e6e9e7;
}

:host .project-output-settings__grid--split .project-output-card__item-icon,
:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__item-icon {
  width: 22px;
  height: 22px;
  color: #596269;
  background: transparent;
  border-radius: 0;
  font-size: 12px;
}

:host .project-output-settings__grid--split .project-output-card__item-label {
  color: #4a5358;
  font-size: 12px;
  font-weight: 700;
}

:host .project-output-settings__grid--split .project-output-card__item-value,
:host .project-output-settings__grid--split .project-output-card__checklist li.is-complete .project-output-card__item-value,
:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__checklist li.is-complete .project-output-card__item-value {
  min-width: 0;
  max-width: 100%;
  justify-self: end;
  padding: 0;
  overflow: hidden;
  color: #2f373c;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-output-settings__grid--split .project-output-card__actions {
  grid-column: auto;
  margin: 0;
  padding: 14px 0 0;
  border: 0;
}

:host .project-output-settings__grid--split .project-output-card__cta,
:host .project-output-settings__grid--split .project-output-card__cta.is-kg {
  min-height: 44px;
  color: #fff;
  background: var(--settings-qa);
  border: 0;
  border-radius: 5px !important;
  box-shadow: none;
  font-size: 12px;
  font-weight: 700;
}

:host .project-output-settings__grid--split .project-output-card__cta.is-kg {
  background: var(--settings-kg);
}

:host .project-output-settings__grid--split .project-output-card__cta:hover {
  background: var(--settings-qa-dark);
}

:host .project-output-settings__grid--split .project-output-card__cta.is-kg:hover {
  background: var(--settings-kg-dark);
}

@media (max-width: 1260px) {
  :host .project-output-settings__grid--split > .project-output-settings__summary {
    grid-template-columns: 190px minmax(0, 1fr);
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 12px;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl > div:nth-child(4) {
    border-left: 0;
  }
  :host .project-output-settings__grid--split .project-output-card__section,
  :host .project-output-settings__grid--split .project-output-card__section--output {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  :host .project-output-settings__grid--split .project-output-card__section-title,
  :host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__section-title {
    margin-top: 0;
  }
}
@media (max-width: 900px) {
  :host .project-output-settings__grid.project-output-settings__grid--split,
  :host .project-output-settings__grid.project-output-settings__grid--split.is-single {
    max-width: 720px;
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: "summary" "qa" "kg";
  }
  :host .project-output-settings__grid--split > .project-output-settings__summary {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 620px) {
  :host .project-output-settings__grid--split > .project-output-settings__summary {
    padding: 14px;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl > div,
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl > div:nth-child(4) {
    border-left: 0;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl > div:nth-child(even) {
    border-left: 1px solid var(--settings-line);
  }
  :host .project-output-settings__grid--split .project-output-card__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
  :host .project-output-settings__grid--split .project-output-card__header-actions {
    width: 100%;
    justify-content: space-between;
  }
  :host .project-output-settings__grid--split .project-output-card__body {
    padding: 0 14px 14px;
  }
  :host .project-output-settings__grid--split .project-output-card__checklist li {
    grid-template-columns: 20px minmax(82px, 0.75fr) minmax(0, 1.25fr);
  }
}
/* Knowledge graph toolbar — keep search icon and input in one control. */
:host .kg-result-page:not(.qa-result-page) .kg-result-toolbar {
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
}

:host .kg-result-page:not(.qa-result-page) .kg-result-search {
  width: min(100%, 420px);
  min-width: 240px;
  height: 38px;
  min-height: 38px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: stretch;
  gap: 0;
  flex: 1 1 420px;
  margin: 0 auto 0 0;
  padding: 0;
  overflow: hidden;
  color: #7a8580;
  background: #fff;
  border: 1px solid #d8dfdb !important;
  border-radius: 7px !important;
  box-shadow: none !important;
}

:host .kg-result-page:not(.qa-result-page) .kg-result-search:focus-within {
  border-color: #397563 !important;
  box-shadow: 0 0 0 3px rgba(57, 117, 99, 0.12) !important;
}

:host .kg-result-page:not(.qa-result-page) .kg-result-search > i {
  width: 42px;
  height: 100%;
  display: grid;
  place-items: center;
  align-self: stretch;
  color: #78847f;
  border-right: 1px solid #e3e8e5;
  font-size: 13px;
  line-height: 1;
}

:host .kg-result-page:not(.qa-result-page) .kg-result-search input,
:host .kg-result-page:not(.qa-result-page) .kg-result-search input[type=search] {
  width: 100% !important;
  min-width: 0 !important;
  height: 36px !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 13px !important;
  appearance: none;
  color: #35413c;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 700;
  line-height: 36px;
}

:host .kg-result-page:not(.qa-result-page) .kg-result-search input::placeholder {
  color: #8a9490;
  opacity: 1;
}

:host .kg-result-page:not(.qa-result-page) .kg-result-search input::-webkit-search-cancel-button {
  margin-inline-start: 8px;
  cursor: pointer;
}

@media (max-width: 980px) {
  :host .kg-result-page:not(.qa-result-page) .kg-result-toolbar {
    align-items: stretch;
    flex-wrap: wrap;
  }
  :host .kg-result-page:not(.qa-result-page) .kg-result-search {
    width: 100%;
    max-width: none;
    flex-basis: 100%;
  }
  :host .kg-result-page:not(.qa-result-page) .kg-result-view-toggle {
    margin-right: auto;
  }
}
@media (max-width: 560px) {
  :host .kg-result-page:not(.qa-result-page) .kg-result-search {
    min-width: 0;
  }
  :host .kg-result-page:not(.qa-result-page) .kg-result-view-toggle {
    width: 100%;
  }
  :host .kg-result-page:not(.qa-result-page) .kg-result-view-toggle button {
    flex: 1 1 50%;
    min-width: 0;
  }
}
/* -------------------------------------------------------------------------- */
/* Project creation control — premium settings studio                         */
/* -------------------------------------------------------------------------- */
:host .review-project-header:has(.project-settings-page-title) {
  border-color: #e1e4df !important;
  background: radial-gradient(circle at 72% -30%, rgba(68, 103, 82, 0.08), transparent 34rem), #fbfcf9 !important;
}

:host .project-settings-page-title__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  width: fit-content;
  margin: 0;
  color: #b65432;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

:host .project-settings-page-title__eyebrow i {
  font-size: 12px;
}

:host .project-settings-page-title__line h1 {
  margin: 0 4px 0 0;
}

:host .project-settings-page-title__line > span {
  color: #9a9f99;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-page-title__line > strong {
  color: #4b544d;
  font-size: 16px !important;
  line-height: 24px !important;
  font-weight: 700;
}

:host .project-settings-page-title__line > code {
  padding: 5px 8px;
  border: 1px solid #dce1dc;
  border-radius: 7px;
  color: #59645d;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-page-title__description {
  color: #7f867f;
}

:host .review-project-header:has(.project-settings-page-title) .project-settings-completion {
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid #d3ded0;
  border-radius: 10px;
  color: #4c644c;
  background: #f2f7ef;
  box-shadow: 0 5px 14px rgba(50, 74, 48, 0.05);
}

:host .review-project-header:has(.project-settings-page-title) .project-settings-completion i {
  color: #567252;
}

:host main:has(> .project-output-settings > .project-output-settings__grid--split) {
  max-width: 1480px !important;
  padding-top: 28px !important;
  padding-bottom: 64px !important;
}

:host .project-output-settings:has(> .project-output-settings__grid--split) {
  padding: 0 !important;
}

:host .project-output-settings__grid.project-output-settings__grid--split,
:host .project-output-settings__grid.project-output-settings__grid--split.is-single {
  --studio-ink: #252c28;
  --studio-muted: #778079;
  --studio-line: #e0e5e0;
  --studio-soft-line: #eaede9;
  --studio-qa: #455f82;
  --studio-qa-dark: #354c6b;
  --studio-qa-soft: #f1f5fa;
  --studio-kg: #3f7a69;
  --studio-kg-dark: #2e6254;
  --studio-kg-soft: #eff7f4;
  width: min(100%, 1420px) !important;
  max-width: 1420px !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  grid-template-rows: auto auto !important;
  grid-template-areas: "summary summary" "qa kg" !important;
  gap: 20px !important;
}

:host .project-output-settings__grid--split > .project-output-settings__summary,
:host .project-output-settings__grid--split.is-single > .project-output-settings__summary {
  grid-area: summary !important;
  min-height: 178px !important;
  display: grid !important;
  grid-template-columns: 360px minmax(0, 1fr) !important;
  align-items: stretch !important;
  gap: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  border: 1px solid #dce2dc !important;
  border-radius: 18px !important;
  background: #fff !important;
  box-shadow: 0 14px 38px rgba(35, 47, 39, 0.07) !important;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status {
  display: grid !important;
  grid-template-columns: 56px minmax(0, 1fr) !important;
  grid-template-rows: auto auto auto auto auto !important;
  align-content: center !important;
  align-items: center !important;
  gap: 3px 14px !important;
  min-width: 0;
  padding: 25px 27px !important;
  color: #fff;
  background: radial-gradient(circle at 92% 4%, rgba(111, 161, 126, 0.25), transparent 42%), linear-gradient(140deg, #344039 0%, #26312b 100%) !important;
}

:host .project-output-settings__summary-kicker {
  grid-column: 1/-1;
  grid-row: 1;
  margin-bottom: 10px;
  color: #b8c6bb;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

:host .project-output-settings__grid--split .project-output-settings__summary-icon {
  grid-column: 1 !important;
  grid-row: 2/4 !important;
  width: 56px !important;
  height: 56px !important;
  margin: 0 !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-radius: 16px !important;
  color: #fff !important;
  background: rgba(255, 255, 255, 0.08) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
  font-size: 18px !important;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status strong {
  grid-column: 2 !important;
  grid-row: 2 !important;
  color: #fff !important;
  font-size: 26px !important;
  font-weight: 700 !important;
  letter-spacing: -0.04em;
  line-height: 1 !important;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status b {
  grid-column: 2 !important;
  grid-row: 3 !important;
  color: #dce5dd !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

:host .project-output-settings__grid--split .project-output-settings__summary-status p {
  grid-column: 1/-1;
  grid-row: 4;
  display: block !important;
  margin: 13px 0 0 !important;
  color: #aebbb0 !important;
  font-size: 12px !important;
  font-weight: 600;
  line-height: 1.55;
}

:host .project-output-settings__summary-progress {
  grid-column: 1/-1;
  grid-row: 5;
  height: 5px;
  margin-top: 11px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
}

:host .project-output-settings__summary-progress i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #9ab287, #d1dfc8);
}

:host .project-output-settings__summary-action {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 33px;
  margin-top: 12px;
  padding: 0 11px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  color: #f0f5f1;
  background: rgba(255, 255, 255, 0.07);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  transition: background 0.18s ease, border-color 0.18s ease;
}

:host .project-output-settings__summary-action:hover {
  border-color: rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.12);
}

:host .project-output-settings__grid--split .project-output-settings__summary-details {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 23px 26px !important;
  border: 0 !important;
  background: #fff;
}

:host .project-output-settings__summary-heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 13px;
}

:host .project-output-settings__summary-heading > div {
  display: grid;
  gap: 2px;
}

:host .project-output-settings__summary-heading small {
  color: #a05a3d;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

:host .project-output-settings__grid--split .project-output-settings__summary-heading h3 {
  position: static !important;
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  overflow: visible !important;
  clip: auto !important;
  color: var(--studio-ink);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

:host .project-output-settings__summary-heading > span {
  min-height: 25px;
  display: inline-flex;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  color: #567052;
  background: #edf4e9;
  font-size: 12px;
  font-weight: 700;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dl {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  gap: 8px !important;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dl > div,
:host .project-output-settings__grid--split .project-output-settings__summary-details dl > div + div {
  min-height: 54px;
  padding: 10px 11px !important;
  border: 1px solid #eef0ed !important;
  border-radius: 9px !important;
  background: #f8f9f7 !important;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dt {
  color: #909790 !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dt i {
  color: #69736c !important;
  font-size: 12px !important;
}

:host .project-output-settings__grid--split .project-output-settings__summary-details dd {
  margin: 5px 0 0 18px !important;
  color: #333b36 !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

:host .project-output-settings__grid--split > .project-output-card,
:host .project-output-settings__grid--split > .project-output-card.is-kg,
:host .project-output-settings__grid--split.is-single > .project-output-card,
:host .project-output-settings__grid--split.is-single > .project-output-card.is-kg {
  position: relative;
  min-height: 500px !important;
  overflow: hidden !important;
  border: 1px solid var(--studio-line) !important;
  border-radius: 18px !important;
  background: #fff !important;
  box-shadow: 0 12px 34px rgba(35, 47, 39, 0.055) !important;
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease !important;
}

:host .project-output-settings__grid--split > .project-output-card::before {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--studio-qa), #7890ad);
  content: "";
}

:host .project-output-settings__grid--split > .project-output-card.is-kg::before {
  background: linear-gradient(90deg, var(--studio-kg), #79a597);
}

:host .project-output-settings__grid--split > .project-output-card:hover,
:host .project-output-settings__grid--split > .project-output-card:focus-visible {
  border-color: #cbd4ce !important;
  box-shadow: 0 17px 40px rgba(35, 47, 39, 0.085) !important;
  transform: translateY(-2px) !important;
}

:host .project-output-settings__grid--split .project-output-card__header,
:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__header {
  min-height: 108px !important;
  padding: 23px 24px !important;
  border: 0 !important;
  border-bottom: 1px solid var(--studio-line) !important;
  background: radial-gradient(circle at 88% -10%, rgba(85, 111, 148, 0.13), transparent 40%), var(--studio-qa-soft) !important;
}

:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__header {
  background: radial-gradient(circle at 88% -10%, rgba(68, 132, 113, 0.14), transparent 40%), var(--studio-kg-soft) !important;
}

:host .project-output-settings__grid--split .project-output-card__identity {
  gap: 14px !important;
}

:host .project-output-settings__grid--split .project-output-card__code {
  width: 52px !important;
  height: 52px !important;
  flex-basis: 52px !important;
  border-radius: 13px !important;
  background: linear-gradient(145deg, #536f95, var(--studio-qa-dark)) !important;
  box-shadow: 0 8px 18px rgba(50, 72, 101, 0.17) !important;
  font-size: 14px !important;
}

:host .project-output-settings__grid--split .project-output-card__code.is-kg {
  background: linear-gradient(145deg, #4d8877, var(--studio-kg-dark)) !important;
  box-shadow: 0 8px 18px rgba(46, 98, 84, 0.17) !important;
}

:host .project-output-card__kicker {
  display: block;
  margin-bottom: 3px;
  color: #7e8da0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

:host .project-output-card.is-kg .project-output-card__kicker {
  color: #648b80;
}

:host .project-output-settings__grid--split .project-output-card__identity strong {
  font-size: 17px !important;
  letter-spacing: -0.025em;
}

:host .project-output-settings__grid--split .project-output-card__identity p {
  margin-top: 4px !important;
  font-size: 12px !important;
}

:host .project-output-settings__grid--split .project-output-card__status {
  min-height: 30px !important;
  padding: 0 10px !important;
  border-color: #d5dfd1 !important;
  border-radius: 999px !important;
  color: #536951 !important;
  background: rgba(255, 255, 255, 0.82) !important;
  font-size: 12px !important;
}

:host .project-output-settings__grid--split .project-output-card__settings,
:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__settings {
  min-height: 34px !important;
  padding: 0 11px !important;
  border-radius: 8px !important;
  background: rgba(255, 255, 255, 0.86) !important;
  font-size: 12px !important;
}

:host .project-output-settings__grid--split .project-output-card__body {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  grid-template-rows: auto auto 1fr auto !important;
  align-content: start;
  gap: 0 !important;
  min-height: 390px !important;
  padding: 0 !important;
}

:host .project-output-settings__grid--split .project-output-card__section,
:host .project-output-settings__grid--split .project-output-card__section--output {
  display: block !important;
  min-width: 0;
  padding: 22px 23px !important;
  border: 0 !important;
  border-bottom: 1px solid var(--studio-soft-line) !important;
  background: #fff !important;
}

:host .project-output-settings__grid--split .project-output-card__section:nth-child(2) {
  border-left: 1px solid var(--studio-soft-line) !important;
}

:host .project-output-settings__grid--split .project-output-card__section--output {
  grid-column: 1/-1;
  min-height: 86px;
  padding-block: 18px !important;
}

:host .project-output-settings__grid--split .project-output-card__section-title,
:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__section-title {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0 0 11px !important;
  color: var(--studio-qa) !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__section-title {
  color: var(--studio-kg) !important;
}

:host .project-output-settings__grid--split .project-output-card__section-title::before {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
  content: "";
}

:host .project-output-settings__grid--split .project-output-card__checklist li {
  min-height: 38px !important;
  grid-template-columns: 24px minmax(82px, 0.8fr) minmax(0, 1.2fr) !important;
  gap: 8px !important;
}

:host .project-output-settings__grid--split .project-output-card__item-icon,
:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__item-icon {
  width: 24px !important;
  height: 24px !important;
  border-radius: 7px !important;
  color: #627189 !important;
  background: #f1f4f8 !important;
  font-size: 12px !important;
}

:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__item-icon {
  color: #4b7b6d !important;
  background: #edf5f2 !important;
}

:host .project-output-settings__grid--split .project-output-card__item-label {
  color: #606962 !important;
  font-size: 12px !important;
}

:host .project-output-settings__grid--split .project-output-card__item-value,
:host .project-output-settings__grid--split .project-output-card__checklist li.is-complete .project-output-card__item-value,
:host .project-output-settings__grid--split .project-output-card.is-kg .project-output-card__checklist li.is-complete .project-output-card__item-value {
  color: #2d3530 !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

:host .project-output-settings__grid--split .project-output-card__actions {
  grid-column: 1/-1 !important;
  align-self: end;
  margin: 0 !important;
  padding: 20px 23px 22px !important;
  border: 0 !important;
}

:host .project-output-settings__grid--split .project-output-card__cta,
:host .project-output-settings__grid--split .project-output-card__cta.is-kg {
  min-height: 50px !important;
  border-radius: 11px !important;
  background: linear-gradient(135deg, #4c688e, var(--studio-qa-dark)) !important;
  box-shadow: 0 9px 18px rgba(49, 70, 95, 0.15) !important;
  font-size: 12px !important;
  letter-spacing: -0.01em;
}

:host .project-output-settings__grid--split .project-output-card__cta.is-kg {
  background: linear-gradient(135deg, #4b8373, var(--studio-kg-dark)) !important;
  box-shadow: 0 9px 18px rgba(46, 98, 84, 0.15) !important;
}

:host .project-output-settings__grid--split .project-output-card__cta:hover {
  background: var(--studio-qa-dark) !important;
  transform: translateY(-1px);
}

:host .project-output-settings__grid--split .project-output-card__cta.is-kg:hover {
  background: var(--studio-kg-dark) !important;
}

@media (max-width: 1180px) {
  :host .project-output-settings__grid--split > .project-output-settings__summary,
  :host .project-output-settings__grid--split.is-single > .project-output-settings__summary {
    grid-template-columns: 310px minmax(0, 1fr) !important;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  :host .project-output-settings__grid--split .project-output-card__body {
    grid-template-columns: 1fr !important;
  }
  :host .project-output-settings__grid--split .project-output-card__section:nth-child(2) {
    border-left: 0 !important;
  }
  :host .project-output-settings__grid--split .project-output-card__section--output,
  :host .project-output-settings__grid--split .project-output-card__actions {
    grid-column: 1 !important;
  }
}
@media (max-width: 900px) {
  :host .project-output-settings__grid.project-output-settings__grid--split,
  :host .project-output-settings__grid.project-output-settings__grid--split.is-single {
    grid-template-columns: 1fr !important;
    grid-template-areas: "summary" "qa" "kg" !important;
  }
  :host .project-output-settings__grid--split > .project-output-settings__summary,
  :host .project-output-settings__grid--split.is-single > .project-output-settings__summary {
    grid-template-columns: 1fr !important;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details {
    padding: 22px !important;
  }
}
@media (max-width: 620px) {
  :host .project-settings-page-title__line > span {
    display: none;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-status {
    padding: 22px !important;
  }
  :host .project-output-settings__grid--split .project-output-settings__summary-details dl {
    grid-template-columns: 1fr !important;
  }
  :host .project-output-settings__summary-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 7px;
  }
  :host .project-output-settings__grid--split .project-output-card__header {
    align-items: flex-start !important;
    flex-direction: column !important;
    gap: 14px !important;
  }
  :host .project-output-settings__grid--split .project-output-card__header-actions {
    width: 100%;
    justify-content: space-between;
  }
  :host .project-output-settings__grid--split .project-output-card__section,
  :host .project-output-settings__grid--split .project-output-card__section--output {
    padding-inline: 18px !important;
  }
  :host .project-output-settings__grid--split .project-output-card__actions {
    padding-inline: 18px !important;
  }
}
/* Knowledge graph zoom controls — do not clip the outer button corners. */
:host .kg-result-page:not(.qa-result-page) .kg-result-zoom {
  width: auto;
  height: auto;
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex: 0 0 auto;
  padding: 0;
  overflow: visible !important;
  background: transparent;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

:host .kg-result-page:not(.qa-result-page) .kg-result-zoom button,
:host .kg-result-page:not(.qa-result-page) .kg-result-zoom button:first-child,
:host .kg-result-page:not(.qa-result-page) .kg-result-zoom button:last-child {
  width: 36px;
  min-width: 36px;
  height: 36px;
  min-height: 36px;
  display: grid;
  place-items: center;
  flex: 0 0 36px;
  margin: 0;
  padding: 0;
  color: #52605a;
  background: #fff;
  border: 1px solid #d8dfdb !important;
  outline: 0;
  box-shadow: none !important;
}

:host .kg-result-page:not(.qa-result-page) .kg-result-zoom button:hover {
  color: #225e4a;
  background: #eef5f2;
  border-color: #b8c9c1 !important;
}

:host .kg-result-page:not(.qa-result-page) .kg-result-zoom button:focus-visible {
  border-color: #397563 !important;
  box-shadow: 0 0 0 3px rgba(57, 117, 99, 0.12) !important;
}

/* Project settings — selected concept 03: setup canvas + readiness inspector. */
:host .review-workspace:has(.project-settings-v3) {
  min-height: 100%;
  background: #f7f7f3;
}

:host .review-project-header:has(.project-settings-page-title) {
  background: #fffefb !important;
  border-color: #e4e6e0 !important;
}

:host .review-project-header:has(.project-settings-page-title) .review-project-header__inner > div {
  align-items: center !important;
  padding-bottom: 24px !important;
}

:host .project-settings-page-title__eyebrow {
  margin: 0 0 8px !important;
  color: #df5a32 !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0.18em !important;
}

:host .project-settings-page-title__line span {
  color: #9ba29d !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

:host .project-settings-page-title__line strong {
  color: #56605a !important;
  font-size: 16px !important;
  line-height: 24px !important;
}

:host .project-settings-page-title__line code {
  padding: 5px 9px !important;
  color: #55605a !important;
  background: #f4f6f3 !important;
  border: 1px solid #dfe4df !important;
  border-radius: 6px !important;
  font-size: 12px !important;
}

:host .project-settings-page-title__description {
  color: #526052 !important;
}

:host .project-settings-completion {
  min-height: 38px !important;
  padding: 0 14px !important;
  color: #526552 !important;
  background: #f7faf4 !important;
  border: 1px solid #d7e1d2 !important;
  border-radius: 9px !important;
  box-shadow: none !important;
}

:host .project-output-settings.project-output-settings--v3 {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  overflow: visible !important;
}

:host .project-settings-v3 {
  --v3-coral: #e65b35;
  --v3-coral-dark: #ca4927;
  --v3-ink: #272d2a;
  --v3-muted: #7b8580;
  --v3-line: #e2e6e1;
  --v3-navy: #496789;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 350px;
  gap: 22px;
  width: 100%;
  outline: 0;
}

:host .project-settings-v3__canvas,
:host .project-settings-v3__inspector {
  min-width: 0;
  background: #fff;
  border: 1px solid var(--v3-line);
  border-radius: 14px;
  box-shadow: 0 14px 34px rgba(47, 59, 52, 0.06);
}

:host .project-settings-v3__canvas {
  overflow: hidden;
}

:host .project-settings-v3__steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-height: 72px;
  padding: 0 22px;
  background: #fff;
  border-bottom: 1px solid var(--v3-line);
}

:host .project-settings-v3__steps button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 0;
  padding: 0 18px;
  color: #9aa29d;
  background: transparent;
  border: 0;
  cursor: pointer;
}

:host .project-settings-v3__steps button::after {
  position: absolute;
  right: 16px;
  bottom: -1px;
  left: 16px;
  height: 3px;
  content: "";
  background: transparent;
}

:host .project-settings-v3__steps button > span {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  flex: 0 0 28px;
  color: #7e8882;
  background: #f3f5f2;
  border: 1px solid #dfe4df;
}

:host .project-settings-v3__steps button > strong {
  color: inherit;
}

:host .project-settings-v3__steps button.is-complete > span {
  color: #fff;
  background: #71856b;
  border-color: #71856b;
}

:host .project-settings-v3__steps button.is-active {
  color: var(--v3-ink);
}

:host .project-settings-v3__steps button.is-active::after {
  background: var(--v3-coral);
}

:host .project-settings-v3__steps button.is-active > span {
  color: #fff;
  background: var(--v3-coral);
  border-color: var(--v3-coral);
  box-shadow: 0 5px 12px rgba(230, 91, 53, 0.18);
}

:host .project-settings-v3__steps button:focus-visible {
  outline: 2px solid rgba(230, 91, 53, 0.34);
  outline-offset: -4px;
}

:host .project-settings-v3__content {
  padding: 30px 34px 34px;
}

:host .project-settings-v3__content-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 22px;
  margin-bottom: 24px;
}

:host .project-settings-v3__content-head p {
  margin: 0 0 7px;
  color: var(--v3-coral);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

:host .project-settings-v3__content-head h2 {
  margin: 0;
  color: var(--v3-ink);
  font-size: 23px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.035em;
}

:host .project-settings-v3__content-head > div:first-child > span {
  display: block;
  margin-top: 7px;
  color: var(--v3-muted);
  font-size: 12px;
  line-height: 1.6;
}

:host .project-settings-v3__kind-switch {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  background: #f4f6f3;
  border: 1px solid var(--v3-line);
  border-radius: 9px;
}

:host .project-settings-v3__kind-switch button {
  min-width: 42px;
  height: 30px;
  color: #86908a;
  background: transparent;
  border: 0;
}

:host .project-settings-v3__kind-switch button.is-active {
  color: #fff;
  background: var(--v3-navy);
  box-shadow: 0 3px 8px rgba(73, 103, 137, 0.18);
}

:host .project-settings-v3__field-list {
  border-top: 1px solid var(--v3-line);
}

:host .project-settings-v3__field {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto 14px;
  gap: 14px;
  align-items: center;
  width: 100%;
  min-height: 72px;
  padding: 12px 8px;
  text-align: left;
  background: #fff;
  border: 0;
  border-bottom: 1px solid var(--v3-line);
  cursor: pointer;
  transition: background 0.16s ease;
}

:host .project-settings-v3__field:hover {
  background: #fafbf9;
}

:host .project-settings-v3__field-icon {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: var(--v3-navy);
  background: #edf2f8;
  border-radius: 9px;
  font-size: 13px;
}

:host .project-settings-v3__field-copy {
  min-width: 0;
}

:host .project-settings-v3__field-copy small,
:host .project-settings-v3__field-copy strong {
  display: block;
}

:host .project-settings-v3__field-copy small {
  margin-bottom: 4px;
  color: #8c958f;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-v3__field-copy strong {
  overflow: hidden;
  color: var(--v3-ink);
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-settings-v3__field-state {
  padding: 5px 8px;
  color: #aa6a43;
  background: #fff7ec;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

:host .project-settings-v3__field-state.is-ready {
  color: #5c7658;
  background: #f0f6ec;
}

:host .project-settings-v3__field > .fa-chevron-right {
  color: #aab1ad;
  font-size: 12px;
}

:host .project-settings-v3__guide {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  padding: 17px 18px;
  color: #50677e;
  background: #f2f7fb;
  border: 1px solid #dce8f1;
  border-radius: 10px;
}

:host .project-settings-v3__guide > i {
  margin-top: 2px;
  color: #5f7d9a;
}

:host .project-settings-v3__guide strong {
  display: block;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-v3__guide p {
  margin: 4px 0 0;
  color: #74889a;
  font-size: 12px;
  line-height: 1.55;
}

:host .project-settings-v3__result {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr) auto;
  gap: 18px;
  align-items: center;
  min-height: 174px;
  padding: 24px;
  background: #f8fafc;
  border: 1px solid #dfe6ee;
  border-radius: 12px;
}

:host .project-settings-v3__result-icon {
  display: grid;
  width: 56px;
  height: 56px;
  place-items: center;
  color: #fff;
  background: var(--v3-navy);
  border-radius: 13px;
  font-size: 18px;
}

:host .project-settings-v3__result-icon.is-kg {
  background: #3f7868;
}

:host .project-settings-v3__result small {
  color: #8794a1;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.17em;
}

:host .project-settings-v3__result h3 {
  margin: 6px 0 2px;
  color: var(--v3-ink);
  font-size: 15px;
  font-weight: 700;
}

:host .project-settings-v3__result div > strong {
  color: var(--v3-navy);
  font-size: 24px;
  font-weight: 700;
}

:host .project-settings-v3__result p {
  margin: 5px 0 0;
  color: var(--v3-muted);
  font-size: 12px;
}

:host .project-settings-v3__result button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 38px;
  padding: 0 13px;
  color: #55635d;
  background: #fff;
  border: 1px solid #d7ddd9;
}

:host .project-settings-v3__preview {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 24px;
}

:host .project-settings-v3__preview button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  min-height: 58px;
  padding: 12px 14px;
  text-align: left;
  background: #fff;
  border: 1px solid var(--v3-line);
}

:host .project-settings-v3__preview button.is-current {
  background: #fff8f5;
  border-color: #f0b7a5;
}

:host .project-settings-v3__preview button > span {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
  color: #66716b;
}

:host .project-settings-v3__preview button strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-settings-v3__preview button em {
  color: #9aa29d;
  font-style: normal;
  white-space: nowrap;
}

:host .project-settings-v3__inspector {
  align-self: start;
  position: sticky;
  top: 20px;
  padding: 25px 24px 22px;
}

:host .project-settings-v3__readiness {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

:host .project-settings-v3__readiness small {
  color: var(--v3-coral);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

:host .project-settings-v3__readiness h2 {
  margin: 7px 0 0;
  color: var(--v3-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

:host .project-settings-v3__readiness > span {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: #7c8881;
  background: #f1f4ef;
  border: 1px solid #dfe5dd;
  border-radius: 50%;
}

:host .project-settings-v3__readiness > span.is-ready {
  color: #fff;
  background: #6f8568;
  border-color: #6f8568;
}

:host .project-settings-v3__score {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: 20px 0 17px;
  padding-bottom: 18px;
  border-bottom: 1px solid var(--v3-line);
}

:host .project-settings-v3__score strong {
  color: var(--v3-ink);
  font-size: 29px;
  font-weight: 700;
  letter-spacing: -0.05em;
}

:host .project-settings-v3__score span {
  color: #78827c;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-v3__checklist {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

:host .project-settings-v3__checklist li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 16px;
  gap: 11px;
  align-items: center;
  min-height: 54px;
  padding: 9px 11px;
  background: #fafbf9;
  border: 1px solid #e7eae6;
  border-radius: 9px;
}

:host .project-settings-v3__checklist li.is-active {
  background: #fff8f5;
  border-color: #efc1b2;
}

:host .project-settings-v3__checklist li > span {
  display: grid;
  width: 27px;
  height: 27px;
  place-items: center;
  color: #7d8781;
  background: #eef1ee;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-v3__checklist li.is-active > span {
  color: #fff;
  background: var(--v3-coral);
}

:host .project-settings-v3__checklist li.is-complete > span {
  color: #fff;
  background: #73866d;
}

:host .project-settings-v3__checklist strong,
:host .project-settings-v3__checklist small {
  display: block;
}

:host .project-settings-v3__checklist strong {
  color: #3c4540;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-v3__checklist small {
  margin-top: 3px;
  color: #9aa29e;
  font-size: 12px;
}

:host .project-settings-v3__checklist li > i {
  color: transparent;
  font-size: 12px;
}

:host .project-settings-v3__checklist li.is-complete > i {
  color: #6d8267;
}

:host .project-settings-v3__project-info {
  margin-top: 20px;
  padding-top: 19px;
  border-top: 1px solid var(--v3-line);
}

:host .project-settings-v3__project-info h3 {
  margin: 0 0 11px;
  color: #4d5751;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-v3__project-info dl,
:host .project-settings-v3__project-info dl > div {
  margin: 0;
}

:host .project-settings-v3__project-info dl {
  display: grid;
  gap: 8px;
}

:host .project-settings-v3__project-info dl > div {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  font-size: 12px;
}

:host .project-settings-v3__project-info dt {
  color: #9aa29d;
}

:host .project-settings-v3__project-info dd {
  overflow: hidden;
  margin: 0;
  color: #4d5751;
  font-weight: 700;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-settings-v3__actions {
  display: grid;
  gap: 9px;
  margin-top: 22px;
}

:host .project-settings-v3__actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 42px;
}

:host .project-settings-v3__primary {
  color: #fff;
  background: var(--v3-coral);
  border: 1px solid var(--v3-coral);
  box-shadow: 0 8px 18px rgba(230, 91, 53, 0.17);
}

:host .project-settings-v3__primary:hover {
  background: var(--v3-coral-dark);
  border-color: var(--v3-coral-dark);
}

:host .project-settings-v3__result-button {
  color: #fff;
  background: var(--v3-coral);
  border: 1px solid var(--v3-coral);
  box-shadow: 0 8px 18px rgba(230, 91, 53, 0.17);
}

:host .project-settings-v3__result-button:hover {
  background: var(--v3-coral-dark);
  border-color: var(--v3-coral-dark);
}

:host .project-settings-v3__generation {
  color: #59645e;
  background: #fff;
  border: 1px solid #d9dfda;
}

:host .project-settings-v3__generation:hover {
  color: #285f52;
  background: #f3f7f3;
  border-color: #b7c8bd;
}

:host .project-settings-v3__secondary {
  color: #59645e;
  background: #fff;
  border: 1px solid #d9dfda;
}

:host .project-settings-v3__reset {
  min-height: 28px !important;
  color: #a0a8a3;
  background: transparent;
  border: 0;
  font-size: 12px !important;
}

:host .project-settings-v3 button:focus-visible {
  outline: 2px solid rgba(230, 91, 53, 0.38);
  outline-offset: 2px;
}

@media (max-width: 1120px) {
  :host .project-settings-v3 {
    grid-template-columns: minmax(0, 1fr);
  }
  :host .project-settings-v3__inspector {
    position: static;
  }
  :host .project-settings-v3__checklist {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 720px) {
  :host .project-settings-v3__steps {
    min-height: 64px;
    padding: 0 8px;
  }
  :host .project-settings-v3__steps button {
    gap: 6px;
    padding: 0 6px;
  }
  :host .project-settings-v3__content {
    padding: 24px 18px;
  }
  :host .project-settings-v3__content-head {
    flex-direction: column;
  }
  :host .project-settings-v3__field {
    grid-template-columns: 38px minmax(0, 1fr) 12px;
  }
  :host .project-settings-v3__field-state {
    display: none;
  }
  :host .project-settings-v3__preview,
  :host .project-settings-v3__checklist {
    grid-template-columns: 1fr;
  }
  :host .project-settings-v3__result {
    grid-template-columns: 48px minmax(0, 1fr);
  }
  :host .project-settings-v3__result button {
    grid-column: 1/-1;
    justify-content: center;
  }
}
/* Project settings — selected concept 01: single-page inline editor. */
:host .project-settings-page-title__back {
  place-items: center;
  color: #4f5b54;
  background: #fff;
  border: 1px solid #d9dfda;
  transition: color 0.16s ease, background-color 0.16s ease, border-color 0.16s ease, transform 0.16s ease;
}

:host .project-settings-page-title__back:hover {
  color: #285f52;
  background: #f3f7f3;
  border-color: #b9c9be;
}

:host .project-settings-page-title__back:focus-visible {
  outline: 2px solid rgba(230, 91, 53, 0.38);
  outline-offset: 2px;
}

:host .review-workspace:has(.project-settings-inline) {
  min-height: 100%;
  color: #27302b;
  background: #f7f7f3;
}

:host .project-settings-inline {
  --settings-coral: #e65b35;
  --settings-coral-dark: #c94725;
  --settings-ink: #252c28;
  --settings-muted: #7d8781;
  --settings-line: #dfe5df;
  --settings-sage: #66845d;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 318px;
  gap: 20px;
  width: 100%;
  outline: 0;
}

:host .project-settings-inline__form,
:host .project-settings-inline__summary {
  min-width: 0;
  background: #fff;
  border: 1px solid var(--settings-line);
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(48, 59, 52, 0.045);
}

:host .project-settings-inline__form {
  overflow: hidden;
}

:host .project-settings-inline__form-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 22px;
  padding: 26px 28px 22px;
  border-bottom: 1px solid var(--settings-line);
}

:host .project-settings-inline__form-head p {
  margin: 0 0 7px;
  color: var(--settings-coral);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.17em;
}

:host .project-settings-inline__form-head h2 {
  margin: 0;
  color: var(--settings-ink);
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.035em;
}

:host .project-settings-inline__form-head > div:first-child > span {
  display: block;
  margin-top: 7px;
  color: var(--settings-muted);
  font-size: 12px;
  line-height: 1.55;
}

:host .project-settings-inline__kind-switch {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  background: #f3f5f2;
  border: 1px solid var(--settings-line);
  border-radius: 9px;
}

:host .project-settings-inline__kind-switch button {
  min-width: 44px;
  height: 32px;
  padding: 0 12px;
  color: #7e8982;
  background: transparent;
  border: 0;
}

:host .project-settings-inline__kind-switch button.is-active {
  color: #fff;
  background: #456e63;
  box-shadow: 0 3px 8px rgba(69, 110, 99, 0.16);
}

:host .project-settings-inline__validation {
  margin: 20px 28px 0;
}

:host .project-settings-inline__section {
  margin: 0 28px;
  padding: 28px 0 24px;
  border-bottom: 0;
}

:host .project-settings-inline__section > header {
  margin-bottom: 15px;
}

:host .project-settings-inline__section > header h3 {
  margin: 0;
  color: var(--settings-ink);
  font-size: 19px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.03em;
}

:host .project-settings-inline__section > header p {
  margin: 6px 0 0;
  color: var(--settings-muted);
  font-size: 12px;
  line-height: 1.55;
}

:host .project-settings-inline__rows {
  overflow: hidden;
  border: 1px solid var(--settings-line);
  border-radius: 10px;
}

:host .project-settings-inline__rows--reviewers {
  position: relative;
  z-index: 2;
  overflow: visible;
}

:host .project-settings-inline__rows--reviewers > :first-child {
  border-radius: 9px 9px 0 0;
}

:host .project-settings-inline__rows--reviewers > :last-child {
  border-radius: 0 0 9px 9px;
}

:host .project-settings-inline__section:has(.project-reviewer-picker[open]) {
  position: relative;
  z-index: 5;
}

:host .project-settings-inline__resource {
  background: #fff;
  border-bottom: 1px solid var(--settings-line);
}

:host .project-settings-inline__resource:last-child {
  border-bottom: 0;
}

:host .project-settings-inline__resource.has-error {
  background: #fff9f7;
}

:host .project-settings-inline__resource summary,
:host .project-settings-inline__resource-summary {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto auto;
  gap: 14px;
  align-items: center;
  min-height: 78px;
  padding: 12px 16px;
  cursor: pointer;
  list-style: none;
  transition: background 0.16s ease;
}

:host .project-settings-inline__resource-summary {
  cursor: default;
}

:host .project-settings-inline__resource summary::-webkit-details-marker {
  display: none;
}

:host .project-settings-inline__resource summary:hover,
:host .project-settings-inline__resource[open] summary {
  background: #fafbf9;
}

:host .project-settings-inline__resource--fixed:hover .project-settings-inline__resource-summary {
  background: #fafbf9;
}

:host .project-settings-inline__resource[open] summary {
  border-bottom: 1px solid var(--settings-line);
}

:host .project-settings-inline__icon {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  color: #547391;
  background: #edf3f8;
  border-radius: 9px;
  font-size: 14px;
}

:host .project-settings-inline__icon.is-harness {
  color: #55745d;
  background: #eef5ee;
}

:host .project-settings-inline__icon.is-survey {
  color: #775f8b;
  background: #f3eff7;
}

:host .project-settings-inline__resource-copy {
  min-width: 0;
}

:host .project-settings-inline__resource-copy small,
:host .project-settings-inline__resource-copy strong,
:host .project-settings-inline__resource-copy em {
  display: block;
}

:host .project-settings-inline__resource-copy small {
  margin-bottom: 4px;
  color: #89938d;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__resource-copy strong {
  overflow: hidden;
  color: #303834;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-settings-inline__resource-copy em {
  overflow: hidden;
  margin-top: 4px;
  color: #8b948f;
  font-size: 12px;
  font-style: normal;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-settings-inline__preview-trigger {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 9px;
  padding: 0;
  border: 0;
  color: inherit;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

:host .project-settings-inline__preview-trigger strong {
  min-width: 0;
  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 3px;
  transition: color 0.16s ease, text-decoration-color 0.16s ease;
}

:host .project-settings-inline__preview-trigger > span {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  color: #607663;
  background: #edf4ec;
  white-space: nowrap;
}

:host .project-settings-inline__preview-trigger:hover strong,
:host .project-settings-inline__preview-trigger:focus-visible strong {
  color: #48674e;
  text-decoration-color: #91a593;
}

:host .project-settings-inline__preview-trigger:focus-visible {
  outline: 2px solid rgba(84, 116, 93, 0.32);
  outline-offset: 3px;
}

:host .project-settings-inline__state {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  color: #a9673d;
  background: #fff5e9;
  white-space: nowrap;
}

:host button.project-settings-inline__state {
  border: 0;
  font-family: inherit;
}

:host .project-settings-inline__state.is-action {
  cursor: pointer;
  transition: background 0.16s ease, box-shadow 0.16s ease, color 0.16s ease;
}

:host .project-settings-inline__state.is-action:hover,
:host .project-settings-inline__state.is-action:focus-visible {
  color: #98532f;
  background: #ffead6;
  box-shadow: 0 0 0 3px rgba(185, 105, 57, 0.11);
  outline: 0;
}

:host .project-settings-inline__state.is-ready {
  color: #587652;
  background: #eff6ec;
}

:host .project-settings-inline__change {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 66px;
  height: 36px;
  padding: 0 14px;
  color: #57645d;
  background: #fff;
  border: 1px solid #d5ddd7;
  cursor: pointer;
}

:host .project-settings-inline__change:hover:not(:disabled),
:host .project-settings-inline__change:focus-visible {
  color: #456b51;
  border-color: #8da794;
  background: #f6faf6;
}

:host .project-settings-inline__change:disabled {
  color: #aeb5b0;
  background: #f6f7f5;
  cursor: not-allowed;
}

:host .project-settings-inline__resource-editor {
  padding: 18px 72px 20px;
  background: #fbfcfa;
}

:host .project-settings-inline__resource-editor > label,
:host .project-settings-inline__editor-label label {
  color: #4d5851;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__editor-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

:host .project-settings-inline__editor-label a {
  color: #56755d;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__resource-editor > select {
  width: 100%;
  min-height: 44px;
  margin-top: 8px;
  padding: 0 12px;
  color: #303834;
  background: #fff;
  border: 1px solid #d7ded8;
  border-radius: 8px;
  outline: 0;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline select:focus,
:host .project-settings-inline input:focus {
  border-color: #657f60 !important;
  box-shadow: 0 0 0 3px rgba(101, 127, 96, 0.12);
}

:host .project-settings-inline__scope {
  margin-top: 17px;
  padding-top: 16px;
  border-top: 1px solid var(--settings-line);
}

:host .project-settings-inline__scope > p {
  margin: 0 0 8px;
  color: #4d5851;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__scope > div[role=group] {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

:host .project-settings-inline__scope > div[role=group] button {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  gap: 9px;
  align-items: center;
  min-height: 58px;
  padding: 9px 11px;
  text-align: left;
  color: #69746d;
  background: #fff;
  border: 1px solid #dce2dd;
}

:host .project-settings-inline__scope > div[role=group] button > i {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  color: #728078;
  background: #f1f4f1;
  border-radius: 7px;
}

:host .project-settings-inline__scope > div[role=group] button strong,
:host .project-settings-inline__scope > div[role=group] button small {
  display: block;
}

:host .project-settings-inline__scope > div[role=group] button small {
  margin-top: 2px;
  color: #929b95;
}

:host .project-settings-inline__scope > div[role=group] button.is-active {
  color: #4e684b;
  background: #f4f8f1;
  border-color: #8fa38a;
  box-shadow: inset 0 0 0 1px rgba(111, 139, 104, 0.18);
}

:host .project-settings-inline__collections {
  display: grid;
  gap: 7px;
  margin-top: 10px;
}

:host .project-settings-inline__collections button {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
  min-height: 54px;
  padding: 9px 12px;
  text-align: left;
  color: #59645e;
  background: #fff;
  border: 1px solid #dfe4df;
}

:host .project-settings-inline__collections button strong,
:host .project-settings-inline__collections button small {
  display: block;
}

:host .project-settings-inline__collections button small {
  margin-top: 3px;
  color: #909993;
}

:host .project-settings-inline__collections button b {
  white-space: nowrap;
}

:host .project-settings-inline__collections button.is-active {
  color: #4f6d4a;
  background: #f4f8f1;
  border-color: #8fa38a;
}

:host .project-settings-inline__number-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

:host .project-settings-inline__number-grid > label {
  min-width: 0;
  padding: 17px 18px;
}

:host .project-settings-inline__number-grid > label + label {
  border-left: 1px solid var(--settings-line);
}

:host .project-settings-inline__reviewer {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) minmax(230px, 0.7fr) auto;
  gap: 14px;
  align-items: center;
  min-height: 82px;
  padding: 14px 16px;
  border-top: 1px solid var(--settings-line);
  background: #fff;
}

:host .project-settings-inline__reviewer-icon {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  color: #4f6f64;
  background: #edf4f0;
  border-radius: 9px;
  font-size: 14px;
}

:host .project-settings-inline__reviewer-copy {
  display: grid;
  min-width: 0;
  gap: 3px;
}

:host .project-settings-inline__reviewer-copy small {
  color: #89938d;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__reviewer-copy strong {
  overflow: hidden;
  color: #303834;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-settings-inline__reviewer-copy em {
  overflow: hidden;
  color: #8b948f;
  font-size: 12px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-settings-inline__reviewer label {
  min-width: 0;
  margin: 0;
}

:host .project-settings-inline__reviewer-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  min-width: 0;
}

:host .project-reviewer-picker {
  position: relative;
  min-width: 0;
}

:host .project-reviewer-picker > summary {
  display: flex;
  height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 12px;
  color: #35403a;
  background: #fff;
  border: 1px solid #d8ded9;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  list-style: none;
}

:host .project-reviewer-picker > summary::-webkit-details-marker {
  display: none;
}

:host .project-reviewer-picker > summary i {
  color: #88938d;
  font-size: 12px;
  transition: transform 0.18s ease;
}

:host .project-reviewer-picker[open] > summary i {
  transform: rotate(180deg);
}

:host .project-reviewer-picker.is-disabled > summary {
  color: #9aa29d;
  background: #f5f6f4;
  pointer-events: none;
}

:host .project-reviewer-picker__options {
  position: absolute;
  z-index: 30;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  display: grid;
  max-height: 220px;
  overflow: auto;
  padding: 6px;
  background: #fff;
  border: 1px solid #d8ded9;
  border-radius: 9px;
  box-shadow: 0 14px 30px rgba(37, 48, 42, 0.14);
}

:host .project-reviewer-picker__options label {
  position: relative;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  gap: 9px;
  align-items: center;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
}

:host .project-reviewer-picker__options label:hover {
  background: #f3f7f4;
}

:host .project-reviewer-picker__input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

:host .project-reviewer-picker__checkbox {
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  color: transparent;
  background: #fff;
  border: 1px solid #91a096;
  border-radius: 5px;
  box-shadow: 0 0 0 3px rgba(85, 118, 95, 0.1);
  font-size: 12px;
  transition: color 0.14s ease, background-color 0.14s ease, border-color 0.14s ease;
}

:host .project-reviewer-picker__input:checked + .project-reviewer-picker__checkbox {
  color: #fff;
  background: #55765f;
  border-color: #55765f;
}

:host .project-reviewer-picker__input:focus-visible + .project-reviewer-picker__checkbox {
  outline: 2px solid rgba(85, 118, 95, 0.4);
  outline-offset: 2px;
}

:host .project-reviewer-picker__copy {
  display: grid;
  gap: 2px;
  min-width: 0;
}

:host .project-reviewer-picker__options label strong {
  color: #344039;
  font-size: 12px;
}

:host .project-reviewer-picker__options label small {
  overflow: hidden;
  color: #89918c;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-settings-inline__reviewer-save,
:host .project-setting-reviewer-save {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 13px;
  color: #fff;
  background: #55765f;
  border: 1px solid #55765f;
  cursor: pointer;
  white-space: nowrap;
}

:host .project-settings-inline__reviewer-save:disabled,
:host .project-setting-reviewer-save:disabled {
  color: #9aa29d;
  background: #f2f4f2;
  border-color: #dde2de;
  cursor: not-allowed;
}

:host .project-setting-field > .project-reviewer-picker {
  width: 100%;
}

:host .project-setting-reviewer-save {
  align-self: flex-start;
  margin-top: 9px;
}

:host .project-settings-inline__reviewer select {
  width: 100%;
  height: 42px;
  min-width: 0;
  padding: 0 34px 0 12px;
  color: #35403a;
  background: #fff;
  border: 1px solid #d8ded9;
  border-radius: 8px;
  outline: 0;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__reviewer select:focus {
  border-color: #657f60;
  box-shadow: 0 0 0 3px rgba(101, 127, 96, 0.12);
}

:host .project-settings-inline__reviewer select:disabled {
  color: #9aa29d;
  background: #f5f6f4;
  cursor: not-allowed;
}

:host .project-settings-inline__reviewer > a {
  color: #597268;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}

:host .project-settings-inline__reviewer > a:hover {
  text-decoration: underline;
}

:host .project-settings-inline__reviewer > .project-setting-field__error {
  grid-column: 3/-1;
  margin-top: -7px;
  color: #c65b44;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__reviewer.has-error select {
  border-color: #d96d55;
}

:host .project-settings-inline__number-grid > label > span,
:host .project-settings-inline__count > span {
  display: block;
  margin-bottom: 9px;
  color: #414a45;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__number-grid > label > div,
:host .project-settings-inline__count > div {
  position: relative;
  display: block;
  overflow: visible;
  min-height: 44px;
  background: transparent;
  border: 0;
  border-radius: 0;
}

:host .project-settings-inline__number-grid input,
:host .project-settings-inline__count input {
  appearance: textfield;
  width: 100%;
  height: 44px;
  min-width: 0;
  padding: 0 60px 0 12px;
  color: #29312d;
  background: #fff;
  border: 1px solid #d8ded9 !important;
  border-radius: 8px;
  outline: 0;
  box-shadow: none;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__number-grid input::-webkit-inner-spin-button,
:host .project-settings-inline__number-grid input::-webkit-outer-spin-button,
:host .project-settings-inline__count input::-webkit-inner-spin-button,
:host .project-settings-inline__count input::-webkit-outer-spin-button {
  margin: 0;
  appearance: none;
}

:host .project-settings-inline__number-grid em,
:host .project-settings-inline__count em {
  position: absolute;
  z-index: 1;
  top: 1px;
  right: 1px;
  bottom: 1px;
  display: grid;
  width: 48px;
  place-items: center;
  color: #748078;
  background: #f7f8f6;
  border-left: 1px solid #e1e5e1;
  border-radius: 0 7px 7px 0;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  pointer-events: none;
}

:host .project-settings-inline__number-grid > label > small,
:host .project-settings-inline__count > small {
  display: block;
  margin-top: 7px;
  color: #909994;
  font-size: 12px;
  line-height: 1.45;
}

:host .project-settings-inline__number-grid > label.has-error > div,
:host .project-settings-inline__count.has-error > div {
  border: 0;
}

:host .project-settings-inline__number-grid > label.has-error input,
:host .project-settings-inline__count.has-error input {
  border-color: #d96d55 !important;
}

:host .project-settings-inline__count {
  display: grid;
  grid-template-columns: 120px minmax(220px, 0.55fr) minmax(0, 1fr);
  gap: 15px;
  align-items: center;
  padding: 17px 18px;
}

:host .project-settings-inline__count > span,
:host .project-settings-inline__count > small {
  margin: 0;
}

:host .project-settings-inline__kg-output {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 18px;
}

:host .project-settings-inline__kg-output > i {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  color: #fff;
  background: #49786b;
  border-radius: 9px;
}

:host .project-settings-inline__kg-output span,
:host .project-settings-inline__kg-output strong,
:host .project-settings-inline__kg-output small {
  display: block;
}

:host .project-settings-inline__kg-output span {
  color: #89938d;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__kg-output strong {
  margin-top: 3px;
  color: #303834;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__kg-output small {
  margin-top: 4px;
  color: #909994;
  font-size: 12px;
}

:host .project-settings-inline__advanced {
  border-top: 1px solid var(--settings-line);
}

:host .project-settings-inline__advanced summary {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) 14px;
  gap: 14px;
  align-items: center;
  min-height: 58px;
  padding: 11px 18px;
  cursor: pointer;
  list-style: none;
}

:host .project-settings-inline__advanced summary::-webkit-details-marker {
  display: none;
}

:host .project-settings-inline__advanced summary > span {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #4d5851;
  font-size: 12px;
}

:host .project-settings-inline__advanced summary em {
  overflow: hidden;
  color: #87918b;
  font-size: 12px;
  font-style: normal;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-settings-inline__advanced summary > i {
  color: #7d8781;
  font-size: 12px;
  transition: transform 0.16s ease;
}

:host .project-settings-inline__advanced[open] summary > i {
  transform: rotate(180deg);
}

:host .project-settings-inline__advanced-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  padding: 18px;
  background: #fbfcfa;
  border-top: 1px solid var(--settings-line);
}

:host .project-settings-inline__advanced-grid label > span {
  display: block;
  margin-bottom: 7px;
  color: #4c5750;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__advanced-grid select {
  width: 100%;
  min-height: 42px;
  padding: 0 11px;
  color: #303834;
  background: #fff;
  border: 1px solid #d8ded9;
  border-radius: 8px;
  outline: 0;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__actions {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 17px 28px;
  background: rgba(255, 255, 255, 0.97);
  border-top: 1px solid var(--settings-line);
  box-shadow: 0 -8px 20px rgba(49, 60, 53, 0.035);
}

:host .project-settings-inline__actions > p {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #7f8983;
  font-size: 12px;
}

:host .project-settings-inline__actions > p i {
  color: #6d8068;
}

:host .project-settings-inline__actions > div {
  display: flex;
  gap: 9px;
}

:host .project-settings-inline__save,
:host .project-settings-inline__primary,
:host .project-settings-inline__result-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 42px;
  padding: 0 18px;
}

:host .project-settings-inline__save {
  color: #58635d;
  background: #fff;
  border: 1px solid #d6ddd8;
}

:host .project-settings-inline__primary {
  min-width: 218px;
  color: #fff;
  background: var(--settings-coral);
  border: 1px solid var(--settings-coral);
  box-shadow: 0 8px 18px rgba(230, 91, 53, 0.18);
}

:host .project-settings-inline__primary:hover {
  background: var(--settings-coral-dark);
  border-color: var(--settings-coral-dark);
}

:host .project-settings-inline__summary {
  position: sticky;
  top: 20px;
  align-self: start;
  padding: 24px 22px;
}

:host .project-settings-inline__summary > header {
  display: flex;
  align-items: center;
  gap: 13px;
}

:host .project-settings-inline__summary > header > span {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  flex: 0 0 44px;
  color: #7b8880;
  background: #f0f3ef;
  border: 1px solid #dde4dc;
  border-radius: 50%;
  font-size: 15px;
}

:host .project-settings-inline__summary > header > span.is-ready {
  color: #fff;
  background: #668a43;
  border-color: #668a43;
}

:host .project-settings-inline__summary > header h2 {
  margin: 0;
  color: var(--settings-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

:host .project-settings-inline__summary > header p {
  margin: 4px 0 0;
  color: #89938d;
  font-size: 12px;
}

:host .project-settings-inline__completion {
  display: flex;
  gap: 10px;
  margin: 20px 0;
  padding: 14px;
  color: #8a6d46;
  background: #fff8ee;
  border: 1px solid #eadbc3;
  border-radius: 9px;
}

:host .project-settings-inline__completion.is-ready {
  color: #58754f;
  background: #f2f8ee;
  border-color: #d6e4cf;
}

:host .project-settings-inline__completion > i {
  margin-top: 2px;
}

:host .project-settings-inline__completion strong,
:host .project-settings-inline__completion p {
  display: block;
}

:host .project-settings-inline__completion strong {
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__completion p {
  margin: 4px 0 0;
  color: inherit;
  opacity: 0.76;
  font-size: 12px;
}

:host .project-settings-inline__summary > section {
  padding: 18px 0;
  border-top: 1px solid var(--settings-line);
}

:host .project-settings-inline__summary > section h3 {
  margin: 0 0 12px;
  color: #46514b;
  font-size: 12px;
  font-weight: 700;
}

:host .project-settings-inline__summary dl,
:host .project-settings-inline__summary dl > div {
  margin: 0;
}

:host .project-settings-inline__summary dl {
  display: grid;
  gap: 11px;
}

:host .project-settings-inline__summary dl > div {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 10px;
  font-size: 12px;
  line-height: 1.45;
}

:host .project-settings-inline__summary dt {
  color: #919a94;
}

:host .project-settings-inline__summary dd {
  overflow-wrap: anywhere;
  margin: 0;
  color: #3e4943;
  font-weight: 700;
}

:host .project-settings-inline__summary-note {
  margin: 1px 0 0;
  padding-top: 17px;
  color: #8c9690;
  border-top: 1px solid var(--settings-line);
  font-size: 12px;
  line-height: 1.6;
}

:host .project-settings-inline__result-button {
  width: 100%;
  margin-top: 14px;
  color: #fff;
  background: #456e63;
  border: 1px solid #456e63;
}

:host .project-settings-inline button,
:host .project-settings-inline summary,
:host .project-settings-inline select,
:host .project-settings-inline input {
  font-family: inherit;
}

:host .project-settings-inline button:focus-visible,
:host .project-settings-inline summary:focus-visible,
:host .project-settings-inline select:focus-visible,
:host .project-settings-inline input:focus-visible {
  outline: 2px solid rgba(230, 91, 53, 0.38);
  outline-offset: 2px;
}

/* Overlay the unit suffix on one bordered input to avoid a nested frame. */
:host .project-settings-inline__number-grid > label > div,
:host .project-settings-inline__count > div {
  transition: none;
}

:host .project-settings-inline__number-grid > label > div:focus-within,
:host .project-settings-inline__count > div:focus-within {
  background: transparent;
  border: 0;
  box-shadow: none;
}

:host .project-settings-inline__number-grid input:focus,
:host .project-settings-inline__number-grid input:focus-visible,
:host .project-settings-inline__count input:focus,
:host .project-settings-inline__count input:focus-visible {
  border: 1px solid #657f60 !important;
  border-radius: 8px;
  outline: 0 !important;
  box-shadow: 0 0 0 3px rgba(101, 127, 96, 0.12) !important;
}

@media (max-width: 1120px) {
  :host .project-settings-inline {
    grid-template-columns: minmax(0, 1fr);
  }
  :host .project-settings-inline__summary {
    position: static;
    display: grid;
    grid-template-columns: minmax(230px, 0.8fr) minmax(0, 1fr) minmax(0, 1fr);
    gap: 18px;
    align-items: start;
  }
  :host .project-settings-inline__summary > header,
  :host .project-settings-inline__completion {
    margin: 0;
  }
  :host .project-settings-inline__summary > section {
    padding: 0;
    border-top: 0;
  }
  :host .project-settings-inline__summary-note,
  :host .project-settings-inline__result-button {
    grid-column: 1/-1;
  }
}
@media (max-width: 760px) {
  :host .project-settings-inline__form-head,
  :host .project-settings-inline__actions {
    align-items: stretch;
    flex-direction: column;
  }
  :host .project-settings-inline__form-head,
  :host .project-settings-inline__section,
  :host .project-settings-inline__validation {
    margin-inline: 18px;
  }
  :host .project-settings-inline__form-head {
    margin-inline: 0;
    padding: 22px 18px;
  }
  :host .project-settings-inline__kind-switch {
    align-self: flex-start;
  }
  :host .project-settings-inline__resource summary,
  :host .project-settings-inline__resource-summary {
    grid-template-columns: 40px minmax(0, 1fr) auto;
    padding-inline: 12px;
  }
  :host .project-settings-inline__state {
    display: none;
  }
  :host .project-settings-inline__resource-editor {
    padding: 16px;
  }
  :host .project-settings-inline__scope > div[role=group],
  :host .project-settings-inline__number-grid,
  :host .project-settings-inline__advanced-grid,
  :host .project-settings-inline__summary {
    grid-template-columns: minmax(0, 1fr);
  }
  :host .project-settings-inline__number-grid > label + label {
    border-top: 1px solid var(--settings-line);
    border-left: 0;
  }
  :host .project-settings-inline__reviewer {
    grid-template-columns: 40px minmax(0, 1fr);
  }
  :host .project-settings-inline__reviewer label,
  :host .project-settings-inline__reviewer-controls,
  :host .project-settings-inline__reviewer > a,
  :host .project-settings-inline__reviewer > .project-setting-field__error {
    grid-column: 1/-1;
  }
  :host .project-settings-inline__reviewer-controls {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  :host .project-settings-inline__count {
    grid-template-columns: minmax(0, 1fr);
  }
  :host .project-settings-inline__advanced summary {
    grid-template-columns: minmax(0, 1fr) 14px;
  }
  :host .project-settings-inline__advanced summary em {
    display: none;
  }
  :host .project-settings-inline__actions {
    padding: 16px 18px;
  }
  :host .project-settings-inline__actions > div,
  :host .project-settings-inline__actions button {
    width: 100%;
  }
  :host .project-settings-inline__summary {
    padding: 20px 18px;
  }
}
/* Project source scope — Material Vault category and curated collection picker. */
:host .project-setting-modal:has(.project-setting-source-builder) {
  width: min(760px, 100vw - 32px);
  max-height: min(880px, 100dvh - 32px);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
}

:host .project-setting-modal:has(.project-setting-source-builder) > .project-setting-modal__header,
:host .project-setting-modal:has(.project-setting-source-builder) > .project-setting-modal__footer {
  position: relative;
  inset: auto;
}

:host .project-setting-modal:has(.project-setting-source-builder) > .project-setting-modal__body {
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

:host .project-setting-source-builder {
  min-width: 0;
  padding: 18px;
  background: #fbfcfa;
  border: 1px solid #e1e6df;
  border-radius: 13px;
}

:host .project-setting-source-builder.has-error {
  border-color: #df7a62;
  box-shadow: 0 0 0 3px rgba(223, 90, 50, 0.08);
}

:host .project-setting-source-builder > .project-setting-field__label {
  align-items: flex-end;
}

:host .project-setting-source-builder > .project-setting-field__label > span {
  color: #29312d;
  font-size: 12px;
  font-weight: 700;
}

:host .project-setting-source-builder > .project-setting-field__label > small {
  color: #8c958f;
  font-size: 12px;
  font-weight: 700;
}

:host .project-setting-source-builder > select {
  width: 100%;
  min-height: 46px;
  margin-top: 9px;
  padding: 0 13px;
  color: #2c342f;
  background: #fff;
  border: 1px solid #d9dfda;
  border-radius: 10px;
  outline: 0;
  font-size: 12px;
  font-weight: 700;
}

:host .project-setting-source-builder > select:focus {
  border-color: #657b5e;
  box-shadow: 0 0 0 4px rgba(101, 123, 94, 0.1);
}

:host .project-source-scope {
  margin-top: 17px;
  padding-top: 16px;
  border-top: 1px solid #e2e7e2;
}

:host .project-source-scope > p {
  margin: 0 0 9px;
  color: #4b554f;
  font-size: 12px;
  font-weight: 700;
}

:host .project-source-scope__options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

:host .project-source-scope__options > button {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  gap: 9px;
  align-items: center;
  min-width: 0;
  min-height: 62px;
  padding: 10px;
  text-align: left;
  color: #66716b;
  background: #fff;
  border: 1px solid #dfe4df;
  cursor: pointer;
}

:host .project-source-scope__options > button:hover {
  background: #f7f9f6;
  border-color: #c8d3c5;
}

:host .project-source-scope__options > button.is-active {
  color: #456345;
  background: #f0f6ed;
  border-color: #aebfa9;
  box-shadow: 0 0 0 2px rgba(103, 130, 94, 0.08);
}

:host .project-source-scope__options > button > i {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  color: #6a7d6a;
  background: #f1f4ef;
  border-radius: 7px;
  font-size: 12px;
}

:host .project-source-scope__options > button.is-active > i {
  color: #fff;
  background: #6c8466;
}

:host .project-source-scope__options strong,
:host .project-source-scope__options small {
  display: block;
}

:host .project-source-scope__options strong {
  color: #38423d;
  font-size: 12px;
  font-weight: 700;
}

:host .project-source-scope__options small {
  overflow: hidden;
  margin-top: 3px;
  color: #939c96;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-source-category,
:host .project-source-collection {
  margin-top: 14px;
  padding: 14px;
  background: #fff;
  border: 1px solid #e1e6e1;
  border-radius: 10px;
  outline: 0;
}

:host .project-source-category > header,
:host .project-source-collection > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

:host .project-source-category > header strong,
:host .project-source-collection > header strong {
  color: #3a443f;
  font-size: 12px;
  font-weight: 700;
}

:host .project-source-category > header span,
:host .project-source-collection > header span {
  color: #9aa29d;
  font-size: 12px;
  font-weight: 700;
}

:host .project-source-category > div {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

:host .project-source-category > div > button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  min-height: 52px;
  padding: 9px 11px;
  text-align: left;
  background: #fbfcfa;
  border: 1px solid #e5e9e5;
}

:host .project-source-category > div > button.is-active {
  background: #fff7f3;
  border-color: #e8a78f;
}

:host .project-source-category button span {
  min-width: 0;
}

:host .project-source-category button strong,
:host .project-source-category button small {
  display: block;
}

:host .project-source-category button strong {
  color: #3f4944;
}

:host .project-source-category button small {
  overflow: hidden;
  margin-top: 3px;
  color: #939c96;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-source-category button em {
  color: #ad6a4f;
  font-style: normal;
  white-space: nowrap;
}

:host .project-source-collection > div {
  display: grid;
  gap: 7px;
}

:host .project-source-collection > div > button {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  min-width: 0;
  min-height: 62px;
  padding: 10px 12px;
  text-align: left;
  background: #fbfcfa;
  border: 1px solid #e5e9e5;
}

:host .project-source-collection > div > button.is-active {
  background: #f1f6ef;
  border-color: #aebfa9;
}

:host .project-source-collection__check {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  color: transparent;
  background: #fff;
  border: 1px solid #d8ded9;
  border-radius: 50%;
  font-size: 12px;
}

:host button.is-active > .project-source-collection__check {
  color: #fff;
  background: #6d8567;
  border-color: #6d8567;
}

:host .project-source-collection__copy {
  min-width: 0;
}

:host .project-source-collection__copy strong,
:host .project-source-collection__copy small,
:host .project-source-collection__copy em {
  display: block;
}

:host .project-source-collection__copy strong {
  color: #37413c;
  font-size: 12px;
  font-weight: 700;
}

:host .project-source-collection__copy small {
  margin-top: 2px;
  color: #7f8983;
  font-size: 12px;
}

:host .project-source-collection__copy em {
  overflow: hidden;
  margin-top: 4px;
  color: #a0a7a3;
  font-size: 12px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .project-source-collection button > b {
  padding: 5px 7px;
  color: #5f735b;
  background: #e8f0e5;
  white-space: nowrap;
}

:host .project-source-summary {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  padding: 11px 12px;
  color: #537055;
  background: #f2f7ef;
  border-radius: 8px;
}

:host .project-source-summary > i {
  margin-top: 2px;
  font-size: 12px;
}

:host .project-source-summary strong {
  display: block;
  font-size: 12px;
  font-weight: 700;
}

:host .project-source-summary p {
  margin: 3px 0 0;
  color: #7c8b7c;
  font-size: 12px;
  line-height: 1.45;
}

:host .project-setting-source-builder > .project-setting-field__error {
  display: flex;
  margin-top: 8px;
}

@media (max-width: 700px) {
  :host .project-source-scope__options,
  :host .project-source-category > div {
    grid-template-columns: 1fr;
  }
  :host .project-setting-source-builder {
    padding: 14px;
  }
  :host .project-setting-source-builder > .project-setting-field__label,
  :host .project-source-category > header,
  :host .project-source-collection > header {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
}
/* QA generation — selected guided workspace direction */
:host main.is-generation-main.is-qa-generation-main {
  background: #f8f9f6;
}

:host main.is-generation-main .project-output-workspace__layout.is-qa {
  display: grid;
  grid-template-areas: "flow" "materials" "command";
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(560px, 1fr) auto;
  min-height: calc(100vh - 74px);
  background: transparent;
  box-shadow: none;
}

:host .qa-generation-flow {
  grid-area: flow;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 44px;
  margin: 0;
  padding: 28px 80px 26px;
  background: #fff;
  border-bottom: 1px solid #e2e6e0;
  list-style: none;
}

:host .qa-generation-flow li {
  position: relative;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
  min-width: 0;
  color: #929992;
}

:host .qa-generation-flow li:not(:last-child)::after {
  position: absolute;
  top: 16px;
  right: -30px;
  width: 36px;
  border-top: 1px dashed #d4dad3;
  content: "";
}

:host .qa-generation-flow li > span {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 1px solid #d6dbd4;
  border-radius: 999px;
  color: #757d75;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-flow strong,
:host .qa-generation-flow small {
  display: block;
}

:host .qa-generation-flow strong {
  margin-top: 1px;
  color: #596159;
  font-size: 13px;
  font-weight: 700;
}

:host .qa-generation-flow small {
  margin-top: 5px;
  font-size: 12px;
  line-height: 1.45;
}

:host .qa-generation-flow li.is-active > span,
:host .qa-generation-flow li.is-complete > span {
  color: #fff;
  background: #2f735b;
  border-color: #2f735b;
  box-shadow: 0 4px 10px rgba(47, 115, 91, 0.18);
}

:host .qa-generation-flow li.is-active strong,
:host .qa-generation-flow li.is-complete strong {
  color: #263128;
}

:host main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials {
  grid-area: materials;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  grid-auto-rows: auto;
  min-height: 560px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e0e4de;
  border-bottom: 0;
  box-shadow: none;
}

:host main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials > :not(.qa-generation-categories) {
  grid-column: 2;
}

:host .qa-generation-categories {
  grid-column: 1;
  grid-row: 1/10;
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 26px 18px 16px;
  background: #fbfcf9;
  border-right: 1px solid #e2e6e0;
}

:host .qa-generation-categories header {
  padding: 0 4px 18px;
}

:host .qa-generation-categories h3 {
  margin: 0;
  color: #252b26;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

:host .qa-generation-categories p {
  margin: 7px 0 0;
  color: #8b928b;
  font-size: 12px;
  line-height: 1.45;
}

:host .qa-generation-categories > button,
:host .qa-generation-categories footer button {
  display: flex;
  width: 100%;
  min-height: 46px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 12px;
  border: 0;
  color: #596159;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

:host .qa-generation-categories > button:hover {
  background: #f2f5ef;
}

:host .qa-generation-categories > button.is-active {
  color: #2e6e58;
  background: #edf3ee;
}

:host .qa-generation-categories > button strong {
  display: grid;
  min-width: 28px;
  height: 22px;
  place-items: center;
  padding: 0 7px;
  color: #747c74;
  background: #e9ece7;
}

:host .qa-generation-categories > button.is-active strong {
  color: #2e6e58;
  background: #dce9df;
}

:host .qa-generation-categories footer {
  margin-top: auto;
  padding-top: 16px;
}

:host .qa-generation-categories footer button {
  justify-content: center;
  border: 1px solid #d7dcd5;
  color: #6f776f;
  background: #fff;
}

:host main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__filters {
  grid-template-columns: minmax(260px, 1fr) auto;
  min-height: 82px;
  align-items: center;
  gap: 18px;
  padding: 18px 22px;
  border-bottom: 1px solid #e2e6e0;
  box-shadow: none;
}

:host main.is-generation-main .project-output-workspace__layout.is-qa .project-generation-field > span {
  display: none;
}

:host main.is-generation-main .project-output-workspace__layout.is-qa .project-generation-search {
  border-color: #d8ddd6;
  border-radius: 7px;
}

:host main.is-generation-main .project-output-workspace__layout.is-qa .project-generation-search input,
:host main.is-generation-main .project-output-workspace__layout.is-qa .project-generation-search button {
  min-height: 44px;
}

:host .qa-generation-source-tools {
  gap: 8px;
}

:host .qa-generation-source-tools button {
  min-height: 40px;
  padding: 0 13px;
  border: 1px solid #d5dbd4;
  box-shadow: none;
}

:host .qa-generation-source-tools button.is-refresh {
  width: 40px;
  border: 1px solid #d5dbd4;
}

:host .qa-generation-filter-panel {
  min-height: 40px;
  padding: 0 22px;
  background: #f8faf7;
  border-bottom: 1px solid #e2e6e0;
  box-shadow: none;
  font-size: 12px;
}

:host main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__source-panel {
  min-height: 500px;
  background: #fff;
}

:host .project-generation-source-table__head.is-qa,
:host main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
  grid-template-columns: 34px minmax(220px, 1.5fr) minmax(110px, 0.7fr) 124px 132px;
  gap: 12px;
  padding-right: 22px;
  padding-left: 22px;
}

:host .project-generation-source-table__head.is-qa {
  min-height: 44px;
  color: #687168;
  background: #fafbf9;
  box-shadow: inset 0 -1px #e2e6e0;
}

:host main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
  min-height: 58px;
  box-shadow: inset 0 -1px #e7eae5;
}

:host main.is-generation-main .project-output-workspace__source-panel.is-compact .project-output-workspace__source-list .project-generation-source.is-qa {
  min-height: 46px;
  padding-top: 6px;
  padding-bottom: 6px;
}

:host .qa-generation-source-error {
  display: grid;
  min-height: 450px;
  place-items: center;
  align-content: center;
  gap: 9px;
  padding: 40px;
  color: #818981;
  text-align: center;
}

:host .qa-generation-source-error > span {
  display: grid;
  width: 68px;
  height: 68px;
  margin-bottom: 6px;
  place-items: center;
  border-radius: 999px;
  color: #35735f;
  background: #eef3ef;
  font-size: 25px;
}

:host .qa-generation-source-error strong {
  color: #353c36;
  font-size: 14px;
  font-weight: 700;
}

:host .qa-generation-source-error p {
  margin: 0;
  font-size: 12px;
}

:host .qa-generation-source-error button {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 0 16px;
  border: 1px solid #e4714f;
  color: #c65332;
  background: #fff;
}

:host .qa-generation-review {
  min-height: 500px;
  padding: 28px 30px;
  background: #fff;
}

:host .qa-generation-review > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 22px;
  border-bottom: 1px solid #e4e7e2;
}

:host .qa-generation-review > header span,
:host .qa-generation-review > header h3,
:host .qa-generation-review > header p {
  display: block;
}

:host .qa-generation-review > header span {
  color: #39745f;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-review > header h3 {
  margin: 7px 0 0;
  color: #2e352f;
  font-size: 19px;
  font-weight: 700;
}

:host .qa-generation-review > header p {
  margin: 8px 0 0;
  color: #7f877f;
  font-size: 12px;
}

:host .qa-generation-review > header button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  gap: 8px;
  padding: 0 13px;
  border: 1px solid #d7dcd5;
  color: #606860;
  background: #fff;
}

:host .qa-generation-review__content {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 40px;
  padding-top: 26px;
}

:host .qa-generation-review__content section + section {
  padding-left: 40px;
  border-left: 1px solid #e4e7e2;
}

:host .qa-generation-review__content h4 {
  margin: 0 0 16px;
  color: #343b35;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-review__content dl,
:host .qa-generation-review__content ul {
  display: grid;
  gap: 12px;
  margin: 0;
  padding: 0;
}

:host .qa-generation-review__content dl > div,
:host .qa-generation-review__content li {
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr);
  gap: 14px;
  color: #596159;
  font-size: 12px;
}

:host .qa-generation-review__content dt {
  color: #8a928a;
}

:host .qa-generation-review__content dd {
  margin: 0;
  font-weight: 700;
}

:host .qa-generation-review__content ul {
  list-style: none;
}

:host .qa-generation-review__content li {
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
}

:host .qa-generation-review__content li i,
:host .qa-generation-review__content li strong {
  color: #b0b7b0;
}

:host .qa-generation-review__content li.is-complete i,
:host .qa-generation-review__content li.is-complete strong {
  color: #34745d;
}

:host .qa-generation-review__content li strong {
  font-size: 12px;
}

:host .qa-generation-setup {
  grid-area: materials;
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  min-height: 250px;
  align-items: center;
  gap: 18px;
  padding: 40px;
  background: #fff;
  border: 1px solid #e0e4de;
}

:host .qa-generation-setup > i {
  display: grid;
  width: 48px;
  height: 48px;
  place-items: center;
  border-radius: 12px;
  color: #39745f;
  background: #edf3ee;
}

:host .qa-generation-setup h3 {
  margin: 0;
  color: #303731;
  font-size: 16px;
  font-weight: 700;
}

:host .qa-generation-setup p {
  margin: 7px 0 0;
  color: #7d857d;
  font-size: 12px;
}

:host .qa-generation-setup button {
  min-height: 42px;
  padding: 0 16px;
  color: #fff;
  background: #2f735b;
}

:host .qa-generation-command-bar {
  position: sticky;
  bottom: 0;
  z-index: 8;
  grid-area: command;
  display: grid;
  grid-template-columns: 170px 170px minmax(260px, 1fr) auto;
  min-height: 100px;
  align-items: center;
  gap: 0;
  padding: 15px 22px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid #e0e4de;
  box-shadow: 0 -8px 22px rgba(34, 47, 37, 0.06);
}

:host .qa-generation-command-bar__metric,
:host .qa-generation-command-bar__progress {
  min-width: 0;
  padding: 0 22px;
  border-right: 1px solid #e3e6e1;
}

:host .qa-generation-command-bar__metric:first-child {
  padding-left: 0;
}

:host .qa-generation-command-bar__metric span,
:host .qa-generation-command-bar__metric strong,
:host .qa-generation-command-bar__progress span,
:host .qa-generation-command-bar__progress strong {
  display: block;
}

:host .qa-generation-command-bar__metric span,
:host .qa-generation-command-bar__progress span {
  color: #7e867e;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-command-bar__metric strong {
  margin-top: 7px;
  color: #2d6f58;
  font-size: 22px;
  font-weight: 700;
}

:host .qa-generation-command-bar__progress strong {
  margin-top: 6px;
  color: #4c544c;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-command-bar__progress > i {
  display: block;
  height: 4px;
  margin-top: 9px;
  overflow: hidden;
  border-radius: 999px;
  background: #e7ebe6;
}

:host .qa-generation-command-bar__progress > i b {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #34745d;
}

:host .qa-generation-command-bar__actions {
  display: flex;
  gap: 10px;
  padding-left: 22px;
}

:host .qa-generation-command-bar__actions button {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 17px;
  white-space: nowrap;
}

:host .qa-generation-command-bar__actions .is-secondary {
  color: #5e665e;
  background: #fff;
  border: 1px solid #d5dbd4;
}

:host .qa-generation-command-bar__actions .is-primary {
  min-width: 190px;
  color: #fff;
  background: #2f735b;
}

:host .qa-generation-command-bar__actions .is-primary:disabled {
  color: #a7aea7;
  background: #e5e8e3;
  cursor: not-allowed;
}

@media (max-width: 1180px) {
  :host .qa-generation-flow {
    padding-inline: 40px;
  }
  :host main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials {
    grid-template-columns: 190px minmax(0, 1fr);
  }
  :host .project-generation-source-table__head.is-qa,
  :host main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
    grid-template-columns: 32px minmax(170px, 1.4fr) 100px 105px 112px;
    gap: 8px;
  }
  :host .qa-generation-command-bar {
    grid-template-columns: 140px 140px minmax(220px, 1fr) auto;
    padding-inline: 18px;
  }
  :host .qa-generation-command-bar__actions .is-primary {
    min-width: 160px;
  }
}
@media (max-width: 900px) {
  :host .qa-generation-flow {
    gap: 18px;
    padding: 22px 20px;
  }
  :host .qa-generation-flow li:not(:last-child)::after {
    display: none;
  }
  :host main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials {
    grid-template-columns: minmax(0, 1fr);
  }
  :host main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__materials > :not(.qa-generation-categories) {
    grid-column: 1;
  }
  :host .qa-generation-categories {
    grid-column: 1;
    grid-row: auto;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
    padding: 18px;
    border-right: 0;
    border-bottom: 1px solid #e2e6e0;
  }
  :host .qa-generation-categories header,
  :host .qa-generation-categories footer {
    grid-column: 1/-1;
  }
  :host .qa-generation-categories footer {
    display: none;
  }
  :host .qa-generation-command-bar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 0;
  }
  :host .qa-generation-command-bar__progress,
  :host .qa-generation-command-bar__actions {
    grid-column: 1/-1;
  }
  :host .qa-generation-command-bar__metric:nth-child(2) {
    border-right: 0;
  }
  :host .qa-generation-command-bar__actions {
    padding-left: 0;
  }
  :host .qa-generation-command-bar__actions button {
    flex: 1;
  }
}
@media (max-width: 640px) {
  :host .qa-generation-flow {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  :host .qa-generation-flow li {
    grid-template-columns: 30px minmax(0, 1fr);
  }
  :host .qa-generation-flow li > span {
    width: 30px;
    height: 30px;
  }
  :host .qa-generation-categories {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host main.is-generation-main .project-output-workspace__layout.is-qa .project-output-workspace__filters {
    grid-template-columns: minmax(0, 1fr);
  }
  :host .qa-generation-source-tools {
    justify-content: stretch;
  }
  :host .qa-generation-source-tools button:not(.is-refresh) {
    flex: 1;
  }
  :host .project-generation-source-table__head.is-qa,
  :host main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa {
    grid-template-columns: 30px minmax(0, 1fr) 100px;
  }
  :host .project-generation-source-table__head.is-qa > :nth-child(3),
  :host .project-generation-source-table__head.is-qa > :nth-child(4),
  :host main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa > :nth-child(3),
  :host main.is-generation-main .project-output-workspace__source-list .project-generation-source.is-qa > :nth-child(4) {
    display: none;
  }
  :host .qa-generation-review__content {
    grid-template-columns: minmax(0, 1fr);
    gap: 28px;
  }
  :host .qa-generation-review__content section + section {
    padding: 28px 0 0;
    border-top: 1px solid #e4e7e2;
    border-left: 0;
  }
  :host .qa-generation-command-bar {
    position: static;
  }
}
/* QA generation workspace shares the project settings visual language. */
:host .qa-generation-v2,
:host .qa-generation-v2 *,
:host .qa-generation-v2 *::before,
:host .qa-generation-v2 *::after {
  box-sizing: border-box;
}

:host .qa-generation-v2__toolbar,
:host .qa-generation-v2__setup,
:host .qa-generation-v2__overview,
:host .qa-generation-v2__catalog,
:host .qa-generation-v2__review-panel,
:host .qa-generation-v2__message,
:host .qa-generation-v2__progress,
:host .qa-generation-v2__actions {
  overflow: hidden;
  border: 1px solid #dfe4dd !important;
  box-shadow: none !important;
}

:host .qa-generation-v2__toolbar {
  padding: 20px 22px;
}

:host .qa-generation-v2__toolbar-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

:host .qa-generation-v2__result-button {
  height: 36px;
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 13px;
  color: #fff;
  background: #456e63;
  border: 1px solid #456e63;
  box-shadow: none;
  letter-spacing: 0;
  white-space: nowrap;
  cursor: pointer;
}

:host .qa-generation-v2__result-button i:first-child {
  font-size: 12px;
}

:host .qa-generation-v2__result-button i:last-child {
  margin-left: 1px;
  font-size: 12px;
}

:host .qa-generation-v2__result-button:hover {
  background: #365a51;
  border-color: #365a51;
}

:host .qa-generation-v2__result-button:focus-visible {
  outline: 3px solid rgba(69, 110, 99, 0.2);
  outline-offset: 2px;
}

:host .qa-generation-v2__back,
:host .qa-generation-v2__settings-button,
:host .qa-generation-v2__refresh,
:host .qa-generation-v2__catalog-actions button,
:host .qa-generation-v2__pagination button,
:host .qa-generation-v2__pagination select,
:host .qa-generation-v2__review-panel header button,
:host .qa-generation-v2__message button,
:host .qa-generation-v2__action-buttons button {
  color: #47544c !important;
  border-width: 1px !important;
  border-color: #d5dcd5 !important;
  box-shadow: none !important;
}

:host .qa-generation-v2__back:hover,
:host .qa-generation-v2__settings-button:hover,
:host .qa-generation-v2__refresh:hover:not(:disabled),
:host .qa-generation-v2__catalog-actions button:hover,
:host .qa-generation-v2__catalog-actions button.is-active,
:host .qa-generation-v2__review-panel header button:hover {
  color: #456e63 !important;
  background: #f3f6f3 !important;
  border-color: #b9c8be !important;
}

:host .qa-generation-v2__heading > div > span,
:host .qa-generation-v2__section-header > div > span,
:host .qa-generation-v2__review-panel header > div > span {
  color: #e65b35;
}

:host .qa-generation-v2__section-header button span,
:host .qa-generation-v2__review-panel header button span {
  display: inline;
  margin: 0;
  color: inherit;
  letter-spacing: 0;
}

:host .qa-generation-v2__overview-card small,
:host .qa-generation-v2__overview-card p,
:host .qa-generation-v2__catalog-summary,
:host .qa-generation-v2__section-header p,
:host .qa-generation-v2__heading p,
:host .qa-generation-v2__review-panel dt,
:host .qa-generation-v2__readiness p {
  color: #6e7971;
}

:host .qa-generation-v2__overview-card strong b,
:host .qa-generation-v2__pagination nav strong,
:host .qa-generation-v2__review-panel header > strong {
  color: #456e63;
}

:host .qa-generation-v2__overview-card {
  border-width: 0 0 0 1px !important;
  border-color: #e5e9e4 !important;
  box-shadow: none !important;
}

:host .qa-generation-v2__overview-card:first-child {
  border-left: 0 !important;
}

:host .qa-generation-v2__catalog > *,
:host .qa-generation-v2__table,
:host .qa-generation-v2__table-head,
:host .qa-generation-v2__table-row,
:host .qa-generation-v2__pagination {
  width: 100%;
  max-width: 100%;
}

:host .qa-generation-v2__section-header,
:host .qa-generation-v2__catalog-tools,
:host .qa-generation-v2__catalog-summary,
:host .qa-generation-v2__table-head,
:host .qa-generation-v2__table-row {
  border-width: 0 0 1px !important;
  border-color: #e5e9e4 !important;
  box-shadow: none !important;
}

:host .qa-generation-v2__search {
  overflow: hidden;
  border: 1px solid #d4dcd5 !important;
  box-shadow: none !important;
}

:host .qa-generation-v2__search input {
  color: #354139;
  border: 0 !important;
  box-shadow: none !important;
}

:host .qa-generation-v2__search input::placeholder {
  color: #879188;
}

:host .qa-generation-v2__search button {
  color: #2d685a !important;
  border-width: 0 0 0 1px !important;
  border-color: #d4dcd5 !important;
  box-shadow: none !important;
}

:host .qa-generation-v2__review-panel dl,
:host .qa-generation-v2__review-panel dl > div {
  border-color: #e5e9e4 !important;
  border-width: 1px !important;
  box-shadow: none !important;
}

:host .qa-generation-v2__review-panel dl {
  border-width: 1px 0 0 1px !important;
}

:host .qa-generation-v2__review-panel dl > div {
  border-width: 0 1px 1px 0 !important;
}

:host .qa-generation-v2__pagination {
  border: 0 !important;
}

:host .qa-generation-v2__actions {
  border-color: #d7ddd7 !important;
  backdrop-filter: none;
}

:host .qa-generation-v2__action-buttons button.is-primary,
:host .qa-generation-v2__action-buttons button.is-primary:hover:not(:disabled) {
  color: #fff !important;
  background: #e65b35 !important;
  border-color: #e65b35 !important;
}

@media (max-width: 1180px) {
  :host .qa-generation-v2__overview-card.is-source {
    border-width: 0 0 1px !important;
  }
  :host .qa-generation-v2__overview-card:nth-child(2) {
    border-left: 0 !important;
  }
}
@media (max-width: 640px) {
  :host .qa-generation-v2__overview-card,
  :host .qa-generation-v2__overview-card:nth-child(2) {
    border-width: 1px 0 0 !important;
  }
  :host .qa-generation-v2__overview-card:first-child {
    border-top: 0 !important;
  }
}
/* QA generation aligned with the project settings workspace. */
:host main.is-generation-main.is-qa-generation-main {
  background: #f7f7f3;
}

:host main.is-qa-generation-main .project-output-settings {
  width: 100%;
  max-width: 1450px;
  min-height: 0;
  margin: 0 auto;
  padding: 0;
}

:host main.is-qa-generation-main .project-output-workspace {
  max-width: none;
}

:host .qa-generation-v2 {
  --qa-green: #456e63;
  --qa-green-dark: #365a51;
  --qa-orange: #e65b35;
  --qa-ink: #27302b;
  --qa-muted: #7d8781;
  --qa-line: #dfe5df;
  --qa-survey-line: #dfe5df;
  --qa-survey-soft-line: #edf0ec;
  --qa-survey-surface: #fff;
  --qa-survey-ink: #27302b;
  --qa-survey-muted: #7d8781;
  --qa-survey-sage: #456e63;
  --qa-survey-coral: #e65b35;
  gap: 20px;
  max-width: none;
  color: var(--qa-survey-ink);
}

:host .qa-generation-v2__toolbar,
:host .qa-generation-v2__setup,
:host .qa-generation-v2__overview,
:host .qa-generation-v2__catalog,
:host .qa-generation-v2__review-panel,
:host .qa-generation-v2__message,
:host .qa-generation-v2__progress,
:host .qa-generation-v2__actions {
  border: 1px solid var(--qa-survey-line) !important;
  border-radius: 12px !important;
  background: var(--qa-survey-surface);
  box-shadow: 0 12px 28px rgba(48, 59, 52, 0.045) !important;
}

:host .qa-generation-v2__toolbar {
  min-height: 100px;
  padding: 22px 24px;
}

:host .qa-generation-v2__back {
  width: 42px;
  height: 42px;
  border-radius: 9px !important;
  background: #f7f8f6;
}

:host .qa-generation-v2__heading {
  gap: 15px;
}

:host .qa-generation-v2__heading > div > span,
:host .qa-generation-v2__section-header > div > span,
:host .qa-generation-v2__review-panel header > div > span {
  color: var(--qa-survey-coral);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

:host .qa-generation-v2__heading h2 {
  font-size: 19px;
  letter-spacing: 0;
}

:host .qa-generation-v2__heading p,
:host .qa-generation-v2__section-header p {
  font-size: 12px;
  font-weight: 600;
}

:host .qa-generation-v2__settings-button,
:host .qa-generation-v2__refresh,
:host .qa-generation-v2__catalog-actions button,
:host .qa-generation-v2__pagination button,
:host .qa-generation-v2__pagination select,
:host .qa-generation-v2__review-panel header button,
:host .qa-generation-v2__message button,
:host .qa-generation-v2__action-buttons button {
  border-radius: 8px !important;
}

:host .qa-generation-v2__overview {
  grid-template-columns: minmax(330px, 1.28fr) repeat(3, minmax(150px, 1fr));
}

:host .qa-generation-v2__overview-card {
  position: relative;
  min-height: 126px;
  padding: 23px 22px;
  border-width: 0 0 0 1px !important;
  border-color: var(--qa-survey-soft-line) !important;
  background: #fff;
}

:host .qa-generation-v2__overview-card.is-source {
  min-height: 126px;
  padding: 24px 26px;
  border: 0 !important;
  color: var(--qa-survey-ink);
  background: #f4f8f1;
}

:host .qa-generation-v2__overview-card.is-source .qa-generation-v2__overview-icon {
  border: 1px solid #dbe7d8;
  color: var(--qa-survey-sage);
  background: #fff;
}

:host .qa-generation-v2__overview-card.is-source small,
:host .qa-generation-v2__overview-card.is-source p {
  color: #758078;
}

:host .qa-generation-v2__overview-card.is-source strong {
  color: var(--qa-survey-ink);
}

:host .qa-generation-v2__overview-card.is-source em {
  color: var(--qa-survey-sage);
}

:host .qa-generation-v2__catalog {
  overflow: hidden;
}

:host .qa-generation-v2__section-header {
  min-height: 100px;
  padding: 20px 24px;
  border-width: 0 0 1px !important;
  border-color: var(--qa-survey-soft-line) !important;
  background: #fff;
}

:host .qa-generation-v2__section-header > div:first-child {
  min-width: 260px;
}

:host .qa-generation-v2__catalog-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

:host .qa-generation-v2__catalog-title h3 {
  font-size: 18px;
  letter-spacing: 0;
}

:host .qa-generation-v2__catalog-title em {
  display: inline-grid;
  min-width: 28px;
  height: 22px;
  padding: 0 8px;
  place-items: center;
  border-radius: 8px !important;
  color: #6d736c;
  background: #f0f1ed;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

:host .qa-generation-v2__catalog-header-controls {
  display: grid;
  flex: 1;
  grid-template-columns: minmax(280px, 1fr) auto;
  gap: 10px;
  width: min(100%, 620px);
}

:host .qa-generation-v2__search {
  position: relative;
  height: 42px;
  display: flex;
  align-items: center;
  border: 1px solid #dcded8 !important;
  border-radius: 8px !important;
  background: #fbfbfa;
}

:host .qa-generation-v2__search:focus-within {
  border-color: #7f9a82 !important;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(101, 127, 96, 0.12) !important;
}

:host .qa-generation-v2__search > i {
  position: absolute;
  left: 14px;
  z-index: 1;
  color: #7f877f;
  font-size: 12px;
  pointer-events: none;
}

:host .qa-generation-v2__search input {
  width: 100%;
  height: 100%;
  padding: 0 40px 0 38px;
  color: #3e433e;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-v2__search button {
  position: absolute;
  right: 8px;
  width: 26px;
  height: 26px;
  border: 0 !important;
  color: #858b84 !important;
  background: #eff0ed;
}

:host .qa-generation-v2__refresh {
  min-width: 106px;
  height: 42px;
  min-height: 42px;
}

:host .qa-generation-v2__catalog-summary {
  min-height: 55px;
  padding: 8px 24px;
  border-width: 0 0 1px !important;
  border-color: var(--qa-survey-line) !important;
  background: #fafaf8;
}

:host .qa-generation-v2__catalog-summary > div:first-child {
  display: grid;
  gap: 3px;
}

:host .qa-generation-v2__catalog-summary p,
:host .qa-generation-v2__catalog-summary small {
  font-size: 12px;
}

:host .qa-generation-v2__catalog-actions button {
  min-width: 82px;
  height: 34px;
  background: transparent;
}

:host .qa-generation-v2__catalog-actions button.is-icon {
  min-width: 34px;
  width: 34px;
}

:host .qa-generation-v2__table-head {
  min-height: 44px;
  color: #777d76;
  background: #f6f7f4;
}

:host .qa-generation-v2__table-row {
  min-height: 68px;
  border-color: var(--qa-survey-soft-line) !important;
  background: #fff;
  transition: background 0.18s ease;
}

:host .qa-generation-v2__table-row:hover {
  background: #fafbf8;
}

:host .qa-generation-v2__row-title strong {
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-v2__row-title small {
  color: #949a93;
  font-size: 12px;
}

:host .qa-generation-v2__chunk {
  font-size: 12px;
}

:host .qa-generation-v2__pagination {
  min-height: 58px;
  padding: 0 24px;
  border: 0 !important;
  background: #fafaf8;
}

:host .qa-generation-v2__pagination nav button,
:host .qa-generation-v2__pagination select {
  border-radius: 7px !important;
}

:host .qa-generation-v2__review {
  gap: 18px;
}

:host .qa-generation-v2__review-panel {
  padding: 22px 24px;
}

:host .qa-generation-v2__review-panel dl {
  border-radius: 8px !important;
  overflow: hidden;
}

:host .qa-generation-v2__actions {
  position: static;
  min-height: 84px;
  padding: 16px 18px 16px 22px;
  backdrop-filter: none;
}

:host .qa-generation-v2__action-buttons button.is-primary {
  min-width: 180px;
  color: #fff !important;
  background: var(--qa-survey-coral) !important;
  border-color: var(--qa-survey-coral) !important;
  box-shadow: 0 6px 14px rgba(230, 91, 53, 0.16) !important;
}

:host .qa-generation-v2__action-buttons button.is-primary:hover:not(:disabled) {
  background: #c94725 !important;
  border-color: #c94725 !important;
}

@media (max-width: 1180px) {
  :host .qa-generation-v2__overview {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  :host .qa-generation-v2__overview-card.is-source {
    grid-column: 1/-1;
  }
  :host .qa-generation-v2__overview-card:nth-child(2) {
    border-left: 0 !important;
  }
}
@media (max-width: 900px) {
  :host .qa-generation-v2__section-header {
    align-items: stretch;
  }
  :host .qa-generation-v2__catalog-header-controls {
    width: 100%;
  }
  :host .qa-generation-v2__refresh {
    width: auto;
  }
}
@media (max-width: 640px) {
  :host .qa-generation-v2__toolbar,
  :host .qa-generation-v2__section-header,
  :host .qa-generation-v2__catalog-summary,
  :host .qa-generation-v2__actions {
    padding-right: 16px;
    padding-left: 16px;
  }
  :host .qa-generation-v2__catalog-header-controls {
    grid-template-columns: minmax(0, 1fr);
  }
  :host .qa-generation-v2__refresh {
    width: 100%;
  }
  :host .qa-generation-v2__catalog-summary {
    align-items: stretch;
  }
  :host .qa-generation-v2__catalog-actions {
    width: 100%;
  }
  :host .qa-generation-v2__catalog-actions button:first-child {
    flex: 1;
  }
}
/* Keep QA preparation in one settings-style workspace instead of stacked cards. */
:host .qa-generation-v2 {
  gap: 0;
  overflow: hidden;
  border: 1px solid var(--qa-survey-line);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(48, 59, 52, 0.045);
}

:host .qa-generation-v2 > .qa-generation-v2__toolbar,
:host .qa-generation-v2 > .qa-generation-v2__setup,
:host .qa-generation-v2 > .qa-generation-v2__overview,
:host .qa-generation-v2 > .qa-generation-v2__catalog,
:host .qa-generation-v2 > .qa-generation-v2__actions {
  margin: 0;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

:host .qa-generation-v2 > .qa-generation-v2__toolbar,
:host .qa-generation-v2 > .qa-generation-v2__overview {
  border-bottom: 1px solid var(--qa-survey-line) !important;
}

:host .qa-generation-v2 > .qa-generation-v2__toolbar {
  min-height: 112px;
  padding: 24px 28px;
  background: #fff;
}

:host .qa-generation-v2 > .qa-generation-v2__setup {
  min-height: 420px;
  padding: 42px 34px;
}

:host .qa-generation-v2 > .qa-generation-v2__overview {
  overflow: hidden;
  background: #fff;
}

:host .qa-generation-v2 > .qa-generation-v2__catalog {
  overflow: hidden;
  margin: 28px 28px 0;
  border: 1px solid var(--qa-survey-line) !important;
  border-radius: 10px !important;
  background: #fff;
}

:host .qa-generation-v2 > .qa-generation-v2__review {
  gap: 0;
  overflow: hidden;
  margin: 22px 28px 28px;
  border: 1px solid var(--qa-survey-line) !important;
  border-radius: 10px;
  background: #fff;
}

:host .qa-generation-v2__review > .qa-generation-v2__review-panel {
  margin: 0;
  border: 0 !important;
  border-radius: 0 !important;
  background: #fff;
  box-shadow: none !important;
}

:host .qa-generation-v2__review > .qa-generation-v2__review-panel + .qa-generation-v2__review-panel {
  border-left: 1px solid var(--qa-survey-line) !important;
}

:host .qa-generation-v2 > .qa-generation-v2__message,
:host .qa-generation-v2 > .qa-generation-v2__progress {
  margin: 0 28px 20px;
  border: 1px solid var(--qa-survey-line) !important;
  border-radius: 9px !important;
  box-shadow: none !important;
}

:host .qa-generation-v2 > .qa-generation-v2__actions {
  min-height: 86px;
  padding: 17px 22px 17px 28px;
  border-top: 1px solid var(--qa-survey-line) !important;
  background: #fff;
  backdrop-filter: none;
}

@media (max-width: 900px) {
  :host .qa-generation-v2 > .qa-generation-v2__toolbar {
    padding: 22px 20px;
  }
  :host .qa-generation-v2__review > .qa-generation-v2__review-panel + .qa-generation-v2__review-panel {
    border-top: 1px solid var(--qa-survey-line) !important;
    border-left: 0 !important;
  }
}
@media (max-width: 640px) {
  :host .qa-generation-v2 {
    border-radius: 10px;
  }
  :host .qa-generation-v2 > .qa-generation-v2__toolbar,
  :host .qa-generation-v2 > .qa-generation-v2__actions {
    padding-right: 16px;
    padding-left: 16px;
  }
  :host .qa-generation-v2 > .qa-generation-v2__message,
  :host .qa-generation-v2 > .qa-generation-v2__progress {
    margin-right: 16px;
    margin-left: 16px;
  }
  :host .qa-generation-v2 > .qa-generation-v2__catalog {
    margin: 20px 16px 0;
  }
  :host .qa-generation-v2 > .qa-generation-v2__review {
    margin: 16px 16px 20px;
  }
}
/* QA preparation owns one outer frame; its settings wrapper stays structural. */
:host-context(.reviewops-shell) main.is-generation-main.is-qa-generation-main > .project-output-settings {
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

:host .qa-generation-v2 {
  border: 1px solid var(--qa-survey-line) !important;
  outline: 0 !important;
  box-shadow: none !important;
}

:host .qa-generation-v2__settings-button {
  width: auto;
  min-width: 0;
  height: 36px;
  min-height: 36px;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #d9dfd9 !important;
  color: #4d5a52 !important;
  background: #fff !important;
  box-shadow: none !important;
  letter-spacing: 0;
  white-space: nowrap;
}

:host .qa-generation-v2__settings-button i {
  width: 14px;
  display: grid;
  place-items: center;
  color: #587266;
  font-size: 12px;
}

:host .qa-generation-v2__settings-button:hover:not(:disabled) {
  border-color: #b9c7bd !important;
  color: #365a4f !important;
  background: #eef3ee !important;
}

:host .qa-generation-v2__settings-button:active:not(:disabled) {
  background: #e8efe9 !important;
}

/* QA set generations: comparison-first version selection and collapsible source catalog. */
:host button.qa-generation-v2__overview-card.is-source {
  width: 100%;
  margin: 0;
  border: 0 !important;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

:host button.qa-generation-v2__overview-card.is-source:hover {
  background: #edf4ea;
}

:host button.qa-generation-v2__overview-card.is-source:focus-visible {
  z-index: 1;
  outline: 3px solid rgba(69, 110, 99, 0.2);
  outline-offset: -3px;
}

:host .qa-generation-v2__overview-toggle {
  position: absolute;
  right: 17px;
  bottom: 12px;
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  color: #365e51;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #c7d5cb;
  border-radius: 7px;
  box-shadow: 0 1px 2px rgba(34, 59, 48, 0.05);
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  pointer-events: none;
}

:host .qa-generation-v2__overview-toggle i {
  width: 12px;
  text-align: center;
  transition: transform 0.24s ease;
}

:host button.qa-generation-v2__overview-card.is-source:hover .qa-generation-v2__overview-toggle {
  color: #274f43;
  background: #fff;
  border-color: #91ad9b;
  box-shadow: 0 3px 9px rgba(34, 59, 48, 0.09);
}

:host button.qa-generation-v2__overview-card.is-source:active .qa-generation-v2__overview-toggle {
  background: #e7f0e9;
  transform: translateY(1px);
}

:host .qa-generation-v2 > .qa-generation-v2__catalog {
  max-height: 2400px;
  opacity: 1;
  visibility: visible;
  transition: max-height 0.38s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.22s ease, margin 0.38s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.2s ease, visibility 0s;
}

:host .qa-generation-v2 > .qa-generation-v2__catalog.is-collapsed {
  max-height: 0;
  margin-top: 0;
  opacity: 0;
  visibility: hidden;
  border-color: transparent !important;
  pointer-events: none;
  transition: max-height 0.38s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.18s ease, margin 0.38s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.16s ease, visibility 0s 0.38s;
}

:host .qa-generation-v2 > .qa-generation-v2__versioning {
  margin: 22px 28px 0;
  border: 1px solid var(--qa-survey-line) !important;
  border-radius: 10px;
  background: #fff;
  box-shadow: none !important;
}

:host .qa-generation-v2__versioning-header {
  min-height: 86px;
  padding: 18px 20px;
  background: #fbfcfa;
  border-bottom: 1px solid var(--qa-survey-line);
}

:host .qa-generation-v2__versioning-header > div > span {
  color: var(--qa-survey-coral);
  font-size: 12px;
  letter-spacing: 0.15em;
}

:host .qa-generation-v2__versioning-header h3 {
  font-size: 17px;
}

:host .qa-generation-v2__versioning-header > strong.qa-generation-v2__next-version {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 8px 11px;
  color: #315c4e;
  background: #edf4ef;
  border: 1px solid #d6e2d9;
  border-radius: 999px;
  box-shadow: none;
}

:host .qa-generation-v2__next-version > i {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  color: #456f60;
  background: #fff;
  border-radius: 50%;
  font-size: 12px;
}

:host .qa-generation-v2__next-version > span,
:host .qa-generation-v2__next-version small,
:host .qa-generation-v2__next-version b {
  display: block;
}

:host .qa-generation-v2__next-version small {
  margin: 0 0 1px;
  color: #718078;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.1;
}

:host .qa-generation-v2__next-version b {
  color: #315c4e;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

:host .qa-generation-v2__comparison {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 82px minmax(250px, 1.08fr) minmax(250px, 0.82fr);
  align-items: stretch;
  gap: 12px;
  padding: 18px 20px 12px;
}

:host .qa-generation-v2__comparison-card,
:host .qa-generation-v2__version-history {
  min-width: 0;
  padding: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dde4dd;
  border-radius: 8px;
}

:host .qa-generation-v2__comparison-card.is-next {
  background: #fbfdfb;
  border-color: #8cab99;
  box-shadow: inset 0 0 0 1px rgba(69, 110, 99, 0.08);
}

:host .qa-generation-v2__comparison-card > header {
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 11px 13px;
  background: #fafbf9;
  border-bottom: 1px solid #e3e8e2;
}

:host .qa-generation-v2__comparison-card.is-next > header {
  background: #eef5ef;
  border-bottom-color: #d6e2d8;
}

:host .qa-generation-v2__comparison-card h4,
:host .qa-generation-v2__comparison-card header small {
  display: block;
  margin: 0;
}

:host .qa-generation-v2__comparison-card h4 {
  color: #2c3730;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-v2__comparison-card header small {
  margin-top: 3px;
  color: #708078;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-v2__comparison-card header em {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 7px;
  color: #68736a;
  background: #eff1ee;
  border-radius: 6px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

:host .qa-generation-v2__comparison-card header em.is-complete,
:host .qa-generation-v2__version-history li > em.is-complete {
  color: #326b5c;
  background: #e6f0e8;
}

:host .qa-generation-v2__comparison-card dl {
  margin: 0;
  padding: 5px 13px 10px;
}

:host .qa-generation-v2__comparison-card dl > div {
  min-height: 31px;
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  border-bottom: 1px solid #edf0ec;
}

:host .qa-generation-v2__comparison-card dl > div:last-child {
  border-bottom: 0;
}

:host .qa-generation-v2__comparison-card dt,
:host .qa-generation-v2__comparison-card dd {
  margin: 0;
  font-size: 12px;
}

:host .qa-generation-v2__comparison-card dt {
  color: #778079;
  font-weight: 700;
}

:host .qa-generation-v2__comparison-card dt i {
  width: 14px;
  margin-right: 4px;
  color: #5c7768;
  text-align: center;
}

:host .qa-generation-v2__comparison-card dd {
  min-width: 0;
  color: #364139;
  font-weight: 700;
}

:host .qa-generation-v2__comparison-card .is-criteria dd {
  display: flex;
  align-items: center;
  gap: 6px;
}

:host .qa-generation-v2__comparison-card select {
  min-width: 0;
  width: 100%;
  height: 28px;
  padding: 0 24px 0 8px;
  color: #2d5f52;
  background: #fff;
  border: 1px solid #bac9bf;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

:host .qa-generation-v2__comparison-card .is-criteria dd > small {
  flex: 0 0 auto;
  padding: 4px 6px;
  color: #2f6f61;
  background: #e8f2ea;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

:host .qa-generation-v2__comparison-empty {
  min-height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  color: #718078;
  text-align: left;
}

:host .qa-generation-v2__comparison-empty i {
  color: #6b8a77;
  font-size: 18px;
}

:host .qa-generation-v2__comparison-empty strong,
:host .qa-generation-v2__comparison-empty small {
  display: block;
}

:host .qa-generation-v2__comparison-empty strong {
  color: #455148;
  font-size: 12px;
}

:host .qa-generation-v2__comparison-empty small {
  margin-top: 4px;
  font-size: 12px;
}

:host .qa-generation-v2__comparison-arrow {
  display: grid;
  place-items: center;
  align-content: center;
  gap: 6px;
  color: #6e7c72;
  text-align: center;
}

:host .qa-generation-v2__comparison-arrow i {
  color: #457061;
  font-size: 20px;
}

:host .qa-generation-v2__comparison-arrow strong {
  color: #446154;
  font-size: 12px;
}

:host .qa-generation-v2__comparison-arrow small {
  max-width: 76px;
  font-size: 12px;
  line-height: 1.45;
}

:host .qa-generation-v2__comparison-generate {
  width: calc(100% - 24px);
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0 12px 12px;
  color: #fff;
  background: var(--qa-green);
  border: 1px solid var(--qa-green);
  cursor: pointer;
}

:host .qa-generation-v2__comparison-generate:hover:not(:disabled) {
  background: var(--qa-green-dark);
  border-color: var(--qa-green-dark);
}

:host .qa-generation-v2__comparison-generate:disabled {
  color: #929b94;
  background: #edf0ed;
  border-color: #e0e5e0;
  cursor: not-allowed;
}

:host .qa-generation-v2__version-history {
  padding: 12px;
  background: #fcfdfb;
}

:host .qa-generation-v2__version-history > header {
  min-height: 36px;
  margin: 0 0 8px;
}

:host .qa-generation-v2__version-history > header strong {
  font-size: 12px;
}

:host .qa-generation-v2__version-history > header small,
:host .qa-generation-v2__version-history > header em {
  font-size: 12px;
}

:host .qa-generation-v2__version-history ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

:host .qa-generation-v2__version-history li {
  position: relative;
  min-height: 66px;
  display: grid;
  grid-template-columns: 14px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: 9px 8px;
  border: 0;
  border-top: 1px solid #e6ebe5;
  border-radius: 0;
}

:host .qa-generation-v2__version-history li + li {
  margin-top: 0;
}

:host .qa-generation-v2__version-history li.is-current {
  background: #f4f8f4;
}

:host .qa-generation-v2__version-history li.is-planned {
  grid-template-columns: minmax(0, 1fr) auto;
  background: #fbfcfa;
}

:host .qa-generation-v2__history-dot {
  color: #6f8f7c;
  text-align: center;
}

:host .qa-generation-v2__history-dot i.fa-clock {
  color: #829087;
}

:host .qa-generation-v2__history-detail strong,
:host .qa-generation-v2__history-detail b,
:host .qa-generation-v2__history-detail small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host .qa-generation-v2__history-detail strong {
  color: #344139;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-v2__history-detail b {
  margin-top: 3px;
  color: #5b675f;
  font-size: 12px;
  font-weight: 700;
}

:host .qa-generation-v2__history-detail small {
  margin-top: 3px;
  font-size: 12px;
}

:host .qa-generation-v2__version-history li > em {
  padding: 4px 6px;
  border-radius: 5px;
  font-size: 12px;
}

:host .qa-generation-v2__version-policy {
  margin: 0 20px 16px;
  border-radius: 7px;
}

@media (max-width: 1180px) {
  :host .qa-generation-v2__comparison {
    grid-template-columns: minmax(0, 1fr) 68px minmax(0, 1fr);
  }
  :host .qa-generation-v2__version-history {
    grid-column: 1/-1;
  }
  :host .qa-generation-v2__version-history ol {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host .qa-generation-v2__version-history li + li {
    border-left: 1px solid #e6ebe5;
  }
}
@media (max-width: 760px) {
  :host .qa-generation-v2 > .qa-generation-v2__versioning {
    margin: 18px 16px 0;
  }
  :host .qa-generation-v2__comparison {
    grid-template-columns: minmax(0, 1fr);
    padding: 14px;
  }
  :host .qa-generation-v2__comparison-arrow {
    min-height: 54px;
  }
  :host .qa-generation-v2__comparison-arrow i {
    transform: rotate(90deg);
  }
  :host .qa-generation-v2__comparison-arrow small {
    max-width: none;
  }
  :host .qa-generation-v2__version-history {
    grid-column: auto;
  }
  :host .qa-generation-v2__version-history ol {
    display: block;
  }
  :host .qa-generation-v2__version-history li + li {
    border-left: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  :host .qa-generation-v2 > .qa-generation-v2__catalog,
  :host .qa-generation-v2__overview-toggle i {
    transition: none;
  }
}
@media (max-width: 900px) {
  :host .qa-generation-v2__settings-button {
    width: auto;
    align-self: flex-end;
  }
}
@media (max-width: 640px) {
  :host .qa-generation-v2__settings-button {
    width: 100%;
    align-self: stretch;
  }
}
/* Summary groups use divider lines, not rounded section outlines. */
:host-context(.reviewops-shell) .project-settings-inline__summary > section {
  border-radius: 0 !important;
}

/* One QA result is the card; its internal rows remain continuous panels. */
:host-context(.reviewops-shell) .qa-result-card > .qa-result-card__header,
:host-context(.reviewops-shell) .qa-result-card__content > section,
:host-context(.reviewops-shell) .qa-result-card__review-grid > section {
  margin: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

/* Metric cells share the overview frame instead of rounding every divider. */
:host-context(.reviewops-shell) .qa-result-overview__metrics > article {
  margin: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

/* Project-bound harness and survey snapshots */
.project-resource-preview-backdrop {
  position: fixed;
  inset: 0;
  z-index: 82;
  display: grid;
  width: 100vw;
  height: 100dvh;
  padding: 24px;
  place-items: center;
  background: rgba(30, 39, 34, 0.62);
  backdrop-filter: blur(3px);
}

.project-resource-preview {
  display: grid;
  width: min(920px, 100vw - 48px);
  max-height: calc(100dvh - 48px);
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  border: 1px solid #dfe6df;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(20, 31, 24, 0.24);
}

.project-resource-preview__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 20px 22px;
  border-bottom: 1px solid #e3e8e4;
  background: #fcfdfc;
}

.project-resource-preview__identity {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 13px;
}

.project-resource-preview__identity > div {
  min-width: 0;
}

.project-resource-preview__icon {
  display: grid;
  width: 44px;
  height: 44px;
  flex: none;
  place-items: center;
  border-radius: 11px;
  color: #55745d;
  background: #eaf3eb;
  font-size: 16px;
}

.project-resource-preview__icon.is-survey {
  color: #775f8b;
  background: #f1ebf6;
}

.project-resource-preview__identity small,
.project-resource-preview__identity h2,
.project-resource-preview__identity p {
  display: block;
  margin: 0;
}

.project-resource-preview__identity small {
  color: #88938c;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__identity h2 {
  overflow: hidden;
  margin-top: 4px;
  color: #27312b;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-resource-preview__identity p {
  margin-top: 4px;
  color: #89928d;
  font-size: 12px;
}

.project-resource-preview__controls {
  display: flex;
  flex: none;
  align-items: flex-end;
  gap: 10px;
}

.project-resource-preview__controls label {
  display: grid;
  gap: 5px;
  color: #7d8881;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__controls select {
  min-width: 174px;
  height: 36px;
  padding: 0 32px 0 11px;
  border: 1px solid #d5ddd7;
  border-radius: 8px;
  color: #354139;
  background: #fff;
  outline: 0;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__controls select:focus-visible {
  border-color: #829881;
  box-shadow: 0 0 0 3px rgba(91, 120, 94, 0.12);
}

.project-resource-preview__close {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border: 1px solid #dce2de;
  color: #7b8780;
  background: #fff;
  cursor: pointer;
}

.project-resource-preview__close:hover {
  color: #39453e;
  background: #f2f5f2;
}

.project-resource-preview__body {
  overflow-y: auto;
  padding: 20px 22px 24px;
  scrollbar-gutter: stable;
}

.project-resource-preview__version-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 18px;
  padding: 10px 12px;
  border: 1px solid #e4e9e5;
  background: #f8faf8;
}

.project-resource-preview__version-summary span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #78847c;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__version-summary em {
  margin-left: auto;
  padding: 4px 8px;
  border-radius: 999px;
  color: #51704f;
  background: #eaf4e7;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-resource-preview__section {
  margin-top: 20px;
}

.project-resource-preview__section > header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 11px;
}

.project-resource-preview__section > header small,
.project-resource-preview__section > header h3 {
  display: block;
  margin: 0;
}

.project-resource-preview__section > header small {
  color: #91a096;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.project-resource-preview__section > header h3 {
  margin-top: 3px;
  color: #303a34;
  font-size: 14px;
  font-weight: 700;
}

.project-resource-preview__section > header em {
  color: #617369;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-resource-preview__rules {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.project-resource-preview__rules li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 11px;
  align-items: start;
  padding: 12px 14px;
  border: 1px solid #e3e8e4;
  background: #fff;
}

.project-resource-preview__rules li > span {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  border-radius: 50%;
  color: #55705b;
  background: #eaf2e9;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__rules p {
  margin: 2px 0 0;
  color: #46524b;
  font-size: 12px;
  line-height: 1.65;
}

.project-resource-preview__questions {
  display: grid;
  gap: 10px;
}

.project-resource-preview__questions article {
  padding: 14px 15px;
  border: 1px solid #e2e7e3;
  background: #fff;
}

.project-resource-preview__questions article > header {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 11px;
}

.project-resource-preview__questions article > header > span {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  border-radius: 7px;
  color: #755d88;
  background: #f0ebf4;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__questions small {
  display: block;
  color: #826c91;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__questions h4 {
  margin: 4px 0 0;
  color: #38423c;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.55;
}

.project-resource-preview__options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 11px 0 0 39px;
}

.project-resource-preview__options span {
  padding: 5px 8px;
  border: 1px solid #e1e6e2;
  border-radius: 999px;
  color: #657169;
  background: #f8faf8;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__survey-result {
  margin-top: 16px;
}

.project-resource-preview__survey-result > header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-bottom: 10px;
}

.project-resource-preview__survey-result > header small {
  display: block;
  color: #96a099;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.project-resource-preview__survey-result > header h3 {
  margin: 4px 0 0;
  color: #354139;
  font-size: 15px;
}

.project-resource-preview__survey-result > header em {
  border-radius: 999px;
  background: #eef3ef;
  padding: 5px 8px;
  color: #647168;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.project-resource-preview__survey-result-form {
  overflow: hidden;
  border: 1px solid #dfe5e0;
  border-radius: 11px;
  background: #fff;
}

.project-resource-preview__survey-result-form > section {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  min-height: 46px;
}

.project-resource-preview__survey-result-form > section + section {
  border-top: 1px solid #e6eae7;
}

.project-resource-preview__survey-result-form > section > small {
  display: flex;
  align-items: center;
  padding: 11px 12px;
  background: #f7f9f7;
  color: #68746c;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__survey-result-values {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  padding: 10px 12px;
}

.project-resource-preview__survey-result-values span {
  border: 1px solid #dce4de;
  border-radius: 999px;
  background: #f8faf8;
  padding: 5px 7px;
  color: #59665e;
  font-size: 12px;
  font-weight: 700;
}

.project-resource-preview__survey-result-values.is-decisions span {
  border-color: #d5e3d8;
  background: #edf5ef;
  color: #496b53;
}

.project-resource-preview__survey-result-values.is-issues span {
  border-color: #e3dbea;
  background: #f7f3f9;
  color: #705e7e;
}

.project-resource-preview__survey-result-comments {
  display: grid;
}

.project-resource-preview__survey-result-comments article {
  display: grid;
  grid-template-columns: minmax(115px, 0.45fr) minmax(0, 1fr);
  min-height: 48px;
  align-items: center;
}

.project-resource-preview__survey-result-comments article + article {
  border-top: 1px solid #edf0ed;
}

.project-resource-preview__survey-result-comments strong {
  padding: 11px 12px;
  color: #48544c;
  font-size: 12px;
}

.project-resource-preview__survey-result-comments span {
  align-self: stretch;
  border-left: 1px solid #edf0ed;
  padding: 12px;
  color: #a0a8a2;
  font-size: 12px;
}

.project-resource-preview__note {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 10px;
  margin: 16px 0 0;
  padding: 11px 12px;
  border-left: 3px solid #90a48d;
  color: #667169;
  background: #f5f8f4;
  font-size: 12px;
  line-height: 1.55;
}

.project-resource-preview__note strong {
  color: #4d5c52;
}

.project-resource-preview__empty {
  display: grid;
  min-height: 150px;
  place-items: center;
  align-content: center;
  padding: 24px;
  border: 1px dashed #d9e0da;
  color: #8b958f;
  background: #fafbfa;
  text-align: center;
}

.project-resource-preview__empty i {
  margin-bottom: 10px;
  font-size: 20px;
}

.project-resource-preview__empty strong {
  color: #59655e;
  font-size: 12px;
}

.project-resource-preview__empty p {
  margin: 6px 0 0;
  font-size: 12px;
}

.project-resource-preview__footer {
  display: flex;
  min-height: 60px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 22px;
  border-top: 1px solid #e3e8e4;
  background: #fafbfa;
}

.project-resource-preview__footer > span {
  color: #8b948e;
  font-size: 12px;
}

.project-resource-preview__footer > div {
  display: flex;
  gap: 8px;
}

.project-resource-preview__footer a,
.project-resource-preview__footer button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 13px;
  border: 1px solid #d5ddd7;
  border-radius: 8px;
  color: #56645b;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}

.project-resource-preview__footer button:not(.is-secondary) {
  border-color: #617b66;
  color: #fff;
  background: #617b66;
}

@media (max-width: 720px) {
  .project-resource-preview-backdrop {
    padding: 12px;
  }
  .project-resource-preview {
    width: calc(100vw - 24px);
    max-height: calc(100dvh - 24px);
  }
  .project-resource-preview__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
    padding: 16px;
  }
  .project-resource-preview__controls {
    width: 100%;
  }
  .project-resource-preview__controls label {
    flex: 1;
  }
  .project-resource-preview__controls select {
    width: 100%;
    min-width: 0;
  }
  .project-resource-preview__body {
    padding: 16px;
  }
  .project-resource-preview__survey-result > header {
    align-items: flex-start;
    flex-direction: column;
    gap: 7px;
  }
  .project-resource-preview__survey-result-form > section {
    grid-template-columns: 1fr;
  }
  .project-resource-preview__survey-result-form > section > small {
    border-bottom: 1px solid #edf0ed;
    padding: 9px 11px;
  }
  .project-resource-preview__survey-result-comments article {
    grid-template-columns: 1fr;
  }
  .project-resource-preview__survey-result-comments span {
    min-height: 42px;
    border-top: 1px solid #edf0ed;
    border-left: 0;
  }
  .project-resource-preview__footer {
    align-items: stretch;
    flex-direction: column;
    padding: 12px 16px;
  }
  .project-resource-preview__footer > div,
  .project-resource-preview__footer a,
  .project-resource-preview__footer button {
    flex: 1;
  }
}
/* Project-aware next action guide */
:host .project-next-action {
  margin-bottom: 18px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dfe5df;
  border-radius: 16px;
  box-shadow: 0 14px 34px rgba(43, 55, 47, 0.065);
}

:host .project-next-action__header {
  display: flex;
  min-height: 88px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 19px 22px;
  background: radial-gradient(circle at 92% -90%, rgba(120, 154, 116, 0.13), transparent 25rem), #fbfcfa;
  border-bottom: 1px solid #e5e9e5;
}

:host .project-next-action__header p,
:host .project-next-action__header h2,
:host .project-next-action__header span {
  margin: 0;
}

:host .project-next-action__header p {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #d65732;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.17em;
}

:host .project-next-action__header h2 {
  margin-top: 4px;
  color: #28302b;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

:host .project-next-action__header > div:first-child > span {
  display: block;
  margin-top: 5px;
  color: #7e8882;
  font-size: 12px;
}

:host .project-next-action__progress {
  display: grid;
  grid-template-columns: auto auto;
  gap: 3px 12px;
  min-width: 185px;
  align-items: baseline;
}

:host .project-next-action__progress strong {
  color: #47634c;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

:host .project-next-action__progress > span {
  color: #7a857e;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

:host .project-next-action__progress > div {
  grid-column: 1/-1;
  height: 5px;
  overflow: hidden;
  background: #e9eee8;
  border-radius: 999px;
}

:host .project-next-action__progress > div i {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #658266, #9bb481);
  border-radius: inherit;
  transition: width 0.24s ease;
}

:host .project-next-action__body {
  display: block;
}

:host .project-next-action__recommendation {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  align-items: center;
  gap: 3px 15px;
  min-width: 0;
  min-height: 102px;
  padding: 18px 22px;
  color: #304038;
  background: linear-gradient(90deg, #f5f8f3 0%, #fbfcfa 72%);
  border-bottom: 1px solid #e2e8e2;
}

:host .project-next-action__recommendation.is-complete {
  background: linear-gradient(90deg, #f0f6ee 0%, #fafcf9 72%);
}

:host .project-next-action__recommendation-icon {
  display: grid;
  grid-row: 1/3;
  width: 46px;
  height: 46px;
  place-items: center;
  color: #fff;
  background: #607c64;
  border: 1px solid #607c64;
  border-radius: 13px;
  font-size: 16px;
  box-shadow: 0 7px 16px rgba(74, 103, 79, 0.16);
}

:host .project-next-action__recommendation small {
  color: #607862;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

:host .project-next-action__recommendation h3 {
  margin: 4px 0 0;
  color: #29332d;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.35;
}

:host .project-next-action__recommendation p {
  grid-column: 2;
  margin: 2px 0 0;
  color: #758078;
  font-size: 12px;
  line-height: 1.45;
}

:host .project-next-action__recommendation button {
  grid-column: 3;
  grid-row: 1/3;
  display: flex;
  min-width: 138px;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px;
  color: #fff;
  background: #d95a36;
  border: 1px solid #d95a36;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(217, 90, 54, 0.18);
  transition: background-color 0.16s ease, border-color 0.16s ease, transform 0.16s ease;
}

:host .project-next-action__recommendation button:hover {
  background: #c94d2c;
  border-color: #c94d2c;
  transform: translateY(-1px);
}

:host .project-next-action__steps {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  min-width: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
}

:host .project-next-action__steps li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-content: center;
  gap: 5px 10px;
  min-width: 0;
  min-height: 104px;
  padding: 16px 17px;
  border-top: 3px solid transparent;
}

:host .project-next-action__steps li + li {
  border-left: 1px solid #edf0ed;
}

:host .project-next-action__steps li.is-complete {
  background: #fbfcfa;
}

:host .project-next-action__steps li.is-current {
  background: #fff8f4;
  border-top-color: #d95a36;
}

:host .project-next-action__step-marker {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  color: #8b958f;
  background: #f0f3f0;
  border: 1px solid #e0e5e1;
  border-radius: 50%;
  font-size: 12px;
}

:host .project-next-action__step-marker b {
  font-weight: 700;
}

:host .project-next-action__steps li.is-complete .project-next-action__step-marker {
  color: #fff;
  background: #68826a;
  border-color: #68826a;
}

:host .project-next-action__steps li.is-current .project-next-action__step-marker {
  color: #fff;
  background: #dc603d;
  border-color: #dc603d;
  box-shadow: 0 0 0 4px rgba(220, 96, 61, 0.1);
}

:host .project-next-action__step-copy {
  min-width: 0;
}

:host .project-next-action__step-copy > span {
  display: flex;
  align-items: center;
  gap: 7px;
}

:host .project-next-action__step-copy > span i {
  color: #718079;
  font-size: 12px;
}

:host .project-next-action__step-copy strong {
  color: #39423d;
  font-size: 12px;
  font-weight: 700;
}

:host .project-next-action__step-copy p {
  margin: 3px 0 0;
  color: #8a938e;
  font-size: 12px;
  line-height: 1.45;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

:host .project-next-action__steps li > em {
  grid-column: 2;
  justify-self: start;
  min-width: 48px;
  padding: 5px 7px;
  color: #858f89;
  background: #f3f5f3;
  border-radius: 999px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
}

:host .project-next-action__steps li.is-complete > em {
  color: #4f6f55;
  background: #edf4eb;
}

:host .project-next-action__steps li.is-current > em {
  color: #b94a2a;
  background: #fff0ea;
}

:host .project-next-action button:focus-visible {
  outline: 2px solid rgba(218, 90, 54, 0.42);
  outline-offset: 2px;
}

/* A project can keep multiple resources; make the active connection explicit. */
:host .project-resource-card__list-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 7px;
  align-items: stretch;
}

:host .project-resource-card__preview {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 11px;
  color: inherit;
  background: #fff;
  border: 1px solid #e7ebe4;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;
}

:host .project-resource-card__list-row.is-connected .project-resource-card__preview {
  border-color: #bfceba;
  background: #fbfdf9;
}

:host .project-resource-card__preview:hover,
:host .project-resource-card__preview:focus-visible {
  border-color: #aebeaa;
  background: #f8faf6;
  box-shadow: 0 0 0 3px rgba(118, 137, 94, 0.1);
  outline: 0;
}

:host .project-resource-card__preview > span:first-child {
  min-width: 0;
}

:host .project-resource-card__preview:hover .project-resource-card__list-action i,
:host .project-resource-card__preview:focus-visible .project-resource-card__list-action i {
  color: #667653;
  transform: translateX(2px);
}

:host .project-resource-card__connect,
:host .project-resource-card__connected,
:host .project-resource-card__register-common,
:host .project-resource-card__common-state {
  display: inline-flex;
  min-width: 66px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 9px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

:host .project-resource-card__actions {
  display: flex;
  min-width: 118px;
  flex-direction: column;
  gap: 6px;
}

:host .project-resource-card__connect {
  color: #fff;
  background: #5f775f;
  border: 1px solid #5f775f;
  cursor: pointer;
}

:host .project-resource-card__connect:disabled {
  color: #98a19a;
  background: #eff2ef;
  border-color: #dfe4df;
  cursor: not-allowed;
}

:host .project-resource-card__connected {
  color: #55705a;
  background: #edf4eb;
  border: 1px solid #ccdac8;
}

:host .project-resource-card__register-common {
  color: #52664f;
  background: #fff;
  border: 1px solid #cbd6c7;
  cursor: pointer;
}

:host .project-resource-card__register-common:hover,
:host .project-resource-card__register-common:focus-visible {
  color: #fff;
  background: #5f775f;
  border-color: #5f775f;
  outline: 0;
}

:host .project-resource-card__register-common:disabled {
  color: #98a19a;
  background: #eff2ef;
  border-color: #dfe4df;
  cursor: not-allowed;
}

:host .project-resource-card__common-state {
  color: #55705a;
  background: #edf4eb;
  border: 1px solid #ccdac8;
}

@media (max-width: 720px) {
  :host .project-next-action__header {
    align-items: stretch;
    flex-direction: column;
  }
  :host .project-next-action__progress {
    width: 100%;
  }
  :host .project-next-action__recommendation {
    grid-template-columns: 42px minmax(0, 1fr);
    padding: 21px 18px;
  }
  :host .project-next-action__recommendation p,
  :host .project-next-action__recommendation button {
    grid-column: 1/-1;
    grid-row: auto;
  }
  :host .project-next-action__steps {
    grid-auto-flow: row;
    grid-auto-columns: auto;
    grid-template-columns: 1fr;
    overflow: visible;
  }
  :host .project-next-action__steps li {
    grid-template-columns: 28px minmax(0, 1fr) auto;
    min-height: 76px;
    padding-block: 10px;
  }
  :host .project-next-action__steps li + li {
    border-top: 1px solid #edf0ed;
    border-left: 0;
  }
  :host .project-next-action__steps li > em {
    grid-column: 3;
    grid-row: 1;
  }
  :host .project-resource-card__list-row {
    grid-template-columns: minmax(0, 1fr);
  }
  :host .project-resource-card__connect,
  :host .project-resource-card__connected,
  :host .project-resource-card__register-common,
  :host .project-resource-card__common-state {
    min-height: 30px;
  }
  :host .project-resource-card__actions {
    width: 100%;
  }
}
/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .ro-workspace .project-next-action__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}
:host-context(.reviewops-shell) .ro-workspace .project-next-action__recommendation {
  padding: 16px;
}
:host-context(.reviewops-shell) .ro-workspace .project-next-action__steps {
  margin: 0;
}
:host-context(.reviewops-shell) .ro-workspace .project-next-action__steps > li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: start;
  gap: 8px 12px;
  min-height: 0;
  padding: 12px 16px;
}
:host-context(.reviewops-shell) .ro-workspace .project-next-action__steps > li > em {
  grid-column: 3;
  grid-row: 1;
  justify-self: start;
  align-self: start;
  width: auto;
  min-width: 0;
  height: auto;
  padding: 4px 8px;
  border-radius: 8px;
  white-space: nowrap;
  font-size: 12px;
  line-height: 18px;
}
:host-context(.reviewops-shell) .ro-workspace .project-next-action__step-copy p {
  display: block;
  -webkit-line-clamp: unset;
  overflow: visible;
}
:host-context(.reviewops-shell) .ro-workspace .project-next-action__step-copy strong {
  font-size: 16px;
  line-height: 24px;
}
:host-context(.reviewops-shell) .ro-workspace .project-next-action__progress {
  width: auto;
  min-width: 0;
}
:host-context(.reviewops-shell) .ro-workspace .project-next-action__header {
  gap: 16px;
  padding: 16px;
}
:host-context(.reviewops-shell) .ro-workspace .project-next-action__header > div:first-child > p {
  display: none;
}
:host-context(.reviewops-shell) .ro-workspace .project-resource-studio__header {
  padding: 16px 0;
}
:host-context(.reviewops-shell) .ro-workspace .project-settings-inline__form, :host-context(.reviewops-shell) .ro-workspace .project-settings-inline__summary {
  padding: 16px;
}
:host-context(.reviewops-shell) .ro-workspace .project-settings-inline__summary {
  position: static;
}
:host-context(.reviewops-shell) .ro-workspace .project-resource-card {
  border-radius: 12px;
  background: white;
  box-shadow: none;
}
:host-context(.reviewops-shell) .ro-workspace .project-resource-card__list-row {
  gap: 12px;
  padding: 12px;
}
:host-context(.reviewops-shell) .ro-workspace .project-resource-card__name {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}
:host-context(.reviewops-shell) .ro-workspace .project-admin-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-block: 0;
}
:host-context(.reviewops-shell) .ro-workspace .project-admin-tabs a {
  min-height: 44px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
}
:host-context(.reviewops-shell) .ro-workspace .project-admin-tabs a.is-active {
  background: #FFF0ED;
  color: #8F351D;
}
:host-context(.reviewops-shell) .ro-workspace .qa-generation-v2__toolbar, :host-context(.reviewops-shell) .ro-workspace .qa-result-toolbar, :host-context(.reviewops-shell) .ro-workspace .kg-result-toolbar, :host-context(.reviewops-shell) .ro-workspace .dataset-detail-header {
  gap: 16px;
  flex-wrap: wrap;
}
:host-context(.reviewops-shell) .ro-workspace .qa-generation-v2__catalog, :host-context(.reviewops-shell) .ro-workspace .qa-generation-v2__versioning, :host-context(.reviewops-shell) .ro-workspace .qa-generation-v2__review {
  min-width: 0;
}
:host-context(.reviewops-shell) .ro-workspace .project-settings-completion {
  width: auto;
  max-width: 100%;
  white-space: normal;
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .ro-workspace .project-next-action__header {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }
  :host-context(.reviewops-shell) .ro-workspace .project-resource-studio__grid, :host-context(.reviewops-shell) .ro-workspace .project-settings-inline {
    grid-template-columns: minmax(0, 1fr);
  }
  :host-context(.reviewops-shell) .ro-workspace .project-settings-inline__summary, :host-context(.reviewops-shell) .ro-workspace .qa-generation-v2__catalog, :host-context(.reviewops-shell) .ro-workspace .qa-generation-v2__review {
    position: static;
    max-height: none;
  }
  :host-context(.reviewops-shell) .ro-workspace .project-next-action__recommendation {
    grid-template-columns: 32px minmax(0, 1fr);
  }
  :host-context(.reviewops-shell) .ro-workspace .project-next-action__recommendation p, :host-context(.reviewops-shell) .ro-workspace .project-next-action__recommendation button {
    grid-column: 1/-1;
    grid-row: auto;
  }
}`],
})
export class PageReviewProjectsItemComponent implements OnInit, OnDestroy {
    public routerSub: Subscription;
    public projectId: string = '';
    public tab: string = 'process';
    public selectedStage: number = 3;
    public selectedSample: number = 0;
    public showRunModal: boolean = false;
    public showHarnessModal: boolean = false;
    public scoreOptions: number[] = [1, 2, 3, 4, 5];

    public project: any = {};
    public source: any = {};
    public gate: any = {};
    public stages: any[] = [];
    public llmChecks: any[] = [];
    public samples: any[] = [];
    public surveyDimensions: any[] = [];
    public reviewScopes: any[] = [
        { key: 'representative', label: '대표 표본' },
        { key: 'risk', label: '집중 검토 후보' },
        { key: 'pattern', label: '통계·패턴 요약' },
        { key: 'other', label: '기타' }
    ];
    public overallDecisionOptions: string[] = [
        '현 방향 유지',
        '질문·답변 수정 후 사용',
        '관계·유형 재검수',
        '원문 재확인 필요',
        '사용 제외'
    ];
    public issueReasonOptions: any[] = [
        { code: 'QUESTION_QUALITY', label: '질문이 모호하거나 활용 가치가 낮음' },
        { code: 'FACT_ERROR', label: '인물·사건·지명·연도 사실 오류' },
        { code: 'EVIDENCE_GAP', label: '답변 또는 관계의 사료 근거 부족' },
        { code: 'TIME_CONTEXT', label: '시대 구분 또는 역사적 맥락 오류' },
        { code: 'ENTITY_RELATION', label: '개체 식별 또는 관계 방향 오류' },
        { code: 'OCR_NOISE', label: '원문 인식 오류나 문장 파편 포함' },
        { code: 'BIAS', label: '기록과 해석의 혼동 또는 관점 편향' },
        { code: 'LABEL_MISMATCH', label: 'QA 유형 또는 지식그래프 관계 라벨 불일치' }
    ];
    public evaluation: any = this.emptyEvaluation();
    public rounds: any[] = [];
    public history: any[] = [];

    public settingsEditing: boolean = false;
    public settingsModalKind: any = null;
    public settingsValidationFields: any = {};
    public settingsValidationMessages: string[] = [];
    public projectSettings: any = {};
    public settingsDraft: any = {};
    public projectSourceSaving: boolean = false;
    public projectSettingsActiveStep: number = 1;
    public projectSettingsActiveKindKey: string = 'qa';
    public projectSettingKinds: any[] = [
        { key: 'qa', code: 'QA', label: 'QA 세트', description: '질문·답변·원문 근거 생성 설정' },
        { key: 'kg', code: 'KG', label: '지식그래프', description: '노드·관계·원문 근거 생성 설정' }
    ];
    public projectSourceOptions: string[] = ['자료함 API'];
    public projectSourceScopes: any[] = [
        { key: 'all', label: '전체 자료', description: '게시된 전체 자료를 사용합니다.', icon: 'fa-layer-group' },
        { key: 'collection', label: '주제 컬렉션', description: '미리 묶어둔 목적형 자료군을 사용합니다.', icon: 'fa-book-bookmark' }
    ];
    public projectSourceCollections: any[] = [
        {
            key: 'dokdo-core-121',
            label: '독도 자료 모음',
            query: '독도',
            count: 509,
            countUnit: '원문 Chunk',
            description: '구조화된 개별 사료의 검증된 primary_original 원문 컬렉션',
            examples: '편찬물 1건 · 개별 사료 180건 · 검증된 원문 Chunk 509건'
        },
        {
            key: 'east-asia-relations',
            label: '동아시아 관계사',
            query: '동아시아',
            count: 24,
            description: '국가·기관·인물 관계 추출용 컬렉션',
            examples: '중국정사외국전 · 중국정사동이전'
        },
        {
            key: 'border-diplomacy',
            label: '국경과 외교 기록',
            query: '국경',
            count: 14,
            description: '국경 협상과 외교 사건 중심 컬렉션',
            examples: '조청국경회담자료집 · 근현대 외교 문서'
        },
        {
            key: 'japan-relations',
            label: '한일 관계 기록',
            query: '한일',
            count: 16,
            description: '일본 사료와 한일 관계 기록을 묶은 컬렉션',
            examples: '일본 사료 · 근현대 한일 관계 문서'
        }
    ];
    public projectHarnessOptions: any[] = [];
    public projectSurveyOptions: any[] = [];
    public projectReviewerOptions: any[] = [];
    public projectReviewersLoading: boolean = false;
    public projectReviewersError: string = '';
    public projectReviewerAssignmentSaving: boolean = false;
    public projectResourceBusy: string = '';
    public commonHarnessRegistrationId: string = '';
    public commonSurveyRegistrationId: string = '';
    public projectResourcePreviewOpen: boolean = false;
    public projectResourcePreviewKind: 'harness' | 'survey' | '' = '';
    public projectResourcePreviewItem: any = null;
    public projectResourcePreviewVersion: string = '';
    public projectQualityBusy: boolean = false;
    public qualityCenterLoading: boolean = false;
    public qualityCenterError: string = '';
    public qualityCenter: any = null;
    public qualityWorkspaceTab: 'reviews' | 'feedback' | 'proposals' | 'regression' = 'reviews';
    public qualityProposalTarget: 'harness' | 'survey' = 'harness';
    public qualityReviewFilter: string = 'all';
    public qualitySelectedReviewId: string = '';
    public qualityProposalBusy: string = '';
    private readonly qualityImprovementUrl: string = '/api/v1/review-workspace/quality-improvement';
    private readonly qaReviewTaskUrl: string = '/api/v1/review-workspace/qa-review-task';
    private readonly qaReviewAssignmentUrl: string = '/api/v1/review-workspace/qa-review-assignment';
    public readonly qaUsageModeOptions: any[] = [
        { value: 'rag', label: '검색형 AI 답변에 사용' },
        { value: 'fine_tuning', label: 'AI 학습에 사용' },
        { value: 'hybrid', label: '검색형 답변과 AI 학습에 모두 사용' }
    ];
    public readonly qaOutOfScopeOptions: any[] = [
        { value: 'abstain', label: '답변하지 않고 ‘자료 없음’으로 표시' },
        { value: 'evidence_only', label: '자료에서 확인되는 내용까지만 답변' }
    ];
    public readonly qaAdversarialOptions: any[] = [
        { value: 'evidence_led', label: '근거를 먼저 보여주고 답변' },
        { value: 'position_first', label: '기관의 기준을 우선 적용해 답변' }
    ];
    public readonly qaLanguagePolicyOptions: any[] = [
        { value: 'ko_preserve_original', label: '답변은 한국어로, 원문은 그대로 표시' },
        { value: 'ko_translate_with_original', label: '한국어 번역과 원문을 함께 표시' }
    ];
    public generationModalKind: any = null;
    public generationSources: any[] = [];
    public generationAvailability: any = {};
    public generationSourceQuery: string = '';
    public generationSearchQuery: string = '';
    public generationSourcePage: number = 1;
    public generationSourcePageSize: number = 20;
    public generationSourceSortAsc: boolean = true;
    public qaSourceFiltersOpen: boolean = false;
    public qaSourceCategory: string = '전체 자료';
    public qaSourceNewestFirst: boolean = true;
    public qaSourceCompact: boolean = false;
    public qaSourceCatalogOpen: boolean = true;
    public qaGenerationSummaryOpen: boolean = false;
    public readonly qaSourceCategories: string[] = ['전체 자료', '역사 문헌', '연구 자료', '보고서', '간행물', '기타 자료'];
    public generationLoading: boolean = false;
    public generationRunning: boolean = false;
    public qaRegenerationPreparing: boolean = false;
    public qaGenerationProgressDialogOpen: boolean = false;
    public generationProgress: any = {};
    public generationJobId: string = '';
    public generationError: string = '';
    public generationErrorCode: string = '';
    public generationStartedAtMs: number = 0;
    public generationLastProgressAtMs: number = 0;
    public generationResult: any = null;
    public outputGenerationStates: any = { qa: null, kg: null };
    public qaPersistedResult: any = null;
    public qaSetVersions: any[] = [];
    public qaResultSelectedVersionId: string = '';
    public qaResultVersionMenuOpen: boolean = false;
    public qaGenerationVersionSaving: 'harness' | 'survey' | '' = '';
    public qaResultLoading: boolean = false;
    public qaResultError: string = '';
    public qaResult: any = null;
    public qaResultArtifact: string = '';
    public qaResultSourceDigest: string = '';
    public qaDeletingItemId: string = '';
    public qaSelectedItemIds: Set<string> = new Set<string>();
    public qaSelectionBusy: boolean = false;
    public qaBatchRegenerationTotal: number = 0;
    public qaBatchRegenerationIndex: number = 0;
    public qaResultSearchQuery: string = '';
    public qaResultSourceFilter: string = 'all';
    public qaResultStatusFilter: string = 'all';
    public qaResultPage: number = 1;
    public readonly qaResultPageSize: number = 10;
    public qaResultTargetDraft: number = 15;
    public qaResultTargetUpdating: boolean = false;
    public qaRegeneratingItemId: string = '';
    public qaGenerationUpdateMode: 'replace_all' | 'append_to_target' = 'replace_all';
    public qaResultSourceModalOpen: boolean = false;
    public qaResultSourceModalItem: any = null;
    public qaResultSourceModalSnapshot: any = null;
    public resultExportLoading: string = '';
    public kgPersistedResult: any = null;
    public kgResultLoading: boolean = false;
    public kgResultError: string = '';
    public workspaceLoadError: string = '';
    public kgResult: any = null;
    public kgResultArtifact: string = '';
    public kgResultNodeFilter: string = 'all';
    public kgResultSearchQuery: string = '';
    public kgResultSelectedNodeId: string = '';
    public kgResultGraphViewMode: 'all' | 'selection' = 'all';
    public kgResultInspectorTab: 'details' | 'connections' | 'evidence' = 'details';
    public kgResultLowerTab: 'sources' | 'warnings' = 'sources';
    public kgResultSourceModalOpen: boolean = false;
    public kgResultSourceModalSnapshot: any = null;
    public kgResultNodeTypes: any[] = [
        { key: 'all', label: '전체' },
        { key: 'source', label: '사료' },
        { key: 'claim', label: '주장' },
        { key: 'entity', label: '개체' },
        { key: 'event', label: '사건' },
        { key: 'time', label: '시간' },
        { key: 'concept', label: '개념' },
        { key: 'evidence', label: '근거' }
    ];
    private readonly containerStorageKey: string = 'review-project-containers-v1';
    private readonly settingsStorageKey: string = 'review-project-settings-v1';
    private readonly harnessStorageKey: string = 'review-harnesses-v1';
    private readonly surveyStorageKey: string = 'review-surveys-v1';
    private readonly workspaceStateUrl: string = '/api/v1/review-workspace/state';
    private readonly workspaceManagementUrl: string = '/api/v1/review-workspace/management';
    private readonly generationSourceRequestTimeoutMs: number = 30000;
    private workspaceState: any = null;
    private workspaceStateLoaded: boolean = false;
    private readonly projectResourceUpdatedHandler = (event: Event) => {
        void this.syncUpdatedProjectResource((event as CustomEvent)?.detail || {});
    };
    private readonly projectContextRequestHandler = (event: Event) => {
        const detail = (event as CustomEvent)?.detail;
        if (!detail || String(detail.project_id || '') !== String(this.project?.id || '')) return;
        const qa = this.settingsDraft?.qa;
        if (!qa || typeof qa !== 'object') return;
        detail.project_qa_context = this.projectQaContextSnapshot(qa);
    };

    public datasetStep: number = 1;
    public datasetCompletionStep: number = 0;
    public datasetDraftMode: boolean = false;
    public datasetView: 'list' | 'detail' | 'create' = 'list';
    public datasetListMode: 'flow' | 'compact' = 'flow';
    public datasetDetailTab: 'configuration' | 'results' = 'configuration';
    public datasetDraftOrigin: 'list' | 'detail' = 'list';
    public datasetMaterialQuery: string = '';
    public datasetMaterialStatus: string = '게시됨';
    public datasetScope: string = 'chunk';
    public datasetSnapshotLocked: boolean = false;
    public datasetMaterials: any[] = [];
    public datasetChunks: any[] = [];
    public datasetSettings: any = {};
    public datasetRun: any = {};
    public datasetExistingResult: any = {};
    public datasetConnection: any = {};
    public datasetGraphView: 'relations' | 'evidence' | 'triples' = 'relations';
    public datasetGraphSelectedNodeId: string = 'concept';
    public datasetGraphHasFocus: boolean = false;
    public datasetGraphNodeFilter: string = 'all';
    public datasetGraphSearchQuery: string = '';
    public datasetGraphInspectorTab: 'details' | 'connections' | 'review' = 'details';
    public datasetGraphLeftCollapsed: boolean = false;
    public datasetGraphRightCollapsed: boolean = true;
    public datasetGraphExpanded: boolean = false;
    private datasetSavedState: any = null;
    private datasetGraphInstance: cytoscapeModule.Core | null = null;
    private datasetGraphRenderTimer: ReturnType<typeof setTimeout> | null = null;
    private kgResultGraphInstance: cytoscapeModule.Core | null = null;
    private kgResultGraphRenderTimer: ReturnType<typeof setTimeout> | null = null;
    private kgResultClusterOffsets: Record<string, { x: number; y: number }> = {};
    private kgResultClusterDragOrigin: {
        type: string;
        x: number;
        y: number;
        offsetX: number;
        offsetY: number;
    } | null = null;
    private projectReviewerPickerDocumentClickHandler = (event: MouseEvent) => {
        const target = event?.target instanceof Node ? event.target : null;
        document.querySelectorAll<HTMLDetailsElement>('details.project-reviewer-picker[open]')
            .forEach((picker) => {
                if (!target || !picker.contains(target)) picker.removeAttribute('open');
            });
    };
    public datasetSteps: any[] = [
        { no: 1, label: '자료 선택', hint: '자료함 문서를 고릅니다' },
        { no: 2, label: '생성 결과 설정', hint: '만들 결과를 정합니다' },
        { no: 3, label: '확인하고 생성', hint: '내용을 확인합니다' }
    ];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role('admin', '/access');
        await this.loadWorkspaceState();
        if (this.workspaceLoadError) {
            await this.service.render();
            return;
        }
        await this.loadProjectReviewerOptions();
        this.syncRoute();
        document.addEventListener('click', this.projectReviewerPickerDocumentClickHandler);
        window.addEventListener('reviewops:project-resource-updated', this.projectResourceUpdatedHandler);
        window.addEventListener('reviewops:project-context-request', this.projectContextRequestHandler);
        await this.service.render();
        await this.prepareOutputDetail();
        this.ensureRouterSubscription();
    }

    private ensureRouterSubscription() {
        if (this.routerSub) return;
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                if (this.workspaceLoadError) return;
                this.syncRoute();
                await this.service.render();
                await this.prepareOutputDetail();
            }
        });
    }

    public async reloadWorkspaceState() {
        await this.loadWorkspaceState();
        if (!this.workspaceLoadError) {
            this.syncRoute();
            this.ensureRouterSubscription();
            await this.prepareOutputDetail();
        }
        await this.service.render();
    }

    public ngOnDestroy() {
        document.removeEventListener('click', this.projectReviewerPickerDocumentClickHandler);
        window.removeEventListener('reviewops:project-resource-updated', this.projectResourceUpdatedHandler);
        window.removeEventListener('reviewops:project-context-request', this.projectContextRequestHandler);
        if (this.routerSub) this.routerSub.unsubscribe();
        this.destroyDatasetGraph();
        this.destroyKgResultGraph();
    }

    private projectQaContextSnapshot(setting: any) {
        const fields = [
            'source', 'sourceScope', 'sourceCategory', 'sourceCollection', 'usageMode',
            'outOfScopePolicy', 'adversarialPolicy', 'languagePolicy'
        ];
        return fields.reduce((context: any, key: string) => {
            context[key] = String(setting?.[key] || '');
            return context;
        }, {});
    }

    private normalizeWorkspaceState(payload: any) {
        const candidates = [
            payload?.data?.data?.state,
            payload?.data?.state,
            payload?.data?.data,
            payload?.result?.state,
            payload?.state,
            payload?.result,
            payload?.data,
            payload
        ];
        const state = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (
                Object.prototype.hasOwnProperty.call(candidate, 'schema_version')
                || Object.prototype.hasOwnProperty.call(candidate, 'projects')
                || Object.prototype.hasOwnProperty.call(candidate, 'surveys')
                || Object.prototype.hasOwnProperty.call(candidate, 'harnesses')
                || Object.prototype.hasOwnProperty.call(candidate, 'tasks')
                || Object.prototype.hasOwnProperty.call(candidate, 'evaluations')
            ));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value)
            ? value
            : (value && typeof value === 'object' ? Object.values(value) : []);
        return Object.assign({}, state, {
            projects: rows(state.projects),
            surveys: rows(state.surveys),
            harnesses: rows(state.harnesses),
            tasks: rows(state.tasks),
            evaluations: state.evaluations && typeof state.evaluations === 'object' && !Array.isArray(state.evaluations)
                ? state.evaluations
                : {}
        });
    }

    private async fetchWorkspaceState() {
        const response = await fetch(this.workspaceStateUrl, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('REVIEW_WORKSPACE_STATE_UNAVAILABLE');
        const payload = await response.json();
        const state = this.normalizeWorkspaceState(payload);
        if (!state || !Array.isArray(state.projects)) {
            throw new Error('REVIEW_WORKSPACE_STATE_INVALID');
        }
        return state;
    }

    private async mutateWorkspace(request: any) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(request));
        const response = await fetch(this.workspaceManagementUrl, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            body
        });
        let payload: any = null;
        try {
            payload = await response.json();
        } catch (error) {
            payload = null;
        }
        const responseCode = Number(payload?.code ?? payload?.status ?? response.status);
        const responseMessage = payload?.message || payload?.data?.message || payload?.error?.message;
        if (!response.ok || (Number.isFinite(responseCode) && responseCode >= 400)) {
            throw new Error(responseMessage || '프로젝트 설정을 서버에 저장하지 못했습니다.');
        }
        const candidates = [payload?.data?.data, payload?.data, payload?.result, payload];
        const result = candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && candidate.state && typeof candidate.state === 'object');
        const state = this.normalizeWorkspaceState({ state: result?.state });
        if (!result || !state) {
            throw new Error('프로젝트 설정 저장 응답이 올바르지 않습니다.');
        }
        return { ...result, state };
    }

    private async loadWorkspaceState() {
        try {
            this.workspaceState = await this.fetchWorkspaceState();
            this.workspaceStateLoaded = true;
            this.workspaceLoadError = '';
        } catch (error) {
            this.workspaceState = null;
            this.workspaceStateLoaded = false;
            this.workspaceLoadError = error instanceof Error
                ? error.message
                : '프로젝트 상세를 불러오지 못했습니다.';
        }
    }

    private numericValue(...values: any[]) {
        for (const value of values) {
            if (value === null || value === undefined || value === '') continue;
            const numeric = Number(value);
            if (Number.isFinite(numeric)) return numeric;
        }
        return null;
    }

    private async loadProjectReviewerOptions() {
        this.projectReviewersLoading = true;
        this.projectReviewersError = '';
        try {
            const response = await fetch('/wiz/api/page.experts/registered_users', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Accept': 'application/json' }
            });
            const payload = await response.json();
            const code = payload?.code;
            const data = payload?.data;
            if (code !== 200 || !Array.isArray(data)) {
                throw new Error(data?.message || '검수자 목록을 불러오지 못했습니다.');
            }
            const seen = new Set<string>();
            this.projectReviewerOptions = data
                .filter((row: any) => !row?.isAdmin && ['reviewer', '검수자'].includes(String(row?.role || '').trim()))
                .map((row: any) => ({
                    id: String(row?.id || '').trim(),
                    name: String(row?.name || row?.email || '').trim(),
                    email: String(row?.email || '').trim()
                }))
                .filter((row: any) => row.id && row.email && !seen.has(row.id) && seen.add(row.id))
                .sort((left: any, right: any) => left.name.localeCompare(right.name, 'ko'));
        } catch (error) {
            this.projectReviewerOptions = [];
            this.projectReviewersError = error instanceof Error
                ? error.message
                : '검수자 목록을 불러오지 못했습니다.';
        } finally {
            this.projectReviewersLoading = false;
        }
    }

    public selectedProjectReviewers(setting: any) {
        const selected = Array.isArray(setting?.reviewers) ? setting.reviewers : [];
        if (selected.length) return selected;
        const reviewerId = String(setting?.reviewerId || '').trim();
        if (!reviewerId) return [];
        return [{
            id: reviewerId,
            name: String(setting?.reviewerName || '').trim(),
            email: String(setting?.reviewerEmail || '').trim()
        }];
    }

    public isProjectReviewerSelected(setting: any, reviewerId: string) {
        return this.selectedProjectReviewers(setting)
            .some((row: any) => String(row?.id || '') === String(reviewerId || ''));
    }

    public async toggleProjectReviewer(reviewerId: string, event: any) {
        const setting = this.settingsDraft?.qa;
        if (!setting) return;
        const reviewer = this.projectReviewerOptions.find((row: any) => row.id === String(reviewerId || ''));
        if (!reviewer) return;
        const checked = !!event?.target?.checked;
        const selected = this.selectedProjectReviewers(setting)
            .map((row: any) => this.projectReviewerOptions.find(
                (option: any) => option.id === String(row?.id || '')
            ) || row)
            .filter((row: any) => row && row.id !== reviewer.id);
        if (checked) selected.push(reviewer);
        setting.reviewers = selected.map((row: any) => ({
            id: row.id,
            name: row.name,
            email: row.email
        }));
        const primary = setting.reviewers[0] || {};
        setting.reviewerId = String(primary.id || '');
        setting.reviewerName = String(primary.name || '');
        setting.reviewerEmail = String(primary.email || '');
        this.clearProjectSettingValidationField('reviewerId');
        await this.service.render();
    }

    public projectReviewerLabel(setting: any) {
        const reviewers = this.selectedProjectReviewers(setting);
        if (!reviewers.length) return '미지정';
        const primary = reviewers[0];
        const name = String(primary?.name || primary?.email || '').trim();
        const email = String(primary?.email || '').trim();
        const suffix = reviewers.length > 1 ? ` 외 ${reviewers.length - 1}명` : '';
        return `${name}${!suffix && email && email !== name ? ' · ' + email : ''}${suffix}`;
    }

    public projectReviewerPickerLabel(setting: any) {
        const count = this.selectedProjectReviewers(setting).length;
        return count ? `${count}명 선택됨` : '검수자를 선택하세요';
    }

    private async persistProjectReviewerAssignments(setting: any, showSuccess: boolean = false) {
        const reviewers = this.selectedProjectReviewers(setting).map((reviewer: any) => ({
            id: String(reviewer?.id || '').trim(),
            name: String(reviewer?.name || '').trim(),
            email: String(reviewer?.email || '').trim()
        }));
        if (!reviewers.length) {
            this.settingsValidationFields = { ...this.settingsValidationFields, reviewerId: 'QA 검수자를 1명 이상 선택해주세요.' };
            this.settingsValidationMessages = Object.keys(this.settingsValidationFields)
                .map((key: string) => this.settingsValidationFields[key]);
            await this.service.render();
            return false;
        }
        try {
            const body = new URLSearchParams();
            body.set('payload', JSON.stringify({ project_id: this.project.id, reviewers }));
            const response = await fetch(this.qaReviewAssignmentUrl, {
                method: 'POST',
                credentials: 'same-origin',
                cache: 'no-store',
                headers: { Accept: 'application/json' },
                body
            });
            let payload: any = null;
            try {
                payload = await response.json();
            } catch (error) {
                payload = null;
            }
            if (!response.ok) throw new Error(payload?.message || '검수자 배정을 저장하지 못했습니다.');
            this.workspaceState = await this.fetchWorkspaceState();
            if (this.projectSettings?.qa) Object.assign(this.projectSettings.qa, {
                reviewers: this.cloneValue(reviewers),
                reviewerId: reviewers[0].id,
                reviewerName: reviewers[0].name,
                reviewerEmail: reviewers[0].email
            });
            if (this.settingsDraft?.qa) Object.assign(this.settingsDraft.qa, {
                reviewers: this.cloneValue(reviewers),
                reviewerId: reviewers[0].id,
                reviewerName: reviewers[0].name,
                reviewerEmail: reviewers[0].email
            });
            if (showSuccess) {
                await this.service.modal.success(`${reviewers.length}명의 검수자 배정을 저장했습니다.`);
            }
            return true;
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '검수자 배정을 저장하지 못했습니다.',
                false,
                '확인'
            );
            return false;
        }
    }

    public async saveProjectReviewerAssignments() {
        if (this.projectReviewerAssignmentSaving) return;
        this.projectReviewerAssignmentSaving = true;
        await this.service.render();
        try {
            await this.persistProjectReviewerAssignments(this.settingsDraft?.qa, true);
        } finally {
            this.projectReviewerAssignmentSaving = false;
            await this.service.render();
        }
    }

    private serverProject(id: string) {
        const projects = Array.isArray(this.workspaceState?.projects) ? this.workspaceState.projects : [];
        return projects.find((project: any) => String(project?.id || '') === String(id || '')) || null;
    }

    private normalizeServerProject(row: any) {
        const settings = row?.settings && typeof row.settings === 'object' ? row.settings : {};
        const sourceIds = Array.isArray(row?.source_ids)
            ? row.source_ids
            : (Array.isArray(row?.sourceIds) ? row.sourceIds : []);
        const sourceTitles = Array.isArray(row?.source_titles)
            ? row.source_titles
            : (Array.isArray(row?.sourceTitles) ? row.sourceTitles : []);
        const outputs = {
            qa: row?.outputs?.qa !== undefined ? !!row.outputs.qa : !!settings.qa,
            kg: row?.outputs?.kg !== undefined ? !!row.outputs.kg : !!settings.kg
        };
        const qaCount = this.numericValue(row?.qaCount, row?.qa_count, row?.qa) || 0;
        const kgCount = this.numericValue(row?.kgCount, row?.kg_count, row?.kg, row?.tripleCount, row?.triple_count) || 0;
        return {
            ...row,
            id: String(row?.id || ''),
            name: row?.name || row?.title || '이름 없는 프로젝트',
            domain: row?.domain || row?.topic || '독도',
            owner: row?.owner || row?.reviewer || '미지정',
            updatedAt: row?.updatedAt || row?.updated_at || row?.updated || '—',
            createdAt: row?.createdAt || row?.created_at || row?.created || '—',
            configured: row?.configured !== undefined ? !!row.configured : !!(settings.qa || settings.kg),
            outputs,
            requestedOutputs: outputs,
            settings,
            qaCount,
            kgCount,
            nodeCount: this.numericValue(row?.nodeCount, row?.node_count, row?.nodes) || 0,
            edgeCount: this.numericValue(row?.edgeCount, row?.edge_count, row?.edges) || 0,
            sourceIds,
            sourceTitles,
            sourceCount: sourceIds.length,
            sourceLabel: row?.sourceLabel || row?.source_label || (sourceTitles.length ? sourceTitles.slice(0, 2).join(' · ') : '자료함 API'),
            harness: row?.harness || settings?.qa?.harness || settings?.kg?.harness || '미설정',
            harnessVersion: row?.harnessVersion || row?.harness_version || '',
            survey: row?.survey || settings?.qa?.survey || settings?.kg?.survey || '미설정',
            surveyVersion: row?.surveyVersion || row?.survey_version || '',
            target: this.numericValue(row?.target, row?.targetScore, row?.target_score, settings?.qa?.target, settings?.kg?.target) || 90,
            isContainer: true
        };
    }

    private currentProjectRouteSegments() {
        const path = String(this.router.url || '').split(/[?#]/, 1)[0];
        const matched = path.match(/^\/review-projects\/([^/]+)(?:\/([^/]+))?\/?$/);
        if (!matched) return null;
        const decode = (value: string) => {
            try {
                return decodeURIComponent(value || '');
            } catch (error) {
                return value || '';
            }
        };
        return { id: decode(matched[1]), tab: decode(matched[2] || '') };
    }

    public syncRoute() {
        this.destroyDatasetGraph();
        this.destroyKgResultGraph();
        const routerRoute = this.currentProjectRouteSegments();
        this.projectId = routerRoute?.id || WizRoute.segment.id || 'RV-2026-015';
        this.loadProject(this.projectId);
        this.loadProjectSettingOptions();
        const defaultTab = this.project.isContainer ? 'settings' : 'dataset';
        const routeTab = routerRoute?.tab || WizRoute.segment.tab || defaultTab;
        const allowedTabs = ['settings', 'quality', 'qa', 'qa-result', 'kg', 'kg-result', 'dataset', 'process', 'samples', 'rounds', 'history'];
        this.tab = allowedTabs.indexOf(routeTab) > -1 ? routeTab : defaultTab;
        if (this.project.isContainer && ['settings', 'quality', 'qa', 'qa-result', 'kg', 'kg-result'].indexOf(this.tab) < 0) {
            this.tab = 'settings';
        }
        const settingKinds = this.selectedProjectSettingKinds();
        if (!settingKinds.some((kind: any) => kind.key === this.projectSettingsActiveKindKey)) {
            this.projectSettingsActiveKindKey = settingKinds.length ? settingKinds[0].key : 'qa';
        }
        if (this.tab === 'settings') {
            const activeKind = this.activeProjectSettingKind();
            this.projectSettingsActiveStep = this.firstIncompleteProjectSettingStep(activeKind);
        }
    }

    private loadProject(id: string) {
        if (this.workspaceStateLoaded) {
            const serverProject = this.serverProject(id);
            if (serverProject) {
                this.loadContainerProject(this.normalizeServerProject(serverProject));
                return;
            }
            this.loadContainerProject({
                id,
                name: '프로젝트를 찾을 수 없습니다.',
                outputs: { qa: false, kg: false },
                settings: {},
                configured: false,
                sourceLabel: '자료함 API'
            });
            return;
        }
        const container = this.findStoredContainer(id);
        if (container) {
            this.loadContainerProject(container);
            return;
        }
        if (id === 'RV-2026-015') {
            this.loadTestProject();
        } else {
            this.loadFinanceProject(id);
        }
        this.project.isContainer = false;
        this.project.configured = true;
        this.loadExistingProjectSettings();
    }

    private readStoredContainers() {
        if (typeof window === 'undefined') return [];
        try {
            const rows = JSON.parse(window.localStorage.getItem(this.containerStorageKey) || '[]');
            return Array.isArray(rows) ? rows : [];
        } catch (error) {
            return [];
        }
    }

    private findStoredContainer(id: string) {
        return this.readStoredContainers().find((project: any) => project.id === id) || null;
    }

    private readStoredSettings() {
        if (typeof window === 'undefined') return {};
        try {
            const data = JSON.parse(window.localStorage.getItem(this.settingsStorageKey) || '{}');
            return data && typeof data === 'object' ? data : {};
        } catch (error) {
            return {};
        }
    }

    private readStoredCollection(storageKey: string) {
        if (typeof window === 'undefined') return [];
        try {
            const rows = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
            return Array.isArray(rows) ? rows : [];
        } catch (error) {
            return [];
        }
    }

    private normalizeProjectOptions(rows: any[], versionKey: string) {
        const seen: any = {};
        return rows.reduce((options: any[], row: any) => {
            const name = String((row && row.name) || '').trim();
            if (!name || seen[name]) return options;
            seen[name] = true;
            options.push({
                id: String((row && row.id) || '').trim(),
                name: name,
                meta: String((row && row[versionKey]) || '').trim(),
                version: String((row && row[versionKey]) || '').trim()
            });
            return options;
        }, []);
    }

    private ensureKnowledgeGraphTestHarness(rows: any[]) {
        const harnessName = '동북아 역사 지식그래프 생성 하네스';
        if (rows.some((row: any) => String((row && row.name) || '').trim() === harnessName)) {
            return rows;
        }

        const maxId = rows.reduce((max: number, row: any) => {
            const match = String((row && row.id) || '').match(/^HN-(\d+)$/);
            return match ? Math.max(max, Number(match[1])) : max;
        }, 0);
        const harness = {
            id: 'HN-' + String(maxId + 1).padStart(3, '0'),
            name: harnessName,
            category: '공통',
            version: 'v1.0',
            projects: 0,
            passRate: 0,
            delta: 0,
            owner: '관리자',
            updated: '2026.08.11',
            status: '실험',
            versions: [{
                version: 'v1.0',
                date: '2026.08.11',
                author: '관리자',
                passRate: 0,
                delta: '-',
                note: 'OpenAI 지식그래프 생성 테스트용 하네스 생성',
                active: true
            }]
        };
        const nextRows = [harness, ...rows];
        if (typeof window !== 'undefined') {
            try {
                window.localStorage.setItem(this.harnessStorageKey, JSON.stringify(nextRows));
            } catch (error) {
                // Keep the generated option available for this session even when storage is unavailable.
            }
        }
        return nextRows;
    }

    private includeCurrentProjectSettingOptions() {
        const settings = this.projectSettings || {};
        ['qa', 'kg'].forEach((key: string) => {
            const setting = settings[key];
            if (!setting) return;
            const harness = String(setting.harness || '').trim();
            const survey = String(setting.survey || '').trim();
            if (harness && !this.projectHarnessOptions.some((option: any) => option.name === harness)) {
                this.projectHarnessOptions.push({ name: harness, meta: '현재 설정' });
            }
            if (survey && !this.projectSurveyOptions.some((option: any) => option.name === survey)) {
                this.projectSurveyOptions.push({ name: survey, meta: '현재 설정' });
            }
        });
    }

    private loadProjectSettingOptions() {
        if (this.workspaceStateLoaded) {
            const harnesses = Array.isArray(this.workspaceState?.harnesses) ? this.workspaceState.harnesses : [];
            const surveys = Array.isArray(this.workspaceState?.surveys) ? this.workspaceState.surveys : [];
            this.projectHarnessOptions = this.normalizeProjectOptions(
                harnesses.filter((harness: any) => {
                    const bindings = Array.isArray(harness?.bindings) ? harness.bindings : [];
                    const selected = ['qa', 'kg'].some((key: string) => {
                        const setting = this.projectSettings?.[key];
                        return setting && (setting.harnessId === harness?.id || setting.harness === harness?.name);
                    });
                    return String(harness?.projectId || '') === this.project.id
                        || bindings.some((binding: any) => binding?.kind === '프로젝트' && String(binding?.id || '') === this.project.id)
                        || selected;
                }).map((harness: any) => {
                    const versions = Array.isArray(harness?.versions) ? harness.versions : [];
                    const active = versions.find((version: any) => version?.active === true);
                    return {
                        ...harness,
                        version: active?.version || active?.id || harness?.activeVersion
                            || harness?.active_version || harness?.version || ''
                    };
                }),
                'version'
            );
            this.projectSurveyOptions = this.normalizeProjectOptions(
                surveys.filter((survey: any) => {
                    const selected = ['qa', 'kg'].some((key: string) => {
                        const setting = this.projectSettings?.[key];
                        return setting && (setting.surveyId === survey?.id || setting.survey === survey?.name);
                    });
                    return String(survey?.projectId || '') === this.project.id || selected;
                }).map((survey: any) => ({
                    ...survey,
                    activeVersion: survey?.activeVersion || survey?.active_version || survey?.version || ''
                })),
                'activeVersion'
            );
            this.includeCurrentProjectSettingOptions();
            return;
        }
        const harnesses = this.ensureKnowledgeGraphTestHarness(
            this.readStoredCollection(this.harnessStorageKey)
        );
        const storedSurveys = this.readStoredCollection(this.surveyStorageKey);
        const surveys = storedSurveys.length
            ? storedSurveys
            : [{
                name: '동북아 역사 QA·지식그래프 대표 표본 검수서',
                activeVersion: 'v1.0'
            }];
        this.projectHarnessOptions = this.normalizeProjectOptions(harnesses, 'version');
        this.projectSurveyOptions = this.normalizeProjectOptions(surveys, 'activeVersion');
        this.includeCurrentProjectSettingOptions();
    }

    public projectHarnesses() {
        const rows = Array.isArray(this.workspaceState?.harnesses) ? this.workspaceState.harnesses : [];
        const setting = this.projectSettings?.qa || {};
        return rows.filter((row: any) => {
            const bindings = Array.isArray(row?.bindings) ? row.bindings : [];
            return String(row?.projectId || '') === this.project.id
                || bindings.some((binding: any) => binding?.kind === '프로젝트' && String(binding?.id || '') === this.project.id)
                || String(row?.id || '') === String(setting.harnessId || '')
                || (!!setting.harness && String(row?.name || '') === String(setting.harness));
        });
    }

    public projectSurveys() {
        const rows = Array.isArray(this.workspaceState?.surveys) ? this.workspaceState.surveys : [];
        const setting = this.projectSettings?.qa || {};
        return rows.filter((row: any) => {
            return String(row?.projectId || '') === this.project.id
                || String(row?.id || '') === String(setting.surveyId || '')
                || (!!setting.survey && String(row?.name || '') === String(setting.survey));
        });
    }

    public isProjectResourceConnected(kind: 'harness' | 'survey', resource: any) {
        const setting = this.projectSettings?.[this.activeProjectSettingKind()?.key || 'qa'] || {};
        const resourceId = String(resource?.id || '').trim();
        const configuredId = String(setting?.[`${kind}Id`] || '').trim();
        const resourceName = String(resource?.name || '').trim();
        const configuredName = String(setting?.[kind] || '').trim();
        return !!(
            resourceId && configuredId && resourceId === configuredId
            || resourceName && configuredName && resourceName === configuredName
        );
    }

    public async connectProjectResource(kind: 'harness' | 'survey', resource: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!resource || this.projectResourceBusy || this.isProjectResourceConnected(kind, resource)) return;
        this.projectResourceBusy = kind;
        await this.service.render();
        try {
            await this.bindProjectResource(kind, resource);
            await this.service.modal.success(
                `${resource.name} ${kind === 'harness' ? '하네스' : '설문지'}를 이 프로젝트에 연결했습니다.`
            );
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '프로젝트 리소스를 연결하지 못했습니다.',
                false,
                '확인'
            );
        } finally {
            this.projectResourceBusy = '';
            await this.service.render();
        }
    }

    public isCommonHarness(resource: any) {
        return resource?.adminDesignated === true
            || resource?.admin_designated === true
            || resource?.catalogVisible === true
            || resource?.catalog_visible === true;
    }

    public isCommonSurvey(resource: any) {
        return resource?.adminDesignated === true
            || resource?.admin_designated === true
            || resource?.catalogVisible === true
            || resource?.catalog_visible === true;
    }

    public async registerCommonHarness(harness: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        const harnessId = String(harness?.id || '').trim();
        if (!harnessId || this.commonHarnessRegistrationId || this.isCommonHarness(harness)) return;

        this.commonHarnessRegistrationId = harnessId;
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'harnesses',
                action: 'update',
                id: harnessId,
                patch: { adminDesignated: true }
            });
            this.workspaceState = result.state;
            await this.service.modal.success(`'${harness.name}' 하네스를 공통 하네스로 등록했습니다.`);
            await this.router.navigate(['/harnesses']);
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '공통 하네스로 등록하지 못했습니다.',
                false,
                '확인'
            );
        } finally {
            this.commonHarnessRegistrationId = '';
            await this.service.render();
        }
    }

    public async registerCommonSurvey(survey: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        const surveyId = String(survey?.id || '').trim();
        if (!surveyId || this.commonSurveyRegistrationId || this.isCommonSurvey(survey)) return;
        const catalogVersion = String(survey?.activeVersion || survey?.active_version || survey?.version || '').trim();
        if (!catalogVersion) return;

        this.commonSurveyRegistrationId = surveyId;
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'surveys',
                action: 'update',
                id: surveyId,
                patch: { adminDesignated: true, catalogVersion }
            });
            this.workspaceState = result.state;
            await this.service.modal.success(`'${survey.name}' ${catalogVersion} 버전을 공통 설문지로 등록했습니다.`);
            await this.router.navigate(['/surveys']);
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '공통 설문지로 등록하지 못했습니다.',
                false,
                '확인'
            );
        } finally {
            this.commonSurveyRegistrationId = '';
            await this.service.render();
        }
    }

    public resourceVersion(resource: any, kind: 'harness' | 'survey') {
        if (!resource) return '—';
        return String(kind === 'harness'
            ? (resource.activeVersion || resource.version || '')
            : (resource.activeVersion || resource.version || '')) || '—';
    }

    public resourceOrigin(resource: any) {
        const origin = String(resource?.origin || '');
        if (origin === 'floating_ai') return '플로팅 AI 생성';
        if (origin === 'file_upload') return '사용자 파일 업로드';
        if (origin === 'common_harness') return '공통 하네스에서 복제';
        if (origin === 'common_survey') return '공통 설문지에서 복제';
        return resource?.projectId ? '프로젝트 전용' : '기존 연결 리소스';
    }

    public projectResourcePreviewVersions() {
        const versions = Array.isArray(this.projectResourcePreviewItem?.versions)
            ? this.projectResourcePreviewItem.versions.filter((version: any) => version && typeof version === 'object')
            : [];
        if (versions.length) return [...versions].reverse();
        if (!this.projectResourcePreviewItem) return [];
        return [{
            version: this.resourceVersion(this.projectResourcePreviewItem, this.projectResourcePreviewKind || 'harness'),
            active: true
        }];
    }

    public projectResourcePreviewSnapshot() {
        const item = this.projectResourcePreviewItem;
        if (!item) return null;
        const version = this.projectResourcePreviewVersions().find((row: any) => {
            return String(row?.version || row?.id || '') === String(this.projectResourcePreviewVersion || '');
        });
        if (!version) return item;
        const activeVersion = String(item.activeVersion || item.version || '');
        const versionName = String(version.version || version.id || '');
        return version.active === true || versionName === activeVersion
            ? { ...item, ...version }
            : version;
    }

    public projectResourcePreviewRules() {
        const snapshot = this.projectResourcePreviewSnapshot();
        return Array.isArray(snapshot?.rules)
            ? snapshot.rules.map((rule: any) => String(rule || '').trim()).filter(Boolean)
            : [];
    }

    public projectResourcePreviewQuestions() {
        const snapshot = this.projectResourcePreviewSnapshot();
        const rows = Array.isArray(snapshot?.dimensions)
            ? snapshot.dimensions
            : (Array.isArray(snapshot?.questionItems) ? snapshot.questionItems : []);
        return rows.filter((row: any) => row && typeof row === 'object');
    }

    public projectResourcePreviewDecisionOptions() {
        const snapshot = this.projectResourcePreviewSnapshot();
        return Array.isArray(snapshot?.decisionOptions) ? snapshot.decisionOptions : [];
    }

    public projectResourcePreviewIssueOptions() {
        const snapshot = this.projectResourcePreviewSnapshot();
        return Array.isArray(snapshot?.issueOptions)
            ? snapshot.issueOptions.filter((item: any) => item && typeof item === 'object')
            : [];
    }

    public projectResourcePreviewCommentFields() {
        const snapshot = this.projectResourcePreviewSnapshot();
        return Array.isArray(snapshot?.commentFields) ? snapshot.commentFields : [];
    }

    public projectResourcePreviewOptionLabel(option: any) {
        if (option && typeof option === 'object') {
            const label = String(option.label || option.text || option.value || '').trim();
            return option.score !== undefined && option.score !== null
                ? `${option.score}점${label ? ' · ' + label : ''}`
                : label;
        }
        return String(option || '').trim();
    }

    public projectResourcePreviewIssueLabel(issue: any) {
        const code = String(issue?.code || issue?.value || '').trim();
        const label = String(issue?.label || issue?.text || '').trim();
        return label || code;
    }

    public projectResourcePreviewVersionLabel(version: any) {
        const name = String(version?.version || version?.id || '버전 정보 없음');
        return version?.active === true ? `${name} · 현재 사용 중` : name;
    }

    private findProjectResource(kind: 'harness' | 'survey', setting: any) {
        const collection = kind === 'harness' ? 'harnesses' : 'surveys';
        const rows = Array.isArray(this.workspaceState?.[collection]) ? this.workspaceState[collection] : [];
        const id = String(setting?.[`${kind}Id`] || '');
        const name = String(setting?.[kind] || '');
        return rows.find((row: any) => id && String(row?.id || '') === id)
            || rows.find((row: any) => name && String(row?.name || '') === name)
            || null;
    }

    private projectResourceHasVersion(
        kind: 'harness' | 'survey', setting: any, version: any,
    ) {
        const normalized = String(version || '').trim();
        if (!normalized) return false;
        const resource = this.findProjectResource(kind, setting);
        const versions = Array.isArray(resource?.versions) ? resource.versions : [];
        if (!versions.length) {
            return normalized === String(resource?.activeVersion || resource?.version || '').trim();
        }
        return versions.some((row: any) => String(row?.version || row?.id || '').trim() === normalized);
    }

    public async openConfiguredProjectResourcePreview(kind: 'harness' | 'survey', setting: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        const resource = this.findProjectResource(kind, setting);
        if (!resource) {
            await this.service.modal.warning(`${kind === 'harness' ? '하네스' : '설문지'} 상세 정보를 찾을 수 없습니다.`, false, '확인');
            return;
        }
        await this.openProjectResourcePreview(kind, resource);
    }

    public async openProjectResourcePreview(kind: 'harness' | 'survey', resource: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!resource) return;
        this.projectResourcePreviewKind = kind;
        this.projectResourcePreviewItem = resource;
        const versions = Array.isArray(resource?.versions) ? resource.versions : [];
        const active = versions.find((version: any) => version?.active === true);
        this.projectResourcePreviewVersion = String(
            active?.version || active?.id || resource?.activeVersion || resource?.version
            || versions[versions.length - 1]?.version || versions[versions.length - 1]?.id || ''
        );
        this.projectResourcePreviewOpen = true;
        await this.service.render();
    }

    public async closeProjectResourcePreview() {
        this.projectResourcePreviewOpen = false;
        this.projectResourcePreviewKind = '';
        this.projectResourcePreviewItem = null;
        this.projectResourcePreviewVersion = '';
        await this.service.render();
    }

    public async openConfiguredProjectResourceEditor(kind: 'harness' | 'survey', setting: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        const resource = this.findProjectResource(kind, setting);
        if (!resource) {
            this.openProjectResourceAssistant(kind);
            return;
        }
        this.openProjectResourceEditor(kind, resource, event);
    }

    public openProjectResourceEditor(kind: 'harness' | 'survey' | '', resource: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.project?.id || !resource?.id || !['harness', 'survey'].includes(kind)) return;
        this.projectResourcePreviewOpen = false;
        void this.router.navigate(['/review-projects', this.project.id, 'resource-editor', kind, resource.id]);
    }

    public openProjectResourceAssistant(kind: 'harness' | 'survey') {
        if (!this.project?.id) return;
        void this.router.navigate(['/review-projects', this.project.id, 'resource-editor', kind, 'new']);
    }

    private async syncUpdatedProjectResource(detail: any) {
        const projectId = String(detail?.project_id || detail?.projectId || '');
        const resourceId = String(detail?.resource_id || detail?.resourceId || '');
        const kind = ['project', 'harness', 'survey'].includes(detail?.kind) ? detail.kind : '';
        if (!kind || !resourceId || projectId !== String(this.project?.id || '')) return;
        try {
            const latestState = await this.fetchWorkspaceState();
            if (kind === 'project') {
                const projects = Array.isArray(latestState?.projects) ? latestState.projects : [];
                const project = projects.find((item: any) => String(item?.id || '') === resourceId);
                if (!project) return;
                this.workspaceState = { ...(this.workspaceState || {}), projects };
                this.project.name = project.name;
                await this.service.render();
                return;
            }
            const collection = kind === 'harness' ? 'harnesses' : 'surveys';
            const rows = Array.isArray(latestState?.[collection]) ? latestState[collection] : [];
            const resource = rows.find((item: any) => String(item?.id || '') === resourceId);
            if (!resource) return;

            this.workspaceState = {
                ...(this.workspaceState || {}),
                [collection]: rows
            };
            if (!this.projectSettings.qa) this.projectSettings.qa = this.emptyOutputSetting();
            if (!this.settingsDraft.qa) this.settingsDraft.qa = this.cloneValue(this.projectSettings.qa);
            const version = this.resourceVersion(resource, kind);
            if (kind === 'harness') {
                Object.assign(this.projectSettings.qa, {
                    harness: resource.name, harnessId: resource.id, harnessVersion: version
                });
                Object.assign(this.settingsDraft.qa, {
                    harness: resource.name, harnessId: resource.id, harnessVersion: version
                });
                this.project.harness = resource.name;
            } else {
                Object.assign(this.projectSettings.qa, {
                    survey: resource.name, surveyId: resource.id, surveyVersion: version
                });
                Object.assign(this.settingsDraft.qa, {
                    survey: resource.name, surveyId: resource.id, surveyVersion: version
                });
                this.project.survey = resource.name;
            }
            this.clearProjectSettingValidationField(kind);
            this.loadProjectSettingOptions();
            await this.service.render();
        } catch (error) {
            return;
        }
    }

    public async uploadProjectHarness(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input?.files?.[0];
        if (!file || this.projectResourceBusy) return;
        this.projectResourceBusy = 'harness';
        await this.service.render();
        try {
            const text = await file.text();
            let rules: string[] = [];
            try {
                const data = JSON.parse(text);
                const source = Array.isArray(data) ? data : (data?.rules || data?.harness?.rules || []);
                if (Array.isArray(source)) rules = source.filter((value: any) => typeof value === 'string');
            } catch (error) {
                rules = text.split(/\r?\n/)
                    .map((line: string) => line.replace(/^\s*(?:[-*•]|\d+[.)])\s*/, '').trim())
                    .filter((line: string) => !!line);
            }
            rules = Array.from(new Set(rules.map((rule: string) => rule.trim()).filter(Boolean))).slice(0, 100);
            if (!rules.length) throw new Error('파일에서 하네스 규칙을 찾을 수 없습니다. JSON rules 배열 또는 줄 단위 텍스트를 사용해주세요.');
            const stem = file.name.replace(/\.[^.]+$/, '').trim() || '업로드 하네스';
            const version = 'v1.0';
            const result = await this.mutateWorkspace({
                resource: 'harnesses', action: 'create', item: {
                    name: `${this.project.name} · ${stem}`,
                    category: 'QA', version, activeVersion: version, projects: 1,
                    passRate: 0, delta: 0, owner: this.service.auth.session?.name || '관리자',
                    status: '사용 중', target: Number(this.projectSettings?.qa?.target || 90),
                    projectId: this.project.id, origin: 'file_upload', sourceFileName: file.name,
                    rules, bindings: [{
                        id: this.project.id, kind: '프로젝트', name: this.project.name,
                        version, status: '적용 중'
                    }],
                    testRuns: [], versions: [{
                        version, date: new Date().toISOString(), author: this.service.auth.session?.name || '관리자',
                        passRate: 0, delta: '-', note: `${file.name}에서 업로드`, active: true, rules
                    }]
                }
            });
            this.workspaceState = this.normalizeWorkspaceState({ state: result.state });
            await this.bindProjectResource('harness', result.item);
            await this.service.modal.success('업로드한 하네스를 이 QA 프로젝트에 연결했습니다.');
        } catch (error) {
            await this.service.modal.warning(error instanceof Error ? error.message : '하네스를 업로드하지 못했습니다.', false, '확인');
        } finally {
            this.projectResourceBusy = '';
            if (input) input.value = '';
            await this.service.render();
        }
    }

    public async uploadProjectSurvey(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input?.files?.[0];
        if (!file || this.projectResourceBusy) return;
        this.projectResourceBusy = 'survey';
        await this.service.render();
        try {
            const body = new FormData();
            body.append('file', file);
            const response = await fetch('/api/v1/review-workspace/survey-document', {
                method: 'POST', credentials: 'same-origin', cache: 'no-store', body
            });
            const payload = await response.json();
            const document = payload?.data?.data || payload?.data || payload?.result || payload;
            if (!response.ok || !document?.url) throw new Error(payload?.message || '설문지 문서를 처리하지 못했습니다.');
            const fallbackDimensions = [
                { key: 'question_quality', label: '질문 적절성', question: '질문의 대상과 요구사항이 명확하고 원문으로 답할 수 있습니까?' },
                { key: 'answer_accuracy', label: '답변 정확성', question: '답변의 내용과 핵심 사실이 원문과 정확히 일치합니까?' },
                { key: 'evidence_quality', label: '근거 적절성', question: '제시된 근거가 답변의 핵심 내용을 직접적이고 충분하게 뒷받침합니까?' },
                { key: 'qa_composition', label: 'QA 구성 일치성', question: '질문·답변·근거·분류 라벨이 서로 자연스럽고 일관되게 연결됩니까?' },
                { key: 'format_quality', label: '표현·형식 완결성', question: '중복이나 모호한 표현 없이 문장과 형식이 완결되어 있습니까?' },
                { key: 'overall_quality', label: '종합 활용성', question: '전체적으로 수정 없이 사용할 수 있는 QA 품질입니까?' }
            ];
            const schema = document.survey_schema || {};
            const dimensions = Array.isArray(schema.dimensions) && schema.dimensions.length ? schema.dimensions : fallbackDimensions;
            const version = 'v1.0';
            const stem = file.name.replace(/\.[^.]+$/, '').trim() || '업로드 설문지';
            const item: any = {
                name: `${this.project.name} · ${stem}`, category: '프로젝트 QA', activeVersion: version,
                questions: dimensions.length, questionItems: dimensions, dimensions, usage: 0,
                owner: this.service.auth.session?.name || '관리자', status: '사용 중',
                description: `${this.project.name} QA 검수용 업로드 설문지`, pdfUrl: document.url,
                pdfPages: Number(document.pages || 1), projectId: this.project.id, origin: 'file_upload',
                sourceFileName: file.name, decisionOptions: schema.decisionOptions || [],
                issueOptions: schema.issueOptions || [], commentFields: schema.commentFields || [],
                versions: [{
                    version, date: new Date().toISOString(), author: this.service.auth.session?.name || '관리자',
                    note: `${file.name}에서 업로드`, active: true, questions: dimensions.length,
                    questionItems: dimensions, dimensions, pdfUrl: document.url, pdfPages: Number(document.pages || 1)
                }]
            };
            if (schema.sourcePage) item.sourcePage = schema.sourcePage;
            if (schema.extractionVersion) item.extractionVersion = schema.extractionVersion;
            const result = await this.mutateWorkspace({ resource: 'surveys', action: 'create', item });
            this.workspaceState = this.normalizeWorkspaceState({ state: result.state });
            await this.bindProjectResource('survey', result.item);
            await this.service.modal.success('업로드한 설문지를 이 QA 프로젝트에 연결했습니다.');
        } catch (error) {
            await this.service.modal.warning(error instanceof Error ? error.message : '설문지를 업로드하지 못했습니다.', false, '확인');
        } finally {
            this.projectResourceBusy = '';
            if (input) input.value = '';
            await this.service.render();
        }
    }

    private async bindProjectResource(kind: 'harness' | 'survey', resource: any) {
        if (!resource) return;
        if (!this.projectSettings.qa) this.projectSettings.qa = this.emptyOutputSetting();
        const setting = this.projectSettings.qa;
        const version = this.resourceVersion(resource, kind);
        if (kind === 'harness') {
            setting.harness = resource.name;
            setting.harnessId = resource.id;
            setting.harnessVersion = version;
        } else {
            setting.survey = resource.name;
            setting.surveyId = resource.id;
            setting.surveyVersion = version;
        }
        this.settingsDraft = this.cloneValue(this.projectSettings);
        this.project.configured = this.selectedProjectSettingKinds().every((item: any) => this.isProjectSettingComplete(item));
        this.applySettingsToProject();
        await this.persistProjectSettings();
        this.workspaceState = await this.fetchWorkspaceState();
        this.loadProject(this.project.id);
        this.loadProjectSettingOptions();
    }

    public projectQualitySummary() {
        const projectTasks = (Array.isArray(this.workspaceState?.tasks) ? this.workspaceState.tasks : [])
            .filter((task: any) => String(task?.projectId || task?.project_id || '') === this.project.id && String(task?.kind || '').toLowerCase() === 'qa');
        const harnessVersion = String(this.projectSettings?.qa?.harnessVersion || '');
        const surveyVersion = String(this.projectSettings?.qa?.surveyVersion || '');
        const currentTasks = projectTasks.filter((task: any) => {
            return (!harnessVersion || String(task?.harnessVersion || '') === harnessVersion)
                && (!surveyVersion || String(task?.surveyVersion || '') === surveyVersion);
        });
        const tasks = currentTasks;
        const evaluations = this.workspaceState?.evaluations || {};
        const completed = tasks
            .map((task: any) => ({ task, evaluation: evaluations[String(task?.id || '')] }))
            .filter((row: any) => !!row.evaluation)
            .sort((a: any, b: any) => String(b.evaluation.recorded_at || '').localeCompare(String(a.evaluation.recorded_at || '')));
        const latest = completed[0]?.evaluation || null;
        const rawProject = this.serverProject(this.project.id) || {};
        const target = Number(this.projectSettings?.qa?.target || rawProject?.target || 90);
        const loopStatus = String(rawProject?.reviewLoop?.status || '');
        const loopScore = rawProject?.reviewLoop?.score;
        const score = loopScore !== null && loopScore !== undefined && Number.isFinite(Number(loopScore))
            ? Number(loopScore)
            : (latest && Number.isFinite(Number(latest.score)) ? Number(latest.score) : null);
        return {
            taskCount: tasks.length,
            completedCount: completed.length,
            pendingCount: Math.max(0, tasks.length - completed.length),
            score,
            target,
            reached: loopStatus === 'target_met' || score !== null && score >= target && loopStatus !== 'review_pending',
            canImprove: score !== null && score < target && loopStatus === 'feedback_ready',
            priorities: Array.isArray(rawProject?.reviewLoop?.priorities) ? rawProject.reviewLoop.priorities : [],
            loopStatus
        };
    }

    public projectHasQaResult() {
        return Number(this.project?.qaCount || 0) > 0
            || Number(this.qaPersistedResult?.qa_count || this.qaResult?.qa_count || 0) > 0
            || !!this.qaPersistedResult?.artifact;
    }

    public async prepareProjectQaReview() {
        if (this.projectQualityBusy) return;
        this.projectQualityBusy = true;
        await this.service.render();
        try {
            const result = await this.postProjectWorkflow(this.qaReviewTaskUrl);
            const task = result?.task;
            if (!task?.id) throw new Error('검수 작업을 준비하지 못했습니다.');
            this.service.href('/human-reviews');
        } catch (error) {
            await this.service.modal.warning(error instanceof Error ? error.message : '검수 작업을 준비하지 못했습니다.', false, '확인');
        } finally {
            this.projectQualityBusy = false;
            await this.service.render();
        }
    }

    public async openUpdatedQaGeneration() {
        await this.navigateToQaGeneration();
    }

    public async improveProjectQuality(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        const targetTab = 'quality';
        const targetUrl = `/review-projects/${encodeURIComponent(String(this.project.id || ''))}/${targetTab}`;
        let navigated = false;
        try {
            navigated = await this.router.navigateByUrl(targetUrl);
        } catch (error) {
            navigated = false;
        }

        if (navigated && this.currentProjectRouteSegments()?.tab === targetTab) {
            if (this.tab !== targetTab) {
                this.syncRoute();
                await this.service.render();
                await this.prepareOutputDetail(true);
            }
            return;
        }

        if (typeof window !== 'undefined') {
            window.location.assign(targetUrl);
            return;
        }

        this.tab = targetTab;
        await this.service.render();
        await this.prepareOutputDetail(true);
    }

    public async loadQualityCenter(force: boolean = false) {
        if (this.qualityCenterLoading || (!force && this.qualityCenter?.project?.id === this.project.id)) return;
        this.qualityCenterLoading = true;
        this.qualityCenterError = '';
        await this.service.render();
        try {
            const query = new URLSearchParams({ project_id: String(this.project.id || '') });
            const response = await fetch(`${this.qualityImprovementUrl}?${query.toString()}`, {
                method: 'GET', credentials: 'same-origin', cache: 'no-store',
                headers: { Accept: 'application/json' }
            });
            const payload = await response.json();
            if (!response.ok) throw new Error(payload?.message || '품질 개선 현황을 불러오지 못했습니다.');
            this.qualityCenter = payload?.data?.data || payload?.data || payload?.result || payload;
            const reviews = Array.isArray(this.qualityCenter?.reviews) ? this.qualityCenter.reviews : [];
            if (!reviews.some((row: any) => row.id === this.qualitySelectedReviewId)) {
                this.qualitySelectedReviewId = reviews[0]?.id || '';
            }
        } catch (error) {
            this.qualityCenter = null;
            this.qualityCenterError = error instanceof Error ? error.message : '품질 개선 현황을 불러오지 못했습니다.';
        } finally {
            this.qualityCenterLoading = false;
            await this.service.render();
        }
    }

    private async qualityCenterRequest(request: any) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify({ ...request, project_id: this.project.id }));
        const response = await fetch(this.qualityImprovementUrl, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store',
            headers: { Accept: 'application/json' }, body
        });
        let payload: any = null;
        try {
            payload = await response.json();
        } catch (error) {
            payload = null;
        }
        if (!response.ok) throw new Error(payload?.message || '품질 개선 요청을 처리하지 못했습니다.');
        const result = payload?.data?.data || payload?.data || payload?.result || payload;
        if (!result || typeof result !== 'object') throw new Error('품질 개선 응답이 올바르지 않습니다.');
        this.qualityCenter = result;
        return result;
    }

    public async analyzeQualityFeedback() {
        if (this.qualityProposalBusy) return;
        this.qualityProposalBusy = 'analyze';
        await this.service.render();
        try {
            const result = await this.qualityCenterRequest({ action: 'analyze' });
            const count = Array.isArray(result?.plan?.proposals) ? result.plan.proposals.length : 0;
            this.qualityWorkspaceTab = 'proposals';
            await this.service.modal.success(`검수 결과를 분석해 개선 제안 ${count}건과 다시 확인할 검수 사례를 준비했습니다.`);
        } catch (error) {
            await this.service.modal.warning(error instanceof Error ? error.message : '검수 결과를 분석하지 못했습니다.', false, '확인');
        } finally {
            this.qualityProposalBusy = '';
            await this.service.render();
        }
    }

    public async decideQualityProposal(proposal: any, decision: 'approved' | 'hold' | 'rejected' | 'pending') {
        const plan = this.qualityCenter?.plan;
        if (!plan?.id || !proposal?.id || this.qualityProposalBusy) return;
        this.qualityProposalBusy = String(proposal.id);
        await this.service.render();
        try {
            await this.qualityCenterRequest({
                action: 'decide', plan_id: plan.id, proposal_id: proposal.id, decision,
                edited_value: String(proposal.edited_value || ''),
                note: String(proposal.decision_note || '')
            });
        } catch (error) {
            await this.service.modal.warning(error instanceof Error ? error.message : '개선안 결정을 저장하지 못했습니다.', false, '확인');
        } finally {
            this.qualityProposalBusy = '';
            await this.service.render();
        }
    }

    public qualityApprovedProposalCount() {
        const proposals = Array.isArray(this.qualityCenter?.plan?.proposals) ? this.qualityCenter.plan.proposals : [];
        return proposals.filter((row: any) => row?.decision === 'approved').length;
    }

    public qualityPendingProposalCount() {
        const proposals = Array.isArray(this.qualityCenter?.plan?.proposals) ? this.qualityCenter.plan.proposals : [];
        return proposals.filter((row: any) => !row?.decision || row.decision === 'pending').length;
    }

    public qualityProposals(target: 'harness' | 'survey' = this.qualityProposalTarget) {
        const proposals = Array.isArray(this.qualityCenter?.plan?.proposals) ? this.qualityCenter.plan.proposals : [];
        return proposals.filter((row: any) => String(row?.target || '') === target);
    }

    public qualityProposalTargetCount(target: 'harness' | 'survey') {
        return this.qualityProposals(target).length;
    }

    public qualityProposalTargetPendingCount(target: 'harness' | 'survey') {
        return this.qualityProposals(target).filter((row: any) => !row?.decision || row.decision === 'pending').length;
    }

    public qualityProposalTargetApprovedCount(target: 'harness' | 'survey') {
        return this.qualityProposals(target).filter((row: any) => row?.decision === 'approved').length;
    }

    public qualityAppliedProposalIds() {
        const ids = this.qualityCenter?.plan?.application?.approved_proposal_ids;
        return Array.isArray(ids) ? ids.map((value: any) => String(value || '')) : [];
    }

    public qualityProposalDecisionLocked(proposal: any) {
        if (this.qualityCenter?.plan?.status === 'verified') return true;
        return this.qualityAppliedProposalIds().includes(String(proposal?.id || ''));
    }

    public qualityPlanReviewEditable() {
        const plan = this.qualityCenter?.plan;
        if (!plan || plan.status === 'verified') return false;
        const applied = new Set(this.qualityAppliedProposalIds());
        return this.qualityProposals('harness').concat(this.qualityProposals('survey')).some(
            (proposal: any) => !applied.has(String(proposal?.id || ''))
        );
    }

    public qualityUnappliedApprovedProposalCount() {
        const applied = new Set(this.qualityAppliedProposalIds());
        const proposals = Array.isArray(this.qualityCenter?.plan?.proposals) ? this.qualityCenter.plan.proposals : [];
        return proposals.filter(
            (proposal: any) => proposal?.decision === 'approved' && !applied.has(String(proposal?.id || ''))
        ).length;
    }

    public qualityProposalTargetComplete(target: 'harness' | 'survey') {
        return this.qualityProposalTargetPendingCount(target) === 0;
    }

    public qualityProposalCompletionHint() {
        const current = this.qualityProposalTarget;
        const other: 'harness' | 'survey' = current === 'harness' ? 'survey' : 'harness';
        const currentPending = this.qualityProposalTargetPendingCount(current);
        if (currentPending) return `미결정 개선안 ${currentPending}건의 처리 방향을 선택해주세요.`;
        if (!this.qualityProposalTargetComplete(other)) {
            return `완료하면 아직 검토하지 않은 ${other === 'harness' ? '하네스' : '설문지'} 탭으로 이동합니다.`;
        }
        return '두 탭의 검토가 완료되었습니다. 새 버전을 적용한 뒤 개선 효과 확인으로 이동합니다.';
    }

    public async setQualityProposalTarget(target: 'harness' | 'survey') {
        if (target !== 'harness' && target !== 'survey') return;
        this.qualityProposalTarget = target;
        await this.service.render();
    }

    public async completeQualityProposalTarget() {
        if (this.qualityProposalBusy) return;
        const current = this.qualityProposalTarget;
        const other: 'harness' | 'survey' = current === 'harness' ? 'survey' : 'harness';
        const pending = this.qualityProposalTargetPendingCount(current);
        if (pending) {
            await this.service.modal.warning(`현재 탭에 결정하지 않은 개선안이 ${pending}건 있습니다.`, false, '확인');
            return;
        }
        if (!this.qualityProposalTargetComplete(other)) {
            this.qualityProposalTarget = other;
            await this.service.render();
            return;
        }
        if (!this.qualityApprovedProposalCount()) {
            await this.service.modal.warning('반영 승인한 개선안이 없어 새 버전을 만들 수 없습니다.', false, '확인');
            return;
        }
        await this.applyApprovedQualityPlan();
    }

    public async applyApprovedQualityPlan() {
        const plan = this.qualityCenter?.plan;
        if (!plan?.id || this.qualityProposalBusy) return;
        const incompleteTarget = (['harness', 'survey'] as const).find(
            (target) => !this.qualityProposalTargetComplete(target)
        );
        if (incompleteTarget) {
            this.qualityProposalTarget = incompleteTarget;
            await this.service.render();
            await this.service.modal.warning(
                `${incompleteTarget === 'harness' ? '하네스' : '설문지'} 개선안 검토를 먼저 완료해주세요.`,
                false,
                '확인'
            );
            return;
        }
        const approvedCount = this.qualityUnappliedApprovedProposalCount();
        if (!approvedCount && plan.application) {
            this.qualityWorkspaceTab = 'regression';
            await this.service.render();
            return;
        }
        if (!approvedCount) return;
        const confirmed = await this.service.modal.show({
            title: '승인한 개선안 적용',
            message: `승인한 ${approvedCount}개 항목만 하네스·설문지의 새 버전으로 적용할까요? 보류·미반영 항목은 변경되지 않습니다.`,
            cancel: '취소', action: '새 버전 적용', actionBtn: 'primary', status: 'info'
        });
        if (!confirmed) return;
        this.qualityProposalBusy = 'apply';
        await this.service.render();
        try {
            const result = await this.qualityCenterRequest({ action: 'apply', plan_id: plan.id });
            this.workspaceState = await this.fetchWorkspaceState();
            this.loadProject(this.project.id);
            this.loadProjectSettingOptions();
            const application = result?.plan?.application || {};
            this.qualityWorkspaceTab = 'regression';
            await this.service.modal.success(
                `승인안을 적용했습니다. 하네스 ${application.harness_version || '유지'} · 설문지 ${application.survey_version || '유지'} 기준으로 개선 효과 확인을 준비했습니다.`
            );
        } catch (error) {
            await this.service.modal.warning(error instanceof Error ? error.message : '승인한 개선안을 적용하지 못했습니다.', false, '확인');
        } finally {
            this.qualityProposalBusy = '';
            await this.service.render();
        }
    }

    public async runQualityRegression() {
        const plan = this.qualityCenter?.plan;
        if (!plan?.id || this.qualityProposalBusy) return;
        this.qualityProposalBusy = 'regression';
        await this.service.render();
        try {
            const result = await this.qualityCenterRequest({ action: 'run_regression', plan_id: plan.id });
            const run = result?.regression?.latest_run;
            if (run?.status === 'passed') {
                await this.service.modal.success(`개선 효과를 확인했습니다. 현재 점수는 ${run.current_score}점입니다.`);
            } else if (run?.status === 'failed') {
                await this.service.modal.warning(`추가 개선이 필요합니다. 개선 후 ${run.current_score}점 · 이전 ${run.baseline_score}점 · 목표 ${run.target}점`, false, '확인');
            } else {
                await this.service.modal.warning('개선된 설정으로 QA를 다시 생성하고 검수를 완료한 뒤 확인해주세요.', false, '확인');
            }
        } catch (error) {
            await this.service.modal.warning(error instanceof Error ? error.message : '개선 효과를 확인하지 못했습니다.', false, '확인');
        } finally {
            this.qualityProposalBusy = '';
            await this.service.render();
        }
    }

    public qualityRegressionCategoryLabel(category: any) {
        const labels: Record<string, string> = {
            '수정 기준': '수정이 필요했던 검수',
            '승인 기준': '품질을 유지할 검수',
            '자료 확인 기준': '근거를 다시 확인할 검수',
            '제외 기준': '제외 조건을 확인할 검수'
        };
        return labels[String(category || '')] || '이전 검수 사례';
    }

    public qualityRegressionStateTitle(run: any) {
        if (!this.qualityCenter?.plan?.application) return '개선안을 아직 적용하지 않았습니다';
        const status = String(run?.status || '');
        if (status === 'awaiting_review') return '개선된 QA의 새 검수를 기다리고 있어요';
        if (status === 'in_progress') return '새 검수가 진행 중이에요';
        if (status === 'passed') return '개선 효과를 확인했어요';
        if (status === 'failed') return '추가 개선이 필요해요';
        return '비교할 결과를 준비하고 있어요';
    }

    public qualityRegressionStateDescription(run: any) {
        if (!this.qualityCenter?.plan?.application) {
            return '승인한 개선안을 적용하면 이전 검수와 비교할 기준이 만들어집니다.';
        }
        const status = String(run?.status || '');
        if (status === 'awaiting_review') {
            return '개선된 하네스·설문지로 QA를 다시 생성하고 검수를 제출하면 이전 결과와 비교할 수 있습니다.';
        }
        if (status === 'in_progress') return '등록된 새 검수를 모두 마치면 이전 점수와 개선 후 점수를 비교합니다.';
        if (status === 'passed') return '개선 후 점수가 이전 점수와 목표 점수를 모두 충족했습니다.';
        if (status === 'failed') return '개선 후 점수가 비교 기준에 미치지 못해 개선안을 다시 살펴봐야 합니다.';
        return '새 검수 결과가 준비되면 이전 검수와 자동으로 비교합니다.';
    }

    public qualityRegressionStateClass(run: any) {
        const status = this.qualityCenter?.plan?.application ? String(run?.status || '') : 'before';
        return {
            'is-before': status === 'before',
            'is-waiting': status === 'awaiting_review' || status === 'in_progress' || !status,
            'is-passed': status === 'passed',
            'is-failed': status === 'failed'
        };
    }

    public qualityRegressionStateIcon(run: any) {
        if (!this.qualityCenter?.plan?.application) return 'fa-layer-group';
        const status = String(run?.status || '');
        if (status === 'passed') return 'fa-circle-check';
        if (status === 'failed') return 'fa-triangle-exclamation';
        if (status === 'in_progress') return 'fa-spinner';
        return 'fa-clock';
    }

    public qualityRegressionReviewProgress(run: any) {
        const taskCount = Number(run?.task_count || 0);
        const reviewedCount = Number(run?.reviewed_count || 0);
        return taskCount > 0 ? `${reviewedCount} / ${taskCount}건 완료` : '아직 새 검수 없음';
    }

    public qualityRegressionNextAction(run: any) {
        if (!this.qualityCenter?.plan?.application) return '검토를 마친 개선안을 먼저 적용해주세요.';
        if (String(run?.status || '') === 'in_progress') return '진행 중인 새 검수를 모두 완료해주세요.';
        if (String(run?.status || '') === 'failed') return '개선안과 검수 의견을 다시 확인해주세요.';
        return '개선된 설정으로 QA를 다시 생성하고 검수를 제출해주세요.';
    }

    public async restoreQualityVersion(resource: 'harness' | 'survey', version: any) {
        const versionId = String(version?.version || version?.id || '');
        if (!versionId || version?.active === true || this.qualityProposalBusy) return;
        const label = resource === 'harness' ? '하네스' : '설문지';
        const confirmed = await this.service.modal.show({
            title: `${label} ${versionId} 복원`,
            message: `${label}를 ${versionId} 기준으로 되돌릴까요? 변경 이력은 유지되며 복원 후 다시 생성·검수해야 합니다.`,
            cancel: '취소', action: '이 버전 복원', actionBtn: 'primary', status: 'info'
        });
        if (!confirmed) return;
        this.qualityProposalBusy = `restore-${resource}-${versionId}`;
        await this.service.render();
        try {
            await this.qualityCenterRequest({
                action: 'restore_version', resource, version_id: versionId
            });
            this.workspaceState = await this.fetchWorkspaceState();
            this.loadProject(this.project.id);
            this.loadProjectSettingOptions();
            await this.service.modal.success(`${label} ${versionId}을 현재 적용 버전으로 복원했습니다.`);
        } catch (error) {
            await this.service.modal.warning(error instanceof Error ? error.message : `${label} 버전을 복원하지 못했습니다.`, false, '확인');
        } finally {
            this.qualityProposalBusy = '';
            await this.service.render();
        }
    }

    public filteredQualityReviews() {
        const rows = Array.isArray(this.qualityCenter?.reviews) ? this.qualityCenter.reviews : [];
        return this.qualityReviewFilter === 'all'
            ? rows
            : rows.filter((row: any) => String(row?.decision || '') === this.qualityReviewFilter);
    }

    public selectedQualityReview() {
        const rows = this.filteredQualityReviews();
        return rows.find((row: any) => String(row?.id || '') === this.qualitySelectedReviewId) || rows[0] || null;
    }

    public async setQualityWorkspaceTab(tab: 'reviews' | 'feedback' | 'proposals' | 'regression') {
        this.qualityWorkspaceTab = tab;
        await this.service.render();
    }

    public async setQualityReviewFilter(filter: string) {
        if (!['all', 'approve', 'revise', 'verify', 'exclude'].includes(filter)) return;
        this.qualityReviewFilter = filter;
        const first = this.filteredQualityReviews()[0];
        this.qualitySelectedReviewId = String(first?.id || '');
        await this.service.render();
    }

    public async selectQualityReview(review: any) {
        this.qualitySelectedReviewId = String(review?.id || '');
        await this.service.render();
    }

    public qualityDecisionClass(decision: string) {
        return `is-${String(decision || 'unknown').replace(/[^a-z_-]/g, '')}`;
    }

    public qualityDecisionLabel(decision: string) {
        return ({
            approve: '승인', revise: '수정 필요', verify: '자료 확인 필요', exclude: '제외'
        } as any)[String(decision || '')] || '판정 없음';
    }

    public qualityDecisionDescription(decision: string) {
        return ({
            approve: '현재 QA를 그대로 사용할 수 있습니다.',
            revise: '표시된 문제를 수정한 뒤 다시 사용할 수 있습니다.',
            verify: '원문이나 추가 자료를 확인한 뒤 사용 여부를 결정해야 합니다.',
            exclude: '현재 QA는 사용 대상에서 제외합니다.'
        } as any)[String(decision || '')] || '검수자가 남긴 최종 판정입니다.';
    }

    public qualityReviewDate(value: any) {
        const raw = String(value || '').trim();
        if (!raw) return '—';
        const date = new Date(raw);
        if (Number.isNaN(date.getTime())) return raw.replace('T', ' ').replace(/\.\d+Z?$/, '').replace(/Z$/, '');
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hour12: false
        }).format(date);
    }

    public qualityReviewQuestions(review: any) {
        const snapshot = review?.survey_snapshot || review?.surveySnapshot || {};
        const source = Array.isArray(snapshot?.dimensions)
            ? snapshot.dimensions
            : (Array.isArray(snapshot?.questionItems) ? snapshot.questionItems : []);
        if (source.length) {
            return source.filter((row: any) => row && typeof row === 'object').map((row: any, index: number) => ({
                ...row,
                key: String(row.key || row.id || `question_${index + 1}`),
                label: String(row.label || row.name || `평가 문항 ${index + 1}`),
                question: String(row.question || row.description || ''),
                responseOptions: Array.isArray(row.responseOptions)
                    ? row.responseOptions
                    : (Array.isArray(row.response_options) ? row.response_options : [])
            }));
        }
        const values = review?.responses && typeof review.responses === 'object'
            ? review.responses
            : (review?.scores && typeof review.scores === 'object' ? review.scores : {});
        return Object.keys(values).map((key: string, index: number) => ({
            key, label: `평가 문항 ${index + 1}`, question: '', responseOptions: []
        }));
    }

    public qualityReviewDecisionOptions(review: any) {
        const snapshot = review?.survey_snapshot || review?.surveySnapshot || {};
        const rows = Array.isArray(snapshot?.decisionOptions)
            ? snapshot.decisionOptions
            : (Array.isArray(snapshot?.decision_options) ? snapshot.decision_options : []);
        return rows.length ? rows : [
            { value: 'approve', label: '승인', description: '현재 QA를 그대로 사용할 수 있습니다.' },
            { value: 'revise', label: '수정 후 사용', description: '표시된 내용을 수정한 뒤 사용할 수 있습니다.' },
            { value: 'verify', label: '자료 확인 필요', description: '원문 또는 추가 자료를 확인해야 합니다.' },
            { value: 'exclude', label: '제외', description: '현재 결과에서 제외합니다.' }
        ];
    }

    public qualityReviewIssueOptions(review: any) {
        const snapshot = review?.survey_snapshot || review?.surveySnapshot || {};
        const rows = Array.isArray(snapshot?.issueOptions)
            ? snapshot.issueOptions
            : (Array.isArray(snapshot?.issue_options) ? snapshot.issue_options : []);
        if (rows.length) return rows;
        return (Array.isArray(review?.issues) ? review.issues : []).map((code: any) => ({
            code: String(code || ''), label: this.qualityIssueLabel(code)
        }));
    }

    public qualityReviewCommentFields(review: any) {
        const snapshot = review?.survey_snapshot || review?.surveySnapshot || {};
        const rows = Array.isArray(snapshot?.commentFields)
            ? snapshot.commentFields
            : (Array.isArray(snapshot?.comment_fields) ? snapshot.comment_fields : []);
        return rows.length ? rows : [
            { key: 'problem_location', label: '문제 위치' },
            { key: 'comment', label: '검수 의견' },
            { key: 'request', label: '수정·확인 사항' }
        ];
    }

    public qualityReviewFieldValue(review: any, field: any) {
        const key = String(field?.key || field?.id || '');
        if (!key) return '기재 없음';
        const aliases: any = { problemLocation: 'problem_location', problem_location: 'problem_location' };
        const value = review?.[key] ?? review?.[aliases[key]];
        return String(value || '').trim() || '기재 없음';
    }

    public qualityReviewResponse(review: any, question: any) {
        const key = String(question?.key || question?.id || '');
        const responses = review?.responses && typeof review.responses === 'object' ? review.responses : {};
        const scores = review?.scores && typeof review.scores === 'object' ? review.scores : {};
        return responses[key] !== undefined && responses[key] !== null ? responses[key] : scores[key];
    }

    public qualityReviewOptionSelected(review: any, question: any, option: any) {
        const selected = this.qualityReviewResponse(review, question);
        const value = option && typeof option === 'object' ? (option.value ?? option.code ?? option.score) : option;
        return String(selected ?? '') === String(value ?? '');
    }

    public qualityReviewOptionLabel(option: any) {
        if (option && typeof option === 'object') return String(option.label || option.name || option.value || '');
        return String(option ?? '');
    }

    public qualityReviewOptionScore(option: any) {
        if (!option || typeof option !== 'object' || option.score === null || option.score === undefined) return '';
        return `${option.score}점`;
    }

    public qualityReviewFallbackAnswer(review: any, question: any) {
        const value = this.qualityReviewResponse(review, question);
        return value === undefined || value === null || value === '' ? '응답 없음' : `${value}${typeof value === 'number' ? '점' : ''}`;
    }

    public qualityReviewHasIssue(review: any, issue: any) {
        const code = String(issue?.code || issue?.value || issue || '');
        return (Array.isArray(review?.issues) ? review.issues : []).some((value: any) => String(value || '') === code);
    }

    public qualityIssueLabel(issue: any) {
        const code = String(issue?.code || issue?.value || issue || '');
        return ({
            Q_INVALID: '질문이 명확하지 않음', Q_VALUE: '질문·답변의 사실값 오류',
            EVIDENCE_GAP: '근거가 충분하지 않음', QA_MISMATCH: '질문과 답변이 맞지 않음',
            LABEL_MISMATCH: '분류 정보가 맞지 않음', CONTENT_MISSING: '필요한 내용이 빠짐',
            DATA_NOISE: '불필요한 문구가 섞임', PROJECT_RULE: '프로젝트 기준에 맞지 않음'
        } as any)[code] || code || '기타 의견';
    }

    public qualityFeedbackKindLabel(kind: any) {
        return ({ issue: '발견된 문제', comment: '검수 의견', request: '수정 요청', problem_location: '문제 위치', score: '점수 기준' } as any)[String(kind || '')] || '검수 의견';
    }

    public qualityFeedbackTitle(group: any) {
        if (String(group?.kind || '') === 'issue') return this.qualityIssueLabel(group?.text);
        return this.qualityFeedbackKindLabel(group?.kind);
    }

    public qualityFeedbackDescription(group: any) {
        const code = String(group?.text || '');
        const descriptions: any = {
            Q_INVALID: '질문의 대상이나 범위가 모호해 질문만으로 의도를 파악하기 어렵다는 의견입니다.',
            Q_VALUE: '인물·지명·날짜·수치 등 질문이나 답변의 사실값을 원문과 다시 대조해야 합니다.',
            EVIDENCE_GAP: '제시한 원문 근거만으로 답변의 핵심 내용을 충분히 확인하기 어렵습니다.',
            QA_MISMATCH: '질문에서 요구한 내용과 답변 또는 근거가 직접 연결되지 않습니다.',
            LABEL_MISMATCH: 'QA에 지정된 유형이나 분류 정보가 실제 내용과 맞지 않습니다.',
            CONTENT_MISSING: '답변에 필요한 핵심 조건이나 맥락이 빠져 있습니다.',
            DATA_NOISE: 'OCR 흔적, 중복 문구 등 QA 사용을 방해하는 내용이 포함되어 있습니다.',
            PROJECT_RULE: '이 프로젝트에서 정한 생성·표현·제외 기준을 다시 확인해야 합니다.'
        };
        return descriptions[code] || String(group?.text || '세부 의견이 없습니다.');
    }

    public qualityFeedbackPriorityLabel(priority: any) {
        const value = Number(priority || 3);
        return value <= 1 ? '먼저 확인' : value === 2 ? '우선 확인' : '함께 확인';
    }

    public qualityPlanStatusLabel(status: string) {
        if (String(status || '') === 'applied' && this.qualityPlanReviewEditable()) {
            return '일부 적용 · 추가 검토';
        }
        return ({
            awaiting_decision: '관리자 결정 대기', in_review: '검토 중', decided: '결정 완료',
            applied: '적용 완료', verified: '개선 효과 확인 완료'
        } as any)[String(status || '')] || '분석 대기';
    }

    private async postProjectWorkflow(url: string) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify({ project_id: this.project.id }));
        const response = await fetch(url, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store',
            headers: { Accept: 'application/json' }, body
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload?.message || '요청을 처리하지 못했습니다.');
        return payload?.data?.data || payload?.data || payload?.result || payload;
    }

    private cloneValue(value: any) {
        return JSON.parse(JSON.stringify(value));
    }

    private emptyOutputSetting() {
        return {
            source: '',
            sourceScope: 'all',
            sourceCategory: '',
            sourceCollection: '',
            harness: '',
            survey: '',
            target: 90,
            targetQaCount: 15,
            usageMode: 'rag',
            outOfScopePolicy: 'abstain',
            adversarialPolicy: 'evidence_led',
            languagePolicy: 'ko_preserve_original',
            primarySourceRatio: 0,
            neutralQuestionRatio: 0,
            reviewerId: '',
            reviewerName: '',
            reviewerEmail: '',
            reviewers: []
        };
    }

    private normalizeSettings(settings: any, outputs: any) {
        const normalized: any = {};
        const legacyCategoryCollections: any = {
            dokdo: 'dokdo-core-121',
            ancient: 'east-asia-relations',
            border: 'border-diplomacy',
            japan: 'japan-relations'
        };
        ['qa', 'kg'].forEach((key: string) => {
            if (!outputs[key]) {
                normalized[key] = null;
                return;
            }
            const setting = { ...this.emptyOutputSetting(), ...((settings && settings[key]) || {}) };
            if (key === 'qa') {
                setting.reviewers = Array.isArray(setting.reviewers)
                    ? setting.reviewers.filter((row: any) => row && row.id && row.email)
                    : [];
                if (!setting.reviewers.length && String(setting.reviewerId || '').trim()) {
                    setting.reviewers = [{
                        id: String(setting.reviewerId || '').trim(),
                        name: String(setting.reviewerName || '').trim(),
                        email: String(setting.reviewerEmail || '').trim()
                    }];
                }
            }
            if (setting.sourceScope === 'category') {
                setting.sourceScope = 'collection';
                setting.sourceCollection = legacyCategoryCollections[setting.sourceCategory] || '';
                setting.sourceCategory = '';
            }
            normalized[key] = setting;
        });
        return normalized;
    }

    private loadContainerProject(container: any) {
        const outputs = {
            qa: !!(container.outputs && container.outputs.qa),
            kg: !!(container.outputs && container.outputs.kg)
        };
        this.projectSettings = this.normalizeSettings(container.settings, outputs);
        this.settingsDraft = this.cloneValue(this.projectSettings);
        this.settingsEditing = false;
        this.settingsModalKind = null;

        this.project = {
            id: container.id,
            name: container.name,
            domain: container.domain || 'QA 프로젝트',
            status: container.status || container.lifecycle || (container.configured ? '설정 완료' : '설정 필요'),
            owner: container.owner || '미지정',
            created: container.createdAt || container.created_at || container.updatedAt || '—',
            currentRound: this.numericValue(container.currentRound, container.current_round, container.round) || 0,
            sourceVersion: container.sourceVersion || container.source_version || '고정 스냅샷',
            harness: container.harness || '미설정',
            harnessVersion: container.harnessVersion || container.harness_version || '',
            survey: container.survey || '미설정',
            surveyVersion: container.surveyVersion || container.survey_version || '',
            qaCount: this.numericValue(container.qaCount, container.qa_count, container.qa) || 0,
            kgCount: this.numericValue(container.kgCount, container.kg_count, container.kg) || 0,
            nodeCount: this.numericValue(container.nodeCount, container.node_count, container.nodes) || 0,
            edgeCount: this.numericValue(container.edgeCount, container.edge_count, container.edges) || 0,
            llmScore: this.numericValue(container.llmScore, container.llm_score),
            aiQualityScore: this.numericValue(
                container.aiQualityScore, container.ai_quality_score,
                container.combinedScore, container.combined_score
            ),
            humanScore: this.numericValue(container.humanScore, container.human_score),
            llmModel: container.llmModel || container.llm_model || 'OpenAI',
            llmRun: container.llmRun || container.llm_run || (container.qaCount || container.kgCount ? '생성 완료' : '미실행'),
            sampleSet: container.sampleSet || container.sample_set || '미생성',
            sampleSeed: container.sampleSeed || container.sample_seed || '미설정',
            surveyResponses: container.surveyResponses || container.survey_responses || '0 / 0',
            isContainer: true,
            configured: !!container.configured,
            outputs: outputs,
            sourceIds: container.sourceIds || container.source_ids || [],
            sourceTitles: container.sourceTitles || container.source_titles || []
        };
        const sourceIds = Array.isArray(this.project.sourceIds) ? this.project.sourceIds : [];
        const sourceTitles = Array.isArray(this.project.sourceTitles) ? this.project.sourceTitles : [];
        this.source = {
            provider: container.sourceLabel || '미설정',
            status: sourceIds.length ? '스냅샷 고정' : (container.configured ? '설정 완료' : '설정 필요'),
            title: sourceTitles.length ? sourceTitles.slice(0, 3).join(' · ') : (container.sourceLabel || '자료 소스 미설정'),
            documentId: sourceIds.length ? sourceIds[0] : '—',
            version: container.sourceVersion || container.source_version || '—',
            format: '—',
            page: '—',
            chunk: '—',
            chunkCount: this.numericValue(container.chunkCount, container.chunk_count) || 0,
            snapshot: container.snapshot || container.snapshotId || container.snapshot_id || (sourceIds.length ? `${sourceIds.length}개 문서 고정` : '미생성'),
            fixedAt: container.updatedAt || container.updated_at || '—'
        };
        this.gate = {
            target: container.target === null || container.target === undefined ? null : container.target,
            requiredResponse: this.numericValue(container.requiredResponse, container.required_response) || 100,
            status: container.gate || (container.configured ? '설정 완료' : '설정 필요'),
            current: this.numericValue(
                container.aiQualityScore, container.ai_quality_score,
                container.combinedScore, container.combined_score
            )
        };
        this.stages = [];
        this.llmChecks = [];
        this.samples = [];
        this.surveyDimensions = [];
        this.evaluation = this.emptyEvaluation();
        this.rounds = [];
        this.history = [];
        this.datasetMaterials = [];
        this.datasetChunks = [];
        this.datasetSettings = {};
        this.datasetRun = container.datasetRun || container.dataset_run || {
            status: '미생성',
            createdAt: '—',
            qa: { generated: 0, valid: 0 },
            kg: { generated: 0, valid: 0 }
        };
        this.datasetExistingResult = container.datasetExistingResult || container.dataset_existing_result || {
            nodes: 0,
            edges: 0,
            graphNodes: [],
            graphEdges: []
        };
        this.datasetConnection = {};
        this.selectedStage = 0;
        this.selectedSample = 0;
    }

    private loadExistingProjectSettings() {
        const requestedOutputs = this.project.requestedOutputs;
        const outputs = requestedOutputs ? {
            qa: !!requestedOutputs.qa,
            kg: !!requestedOutputs.kg
        } : {
            qa: Number(this.project.qaCount || 0) > 0,
            kg: Number(this.project.kgCount || 0) > 0
        };
        if (!outputs.qa && !outputs.kg) outputs.qa = true;
        this.project.outputs = outputs;

        const defaults: any = {};
        ['qa', 'kg'].forEach((key: string) => {
            if (!outputs[key]) {
                defaults[key] = null;
                return;
            }
            defaults[key] = {
                source: this.source.provider || '',
                harness: this.project.harness || '',
                survey: this.project.survey || '',
                target: this.gate.target || 90,
                targetQaCount: 15
            };
        });

        const stored = this.readStoredSettings()[this.project.id];
        this.projectSettings = this.normalizeSettings(stored || defaults, outputs);
        this.settingsDraft = this.cloneValue(this.projectSettings);
        this.settingsEditing = false;
        this.settingsModalKind = null;
    }

    public selectedProjectSettingKinds() {
        const outputs = this.project.outputs || {};
        return this.projectSettingKinds.filter((kind: any) => !!outputs[kind.key]);
    }

    public activeProjectSettingKind() {
        const kinds = this.selectedProjectSettingKinds();
        return kinds.find((kind: any) => kind.key === this.projectSettingsActiveKindKey)
            || kinds[0]
            || null;
    }

    public projectSourceSelectionLabel(setting: any) {
        if (!setting || !String(setting.source || '').trim()) return '설정 전';
        const source = String(setting.source).trim();
        if (source !== '자료함 API') return source;
        const scope = setting.sourceScope || 'all';
        if (scope === 'collection') {
            const collection = this.projectSourceCollections.find((item: any) => item.key === setting.sourceCollection);
            return collection
                ? `${source} · ${collection.label} · ${collection.count}${collection.countUnit ? ` ${collection.countUnit}` : '건'}`
                : `${source} · 컬렉션 선택 필요`;
        }
        return `${source} · 전체 자료`;
    }

    public projectSourceSelectionComplete(setting: any) {
        if (!setting || !String(setting.source || '').trim()) return false;
        if (setting.source !== '자료함 API') return true;
        const scope = setting.sourceScope || 'all';
        return scope === 'all'
            || (scope === 'collection' && !!setting.sourceCollection);
    }

    public projectSourceSelectionMeta(setting: any) {
        if (!setting || setting.source !== '자료함 API') return '';
        if (setting.sourceScope === 'collection') {
            const collection = this.projectSourceCollections.find((item: any) => item.key === setting.sourceCollection);
            return collection ? collection.examples : '';
        }
        return '게시된 전체 자료를 생성 시점의 버전으로 고정합니다.';
    }

    private clearProjectSourceValidation() {
        const next = { ...this.settingsValidationFields };
        delete next.source;
        delete next.sourceCategory;
        delete next.sourceCollection;
        this.settingsValidationFields = next;
        this.settingsValidationMessages = Object.keys(next).map((key: string) => next[key]);
    }

    public async handleProjectSourceChange(value: string, inlineKind?: any) {
        const kind = inlineKind || this.settingsModalKind;
        const setting = kind && this.settingsDraft && this.settingsDraft[kind.key];
        if (!setting) return;
        setting.source = value;
        if (value !== '자료함 API') {
            setting.sourceScope = 'all';
            setting.sourceCategory = '';
            setting.sourceCollection = '';
        } else if (!setting.sourceScope) {
            setting.sourceScope = 'all';
        }
        this.clearProjectSourceValidation();
        if (inlineKind) await this.persistInlineProjectSource(kind);
        await this.service.render();
    }

    public async selectProjectSourceScope(scope: string, inlineKind?: any) {
        const kind = inlineKind || this.settingsModalKind;
        const setting = kind && this.settingsDraft && this.settingsDraft[kind.key];
        if (!setting) return;
        setting.sourceScope = scope;
        if (scope === 'collection') {
            setting.sourceCollection = setting.sourceCollection || this.projectSourceCollections[0].key;
            setting.sourceCategory = '';
        } else {
            setting.sourceCategory = '';
            setting.sourceCollection = '';
        }
        this.clearProjectSourceValidation();
        if (inlineKind) await this.persistInlineProjectSource(kind);
        await this.service.render();
    }

    public async selectProjectSourceCollection(collection: any, inlineKind?: any) {
        const kind = inlineKind || this.settingsModalKind;
        const setting = kind && this.settingsDraft && this.settingsDraft[kind.key];
        if (!setting || !collection) return;
        setting.sourceScope = 'collection';
        setting.sourceCollection = collection.key;
        setting.sourceCategory = '';
        this.clearProjectSourceValidation();
        if (inlineKind) await this.persistInlineProjectSource(kind);
        await this.service.render();
    }

    private async persistInlineProjectSource(kind: any) {
        const draft = kind && this.settingsDraft?.[kind.key];
        if (!draft || !this.projectSourceSelectionComplete(draft)) return false;

        const next = this.cloneValue(this.projectSettings || {});
        const setting = next[kind.key] || this.emptyOutputSetting();
        ['source', 'sourceScope', 'sourceCategory', 'sourceCollection'].forEach((field: string) => {
            setting[field] = String(draft[field] || '').trim();
        });
        setting.sourceScope = setting.sourceScope || 'all';
        next[kind.key] = setting;
        this.projectSettings = next;
        this.project.configured = this.selectedProjectSettingKinds()
            .every((settingKind: any) => this.isProjectSettingComplete(settingKind, next));
        this.project.status = this.project.configured ? '설정 완료' : '설정 필요';

        this.projectSourceSaving = true;
        await this.service.render();
        try {
            const persisted = await this.persistProjectSettings();
            if (!persisted) return false;
            this.source.provider = setting.source;
            this.source.status = '설정 완료';
            this.source.title = this.projectSourceSelectionLabel(setting);
            return true;
        } finally {
            this.projectSourceSaving = false;
        }
    }

    private firstIncompleteProjectSettingStep(kind: any) {
        if (!kind) return 1;
        for (let step = 1; step <= 3; step += 1) {
            if (!this.projectSettingStepComplete(step, kind)) return step;
        }
        return 3;
    }

    public projectSettingStepComplete(step: number, kind?: any) {
        const targetKind = kind || this.activeProjectSettingKind();
        const setting = targetKind && this.projectSettings && this.projectSettings[targetKind.key];
        if (!targetKind || !setting) return false;
        if (step === 1) {
            return this.projectSourceSelectionComplete(setting)
                && !!String(setting.harness || '').trim();
        }
        if (step === 2) {
            const target = Number(setting.target);
            return !!String(setting.survey || '').trim()
                && (targetKind.key !== 'qa' || this.selectedProjectReviewers(setting).length > 0)
                && Number.isFinite(target) && target >= 1 && target <= 100;
        }
        return this.isProjectSettingComplete(targetKind);
    }

    public projectSettingStepStatus(step: number, kind?: any) {
        if (this.projectSettingStepComplete(step, kind)) return '완료';
        if (this.projectSettingsActiveStep === step) return '현재 설정 단계';
        return '대기 중';
    }

    public projectSettingRequiredCount(kind?: any) {
        const targetKind = kind || this.activeProjectSettingKind();
        return targetKind && targetKind.key === 'qa' ? 6 : 4;
    }

    public projectSettingDraftCompletedCount(kind?: any) {
        const targetKind = kind || this.activeProjectSettingKind();
        const setting = targetKind && this.settingsDraft && this.settingsDraft[targetKind.key];
        if (!targetKind || !setting) return 0;
        const checks = [
            this.projectSourceSelectionComplete(setting),
            !!String(setting.harness || '').trim(),
            !!String(setting.survey || '').trim(),
            Number.isFinite(Number(setting.target)) && Number(setting.target) >= 1 && Number(setting.target) <= 100
        ];
        if (targetKind.key === 'qa') {
            const targetQaCount = Number(setting.targetQaCount);
            checks.push(this.selectedProjectReviewers(setting).length > 0);
            checks.push(
                Number.isInteger(targetQaCount) && targetQaCount >= 1 && targetQaCount <= 150
                && this.qaUsageModeOptions.some((option: any) => option.value === setting.usageMode)
                && this.qaOutOfScopeOptions.some((option: any) => option.value === setting.outOfScopePolicy)
                && this.qaAdversarialOptions.some((option: any) => option.value === setting.adversarialPolicy)
                && this.qaLanguagePolicyOptions.some((option: any) => option.value === setting.languagePolicy)
            );
        }
        return checks.filter(Boolean).length;
    }

    public projectSettingsStepEyebrow() {
        if (this.projectSettingsActiveStep === 2) return 'EVALUATION STANDARD';
        if (this.projectSettingsActiveStep === 3) return 'OUTPUT CONFIGURATION';
        return 'CONNECTION SETUP';
    }

    public projectSettingsStepTitle() {
        if (this.projectSettingsActiveStep === 2) return '평가 기준';
        if (this.projectSettingsActiveStep === 3) return '생성 결과';
        return '연결 설정';
    }

    public projectSettingsStepDescription() {
        if (this.projectSettingsActiveStep === 2) return '사람 검수 설문과 목표 품질 점수를 설정합니다.';
        if (this.projectSettingsActiveStep === 3) return '생성할 결과의 형식과 목표 수량을 최종 확인합니다.';
        return '생성에 사용할 원문 자료와 하네스 버전을 연결합니다.';
    }

    public async setProjectSettingsStep(step: number) {
        this.projectSettingsActiveStep = Math.max(1, Math.min(3, Number(step) || 1));
        await this.service.render();
    }

    public async setProjectSettingsKind(kind: any) {
        if (!kind) return;
        this.projectSettingsActiveKindKey = kind.key;
        this.projectSettingsActiveStep = this.firstIncompleteProjectSettingStep(kind);
        await this.service.render();
    }

    public projectSettingsPrimaryLabel(kind?: any) {
        const targetKind = kind || this.activeProjectSettingKind();
        if (this.projectSettingsActiveStep === 1) return '다음: 평가 기준';
        if (this.projectSettingsActiveStep === 2) return '다음: 생성 결과';
        if (targetKind && this.isProjectSettingComplete(targetKind)) {
            return `${targetKind.code} 생성 화면 열기`;
        }
        return '설정 완료하기';
    }

    public async advanceProjectSettings(kind?: any) {
        const targetKind = kind || this.activeProjectSettingKind();
        if (!targetKind) return;
        if (!this.projectSettingStepComplete(this.projectSettingsActiveStep, targetKind)) {
            await this.openProjectSetting(targetKind);
            return;
        }
        if (this.projectSettingsActiveStep < 3) {
            await this.setProjectSettingsStep(this.projectSettingsActiveStep + 1);
            return;
        }
        await this.navigateToOutputDetail(targetKind);
    }

    public async resetActiveProjectSettings(kind?: any) {
        const targetKind = kind || this.activeProjectSettingKind();
        if (!targetKind || typeof window === 'undefined') return;
        const confirmed = window.confirm(`${targetKind.label} 설정을 초기화할까요?`);
        if (!confirmed) return;
        this.projectSettings[targetKind.key] = this.emptyOutputSetting();
        this.settingsDraft = this.cloneValue(this.projectSettings);
        this.project.configured = this.selectedProjectSettingKinds()
            .every((settingKind: any) => this.isProjectSettingComplete(settingKind));
        this.project.status = this.project.configured ? '설정 완료' : '설정 필요';
        this.projectSettingsActiveStep = 1;
        this.applySettingsToProject();
        const persisted = await this.persistProjectSettings();
        if (!persisted) return;
        await this.service.render();
    }

    public outputDetailKind() {
        if (this.tab !== 'qa' && this.tab !== 'kg') return null;
        return this.projectSettingKinds.find((kind: any) => kind.key === this.tab) || null;
    }

    public async navigateToOutputDetail(kind: any) {
        if (!kind || (kind.key !== 'qa' && kind.key !== 'kg')) return;
        const targetUrl = `/review-projects/${encodeURIComponent(String(this.project.id || ''))}/${kind.key}`;
        let navigated = false;
        try {
            navigated = await this.router.navigateByUrl(targetUrl);
        } catch (error) {
            navigated = false;
        }

        if (navigated && String(WizRoute.segment?.tab || '') === kind.key) {
            if (this.tab !== kind.key) {
                this.syncRoute();
                await this.service.render();
                await this.prepareOutputDetail(true);
            }
            return;
        }

        // The custom optional-tab matcher can occasionally leave the component on
        // the settings view even after Router reports navigation. Reloading the
        // canonical URL guarantees that the saved generation screen is opened.
        if (typeof window !== 'undefined') {
            window.location.assign(targetUrl);
            return;
        }

        this.tab = kind.key;
        await this.service.render();
        await this.prepareOutputDetail(true);
    }

    public async navigateToProjectSettings(kind?: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (kind && (kind.key === 'qa' || kind.key === 'kg')) {
            this.projectSettingsActiveKindKey = kind.key;
        }
        const targetTab = 'settings';
        const targetUrl = `/review-projects/${encodeURIComponent(String(this.project.id || ''))}/${targetTab}`;
        let navigated = false;
        try {
            navigated = await this.router.navigateByUrl(targetUrl);
        } catch (error) {
            navigated = false;
        }

        if (navigated && this.currentProjectRouteSegments()?.tab === targetTab) {
            if (this.tab !== targetTab) {
                this.syncRoute();
                await this.service.render();
                await this.prepareOutputDetail(true);
            }
            return;
        }

        if (typeof window !== 'undefined') {
            window.location.assign(targetUrl);
            return;
        }

        this.tab = targetTab;
        await this.service.render();
        await this.prepareOutputDetail(true);
    }

    public focusProjectSettings() {
        if (typeof document === 'undefined') return;
        const settings = document.getElementById('project-output-settings-grid') as HTMLElement;
        if (!settings) return;
        settings.scrollIntoView({ behavior: 'smooth', block: 'start' });
        settings.focus({ preventScroll: true });
    }

    public async handleOutputDetailPrimary(kind: any) {
        if (!kind) return;
        if (this.isProjectSettingComplete(kind)) {
            await this.prepareOutputDetail(true);
            return;
        }
        await this.openProjectSetting(kind);
    }

    public async prepareOutputDetail(force: boolean = false) {
        if (this.tab === 'quality') {
            this.destroyKgResultGraph();
            if (!this.generationRunning) this.generationModalKind = null;
            await this.loadQualityCenter(force);
            return;
        }
        if (this.tab === 'settings') {
            this.destroyKgResultGraph();
            if (this.project?.outputs?.qa) await this.restoreQaGenerationResult();
            if (!this.generationRunning) this.generationModalKind = null;
            return;
        }
        if (this.tab === 'qa-result') {
            this.destroyKgResultGraph();
            if (!this.generationRunning) this.generationModalKind = null;
            await this.loadQaResult(force);
            return;
        }
        if (this.tab === 'kg-result') {
            if (!this.generationRunning) this.generationModalKind = null;
            await this.loadKgResult(force);
            return;
        }
        this.destroyKgResultGraph();
        const kind = this.outputDetailKind();
        if (!kind) {
            if (!this.generationRunning) this.generationModalKind = null;
            return;
        }
        if (!force && this.generationModalKind && this.generationModalKind.key === kind.key) {
            if (
                this.generationLoading || this.generationRunning || this.generationResult
                || this.generationSources.length || Object.keys(this.generationAvailability || {}).length
            ) return;
        }
        this.generationModalKind = kind;
        if (!this.isProjectSettingComplete(kind)) {
            this.generationSources = [];
            this.generationAvailability = {};
            this.generationError = '';
            this.generationErrorCode = '';
            this.generationResult = null;
            await this.service.render();
            return;
        }
        await this.openOutputGeneration(kind);
    }

    public completedProjectSettingCount() {
        return this.selectedProjectSettingKinds()
            .filter((kind: any) => this.isProjectSettingComplete(kind))
            .length;
    }

    public projectSettingProgress() {
        const total = this.selectedProjectSettingKinds().length;
        return total ? Math.round(this.completedProjectSettingCount() / total * 100) : 0;
    }

    public nextIncompleteProjectSettingKind() {
        return this.selectedProjectSettingKinds()
            .find((kind: any) => !this.isProjectSettingComplete(kind)) || null;
    }

    public projectReadinessTasks() {
        const kind = this.activeProjectSettingKind();
        if (!kind) return [];
        const readinessSettings = this.settingsDraft && this.settingsDraft[kind.key]
            ? this.settingsDraft
            : this.projectSettings;
        const setting = readinessSettings?.[kind.key] || {};
        const sourceReady = this.projectSourceSelectionComplete(setting);
        const harnessResource = this.findProjectResource('harness', setting);
        const surveyResource = this.findProjectResource('survey', setting);
        const harnessReady = !!String(setting.harness || '').trim()
            && (!this.workspaceStateLoaded || !!harnessResource);
        const surveyReady = !!String(setting.survey || '').trim()
            && (!this.workspaceStateLoaded || !!surveyResource);
        const settingsReady = sourceReady && harnessReady && surveyReady
            && this.isProjectSettingComplete(kind, readinessSettings);
        const outputReady = kind.key === 'qa'
            ? this.projectHasQaResult()
            : Number(this.project?.kgCount || 0) > 0 || !!this.kgPersistedResult;
        const harnesses = this.projectHarnesses();
        const surveys = this.projectSurveys();
        const tasks: any[] = [
            {
                key: 'source',
                label: '자료함 연결',
                icon: 'fa-database',
                done: sourceReady,
                detail: sourceReady
                    ? this.projectSourceSelectionLabel(setting)
                    : 'QA 생성 설정에서 자료함과 사용할 자료 범위를 선택해주세요.',
                actionLabel: sourceReady ? '연결됨' : '자료함 연결하기'
            },
            {
                key: 'harness',
                label: '하네스 연결',
                icon: 'fa-cube',
                done: harnessReady,
                detail: harnessReady
                    ? `${setting.harness}${setting.harnessVersion ? ' · ' + setting.harnessVersion : ''}`
                    : (harnesses.length
                        ? `준비된 하네스 ${harnesses.length}개 중 사용할 항목을 연결해주세요.`
                        : 'QA 형식과 생성 규칙을 담은 하네스를 먼저 만들어주세요.'),
                actionLabel: harnessReady ? '연결됨' : (harnesses.length ? '하네스 선택하기' : '하네스 만들기')
            },
            {
                key: 'survey',
                label: '설문지 연결',
                icon: 'fa-clipboard-check',
                done: surveyReady,
                detail: surveyReady
                    ? `${setting.survey}${setting.surveyVersion ? ' · ' + setting.surveyVersion : ''}`
                    : (surveys.length
                        ? `준비된 설문지 ${surveys.length}개 중 사용할 항목을 연결해주세요.`
                        : '생성 결과를 평가할 사람 검수 설문지를 만들어주세요.'),
                actionLabel: surveyReady ? '연결됨' : (surveys.length ? '설문지 선택하기' : '설문지 만들기')
            },
            {
                key: 'settings',
                label: '생성 설정 확인',
                icon: 'fa-sliders',
                done: settingsReady,
                detail: settingsReady
                    ? `목표 ${setting.target}점 · ${kind.key === 'qa' ? 'QA ' + setting.targetQaCount + '개' : '지식그래프 생성'}`
                    : this.projectGenerationSettingGap(setting, kind),
                actionLabel: settingsReady ? '설정 완료' : '설정 마무리하기'
            },
            {
                key: 'output',
                label: `${kind.code} 생성`,
                icon: kind.key === 'qa' ? 'fa-wand-magic-sparkles' : 'fa-diagram-project',
                done: outputReady,
                blocked: !settingsReady,
                detail: outputReady
                    ? `${kind.label} 결과가 준비되었습니다.`
                    : (settingsReady
                        ? `모든 연결이 준비되었습니다. ${kind.label} 생성을 시작할 수 있습니다.`
                        : '자료·하네스·설문지와 생성 설정을 완료하면 실행할 수 있습니다.'),
                actionLabel: outputReady ? '결과 보기' : (settingsReady ? `${kind.code} 생성하기` : '선행 작업 확인')
            }
        ];
        const firstIncomplete = tasks.findIndex((task: any) => !task.done);
        return tasks.map((task: any, index: number) => ({
            ...task,
            state: task.done ? 'complete' : (index === firstIncomplete ? 'current' : 'pending')
        }));
    }

    public projectReadinessProgress() {
        const tasks = this.projectReadinessTasks();
        return tasks.length
            ? Math.round(tasks.filter((task: any) => task.done).length / tasks.length * 100)
            : 0;
    }

    public projectReadinessCompletedCount() {
        return this.projectReadinessTasks().filter((task: any) => task.done).length;
    }

    public projectNextRecommendation() {
        const tasks = this.projectReadinessTasks();
        const next = tasks.find((task: any) => !task.done);
        if (!next) {
            const kind = this.activeProjectSettingKind();
            return {
                key: 'output',
                done: true,
                title: '프로젝트 준비와 생성이 완료되었습니다',
                description: '생성 결과를 확인하고 다음 검수 작업을 이어갈 수 있습니다.',
                actionLabel: '결과 보기',
                icon: 'fa-circle-check'
            };
        }
        const titles: any = {
            source: '먼저 자료함을 연결하세요',
            harness: this.projectHarnesses().length ? '사용할 하네스를 연결하세요' : 'QA 생성 하네스를 준비하세요',
            survey: this.projectSurveys().length ? '사람 평가 설문지를 연결하세요' : '사람 평가 설문지를 준비하세요',
            settings: '생성 설정을 마무리하세요',
            output: `${this.activeProjectSettingKind()?.code || 'QA'} 생성을 시작할 수 있습니다`
        };
        return {
            ...next,
            title: titles[next.key],
            description: next.detail
        };
    }

    public async runProjectReadinessTask(task: any) {
        if (!task) return;
        const kind = this.activeProjectSettingKind();
        if (!kind) return;
        if (task.key === 'source') {
            await this.revealProjectSetting('source');
            return;
        }
        if (task.key === 'harness') {
            if (task.done) {
                const resource = this.findProjectResource('harness', this.projectSettings?.[kind.key]);
                if (resource) await this.openProjectResourcePreview('harness', resource);
                return;
            }
            if (this.projectHarnesses().length) {
                this.revealProjectResourceStudio('harness');
            } else {
                this.openProjectResourceAssistant('harness');
            }
            return;
        }
        if (task.key === 'survey') {
            if (task.done) {
                const resource = this.findProjectResource('survey', this.projectSettings?.[kind.key]);
                if (resource) await this.openProjectResourcePreview('survey', resource);
                return;
            }
            if (this.projectSurveys().length) {
                this.revealProjectResourceStudio('survey');
            } else {
                this.openProjectResourceAssistant('survey');
            }
            return;
        }
        if (task.key === 'settings') {
            await this.revealProjectSetting('settings');
            return;
        }
        if (task.key === 'output') {
            if (task.done) {
                if (kind.key === 'qa') await this.navigateToQaResult();
                else await this.router.navigate(['/review-projects', this.project.id, 'kg-result']);
                return;
            }
            if (task.blocked) {
                await this.revealProjectSetting('settings');
                return;
            }
            await this.navigateToOutputDetail(kind);
        }
    }

    private projectGenerationSettingGap(setting: any, kind: any) {
        const missing: string[] = [];
        const target = Number(setting?.target);
        if (!Number.isFinite(target) || target < 1 || target > 100) missing.push('목표 점수');
        if (kind?.key === 'qa') {
            const count = Number(setting?.targetQaCount);
            if (!this.selectedProjectReviewers(setting).length) missing.push('검수자');
            if (!Number.isInteger(count) || count < 1 || count > 150) missing.push('목표 QA 개수');
            if (!this.qaUsageModeOptions.some((option: any) => option.value === setting?.usageMode)) missing.push('사용 목적');
            if (!this.qaOutOfScopeOptions.some((option: any) => option.value === setting?.outOfScopePolicy)) missing.push('답변 범위 정책');
            if (!this.qaAdversarialOptions.some((option: any) => option.value === setting?.adversarialPolicy)) missing.push('유도 질문 정책');
            if (!this.qaLanguagePolicyOptions.some((option: any) => option.value === setting?.languagePolicy)) missing.push('언어 정책');
        }
        if (!missing.length) return '자료·하네스·설문지 연결 상태를 다시 확인해주세요.';
        return `${missing.join(' · ')} 설정이 필요합니다.`;
    }

    private async revealProjectSetting(section: 'source' | 'settings') {
        this.projectSettingsActiveStep = section === 'source' ? 1 : 2;
        await this.service.render();
        if (typeof document === 'undefined') return;
        setTimeout(() => {
            if (section === 'source') {
                const sourceDetails = document.getElementById('project-setting-inline-source-details') as HTMLDetailsElement;
                if (sourceDetails) sourceDetails.open = true;
            }
            const targetId = section === 'source'
                ? 'project-settings-source-title'
                : 'project-settings-evaluation-title';
            const target = document.getElementById(targetId) as HTMLElement;
            const container = target?.closest('.project-settings-inline__section') as HTMLElement;
            const focusTarget = section === 'source'
                ? document.getElementById('project-setting-inline-source') as HTMLElement
                : document.getElementById('project-setting-inline-reviewerId') as HTMLElement;
            (container || target)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
        }, 0);
    }

    private revealProjectResourceStudio(kind: 'harness' | 'survey') {
        if (typeof document === 'undefined') return;
        const target = document.getElementById(`project-resource-${kind}-title`) as HTMLElement;
        const card = target?.closest('.project-resource-card') as HTMLElement;
        (card || target)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
            const action = card?.querySelector('.project-resource-card__connect') as HTMLElement;
            if (action && typeof action.focus === 'function') action.focus({ preventScroll: true });
        }, 350);
    }

    public isProjectSettingComplete(kind: any, settings?: any) {
        const source = settings || this.projectSettings || {};
        const setting = kind && source[kind.key];
        if (!setting) return false;
        const target = Number(setting.target);
        const targetQaCount = Number(setting.targetQaCount);
        return this.projectSourceSelectionComplete(setting)
            && !!String(setting.harness || '').trim()
            && !!String(setting.survey || '').trim()
            && Number.isFinite(target) && target >= 1 && target <= 100
            && (
                kind.key !== 'qa'
                || (
                    this.selectedProjectReviewers(setting).length > 0
                    && Number.isInteger(targetQaCount) && targetQaCount >= 1 && targetQaCount <= 150
                    && this.qaUsageModeOptions.some((option: any) => option.value === setting.usageMode)
                    && this.qaOutOfScopeOptions.some((option: any) => option.value === setting.outOfScopePolicy)
                    && this.qaAdversarialOptions.some((option: any) => option.value === setting.adversarialPolicy)
                    && this.qaLanguagePolicyOptions.some((option: any) => option.value === setting.languagePolicy)
                )
            );
    }

    private resetProjectSettingValidation() {
        this.settingsValidationFields = {};
        this.settingsValidationMessages = [];
    }

    public clearProjectSettingValidationField(field: string) {
        if (!this.settingsValidationFields[field]) return;
        const next = { ...this.settingsValidationFields };
        delete next[field];
        this.settingsValidationFields = next;
        this.settingsValidationMessages = Object.keys(next).map((key: string) => next[key]);
    }

    private projectSettingValidationErrors(setting: any, kind: any) {
        const errors: any = {};
        if (!setting || !String(setting.source || '').trim()) {
            errors.source = '자료 소스를 선택해주세요.';
        }
        if (setting && setting.source === '자료함 API' && setting.sourceScope === 'collection' && !setting.sourceCollection) {
            errors.sourceCollection = '사용할 주제 컬렉션을 선택해주세요.';
        }
        if (!setting || !String(setting.harness || '').trim()) {
            errors.harness = this.projectHarnessOptions.length
                ? '생성 하네스를 선택해주세요.'
                : '선택할 하네스가 없습니다. 프로젝트 상단에서 AI로 만들거나 파일을 업로드해주세요.';
        }
        if (!setting || !String(setting.survey || '').trim()) {
            errors.survey = this.projectSurveyOptions.length
                ? '사람 평가 설문지를 선택해주세요.'
                : '선택할 설문지가 없습니다. 프로젝트 상단에서 AI로 만들거나 파일을 업로드해주세요.';
        }
        const target = Number(setting && setting.target);
        if (!Number.isFinite(target) || target < 1 || target > 100) {
            errors.target = '목표 종합 점수는 1~100 사이로 입력해주세요.';
        }
        const targetQaCount = Number(setting && setting.targetQaCount);
        if (
            kind && kind.key === 'qa'
            && (!Number.isInteger(targetQaCount) || targetQaCount < 1 || targetQaCount > 150)
        ) {
            errors.targetQaCount = '목표 QA 개수는 1~150 사이의 정수로 입력해주세요.';
        }
        if (kind && kind.key === 'qa') {
            if (!this.selectedProjectReviewers(setting).length) {
                errors.reviewerId = this.projectReviewerOptions.length
                    ? 'QA 검수를 담당할 검수자를 선택해주세요.'
                    : (this.projectReviewersError || '할당 가능한 검수자 계정이 없습니다.');
            }
            if (!this.qaUsageModeOptions.some((option: any) => option.value === setting?.usageMode)) {
                errors.usageMode = '생성한 QA의 사용 목적을 선택해주세요.';
            }
            if (!this.qaOutOfScopeOptions.some((option: any) => option.value === setting?.outOfScopePolicy)) {
                errors.outOfScopePolicy = '자료에 답이 없는 질문의 처리 방식을 선택해주세요.';
            }
            if (!this.qaAdversarialOptions.some((option: any) => option.value === setting?.adversarialPolicy)) {
                errors.adversarialPolicy = '유도·편향 질문의 처리 방식을 선택해주세요.';
            }
            if (!this.qaLanguagePolicyOptions.some((option: any) => option.value === setting?.languagePolicy)) {
                errors.languagePolicy = '외국어 자료 표시 방식을 선택해주세요.';
            }
        }
        return errors;
    }

    private focusFirstProjectSettingError() {
        const field = Object.keys(this.settingsValidationFields)[0];
        if (!field || typeof document === 'undefined') return;
        setTimeout(() => {
            const summary = document.getElementById('project-setting-validation-summary') as HTMLElement;
            if (summary && typeof summary.scrollIntoView === 'function') {
                summary.scrollIntoView({ block: 'nearest' });
            }
            const fieldPrefix = this.tab === 'settings' ? 'project-setting-inline-' : 'project-setting-';
            const target = document.getElementById(fieldPrefix + field) as HTMLElement;
            if (target && !target.hasAttribute('disabled') && typeof target.focus === 'function') {
                target.focus();
                return;
            }
            if (summary && typeof summary.focus === 'function') summary.focus();
        }, 0);
    }

    public async openProjectSetting(kind: any) {
        if (!kind) return;
        this.loadProjectSettingOptions();
        this.settingsDraft = this.cloneValue(this.projectSettings);
        if (!this.settingsDraft[kind.key]) this.settingsDraft[kind.key] = this.emptyOutputSetting();
        this.resetProjectSettingValidation();
        this.settingsModalKind = kind;
        this.settingsEditing = true;
        await this.service.render();
    }

    public async cancelProjectSettings() {
        this.settingsDraft = this.cloneValue(this.projectSettings);
        this.resetProjectSettingValidation();
        this.settingsEditing = false;
        this.settingsModalKind = null;
        await this.service.render();
    }

    public async saveProjectSettings() {
        const kinds = this.settingsModalKind ? [this.settingsModalKind] : this.selectedProjectSettingKinds();
        const errors: any = {};
        for (const kind of kinds) {
            const setting = this.settingsDraft[kind.key];
            Object.assign(errors, this.projectSettingValidationErrors(setting, kind));
        }

        if (Object.keys(errors).length) {
            this.settingsValidationFields = errors;
            this.settingsValidationMessages = Object.keys(errors).map((key: string) => errors[key]);
            await this.service.render();
            this.focusFirstProjectSettingError();
            return false;
        }

        for (const kind of kinds) {
            const setting = this.settingsDraft[kind.key];
            setting.source = String(setting.source).trim();
            setting.sourceScope = setting.sourceScope || 'all';
            setting.sourceCategory = String(setting.sourceCategory || '').trim();
            setting.sourceCollection = String(setting.sourceCollection || '').trim();
            setting.harness = String(setting.harness).trim();
            setting.survey = String(setting.survey).trim();
            const harnessOption = this.projectHarnessOptions.find((option: any) => option.name === setting.harness);
            const surveyOption = this.projectSurveyOptions.find((option: any) => option.name === setting.survey);
            setting.harnessId = String(harnessOption?.id || setting.harnessId || '').trim();
            setting.harnessVersion = this.projectResourceHasVersion(
                'harness', setting, setting.harnessVersion
            ) ? String(setting.harnessVersion).trim() : String(harnessOption?.version || '').trim();
            setting.surveyId = String(surveyOption?.id || setting.surveyId || '').trim();
            setting.surveyVersion = this.projectResourceHasVersion(
                'survey', setting, setting.surveyVersion
            ) ? String(setting.surveyVersion).trim() : String(surveyOption?.version || '').trim();
            setting.target = Number(setting.target);
            if (kind.key === 'qa') {
                setting.reviewers = this.selectedProjectReviewers(setting)
                    .map((selected: any) => this.projectReviewerOptions.find(
                        (option: any) => option.id === String(selected?.id || '')
                    ) || selected)
                    .map((reviewer: any) => ({
                        id: String(reviewer?.id || '').trim(),
                        name: String(reviewer?.name || '').trim(),
                        email: String(reviewer?.email || '').trim()
                    }));
                const reviewer = setting.reviewers[0] || {};
                setting.reviewerId = String(reviewer.id || '').trim();
                setting.reviewerName = String(reviewer.name || '').trim();
                setting.reviewerEmail = String(reviewer.email || '').trim();
                setting.targetQaCount = Number(setting.targetQaCount);
                // Retain legacy fields for persisted-state compatibility only.
                // Distribution is monitored in result metrics, never used as a gate.
                setting.primarySourceRatio = 0;
                setting.neutralQuestionRatio = 0;
            }
        }

        this.resetProjectSettingValidation();
        this.projectSettings = this.cloneValue(this.settingsDraft);
        this.project.configured = this.selectedProjectSettingKinds()
            .every((kind: any) => this.isProjectSettingComplete(kind, this.projectSettings));
        this.project.status = this.project.configured ? '설정 완료' : '설정 필요';
        this.settingsEditing = false;
        this.settingsModalKind = null;
        this.applySettingsToProject();
        const persisted = await this.persistProjectSettings();
        if (!persisted) return false;
        if (kinds.some((kind: any) => kind.key === 'qa')) {
            const assigned = await this.persistProjectReviewerAssignments(this.projectSettings.qa);
            if (!assigned) return false;
        }
        await this.service.render();
        if (this.outputDetailKind()) await this.prepareOutputDetail(true);
        return true;
    }

    public async saveProjectSettingsAndOpen(kind?: any) {
        const targetKind = kind || this.activeProjectSettingKind();
        if (!targetKind) return;
        const saved = await this.saveProjectSettings();
        if (!saved) return;
        await this.navigateToOutputDetail(targetKind);
    }

    public async openOutputGeneration(kind: any, resumeActive: boolean = true) {
        if (!kind || !this.isProjectSettingComplete(kind)) return;
        this.generationModalKind = kind;
        this.generationSources = [];
        this.generationAvailability = {};
        this.generationSourceQuery = '';
        this.generationSearchQuery = '';
        this.generationSourcePage = 1;
        this.generationSourcePageSize = kind.key === 'qa' ? 20 : 7;
        this.qaSourceFiltersOpen = false;
        this.qaSourceCategory = '전체 자료';
        this.qaSourceNewestFirst = true;
        this.qaSourceCompact = false;
        this.qaSourceCatalogOpen = true;
        this.qaGenerationSummaryOpen = false;
        this.generationProgress = {};
        this.generationError = '';
        this.generationErrorCode = '';
        this.generationStartedAtMs = 0;
        this.generationLastProgressAtMs = 0;
        this.generationResult = null;
        if (kind.key === 'qa') await this.restoreQaGenerationResult();
        if (kind.key === 'kg') await this.restoreKgGenerationResult();
        await this.loadGenerationSources();
        if (resumeActive) await this.resumeOutputGeneration();
    }

    public async closeOutputGeneration() {
        if (this.generationRunning) return;
        this.generationModalKind = null;
        this.generationSources = [];
        this.generationAvailability = {};
        this.generationSourceQuery = '';
        this.generationSearchQuery = '';
        this.generationSourcePage = 1;
        this.qaSourceFiltersOpen = false;
        this.qaSourceCategory = '전체 자료';
        this.qaSourceNewestFirst = true;
        this.qaSourceCompact = false;
        this.qaSourceCatalogOpen = true;
        this.qaGenerationSummaryOpen = false;
        this.generationJobId = '';
        this.generationError = '';
        this.generationErrorCode = '';
        this.generationStartedAtMs = 0;
        this.generationLastProgressAtMs = 0;
        this.generationResult = null;
        await this.service.render();
    }

    public async loadGenerationSources() {
        if (!this.generationModalKind || this.generationLoading) return;
        this.generationLoading = true;
        this.generationError = '';
        this.generationErrorCode = '';
        await this.service.render();

        // Keep the visible QA catalog inside the source scope saved in project settings.
        // The configured scope owns the remote query; the catalog search box filters that
        // already-scoped response locally and never broadens it back to the full vault.
        const query = this.generationModalKind.key === 'qa'
            ? this.qaConfiguredScopeQuery()
            : String(this.generationSourceQuery || '').trim();
        const { code, data } = await this.callGenerationSources({
            kind: this.generationModalKind.key,
            project_id: this.project.id,
            query
        });
        if (code === 200) {
            this.generationAvailability = data || {};
            this.generationSources = ((data && data.sources) || []).map((source: any) => ({
                ...source,
                selected: false
            }));
            if (this.generationModalKind.key === 'qa') this.qaAutoSelectGenerationSources();
            this.generationSourcePage = 1;
        } else {
            this.generationAvailability = {
                ready: false,
                reason: (data && data.message) || '자료함에서 원문 목록을 불러오지 못했습니다.',
                action: '자료함 연결 상태를 확인한 뒤 다시 시도해주세요.'
            };
            this.generationSources = [];
            this.generationError = (data && data.message) || '생성 자료를 불러오지 못했습니다.';
            this.generationErrorCode = String(data && data.code || '').trim();
        }
        this.generationLoading = false;
        await this.service.render();
    }

    private async callGenerationSources(parameters: any) {
        let timeoutId: any = null;
        const timeoutResponse = new Promise<any>((resolve) => {
            timeoutId = setTimeout(() => resolve({
                code: 504,
                data: {
                    message: '자료함 응답이 지연되고 있습니다. 잠시 후 다시 시도해주세요.'
                }
            }), this.generationSourceRequestTimeoutMs);
        });
        try {
            return await Promise.race([
                wiz.call('generation_sources', parameters),
                timeoutResponse
            ]);
        } catch (error) {
            return {
                code: 503,
                data: {
                    message: '자료함 연결 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'
                }
            };
        } finally {
            if (timeoutId !== null) clearTimeout(timeoutId);
        }
    }

    public async searchGenerationSources() {
        this.generationSourcePage = 1;
        if (this.generationModalKind && this.generationModalKind.key === 'qa') {
            await this.service.render();
            return;
        }
        await this.loadGenerationSources();
    }

    public async toggleGenerationSource(source: any) {
        if (this.generationModalKind && this.generationModalKind.key === 'qa') return;
        if (!source || !source.available || this.generationRunning) return;
        if (!source.selected && this.selectedGenerationSources().length >= 50) return;
        source.selected = !source.selected;
        await this.service.render();
    }

    public selectedGenerationSources() {
        return this.generationSources.filter((source: any) => !!source.selected);
    }

    public sortedGenerationSources() {
        if (this.generationModalKind && this.generationModalKind.key === 'qa') {
            const direction = this.qaSourceNewestFirst ? -1 : 1;
            return this.filteredGenerationSources().sort((left: any, right: any) => {
                const dateDifference = this.qaSourceUpdatedTimestamp(left) - this.qaSourceUpdatedTimestamp(right);
                if (dateDifference) return dateDifference * direction;
                return String(left && left.title || '').localeCompare(String(right && right.title || ''), 'ko');
            });
        }
        const direction = this.generationSourceSortAsc ? 1 : -1;
        return this.filteredGenerationSources().sort((left: any, right: any) => (
            String(left && left.title || '').localeCompare(String(right && right.title || ''), 'ko') * direction
        ));
    }

    public filteredGenerationSources() {
        if (!this.generationModalKind || this.generationModalKind.key !== 'qa') {
            return [...this.generationSources];
        }
        const query = String(this.generationSourceQuery || '').trim().toLocaleLowerCase('ko');
        if (!query) return [...this.generationSources];
        return this.generationSources.filter((source: any) => (
            `${source?.title || ''} ${source?.publisher || ''} ${source?.id || ''} ${source?.format || ''}`
                .toLocaleLowerCase('ko')
                .includes(query)
        ));
    }

    public qaConfiguredScopeQuery() {
        const setting = this.projectSettings && this.projectSettings.qa || {};
        if (setting.source !== '자료함 API' || !setting.sourceScope || setting.sourceScope === 'all') return '';
        if (setting.sourceScope === 'collection') {
            const collection = this.projectSourceCollections.find((item: any) => item.key === setting.sourceCollection);
            return String(collection && (collection.query || collection.label) || '').trim();
        }
        return '';
    }

    public qaPlannedSourceCount() {
        // v9 maximizes source diversity: use one distinct source per requested
        // QA when the collection can supply it. The backend still permits up to
        // three per source when fewer suitable historical records are available.
        const distinctAvailable = new Set(
            this.generationSources
                .filter((source: any) => !!source?.available)
                .map((source: any) => String(source?.content_key || source?.id || '').trim())
                .filter((key: string) => !!key)
        ).size;
        const availableLimit = distinctAvailable || this.qaTargetCount();
        return Math.min(50, availableLimit, Math.max(1, this.qaTargetCount()));
    }

    private qaAutoSelectGenerationSources() {
        const planned = this.qaPlannedSourceCount();
        const seenContent = new Set<string>();
        const available = this.generationSources.filter((source: any) => {
            if (!source?.available) return false;
            const contentKey = String(source?.content_key || source?.id || '').trim();
            if (contentKey && seenContent.has(contentKey)) return false;
            if (contentKey) seenContent.add(contentKey);
            return true;
        });
        const scopeKeywords = this.qaConfiguredScopeQuery()
            .toLocaleLowerCase('ko')
            .split(/\s+/)
            .filter((keyword: string) => keyword.length > 1);
        const scopeMatches = scopeKeywords.length
            ? available.filter((source: any) => {
                const text = `${source?.title || ''} ${source?.publisher || ''}`.toLocaleLowerCase('ko');
                return scopeKeywords.some((keyword: string) => text.includes(keyword));
            })
            : available;
        const candidates = scopeMatches.length >= planned ? scopeMatches : available;
        // Document titles do not establish first-hand-source status. The backend
        // selects primary_original Chunks by Material Vault content_layer and
        // distributes them by source_work_id after these document containers are chosen.
        const selected = new Set<any>();
        const spread = (rows: any[], count: number) => {
            for (let index = 0; index < count; index += 1) {
                const position = count === 1
                ? 0
                : Math.round(index * (rows.length - 1) / (count - 1));
                selected.add(rows[position]);
            }
        };
        spread(candidates, Math.min(planned, candidates.length));
        this.generationSources.forEach((source: any) => source.selected = selected.has(source));
    }

    public qaPolicyOptionLabel(options: any[], value: any) {
        const option = options.find((item: any) => item.value === value);
        return option ? option.label : '미설정';
    }

    public qaCatalogTotalCount() {
        return Number(this.generationAvailability && this.generationAvailability.total_count) || this.generationSources.length;
    }

    public qaCatalogAvailableCount() {
        const reported = Number(this.generationAvailability && this.generationAvailability.available_count);
        return Number.isFinite(reported) && reported >= 0
            ? reported
            : this.generationSources.filter((source: any) => !!source.available).length;
    }

    public qaFilteredSourceCount() {
        return this.filteredGenerationSources().length;
    }

    public qaSourceCategoryFor(source: any) {
        const text = `${source?.title || ''} ${source?.format || ''}`.toLowerCase();
        if (/사료|역사|고문서|문헌|실록|기록/.test(text)) return '역사 문헌';
        if (/연구|논문|학술|저널/.test(text)) return '연구 자료';
        if (/보고서|리포트|백서/.test(text)) return '보고서';
        if (/간행|책자|도서|pdf/.test(text)) return '간행물';
        return '기타 자료';
    }

    public qaSourceCategoryCount(category: string) {
        if (category === '전체 자료') return this.generationSources.length;
        return this.generationSources.filter((source: any) => this.qaSourceCategoryFor(source) === category).length;
    }

    public async selectQaSourceCategory(category: string) {
        this.qaSourceCategory = category;
        this.generationSourcePage = 1;
        await this.service.render();
    }

    public qaSourcePublisher(source: any) {
        return String(source?.publisher || source?.organization || source?.provider || '자료함');
    }

    public qaSourceUpdatedDate(source: any) {
        const text = String(source?.updated_at || source?.updatedAt || '').trim();
        const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
        return match ? `${match[1]}.${match[2]}.${match[3]}` : (text || '—');
    }

    private qaSourceUpdatedTimestamp(source: any) {
        const value = Date.parse(String(source?.updated_at || source?.updatedAt || ''));
        return Number.isFinite(value) ? value : 0;
    }

    public async toggleQaSourceSort() {
        this.qaSourceNewestFirst = !this.qaSourceNewestFirst;
        this.generationSourcePage = 1;
        await this.service.render();
    }

    public async toggleQaSourceDensity() {
        this.qaSourceCompact = !this.qaSourceCompact;
        await this.service.render();
    }

    public async toggleQaSourceCatalog() {
        this.qaSourceCatalogOpen = !this.qaSourceCatalogOpen;
        await this.service.render();
    }

    public projectDateTimeLabel(value: any) {
        return workspaceDateTime(value);
    }

    private qaGenerationResource(kind: 'harness' | 'survey') {
        return this.findProjectResource(kind, this.projectSettings?.qa || {});
    }

    public qaGenerationVersionOptions(kind: 'harness' | 'survey') {
        const resource = this.qaGenerationResource(kind);
        const versions = Array.isArray(resource?.versions)
            ? resource.versions.filter((row: any) => row && typeof row === 'object')
            : [];
        if (versions.length) {
            return [...versions].reverse().map((row: any) => ({
                ...row,
                version: String(row.version || row.id || '').trim(),
                active: row.active === true
                    || String(row.version || row.id || '') === String(resource?.activeVersion || resource?.version || '')
            })).filter((row: any) => !!row.version);
        }
        const fallback = String(resource?.activeVersion || resource?.version || '').trim();
        return fallback ? [{ version: fallback, active: true }] : [];
    }

    public qaGenerationSelectedVersion(kind: 'harness' | 'survey') {
        return String(this.projectSettings?.qa?.[`${kind}Version`] || '').trim();
    }

    public qaGenerationVersionDetail(kind: 'harness' | 'survey') {
        const selected = this.qaGenerationSelectedVersion(kind);
        return this.qaGenerationVersionOptions(kind).find(
            (row: any) => String(row.version || '') === selected
        ) || null;
    }

    public qaGenerationVersionContentCount(kind: 'harness' | 'survey') {
        const detail = this.qaGenerationVersionDetail(kind);
        const resource = this.qaGenerationResource(kind);
        if (kind === 'harness') {
            const rules = Array.isArray(detail?.rules)
                ? detail.rules
                : (Array.isArray(resource?.rules) ? resource.rules : []);
            return `${rules.length}개 규칙`;
        }
        const questions = Array.isArray(detail?.dimensions)
            ? detail.dimensions
            : (Array.isArray(detail?.questionItems)
                ? detail.questionItems
                : (Array.isArray(resource?.dimensions) ? resource.dimensions : []));
        return `${questions.length}개 문항`;
    }

    public qaGenerationVersionOptionLabel(option: any) {
        const version = String(option?.version || '버전 정보 없음');
        return option?.active === true ? `${version} · 최신` : `${version} · 이전`;
    }

    public async selectQaGenerationVersion(
        kind: 'harness' | 'survey', version: string,
    ) {
        const normalized = String(version || '').trim();
        if (
            !normalized
            || this.generationRunning
            || this.qaGenerationVersionSaving
            || normalized === this.qaGenerationSelectedVersion(kind)
            || !this.qaGenerationVersionOptions(kind).some(
                (row: any) => String(row.version || '') === normalized
            )
        ) return;
        const previous = this.qaGenerationSelectedVersion(kind);
        this.qaGenerationVersionSaving = kind;
        this.projectSettings.qa[`${kind}Version`] = normalized;
        if (!this.settingsDraft.qa) this.settingsDraft.qa = this.cloneValue(this.projectSettings.qa);
        this.settingsDraft.qa[`${kind}Version`] = normalized;
        this.applySettingsToProject();
        await this.service.render();
        const persisted = await this.persistProjectSettings();
        if (!persisted) {
            this.projectSettings.qa[`${kind}Version`] = previous;
            this.settingsDraft.qa[`${kind}Version`] = previous;
        }
        this.qaGenerationVersionSaving = '';
        await this.service.render();
    }

    public qaNextSetVersionLabel() {
        return `v${this.qaSetVersions.length + 1}.0`;
    }

    public qaNextSetGenerationLabel() {
        return `${this.qaSetVersions.length + 1}차 생성`;
    }

    public qaSetGenerationLabel(version: any, fallbackIndex: number = 0) {
        const value = String(version?.version || version?.label || '');
        const match = value.match(/v(\d+)/i);
        const number = match ? Number(match[1]) : Math.max(1, fallbackIndex + 1);
        return `${number}차 생성`;
    }

    public qaSetVersionsChronological() {
        return [...this.qaSetVersions].reverse();
    }

    public qaSetReviewStatusLabel(version: any) {
        return String(
            version?.review_status_label
            || version?.human_review?.label
            || version?.status
            || '검수 상태 확인 필요'
        );
    }

    public qaSetReviewComplete(version: any) {
        return String(
            version?.review_status
            || version?.human_review_status
            || version?.human_review?.status
            || ''
        ) === 'completed';
    }

    public qaCurrentCriteriaVersion(kind: 'harness' | 'survey') {
        const current = this.qaCurrentSetVersion();
        return String(current?.[`${kind}_version`] || '').trim();
    }

    public qaGenerationCriteriaChanged(kind: 'harness' | 'survey') {
        const previous = this.qaCurrentCriteriaVersion(kind);
        return !!previous && previous !== this.qaGenerationSelectedVersion(kind);
    }

    public qaCurrentSetVersion() {
        return this.qaSetVersions.find((row: any) => row?.is_current === true)
            || this.qaSetVersions[0]
            || null;
    }

    public qaGenerationUsesNewCriteria() {
        const current = this.qaCurrentSetVersion();
        if (!current) return true;
        return String(current.harness_version || '') !== this.qaGenerationSelectedVersion('harness')
            || String(current.survey_version || '') !== this.qaGenerationSelectedVersion('survey');
    }

    public paginatedGenerationSources() {
        const start = (this.generationSourcePage - 1) * this.generationSourcePageSize;
        return this.sortedGenerationSources().slice(start, start + this.generationSourcePageSize);
    }

    public generationSourcePageCount() {
        return Math.max(1, Math.ceil(this.filteredGenerationSources().length / this.generationSourcePageSize));
    }

    public async setGenerationSourcePage(page: number) {
        const next = Math.min(Math.max(1, Number(page) || 1), this.generationSourcePageCount());
        if (next === this.generationSourcePage) return;
        this.generationSourcePage = next;
        await this.service.render();
    }

    public async changeGenerationSourcePageSize() {
        this.generationSourcePageSize = Number(this.generationSourcePageSize) || 7;
        this.generationSourcePage = 1;
        await this.service.render();
    }

    public async toggleGenerationSourceSort() {
        this.generationSourceSortAsc = !this.generationSourceSortAsc;
        this.generationSourcePage = 1;
        await this.service.render();
    }

    public async toggleQaSourceFilters() {
        this.qaSourceFiltersOpen = !this.qaSourceFiltersOpen;
        await this.service.render();
    }

    public qaGenerationChecklistItems() {
        const selected = this.selectedGenerationSources();
        const qaKind = this.projectSettingKinds.find((kind: any) => kind.key === 'qa');
        const setting = this.projectSettings && this.projectSettings.qa || {};
        return [
            { label: '저장된 연결 범위 적용', complete: this.projectSourceSelectionComplete(setting) && !!this.generationAvailability.ready },
            { label: `원문 ${this.qaPlannedSourceCount()}건 준비`, complete: selected.length >= this.qaPlannedSourceCount() && selected.every((source: any) => !!source.available) },
            { label: '자료함 원문 층위 확인', complete: selected.length > 0 },
            { label: '생성 설정 구성 완료', complete: !!qaKind && this.isProjectSettingComplete(qaKind) },
            { label: '사람 평가 설문 선택', complete: !!String(setting.survey || '').trim() },
            { label: '목표값 설정 확인', complete: Number(setting.target || 0) > 0 && Number(setting.targetQaCount || 0) > 0 }
        ];
    }

    public qaGenerationCompletionPercent() {
        const items = this.qaGenerationChecklistItems();
        return Math.round(items.filter((item: any) => item.complete).length / items.length * 100);
    }

    public qaGenerationCompletedChecklistCount() {
        return this.qaGenerationChecklistItems().filter((item: any) => item.complete).length;
    }

    public qaGenerationStep() {
        if (this.generationRunning || this.generationResult) return 3;
        return this.qaGenerationSummaryOpen ? 2 : 1;
    }

    public qaGenerationAdvanceEnabled() {
        return this.qaGenerationSummaryOpen
            ? this.canStartOutputGeneration()
            : this.selectedGenerationSources().length > 0;
    }

    public qaGenerationAdvanceLabel() {
        if (this.generationRunning) return '생성 중입니다';
        if (this.qaGenerationSummaryOpen) return this.generationButtonLabel(this.generationModalKind);
        return '다음: 설정 확인';
    }

    public async advanceQaGeneration() {
        if (!this.qaGenerationAdvanceEnabled()) return;
        if (!this.qaGenerationSummaryOpen) {
            this.qaGenerationSummaryOpen = true;
            await this.service.render();
            return;
        }
        await this.startOutputGeneration();
    }

    public async returnToQaSourceSelection() {
        if (this.generationRunning) return;
        this.qaGenerationSummaryOpen = false;
        await this.service.render();
    }

    public async toggleQaGenerationSummary() {
        if (this.generationRunning) return;
        this.qaGenerationSummaryOpen = !this.qaGenerationSummaryOpen;
        await this.service.render();
    }

    public generationPageSourcesSelected() {
        const available = this.paginatedGenerationSources().filter((source: any) => !!source.available);
        return !!available.length && available.every((source: any) => !!source.selected);
    }

    public async toggleGenerationPageSources() {
        if (this.generationModalKind && this.generationModalKind.key === 'qa') return;
        if (this.generationRunning) return;
        const pageSources = this.paginatedGenerationSources().filter((source: any) => !!source.available);
        const nextSelected = !this.generationPageSourcesSelected();
        if (nextSelected) {
            const currentSelected = this.selectedGenerationSources().length;
            let remaining = Math.max(0, 50 - currentSelected);
            pageSources.forEach((source: any) => {
                if (!source.selected && remaining > 0) {
                    source.selected = true;
                    remaining -= 1;
                }
            });
        } else {
            pageSources.forEach((source: any) => source.selected = false);
        }
        await this.service.render();
    }

    public kgGenerationMetric(metric: 'claim_count' | 'node_count' | 'edge_count') {
        const result = this.generationResult && this.generationResult.kind === 'kg'
            ? this.generationResult
            : this.kgPersistedResult;
        return Number(result && result[metric] || 0);
    }

    public canStartOutputGeneration() {
        if (
            !this.generationModalKind
            || this.generationLoading
            || this.generationRunning
            || !!this.qaGenerationVersionSaving
        ) return false;
        const selected = this.selectedGenerationSources();
        if (!selected.length || selected.length > 50 || selected.some((source: any) => !source.available)) {
            return false;
        }
        return true;
    }

    public qaTargetCount() {
        const setting = this.projectSettings && this.projectSettings.qa;
        return Number(setting && setting.targetQaCount || 0);
    }

    public qaGenerationProgressStage() {
        if (this.qaRegenerationPreparing) return 1;
        const stage = Number(this.generationProgress && this.generationProgress.stage_number || 0);
        return Math.min(3, Math.max(1, stage || (this.generationRunning ? 2 : 1)));
    }

    public qaGenerationProgressCount() {
        const target = this.qaGenerationProgressTarget();
        const count = Number(this.generationProgress && this.generationProgress.generated_count || 0);
        return Math.min(target, Math.max(0, Number.isFinite(count) ? Math.floor(count) : 0));
    }

    public qaGenerationProgressTarget() {
        if (this.qaRegeneratingItemId) return 1;
        const reported = Number(this.generationProgress && this.generationProgress.target_qa_count || 0);
        const fallback = Number(this.qaTargetCount() || 0);
        return Math.max(1, Number.isFinite(reported) && reported > 0 ? Math.floor(reported) : fallback);
    }

    public qaGenerationProcessedSourceCount() {
        const count = Number(this.generationProgress && this.generationProgress.processed_source_count || 0);
        return Math.max(0, Number.isFinite(count) ? Math.floor(count) : 0);
    }

    public qaGenerationTotalSourceCount() {
        const reported = Number(this.generationProgress && this.generationProgress.total_source_count || 0);
        if (this.qaRegeneratingItemId) {
            return Math.max(1, Number.isFinite(reported) ? Math.floor(reported) : 0);
        }
        const selected = this.selectedGenerationSources().length;
        return Math.max(0, Number.isFinite(reported) && reported > 0 ? Math.floor(reported) : selected);
    }

    public qaGenerationProgressLabel() {
        const count = this.qaGenerationProgressCount();
        const target = this.qaGenerationProgressTarget();
        const stage = this.qaGenerationProgressStage();
        if (this.qaRegeneratingItemId) {
            const batchPrefix = this.qaBatchRegenerationTotal > 1
                ? `선택 ${this.qaBatchRegenerationIndex} / ${this.qaBatchRegenerationTotal} · `
                : '';
            if (stage === 1) return `${batchPrefix}${this.qaRegeneratingItemId} · 원문과 Chunk 확인 중`;
            if (stage === 3) return `${batchPrefix}${this.qaRegeneratingItemId} · 새 답변 품질 확인 중`;
            return `${batchPrefix}${this.qaRegeneratingItemId} · 대체 QA 생성 중`;
        }
        if (stage === 1) return `원문 분석 중 · QA ${count} / ${target}개`;
        if (stage === 3) return `QA ${count} / ${target}개 생성 완료 · 품질 기준 확인 중`;
        return `QA ${count} / ${target}개 생성 중`;
    }

    public qaGenerationOverallProgressPercent() {
        const stage = this.qaGenerationProgressStage();
        const generated = this.qaGenerationProgressCount();
        const target = this.qaGenerationProgressTarget();
        if (stage >= 3) return 95;
        if (stage === 2) {
            return Math.min(90, Math.max(15, 15 + Math.round((generated / target) * 75)));
        }
        const processed = this.qaGenerationProcessedSourceCount();
        const total = this.qaGenerationTotalSourceCount();
        const sourceRatio = total > 0 ? processed / total : 0;
        return Math.min(14, Math.max(3, 3 + Math.round(sourceRatio * 11)));
    }

    private qaGenerationExpectedDurationSeconds() {
        const target = this.qaGenerationProgressTarget();
        const sources = Math.max(1, this.qaGenerationTotalSourceCount());
        return Math.min(1200, Math.max(60, 45 + target * 10 + sources * 2));
    }

    private durationMinuteRange(seconds: number) {
        if (!Number.isFinite(seconds) || seconds <= 45) return '1분 이내';
        const lower = Math.max(1, Math.ceil(seconds * .75 / 60));
        const upper = Math.max(lower + 1, Math.ceil(seconds * 1.25 / 60));
        return `${lower}~${upper}분`;
    }

    public qaGenerationExpectedDurationLabel() {
        return this.durationMinuteRange(this.qaGenerationExpectedDurationSeconds());
    }

    public qaGenerationEstimatedRemainingLabel() {
        const stage = this.qaGenerationProgressStage();
        if (stage >= 3) return '약 1분 이내';
        const generated = this.qaGenerationProgressCount();
        const target = this.qaGenerationProgressTarget();
        const elapsedSeconds = this.generationStartedAtMs
            ? Math.max(1, (Date.now() - this.generationStartedAtMs) / 1000)
            : 0;
        let remainingSeconds = this.qaGenerationExpectedDurationSeconds()
            * (1 - this.qaGenerationOverallProgressPercent() / 100);
        if (stage === 2 && generated > 0 && target > generated && elapsedSeconds > 0) {
            remainingSeconds = (elapsedSeconds / generated) * (target - generated) + 20;
        }
        return `약 ${this.durationMinuteRange(Math.max(15, remainingSeconds))}`;
    }

    public qaGenerationElapsedLabel() {
        if (!this.generationStartedAtMs) return '방금 시작';
        const seconds = Math.max(0, Math.floor((Date.now() - this.generationStartedAtMs) / 1000));
        if (seconds < 60) return `${seconds}초`;
        const minutes = Math.floor(seconds / 60);
        const remainder = seconds % 60;
        return remainder ? `${minutes}분 ${remainder}초` : `${minutes}분`;
    }

    private syncGenerationTiming(data: any, reset: boolean = false) {
        const started = Date.parse(String(data && data.started_at || ''));
        const updated = Date.parse(String(data && data.updated_at || ''));
        if (reset || !this.generationStartedAtMs) {
            this.generationStartedAtMs = Number.isFinite(started) ? started : Date.now();
        }
        if (Number.isFinite(updated)) this.generationLastProgressAtMs = updated;
        else this.generationLastProgressAtMs = Date.now();
    }

    public generationRecoveryInfo() {
        const code = String(this.generationErrorCode || '').trim();
        const sourceSettingCodes = [
            'QA_PRIMARY_ORIGINAL_NOT_FOUND', 'SOURCE_CHUNK_NOT_FOUND',
            'SOURCE_SELECTION_INVALID'
        ];
        if (sourceSettingCodes.includes(code)) {
            return {
                title: '자료 범위와 원문 상태를 확인해주세요.',
                message: '지금까지 저장한 프로젝트 설정은 유지됩니다. 자료함 연결과 사용할 자료 범위를 확인한 뒤 다시 생성할 수 있습니다.',
                action: 'settings',
                actionLabel: '자료 설정 확인'
            };
        }
        if (
            code.startsWith('MATERIAL_VAULT_')
            || code.startsWith('OPENAI_')
            || code === 'GENERATION_JOB_INTERRUPTED'
            || code === 'QA_GENERATION_FAILED'
        ) {
            return {
                title: '현재 설정을 그대로 두고 다시 시도할 수 있습니다.',
                message: '일시적인 외부 서비스 지연 또는 작업 중단입니다. 자료·하네스·설문지 설정은 변경되지 않았습니다.',
                action: 'retry',
                actionLabel: '같은 설정으로 다시 시도'
            };
        }
        return {
            title: '설정은 저장되어 있습니다.',
            message: '오류가 반복되면 자료 설정을 확인하고, 문제가 없으면 같은 설정으로 다시 시도해주세요.',
            action: 'retry',
            actionLabel: '다시 시도'
        };
    }

    public async runGenerationRecoveryAction() {
        const recovery = this.generationRecoveryInfo();
        if (recovery.action === 'settings') {
            const kind = this.generationModalKind;
            this.projectSettingsActiveStep = 1;
            await this.navigateToProjectSettings(kind);
            await this.revealProjectSetting('source');
            return;
        }
        if (!this.generationRunning && this.canStartOutputGeneration()) {
            await this.startOutputGeneration();
        }
    }

    public qaGenerationDialogTitle() {
        return this.qaRegeneratingItemId
            ? (this.qaBatchRegenerationTotal > 1
                ? '선택한 QA를 순서대로 다시 생성하고 있습니다'
                : 'QA 한 건을 다시 생성하고 있습니다')
            : 'QA 세트를 생성하고 있습니다';
    }

    public qaGenerationDialogDescription() {
        return this.qaRegeneratingItemId
            ? (this.qaBatchRegenerationTotal > 1
                ? `${this.qaBatchRegenerationIndex}번째 QA의 원문과 Chunk를 유지한 채 답변을 새로 만들고 있습니다.`
                : `${this.qaRegeneratingItemId}의 원문과 Chunk를 유지한 채 답변을 새로 만들고 있습니다.`)
            : '연결된 원문을 분석해 검수용 문답을 만들고 있습니다.';
    }

    public qaGenerationDialogNotice() {
        return this.qaRegeneratingItemId
            ? (this.qaBatchRegenerationTotal > 1
                ? '선택한 QA만 차례대로 교체하며, 완료된 항목은 선택 목록에서 자동으로 제외됩니다.'
                : '선택한 QA 한 건만 교체하며 다른 QA는 그대로 유지됩니다.')
            : '백그라운드로 전환해도 생성 작업은 중단되지 않습니다.';
    }

    public generationReadinessMessage() {
        const selectedCount = this.selectedGenerationSources().length;
        if (!selectedCount && this.generationModalKind && this.generationModalKind.key === 'qa') {
            return '저장된 연결 범위에서 Chunk 준비가 완료된 원문을 찾지 못했습니다.';
        }
        if (!selectedCount) return '왼쪽에서 원문 자료를 1개 이상 선택해주세요.';
        if (this.generationModalKind && this.generationModalKind.key === 'qa') {
            return `자료 컨테이너 ${selectedCount}건에서 primary_original 원문을 확인해 목표 QA ${this.qaTargetCount()}개를 생성합니다. 원문이 부족하면 검증된 결과만 부분 저장하며, 전체 자료의 원문 비율 때문에 생성을 차단하지 않습니다.`;
        }
        return '생성 준비가 완료되었습니다.';
    }

    public generationSourceLabel() {
        return this.generationModalKind ? '원문 자료' : '생성 자료';
    }

    public generationButtonLabel(kind: any) {
        const state = kind && this.outputGenerationStates[kind.key];
        if (kind && kind.key === 'qa' && this.qaGenerationIsPartial(state)) return '부족분 생성';
        if (state && state.status === 'completed') return '다시 생성';
        return kind && kind.key === 'kg' ? '지식그래프 생성' : 'QA 생성';
    }

    public generationCardHint(kind: any) {
        const state = kind && this.outputGenerationStates[kind.key];
        if (kind && kind.key === 'qa' && this.qaGenerationIsPartial(state)) {
            return '부분 저장 · QA ' + (state.qa_count || 0) + '개 · 부족분 '
                + (state.remaining_qa_count || 0) + '개';
        }
        if (state && state.status === 'completed') {
            if (kind.key === 'kg') {
                return '생성 작업 완료 · 그래프 '
                    + this.kgGenerationGraphStatusLabel(state.graph_status)
                    + ' · Claim ' + state.claim_count + '개 · 노드 ' + state.node_count + '개';
            }
            return '생성 완료 · QA ' + (state.qa_count || 0) + '개';
        }
        return this.isProjectSettingComplete(kind)
            ? (kind.key === 'qa'
                ? '저장한 연결 범위에서 대표 원문을 자동 활용해 생성을 시작할 수 있습니다.'
                : '세부 페이지에서 원문 자료를 선택해 생성을 시작할 수 있습니다.')
            : '세부 페이지에서 설정을 완료한 뒤 생성을 시작할 수 있습니다.';
    }

    public async startOutputGeneration() {
        if (!this.canStartOutputGeneration()) return;
        const kind = this.generationModalKind;
        const incrementalTarget = kind.key === 'qa' && this.qaGenerationUpdateMode === 'append_to_target'
            ? this.qaResultTargetDelta()
            : this.qaTargetCount();
        this.generationRunning = true;
        this.qaGenerationProgressDialogOpen = kind.key === 'qa';
        this.generationProgress = kind.key === 'qa' ? {
            stage: 'source_analysis',
            stage_number: 1,
            generated_count: 0,
            target_qa_count: incrementalTarget,
            final_target_qa_count: this.qaTargetCount(),
            existing_qa_count: this.qaResultItems().length,
            processed_source_count: 0,
            total_source_count: this.selectedGenerationSources().length
        } : {};
        this.generationError = '';
        this.generationErrorCode = '';
        this.generationStartedAtMs = Date.now();
        this.generationLastProgressAtMs = this.generationStartedAtMs;
        this.generationResult = null;
        await this.service.render();

        const payload = {
            kind: kind.key,
            project_id: this.project.id,
            project_name: this.project.name,
            source_ids: this.selectedGenerationSources().map((source: any) => source.id),
            search_query: String(
                this.generationSearchQuery
                || (kind.key === 'qa' ? this.qaConfiguredScopeQuery() : '')
            ).trim(),
            setting: this.cloneValue(this.projectSettings[kind.key]),
            ...(kind.key === 'qa' && this.qaGenerationUpdateMode === 'append_to_target' ? {
                qa_update_mode: 'append_to_target',
                source_artifact_sha256: this.qaResultSourceDigest
            } : {})
        };
        const started = await this.callGenerationOutput({
            payload: JSON.stringify(payload)
        });
        if (started.code === 202 && started.data && started.data.job_id) {
            this.generationJobId = started.data.job_id;
            this.syncGenerationTiming(started.data, true);
            if (started.data.progress) {
                this.generationProgress = {
                    ...started.data.progress,
                    ...(kind.key === 'qa' && this.qaGenerationUpdateMode === 'append_to_target' ? {
                        target_qa_count: incrementalTarget,
                        final_target_qa_count: this.qaTargetCount(),
                        existing_qa_count: this.qaResultItems().length
                    } : {})
                };
            }
            await this.service.render();
            await this.waitForOutputGeneration(kind, this.generationJobId);
            return;
        }
        await this.finishOutputGeneration(kind, started.code, started.data);
    }

    private async resumeOutputGeneration() {
        if (!this.generationModalKind || this.generationRunning) return;
        const kind = this.generationModalKind;
        const active = await this.callGenerationOutput({
            active: 'true',
            kind: kind.key,
            project_id: this.project.id
        });
        if (active.code !== 202 || !active.data || !active.data.job_id) return;
        this.generationRunning = true;
        this.qaGenerationProgressDialogOpen = kind.key === 'qa';
        this.generationJobId = active.data.job_id;
        this.generationProgress = active.data.progress || {};
        this.generationError = '';
        this.generationErrorCode = '';
        this.syncGenerationTiming(active.data, true);
        await this.service.render();
        await this.waitForOutputGeneration(kind, this.generationJobId);
    }

    private async callGenerationOutput(parameters: any) {
        try {
            return await wiz.call('generate_output', parameters);
        } catch (error) {
            const response: any = error || {};
            return {
                code: Number(response.status || 500),
                data: response.responseJSON || response.data || null
            };
        }
    }

    private async waitForOutputGeneration(kind: any, jobId: string) {
        let code = 202;
        let data: any = null;
        let transientFailures = 0;
        for (let attempt = 0; attempt < 900 && code === 202; attempt += 1) {
            await new Promise((resolve) => setTimeout(resolve, 2000));
            const polled = await this.callGenerationOutput({
                job_id: jobId,
                project_id: this.project.id
            });
            const structuredError = !!(polled.data && polled.data.code);
            if (polled.code >= 500 && !structuredError && transientFailures < 15) {
                transientFailures += 1;
                continue;
            }
            transientFailures = 0;
            code = polled.code;
            data = polled.data;
            if (code === 202 && data) this.syncGenerationTiming(data);
            if (code === 202 && data && data.progress) {
                this.generationProgress = data.progress;
                await this.service.render();
            }
        }
        if (code === 202) {
            code = 504;
            data = { message: '생성 작업이 계속 진행 중입니다. 잠시 후 생성 창을 다시 열어주세요.' };
        }
        await this.finishOutputGeneration(kind, code, data);
    }

    private async finishOutputGeneration(kind: any, code: number, data: any) {
        if (code === 200) {
            this.generationError = '';
            this.generationErrorCode = '';
            if (kind.key === 'kg') {
                data = {
                    ...data,
                    generation_status: String(data && (data.generation_status || data.status) || 'completed'),
                    graph_status: String(data && data.graph_status || 'created'),
                    approval_status: 'not_approved',
                    ai_quality_gate_status: 'pending',
                    human_release_status: 'pending',
                    artifact_snapshot_kind: 'generation_output'
                };
            } else {
                data = {
                    ...data,
                    generation_status: String(data && (data.generation_status || data.status) || 'completed'),
                    ai_quality_gate_status: 'pending',
                    human_release_status: 'pending',
                    artifact_snapshot_kind: 'generation_output'
                };
            }
            this.generationResult = data;
            this.outputGenerationStates[kind.key] = data;
            if (kind.key === 'kg') {
                this.project.kgCount = Number(data.claim_count || 0);
                this.project.nodeCount = Number(data.node_count || 0);
                this.project.edgeCount = Number(data.edge_count || 0);
                this.kgPersistedResult = { ...data, kind: 'kg', status: 'completed' };
                this.kgResult = null;
                this.kgResultArtifact = '';
            } else {
                this.project.qaCount = Number(data.qa_count || 0);
                this.qaPersistedResult = { ...data, kind: 'qa', status: 'completed' };
                this.qaResult = null;
                this.qaResultArtifact = '';
                if (this.project.qaCount > 0) {
                    try {
                        const review = await this.postProjectWorkflow(this.qaReviewTaskUrl);
                        const reviewState = this.normalizeWorkspaceState({ state: review?.state });
                        if (reviewState) this.workspaceState = reviewState;
                    } catch (error) {
                        await this.service.modal.warning(
                            'QA 생성은 완료됐지만 검수 작업을 준비하지 못했습니다. QA 결과 화면에서 다시 준비해주세요.',
                            false,
                            '확인'
                        );
                    }
                }
                await this.restoreQaGenerationResult();
            }
        } else {
            if (data && data.progress) this.generationProgress = data.progress;
            if (data) this.syncGenerationTiming(data);
            this.generationError = (data && data.message) || '생성 요청을 완료하지 못했습니다.';
            this.generationErrorCode = String(data && data.code || '').trim();
        }
        this.generationJobId = '';
        this.generationRunning = false;
        this.qaGenerationProgressDialogOpen = false;
        this.qaGenerationUpdateMode = 'replace_all';
        await this.service.render();
    }

    public async minimizeQaGenerationProgress() {
        this.qaGenerationProgressDialogOpen = false;
        await this.service.render();
    }

    public async openQaGenerationProgress() {
        if ((!this.generationRunning && !this.qaRegenerationPreparing) || !this.generationModalKind || this.generationModalKind.key !== 'qa') return;
        this.qaGenerationProgressDialogOpen = true;
        await this.service.render();
    }

    public async navigateToQaResult() {
        const targetTab = 'qa-result';
        const targetUrl = `/review-projects/${encodeURIComponent(String(this.project.id || ''))}/${targetTab}`;
        let navigated = false;
        try {
            navigated = await this.router.navigateByUrl(targetUrl);
        } catch (error) {
            navigated = false;
        }

        if (navigated && this.currentProjectRouteSegments()?.tab === targetTab) {
            if (this.tab !== targetTab) {
                this.syncRoute();
                await this.service.render();
                await this.prepareOutputDetail(true);
            }
            return;
        }

        if (typeof window !== 'undefined') {
            window.location.assign(targetUrl);
            return;
        }

        this.tab = targetTab;
        await this.service.render();
        await this.prepareOutputDetail(true);
    }

    public qaResultAvailable(kind?: any) {
        return (!kind || kind.key === 'qa') && !!this.qaPersistedResult;
    }

    public async navigateToQaGeneration() {
        await this.router.navigate(['/review-projects', this.project.id, 'qa']);
    }

    public async regenerateQaFromResult() {
        if (this.generationRunning) {
            await this.openQaGenerationProgress();
            return;
        }
        const kind = this.projectSettingKinds.find((item: any) => item.key === 'qa');
        if (!kind || !this.isProjectSettingComplete(kind)) {
            await this.service.modal.warning(
                'QA 생성 설정을 먼저 완료해주세요.', false, '확인',
            );
            return;
        }

        this.generationModalKind = kind;
        this.qaRegenerationPreparing = true;
        this.qaGenerationProgressDialogOpen = true;
        this.generationError = '';
        this.generationErrorCode = '';
        await this.service.render();

        try {
            await this.openOutputGeneration(kind, false);
            if (!this.canStartOutputGeneration()) {
                const message = this.generationError || this.generationReadinessMessage();
                this.qaRegenerationPreparing = false;
                this.qaGenerationProgressDialogOpen = false;
                await this.service.render();
                await this.service.modal.warning(message, false, '확인');
                return;
            }

            this.qaRegenerationPreparing = false;
            await this.startOutputGeneration();
            if (this.generationError) {
                await this.service.modal.warning(this.generationError, false, '확인');
                return;
            }
            await this.loadQaResult(true);
        } catch (error) {
            this.qaRegenerationPreparing = false;
            this.qaGenerationProgressDialogOpen = false;
            await this.service.render();
            await this.service.modal.warning(
                error instanceof Error ? error.message : 'QA 다시 생성을 준비하지 못했습니다.',
                false,
                '확인',
            );
        }
    }

    private qaGenerationResultFromSet(qaSet: any, envelope: any = {}) {
        const metrics = (qaSet && qaSet.metrics) || {};
        const items = Array.isArray(qaSet && qaSet.items) ? qaSet.items : [];
        const sources = Array.isArray(qaSet && qaSet.source_snapshots) ? qaSet.source_snapshots : [];
        const generation = (qaSet && qaSet.generation) || {};
        const completionStatus = String(
            envelope.generation_status || generation.completion_status || 'completed'
        ).toLowerCase() === 'partial' ? 'partial' : 'completed';
        const requestedCount = Number(
            generation.target_qa_count || Math.max(items.length, sources.length * 3)
        );
        const metric = (key: string, fallback: number) => {
            const value = Number(metrics[key]);
            return Number.isFinite(value) ? value : fallback;
        };
        return {
            kind: 'qa',
            status: completionStatus,
            generation_status: completionStatus,
            ai_quality_gate_status: envelope.ai_quality_gate_status === 'passed'
                ? 'passed'
                : 'pending',
            human_release_status: 'pending',
            human_review_status: String(envelope.human_review_status || 'not_assigned'),
            human_review: envelope.human_review && typeof envelope.human_review === 'object'
                ? { ...envelope.human_review }
                : {
                    status: 'not_assigned',
                    label: '사람 검수 전',
                    reviewed_sample_count: 0,
                    sample_count: 0,
                    total_qa_count: metric('qa_count', items.length)
                },
            artifact_snapshot_kind: envelope.artifact_snapshot_kind === 'immutable_ai_quality_snapshot'
                ? 'immutable_ai_quality_snapshot'
                : (envelope.artifact_snapshot_kind === 'curated_result_view'
                    ? 'curated_result_view'
                    : 'generation_output'),
            message: completionStatus === 'partial'
                ? `검증을 통과한 QA ${items.length}개가 부분 저장되어 있습니다.`
                : '저장된 QA 결과가 있습니다.',
            qa_set_id: qaSet && qaSet.qa_set_id,
            generated_at: qaSet && qaSet.generated_at,
            requested_qa_count: requestedCount,
            remaining_qa_count: Math.max(0, requestedCount - items.length),
            source_count: metric('source_count', sources.length),
            qa_count: metric('qa_count', items.length),
            citation_count: metric('citation_count', items.length),
            pending_review_count: metric(
                'pending_review_count',
                items.filter((item: any) => item.review_status === 'pending').length
            )
        };
    }

    public qaGenerationIsPartial(result: any) {
        return String(result && (result.generation_status || result.status) || '').toLowerCase() === 'partial';
    }

    private qaSetVersionsFromArtifact(qaSet: any, envelope: any = {}) {
        const versions = Array.isArray(envelope?.qa_set_versions)
            ? envelope.qa_set_versions
            : [];
        if (versions.length > 0) return versions;

        const items = Array.isArray(qaSet?.items) ? qaSet.items : [];
        if (!qaSet || items.length === 0) return [];

        // QA-set version history was introduced after the first generation
        // artifacts had already been saved. Treat a valid legacy artifact as
        // the preserved first version instead of presenting it as "no history".
        const generation = qaSet.generation && typeof qaSet.generation === 'object'
            ? qaSet.generation
            : {};
        const targetQaCount = Number(generation.target_qa_count || 0);
        const remainingQaCount = Number(generation.remaining_qa_count || 0);
        const completionStatus = String(
            generation.completion_status || qaSet.status || ''
        ).toLowerCase();
        if (
            completionStatus === 'partial'
            || remainingQaCount > 0
            || (targetQaCount > 0 && items.length < targetQaCount)
        ) return [];
        const reviewPlan = qaSet.review_plan && typeof qaSet.review_plan === 'object'
            ? qaSet.review_plan
            : {};
        const humanReview = envelope?.human_review && typeof envelope.human_review === 'object'
            ? { ...envelope.human_review }
            : null;
        const qaSetId = String(qaSet.qa_set_id || '').trim();
        const versionId = String(
            qaSet.qa_set_version_id
            || generation.qa_set_version_id
            || qaSetId
            || 'legacy-qa-set-v1'
        ).trim();
        const reviewStatus = String(
            envelope?.human_review_status
            || humanReview?.status
            || 'not_assigned'
        );

        return [{
            id: versionId,
            version: 'v1.0',
            label: 'QA 세트 v1.0',
            qa_set_id: qaSetId,
            generated_at: String(qaSet.generated_at || ''),
            harness: String(generation.harness || ''),
            harness_version: String(
                generation.harness_version || generation.harnessVersion || ''
            ),
            survey: String(reviewPlan.survey || ''),
            survey_version: String(
                reviewPlan.survey_version || reviewPlan.surveyVersion || ''
            ),
            qa_count: items.length,
            target_qa_count: Number(generation.target_qa_count || items.length),
            is_current: true,
            human_review: humanReview,
            review_status: reviewStatus,
            review_status_label: String(
                humanReview?.label
                || (reviewStatus === 'completed' ? '사람 검수 완료' : '사람 검수 전')
            )
        }];
    }

    private async restoreQaGenerationResult() {
        const { code, data } = await this.callGenerationArtifact({
            project_id: this.project.id,
            kind: 'qa'
        });
        const qaSet = this.qaSetFromArtifactResponse(data);
        if (code === 200 && qaSet) {
            const selectedVersions = this.qaSetVersionsFromArtifact(qaSet, data);
            this.qaSetVersions = selectedVersions;
            this.qaPersistedResult = this.qaGenerationResultFromSet(qaSet, data);
            this.outputGenerationStates.qa = this.qaPersistedResult;
            this.project.qaCount = Number(this.qaPersistedResult.qa_count || 0);
        } else if (code === 404) {
            this.qaSetVersions = [];
            this.qaPersistedResult = null;
            this.outputGenerationStates.qa = null;
        }
        await this.service.render();
    }

    public async loadQaResult(force: boolean = false) {
        if (this.qaResultLoading) return;
        if (!force && this.qaResult) {
            await this.service.render();
            return;
        }
        this.qaResultLoading = true;
        this.qaResultError = '';
        if (force) {
            this.qaResult = null;
            this.qaResultArtifact = '';
            this.qaResultSourceDigest = '';
        }
        await this.service.render();

        const parameters: any = {
            project_id: this.project.id,
            kind: 'qa'
        };
        if (force && this.qaResultSelectedVersionId) {
            parameters.qa_set_version_id = this.qaResultSelectedVersionId;
        }
        const { code, data } = await this.callGenerationArtifact(parameters);
        const qaSet = this.qaSetFromArtifactResponse(data);
        if (code === 200 && qaSet) {
            this.qaSetVersions = this.qaSetVersionsFromArtifact(qaSet, data);
            this.qaResultSelectedVersionId = String(
                data?.selected_qa_set_version_id
                || this.qaSetVersions.find((row: any) => row?.is_selected === true)?.id
                || this.qaSetVersions.find((row: any) => row?.is_current === true)?.id
                || this.qaSetVersions[0]?.id
                || ''
            );
            this.qaResult = qaSet;
            this.qaResultArtifact = (data && data.artifact) || '';
            this.qaResultSourceDigest = (data && data.source_artifact_sha256) || '';
            this.qaResultPage = 1;
            this.qaPersistedResult = this.qaGenerationResultFromSet(qaSet, data);
            if (this.qaResultSelectedVersionIsCurrent()) {
                this.outputGenerationStates.qa = this.qaPersistedResult;
                this.project.qaCount = Number(this.qaPersistedResult.qa_count || 0);
            }
            if (this.qaResultHumanReviewCompleted() && this.qaResultStatusFilter === 'pending') {
                this.qaResultStatusFilter = 'human_review_completed';
            } else if (!this.qaResultHumanReviewCompleted() && this.qaResultStatusFilter === 'human_review_completed') {
                this.qaResultStatusFilter = 'pending';
            }
            this.qaResultTargetDraft = this.qaResultTargetCount();
            this.pruneQaResultSelection();
        } else {
            if (code === 404) {
                this.qaSetVersions = [];
                this.qaPersistedResult = null;
                this.outputGenerationStates.qa = null;
            }
            this.qaResultError = (data && data.message) || 'QA 결과를 불러오지 못했습니다.';
        }
        this.qaResultLoading = false;
        await this.service.render();
    }

    public qaResultSelectedVersion() {
        return this.qaSetVersions.find(
            (row: any) => String(row?.id || '') === this.qaResultSelectedVersionId
        ) || this.qaSetVersions.find((row: any) => row?.is_selected === true)
            || this.qaSetVersions.find((row: any) => row?.is_current === true)
            || this.qaSetVersions[0]
            || null;
    }

    public qaResultSelectedVersionIsCurrent() {
        const selected = this.qaResultSelectedVersion();
        return !selected || selected.is_current === true;
    }

    public qaResultVersionIsLatest(version: any) {
        return !!version && String(version.id || '') === String(this.qaSetVersions[0]?.id || '');
    }

    public qaResultVersionLabel(version?: any) {
        const selected = version || this.qaResultSelectedVersion();
        return String(selected?.label || selected?.version || 'QA 세트');
    }

    public qaResultVersionCriteriaLabel(version?: any) {
        const selected = version || this.qaResultSelectedVersion();
        const harness = String(selected?.harness_version || '').trim();
        const survey = String(selected?.survey_version || '').trim();
        return [
            harness ? `하네스 ${harness}` : '',
            survey ? `설문지 ${survey}` : ''
        ].filter(Boolean).join(' · ') || '적용 기준 정보 없음';
    }

    public qaResultVersionDate(version?: any) {
        const value = String((version || this.qaResultSelectedVersion())?.generated_at || '').trim();
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hour12: false
        }).format(date);
    }

    public toggleQaResultVersionMenu() {
        if (this.qaResultLoading || this.qaSetVersions.length < 2) return;
        this.qaResultVersionMenuOpen = !this.qaResultVersionMenuOpen;
    }

    public closeQaResultVersionMenu() {
        this.qaResultVersionMenuOpen = false;
    }

    public async selectQaResultVersion(version: any) {
        const versionId = String(version?.id || '').trim();
        if (
            !versionId
            || this.qaResultLoading
            || versionId === this.qaResultSelectedVersionId
        ) {
            this.qaResultVersionMenuOpen = false;
            await this.service.render();
            return;
        }
        this.qaResultVersionMenuOpen = false;
        this.qaResultLoading = true;
        this.qaResultError = '';
        await this.service.render();

        const { code, data } = await this.callGenerationArtifact({
            project_id: this.project.id,
            kind: 'qa',
            qa_set_version_id: versionId
        });
        const qaSet = this.qaSetFromArtifactResponse(data);
        if (code === 200 && qaSet) {
            this.qaSetVersions = this.qaSetVersionsFromArtifact(qaSet, data);
            this.qaResultSelectedVersionId = String(
                data?.selected_qa_set_version_id || versionId
            );
            this.qaResult = qaSet;
            this.qaResultArtifact = String(data?.artifact || '');
            this.qaResultSourceDigest = String(data?.source_artifact_sha256 || '');
            this.qaPersistedResult = this.qaGenerationResultFromSet(qaSet, data);
            this.qaResultPage = 1;
            this.qaResultTargetDraft = this.qaResultTargetCount();
            this.qaSelectedItemIds.clear();
            if (this.qaResultHumanReviewCompleted()) {
                if (this.qaResultStatusFilter === 'pending') {
                    this.qaResultStatusFilter = 'human_review_completed';
                }
            } else if (this.qaResultStatusFilter === 'human_review_completed') {
                this.qaResultStatusFilter = 'pending';
            }
        } else {
            this.qaResultError = String(data?.message || '선택한 QA 세트 결과를 불러오지 못했습니다.');
        }
        this.qaResultLoading = false;
        await this.service.render();
    }

    public qaResultMetric(key: string) {
        const metrics = (this.qaResult && this.qaResult.metrics) || {};
        return Number(metrics[key] || 0);
    }

    public qaResultItems() {
        return this.qaResult && Array.isArray(this.qaResult.items) ? this.qaResult.items : [];
    }

    private qaResultItemId(item: any) {
        return String(item && item.id || '').trim();
    }

    private pruneQaResultSelection() {
        const available = new Set(this.qaResultItems()
            .map((item: any) => this.qaResultItemId(item))
            .filter((itemId: string) => !!itemId));
        this.qaSelectedItemIds = new Set(
            Array.from(this.qaSelectedItemIds).filter((itemId: string) => available.has(itemId))
        );
    }

    public qaSelectedResultItems() {
        const selected = this.qaSelectedItemIds;
        return this.qaResultItems().filter((item: any) => selected.has(this.qaResultItemId(item)));
    }

    public qaSelectedResultCount() {
        return this.qaSelectedResultItems().length;
    }

    public isQaResultItemSelected(item: any) {
        return this.qaSelectedItemIds.has(this.qaResultItemId(item));
    }

    public qaAllResultItemsSelected() {
        const items = this.qaResultItems();
        return !!items.length && items.every((item: any) => this.isQaResultItemSelected(item));
    }

    public async toggleQaResultItemSelection(item: any, event: any) {
        if (this.qaSelectionBusy || this.generationRunning) return;
        const itemId = this.qaResultItemId(item);
        if (!itemId) return;
        const checked = !!(event && event.target && event.target.checked);
        if (checked) this.qaSelectedItemIds.add(itemId);
        else this.qaSelectedItemIds.delete(itemId);
        await this.service.render();
    }

    public async toggleAllQaResultItems() {
        if (this.qaSelectionBusy || this.generationRunning) return;
        const items = this.qaResultItems();
        if (this.qaAllResultItemsSelected()) {
            this.qaSelectedItemIds.clear();
        } else {
            this.qaSelectedItemIds = new Set(items
                .map((item: any) => this.qaResultItemId(item))
                .filter((itemId: string) => !!itemId));
        }
        await this.service.render();
    }

    public async clearQaResultSelection() {
        if (this.qaSelectionBusy || this.generationRunning || !this.qaSelectedItemIds.size) return;
        this.qaSelectedItemIds.clear();
        await this.service.render();
    }

    public qaResultSnapshots() {
        return this.qaResult && Array.isArray(this.qaResult.source_snapshots)
            ? this.qaResult.source_snapshots
            : [];
    }

    public qaResultSourceOptions() {
        const seen: any = {};
        return this.qaResultSnapshots().reduce((options: any[], snapshot: any) => {
            const id = String(snapshot.document_id || '').trim();
            if (!id || seen[id]) return options;
            seen[id] = true;
            options.push({ id: id, title: snapshot.document_title || id });
            return options;
        }, []);
    }

    public filteredQaResultItems() {
        const query = String(this.qaResultSearchQuery || '').trim().toLowerCase();
        return this.qaResultItems().filter((item: any) => {
            const citation = item && item.citation || {};
            const answer = item && item.answer || {};
            const evidence = citation.evidence_span || {};
            if (
                this.qaResultSourceFilter !== 'all'
                && citation.document_id !== this.qaResultSourceFilter
            ) return false;
            if (
                this.qaResultStatusFilter !== 'all'
                && this.qaResultEffectiveReviewStatus(item) !== this.qaResultStatusFilter
            ) return false;
            if (!query) return true;
            return [
                item.id,
                item.question,
                answer.text,
                citation.document_title,
                citation.document_id,
                evidence.quote
            ].join(' ').toLowerCase().indexOf(query) > -1;
        });
    }

    public qaResultPageCount() {
        return Math.max(1, Math.ceil(this.filteredQaResultItems().length / this.qaResultPageSize));
    }

    public pagedQaResultItems() {
        const page = Math.min(Math.max(1, this.qaResultPage), this.qaResultPageCount());
        const start = (page - 1) * this.qaResultPageSize;
        return this.filteredQaResultItems().slice(start, start + this.qaResultPageSize);
    }

    public qaResultPageNumbers() {
        return Array.from({ length: this.qaResultPageCount() }, (_value, index) => index + 1);
    }

    public qaResultRangeStart() {
        if (!this.filteredQaResultItems().length) return 0;
        return (this.qaResultPage - 1) * this.qaResultPageSize + 1;
    }

    public qaResultRangeEnd() {
        return Math.min(this.qaResultPage * this.qaResultPageSize, this.filteredQaResultItems().length);
    }

    public async setQaResultPage(page: number) {
        const next = Math.min(Math.max(1, Number(page) || 1), this.qaResultPageCount());
        if (next === this.qaResultPage) return;
        this.qaResultPage = next;
        await this.service.render();
    }

    public async onQaResultFiltersChanged() {
        this.qaResultPage = 1;
        await this.service.render();
    }

    public qaResultStatusLabel() {
        const status = this.qaResult && this.qaResult.status;
        if (this.qaResultHumanReviewCompleted()) return '사람 검수 완료';
        if (this.qaPersistedResult && this.qaPersistedResult.ai_quality_gate_status === 'passed') {
            return 'AI 품질 게이트 통과';
        }
        if (status === 'partial') return '부분 저장 · 부족분 생성 가능';
        if (status === 'generated') return '생성 완료 · 승인 전';
        if (status === 'approved') return 'QA approved · 사람 release 대기';
        return status || '상태 미확인';
    }

    public qaResultStatusIcon() {
        return this.qaResultHumanReviewCompleted() || (this.qaPersistedResult
            && this.qaPersistedResult.ai_quality_gate_status === 'passed'
        )
            ? 'fa-circle-check'
            : 'fa-circle-info';
    }

    public qaResultAiQualityGateLabel() {
        return this.qaPersistedResult
            && this.qaPersistedResult.ai_quality_gate_status === 'passed'
            ? 'AI 품질 게이트 통과'
            : 'AI 품질 게이트 대기';
    }

    public qaResultHumanReleaseLabel() {
        return this.qaPersistedResult
            && this.qaPersistedResult.human_release_status === 'released'
            ? '사람 release 완료'
            : '사람 release 대기';
    }

    public qaResultHumanReview() {
        const review = this.qaPersistedResult && this.qaPersistedResult.human_review;
        return review && typeof review === 'object' ? review : {};
    }

    public qaResultHumanReviewCompleted() {
        return String(this.qaResultHumanReview().status || '') === 'completed';
    }

    public qaResultHumanReviewLabel() {
        const status = String(this.qaResultHumanReview().status || 'not_assigned');
        if (status === 'completed') return '사람 검수 완료';
        if (status === 'in_progress') return '사람 검수 진행 중';
        if (status === 'pending') return '사람 검수 대기';
        return '사람 검수 전';
    }

    public qaResultHumanReviewMetricValue() {
        if (this.qaResultHumanReviewCompleted()) return '완료';
        if (this.qaResultHumanReview().status === 'in_progress') return '진행 중';
        return '대기';
    }

    public qaResultHumanReviewMetricCaption() {
        const review = this.qaResultHumanReview();
        const reviewed = Number(review.reviewed_sample_count || 0);
        const samples = Number(review.sample_count || 0);
        const total = Number(review.total_qa_count || this.qaResultMetric('qa_count'));
        if (this.qaResultHumanReviewCompleted()) {
            return `대표 표본 ${reviewed || samples}개 검수 완료 · 전체 QA ${total}개`;
        }
        if (review.status === 'in_progress') {
            return `대표 표본 ${reviewed}/${samples}개 확인 · 전체 QA ${total}개`;
        }
        if (samples > 0) return `대표 표본 ${samples}개 검수 대기 · 전체 QA ${total}개`;
        return `검수 작업 준비 전 · 전체 QA ${total}개`;
    }

    public qaResultEffectiveReviewStatus(item: any) {
        if (this.qaResultHumanReviewCompleted()) return 'human_review_completed';
        return String(item && item.review_status || 'pending');
    }

    public qaResultSnapshotLabel() {
        if (
            this.qaPersistedResult
            && this.qaPersistedResult.artifact_snapshot_kind === 'curated_result_view'
        ) return '삭제 반영 결과 · 원본 스냅샷 보존';
        return this.qaPersistedResult
            && this.qaPersistedResult.artifact_snapshot_kind === 'immutable_ai_quality_snapshot'
            ? 'immutable AI-quality snapshot'
            : '승인 전 생성 산출물';
    }

    public qaResultCreatedAt() {
        const value = this.qaResult && this.qaResult.generated_at;
        if (!value) return '—';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return date.toLocaleString('ko-KR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit'
        });
    }

    public qaResultTargetCount() {
        const generation = (this.qaResult && this.qaResult.generation) || {};
        const legacyTarget = Math.max(
            this.qaResultMetric('qa_count'),
            this.qaResultSnapshots().length * 3
        );
        return Number(generation.target_qa_count || legacyTarget);
    }

    public qaResultTargetDelta() {
        const target = Math.floor(Number(this.qaResultTargetDraft) || 0);
        return Math.max(0, target - this.qaResultItems().length);
    }

    public qaResultTargetProgress() {
        const target = Math.max(1, Math.floor(Number(this.qaResultTargetDraft) || this.qaResultTargetCount()));
        return Math.min(100, Math.round(this.qaResultItems().length / target * 100));
    }

    public qaResultTargetActionLabel() {
        if (this.qaResultTargetUpdating || this.generationRunning) return '생성 중';
        const delta = this.qaResultTargetDelta();
        return delta > 0 ? `부족분 ${delta}개 생성` : '목표 수량 저장';
    }

    public async generateQaToTarget() {
        if (!this.qaResultSelectedVersionIsCurrent() || this.qaResultTargetUpdating || this.generationRunning) return;
        const target = Math.floor(Number(this.qaResultTargetDraft) || 0);
        const current = this.qaResultItems().length;
        if (!Number.isInteger(target) || target < current || target > 150) {
            await this.service.modal.warning(
                `최종 목표는 현재 QA ${current}개 이상, 최대 150개까지 입력해주세요.`, false, '확인'
            );
            return;
        }
        const qaSetting = this.projectSettings && this.projectSettings.qa;
        if (!qaSetting) return;
        this.qaResultTargetUpdating = true;
        qaSetting.targetQaCount = target;
        this.settingsDraft = this.cloneValue(this.projectSettings);
        const persisted = await this.persistProjectSettings();
        if (!persisted) {
            this.qaResultTargetUpdating = false;
            await this.service.render();
            return;
        }
        if (target === current) {
            if (this.qaResult.generation) this.qaResult.generation.target_qa_count = target;
            this.qaResultTargetUpdating = false;
            await this.service.render();
            return;
        }
        const kind = this.projectSettingKinds.find((item: any) => item.key === 'qa');
        this.generationModalKind = kind;
        this.qaGenerationUpdateMode = 'append_to_target';
        this.qaRegenerationPreparing = true;
        this.qaGenerationProgressDialogOpen = true;
        this.generationError = '';
        this.generationErrorCode = '';
        await this.service.render();
        try {
            await this.openOutputGeneration(kind, false);
            this.qaGenerationUpdateMode = 'append_to_target';
            if (!this.canStartOutputGeneration()) {
                throw new Error(this.generationError || this.generationReadinessMessage());
            }
            this.qaRegenerationPreparing = false;
            await this.startOutputGeneration();
            if (this.generationError) throw new Error(this.generationError);
            await this.loadQaResult(true);
        } catch (error) {
            this.qaRegenerationPreparing = false;
            this.qaGenerationProgressDialogOpen = false;
            await this.service.modal.warning(
                error instanceof Error ? error.message : '부족분 QA 생성을 완료하지 못했습니다.', false, '확인'
            );
        } finally {
            this.qaResultTargetUpdating = false;
            await this.service.render();
        }
    }

    public async regenerateQaResultItem(item: any) {
        const itemId = String(item && item.id || '').trim();
        const citation = item && item.citation || {};
        const documentId = String(citation.document_id || '').trim();
        const chunkId = String(citation.chunk_id || '').trim();
        if (!this.qaResultSelectedVersionIsCurrent() || !itemId || !documentId || !chunkId || this.generationRunning || this.qaSelectionBusy) return;
        const confirmed = await this.service.modal.show({
            title: 'QA 한 건 다시 생성',
            message: `'${itemId}'을 같은 원문과 Chunk에서 다시 생성해 교체할까요? 다른 QA는 그대로 유지됩니다.`,
            cancel: '취소', action: '다시 생성', actionBtn: 'primary', status: 'info'
        });
        if (!confirmed) return;
        this.qaRegeneratingItemId = itemId;
        this.generationRunning = true;
        this.qaGenerationProgressDialogOpen = true;
        this.generationModalKind = this.projectSettingKinds.find((kind: any) => kind.key === 'qa');
        this.generationProgress = {
            stage: 'source_analysis',
            stage_number: 1,
            generated_count: 0,
            target_qa_count: 1,
            final_target_qa_count: this.qaResultItems().length,
            existing_qa_count: this.qaResultItems().length,
            processed_source_count: 0,
            total_source_count: 1
        };
        this.generationError = '';
        this.generationErrorCode = '';
        this.generationStartedAtMs = Date.now();
        this.generationLastProgressAtMs = this.generationStartedAtMs;
        await this.service.render();
        const payload = {
            kind: 'qa',
            project_id: this.project.id,
            project_name: this.project.name,
            source_ids: [documentId],
            source_chunk_ids: { [documentId]: chunkId },
            search_query: '',
            setting: this.cloneValue(this.projectSettings.qa),
            qa_update_mode: 'replace_item',
            replace_item_id: itemId,
            source_artifact_sha256: this.qaResultSourceDigest
        };
        const started = await this.callGenerationOutput({ payload: JSON.stringify(payload) });
        if (started.code === 202 && started.data && started.data.job_id) {
            this.generationJobId = started.data.job_id;
            this.syncGenerationTiming(started.data, true);
            await this.waitForOutputGeneration(this.generationModalKind, this.generationJobId);
        } else {
            await this.finishOutputGeneration(this.generationModalKind, started.code, started.data);
        }
        if (!this.generationError) await this.loadQaResult(true);
        if (this.generationError) {
            await this.service.modal.warning(this.generationError, false, '확인');
        }
        this.qaRegeneratingItemId = '';
        await this.service.render();
    }

    public async regenerateSelectedQaResultItems() {
        const initiallySelected = this.qaSelectedResultItems();
        if (!this.qaResultSelectedVersionIsCurrent() || !initiallySelected.length || this.generationRunning || this.qaSelectionBusy) return;
        const invalidItem = initiallySelected.find((item: any) => {
            const citation = item && item.citation || {};
            return !this.qaResultItemId(item)
                || !String(citation.document_id || '').trim()
                || !String(citation.chunk_id || '').trim();
        });
        if (invalidItem) {
            await this.service.modal.warning(
                '선택한 QA 중 원문과 Chunk 근거가 없는 항목이 있습니다. 해당 QA는 다시 생성할 수 없습니다.',
                false,
                '확인'
            );
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '선택 QA 다시 생성',
            message: `선택한 ${initiallySelected.length}개 QA를 각각 같은 원문과 Chunk에서 다시 생성해 교체할까요? 완료된 항목부터 반영되며 다른 QA는 유지됩니다.`,
            cancel: '취소', action: '선택 재생성', actionBtn: 'primary', status: 'info'
        });
        if (!confirmed) return;

        const kind = this.projectSettingKinds.find((entry: any) => entry.key === 'qa');
        if (!kind) {
            await this.service.modal.warning('QA 생성 설정을 찾지 못했습니다.', false, '확인');
            return;
        }

        this.qaSelectionBusy = true;
        this.generationRunning = true;
        this.qaBatchRegenerationTotal = initiallySelected.length;
        this.qaBatchRegenerationIndex = 0;
        this.generationModalKind = kind;
        this.qaGenerationProgressDialogOpen = true;
        let failureMessage = '';
        try {
            for (const selectedItem of initiallySelected) {
                const itemId = this.qaResultItemId(selectedItem);
                const currentItem = this.qaResultItems().find(
                    (item: any) => this.qaResultItemId(item) === itemId
                );
                const citation = currentItem && currentItem.citation || {};
                const documentId = String(citation.document_id || '').trim();
                const chunkId = String(citation.chunk_id || '').trim();
                if (!currentItem || !documentId || !chunkId) {
                    failureMessage = '선택한 QA가 변경되어 다시 생성하지 못했습니다. 결과를 새로고침한 뒤 다시 선택해주세요.';
                    break;
                }

                this.qaBatchRegenerationIndex += 1;
                this.qaRegeneratingItemId = itemId;
                this.generationRunning = true;
                this.qaGenerationProgressDialogOpen = true;
                this.generationProgress = {
                    stage: 'source_analysis',
                    stage_number: 1,
                    generated_count: 0,
                    target_qa_count: 1,
                    final_target_qa_count: this.qaResultItems().length,
                    existing_qa_count: this.qaResultItems().length,
                    processed_source_count: 0,
                    total_source_count: 1
                };
                this.generationError = '';
                this.generationErrorCode = '';
                this.generationStartedAtMs = Date.now();
                this.generationLastProgressAtMs = this.generationStartedAtMs;
                await this.service.render();

                const payload = {
                    kind: 'qa',
                    project_id: this.project.id,
                    project_name: this.project.name,
                    source_ids: [documentId],
                    source_chunk_ids: { [documentId]: chunkId },
                    search_query: '',
                    setting: this.cloneValue(this.projectSettings.qa),
                    qa_update_mode: 'replace_item',
                    replace_item_id: itemId,
                    source_artifact_sha256: this.qaResultSourceDigest
                };
                const started = await this.callGenerationOutput({ payload: JSON.stringify(payload) });
                if (started.code === 202 && started.data && started.data.job_id) {
                    this.generationJobId = started.data.job_id;
                    this.syncGenerationTiming(started.data, true);
                    await this.waitForOutputGeneration(kind, this.generationJobId);
                } else {
                    await this.finishOutputGeneration(kind, started.code, started.data);
                }
                await this.loadQaResult(true);
                if (this.generationError) {
                    failureMessage = this.generationError;
                    break;
                }
                this.qaSelectedItemIds.delete(itemId);
            }

            if (failureMessage) {
                await this.service.modal.warning(
                    `${failureMessage} 완료된 QA는 유지했고, 남은 QA는 선택된 상태로 남겼습니다.`, false, '확인'
                );
            } else {
                await this.service.modal.success(
                    `선택한 ${initiallySelected.length}개 QA를 각각 다시 생성했습니다.`
                );
            }
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '선택한 QA를 다시 생성하지 못했습니다.',
                false,
                '확인'
            );
        } finally {
            this.qaRegeneratingItemId = '';
            this.qaBatchRegenerationTotal = 0;
            this.qaBatchRegenerationIndex = 0;
            this.generationRunning = false;
            this.qaGenerationProgressDialogOpen = false;
            this.qaSelectionBusy = false;
            await this.service.render();
        }
    }

    public qaResultGeneratorLabel() {
        const generation = (this.qaResult && this.qaResult.generation) || {};
        const generator = generation.generator || {};
        return generator.name || '생성기 정보 없음';
    }

    public qaResultTypeLabel(type: string) {
        if (type === 'factual') return '사실 확인형';
        if (type === 'source_comparison') return '사료 비교형';
        return type || '유형 미지정';
    }

    public qaResultReviewStatusLabel(status: string) {
        if (status === 'human_review_completed') return '사람 검수 완료';
        if (status === 'pending') return '사람 검수 전';
        if (status === 'approved') return '사람 검수 승인';
        if (status === 'changes_requested') return '수정 요청';
        if (status === 'rejected') return '사용 제외';
        return status || '상태 미확인';
    }

    public qaResultConfidence(item: any) {
        const confidence = Number(item && item.confidence);
        return Number.isFinite(confidence) ? Math.round(confidence * 100) : 0;
    }

    public qaResultCitationPage(item: any) {
        const citation = item && item.citation || {};
        const page = citation.page_span && citation.page_span.page_number;
        return page === 0 || page ? `${page}쪽` : '페이지 미확인';
    }

    public qaResultTranslationDisplay(item: any): string {
        const citation = item && item.citation || {};
        const translationChunkId = String(citation.translation_chunk_id || '').trim();
        const translationQuote = String(citation.translation_quote || '').trim();
        const translationDisplay = String(citation.translation_display || '').trim();
        return translationChunkId && translationQuote
            ? modernizeHistoricalProse(translationDisplay || translationQuote)
            : '';
    }

    public qaResultCommentaryDisplay(item: any): string {
        if (this.qaResultTranslationDisplay(item)) return '';
        const citation = item && item.citation || {};
        return modernizeHistoricalProse(citation.commentary_quote).trim();
    }

    public qaReadableText(value: any): string {
        return modernizeHistoricalProse(value);
    }

    public qaOriginalText(value: any): string {
        // Preserve the immutable source string. The bundled YetHangul font
        // renders both Hanyang PUA and standard old-Hangul code points.
        return String(value ?? '');
    }

    public qaOriginalUsesHistoricalHangul(value: any): boolean {
        return OLD_HANGUL_RE.test(String(value ?? ''));
    }

    public async openQaResultSourceModal(item: any) {
        const citation = item && item.citation || {};
        if (!citation.document_id && !citation.snapshot_id) return;
        const snapshot = this.qaResultSnapshots().find((entry: any) => (
            (citation.snapshot_id && entry.snapshot_id === citation.snapshot_id)
            || (
                entry.document_id === citation.document_id
                && Number(entry.document_version || 0) === Number(citation.document_version || 0)
            )
        ));
        this.qaResultSourceModalItem = item;
        this.qaResultSourceModalSnapshot = {
            ...(snapshot || {}),
            ...citation,
            source_profile: {
                ...((snapshot && snapshot.source_profile) || {}),
                ...(citation.source_profile || {})
            }
        };
        this.qaResultSourceModalOpen = true;
        await this.service.render();
    }

    public async closeQaResultSourceModal() {
        this.qaResultSourceModalOpen = false;
        this.qaResultSourceModalItem = null;
        this.qaResultSourceModalSnapshot = null;
        await this.service.render();
    }

    public qaResultSourceFormat() {
        const snapshot = this.qaResultSourceModalSnapshot || {};
        return snapshot.original_kind ? String(snapshot.original_kind).toUpperCase() : '사료(원문)';
    }

    public qaResultSourceStatusLabel() {
        const status = this.qaResultSourceModalSnapshot && this.qaResultSourceModalSnapshot.document_status;
        if (status === 'published') return '게시됨';
        if (status === 'draft') return '작성 중';
        return status || '상태 미확인';
    }

    public qaResultSourceProviderLabel() {
        const provider = this.qaResultSourceModalSnapshot && this.qaResultSourceModalSnapshot.provider;
        if (provider === 'material-vault') return '자료함 API';
        return provider || '제공 경로 미확인';
    }

    public qaResultSourceTypeLabel() {
        const profile = this.qaResultSourceModalSnapshot && this.qaResultSourceModalSnapshot.source_profile || {};
        return profile.source_type_label || '출처 유형 미분류';
    }

    public qaResultSourceEvidenceEntries() {
        const snapshot = this.qaResultSourceModalSnapshot;
        if (!snapshot) return [];
        return this.qaResultItems()
            .filter((item: any) => {
                const citation = item && item.citation || {};
                return (snapshot.snapshot_id && citation.snapshot_id === snapshot.snapshot_id)
                    || (
                        citation.document_id === snapshot.document_id
                        && Number(citation.document_version || 0) === Number(snapshot.document_version || 0)
                    );
            })
            .map((item: any) => {
                const citation = item.citation || {};
                const evidence = citation.evidence_span || {};
                const page = citation.page_span && citation.page_span.page_number;
                const translation = this.qaResultTranslationDisplay(item);
                const commentary = this.qaResultCommentaryDisplay(item);
                return {
                    id: item.id || 'QA',
                    question: modernizeHistoricalProse(item.question || '질문 정보 없음'),
                    answer: modernizeHistoricalProse(item.answer && item.answer.text || ''),
                    quote: String(evidence.quote || ''),
                    hasHistoricalHangul: this.qaOriginalUsesHistoricalHangul(evidence.quote),
                    modernKorean: translation || commentary,
                    modernKoreanSource: translation ? '연결 번역' : commentary ? '연결 해설' : '',
                    pageLabel: page === 0 || page ? `${page}쪽` : '페이지 미확인',
                    chunkLabel: citation.chunk_id ? `Chunk ${citation.chunk_id}` : 'Chunk 미확인'
                };
            });
    }

    public qaResultSourcePageCount() {
        const pages = new Set(
            this.qaResultSourceEvidenceEntries()
                .map((entry: any) => entry.pageLabel)
                .filter((label: string) => label !== '페이지 미확인')
        );
        return pages.size;
    }

    public qaResultSourceRetrievedAt() {
        const value = this.qaResultSourceModalSnapshot && this.qaResultSourceModalSnapshot.retrieved_at;
        if (!value) return '—';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return date.toLocaleString('ko-KR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit'
        });
    }

    public async deleteQaResultItem(item: any) {
        const itemId = String(item && item.id || '').trim();
        if (!this.qaResultSelectedVersionIsCurrent() || !itemId || this.qaDeletingItemId || this.qaSelectionBusy || this.generationRunning) return;
        const confirmed = await this.service.modal.show({
            title: 'QA 삭제',
            message: `'${itemId}' QA를 결과에서 삭제하시겠습니까? 원본 생성 스냅샷은 보존되지만 결과 목록과 JSON·Excel 내보내기에서는 제외됩니다.`,
            cancel: '취소',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;

        this.qaDeletingItemId = itemId;
        await this.service.render();
        const { code, data } = await this.callDeleteQaItem({
            project_id: this.project.id,
            item_id: itemId,
            source_artifact_sha256: this.qaResultSourceDigest
        });
        const qaSet = this.qaSetFromArtifactResponse(data);
        if (code !== 200 || !qaSet) {
            this.qaDeletingItemId = '';
            await this.service.render();
            await this.service.modal.warning(
                (data && data.message) || 'QA를 삭제하지 못했습니다.', false, '확인'
            );
            return;
        }

        this.qaResult = qaSet;
        this.qaResultArtifact = (data && data.artifact) || this.qaResultArtifact;
        this.qaResultSourceDigest = (data && data.source_artifact_sha256) || '';
        this.qaPersistedResult = this.qaGenerationResultFromSet(qaSet, data);
        this.outputGenerationStates.qa = this.qaPersistedResult;
        this.project.qaCount = Number(this.qaPersistedResult.qa_count || 0);
        this.qaResultPage = Math.min(this.qaResultPage, this.qaResultPageCount());
        this.pruneQaResultSelection();
        this.qaDeletingItemId = '';
        await this.service.render();
        await this.service.modal.success(`'${itemId}' QA가 결과에서 삭제되었습니다.`);
    }

    public async deleteSelectedQaResultItems() {
        const selectedItems = this.qaSelectedResultItems();
        if (!this.qaResultSelectedVersionIsCurrent() || !selectedItems.length || this.qaSelectionBusy || this.generationRunning) return;
        const itemIds = selectedItems.map((item: any) => this.qaResultItemId(item));
        const confirmed = await this.service.modal.show({
            title: '선택 QA 삭제',
            message: `선택한 ${itemIds.length}개 QA를 결과에서 삭제하시겠습니까? 원본 생성 스냅샷은 보존되지만 결과 목록과 JSON·Excel 내보내기에서는 제외됩니다.`,
            cancel: '취소', action: '선택 삭제', actionBtn: 'error', status: 'error'
        });
        if (!confirmed) return;

        this.qaSelectionBusy = true;
        await this.service.render();
        try {
            const { code, data } = await this.callDeleteQaItems({
                project_id: this.project.id,
                item_ids: JSON.stringify(itemIds),
                source_artifact_sha256: this.qaResultSourceDigest
            });
            const qaSet = this.qaSetFromArtifactResponse(data);
            if (code !== 200 || !qaSet) {
                await this.service.modal.warning(
                    (data && data.message) || '선택한 QA를 삭제하지 못했습니다.', false, '확인'
                );
                return;
            }

            this.qaResult = qaSet;
            this.qaResultArtifact = (data && data.artifact) || this.qaResultArtifact;
            this.qaResultSourceDigest = (data && data.source_artifact_sha256) || '';
            this.qaPersistedResult = this.qaGenerationResultFromSet(qaSet, data);
            this.outputGenerationStates.qa = this.qaPersistedResult;
            this.project.qaCount = Number(this.qaPersistedResult.qa_count || 0);
            this.qaResultPage = Math.min(this.qaResultPage, this.qaResultPageCount());
            this.pruneQaResultSelection();
            await this.service.render();
            await this.service.modal.success(`선택한 ${itemIds.length}개 QA를 결과에서 삭제했습니다.`);
        } finally {
            this.qaSelectionBusy = false;
            await this.service.render();
        }
    }

    public resultExportBusy(kind: string, format?: string) {
        const prefix = `${kind}:`;
        if (format) return this.resultExportLoading === `${prefix}${format}`;
        return this.resultExportLoading.indexOf(prefix) === 0;
    }

    public async exportQaResult(format: string) {
        await this.exportGenerationResult('qa', format);
    }

    public async exportKgResult(format: string) {
        await this.exportGenerationResult('kg', format);
    }

    private async exportGenerationResult(kind: string, format: string) {
        const artifact = kind === 'qa' ? this.qaResult : this.kgResult;
        if (!artifact || this.resultExportLoading) return;
        if (['qa', 'kg'].indexOf(kind) < 0 || ['json', 'xlsx'].indexOf(format) < 0) {
            await this.service.modal.warning('지원하지 않는 내보내기 형식입니다.', false);
            return;
        }

        this.resultExportLoading = `${kind}:${format}`;
        try {
            const body = new URLSearchParams();
            body.set('project_id', this.project.id);
            body.set('kind', kind);
            body.set('format', format);
            if (kind === 'qa' && this.qaResultSelectedVersionId) {
                body.set('qa_set_version_id', this.qaResultSelectedVersionId);
            }
            const response = await fetch(wiz.url('export_result'), {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Accept': format === 'xlsx'
                        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        : 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: body.toString()
            });
            const disposition = String(response.headers.get('Content-Disposition') || '');
            if (!response.ok || disposition.toLowerCase().indexOf('attachment') < 0) {
                let message = '결과 파일을 생성하지 못했습니다.';
                try {
                    const payload: any = JSON.parse(await response.text());
                    const data = payload && payload.data !== undefined ? payload.data : payload;
                    message = data && data.message ? data.message : message;
                } catch (error) {
                    // Keep the bounded public fallback; never expose raw server errors.
                }
                throw new Error(message);
            }
            const contentType = String(response.headers.get('Content-Type') || '').toLowerCase();
            const expectedType = format === 'xlsx'
                ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                : 'application/json';
            if (contentType.indexOf(expectedType) < 0) {
                throw new Error('내보내기 파일 형식이 요청과 일치하지 않습니다.');
            }
            const blob = await response.blob();
            if (!blob.size) throw new Error('내보내기 파일이 비어 있습니다.');

            const objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = objectUrl;
            anchor.download = `${this.project.id}-${kind}-result.${format}`;
            anchor.rel = 'noopener';
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '결과 파일을 생성하지 못했습니다.',
                false
            );
        } finally {
            this.resultExportLoading = '';
        }
    }

    public async navigateToKgResult() {
        await this.router.navigate(['/review-projects', this.project.id, 'kg-result']);
    }

    public async navigateToKgGeneration() {
        await this.router.navigate(['/review-projects', this.project.id, 'kg']);
    }

    private async callGenerationArtifact(parameters: any) {
        try {
            const response: any = await wiz.call('generation_artifact', parameters);
            if (response && response.code !== undefined) return response;
            return {
                code: 200,
                data: response && response.data !== undefined ? response.data : response
            };
        } catch (error) {
            const response: any = error || {};
            return {
                code: Number(response.status || 500),
                data: response.responseJSON || response.data || null
            };
        }
    }

    private async callDeleteQaItem(parameters: any) {
        try {
            const response: any = await wiz.call('delete_qa_item', parameters);
            if (response && Number(response.status) >= 400) {
                return {
                    code: Number(response.status),
                    data: response.responseJSON || response.data || null
                };
            }
            if (response && response.code !== undefined) return response;
            return {
                code: 200,
                data: response && response.data !== undefined ? response.data : response
            };
        } catch (error) {
            const response: any = error || {};
            return {
                code: Number(response.status || 500),
                data: response.responseJSON || response.data || null
            };
        }
    }

    private async callDeleteQaItems(parameters: any) {
        try {
            const response: any = await wiz.call('delete_qa_items', parameters);
            if (response && Number(response.status) >= 400) {
                return {
                    code: Number(response.status),
                    data: response.responseJSON || response.data || null
                };
            }
            if (response && response.code !== undefined) return response;
            return {
                code: 200,
                data: response && response.data !== undefined ? response.data : response
            };
        } catch (error) {
            const response: any = error || {};
            return {
                code: Number(response.status || 500),
                data: response.responseJSON || response.data || null
            };
        }
    }

    private qaSetFromArtifactResponse(payload: any) {
        let current = payload;
        for (let depth = 0; depth < 6; depth += 1) {
            if (typeof current === 'string') {
                try {
                    current = JSON.parse(current);
                    continue;
                } catch (error) {
                    return null;
                }
            }
            if (!current || typeof current !== 'object' || Array.isArray(current)) return null;
            if (Array.isArray(current.items)) return current;
            if (current.qa_set !== undefined) {
                current = current.qa_set;
                continue;
            }
            if (current.result !== undefined) {
                current = current.result;
                continue;
            }
            if (current.data !== undefined) {
                current = current.data;
                continue;
            }
            if (current.artifact && typeof current.artifact === 'object') {
                current = current.artifact;
                continue;
            }
            return null;
        }
        return null;
    }

    private kgGenerationResultFromGraph(graph: any, envelope: any = {}) {
        const metrics = (graph && graph.metrics) || {};
        const nodes = Array.isArray(graph && graph.nodes) ? graph.nodes : [];
        const edges = Array.isArray(graph && graph.edges) ? graph.edges : [];
        const sources = Array.isArray(graph && graph.source_snapshots) ? graph.source_snapshots : [];
        const graphStatus = String(envelope.graph_status || (graph && graph.status) || 'unknown');
        const normalization = graph && graph.normalization && typeof graph.normalization === 'object'
            ? graph.normalization
            : null;
        const adjudication = graph && graph.adjudication && typeof graph.adjudication === 'object'
            ? graph.adjudication
            : null;
        const metric = (key: string, fallback: number) => {
            const value = Number(metrics[key]);
            return Number.isFinite(value) ? value : fallback;
        };
        const declaredSummary = envelope.review_summary;
        const pendingIdentity = edges.filter((edge: any) => (
            edge && edge.type === 'POSSIBLY_SAME_AS' && edge.review_status === 'pending'
        )).length;
        const reviewSummary = declaredSummary && typeof declaredSummary === 'object'
            ? declaredSummary
            : {
                unresolved_entity_count: nodes.filter((node: any) => (
                    node && node.type === 'entity'
                    && node.properties && node.properties.normalization_status === 'unresolved'
                )).length,
                pending_identity_count: graphStatus === 'approved' ? 0 : pendingIdentity,
                deferred_identity_count: Number(adjudication && adjudication.identity_deferred_count) || 0,
                unassessed_claim_count: nodes.filter((node: any) => (
                    node && node.type === 'claim'
                    && node.properties && node.properties.historical_fact_status === 'unassessed'
                )).length
            };
        return {
            kind: 'kg',
            status: 'completed',
            generation_status: String(envelope.generation_status || 'completed'),
            graph_status: graphStatus,
            approval_status: envelope.approval_status === 'ai_quality_passed'
                ? 'ai_quality_passed'
                : 'not_approved',
            ai_quality_gate_status: envelope.ai_quality_gate_status === 'passed'
                ? 'passed'
                : 'pending',
            human_release_status: 'pending',
            artifact_snapshot_kind: envelope.artifact_snapshot_kind === 'immutable_ai_quality_snapshot'
                ? 'immutable_ai_quality_snapshot'
                : 'generation_output',
            normalization_status: normalization ? 'completed' : 'not_run',
            adjudication_status: adjudication ? 'completed' : 'not_run',
            review_summary: reviewSummary,
            reviewer_provenance: envelope.reviewer_provenance || null,
            message: '저장된 지식그래프 생성 산출물이 있습니다.',
            graph_id: graph && graph.graph_id,
            created_at: graph && graph.created_at,
            source_count: metric('source_count', sources.length),
            claim_count: metric('claim_count', nodes.filter((node: any) => node.type === 'claim').length),
            node_count: metric('node_count', nodes.length),
            edge_count: metric('edge_count', edges.length)
        };
    }

    private async restoreKgGenerationResult() {
        const { code, data } = await this.callGenerationArtifact({
            project_id: this.project.id,
            kind: 'kg'
        });
        if (code === 200 && data && data.graph) {
            this.kgPersistedResult = this.kgGenerationResultFromGraph(data.graph, data);
            this.outputGenerationStates.kg = this.kgPersistedResult;
        } else if (code === 404) {
            this.kgPersistedResult = null;
            this.outputGenerationStates.kg = null;
        }
        await this.service.render();
    }

    public async loadKgResult(force: boolean = false) {
        if (this.kgResultLoading) return;
        if (!force && this.kgResult) {
            await this.service.render();
            this.scheduleKgResultGraphRender();
            return;
        }
        this.kgResultLoading = true;
        this.kgResultError = '';
        if (force) {
            this.kgResult = null;
            this.kgResultArtifact = '';
            this.kgResultClusterOffsets = {};
        }
        await this.service.render();

        const { code, data } = await this.callGenerationArtifact({
            project_id: this.project.id,
            kind: 'kg'
        });
        if (code === 200 && data && data.graph) {
            this.kgResult = data.graph;
            this.kgResultArtifact = data.artifact || '';
            this.kgPersistedResult = this.kgGenerationResultFromGraph(data.graph, data);
            this.outputGenerationStates.kg = this.kgPersistedResult;
            this.kgResultSelectedNodeId = this.kgResultInitialNodeId();
            this.kgResultGraphViewMode = 'all';
            this.kgResultInspectorTab = 'details';
        } else {
            if (code === 404) {
                this.kgPersistedResult = null;
                this.outputGenerationStates.kg = null;
            }
            this.kgResultError = (data && data.message) || '지식그래프 결과를 불러오지 못했습니다.';
        }
        this.kgResultLoading = false;
        await this.service.render();
        this.scheduleKgResultGraphRender();
    }

    public kgResultMetric(key: string) {
        const metrics = (this.kgResult && this.kgResult.metrics) || {};
        return Number(metrics[key] || 0);
    }

    public kgResultNodes() {
        return this.kgResult && Array.isArray(this.kgResult.nodes) ? this.kgResult.nodes : [];
    }

    public kgResultEdges() {
        return this.kgResult && Array.isArray(this.kgResult.edges) ? this.kgResult.edges : [];
    }

    public kgResultSnapshots() {
        return this.kgResult && Array.isArray(this.kgResult.source_snapshots)
            ? this.kgResult.source_snapshots
            : [];
    }

    public kgResultWarnings() {
        const validation = (this.kgResult && this.kgResult.validation) || {};
        return Array.isArray(validation.warnings) ? validation.warnings : [];
    }

    public kgResultNodeTypeCount(type: string) {
        const nodes = this.kgResultNodes();
        return type === 'all' ? nodes.length : nodes.filter((node: any) => node.type === type).length;
    }

    public kgResultTypeLabel(type: string) {
        const option = this.kgResultNodeTypes.find((item: any) => item.key === type);
        return option ? option.label : type;
    }

    public kgResultStatusLabel() {
        const status = String(
            (this.kgPersistedResult && this.kgPersistedResult.graph_status)
            || (this.kgResult && this.kgResult.status)
            || ''
        );
        if (status === 'created') return '그래프 created · 정규화 전';
        if (status === 'refined') return '그래프 refined · 심의 전';
        if (status === 'approved') {
            return this.kgPersistedResult
                && this.kgPersistedResult.ai_quality_gate_status === 'passed'
                ? '그래프 approved · AI 품질 게이트 통과'
                : '그래프 approved · AI snapshot 아님';
        }
        return status || '상태 미확인';
    }

    public kgResultStatusIcon() {
        return this.kgPersistedResult
            && this.kgPersistedResult.ai_quality_gate_status === 'passed'
            ? 'fa-circle-check'
            : 'fa-circle-info';
    }

    public kgGenerationGraphStatusLabel(status: string) {
        if (status === 'created') return 'created (정규화 전)';
        if (status === 'refined') return 'refined (심의 전)';
        if (status === 'approved') return 'approved (AI 심의 완료)';
        return status || '미확인';
    }

    public kgResultGenerationStatusLabel() {
        const status = this.kgPersistedResult && this.kgPersistedResult.generation_status;
        return status === 'completed' ? '완료' : (status || '미확인');
    }

    public kgResultApprovalStatusLabel() {
        return this.kgPersistedResult
            && this.kgPersistedResult.ai_quality_gate_status === 'passed'
            ? 'AI 품질 게이트 통과'
            : 'AI 품질 게이트 대기';
    }

    public kgResultHumanReleaseStatusLabel() {
        return this.kgPersistedResult
            && this.kgPersistedResult.human_release_status === 'released'
            ? '사람 release 완료'
            : '사람 release 대기';
    }

    public kgResultSnapshotLabel() {
        return this.kgPersistedResult
            && this.kgPersistedResult.artifact_snapshot_kind === 'immutable_ai_quality_snapshot'
            ? 'immutable AI-quality snapshot'
            : '승인 전 생성 산출물';
    }

    public kgResultReviewMetric(key: string) {
        const summary = (this.kgPersistedResult && this.kgPersistedResult.review_summary) || {};
        const value = Number(summary[key]);
        return Number.isFinite(value) && value >= 0 ? value : 0;
    }

    public kgResultReviewerLabel() {
        const provenance = this.kgPersistedResult && this.kgPersistedResult.reviewer_provenance;
        if (!provenance) return 'Stage 4 검수 전';
        if (provenance.not_human_review === true) return 'AI 의미 품질 검수 · 사람 아님';
        return '검수 출처 미확인';
    }

    public kgResultReviewerDetail() {
        const provenance = this.kgPersistedResult && this.kgPersistedResult.reviewer_provenance;
        if (!provenance) return '검수 provenance 없음';
        return [provenance.provider, provenance.model, provenance.role, provenance.policy_version]
            .filter((value: any) => !!value)
            .join(' · ');
    }

    public kgResultValidationLabel() {
        const validation = (this.kgResult && this.kgResult.validation) || {};
        if (validation.status === 'valid') return '검증 통과';
        if (validation.status === 'valid_with_warnings') return '경고 포함 검증 통과';
        return validation.status || '검증 상태 없음';
    }

    public kgResultCreatedAt() {
        const value = this.kgResult && this.kgResult.created_at;
        if (!value) return '—';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return date.toLocaleString('ko-KR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit'
        });
    }

    public kgResultVisibleNodes() {
        const query = String(this.kgResultSearchQuery || '').trim().toLowerCase();
        return this.kgResultNodes().filter((node: any) => {
            if (this.kgResultNodeFilter !== 'all' && node.type !== this.kgResultNodeFilter) return false;
            if (!query) return true;
            const properties = node.properties && typeof node.properties === 'object'
                ? JSON.stringify(node.properties)
                : '';
            return [node.id, node.type, node.label, properties]
                .join(' ').toLowerCase().indexOf(query) > -1;
        });
    }

    public kgResultVisibleEdges() {
        const ids = new Set(this.kgResultVisibleNodes().map((node: any) => node.id));
        return this.kgResultEdges().filter((edge: any) => ids.has(edge.source) && ids.has(edge.target));
    }

    public async setKgResultNodeFilter(type: string) {
        this.kgResultNodeFilter = type;
        const visible = this.kgResultVisibleNodes();
        if (!visible.some((node: any) => node.id === this.kgResultSelectedNodeId)) {
            this.kgResultSelectedNodeId = visible.length ? visible[0].id : '';
        }
        await this.service.render();
        this.scheduleKgResultGraphRender();
    }

    public async onKgResultSearchChanged() {
        const visible = this.kgResultVisibleNodes();
        if (!visible.some((node: any) => node.id === this.kgResultSelectedNodeId)) {
            this.kgResultSelectedNodeId = visible.length ? visible[0].id : '';
        }
        await this.service.render();
        this.scheduleKgResultGraphRender();
    }

    public async resetKgResultGraph() {
        this.kgResultNodeFilter = 'all';
        this.kgResultSearchQuery = '';
        this.kgResultGraphViewMode = 'all';
        this.kgResultClusterOffsets = {};
        this.kgResultClusterDragOrigin = null;
        const visible = this.kgResultVisibleNodes();
        this.kgResultSelectedNodeId = visible.length ? visible[0].id : '';
        await this.service.render();
        this.scheduleKgResultGraphRender();
    }

    public async setKgResultLowerTab(tab: 'sources' | 'warnings') {
        this.kgResultLowerTab = tab;
        await this.service.render();
    }

    public async openKgResultSourceModal(snapshot: any) {
        if (!snapshot) return;
        this.kgResultSourceModalSnapshot = snapshot;
        this.kgResultSourceModalOpen = true;
        await this.service.render();
    }

    public async closeKgResultSourceModal() {
        this.kgResultSourceModalOpen = false;
        this.kgResultSourceModalSnapshot = null;
        await this.service.render();
    }

    public kgResultSourceFormat(snapshot: any) {
        return snapshot && snapshot.original_kind
            ? String(snapshot.original_kind).toUpperCase()
            : '사료(원문)';
    }

    public kgResultSourceStatusLabel(snapshot: any) {
        const status = snapshot && snapshot.document_status;
        if (status === 'published') return '게시됨';
        if (status === 'draft') return '작성 중';
        return status || '상태 미확인';
    }

    public kgResultSourceProviderLabel(snapshot: any) {
        const provider = snapshot && snapshot.provider;
        if (provider === 'material-vault') return '자료함 API';
        return provider || '제공 경로 미확인';
    }

    public kgResultSourceEvidenceEntries() {
        const snapshot = this.kgResultSourceModalSnapshot;
        if (!snapshot) return [];
        return this.kgResultNodes()
            .filter((node: any) => {
                if (node.type !== 'evidence') return false;
                const properties = node.properties && typeof node.properties === 'object' ? node.properties : {};
                return properties.source_id === snapshot.source_id
                    || (properties.document_id === snapshot.document_id && properties.chunk_id === snapshot.chunk_id);
            })
            .map((node: any) => {
                const properties = node.properties && typeof node.properties === 'object' ? node.properties : {};
                const span = properties.span && typeof properties.span === 'object' ? properties.span : {};
                return {
                    label: node.label || '원문 근거',
                    quote: span.quote || '',
                    pageLabel: properties.page_number ? `${properties.page_number}쪽` : '페이지 미확인',
                    chunkLabel: properties.chunk_ordinal === 0 || properties.chunk_ordinal
                        ? `Chunk #${properties.chunk_ordinal}`
                        : 'Chunk 미확인'
                };
            });
    }

    public async focusKgResultSourceFromModal() {
        const sourceId = this.kgResultSourceModalSnapshot && this.kgResultSourceModalSnapshot.source_id;
        this.kgResultSourceModalOpen = false;
        this.kgResultSourceModalSnapshot = null;
        await this.service.render();
        if (sourceId) await this.selectKgResultNode(sourceId);
    }

    public kgResultNodeTypePercent(type: string) {
        const total = Math.max(1, this.kgResultNodes().length);
        return Math.round(this.kgResultNodeTypeCount(type) / total * 100);
    }

    public kgResultEdgeTypeSummary() {
        const counts: any = {};
        this.kgResultEdges().forEach((edge: any) => {
            const label = String(edge.label || edge.type || '기타');
            counts[label] = Number(counts[label] || 0) + 1;
        });
        return Object.keys(counts)
            .map((label: string) => ({ label, count: counts[label] }))
            .sort((left: any, right: any) => right.count - left.count)
            .slice(0, 7);
    }

    public kgResultEdgeTypePercent(count: number) {
        return Math.round(Number(count || 0) / Math.max(1, this.kgResultEdges().length) * 100);
    }

    public kgResultSelectedConfidencePercent() {
        const node = this.kgResultSelectedNode();
        const properties = node && node.properties && typeof node.properties === 'object' ? node.properties : {};
        const value = Number(properties.confidence || properties.score || properties.confidence_score || 0);
        if (!Number.isFinite(value) || value <= 0) return 0;
        return Math.round(Math.min(1, value > 1 ? value / 100 : value) * 100);
    }

    public kgResultCompletenessPercent() {
        const nodes = this.kgResultNodes();
        if (!nodes.length) return 0;
        const connected = new Set<string>();
        this.kgResultEdges().forEach((edge: any) => {
            connected.add(edge.source);
            connected.add(edge.target);
        });
        return Math.round(nodes.filter((node: any) => connected.has(node.id)).length / nodes.length * 1000) / 10;
    }

    public kgResultSnapshotContribution(snapshot: any) {
        const sourceNode = this.kgResultNodes().find((node: any) => (
            node.type === 'source' && (
                node.id === snapshot.source_id
                || (node.properties && node.properties.document_id === snapshot.document_id)
            )
        ));
        if (!sourceNode) return 0;
        const connected = new Set<string>();
        this.kgResultEdges().forEach((edge: any) => {
            if (edge.source === sourceNode.id) connected.add(edge.target);
            if (edge.target === sourceNode.id) connected.add(edge.source);
        });
        return connected.size;
    }

    public kgResultNodeById(id: string) {
        return this.kgResultNodes().find((node: any) => node.id === id) || {};
    }

    public kgResultSelectedNode() {
        return this.kgResultNodeById(this.kgResultSelectedNodeId);
    }

    public kgResultSelectedConnections() {
        const selected = this.kgResultSelectedNode();
        if (!selected.id) return [];
        return this.kgResultEdges()
            .filter((edge: any) => edge.source === selected.id || edge.target === selected.id)
            .map((edge: any) => {
                const outgoing = edge.source === selected.id;
                const otherId = outgoing ? edge.target : edge.source;
                return {
                    ...edge,
                    direction: outgoing ? 'outgoing' : 'incoming',
                    other: this.kgResultNodeById(otherId)
                };
            });
    }

    public kgResultSelectedSourceSnapshot() {
        const node = this.kgResultSelectedNode();
        if (!node.id || node.type !== 'source') return null;
        const properties = node.properties && typeof node.properties === 'object' ? node.properties : {};
        return this.kgResultSnapshots().find((snapshot: any) => (
            snapshot.source_id === node.id
            || (properties.document_id && snapshot.document_id === properties.document_id)
        )) || properties;
    }

    public kgResultSelectedSourceCoverUrl() {
        const snapshot = this.kgResultSelectedSourceSnapshot() || {};
        const node = this.kgResultSelectedNode();
        const properties = node.properties && typeof node.properties === 'object' ? node.properties : {};
        return snapshot.cover_url || snapshot.thumbnail_url || properties.cover_url || properties.thumbnail_url || '';
    }

    public kgResultSelectedSourceTitle() {
        const snapshot = this.kgResultSelectedSourceSnapshot() || {};
        const node = this.kgResultSelectedNode();
        return snapshot.document_title || (node.properties && node.properties.title) || node.label || '제목 미확인 사료';
    }

    public kgResultSelectedSourceStatusLabel() {
        const snapshot = this.kgResultSelectedSourceSnapshot() || {};
        if (snapshot.document_status === 'published') return '게시됨';
        if (snapshot.document_status === 'draft') return '작성 중';
        return snapshot.document_status || '상태 미확인';
    }

    public kgResultSelectedSourceClaimCount() {
        const node = this.kgResultSelectedNode();
        if (!node.id || node.type !== 'source') return 0;
        const claimIds = new Set(
            this.kgResultEdges()
                .filter((edge: any) => edge.source === node.id && edge.type === 'ASSERTS')
                .map((edge: any) => edge.target)
        );
        return claimIds.size;
    }

    public kgResultSelectedSourceMetaEntries() {
        const snapshot = this.kgResultSelectedSourceSnapshot();
        if (!snapshot) return [];
        return [
            { label: '자료 ID', value: snapshot.document_id || '—' },
            { label: '버전', value: snapshot.document_version ? `v${snapshot.document_version}` : '—' },
            { label: '원문 형식', value: snapshot.original_kind ? String(snapshot.original_kind).toUpperCase() : '—' },
            { label: '대표 페이지', value: snapshot.page_number ? `${snapshot.page_number}쪽` : '—' },
            { label: '대표 Chunk', value: snapshot.chunk_ordinal === 0 || snapshot.chunk_ordinal ? `#${snapshot.chunk_ordinal}` : '—' },
            { label: '자료 제공', value: snapshot.provider === 'material-vault' ? '자료함 API' : (snapshot.provider || '—') }
        ];
    }

    public kgResultPropertyEntries() {
        const node = this.kgResultSelectedNode();
        const properties = node.properties && typeof node.properties === 'object' ? node.properties : {};
        return Object.keys(properties)
            .filter((key: string) => key !== 'span' && key !== 'page_span')
            .map((key: string) => ({ key, value: this.kgResultPropertyValue(properties[key]) }));
    }

    private kgResultPropertyValue(value: any) {
        if (value === null || value === undefined || value === '') return '—';
        if (Array.isArray(value)) return value.length ? value.join(', ') : '—';
        if (typeof value === 'object') return JSON.stringify(value);
        if (typeof value === 'boolean') return value ? '예' : '아니요';
        return String(value);
    }

    public kgResultEvidenceQuote() {
        const selected = this.kgResultSelectedNode();
        let evidence = selected.type === 'evidence' ? selected : null;
        if (!evidence && selected.id) {
            const edge = this.kgResultEdges().find((item: any) => (
                item.source === selected.id && item.type === 'SUPPORTED_BY'
            ));
            if (edge) evidence = this.kgResultNodeById(edge.target);
        }
        const span = evidence && evidence.properties && evidence.properties.span;
        return span && span.quote ? span.quote : '';
    }

    public kgResultEvidenceMeta() {
        const selected = this.kgResultSelectedNode();
        let evidence = selected.type === 'evidence' ? selected : null;
        if (!evidence && selected.id) {
            const edge = this.kgResultEdges().find((item: any) => (
                item.source === selected.id && item.type === 'SUPPORTED_BY'
            ));
            if (edge) evidence = this.kgResultNodeById(edge.target);
        }
        if (!evidence || !evidence.properties) return '';
        const properties = evidence.properties;
        return `${properties.document_id || '문서'} · ${properties.page_number || '—'}쪽 · chunk ${properties.chunk_ordinal ?? '—'}`;
    }

    public async selectKgResultNode(id: string) {
        if (!id) return;
        this.kgResultSelectedNodeId = id;
        this.kgResultGraphViewMode = 'selection';
        await this.service.render();
        this.updateKgResultGraphSelection();
        this.focusKgResultGraphNode(id);
    }

    public async clearKgResultGraphSelection() {
        this.kgResultSelectedNodeId = '';
        this.kgResultGraphViewMode = 'all';
        await this.service.render();
        this.updateKgResultGraphSelection();
        this.resetKgResultGraphViewport();
    }

    public showKgResultFullGraph() {
        this.kgResultGraphViewMode = 'all';
        this.updateKgResultGraphSelection();
        this.resetKgResultGraphViewport();
    }

    public focusKgResultSelection() {
        if (!this.kgResultSelectedNodeId) return;
        this.kgResultGraphViewMode = 'selection';
        this.updateKgResultGraphSelection();
        this.focusKgResultGraphNode(this.kgResultSelectedNodeId);
    }

    public async setKgResultInspectorTab(tab: 'details' | 'connections' | 'evidence') {
        this.kgResultInspectorTab = tab;
        await this.service.render();
    }

    private kgResultInitialNodeId() {
        const claim = this.kgResultNodes().find((node: any) => node.type === 'claim');
        const first = claim || this.kgResultNodes()[0];
        return first ? first.id : '';
    }

    private kgResultGraphLabel(node: any) {
        const label = String(node.label || node.id || '');
        if (node.type === 'claim' && label.length > 38) return label.slice(0, 38) + '…';
        if (label.length > 28) return label.slice(0, 28) + '…';
        return label;
    }

    private scheduleKgResultGraphRender() {
        this.destroyKgResultGraph();
        if (this.tab !== 'kg-result' || !this.kgResult) return;
        this.kgResultGraphRenderTimer = setTimeout(() => {
            this.kgResultGraphRenderTimer = null;
            this.renderKgResultGraph();
        }, 80);
    }

    private kgResultPresetPositions(nodes: any[], edges: any[]) {
        const positions: Record<string, { x: number; y: number }> = {};
        const degree: Record<string, number> = {};
        edges.forEach((edge: any) => {
            degree[edge.source] = (degree[edge.source] || 0) + 1;
            degree[edge.target] = (degree[edge.target] || 0) + 1;
        });

        const clusters: Record<string, { x: number; y: number; columns: number; gapX: number; gapY: number }> = {
            source: { x: 220, y: 245, columns: 3, gapX: 136, gapY: 82 },
            entity: { x: 220, y: 670, columns: 3, gapX: 128, gapY: 84 },
            claim: { x: 680, y: 430, columns: 5, gapX: 174, gapY: 96 },
            concept: { x: 1135, y: 210, columns: 3, gapX: 126, gapY: 82 },
            event: { x: 1135, y: 485, columns: 3, gapX: 126, gapY: 84 },
            time: { x: 1135, y: 720, columns: 3, gapX: 118, gapY: 80 },
            evidence: { x: 680, y: 900, columns: 5, gapX: 150, gapY: 78 }
        };

        const positionGroup = (type: string, group: any[]) => {
            const config = clusters[type] || { x: 680, y: 1120, columns: 5, gapX: 140, gapY: 78 };
            const offset = this.kgResultClusterOffsets[type] || { x: 0, y: 0 };
            const sorted = [...group].sort((left: any, right: any) => {
                if (left.id === this.kgResultSelectedNodeId) return -1;
                if (right.id === this.kgResultSelectedNodeId) return 1;
                return (degree[right.id] || 0) - (degree[left.id] || 0) || String(left.label || '').localeCompare(String(right.label || ''));
            });
            const rows = Math.max(1, Math.ceil(sorted.length / config.columns));
            const rowCounts = Array.from({ length: rows }, (_value: unknown, row: number) => (
                Math.min(config.columns, sorted.length - row * config.columns)
            ));
            sorted.forEach((node: any, index: number) => {
                const row = Math.floor(index / config.columns);
                const column = index % config.columns;
                const count = rowCounts[row];
                positions[node.id] = {
                    x: config.x + (column - (count - 1) / 2) * config.gapX + offset.x,
                    y: config.y + (row - (rows - 1) / 2) * config.gapY + offset.y
                };
            });
        };

        Object.keys(clusters).forEach((type: string) => {
            positionGroup(type, nodes.filter((node: any) => node.type === type));
        });
        const knownTypes = new Set(Object.keys(clusters));
        positionGroup('other', nodes.filter((node: any) => !knownTypes.has(node.type)));
        return positions;
    }

    private renderKgResultGraph() {
        if (typeof document === 'undefined') return;
        const container = document.getElementById('generated-knowledge-graph-canvas');
        const nodes = this.kgResultVisibleNodes();
        const edges = this.kgResultVisibleEdges();
        if (!container || !nodes.length) return;
        const positions = this.kgResultPresetPositions(nodes, edges);
        const clusterLabels: Record<string, string> = {
            source: '원문 사료',
            claim: '핵심 주장',
            concept: '개념',
            entity: '인물 · 기관',
            event: '사건',
            time: '시간',
            evidence: '근거'
        };
        const nodeTypes = Array.from(new Set(nodes.map((node: any) => node.type)));

        const elements = [
            ...nodeTypes.map((type: string) => ({
                data: {
                    id: `kg-result-cluster-${type}`,
                    label: clusterLabels[type] || '기타',
                    type
                },
                classes: `kg-result-cluster kg-result-cluster--${type}`
            })),
            ...nodes.map((node: any) => ({
                data: {
                    id: node.id,
                    label: this.kgResultGraphLabel(node),
                    type: node.type,
                    parent: `kg-result-cluster-${node.type}`
                },
                position: positions[node.id],
                classes: `kg-result-node kg-result-node--${node.type}`
            })),
            ...edges.map((edge: any) => ({
                data: {
                    id: edge.id,
                    source: edge.source,
                    target: edge.target,
                    label: edge.label || edge.type,
                    type: edge.type
                },
                classes: 'kg-result-edge'
            }))
        ];

        this.kgResultGraphInstance = cytoscapeFactory({
            container,
            elements: elements as any,
            layout: { name: 'preset', fit: true, padding: 64, animate: false },
            minZoom: 0.28,
            maxZoom: 2.4,
            wheelSensitivity: 0.18,
            boxSelectionEnabled: false,
            selectionType: 'single',
            autoungrabify: false,
            style: [
                {
                    selector: 'node',
                    style: {
                        'label': 'data(label)', 'text-wrap': 'ellipsis', 'text-max-width': '138px',
                        'text-valign': 'center', 'text-halign': 'center',
                        'font-family': 'Pretendard, Inter, system-ui, sans-serif',
                        'font-size': '10px', 'font-weight': 760, 'color': '#26332f',
                        'text-outline-width': 0,
                        'border-width': 1, 'border-color': '#d8e0dc',
                        'shadow-blur': 10, 'shadow-color': '#1f2f29', 'shadow-opacity': 0.08,
                        'shadow-offset-x': 0, 'shadow-offset-y': 3,
                        'overlay-opacity': 0, 'transition-property': 'opacity, border-width, border-color',
                        'transition-duration': '160ms'
                    }
                },
                {
                    selector: 'node.kg-result-cluster',
                    style: {
                        'shape': 'round-rectangle', 'label': 'data(label)',
                        'text-valign': 'top', 'text-halign': 'center', 'text-margin-y': -13,
                        'font-family': 'Pretendard, Inter, system-ui, sans-serif',
                        'font-size': '12px', 'font-weight': 850, 'color': '#52605a',
                        'background-color': '#f7faf8', 'background-opacity': 0.72,
                        'border-width': 1, 'border-color': '#dce4e0', 'border-style': 'solid',
                        'padding': '30px', 'z-compound-depth': 'bottom',
                        'events': 'yes', 'overlay-opacity': 0, 'shadow-opacity': 0,
                        'transition-property': 'border-width, border-color, background-opacity',
                        'transition-duration': '140ms'
                    }
                },
                { selector: 'node.kg-result-cluster--source', style: { 'background-color': '#f3f8fc', 'border-color': '#cdddea', 'color': '#52748b' } },
                { selector: 'node.kg-result-cluster--claim', style: { 'background-color': '#f5f9f6', 'border-color': '#cbdccb', 'color': '#35634a' } },
                { selector: 'node.kg-result-cluster--entity', style: { 'background-color': '#f7f4fa', 'border-color': '#ddd3e9', 'color': '#725d88' } },
                { selector: 'node.kg-result-cluster--event', style: { 'background-color': '#fcf7f1', 'border-color': '#eadac9', 'color': '#8a603a' } },
                { selector: 'node.kg-result-cluster--time', style: { 'background-color': '#f2f8f7', 'border-color': '#cfe1dd', 'color': '#46746d' } },
                { selector: 'node.kg-result-cluster--concept', style: { 'background-color': '#f5f8f1', 'border-color': '#d7e2ca', 'color': '#607b49' } },
                { selector: 'node.kg-result-cluster--evidence', style: { 'background-color': '#fafbf7', 'border-color': '#dce4d3', 'color': '#647858' } },
                {
                    selector: 'node.kg-result-cluster.is-dragging',
                    style: {
                        'border-width': 2, 'border-style': 'dashed',
                        'border-color': '#547664', 'background-opacity': 0.9,
                        'color': '#355646', 'z-index': 30
                    }
                },
                { selector: 'node.kg-result-node--source', style: { 'shape': 'round-rectangle', 'width': 112, 'height': 46, 'background-color': '#edf5fb', 'border-color': '#9bbbd3', 'color': '#355d78' } },
                { selector: 'node.kg-result-node--claim', style: { 'shape': 'round-rectangle', 'width': 156, 'height': 56, 'background-color': '#f3f8f4', 'border-width': 1.5, 'border-color': '#6b9b72', 'color': '#245e42', 'font-size': '10px', 'text-wrap': 'wrap', 'text-max-width': '132px' } },
                { selector: 'node.kg-result-node--entity', style: { 'shape': 'ellipse', 'width': 88, 'height': 58, 'background-color': '#f3eff8', 'border-color': '#b5a4cf', 'color': '#614d7a' } },
                { selector: 'node.kg-result-node--event', style: { 'shape': 'round-diamond', 'width': 84, 'height': 70, 'background-color': '#fbf2ea', 'border-color': '#d3aa85', 'color': '#805635', 'text-max-width': '66px' } },
                { selector: 'node.kg-result-node--time', style: { 'shape': 'round-hexagon', 'width': 88, 'height': 58, 'background-color': '#edf6f4', 'border-color': '#8db7b0', 'color': '#356c63', 'text-max-width': '66px' } },
                { selector: 'node.kg-result-node--concept', style: { 'shape': 'round-tag', 'width': 100, 'height': 50, 'background-color': '#f2f6ed', 'border-color': '#a9c294', 'color': '#4e6f38', 'text-max-width': '78px' } },
                { selector: 'node.kg-result-node--evidence', style: { 'shape': 'cut-rectangle', 'width': 124, 'height': 44, 'background-color': '#fbfcf9', 'border-color': '#9ab88e', 'border-style': 'dashed', 'color': '#527048' } },
                {
                    selector: 'edge',
                    style: {
                        'curve-style': 'bezier', 'control-point-step-size': 44,
                        'width': 1, 'line-color': '#bdc8c2',
                        'target-arrow-color': '#a9b3ae', 'target-arrow-shape': 'triangle',
                        'arrow-scale': 0.65, 'label': '', 'font-size': '9px',
                        'font-weight': 700, 'color': '#65756f', 'text-background-color': '#f8fbfa',
                        'text-background-opacity': 0.92, 'text-background-padding': '3px',
                        'text-rotation': 'autorotate', 'opacity': 0.22, 'overlay-opacity': 0
                    }
                },
                {
                    selector: 'node.kg-result-node.is-dimmed',
                    style: {
                        'background-color': '#ecefed', 'border-color': '#c7ccc8',
                        'color': '#777f7a', 'opacity': 0.78, 'text-opacity': 0.72,
                        'shadow-opacity': 0
                    }
                },
                {
                    selector: 'node.kg-result-cluster.is-dimmed',
                    style: {
                        'background-color': '#f1f3f1', 'border-color': '#d4d8d5',
                        'color': '#858d88', 'opacity': 0.8, 'text-opacity': 0.72
                    }
                },
                {
                    selector: 'edge.is-dimmed',
                    style: {
                        'line-color': '#cdd2ce', 'target-arrow-color': '#cdd2ce',
                        'opacity': 0.16, 'label': ''
                    }
                },
                {
                    selector: 'node.is-neighbour',
                    style: { 'opacity': 1, 'text-opacity': 1, 'shadow-opacity': 0.1 }
                },
                {
                    selector: 'node.is-selected',
                    style: {
                        'border-width': 3.5, 'border-color': '#2f6d54',
                        'z-index': 20, 'shadow-color': '#2f6d54',
                        'shadow-blur': 16, 'shadow-opacity': 0.22
                    }
                },
                {
                    selector: 'edge.is-related',
                    style: {
                        'width': 2.4, 'line-color': '#4d8065',
                        'target-arrow-color': '#4d8065', 'label': 'data(label)',
                        'color': '#365b49', 'text-background-color': '#f5f9f7',
                        'text-background-opacity': 0.96, 'opacity': 1, 'z-index': 10
                    }
                }
            ] as any
        });

        this.kgResultGraphInstance.nodes('.kg-result-node').ungrabify();
        this.kgResultGraphInstance.nodes('.kg-result-cluster').grabify();

        this.kgResultGraphInstance.on('mouseover', 'node.kg-result-cluster', () => {
            container.style.cursor = 'grab';
        });
        this.kgResultGraphInstance.on('mouseout', 'node.kg-result-cluster', () => {
            container.style.cursor = '';
        });
        this.kgResultGraphInstance.on('grab', 'node.kg-result-cluster', (event: any) => {
            const cluster = event.target;
            const type = String(cluster.data('type') || 'other');
            const position = cluster.position();
            const offset = this.kgResultClusterOffsets[type] || { x: 0, y: 0 };
            this.kgResultClusterDragOrigin = {
                type,
                x: position.x,
                y: position.y,
                offsetX: offset.x,
                offsetY: offset.y
            };
            cluster.addClass('is-dragging');
            container.style.cursor = 'grabbing';
        });
        this.kgResultGraphInstance.on('free', 'node.kg-result-cluster', (event: any) => {
            const cluster = event.target;
            const origin = this.kgResultClusterDragOrigin;
            const type = String(cluster.data('type') || 'other');
            if (origin && origin.type === type) {
                const position = cluster.position();
                this.kgResultClusterOffsets[type] = {
                    x: origin.offsetX + position.x - origin.x,
                    y: origin.offsetY + position.y - origin.y
                };
            }
            cluster.removeClass('is-dragging');
            this.kgResultClusterDragOrigin = null;
            container.style.cursor = 'grab';
        });
        this.kgResultGraphInstance.on('tap', 'node.kg-result-node', async (event: any) => {
            await this.selectKgResultNode(event.target.id());
        });
        this.kgResultGraphInstance.on('tap', 'node.kg-result-cluster', async () => {
            await this.clearKgResultGraphSelection();
        });
        this.kgResultGraphInstance.on('tap', async (event: any) => {
            if (event.target !== this.kgResultGraphInstance) return;
            await this.clearKgResultGraphSelection();
        });
        this.updateKgResultGraphSelection();
        const graph = this.kgResultGraphInstance;
        setTimeout(() => {
            if (!graph || this.kgResultGraphInstance !== graph) return;
            graph.resize();
            graph.fit(graph.elements(), 54);
        }, 0);
    }

    private updateKgResultGraphSelection() {
        if (!this.kgResultGraphInstance) return;
        const graph = this.kgResultGraphInstance;
        graph.elements().removeClass('is-dimmed is-selected is-related is-neighbour');
        if (!this.kgResultSelectedNodeId) return;
        const selected = graph.getElementById(this.kgResultSelectedNodeId);
        if (!selected.length) return;
        selected.removeClass('is-dimmed').addClass('is-selected');
        selected.connectedEdges().removeClass('is-dimmed').addClass('is-related');
        if (this.kgResultGraphViewMode !== 'selection') return;
        graph.nodes().addClass('is-dimmed');
        graph.edges().addClass('is-dimmed');
        selected.removeClass('is-dimmed');
        selected.neighborhood('node.kg-result-node').removeClass('is-dimmed').addClass('is-neighbour');
        selected.connectedEdges().removeClass('is-dimmed').addClass('is-related');
    }

    private focusKgResultGraphNode(id: string) {
        if (!this.kgResultGraphInstance || !id) return;
        const graph = this.kgResultGraphInstance;
        const selected = graph.getElementById(id);
        if (!selected.length) return;
        const focusElements = selected.closedNeighborhood();
        graph.stop(true);
        graph.animate(
            { fit: { eles: focusElements, padding: 92 } } as any,
            { duration: 520, easing: 'ease-in-out-cubic' } as any
        );
    }

    private resetKgResultGraphViewport() {
        if (!this.kgResultGraphInstance) return;
        const graph = this.kgResultGraphInstance;
        graph.stop(true);
        graph.animate(
            { fit: { eles: graph.elements(), padding: 42 } } as any,
            { duration: 460, easing: 'ease-in-out-cubic' } as any
        );
    }

    public fitKgResultGraph() {
        this.resetKgResultGraphViewport();
    }

    public zoomKgResultGraph(delta: number) {
        if (!this.kgResultGraphInstance) return;
        const graph = this.kgResultGraphInstance;
        const container = graph.container();
        const current = graph.zoom();
        graph.zoom({
            level: Math.max(0.35, Math.min(2.4, current + delta)),
            renderedPosition: {
                x: container ? container.clientWidth / 2 : 0,
                y: container ? container.clientHeight / 2 : 0
            }
        });
    }

    private destroyKgResultGraph() {
        if (this.kgResultGraphRenderTimer) {
            clearTimeout(this.kgResultGraphRenderTimer);
            this.kgResultGraphRenderTimer = null;
        }
        if (this.kgResultGraphInstance) {
            this.kgResultGraphInstance.destroy();
            this.kgResultGraphInstance = null;
        }
        this.kgResultClusterDragOrigin = null;
    }

    private applySettingsToProject() {
        const kinds = this.selectedProjectSettingKinds();
        if (!kinds.length) return;
        const first = this.projectSettings[kinds[0].key];
        this.source.provider = first.source;
        this.source.status = '설정 완료';
        this.source.title = this.projectSourceSelectionLabel(first);
        this.gate.target = first.target;
        this.gate.status = '설정 완료';
        this.project.harness = kinds.map((kind: any) => this.projectSettings[kind.key].harness).join(' · ');
        this.project.survey = kinds.map((kind: any) => this.projectSettings[kind.key].survey).join(' · ');
    }

    private projectSettingsPatch() {
        const kinds = this.selectedProjectSettingKinds();
        const first = kinds.length ? this.projectSettings[kinds[0].key] : null;
        const sourceReady = !!first && this.projectSourceSelectionComplete(first);
        return {
            configured: this.project.configured,
            settings: this.cloneValue(this.projectSettings),
            lifecycle: this.project.configured ? '설정 완료' : '설정 전',
            stage: '프로젝트 설정',
            stageState: this.project.configured ? '운영 설정 완료' : '세부 설정 필요',
            sourceState: sourceReady ? '설정 완료' : '설정 필요',
            sourceLabel: first && first.source ? this.projectSourceSelectionLabel(first) : '미설정',
            target: first ? first.target : null,
            harness: kinds.map((kind: any) => this.projectSettings[kind.key].harness || '미설정').join(' · '),
            survey: kinds.map((kind: any) => this.projectSettings[kind.key].survey || '미설정').join(' · '),
            nextAction: this.project.configured ? '데이터셋 만들기' : '프로젝트 설정 계속',
            updatedRelative: '방금 전'
        };
    }

    private async persistProjectSettings() {
        if (this.workspaceStateLoaded) {
            try {
                const result = await this.mutateWorkspace({
                    resource: 'projects',
                    action: 'update',
                    id: this.project.id,
                    patch: this.projectSettingsPatch()
                });
                this.workspaceState = result.state;
                return true;
            } catch (error) {
                try {
                    this.workspaceState = await this.fetchWorkspaceState();
                    this.loadProject(this.project.id);
                    this.loadProjectSettingOptions();
                } catch (reloadError) {
                    // Keep the current screen usable while surfacing the persistence failure.
                }
                await this.service.modal.warning(
                    error instanceof Error ? error.message : '프로젝트 설정을 서버에 저장하지 못했습니다.',
                    false,
                    '확인'
                );
                await this.service.render();
                return false;
            }
        }
        if (typeof window === 'undefined') return false;
        if (this.project.isContainer) {
            const rows = this.readStoredContainers();
            const patch = this.projectSettingsPatch();
            const updated = rows.map((container: any) => {
                if (container.id !== this.project.id) return container;
                return {
                    ...container,
                    ...patch
                };
            });
            window.localStorage.setItem(this.containerStorageKey, JSON.stringify(updated));
            return true;
        }

        const stored = this.readStoredSettings();
        stored[this.project.id] = this.cloneValue(this.projectSettings);
        window.localStorage.setItem(this.settingsStorageKey, JSON.stringify(stored));
        return true;
    }

    private loadTestProject() {
        this.project = {
            id: 'RV-2026-015',
            name: 'Test',
            domain: '자료함 연동',
            status: '원문 확보 대기',
            owner: '김보미',
            created: '2026.08.04',
            currentRound: 1,
            sourceVersion: '문서 v1',
            harness: '자료함 QA·KG 하네스',
            harnessVersion: 'v1.0',
            survey: '동북아 역사 QA·지식그래프 대표 표본 검수서',
            surveyVersion: 'v1.0',
            requestedOutputs: { qa: false, kg: true },
            qaCount: 0,
            kgCount: 0,
            nodeCount: 0,
            edgeCount: 0,
            llmScore: null,
            humanScore: null,
            llmModel: '원문 확보 후 설정',
            llmRun: '실행 불가',
            sampleSet: '미생성',
            sampleSeed: '미생성',
            surveyResponses: '0 / 0'
        };
        this.source = {
            provider: '자료함 API',
            status: 'Chunk 본문 미확보',
            title: '청계중일한관계사료',
            documentId: 'trn_nahf_cj',
            version: 'v1',
            format: 'XML',
            page: '10쪽',
            chunk: 'chunk 189',
            chunkCount: 1,
            snapshot: 'SRC-015-R01',
            fixedAt: '2026.08.04 01:52'
        };
        this.gate = {
            target: 90,
            requiredResponse: 100,
            status: '생성 전',
            current: null
        };
        this.stages = [
            {
                no: 1, code: 'SOURCE', name: '자료 API 스냅샷', short: '자료 스냅샷', status: '부분 완료',
                eyebrow: '원문 필요', description: '문서 버전과 chunk ID·hash·페이지는 고정했지만 실제 Chunk 본문은 확보하지 못했습니다.',
                actor: '시스템', input: '자료함 API 조회 기록', output: '문서 v1 · chunk 메타데이터 1건 · 본문 없음', progress: 50, action: '입력 상태 보기'
            },
            {
                no: 2, code: 'GENERATE', name: 'QA·KG 생성', short: 'QA·KG 생성', status: '원문 대기',
                eyebrow: '생성 보류', description: '원문이 없으므로 Claim·Entity·Event를 만들지 않고 생성 요청을 대기시켰습니다.',
                actor: '생성 하네스', input: 'SRC-015-R01 · Chunk 본문 필요', output: 'QA 0건 · KG 0건', progress: 0, action: '생성 요건 보기'
            },
            {
                no: 3, code: 'LLM REVIEW', name: 'LLM 전체 검수', short: 'LLM 전체 검수', status: '대기',
                eyebrow: '생성 후 실행', description: '검수할 QA·KG 산출물이 없어 원문 확보와 생성 완료를 기다립니다.',
                actor: 'LLM 검수기', input: 'QA·KG 산출물', output: '검수 대상 없음', progress: 0, action: '대기 사유 보기'
            },
            {
                no: 4, code: 'SAMPLE', name: '대표 표본 선정', short: '대표 표본', status: '대기',
                eyebrow: 'AI 선별', description: '오류 위험도, 유형 대표성, 근거 다양도를 기준으로 사람에게 보여줄 표본을 정합니다.',
                actor: '샘플러', input: 'LLM 검수 결과', output: '대표 표본 후보 0건', progress: 0, action: '선정 기준 확인'
            },
            {
                no: 5, code: 'HUMAN', name: '사람 설문 평가', short: '사람 설문', status: '대기',
                eyebrow: 'Human review', description: '대표 표본을 고정된 설문 양식으로 평가하고 점수와 서술 피드백을 남깁니다.',
                actor: '검수자', input: '표본 · 설문지 v1.0', output: '응답 0건 · 사람 점수 미산정', progress: 0, action: '설문 미리보기'
            },
            {
                no: 6, code: 'DECISION', name: '목표 점수 판정', short: '통과 판정', status: '대기',
                eyebrow: '사람 검수 판정', description: '대표 표본의 사람 검수가 완료되면 사람 검수 점수가 목표를 넘는지 판정합니다.',
                actor: '검수 결과 판정', input: '사람 검수 점수 · 응답 완료', output: '목표 90점 이상', progress: 0, action: '판정 기준 보기'
            },
            {
                no: 7, code: 'REVISE', name: '하네스 개선·다음 회차', short: '개선·재생성', status: '조건부',
                eyebrow: '미달 시 반복', description: '설문 피드백을 개선 항목으로 묶어 하네스 새 버전을 만들고 2단계부터 반복합니다.',
                actor: '하네스 담당자', input: '점수 · 문항별 피드백 · LLM 이슈', output: '통과 시 종료 / 미달 시 v1.1 생성', progress: 0, action: '개선 규칙 보기'
            }
        ];
        this.llmChecks = [
            { name: '근거 추적성', description: '모든 주장이 고정된 source, chunk, page와 정확한 원문 Span으로 역추적되는지 확인', status: '대기', count: '—' },
            { name: '관계 타당성', description: 'ASSERTS, SUPPORTED_BY, REFERS_TO, EXTRACTED_FROM 관계의 방향과 의미 확인', status: '대기', count: '—' },
            { name: '개체 식별', description: '미해결 개체 후보의 유형·별칭·동일 개체 연결 여부 확인', status: '대기', count: '—' },
            { name: 'Blocker', description: '사람 검수 전 반드시 해결해야 하는 치명 이슈', status: '대기', count: '—' }
        ];
        this.samples = [];
        this.surveyDimensions = [
            { key: 'representativeness', label: '표본 대표성', question: '선정된 표본이 현재 QA 셋과 지식그래프의 주요 문서·시대·유형을 대표합니까?' },
            { key: 'historicalAccuracy', label: '역사적 정확성', question: '인물·사건·지명·연도와 관계 방향이 역사적으로 정확합니까?' },
            { key: 'evidence', label: '사료 근거 일치성', question: '질문·답변 또는 관계가 제시된 사료 원문에서 확인됩니까?' },
            { key: 'context', label: '시대·맥락 충분성', question: '사료의 작성 시점, 주체와 역사적 맥락이 충분히 보존되어 있습니까?' },
            { key: 'neutrality', label: '관점 균형성', question: '사료의 기록과 해석을 구분하고 특정 관점을 사실처럼 단정하지 않습니까?' },
            { key: 'usability', label: '활용 가능성', question: '질문·답변과 지식그래프 구조가 역사 자료 검색·연구에 활용하기 적합합니까?' }
        ];
        this.evaluation = this.emptyEvaluation();
        this.rounds = [
            { round: 1, status: '원문 확보 대기', source: '문서 메타데이터 v1', harness: 'v1.0', survey: 'v1.0', qa: 0, kg: 0, ai: '미실행', human: '—', gate: '생성 전' }
        ];
        this.history = [
            { time: '08.10 04:35', stage: '입력 검증', actor: '시스템', event: '근거 없는 Claim·Entity 제거', meta: '원문 확보 전까지 KG 생성 보류', artifact: 'SRC-015-R01' },
            { time: '08.04 01:53', stage: 'QA·KG 생성', actor: '생성 하네스', event: '기존 테스트 그래프 무효 처리', meta: '원문 없는 의미 노드 제거', artifact: 'KG-TEST-001' },
            { time: '08.04 01:52', stage: '자료 스냅샷', actor: '시스템', event: '자료함 chunk 연결 및 입력 고정', meta: 'chunk 189 · 10쪽', artifact: 'SRC-015-R01' },
            { time: '08.04 01:51', stage: '자료 스냅샷', actor: '시스템', event: '문서 버전 확인', meta: 'trn_nahf_cj · v1', artifact: 'API 200' },
            { time: '08.04 01:50', stage: '프로젝트', actor: '김보미', event: 'Test 프로젝트 생성', meta: '목표 점수 90점', artifact: 'RV-2026-015' }
        ];
        this.loadTestDatasetWorkspace();
        this.selectedStage = 2;
        this.selectedSample = 0;
    }

    private loadFinanceProject(id: string) {
        this.project = {
            id: id,
            name: '금융 상품 FAQ 품질 검수',
            domain: '금융',
            status: '사람 설문 평가 중',
            owner: '김보미',
            created: '2026.07.16',
            currentRound: 2,
            sourceVersion: '문서 v4',
            harness: '금융 QA·KG 하네스',
            harnessVersion: 'v2.3',
            survey: 'QA·KG 표본 직접 검수',
            surveyVersion: 'v3.2',
            qaCount: 1120,
            kgCount: 120,
            nodeCount: 3860,
            edgeCount: 5240,
            llmScore: 91.2,
            humanScore: 89.8,
            llmModel: 'LLM 검수 정책 v2.1',
            llmRun: 'LLM-R02-001',
            sampleSet: 'SAMPLE-R02',
            sampleSeed: '240718',
            surveyResponses: '96 / 120'
        };
        this.source = {
            provider: '자료함 API', status: '연결 정상', title: '금융 상품 FAQ 통합본', documentId: 'finance_faq_master',
            version: 'v4', format: 'PDF·HTML', page: '842쪽', chunk: '1,936 chunks', chunkCount: 1936, snapshot: 'SRC-014-R02', fixedAt: '2026.07.17 09:10'
        };
        this.gate = { target: 92, requiredResponse: 100, status: '응답 수집 중', current: 89.8 };
        this.stages = [
            { no: 1, code: 'SOURCE', name: '자료 API 스냅샷', short: '자료 스냅샷', status: '완료', eyebrow: '입력 고정', description: '자료함 문서 v4를 2회차 입력으로 고정했습니다.', actor: '시스템', input: '자료함 API', output: '문서 82건 · chunk 1,936개', progress: 100, action: '스냅샷 보기' },
            { no: 2, code: 'GENERATE', name: 'QA·KG 생성', short: 'QA·KG 생성', status: '완료', eyebrow: '하네스 실행', description: '개선된 하네스 v2.3으로 QA와 KG를 생성했습니다.', actor: '생성 하네스', input: 'SRC-014-R02 · v2.3', output: 'QA 1,120건 · KG 120건', progress: 100, action: '산출물 보기' },
            { no: 3, code: 'LLM REVIEW', name: 'LLM 전체 검수', short: 'LLM 전체 검수', status: '완료', eyebrow: '전수 검사', description: '전체 산출물의 사실성, 근거성, 중복과 관계 타당성을 검사했습니다.', actor: 'LLM 검수기', input: 'QA 1,120 · KG 120', output: '91.2점 · Major 8 · Minor 27', progress: 100, action: '이슈 보기' },
            { no: 4, code: 'SAMPLE', name: '대표 표본 선정', short: '대표 표본', status: '완료', eyebrow: '층화 선별', description: '위험도와 유형 분포를 반영해 대표 표본을 선정했습니다.', actor: '샘플러', input: 'LLM 이슈·유형 분포', output: '대표 표본 120건 · 표본률 9.7%', progress: 100, action: '선정 근거 보기' },
            { no: 5, code: 'HUMAN', name: '사람 설문 평가', short: '사람 설문', status: '진행 중', eyebrow: '현재 단계', description: '3명의 검수자가 동일한 설문 v3.2로 표본을 평가하고 있습니다.', actor: '검수자 3명', input: '표본 120건 · 설문 v3.2', output: '96 / 120 응답 · 임시 89.8점', progress: 80, action: '평가 이어가기' },
            { no: 6, code: 'DECISION', name: '목표 점수 판정', short: '통과 판정', status: '대기', eyebrow: '사람 검수 판정', description: '대표 표본의 모든 응답이 모이면 사람 검수 점수로 92점 통과 여부를 판정합니다.', actor: '검수 결과 판정', input: '사람 검수 점수 · 응답 완료', output: '현재 임시 89.8점 · 목표 92점', progress: 0, action: '판정 기준 보기' },
            { no: 7, code: 'REVISE', name: '하네스 개선·다음 회차', short: '개선·재생성', status: '조건부', eyebrow: '미달 시 반복', description: '미달 문항과 서술 피드백을 하네스 개선안으로 변환합니다.', actor: '하네스 담당자', input: '검수 피드백 패키지', output: '미달 시 v2.4 생성', progress: 0, action: '개선 규칙 보기' }
        ];
        this.llmChecks = [
            { name: 'Blocker', description: '사실 왜곡 또는 잘못된 규제 정보', status: '통과', count: 0 },
            { name: 'Major', description: '근거 부족, 관계 방향 오류, 답변 범위 초과', status: '확인 필요', count: 8 },
            { name: 'Minor', description: '표현 모호성, 메타데이터 누락', status: '참고', count: 27 },
            { name: '중복', description: '의미가 동일한 QA 또는 개체 중복', status: '참고', count: 14 }
        ];
        this.samples = [
            { id: 'QA-0241', type: 'QA', status: '검수 중', risk: '근거 부족', reason: 'LLM Major 이슈이면서 소비자보호 유형의 대표성이 높은 표본입니다.', source: '금융 상품 FAQ 통합본 · v4 · 214쪽', title: '중도상환수수료 면제 조건', nodes: ['질문 · 면제 조건은 무엇인가요?', '답변 · 계약 조건에 따라 달라질 수 있음', '근거 · 상품설명서 214쪽'], edges: ['질문 → 답변 · ANSWERED_BY', '답변 → 근거 · GROUNDED_IN'] },
            { id: 'KG-0088', type: 'KG', status: '검수 대기', risk: '관계 방향', reason: 'KG 관계 방향 오류 가능성이 높은 군집의 중앙 표본입니다.', source: '금융 상품 FAQ 통합본 · v4 · 388쪽', title: '우대금리 조건 관계', nodes: ['상품 · 정기예금', '조건 · 급여이체', '혜택 · 우대금리'], edges: ['정기예금 → 급여이체 · REQUIRES', '급여이체 → 우대금리 · ENABLES'] }
        ];
        this.surveyDimensions = [
            { key: 'evidence', label: '근거 일치성', question: '답변 또는 관계가 제시된 원문 근거에서 확인됩니까?' },
            { key: 'accuracy', label: '내용 정확성', question: '사실·수치·관계 방향이 정확합니까?' },
            { key: 'clarity', label: '명확성', question: '질문과 답변 또는 KG 구조가 모호하지 않습니까?' },
            { key: 'usability', label: '활용 가능성', question: '실제 검색·응답 품질에 기여할 수 있습니까?' }
        ];
        this.evaluation = this.emptyEvaluation();
        this.rounds = [
            { round: 1, status: '미달', source: '문서 v3', harness: 'v2.2', survey: 'v3.2', qa: 1080, kg: 116, ai: 87.4, human: 84.6, gate: '미달 · -7.4' },
            { round: 2, status: '사람 검수 중', source: '문서 v4', harness: 'v2.3', survey: 'v3.2', qa: 1120, kg: 120, ai: 91.2, human: 89.8, gate: '임시 · -2.2' },
            { round: 3, status: '조건부', source: '문서 v4 유지', harness: 'v2.4 예정', survey: 'v3.2 유지', qa: '—', kg: '—', ai: '—', human: '—', gate: '2차 사람 검수 미달 시 실행' }
        ];
        this.history = [
            { time: '오늘 10:42', stage: '사람 설문', actor: '박서연', event: '배정 표본 40건 평가 완료', meta: '평균 92점', artifact: 'RESP-02-001' },
            { time: '오늘 09:12', stage: '사람 설문', actor: '김보미', event: '검수자 3명에게 표본 배정', meta: '총 120건', artifact: 'ASSIGN-R02' },
            { time: '07.18 11:10', stage: '대표 표본', actor: '샘플러', event: '층화 대표 표본 선정 완료', meta: '120건 · 9.7%', artifact: 'SAMPLE-R02' },
            { time: '07.18 09:45', stage: 'LLM 전체 검수', actor: 'LLM 검수기', event: '2회차 전수 검수 완료', meta: '91.2점', artifact: 'AI-R02' },
            { time: '07.17 14:32', stage: 'QA·KG 생성', actor: '생성 하네스', event: '2회차 산출물 생성 완료', meta: 'QA 1,120 · KG 120', artifact: 'GEN-R02' }
        ];
        this.loadFinanceDatasetWorkspace();
        this.selectedStage = 5;
        this.selectedSample = 0;
    }

    private loadTestDatasetWorkspace() {
        this.datasetGraphView = 'relations';
        this.datasetGraphSelectedNodeId = 'evidence';
        this.datasetGraphHasFocus = false;
        this.datasetView = 'list';
        this.datasetDetailTab = 'configuration';
        this.datasetDraftOrigin = 'list';
        this.datasetSavedState = null;
        this.datasetStep = 1;
        this.datasetCompletionStep = 0;
        this.datasetDraftMode = false;
        this.datasetMaterialQuery = '';
        this.datasetMaterialStatus = '게시됨';
        this.datasetScope = 'chunk';
        this.datasetSnapshotLocked = true;
        this.datasetConnection = {
            status: '메타데이터 확보', apiVersion: 'v1', total: 21, lastChecked: '현재 세션',
            contract: 'Chunk 본문 미확보', requestId: '보안상 비공개',
            notice: '문서와 Chunk 식별자·hash·페이지는 보존됐지만 원문 본문은 없습니다. 원문 재조회 전에는 QA·KG를 생성하지 않습니다.'
        };
        this.datasetMaterials = [
            { id: 'trn_nahf_cj', title: '청계중일한관계사료', version: 'v1', status: '게시됨', format: 'XML', selected: true, availability: 'chunk 메타데이터 1건 · 본문 미확보', updated: '현재 스냅샷' },
            { id: 'trn_nahf_jo', title: '중국정사외국전', version: 'v1', status: '게시됨', format: 'XML', selected: false, availability: '상세 조회 필요', updated: '자료함 API' },
            { id: 'trn_nahf_jd', title: '중국정사동이전', version: 'v1', status: '게시됨', format: 'XML', selected: false, availability: '상세 조회 필요', updated: '자료함 API' },
            { id: 'trn_nahf_jc', title: '조청국경회담자료집', version: 'v1', status: '게시됨', format: 'XML', selected: false, availability: '상세 조회 필요', updated: '자료함 API' },
            { id: 'trn_nahf_jb', title: '조선시대북방사자료집', version: 'v1', status: '게시됨', format: 'XML', selected: false, availability: '상세 조회 필요', updated: '자료함 API' },
            { id: 'trn_nahf_ns', title: '일본서기', version: 'v1', status: '게시됨', format: 'XML', selected: false, availability: '상세 조회 필요', updated: '자료함 API' },
            { id: 'trn_nahf_ud', title: '울릉도·독도 일본사료집', version: 'v1', status: '게시됨', format: 'XML', selected: false, availability: '상세 조회 필요', updated: '자료함 API' },
            { id: 'trn_nahf_sd', title: '사료로 보는 독도', version: 'v1', status: '게시됨', format: 'XML', selected: false, availability: '상세 조회 필요', updated: '자료함 API' },
            { id: 'trn_nahf_gt', title: '고구려통사', version: 'v1', status: '게시됨', format: 'XML', selected: false, availability: '상세 조회 필요', updated: '자료함 API' }
        ];
        this.datasetChunks = [
            {
                id: 'chk_u4gHB_x547iqeQLLg_pUHJ9AU28MRmMUSm3wI2eDqng', ordinal: 189, page: 10,
                length: 1199, query: '청계 · 검색 조건 기록', selected: true,
                hash: 'sha256:f8bcc0ed6b918a864ca82fedc3e53b29856f5af97e9eb254d68b128a54478e41'
            }
        ];
        this.datasetSettings = {
            harness: '자료함 QA·KG 하네스 v1.0', language: '한국어', seed: '20260804', evidenceRequired: true, deduplicate: true,
            qa: { enabled: false, target: 20, type: '근거형 중심', difficulty: '혼합', answerLength: '간결' },
            kg: { enabled: true, target: 1, schema: '동북아 역사 KG schema v1.0', confidence: 0.80, mergePolicy: '확실한 개체만 병합' }
        };
        this.datasetRun = {
            id: 'GEN-015-R01', status: '원문 확보 대기', progress: 33, createdAt: '미생성', snapshot: 'SRC-015-R01',
            stages: ['문서·Chunk 메타데이터 고정'],
            nextStageLabel: 'Chunk 원문 확보', nextStageHint: '자료함에서 본문과 Evidence Span을 확보해야 생성할 수 있습니다.',
            qa: { requested: 0, generated: 0, valid: 0, excluded: 0, failed: 0, status: '선택 안 함' },
            kg: { requested: 1, generated: 0, valid: 0, excluded: 0, failed: 0, status: '원문 확보 대기' }
        };
        this.datasetExistingResult = {
            datasetId: 'SRC-015-R01', qaArtifact: '미생성', kgArtifact: '미생성 · 원문 대기',
            qaCoverage: 'QA 출력 미선택', kgCoverage: 'Chunk 위치만 확보',
            nodes: 2, edges: 1, isolatedNodes: 0, schemaViolations: 0,
            schemaVersion: 'history-kg/1.0', validationStatus: '구조 유효 · 원문 필요 1건', validationWarnings: 1,
            nodePreview: ['사료 · 청계중일한관계사료', 'Chunk 근거 위치 · chunk 189 · 10쪽'],
            edgePreview: ['Chunk 근거 위치 → 사료 · EXTRACTED_FROM'],
            graphTitle: '생성 전 사료·근거 스냅샷',
            graphMode: '원문 확보 대기',
            graphScope: '생성 입력',
            graphNotice: '문서와 Chunk 위치만 보존했습니다. 원문 본문을 확보하기 전에는 Claim·Entity·Event를 생성하지 않습니다.',
            graphLegend: [
                { kind: 'source', label: '사료', icon: 'fa-book-open' },
                { kind: 'evidence', label: 'Chunk 근거 위치', icon: 'fa-quote-left' }
            ],
            graphNodes: [
                {
                    id: 'source', kind: 'source', type: '사료', label: '청계중일한관계사료', code: 'trn_nahf_cj',
                    meta: 'v1 · XML · 문서 메타데이터 고정', status: '스냅샷 고정', summary: '생성 입력으로 선택한 사료입니다. 현재 저장소에는 원문 Chunk 본문이 포함되지 않았습니다.', icon: 'fa-book-open',
                    positions: { relations: { x: 0.25, y: 0.50 }, evidence: { x: 0.25, y: 0.50 } }
                },
                {
                    id: 'evidence', kind: 'evidence', type: 'Chunk 근거 위치', label: '10쪽 · chunk 189', code: 'evidence:chunk-189',
                    meta: 'ID·hash·페이지 확보 · 본문 없음', status: '원문 확보 필요', summary: '문서 내 Chunk 위치와 무결성 hash만 보존한 생성 입력입니다. 아직 어떤 Claim도 뒷받침하지 않습니다.', icon: 'fa-quote-left',
                    positions: { relations: { x: 0.75, y: 0.50 }, evidence: { x: 0.75, y: 0.50 } }
                }
            ],
            graphEdges: [
                { id: 'extracted-from', source: 'evidence', target: 'source', label: '사료에서 추출', code: 'EXTRACTED_FROM', tone: 'slate', evidence: 'trn_nahf_cj · v1' }
            ]
        };
    }

    private loadFinanceDatasetWorkspace() {
        this.datasetGraphView = 'relations';
        this.datasetGraphSelectedNodeId = 'product';
        this.datasetGraphHasFocus = false;
        this.datasetView = 'list';
        this.datasetDetailTab = 'configuration';
        this.datasetDraftOrigin = 'list';
        this.datasetSavedState = null;
        this.datasetStep = 1;
        this.datasetCompletionStep = 0;
        this.datasetDraftMode = false;
        this.datasetMaterialQuery = '';
        this.datasetMaterialStatus = '게시됨';
        this.datasetScope = 'document';
        this.datasetSnapshotLocked = true;
        this.datasetConnection = {
            status: '프로젝트 스냅샷', apiVersion: 'v1', total: 82, lastChecked: 'Round 2 고정 시점',
            contract: '회차 입력 고정', requestId: 'SRC-014-R02',
            notice: '현재 회차에 고정된 자료 정보를 표시합니다. 이 화면에서 변경한 제작안은 아직 저장되지 않습니다.'
        };
        this.datasetMaterials = [
            { id: 'finance_faq_master', title: '금융 상품 FAQ 통합본', version: 'v4', status: '게시됨', format: 'PDF·HTML', selected: true, availability: '문서 82 · chunk 1,936', updated: 'Round 2' }
        ];
        this.datasetChunks = [
            { id: 'faq_chunk_214', ordinal: 214, page: 214, length: 1080, query: '중도상환수수료', selected: true, hash: 'snapshot hash 보존' },
            { id: 'faq_chunk_388', ordinal: 388, page: 388, length: 1160, query: '우대금리', selected: true, hash: 'snapshot hash 보존' }
        ];
        this.datasetSettings = {
            harness: '금융 QA·KG 하네스 v2.3', language: '한국어', seed: '240718', evidenceRequired: true, deduplicate: true,
            qa: { enabled: true, target: 1120, type: 'FAQ·근거형', difficulty: '혼합', answerLength: '정책 기준' },
            kg: { enabled: true, target: 120, schema: '금융 KG schema v2.0', confidence: 0.86, mergePolicy: '도메인 사전 병합' }
        };
        this.datasetRun = {
            id: 'GEN-014-R02', status: '완료', progress: 100, createdAt: '2026.07.17 14:32', snapshot: 'SRC-014-R02',
            stages: ['자료 수집 완료', 'QA 생성 완료', 'KG 생성 완료', '산출물 검증 완료'],
            qa: { requested: 1120, generated: 1120, valid: 1087, excluded: 33, failed: 0, status: '완료' },
            kg: { requested: 120, generated: 120, valid: 117, excluded: 3, failed: 0, status: '완료' }
        };
        this.datasetExistingResult = {
            datasetId: 'DS-014-R02', qaArtifact: 'QA-R02', kgArtifact: 'KG-R02',
            qaCoverage: '근거 연결 97.1%', kgCoverage: '근거 연결 98.4%',
            nodes: 3860, edges: 5240, isolatedNodes: 7, schemaViolations: 3,
            nodePreview: ['상품 · 정기예금', '조건 · 급여이체', '혜택 · 우대금리'],
            edgePreview: ['정기예금 → 급여이체 · REQUIRES', '급여이체 → 우대금리 · ENABLES'],
            graphTitle: '도메인 지식그래프',
            graphMode: '근거 추적형 · 대표 관계',
            graphScope: '대표 관계 미리보기',
            graphNotice: '전체 3,860개 노드 중 대표 관계를 표시합니다. 전체 탐색은 그래프 저장소 연동 후 제공됩니다.',
            graphLegend: [
                { kind: 'source', label: '상품', icon: 'fa-building-columns' },
                { kind: 'concept', label: '조건', icon: 'fa-list-check' },
                { kind: 'benefit', label: '혜택', icon: 'fa-percent' }
            ],
            graphNodes: [
                {
                    id: 'product', kind: 'source', type: '상품', label: '정기예금', code: 'product:정기예금',
                    meta: '금융 상품', summary: '대표 관계의 기준이 되는 금융 상품입니다.', icon: 'fa-building-columns',
                    positions: { relations: { x: 0.20, y: 0.50 }, evidence: { x: 0.20, y: 0.50 } }
                },
                {
                    id: 'condition', kind: 'concept', type: '조건', label: '급여이체', code: 'condition:급여이체',
                    meta: '우대 조건', summary: '상품 혜택을 받기 위해 필요한 조건입니다.', icon: 'fa-list-check',
                    positions: { relations: { x: 0.50, y: 0.50 }, evidence: { x: 0.50, y: 0.50 } }
                },
                {
                    id: 'benefit', kind: 'benefit', type: '혜택', label: '우대금리', code: 'benefit:우대금리',
                    meta: '금리 혜택', summary: '조건 충족으로 활성화되는 금융 혜택입니다.', icon: 'fa-percent',
                    positions: { relations: { x: 0.80, y: 0.50 }, evidence: { x: 0.80, y: 0.50 } }
                }
            ],
            graphEdges: [
                { id: 'requires', source: 'product', target: 'condition', label: '조건으로 요구', code: 'REQUIRES', tone: 'olive', evidence: '상품설명서' },
                { id: 'enables', source: 'condition', target: 'benefit', label: '혜택 활성화', code: 'ENABLES', tone: 'teal', evidence: '우대금리 조건' }
            ]
        };
    }

    public currentStage() {
        return this.stages.find((stage: any) => stage.no === this.selectedStage) || this.stages[0] || null;
    }

    public nextStage() {
        const current = this.currentStage();
        if (!current) return null;
        const index = this.stages.findIndex((stage: any) => stage.no === current.no);
        return index > -1 ? this.stages[index + 1] || null : null;
    }

    public isGateFailed() {
        return ['미달', '실패'].indexOf(this.gate.status) > -1;
    }

    public isGatePassed() {
        return ['통과', '승인'].indexOf(this.gate.status) > -1;
    }

    public currentSample() {
        return this.samples[this.selectedSample] || this.samples[0] || {};
    }

    public filteredDatasetMaterials() {
        const query = (this.datasetMaterialQuery || '').trim().toLowerCase();
        return this.datasetMaterials.filter((item: any) => {
            const matchesQuery = !query || item.title.toLowerCase().indexOf(query) > -1 || item.id.toLowerCase().indexOf(query) > -1;
            const matchesStatus = this.datasetMaterialStatus === '전체' || item.status === this.datasetMaterialStatus;
            return matchesQuery && matchesStatus;
        });
    }

    public selectedDatasetMaterials() {
        return this.datasetMaterials.filter((item: any) => item.selected);
    }

    public areFilteredDatasetMaterialsSelected() {
        const materials = this.filteredDatasetMaterials();
        return materials.length > 0 && materials.every((item: any) => item.selected);
    }

    public selectedDatasetChunks() {
        return this.datasetChunks.filter((item: any) => item.selected);
    }

    private copyDatasetValue(value: any) {
        return JSON.parse(JSON.stringify(value));
    }

    private rememberDatasetState() {
        this.datasetSavedState = {
            materials: this.copyDatasetValue(this.datasetMaterials),
            chunks: this.copyDatasetValue(this.datasetChunks),
            settings: this.copyDatasetValue(this.datasetSettings),
            run: this.copyDatasetValue(this.datasetRun),
            existingResult: this.copyDatasetValue(this.datasetExistingResult),
            scope: this.datasetScope,
            snapshotLocked: this.datasetSnapshotLocked
        };
    }

    private restoreDatasetState() {
        if (!this.datasetSavedState) return;
        this.datasetMaterials = this.copyDatasetValue(this.datasetSavedState.materials);
        this.datasetChunks = this.copyDatasetValue(this.datasetSavedState.chunks);
        this.datasetSettings = this.copyDatasetValue(this.datasetSavedState.settings);
        this.datasetRun = this.copyDatasetValue(this.datasetSavedState.run);
        this.datasetExistingResult = this.copyDatasetValue(this.datasetSavedState.existingResult);
        this.datasetScope = this.datasetSavedState.scope;
        this.datasetSnapshotLocked = this.datasetSavedState.snapshotLocked;
        this.datasetSavedState = null;
    }

    public datasetScopeLabel() {
        if (this.datasetScope === 'chunk') return '선택한 근거 범위';
        if (this.datasetScope === 'page') return '선택한 페이지';
        return '문서 전체';
    }

    public datasetGraphNodeById(id: string) {
        const nodes = this.datasetExistingResult.graphNodes || [];
        return nodes.find((node: any) => node.id === id) || {};
    }

    public currentDatasetGraphNode() {
        const nodes = this.datasetExistingResult.graphNodes || [];
        return nodes.find((node: any) => node.id === this.datasetGraphSelectedNodeId) || nodes[0] || {};
    }

    public currentDatasetGraphConnections() {
        const selected = this.currentDatasetGraphNode();
        if (!selected.id) return [];
        return (this.datasetExistingResult.graphEdges || [])
            .filter((edge: any) => edge.source === selected.id || edge.target === selected.id)
            .map((edge: any) => {
                const outgoing = edge.source === selected.id;
                return {
                    edge: edge,
                    direction: outgoing ? '나가는 관계' : '들어오는 관계',
                    node: this.datasetGraphNodeById(outgoing ? edge.target : edge.source)
                };
            });
    }

    public datasetGraphNodeTypeCount(kind: string) {
        return (this.datasetExistingResult.graphNodes || []).filter((node: any) => node.kind === kind).length;
    }

    public datasetGraphMatchingNodes() {
        const query = (this.datasetGraphSearchQuery || '').trim().toLowerCase();
        return (this.datasetExistingResult.graphNodes || []).filter((node: any) => {
            const matchesType = this.datasetGraphNodeFilter === 'all' || node.kind === this.datasetGraphNodeFilter;
            const searchText = [node.label, node.type, node.meta, node.summary].filter(Boolean).join(' ').toLowerCase();
            return matchesType && (!query || searchText.indexOf(query) > -1);
        });
    }

    public async setDatasetGraphNodeFilter(kind: string) {
        this.datasetGraphNodeFilter = kind;
        if (!this.datasetGraphMatchingNodes().some((node: any) => node.id === this.datasetGraphSelectedNodeId)) {
            this.datasetGraphHasFocus = false;
        }
        this.applyDatasetGraphFilters();
        await this.service.render();
    }

    public async onDatasetGraphSearchChanged() {
        if (!this.datasetGraphMatchingNodes().some((node: any) => node.id === this.datasetGraphSelectedNodeId)) {
            this.datasetGraphHasFocus = false;
        }
        this.applyDatasetGraphFilters();
        await this.service.render();
    }

    public async clearDatasetGraphSearch() {
        this.datasetGraphSearchQuery = '';
        this.applyDatasetGraphFilters();
        await this.service.render();
    }

    public async focusFirstDatasetGraphSearchResult() {
        const match = this.datasetGraphMatchingNodes()[0];
        if (!match) return;
        await this.selectDatasetGraphNode(match.id);
    }

    public async setDatasetGraphInspectorTab(tab: 'details' | 'connections' | 'review') {
        this.datasetGraphInspectorTab = tab;
        await this.service.render();
    }

    public async toggleDatasetGraphPanel(panel: 'left' | 'right') {
        if (panel === 'left') this.datasetGraphLeftCollapsed = !this.datasetGraphLeftCollapsed;
        if (panel === 'right') this.datasetGraphRightCollapsed = !this.datasetGraphRightCollapsed;
        await this.service.render();
        this.scheduleDatasetGraphRender();
    }

    public async toggleDatasetGraphExpanded() {
        this.datasetGraphExpanded = !this.datasetGraphExpanded;
        await this.service.render();
        this.scheduleDatasetGraphRender();
    }

    private applyDatasetGraphFilters() {
        if (!this.datasetGraphInstance) return;
        const matchingIds = new Set(this.datasetGraphMatchingNodes().map((node: any) => node.id));
        const filterActive = this.datasetGraphNodeFilter !== 'all' || !!(this.datasetGraphSearchQuery || '').trim();

        this.datasetGraphInstance.elements().removeClass('is-filtered-out');
        if (!this.datasetGraphHasFocus) {
            this.datasetGraphInstance.elements().removeClass('is-selected is-dimmed is-neighbour');
        }
        if (!filterActive) return;

        this.datasetGraphInstance.nodes().forEach((node: any) => {
            if (!matchingIds.has(node.id())) node.addClass('is-filtered-out');
        });
        this.datasetGraphInstance.edges().forEach((edge: any) => {
            if (!matchingIds.has(edge.source().id()) && !matchingIds.has(edge.target().id())) {
                edge.addClass('is-filtered-out');
            }
        });
    }

    public async setDatasetGraphView(view: 'relations' | 'evidence' | 'triples') {
        if (this.datasetGraphView === view) return;
        this.datasetGraphView = view;
        await this.service.render();
        this.scheduleDatasetGraphRender();
    }

    public async selectDatasetGraphNode(id: string) {
        if (!this.datasetGraphNodeById(id).id) return;
        this.datasetGraphSelectedNodeId = id;
        this.datasetGraphHasFocus = true;
        this.datasetGraphInspectorTab = 'details';
        this.datasetGraphRightCollapsed = false;
        await this.service.render();
        this.scheduleDatasetGraphRender();
    }

    public fitDatasetGraph() {
        if (!this.datasetGraphInstance) return;
        this.datasetGraphInstance.fit(this.datasetGraphInstance.elements(), 52);
    }

    public zoomDatasetGraph(delta: number) {
        if (!this.datasetGraphInstance) return;
        const container = this.datasetGraphInstance.container();
        const currentZoom = this.datasetGraphInstance.zoom();
        const nextZoom = Math.max(0.55, Math.min(2.2, currentZoom + delta));
        this.datasetGraphInstance.zoom({
            level: nextZoom,
            renderedPosition: {
                x: container ? container.clientWidth / 2 : 0,
                y: container ? container.clientHeight / 2 : 0
            }
        });
    }

    public async clearDatasetGraphSelection() {
        if (!this.datasetGraphHasFocus) return;
        this.datasetGraphHasFocus = false;
        await this.service.render();
        this.scheduleDatasetGraphRender();
    }

    public async resetDatasetGraphLayout() {
        this.datasetGraphHasFocus = false;
        await this.service.render();
        this.scheduleDatasetGraphRender();
    }

    private scheduleDatasetGraphRender() {
        this.destroyDatasetGraph();
        if (this.datasetView !== 'detail' || this.datasetDetailTab !== 'results' || this.datasetGraphView === 'triples') return;
        this.datasetGraphRenderTimer = setTimeout(() => {
            this.datasetGraphRenderTimer = null;
            this.renderDatasetGraph();
        }, 0);
    }

    private renderDatasetGraph() {
        if (typeof document === 'undefined') return;
        const container = document.getElementById('dataset-knowledge-graph-canvas');
        const graphNodes = this.datasetExistingResult.graphNodes || [];
        const graphEdges = this.datasetExistingResult.graphEdges || [];
        if (!container || !graphNodes.length) return;

        if (this.datasetGraphInstance) {
            this.datasetGraphInstance.destroy();
            this.datasetGraphInstance = null;
        }

        const width = Math.max(container.clientWidth, 320);
        const height = Math.max(container.clientHeight, 420);
        const isSparseGraph = graphNodes.length <= 6;
        const layoutWidth = isSparseGraph
            ? Math.min(Math.max(width * 0.82, 620), 1400)
            : Math.min(Math.max(width * 0.94, 720), 1840);
        const layoutHeight = isSparseGraph
            ? Math.min(Math.max(height * 0.78, 420), 640)
            : height;
        const layoutOffsetX = Math.max((width - layoutWidth) / 2, 0);
        const layoutOffsetY = Math.max((height - layoutHeight) / 2, 0);
        const positionKey = this.datasetGraphView === 'evidence' ? 'evidence' : 'relations';
        const elements = [
            ...graphNodes.map((node: any) => {
                const position = node.positions && node.positions[positionKey] ? node.positions[positionKey] : { x: 0.5, y: 0.5 };
                return {
                    data: {
                        id: node.id,
                        label: node.label,
                        kind: node.kind,
                        type: node.type
                    },
                    position: { x: layoutOffsetX + layoutWidth * position.x, y: layoutOffsetY + layoutHeight * position.y },
                    classes: `dataset-node dataset-node--${node.kind}`
                };
            }),
            ...graphEdges.map((edge: any) => ({
                data: {
                    id: edge.id,
                    source: edge.source,
                    target: edge.target,
                    label: edge.label,
                    code: edge.code,
                    tone: edge.tone || 'slate'
                },
                classes: `dataset-edge dataset-edge--${edge.tone || 'slate'}`
            }))
        ];

        const layoutOptions = this.datasetGraphView === 'evidence'
            ? { name: 'preset', fit: false, animate: false, nodeDimensionsIncludeLabels: true }
            : !isSparseGraph
                ? {
                    name: 'cose', fit: true, padding: 54, animate: false, randomize: true,
                    nodeDimensionsIncludeLabels: true, nodeRepulsion: 76000, idealEdgeLength: 172,
                    edgeElasticity: 120, nestingFactor: 1.1, gravity: 0.08, numIter: 1000
                }
                : { name: 'preset', fit: false, animate: false, nodeDimensionsIncludeLabels: true };

        this.datasetGraphInstance = cytoscapeFactory({
            container: container,
            elements: elements as any,
            layout: layoutOptions,
            minZoom: 0.48,
            maxZoom: 2.5,
            wheelSensitivity: 0.18,
            boxSelectionEnabled: false,
            selectionType: 'single',
            style: [
                {
                    selector: 'node',
                    style: {
                        'label': 'data(label)',
                        'text-wrap': 'wrap',
                        'text-max-width': '170px',
                        'text-valign': 'bottom',
                        'text-halign': 'center',
                        'text-margin-y': 13,
                        'font-family': 'Pretendard, Inter, system-ui, sans-serif',
                        'font-size': '15px',
                        'font-weight': 760,
                        'color': '#28241f',
                        'text-outline-width': 4,
                        'text-outline-color': '#ffffff',
                        'text-outline-opacity': 0.96,
                        'border-width': 3,
                        'border-color': '#ffffff',
                        'overlay-opacity': 0,
                        'transition-property': 'opacity, border-width, border-color',
                        'transition-duration': '160ms'
                    }
                },
                {
                    selector: 'node.dataset-node--source',
                    style: {
                        'shape': 'ellipse', 'width': 72, 'height': 72,
                        'background-color': '#a9bf91', 'border-color': '#58733d',
                        'text-valign': 'top', 'text-margin-y': -15, 'text-max-width': '200px'
                    }
                },
                {
                    selector: 'node.dataset-node--claim',
                    style: {
                        'shape': 'round-rectangle', 'width': 112, 'height': 68,
                        'background-color': '#405d25', 'border-color': '#ffffff',
                        'text-valign': 'top', 'text-margin-y': -14,
                        'font-size': '15px', 'font-weight': 850
                    }
                },
                {
                    selector: 'node.dataset-node--entity',
                    style: {
                        'shape': 'ellipse', 'width': 82, 'height': 82,
                        'background-color': '#526f8a', 'border-color': '#ffffff',
                        'text-valign': 'top', 'text-margin-y': -15,
                        'font-size': '15px', 'font-weight': 820
                    }
                },
                {
                    selector: 'node.dataset-node--concept',
                    style: {
                        'shape': 'ellipse', 'width': 92, 'height': 92,
                        'background-color': '#405d25', 'border-color': '#ffffff',
                        'text-valign': 'top', 'text-margin-y': -15,
                        'font-size': '16px', 'font-weight': 850
                    }
                },
                {
                    selector: 'node.dataset-node--evidence',
                    style: {
                        'shape': 'diamond', 'width': 68, 'height': 68,
                        'background-color': '#d57636', 'border-color': '#ffffff',
                        'text-valign': 'bottom', 'text-margin-y': 15
                    }
                },
                {
                    selector: 'node.dataset-node--page',
                    style: {
                        'shape': 'round-rectangle', 'width': 60, 'height': 60,
                        'background-color': '#8d9089', 'border-color': '#ffffff',
                        'text-valign': 'bottom', 'text-margin-y': 14
                    }
                },
                {
                    selector: 'node.dataset-node--benefit',
                    style: {
                        'shape': 'diamond', 'width': 70, 'height': 70,
                        'background-color': '#3f7b6c', 'border-color': '#ffffff',
                        'text-valign': 'bottom', 'text-margin-y': 15
                    }
                },
                {
                    selector: 'edge',
                    style: {
                        'width': 2.4,
                        'curve-style': 'straight',
                        'line-color': '#8c958c',
                        'target-arrow-color': '#8c958c',
                        'target-arrow-shape': 'triangle',
                        'arrow-scale': 1.08,
                        'label': 'data(label)',
                        'font-family': 'Pretendard, Inter, system-ui, sans-serif',
                        'font-size': '12px',
                        'font-weight': 760,
                        'color': '#5d5952',
                        'text-rotation': 'autorotate',
                        'text-margin-y': -11,
                        'text-background-color': '#ffffff',
                        'text-background-opacity': 0.98,
                        'text-background-padding': '4px',
                        'overlay-opacity': 0,
                        'opacity': 0.9,
                        'transition-property': 'opacity, width, line-color, target-arrow-color',
                        'transition-duration': '160ms'
                    }
                },
                {
                    selector: 'edge.dataset-edge--olive',
                    style: { 'line-color': '#5f793f', 'target-arrow-color': '#5f793f' }
                },
                {
                    selector: 'edge.dataset-edge--orange',
                    style: { 'line-color': '#c56229', 'target-arrow-color': '#c56229' }
                },
                {
                    selector: 'edge.dataset-edge--gold',
                    style: { 'line-color': '#af7f18', 'target-arrow-color': '#af7f18' }
                },
                {
                    selector: 'edge.dataset-edge--teal',
                    style: { 'line-color': '#3f7b6c', 'target-arrow-color': '#3f7b6c' }
                },
                {
                    selector: 'edge.dataset-edge--slate',
                    style: { 'line-color': '#8c958c', 'target-arrow-color': '#8c958c' }
                },
                {
                    selector: '.is-selected',
                    style: {
                        'border-width': 5,
                        'border-color': '#b8521c',
                        'underlay-opacity': 0,
                        'z-index': 20
                    }
                },
                {
                    selector: '.is-hovered',
                    style: {
                        'border-width': 4,
                        'border-color': '#6f8a50'
                    }
                },
                {
                    selector: '.is-neighbour',
                    style: { 'opacity': 1 }
                },
                {
                    selector: '.is-dimmed',
                    style: { 'opacity': 0.34 }
                },
                {
                    selector: '.is-filtered-out',
                    style: { 'opacity': 0.12 }
                }
            ] as any
        } as any);

        const selected = this.datasetGraphInstance.$id(this.datasetGraphSelectedNodeId);
        if (this.datasetGraphHasFocus && selected.length) {
            selected.addClass('is-selected');
            const neighbourhood = selected.closedNeighborhood();
            this.datasetGraphInstance.elements().addClass('is-dimmed');
            neighbourhood.removeClass('is-dimmed');
            neighbourhood.nodes().not(selected).addClass('is-neighbour');
        }

        this.applyDatasetGraphFilters();

        this.datasetGraphInstance.on('tap', 'node', (event: any) => {
            const id = event.target.id();
            if (id !== this.datasetGraphSelectedNodeId || !this.datasetGraphHasFocus) this.selectDatasetGraphNode(id);
        });
        this.datasetGraphInstance.on('mouseover', 'node', (event: any) => event.target.addClass('is-hovered'));
        this.datasetGraphInstance.on('mouseout', 'node', (event: any) => event.target.removeClass('is-hovered'));
        this.datasetGraphInstance.on('tap', (event: any) => {
            if (event.target === this.datasetGraphInstance && this.datasetGraphHasFocus) this.clearDatasetGraphSelection();
        });
    }

    private destroyDatasetGraph() {
        if (this.datasetGraphRenderTimer) {
            clearTimeout(this.datasetGraphRenderTimer);
            this.datasetGraphRenderTimer = null;
        }
        if (this.datasetGraphInstance) {
            this.datasetGraphInstance.destroy();
            this.datasetGraphInstance = null;
        }
    }

    public async setDatasetListMode(mode: 'flow' | 'compact') {
        this.datasetListMode = mode;
        await this.service.render();
    }

    public async openDatasetList() {
        this.destroyDatasetGraph();
        this.datasetGraphExpanded = false;
        if (this.datasetDraftMode) this.restoreDatasetState();
        this.datasetDraftMode = false;
        this.datasetView = 'list';
        this.datasetStep = 1;
        this.datasetCompletionStep = 0;
        await this.service.render();
    }

    public async openDatasetDetail(tab: 'configuration' | 'results' = 'configuration') {
        this.destroyDatasetGraph();
        if (tab !== 'results') this.datasetGraphExpanded = false;
        if (this.datasetDraftMode) this.restoreDatasetState();
        this.datasetDraftMode = false;
        this.datasetView = 'detail';
        this.datasetDetailTab = tab;
        await this.service.render();
        this.scheduleDatasetGraphRender();
    }

    public datasetStepClass(no: number) {
        return [
            no <= this.datasetCompletionStep ? 'is-complete' : 'is-pending',
            no === this.datasetStep ? 'is-current' : ''
        ];
    }

    public datasetExpectedQa() {
        return this.datasetSettings.qa && this.datasetSettings.qa.enabled ? this.datasetSettings.qa.target : 0;
    }

    public datasetExpectedKg() {
        return this.datasetSettings.kg && this.datasetSettings.kg.enabled ? this.datasetSettings.kg.target : 0;
    }

    public async setDatasetOutputEnabled(output: 'qa' | 'kg', event: any) {
        if (!this.datasetSettings[output]) return;
        this.datasetSettings[output].enabled = !!(event && event.target && event.target.checked);
        this.datasetCompletionStep = Math.min(this.datasetCompletionStep, 1);
        await this.service.render();
    }

    public async setDatasetStep(no: number) {
        if (this.datasetView !== 'create' || no < 1 || no > 3) return;
        if (no >= 2 && !await this.validateDatasetSource()) return;
        if (no >= 3 && !await this.validateDatasetOutputs()) return;
        if (no >= 2) {
            this.datasetSnapshotLocked = true;
            this.datasetCompletionStep = Math.max(this.datasetCompletionStep, 1);
        }
        if (no >= 3) this.datasetCompletionStep = Math.max(this.datasetCompletionStep, 2);
        this.datasetStep = no;
        await this.service.render();
    }

    private async validateDatasetSource() {
        if (!this.selectedDatasetMaterials().length) {
            await this.service.modal.warning('데이터셋에 사용할 자료를 하나 이상 선택해주세요.', false, '확인');
            return false;
        }
        if (this.datasetScope === 'chunk' && !this.selectedDatasetChunks().length) {
            await this.service.modal.warning('사용할 근거 범위를 하나 이상 선택해주세요.', false, '확인');
            return false;
        }
        return true;
    }

    private async validateDatasetOutputs() {
        if (!this.datasetSettings.qa.enabled && !this.datasetSettings.kg.enabled) {
            await this.service.modal.warning('QA 또는 지식그래프 중 하나 이상을 선택해주세요.', false, '확인');
            return false;
        }
        return true;
    }

    public async toggleDatasetMaterial(item: any) {
        if (!this.datasetDraftMode) {
            await this.service.modal.warning('완료된 데이터셋의 자료는 변경할 수 없습니다. 다른 자료로 만들려면 새 데이터셋을 만들어주세요.', false, '확인');
            return;
        }
        item.selected = !item.selected;
        this.datasetSnapshotLocked = false;
        this.datasetCompletionStep = 0;
        await this.service.render();
    }

    public async toggleAllFilteredDatasetMaterials() {
        if (!this.datasetDraftMode) {
            await this.service.modal.warning('완료된 데이터셋의 자료는 변경할 수 없습니다. 다른 자료로 만들려면 새 데이터셋을 만들어주세요.', false, '확인');
            return;
        }

        const materials = this.filteredDatasetMaterials();
        if (!materials.length) return;

        const shouldSelect = !materials.every((item: any) => item.selected);
        materials.forEach((item: any) => item.selected = shouldSelect);
        this.datasetSnapshotLocked = false;
        this.datasetCompletionStep = 0;
        await this.service.render();
    }

    public async startDatasetDraft(copyExisting: boolean = false, origin: 'list' | 'detail' = 'list') {
        this.destroyDatasetGraph();
        this.rememberDatasetState();
        this.datasetDraftOrigin = origin;
        this.datasetDraftMode = true;
        this.datasetView = 'create';
        this.datasetStep = 1;
        this.datasetCompletionStep = 0;
        this.datasetSnapshotLocked = false;
        this.datasetMaterials = this.copyDatasetValue(this.datasetMaterials);
        this.datasetChunks = this.copyDatasetValue(this.datasetChunks);
        this.datasetSettings = this.copyDatasetValue(this.datasetSettings);
        if (!copyExisting) {
            this.datasetMaterials.forEach((item: any) => item.selected = false);
            this.datasetChunks.forEach((item: any) => item.selected = false);
            this.datasetScope = 'document';
            if (this.datasetSettings.qa) this.datasetSettings.qa.enabled = true;
            if (this.datasetSettings.kg) this.datasetSettings.kg.enabled = true;
        }
        this.datasetMaterialQuery = '';
        await this.service.render();
    }

    public async cancelDatasetDraft() {
        this.restoreDatasetState();
        this.datasetDraftMode = false;
        this.datasetView = this.datasetDraftOrigin;
        this.datasetStep = 1;
        this.datasetCompletionStep = 0;
        await this.service.render();
        this.scheduleDatasetGraphRender();
    }

    public async setDatasetScope(scope: string) {
        if (!this.datasetDraftMode) return;
        this.datasetScope = scope;
        this.datasetSnapshotLocked = false;
        this.datasetCompletionStep = 0;
        await this.service.render();
    }

    public async onDatasetChunkChanged() {
        this.datasetSnapshotLocked = false;
        this.datasetCompletionStep = 0;
        await this.service.render();
    }

    public async continueDatasetSource() {
        await this.setDatasetStep(2);
    }

    public async continueDatasetConfig() {
        await this.setDatasetStep(3);
    }

    public async lockDatasetSnapshot() {
        await this.continueDatasetSource();
    }

    public async reviewDatasetConfig() {
        await this.continueDatasetConfig();
    }

    public async submitDatasetCreation() {
        if (!await this.validateDatasetSource() || !await this.validateDatasetOutputs()) return;
        await this.service.modal.warning('자료와 생성 설정은 준비되었습니다. 실제 QA 셋과 지식그래프 생성은 서버 연결 후 사용할 수 있습니다.', false, '확인');
    }

    public async openLlmReview() {
        this.selectedStage = 3;
        await this.router.navigate(['/review-projects', this.project.id, 'process']);
    }

    public async openHarness() {
        this.showHarnessModal = true;
        await this.service.render();
    }

    public async closeHarness() {
        this.showHarnessModal = false;
        await this.service.render();
    }

    public async selectStage(no: number) {
        this.selectedStage = no;
        await this.service.render();
    }

    public async selectSample(index: number) {
        this.selectedSample = index;
        this.evaluation = this.emptyEvaluation();
        await this.service.render();
    }

    public async setEvaluationScore(key: string, score: number) {
        this.evaluation.scores[key] = score;
        this.evaluation.saved = false;
        await this.service.render();
    }

    public async toggleReviewScope(key: string) {
        this.evaluation.scopes[key] = !this.evaluation.scopes[key];
        this.evaluation.saved = false;
        await this.service.render();
    }

    public async setOverallDecision(value: string) {
        this.evaluation.decision = value;
        this.evaluation.saved = false;
        await this.service.render();
    }

    public async toggleReasonCode(code: string) {
        const selected = this.evaluation.reasonCodes.indexOf(code);
        if (selected >= 0) this.evaluation.reasonCodes.splice(selected, 1);
        else this.evaluation.reasonCodes.push(code);
        this.evaluation.saved = false;
        await this.service.render();
    }

    public hasReasonCode(code: string) {
        return this.evaluation.reasonCodes.indexOf(code) >= 0;
    }

    public async updateEvaluationText(field: string, event: any) {
        this.evaluation[field] = event.target.value;
        this.evaluation.saved = false;
        await this.service.render();
    }

    public evaluationProgress() {
        return this.surveyDimensions.filter((item: any) => !!this.evaluation.scores[item.key]).length;
    }

    public draftAverage() {
        const values = this.surveyDimensions
            .map((item: any) => this.evaluation.scores[item.key])
            .filter((value: any) => !!value);
        if (!values.length) return '—';
        const average = values.reduce((sum: number, value: number) => sum + value, 0) / values.length;
        return (average * 20).toFixed(1);
    }

    public displayCount(value: any) {
        if (value === null || value === undefined || value === '—') return '—';
        return Number(value).toLocaleString();
    }

    public async saveEvaluation() {
        if (this.evaluationProgress() < this.surveyDimensions.length || !this.evaluation.decision) {
            await this.service.modal.warning('6개 평가 항목과 전체 판정을 모두 선택해주세요.', false, '확인');
            return;
        }
        this.evaluation.saved = true;
        await this.service.render();
        await this.service.modal.success('동북아 역사 대표 표본 검수 의견서를 제출했습니다.');
    }

    private emptyEvaluation() {
        return {
            scores: {},
            scopes: { representative: true, risk: false, pattern: false, other: false },
            decision: null,
            reasonCodes: [],
            overallComment: '',
            keepPatterns: '',
            revisePatterns: '',
            harnessRules: '',
            saved: false
        };
    }

    public async openRun() {
        if (!this.canRunCurrentStage()) return;
        this.showRunModal = true;
        await this.service.render();
    }

    public async closeRun() {
        this.showRunModal = false;
        await this.service.render();
    }

    public async confirmRun() {
        if (!this.canRunCurrentStage()) return;
        const stage = this.currentStage();
        stage.status = '진행 중';
        stage.progress = Math.max(stage.progress || 0, 10);
        this.project.status = stage.name + ' 중';
        this.history.unshift({
            time: '방금', stage: stage.short, actor: '김보미', event: stage.name + ' 실행 준비',
            meta: 'UI 상태 반영', artifact: 'API 연동 대기'
        });
        this.showRunModal = false;
        await this.service.render();
        await this.service.modal.success('단계 실행 상태를 반영했습니다. 실제 파이프라인 호출은 실행 API가 연결되면 저장됩니다.');
    }

    public canRunCurrentStage() {
        const stage = this.currentStage();
        if (!stage || stage.status === '완료' || stage.status === '조건부' || stage.status === '진행 중') return false;
        if (stage.no === 1) return true;
        return this.stages
            .filter((item: any) => item.no < stage.no)
            .every((item: any) => item.status === '완료');
    }

    public stageClass(status: string) {
        if (status === '완료') return 'is-complete';
        if (status === '진행 중') return 'is-active';
        if (status === '조건부') return 'is-conditional';
        return 'is-pending';
    }

    public statusClass(status: string) {
        if (status === '완료' || status === '통과') return 'review-status--success';
        if (status === 'LLM 검수 중') return 'review-status--ai';
        if (status === '사람 검수 중') return 'review-status--human';
        if (status === '진행 중') return 'review-status--active';
        if (status === '조건부' || status === '확인 필요') return 'review-status--warning';
        if (status === '미달') return 'review-status--danger';
        return 'review-status--neutral';
    }

    public checkClass(status: string) {
        if (status === '통과') return 'review-check--success';
        if (status === '확인 필요') return 'review-check--danger';
        if (status === '참고') return 'review-check--warning';
        return 'review-check--neutral';
    }
}

export default PageReviewProjectsItemComponent;